import React from 'react'
import { useEffect, useLayoutEffect, useState, useRef, createRef } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useDispatch, useSelector, useStore } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import DropZone from "../components/DropZone";
import { kakousijiSectionCatalog, kakousijiSampleSectionCatalog } from "./kakousiji/sectionCatalog";
import { buildResolvedSections } from "./kakousiji/sectionResolver";
import { buildEntryBaseFields } from "./kakousiji/baseFieldResolver";
import { createDemandGridColumnBuilder } from "./kakousiji/panels/demandGridColumnBuilder";
import { createDemandGridSupportService } from "./kakousiji/panels/demandGridSupportService";
import { createDemeritPanelService } from "./kakousiji/panels/demeritPanelService";
import { createDetailRowAccessorService } from "./kakousiji/panels/detailRowAccessorService";
import { createFukushizaiBaseSyncService } from "./kakousiji/panels/fukushizaiBaseSyncService";
import { createFukushizaiContextColorService } from "./kakousiji/panels/fukushizaiContextColorService";
import { createFukushizaiCopyContentService } from "./kakousiji/panels/fukushizaiCopyContentService";
import { createFukushizaiCopyMutationService } from "./kakousiji/panels/fukushizaiCopyMutationService";
import { createFukushizaiGroupActionService } from "./kakousiji/panels/fukushizaiGroupActionService";
import { createFukushizaiCopyPreviewService } from "./kakousiji/panels/fukushizaiCopyPreviewService";
import { createFukushizaiRegisteredGroupService } from "./kakousiji/panels/fukushizaiRegisteredGroupService";
import { createPanelDetailPostProcessService } from "./kakousiji/panels/panelDetailPostProcessService";
import { createPanelDetailSourceResolverService } from "./kakousiji/panels/panelDetailSourceResolverService";
import { createFukushizaiPanelDisplayService } from "./kakousiji/panels/fukushizaiPanelDisplayService";
import { createFukushizaiGroupDialogService } from "./kakousiji/panels/fukushizaiGroupDialogService";
import { createFukushizaiContextCommitService } from "./kakousiji/panels/fukushizaiContextCommitService";
import { createFukushizaiGroupCopyService } from "./kakousiji/panels/fukushizaiGroupCopyService";
import { createFukushizaiContextMutationUiService } from "./kakousiji/panels/fukushizaiContextMutationUiService";
import { createFukushizaiDetailSyncService } from "./kakousiji/panels/fukushizaiDetailSyncService";
import { createFukushizaiDirtyStateService } from "./kakousiji/panels/fukushizaiDirtyStateService";
import { createFukushizaiDisplayFlushService } from "./kakousiji/panels/fukushizaiDisplayFlushService";
import { createFukushizaiRepresentativeProjectionService } from "./kakousiji/panels/fukushizaiRepresentativeProjectionService";
import { createFukushizaiProjectionContextService } from "./kakousiji/panels/fukushizaiProjectionContextService";
import { createFukushizaiDisplaySyncService } from "./kakousiji/panels/fukushizaiDisplaySyncService";
import { createFixedVerticalDisplayService } from "./kakousiji/panels/fixedVerticalDisplayService";
import { createFukushizaiDisplayMetaService } from "./kakousiji/panels/fukushizaiDisplayMetaService";
import { createFukushizaiDisplayRowMergeService } from "./kakousiji/panels/fukushizaiDisplayRowMergeService";
import { createKomonoFudaDisplayService } from "./kakousiji/panels/komonoFudaDisplayService";
import { createQualityBaseSyncService } from "./kakousiji/panels/qualityBaseSyncService";
import { createQualityDisplayRowService } from "./kakousiji/panels/qualityDisplayRowService";
import { createQualityDetailSaveService } from "./kakousiji/panels/qualityDetailSaveService";
import { createQualityEntryProjectionService } from "./kakousiji/panels/qualityEntryProjectionService";
import { createQualityFieldService } from "./kakousiji/panels/qualityFieldService";
import { createGenkaRecalcService } from "./kakousiji/panels/genkaRecalcService";
import { createGenkaSummaryGridService } from "./kakousiji/panels/genkaSummaryGridService";
import { createGridMasterSearchService } from "./kakousiji/panels/gridMasterSearchService";
import { createMasterNameHydratorService } from "./kakousiji/panels/masterNameHydratorService";
import { createSustainableImageService } from "./kakousiji/panels/sustainableImageService";
import { createMasterSearchRoutingService } from "./kakousiji/search/masterSearchRoutingService";
import { createWashPanelService } from "./kakousiji/panels/washPanelService";
import { createDemandHeaderRenderer } from "./kakousiji/renderers/demandHeaderRenderer";
import { createGenkaDisplayColumnService } from "./kakousiji/renderers/genkaDisplayColumnService";
import { createGenkaHeaderRenderer } from "./kakousiji/renderers/genkaHeaderRenderer";
import { createPanelContentRenderer } from "./kakousiji/renderers/panelContentRenderer";
import { createSectionActionRenderer } from "./kakousiji/renderers/sectionActionRenderer";
import { createSectionDisplayHelperService } from "./kakousiji/renderers/sectionDisplayHelperService";
import { createTotalGridService } from "./kakousiji/renderers/totalGridService";
import { createSectionLayoutRenderer } from "./kakousiji/renderers/sectionLayoutRenderer";
import EntryFormLayout from "./kakousiji/components/EntryFormLayout";
import EntryHeaderOverlay from "./kakousiji/components/EntryHeaderOverlay";
import SangenDisplayDialog from "./kakousiji/SangenDisplayDialog";
import SustainableImagePanel from "./kakousiji/components/SustainableImagePanel";
import { createFukushizaiProjection } from "./kakousiji/projections/fukushizaiProjection";
import { createQualityProjection } from "./kakousiji/projections/qualityProjection";
import { createLoadDataOrchestrator } from "./kakousiji/loadDataOrchestrator";
import { createEntryVisualPostLoadCoordinator } from "./kakousiji/entryVisualPostLoadCoordinator";
import { createFukushizaiContextGridService } from "./kakousiji/grid/fukushizaiContextGridService";
import { createGridRefreshCoordinator } from "./kakousiji/grid/gridRefreshCoordinator";
import { createSectionPanelResolver } from "./kakousiji/sections/sectionPanelResolver";
import { createSectionNavigationService } from "./kakousiji/sections/sectionNavigationService";
import { createSectionRenderModelResolver } from "./kakousiji/sections/sectionRenderModelResolver";
import "../css/Kakousiji.css";
import Button from '@material-ui/core/Button';
import { isEmpty, getglobaldata, Getstorage, Savestorage, DeepCopy, setglobaldata, getformid, getcontroller, getsubkey, initializedata, isEnabled, DicVal, CellType } from '../modules/appLibrary';
import { cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, gridmaximize, setchangeurl, entrydata, entryrerender } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';
import { createColumnIdUtil } from "./kakousiji/columnIdUtil";
import { createTypeColumnResolver } from "./kakousiji/panels/typeColumnResolver";
import { createDemandRowNormalizer } from "./kakousiji/panels/demandRowNormalizer";
import {
    normalizeGroupNo as sharedNormalizeGroupNo,
    groupNoToLabel as sharedGroupNoToLabel,
    formatNamedOptionLabel as sharedFormatNamedOptionLabel
} from "./kakousiji/panels/groupIdentityUtil";

export const Kakousiji = props => {

    // =====================================================================
    // 加工指示入力画面の主要処理。
    // ---------------------------------------------------------------------
    // レイアウト項目、Grid表示、セクション別の投影、保存payload生成を扱う。
    // =====================================================================

    // =====================================================================
    // 定数定義
    // ---------------------------------------------------------------------
    // 画面type、保存先type、セクション別の物理列名をまとめる。
    // =====================================================================

    const panelsdef = [];
    const GridPanelStorageKey = "Kakousiji_GridPanel";
    const G_id = { BASE: "0", IMAGE: "pic", FILE: "file", NB: "nb", PL:"pl" }
    const PANEL_TYPE = {
        // 商品情報(101) / 基本情報１(102) / 基本情報２(103) / 素材(106) / 附属(109) / トレーサビリティ情報(129)
        PRODUCT_INFO: "101",
        BASE_INFO1: "102",
        BASE_INFO2: "103",
        MATERIAL: "106",
        ACCESSORY: "109",
        TRACEABILITY: "129",

        // 指示数(104) / 素材明細(107) / 附属明細(110)
        SIJISU: "104",
        SIJISU_TOTAL: "105",
        MATERIAL_DETAIL: "107",
        ACCESSORY_DETAIL: "110",

        // 素材配色(108) / 附属配色(111) / 小物札(114) / ブランドネーム(115) / その他ネーム(116) / その他副資材(117) / 組成(118) / 法定外表示(120) / 付記用語(121) / 構成部品(122) / デメリット(123) / 登録グループ(125)
        MATERIAL_COLORWAY: "108",
        ACCESSORY_COLORWAY: "111",
        FUKUSHIZAI_LIST: "112",
        FUKUSHIZAI_BASE: "113",
        KOMONOFUDA: "114",
        BRAND_NAME: "115",
        OTHER_NAME: "116",
        OTHER_FUKUZAI: "117",
        QUALITY_BASE: "118",
        QUALITY_DISPLAY_EXTRA: "119",
        HOUTEIGAI_HYOJI: "120",
        FUKKI_YOGO: "121",
        KOSEI_BUHIN: "122",
        DEMERIT: "123",
        REGISTERED_GROUP: "125",

        // 品質表示(118)
        QUALITY: "118",

        // 洗濯表示(wash)
        WASH: "124",

        // 原価(126)
        GENKA: "126",
        GENKA_SUMMARY: "127",

        // サステナブルマーク(128)
        SUSTAINABLE_MARK: "128",

        // 受注数(130) / 納品予定(131)
        JUTYUSU: "130",
        NOUHIN_YOTEI: "131",

        SAMPLE_BASE: "132",
        SAMPLE_INFO: "133",
        SAMPLE_COMMENT: "134",
        SAMPLE_DETAIL: "135",
        SAMPLE_TOTAL: "136",
        SAMPLE_COMMON_COMMENT: "137",
        SAMPLE_SOSEI: "138"
    };
    // 洗濯表示は section id と panel type の両方で判定するため、alias を分けて持つ。
    const WASH_PANEL_SECTION_IDS = ["wash", "sentakuhyoji"];
    const WASH_PANEL_IDS = [...WASH_PANEL_SECTION_IDS, PANEL_TYPE.WASH];
    const WASH_STP_CODE_FIELD = "SSDE_STPCD";
    const WASH_STP_SEARCH_CHANGE_URL = "common/GetSearchMasterList=kakousiji/GetWashPatternSearchList";
    const KAKOUSIJI_SEARCH_MASTER_CHANGE_URL = "common/GetSearchMasterList=kakousiji/GetSearchMasterList";
    const WASH_STP_SEARCH_DATAID = "__KAKOUSIJI_WASH_STP__";
    const WASH_STP_CODE_DISPLAY_FIELDS = ["SSDE_STPCD_cd", "SSDE_STPCD_nm"];
    const WASH_STP_SENTAKU_FIELDS = ["STP_SENTAKU1", "STP_SENTAKU2", "STP_SENTAKU3", "STP_SENTAKU4", "STP_SENTAKU5", "STP_SENTAKU6", "STP_SENTAKU7"];
    // 洗濯表示(124)の複写/再構築時に、物理列(SSDE_*)と一緒に引き継ぐ表示用列。
    // 洗濯マークはM_STP結合由来のSTP_SENTAKU1-7(とmark1-7)から描画されるため、
    // これらを複写しないとSSDE_STPCD等のデータはコピーされても画面上は空表示になる。
    // 保存時は toWashSaveRows / isKakousijiSavePayloadUiOnlyField が表示専用列を除去するため保存へは影響しない。
    const WASH_COPY_DISPLAY_FIELD_IDS = [
        ...WASH_STP_CODE_DISPLAY_FIELDS,
        ...WASH_STP_SENTAKU_FIELDS,
        "mark1", "mark2", "mark3", "mark4", "mark5", "mark6", "mark7"
    ];
    const SUSTAINABLE_IMAGE_FILE_FIELD = "SSDSAS_SASEGATAFILEMEI";
    const SUSTAINABLE_RESERVE_FIELDS = [
        "SSDSAS_KOUMOKU1",
        "SSDSAS_KOUMOKU2",
        "SSDSAS_KOUMOKU3",
        "SSDSAS_KOUMOKU4",
        "SSDSAS_KOUMOKU5",
        "SSDSAS_KOUMOKU6",
        "SSDSAS_KOUMOKU7",
        "SSDSAS_KOUMOKU8"
    ];
    const SUSTAINABLE_SAVE_SOURCE_PANEL_TYPES = [PANEL_TYPE.SUSTAINABLE_MARK, PANEL_TYPE.TRACEABILITY];
    const SUSTAINABLE_SAVE_KEY_FIELDS = ["SSDSAS_NO"];
    // 画面項目定義の編集可否=1に合わせ、画面上だけ編集不可にする項目。
    // saveedは維持し、共通保存処理の対象から外さない。
    const DESIGN_READONLY_FIELD_IDS_BY_TYPE = {
        // 素材(106)の注意フラグ(SSDS_WARNINGFLG)は附属(109)と同様に入力可のため対象外。
        "107": new Set(["SSDS_LYOJAKU", "SSDS_CUR", "SSDS_MITUMORIRATE"]),
        "110": new Set(["SSDF_LYOJAKU", "SSDF_CUR", "SSDF_MITUMORIRATE"]),
        "111": new Set(["SSDFH_FUZOKU_HINBAN"]),
        [PANEL_TYPE.FUKUSHIZAI_LIST]: new Set(["SSDZM_FUZOKU_HINBAN", "SSDZM_LSURYO", "SSDZM_MITUMORIRATE"]),
        [PANEL_TYPE.KOMONOFUDA]: new Set(["SSDZ_KOMONOFUDACD"]),
        "131": new Set(["SSDNY_NO", "SSDNY_COLORCD", "SSDNY_SIZECD", "SSRM_SIIREBI", "SSRM_SIIRESU"]),
        [PANEL_TYPE.SAMPLE_INFO]: new Set(["SSDSP_KBN"]),
        [PANEL_TYPE.SAMPLE_DETAIL]: new Set(["SSDSPM_COLORCD", "SSDSPM_SIZECD"])
    };
    // 行の通貨単位により単価/金額の入力可否を切り替える対象。
    //   通貨=JPY  ：単価/金額     は入力可、単価(外)/金額(外) は入力不可
    //   通貨≠JPY ：単価(外)/金額(外) は入力可、単価/金額     は入力不可
    // 金額/金額(外)はtable="-"の計算項目で元々編集不可のため、実質は単価側の制御になる。
    const DOMESTIC_CURRENCY_CODE = "JPY";
    const CURRENCY_INPUT_LOCK_BY_TYPE = {
        [PANEL_TYPE.MATERIAL_DETAIL]: {
            currencyField: "SSDS_CUR",
            domesticFields: ["SSDS_TANKA", "SOZAI_KINGAKU"],
            foreignFields: ["SSDS_TANKAF", "SOZAI_KINGAKU_GAIKA"]
        },
        [PANEL_TYPE.ACCESSORY_DETAIL]: {
            currencyField: "SSDF_CUR",
            domesticFields: ["SSDF_TANKA", "FUZOKU_KINGAKU"],
            foreignFields: ["SSDF_TANKAF", "FUZOKU_KINGAKU_GAIKA"]
        },
        [PANEL_TYPE.FUKUSHIZAI_LIST]: {
            currencyField: "SSDZM_CUR",
            domesticFields: ["SSDZM_TANKA", "FUKUSHIZAI_ICHIRAN_KINGAKU"],
            foreignFields: ["SSDZM_TANKAF", "FUKUSHIZAI_ICHIRAN_KINGAKU_GAIKA"]
        }
    };
    const FUKUSHIZAI_BASE_PANEL_TYPE = PANEL_TYPE.FUKUSHIZAI_BASE;
    const FUKUSHIZAI_CONTEXT_DISPLAY_PANEL_TYPES = [
        PANEL_TYPE.KOMONOFUDA,
        PANEL_TYPE.BRAND_NAME,
        PANEL_TYPE.OTHER_NAME,
        PANEL_TYPE.OTHER_FUKUZAI
    ];
    const FUKUSHIZAI_PANEL_TYPES = [FUKUSHIZAI_BASE_PANEL_TYPE, ...FUKUSHIZAI_CONTEXT_DISPLAY_PANEL_TYPES];
    const QUALITY_DISPLAY_PANEL_TYPES = [
        PANEL_TYPE.QUALITY_BASE,
        PANEL_TYPE.QUALITY_DISPLAY_EXTRA,
        PANEL_TYPE.HOUTEIGAI_HYOJI,
        PANEL_TYPE.FUKKI_YOGO,
        PANEL_TYPE.KOSEI_BUHIN,
        PANEL_TYPE.DEMERIT,
        PANEL_TYPE.WASH
    ];
    // 品質表示グループ複写の対象パネル。
    // 組成(119)/法定外表示(120)/付記用語(121)/構成部品(122)/デメリット(123)/洗濯表示(124)。
    // 品質表示基本(118)の単票内容は複写対象外。
    // 副資材の複写(applyFukushizaiGroupCopyToState)は113のみ対象のため、この複写と重複しない。
    const QUALITY_GROUP_COPY_PANEL_TYPES = [
        PANEL_TYPE.QUALITY_DISPLAY_EXTRA,
        PANEL_TYPE.HOUTEIGAI_HYOJI,
        PANEL_TYPE.FUKKI_YOGO,
        PANEL_TYPE.KOSEI_BUHIN,
        PANEL_TYPE.DEMERIT,
        PANEL_TYPE.WASH
    ];
    const QUALITY_BASE_EXTRA_SAVE_FIELD_IDS = [];
    // 品質表示スコープ先頭に表示する品表注意パネル(D_SSDヘッダ列: SSD_WARNINGFLG/SSD_WARNING)。
    // 専用type(139)はDETAIL_SAVE_TARGET_TYPE_MAPの集約対象外のため、標準のヘッダ保存でD_SSDへ保存される。
    // (type=118に入れると明細集約ストリップでヘッダ保存dataから外れ、デフォルト値上書きで値が消えるため専用typeが必須)
    const QUALITY_WARNING_PANEL_TYPE = "139";
    // 摘要(SSDE_TEKIYO)は品質表示(118)の単票項目だが物理列は洗濯表示(D_SSDE)。
    // 洗濯表示(124)の保存列セットへ加えないと、保存payload生成時のstripで除去される。
    const WASH_EXTRA_SAVE_FIELD_IDS = ["SSDE_TEKIYO"];
    const QUALITY_ROOT_DATA_PREFIXES = ["SSDQ_", "SSDH_", "SSDY_", "SSDB_", "SSDD_", "SSDE_"];
    // NOTE: 113〜117、118〜125、128/129は保存先typeを集約する。
    const DETAIL_SAVE_TARGET_TYPE_MAP = {
        [PANEL_TYPE.BASE_INFO1]: PANEL_TYPE.BASE_INFO1,
        [PANEL_TYPE.MATERIAL]: PANEL_TYPE.MATERIAL,
        [PANEL_TYPE.MATERIAL_DETAIL]: PANEL_TYPE.MATERIAL_DETAIL,
        [PANEL_TYPE.MATERIAL_COLORWAY]: PANEL_TYPE.MATERIAL_COLORWAY,
        [PANEL_TYPE.ACCESSORY]: PANEL_TYPE.ACCESSORY,
        [PANEL_TYPE.ACCESSORY_DETAIL]: PANEL_TYPE.ACCESSORY_DETAIL,
        [PANEL_TYPE.ACCESSORY_COLORWAY]: PANEL_TYPE.ACCESSORY_COLORWAY,
        [PANEL_TYPE.FUKUSHIZAI_BASE]: PANEL_TYPE.FUKUSHIZAI_BASE,
        [PANEL_TYPE.KOMONOFUDA]: PANEL_TYPE.FUKUSHIZAI_BASE,
        [PANEL_TYPE.BRAND_NAME]: PANEL_TYPE.FUKUSHIZAI_BASE,
        [PANEL_TYPE.OTHER_NAME]: PANEL_TYPE.FUKUSHIZAI_BASE,
        [PANEL_TYPE.OTHER_FUKUZAI]: PANEL_TYPE.FUKUSHIZAI_BASE,
        [PANEL_TYPE.QUALITY_BASE]: PANEL_TYPE.QUALITY_BASE,
        [PANEL_TYPE.QUALITY_DISPLAY_EXTRA]: PANEL_TYPE.QUALITY_BASE,
        [PANEL_TYPE.HOUTEIGAI_HYOJI]: PANEL_TYPE.QUALITY_BASE,
        [PANEL_TYPE.FUKKI_YOGO]: PANEL_TYPE.QUALITY_BASE,
        [PANEL_TYPE.KOSEI_BUHIN]: PANEL_TYPE.QUALITY_BASE,
        [PANEL_TYPE.DEMERIT]: PANEL_TYPE.QUALITY_BASE,
        [PANEL_TYPE.WASH]: PANEL_TYPE.QUALITY_BASE,
        // 登録グループ(125)は画面・保存対象から削除済み(明細はD_SSDQへ統合しない)。
        [PANEL_TYPE.SUSTAINABLE_MARK]: PANEL_TYPE.SUSTAINABLE_MARK,
        [PANEL_TYPE.TRACEABILITY]: PANEL_TYPE.SUSTAINABLE_MARK,
        [PANEL_TYPE.NOUHIN_YOTEI]: PANEL_TYPE.NOUHIN_YOTEI,
        [PANEL_TYPE.SAMPLE_INFO]: PANEL_TYPE.SAMPLE_INFO,
        [PANEL_TYPE.SAMPLE_COMMENT]: PANEL_TYPE.SAMPLE_INFO,
        [PANEL_TYPE.SAMPLE_COMMON_COMMENT]: PANEL_TYPE.SAMPLE_INFO
    };
    const GROUPED_DETAIL_TARGET_TYPES = [...new Set(Object.values(DETAIL_SAVE_TARGET_TYPE_MAP))];
    const FUKUSHIZAI_FIELD = {
        NO: "SSDZ_NO",
        ITEM_CD: "SSDZ_ITMCITEMCD",
        COLOR_CD: "SSDZ_COLORCD",
        GROUP_NO: "SSDZ_FUKUSIZAICOLORGRP"
    };
    const ROW_ID_FIELD = "rowid";
    const FUKUSHIZAI_DISPLAY_DMY_FIELD = {
        KOMONOFUDA: "KOMONOFUDA_NAIYO_DMY",
        BRAND_NAME: "BRANDNAME_CD_DMY",
        OTHER_NAME: "SONOTANAME_CD_DMY",
        OTHER_FUKUZAI: "SONOTAFUZOKU_CD_DMY"
    };
    const FUKUSHIZAI_UI_META_PREFIXES = ["__FUKUSHIZAI", "__KOMONOFUDA", "__QUALITY", "__PREVIEW", "__SOURCE"];
    const QUALITY_PANEL_FIELD_MAP = {
        "118": { no: "SSDQ_NO", item: "SSDQ_ITMCITEMCD", group: "SSDQ_GROUPNO", groupFallback: "SSDQ_FUKUSIZAICOLORGRP", color: "SSDQ_COLORCD", order: "SSDQ_HYOJIJUN", invalid: "SSDQ_INVALID" },
        "119": { no: "SSDQ_NO", item: "SSDQ_ITMCITEMCD", group: "SSDQ_GROUPNO", groupFallback: "SSDQ_FUKUSIZAICOLORGRP", color: "SSDQ_COLORCD", order: "SSDQ_HYOJIJUN", invalid: "SSDQ_INVALID" },
        "120": { no: "SSDH_NO", item: "SSDH_ITMCITEMCD", group: "SSDH_GROUPNO", groupFallback: "SSDH_FUKUSIZAICOLORGRP", color: "SSDH_COLORCD", order: "SSDH_HYOJIJUN", invalid: "SSDH_INVALID" },
        "121": { no: "SSDY_NO", item: "SSDY_ITMCITEMCD", group: "SSDY_GROUPNO", groupFallback: "SSDY_FUKUSIZAICOLORGRP", color: "SSDY_COLORCD", order: "SSDY_HYOJIJUN", invalid: "SSDY_INVALID" },
        "122": { no: "SSDB_NO", item: "SSDB_ITMCITEMCD", group: "SSDB_GROUPNO", groupFallback: "SSDB_FUKUSIZAICOLORGRP", color: "SSDB_COLORCD", order: "SSDB_HYOJIJUN", invalid: "SSDB_INVALID" },
        "123": { no: "SSDD_NO", item: "SSDD_ITMCITEMCD", group: "SSDD_GROUPNO", groupFallback: "SSDD_FUKUSIZAICOLORGRP", color: "SSDD_COLORCD", order: "SSDD_HYOJIJUN", invalid: "SSDD_INVALID" },
        [PANEL_TYPE.WASH]: { no: "SSDE_NO", item: "SSDE_ITMCITEMCD", group: "SSDE_GROUPNO", groupFallback: "SSDE_FUKUSIZAICOLORGRP", color: "SSDE_COLORCD", order: "SSDE_PATANKBN", invalid: "SSDE_INVALID" }
    };
    const FUKUSHIZAI_LIST_PANEL_TYPE = PANEL_TYPE.FUKUSHIZAI_LIST;
    const FUKUSHIZAI_LIST_SAVE_FIELD_IDS = [
        "SSDZM_NO",
        "SSDZM_OPPICD",
        "SSDZM_HYOJIJUN",
        "SSDZM_FUSIZAIKBN",
        "SSDZM_FUZOKU_HINBAN",
        "SSDZM_TORKUBUN",
        "SSDZM_TORCODE",
        "SSDZM_TORSUBCODE",
        "SSDZM_YOJAKUKOSU",
        "SSDZM_LOSSRITU",
        "SSDZM_LSURYO",
        "SSDZM_CUR",
        "SSDZM_TANKA",
        "SSDZM_TANKAF",
        "SSDZM_SIKYUKBN",
        "SSDZM_MITUMORIRATE",
        "SSDZM_GENKADSPFLG",
        "SSDZM_HACHUTAISYOFLG",
        "SSDZM_HACHUJYOKYOFLG",
        "SSDZM_FUKUSIZAIHACHUDENNO"
    ];
    const SIJISU_TOTAL_COL_ID = "SIJISU_TOTAL";
    const JUTYU_SUMMARY_COL_ID = {
        colorSubtotal: "JUTYU_COLOR_TOTAL",
        totalLabel: "JUTYU_TOTAL"
    };
    const NOUHIN_SUMMARY_COL_ID = {
        zansu: "NOUHIN_ZANSU",
        toinyuTotal: "NOUHIN_TOINYU_TOTAL",
        siireTotal: "NOUHIN_SIIRE_TOTAL",
        nouhinTotal: "NOUHIN_YOTEI_TOTAL",
        centerTotal: "NOUHIN_CENTER_TOTAL",
        part1Total: "NOUHIN_BUNNO1_TOTAL",
        part2Total: "NOUHIN_BUNNO2_TOTAL",
        part3Total: "NOUHIN_BUNNO3_TOTAL",
        part4Total: "NOUHIN_BUNNO4_TOTAL",
        zansuTotal: "NOUHIN_ZANSU_TOTAL"
    };
    const BASE_UI_ONLY_COL_IDS = [
        "KIHON1_SHIIRE_GENKA",
        "KIHON2_JOKEN_SHIIRE"
    ];

    // =====================================================================
    // 画面操作・セクション定義
    // ---------------------------------------------------------------------
    // 固定メニュー、セクション、Kakousiji固有の定数をまとめる。
    // =====================================================================

    //const DEMERIT_TYPE = PANEL_TYPE.DEMERIT;
    const DEMERIT_KIND_FIELD = "SELECTEDDEMERITKIND";
    const DEMERIT_KIND_NAME = "1";
    const DEMERIT_KIND_HUDA = "2";
    const DEMERIT_NAME_FLG = "SSDD_NAMEFLG";
    const DEMERIT_HUDA_FLG = "SSDD_HUDAFLAG";
    const DEMERIT_DMT_CD = "SSDD_DMTCD";
    const DEMERIT_NAME_DMY = "SSDD_DMTCD_NAME_DMY";
    const DEMERIT_HUDA_DMY = "SSDD_DMTCD_HUDA_DMY";
    const DEMERIT_UI_FIELDS = [DEMERIT_KIND_FIELD, DEMERIT_NAME_DMY, DEMERIT_HUDA_DMY];
    const DEMERIT_HIDDEN_DB_FIELDS = [DEMERIT_NAME_FLG, DEMERIT_HUDA_FLG, DEMERIT_DMT_CD];
    const DEMERIT_KIND_OPTIONS = [
        { code: "", name: "" },
        { code: DEMERIT_KIND_NAME, name: "ネーム" },
        { code: DEMERIT_KIND_HUDA, name: "札" }
    ];
    const SAMPLE_SAVE_DETAIL_TYPE_SET = new Set([
        PANEL_TYPE.SAMPLE_INFO,
        PANEL_TYPE.SAMPLE_COMMENT,
        PANEL_TYPE.SAMPLE_DETAIL,
        PANEL_TYPE.SAMPLE_COMMON_COMMENT,
        PANEL_TYPE.SAMPLE_SOSEI
    ]);

    //const listGetListUrl = "kakousiji/GetList";
    const listGetListUrl = "kakousiji/GetListData";
    const listTabsUrl = "kakousiji/GetListTabs";
    const entryDataUrl = "kakousiji/GetEntryData";
    const genkaPatternUrl = "kakousiji/GetGenkaPattern";
    const komonoFudaLabelsUrl = "kakousiji/GetKomonoFudaLabels";
    const qualityHsituhabaResolveUrl = "kakousiji/ResolveQualityHsituhaba";
    const sangenDisplayUrl = "kakousiji/GetSangenDisplay";

    const actionurl = {
        "getlist": listGetListUrl,
        "insert": "forms/Insert",
         "update": "forms/Update",
        "delete": "kakousiji/KakousijiDelete",
         "saveas": "forms/SaveAs",
         "storageadd": "forms/AddStorage",
         "storagerowdel": "forms/StorageRowdel",
         "upload": "forms/Upload"
    }

    const ORDER_DEF = [
        { id: "seihin", action: "seihin_bulk_order", historyLabel: "製商品発注", menuLabel: "製商品一括発注" },
        { id: "sozai", action: "sozai_bulk_order", historyLabel: "素材発注", menuLabel: "素材一括発注" },
        { id: "fuzoku", action: "fuzoku_bulk_order", historyLabel: "附属発注", menuLabel: "附属一括発注" },
        { id: "fukushizai", action: "fukushizai_bulk_order", historyLabel: "副資材発注", menuLabel: "副資材一括発注" }
    ];
    const SECTION_ORDER_ACTION_MAP = {
        sample_info: "seihin",
        sozai_meisai: "sozai",
        fuzoku_meisai: "fuzoku",
        fukushizai_ichiran: "fukushizai"
    };
    const orderHistoryDefs = ORDER_DEF.map(({ id, action, historyLabel }) => ({
        id: id,
        action: action,
        label: historyLabel
    }));
    const viewOrderMenus = ORDER_DEF.map(({ action, menuLabel }) => ({
        status: "VIEW",
        menuid: action,
        icon: "open_in_new",
        label: menuLabel
    }));
    const navmenu = [
        { status: "ENTRY FORM", menuid: "kakousiji_report", icon: "print", label: "加工指示書発行" },
        { status: "ENTRY FORM", menuid: "hinshitsu_tehai", icon: "print", label: "品質表示手配書発行" },
        { status: "ENTRY FORM", menuid: "fukushizai_tehai", icon: "print", label: "副資材手配書発行" },
        { status: "ENTRY FORM", menuid: "fuzoku_tehai", icon: "print", label: "附属手配書発行" },
        { status: "ENTRY FORM", menuid: "sozai_tehai", icon: "print", label: "素材手配書発行" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        ...viewOrderMenus,
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "kakousiji_report", icon: "print", label: "加工指示書発行" },
        { status: "VIEW", menuid: "hinshitsu_tehai", icon: "print", label: "品質表示手配書発行" },
        { status: "VIEW", menuid: "fukushizai_tehai", icon: "print", label: "副資材手配書発行" },
        { status: "VIEW", menuid: "fuzoku_tehai", icon: "print", label: "附属手配書発行" },
        { status: "VIEW", menuid: "sozai_tehai", icon: "print", label: "素材手配書発行" },
    ]
    // TODO(kakousiji-backend): 実装時は KakousijiController 側へ実体追加
    const kakousijiUiActionUrl = "kakousiji/UiAction";
    const kakousijiColorwayMatrixUrlBySection = {
        sozai_haisyoku: "kakousiji/GetColorwayDetailMatrix",
        fuzoku_haisyoku: "kakousiji/GetColorwayDetailMatrix"
    };
    const UI_ACTION = {
        // TODO(kakousiji-backend): action名はbackend側仕様確定後に見直し
        GROUP_ADD: "group_add",
        GROUP_DELETE: "group_delete",
        GROUP_EDIT: "group_edit",
        GROUP_COPY: "group_copy",
        DETAIL_ADD: "detail_add",
        DETAIL_DELETE: "detail_delete",
        DETAIL_COPY: "detail_copy",
        CALC: "calc"
    };
    const DETAIL_COPY_MODE = {
        LIST_REFLECT: "list_reflect",
        BULK_LOSS: "bulk_loss",
        BULK_SHIKYU: "bulk_shikyu"
    };
    const FUKUSHIZAI_LIST_TARGET_SECTION_ID = "fukushizai_ichiran";
    const FUKUSHIZAI_BASE_MASTER_FIELD_IDS = [
        "SSDZ_SAGEFUDASIZECD",
        "SSDZ_SIIRUNOCD",
        "SSDZ_SUKARTOTURICD",
        "SSDZ_SPEAFUKUROCD",
        "SSDZ_BINIRUFUKUROCD",
        "SSDZ_KAIGAINJICD",
        "SSDZ_KOMONOFUDACD",
        "SSDZ_SIZENAMECD1",
        "SSDZ_SIZENAMECD2",
        "SSDZ_SIZENAMECD3",
        "SSDZ_SIZENAMECD4",
        "SSDZ_SIZENAMECD5",
        "SSDZ_SIZENAMECD6",
        "SSDZ_BRANDNAMECD1",
        "SSDZ_BRANDNAMECD2",
        "SSDZ_BRANDNAMECD3",
        "SSDZ_SONOTANAMECD1",
        "SSDZ_SONOTANAMECD2",
        "SSDZ_SONOTANAMECD3",
        "SSDZ_SONOTANAMECD4",
        "SSDZ_SONOTANAMECD5",
        "SSDZ_SONOTANAMECD6",
        "SSDZ_SONOTAFUZOKUCD1",
        "SSDZ_SONOTAFUZOKUCD2",
        "SSDZ_SONOTAFUZOKUCD3",
        "SSDZ_SONOTAFUZOKUCD4",
        "SSDZ_SONOTAFUZOKUCD5",
        // 仕入先はマスタ参照項目（datatype=6 / V_SUPPLIER:SSDZ / TOR_NAMERNM）。
        // マスタ項目として扱わないと名称の取得・キャッシュが走らず、コードだけの表示になる。
        "SSDZ_TORCODE"
    ];
    const FUKUSHIZAI_BASE_EXTRA_FIELD_IDS = [
        "SSDZ_SITEIGENSANKOKUCD",
        "SSDZ_LOX",
        "SSDZ_WARNINGFLG",
        "SSDZ_WARNING",
        "SSDZ_TORSUBCODE",
        "SSDZ_TORKUBUN",
        "SSDZ_SHIIREPOENF"
    ];
    const MATERIAL_ZAI_LINKED_FIELD_IDS = [
        "ZAI_QUALITY",
        "ZAI_KIKAKU",
        "ZAI_KIKAKUE",
        "ZAI_COUNTRY",
        "ZAI_TORCODE",
        "ZAI_BIKOU"
    ];
    const KOMONOFUDA_SIZE_RATE_FIELD_IDS = [
        "SSDZ_KOMONOSIZERITU1",
        "SSDZ_KOMONOSIZERITU2",
        "SSDZ_KOMONOSIZERITU3",
        "SSDZ_KOMONOSIZERITU4",
        "SSDZ_KOMONOSIZERITU5",
        "SSDZ_KOMONOSIZERITU6"
    ];
    const FUKUSHIZAI_SSDZ_TEMPLATE_FIELD_IDS = [
        FUKUSHIZAI_FIELD.NO,
        FUKUSHIZAI_FIELD.ITEM_CD,
        FUKUSHIZAI_FIELD.GROUP_NO,
        FUKUSHIZAI_FIELD.COLOR_CD,
        ...FUKUSHIZAI_BASE_MASTER_FIELD_IDS,
        ...FUKUSHIZAI_BASE_EXTRA_FIELD_IDS,
        ...KOMONOFUDA_SIZE_RATE_FIELD_IDS
    ];
    const FUKUSHIZAI_LIST_FIELD_RULES = [
        { kind: "01", fields: ["SSDZ_SAGEFUDASIZECD"] },
        { kind: "02", fields: ["SSDZ_BRANDNAMECD1", "SSDZ_BRANDNAMECD2", "SSDZ_BRANDNAMECD3"] },
        { kind: "03", fields: ["SSDZ_SIZENAMECD1", "SSDZ_SIZENAMECD2", "SSDZ_SIZENAMECD3", "SSDZ_SIZENAMECD4", "SSDZ_SIZENAMECD5", "SSDZ_SIZENAMECD6"] },
        { kind: "04", fields: ["SSDZ_SONOTANAMECD1", "SSDZ_SONOTANAMECD2", "SSDZ_SONOTANAMECD3", "SSDZ_SONOTANAMECD4", "SSDZ_SONOTANAMECD5", "SSDZ_SONOTANAMECD6"] },
        { kind: "05", fields: ["SSDZ_SIIRUNOCD"] },
        { kind: "06", fields: ["SSDZ_SUKARTOTURICD"] },
        { kind: "07", fields: ["SSDZ_SPEAFUKUROCD"] },
        { kind: "08", fields: ["SSDZ_BINIRUFUKUROCD"] },
        { kind: "09", fields: ["SSDZ_KAIGAINJICD"] },
        { kind: "11", fields: ["SSDZ_KOMONOFUDACD"] },
        { kind: "10", fields: ["SSDZ_SONOTAFUZOKUCD1", "SSDZ_SONOTAFUZOKUCD2", "SSDZ_SONOTAFUZOKUCD3", "SSDZ_SONOTAFUZOKUCD4", "SSDZ_SONOTAFUZOKUCD5"] }
    ];
    const FUKUSHIZAI_LIST_QUALITY_KIND = "14";
    const FUKUSHIZAI_LIST_QUALITY_SOURCE_ORDER = FUKUSHIZAI_LIST_FIELD_RULES.length;
    const QUALITY_LIST_HABACD_FIELD = "SSDQ_HSITUHABACD";
    const QUALITY_LIST_FUZOKU_HINBAN_FIELD = "SSDQ_FUZOKU_HINBAN";
    const QUALITY_HSITUHABA_OPTIONS_DATA_KEY = "__qualityHsituhabaOptions";
    // アイテムタブ(副資材/品質表示)の既定アイテム。対象ドメインのdetailにアイテム/グループを
    // 持つ行が1件も無い場合、画面表示時にこのアイテムをseedして選択状態にする。
    const DEFAULT_ITEM_TAB_CD = "00";
    // アイテム追加ダイアログの候補一覧(アイテム名称マスタ m_code type=0138)取得URL。
    // 通常はロード時に __itemNameMasterOptions で同梱されるため、新規作成時のフォールバックとして使う。
    const ITEM_NAME_MASTER_LIST_URL = "kakousiji/GetKakousijiItemMasterList";
    const ITEM_NAME_MASTER_OPTIONS_DATA_KEY = "__itemNameMasterOptions";
    const FUKUSHIZAI_MASTER_PRIME_FIELD_IDS = [...new Set(FUKUSHIZAI_LIST_FIELD_RULES.flatMap((rule) => rule.fields || []))];

    const kakouTypeButtons = [
        { id: "type1", label: "基本情報" },
        { id: "type2", label: "受注数" },
        { id: "type3", label: "納品予定数" }
    ];
    const sectionChipTargetIds = [
        "product",
        "base1",
        "sijisu",
        "sozai",
        "fuzoku",
        "fukushizai",
        "hinshitsu",
        "genka",
        "sustainable"
    ];
    const sectionChipLabelMap = {
        base1: "基本情報",
        fukushizai: "副素材"
    };
    // Entry Form のセクション順と描画方式だけを保持する catalog です。
    // 見出しや panelId は GetListTabs.panels の内容で解決します。
    const kakouSectionDefs = kakousijiSectionCatalog;
    const kakouSampleSectionDefs = kakousijiSampleSectionCatalog;
    // 現在はSystem固定運用
    const emptyOrderHistoryData = { seihin: [], sozai: [], fuzoku: [], fukushizai: [] };
    const formid = getformid("Kakousiji", props.location.search);
    const controller = getcontroller("Kakousiji", props.location.search);
    const subkey = getsubkey(props.location.search);

    // =====================================================================
    // 画面状態・参照情報
    // ---------------------------------------------------------------------
    // 画面state、ref、Redux値をまとめる。
    // =====================================================================

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const AGRef = useRef();
    const fnc = useRef();
    const baseref = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State
    const pendingShowRef = useRef(null);   //初期準備前のShow要求（解決済みcode）を1回保留
    // VIEW→Entry遷移直後のLoadDataで基本情報タブへ戻すための1回限りフラグ。
    // 保存後の再表示(LoadData直呼び)ではタブを維持するため、Show経路でのみ立てる。
    const entryShowKakouTypeResetRef = useRef(false);
    const fukushizaiDetailSyncingRef = useRef(false);
    const brandNameEntryDataRef = useRef({});
    const fukushizaiPreviewEntryDataRef = useRef({});
    const fukushizaiRepresentativeRowRef = useRef({ rowid: "", index: -1 });
    const komonoFudaLabelCacheRef = useRef({});
    const komonoFudaLabelLoadingRef = useRef({});
    const fukushizaiMasterNameCacheRef = useRef({});
    const fukushizaiMasterNameLoadingRef = useRef({});
    const genkaSummaryCurrencyNameLoadingRef = useRef({});
    const genkaPatternRequestSeqRef = useRef(0);
    const qualityHsituhabaOptionsRef = useRef([]);
    const qualityHsituhabaResolvedMapRef = useRef({});
    const qualityHsituhabaFallbackLoadedRef = useRef(false);
    const washStpSearchChangeUrlBackupRef = useRef([]);
    const washStpSearchRoutingActiveRef = useRef(false);
    const kakousijiSearchMasterChangeUrlBackupRef = useRef([]);
    const kakousijiSearchMasterRoutingActiveRef = useRef(false);
    const colorwayProductColorSelectionCacheRef = useRef({});
    const colorwayMaterialColorNoSelectionCacheRef = useRef({});
    const materialZaiHinbanSelectionCacheRef = useRef({});
    const accessoryFuzokuHinbanSelectionCacheRef = useRef({});
    const linkedDetailSyncTimerRef = useRef({});
    const sustainableImageRequestSeqRef = useRef(0);
    const sustainableImageFileCancelBlurRef = useRef(false);
    const fukushizaiDirtyPanelRef = useRef({});
    const fukushizaiBaseDirtyRef = useRef({ context: createEmptyFukushizaiContext(), fields: {} });
    const qualityBaseDirtyRef = useRef({ context: createEmptyFukushizaiContext(), fields: {} });
    const fukushizaiProjectionGuardRef = useRef(false);
    const fukushizaiProjectionGuardTimerRef = useRef(null);
    const entryLoadingRef = useRef(false); // Entry読込中フラグ（tabs側wait(false)による消し込み防止）
    const entryLoadTimingRef = useRef(null);
    const currentLoadRequestCodeRef = useRef("");
    const entryVisualTraceActiveUntilRef = useRef(0);
    const deferredEntryVisualTraceTimersRef = useRef([]);
    const entryVisualTraceSeqRef = useRef(0);
    const dispatchBaseEntryDataTraceRef = useRef(null);
    const finalizeEntryVisualTraceRef = useRef(null);
    const autoGenkaPatternWatchKeyRef = useRef("");
    const supplierCostAttributeWatchKeyRef = useRef("");
    const [tabsReady, setTabsReady] = useState(false); // GetListTabs完了後にtrue

    const formstatus = useSelector(state => state.form.status);
    const waitOpen = useSelector(state => state.form.wait);
    const entrylock = useSelector(state => state.form.entryformlock);
    const entryinputrender = useSelector(state => state.form.entryinputrender);
    const formListOption = useSelector(state => state.form.listoption);
    // 性能対策: form.entrydata は useSelector で購読しない。
    // (購読すると EntryInput の dispatch(entrydata) のたびに本画面全体が再レンダーされ、
    //  文字入力が非常に重くなるため。トレースで必要な時だけ store から直接読む)
    const reduxStore = useStore();
    const warndescription = useSelector(state => state.form.warndiscription);
    // getRowStyle は描画中に参照されるため、同一レンダー内で最新値を読めるよう ref へ写します。
    const warndescriptionRef = useRef([]);
    warndescriptionRef.current = Array.isArray(warndescription) ? warndescription : [];
    const washlist1 = useSelector(state => state.menu.washlist1);
    const washlist2 = useSelector(state => state.menu.washlist2);
    const washlist3 = useSelector(state => state.menu.washlist3);
    const washlist4 = useSelector(state => state.menu.washlist4);
    const washlist5 = useSelector(state => state.menu.washlist5);
    const washlist6 = useSelector(state => state.menu.washlist6);
    const washlist7 = useSelector(state => state.menu.washlist7);
    const changeurl = useSelector(state => state.form.changeurl);
    const searchlistOpen = useSelector(state => state.search.open);
    const searchlistOpenRef = useRef(false);
    const prevFormstatusRef = useRef(formstatus);
    const prevWaitOpenRef = useRef(waitOpen);
    const [panel, setpanel] = useState(panelsdef);
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);

    // ---- 共有モジュール(kakousiji/)の生成 ----
    // 品番マスタと同一ロジックで出すため、列ID正規化・型別列解決・受注/納品行の集計はモジュール側に集約する。
    const columnIdUtil = createColumnIdUtil({ isEmpty, DicVal });
    const typeColumnResolver = createTypeColumnResolver({
        isEmpty,
        getColumnInfo: () => columninfo,
        getColumns: () => columns,
        normalizeTypeKey: (key) => normalizeTypeKey(key),
        normalizeColumnIdSuffix: (columnid) => normalizeColumnIdSuffix(columnid),
        normalizeLabelKey: (label) => normalizeLabelKey(label)
    });
    const demandRowNormalizer = createDemandRowNormalizer({
        isEmpty,
        DicVal,
        resolveTypeColumnIdBySuffix: (type, suffixCandidates) => resolveTypeColumnIdBySuffix(type, suffixCandidates),
        resolveTypeColumnIdByName: (type, nameCandidates) => resolveTypeColumnIdByName(type, nameCandidates),
        resolveTypeColumnNameById: (type, columnId) => resolveTypeColumnNameById(type, columnId),
        JUTYU_SUMMARY_COL_ID,
        NOUHIN_SUMMARY_COL_ID
    });

    const [edittingcode, setedittingcode] = useState(null);
    const [primarykeys, setprimarykeys] = useState([]);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [resolvedSections, setResolvedSections] = useState(kakouSectionDefs);
    const [resolvedSampleSections, setResolvedSampleSections] = useState(kakouSampleSectionDefs);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [collapsedSections, setCollapsedSections] = useState({});
    const [update, setUpdata] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const [kakouType, setKakouType] = useState("type1");
    const [kakouShijiKubun, setKakouShijiKubun] = useState("normal");
    // 副資材(113-117)のアイテム/グループ選択。
    const [selectedSetItem, setSelectedSetItem] = useState("");
    const [selectedGroup, setSelectedGroup] = useState("");
    // 品質表示(118-124)は副資材(113-117)とは分離したアイテム/グループ選択で制御する。
    const [selectedQualityItem, setSelectedQualityItem] = useState("");
    const [selectedQualityGroup, setSelectedQualityGroup] = useState("");
    // 品質表示専用のグループ候補("item|group"キー)。detail行がまだ無い追加直後のグループを保持する。
    const [qualityGroupOptions, setQualityGroupOptions] = useState([]);
    // 品質表示スコープで追加(または初期seed)したアイテム([{code, name}])。
    // グループ(qualityGroupOptions)と同様にUI状態で、品質行が作られるまでDBへは保存されない。
    const [qualityItemOptions, setQualityItemOptions] = useState([]);
    const qualityItemOptionsRef = useRef([]);
    // 副資材スコープで追加(または初期seed)したアイテム([{code, name}])。D_SSDZ行が作られるまでUI状態のみ。
    const [fukushizaiItemAddedOptions, setFukushizaiItemAddedOptions] = useState([]);
    const fukushizaiItemAddedOptionsRef = useRef([]);
    // アイテム追加/削除ダイアログ(副資材・品質表示共用。domainで対象スコープを持つ)。
    const [itemTabDialogState, setItemTabDialogState] = useState({ open: false, domain: "", mode: "", itemCd: "", options: [], loading: false });
    // アイテム名称マスタ(m_code:0138)のセッションキャッシュ。ロード時は__itemNameMasterOptionsで充填される。
    const itemNameMasterListRef = useRef(null);
    const [copyItem, setCopyItem] = useState("");
    const [copyGroup, setCopyGroup] = useState("");
    // 品質表示(118-124)スコープの複写元選択。副資材の複写元(copyItem/copyGroup)とは独立して保持する。
    const [qualityCopyItem, setQualityCopyItem] = useState("");
    const [qualityCopyGroup, setQualityCopyGroup] = useState("");
    const [sectionBulkInputMap, setSectionBulkInputMap] = useState({
        "107": { lossRate: "" },
        "110": { lossRate: "", shikyuKbn: "" },
        "112": { lossRate: "", shikyuKbn: "" }
    });
    // 支給区分一括設定の選択候補をセクション単位で保持する。
    const [bulkShikyuKbnOptions, setBulkShikyuKbnOptions] = useState({});
    const bulkShikyuKbnRequestKeyRef = useRef({});
    const [genkaPatternNo, setGenkaPatternNo] = useState(0);
    const [genkaPattern, setGenkaPattern] = useState("");
    const [genkaGridRefreshToken, setGenkaGridRefreshToken] = useState(0);
    const [genkaCurrency, setGenkaCurrency] = useState("");
    const [genkaCurrencyNo, setGenkaCurrencyNo] = useState("0");
    const [uiActionBusy, setUiActionBusy] = useState(false);
    const [sangenDialogState, setSangenDialogState] = useState({ open: false, loading: false, header: {}, sizes: [], rows: [] });
    const sangenDisplayRequestNoRef = useRef(0);
    const [groupDialogState, setGroupDialogState] = useState({
        open: false,
        mode: "",
        sectionId: "",
        title: "",
        message: "",
        itemCd: "",
        groupNo: "",
        sourceItem: "",
        sourceGroup: "",
        colorOptions: []
    });
    const [pendingFukushizaiCopy, setPendingFukushizaiCopy] = useState(null);
    const [colorwayMatrixMap, setColorwayMatrixMap] = useState({
        sozai_haisyoku: { size: [], rows: [], loading: false },
        fuzoku_haisyoku: { size: [], rows: [], loading: false }
    });
    const copyContextTouchedRef = useRef(false);
    // 品質表示スコープの複写元をユーザーが手動変更したかどうか(自動seedの抑止用)。
    const qualityCopyContextTouchedRef = useRef(false);
    const fukushizaiGroupClearedByUserRef = useRef(false);
    const isFukushizaiCopyPreviewing = pendingFukushizaiCopy !== null;
    const gridlist = useSelector(state => state.form.gridlist);

    const [orderHistoryData, setOrderHistoryData] = useState(emptyOrderHistoryData);
    const [selectedOrderHistoryDenpyoMap, setSelectedOrderHistoryDenpyoMap] = useState({
        seihin: "",
        sozai_meisai: "",
        fuzoku_meisai: "",
        fukushizai: ""
    });
    const [setItemOptions, setSetItemOptions] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);
    const [groupRows, setGroupRows] = useState([]);
    const [fukushizaiItemMasterOptions, setFukushizaiItemMasterOptions] = useState([]);
    const [fukushizaiColorMasterOptions, setFukushizaiColorMasterOptions] = useState([]);
    const [genkaPatternOptions, setGenkaPatternOptions] = useState([]);
    const [genkaCurrencyOptions, setGenkaCurrencyOptions] = useState([]);
    const [sustainableServerImageUrl, setSustainableServerImageUrl] = useState("");
    const [sustainableImageFileEditing, setSustainableImageFileEditing] = useState(false);
    const [sustainableImageFileInputValue, setSustainableImageFileInputValue] = useState("");
    const [pendingOrderLaunches, setPendingOrderLaunches] = useState([]);
    const kakouShijiKubunColumnRef = useRef("");
    const [selectedFukushizaiContext, setSelectedFukushizaiContext] = useState(createEmptyFukushizaiContext());
    const selectedFukushizaiContextRef = useRef(createEmptyFukushizaiContext());
    // 品質表示専用のコンテキスト(副資材とは独立)。
    const [selectedQualityContext, setSelectedQualityContext] = useState(createEmptyFukushizaiContext());
    const selectedQualityContextRef = useRef(createEmptyFukushizaiContext());
    // 表示グリッド(114-117/119-123)のdataRefを最後に構築したcontextの記録。
    // renderKeyに含めることで、アイテム/グループ切替時にグリッドを再生成させる。
    const fukushizaiGridRenderContextKeyRef = useRef({});
    const prevEntryLockRef = useRef(entrylock);
    const prevUiActionBusyRef = useRef(uiActionBusy);
    const lastEntryFinishLoadingAtRef = useRef(0);
    const entryVisualTraceWatchKeys = [
        "SSD_NO",
        "SSD_SIIRECD",
        "SSD_KAKOUSAKICD",
        "SSD_KAKOUSAKISUBCD",
        "SSD_SIJIYMD",
        "SSD_HATSUKEITAI"
    ];

    function activateEntryVisualTraceWindow(durationMs = 5000) {
        const until = loadTimingNow() + Number(durationMs || 0);
        if (until > entryVisualTraceActiveUntilRef.current) {
            entryVisualTraceActiveUntilRef.current = until;
        }
    }
    function shouldLogEntryVisualTrace() {
        return entryLoadingRef.current
            || !isEmpty(entryLoadTimingRef.current)
            || loadTimingNow() <= entryVisualTraceActiveUntilRef.current;
    }
    function elapsedFromFinishEntryLoadingMs() {
        if (lastEntryFinishLoadingAtRef.current <= 0) return -1;
        return Math.round(loadTimingNow() - lastEntryFinishLoadingAtRef.current);
    }
    function shouldLogInteractionDiagnostics() {
        return shouldLogEntryVisualTrace()
            || waitOpen
            || uiActionBusy
            || entrylock
            || (lastEntryFinishLoadingAtRef.current > 0 && elapsedFromFinishEntryLoadingMs() <= 5000);
    }
    function clearDeferredEntryVisualTraceTimers() {
        deferredEntryVisualTraceTimersRef.current.forEach((timerId) => clearTimeout(timerId));
        deferredEntryVisualTraceTimersRef.current = [];
        entryVisualTraceSeqRef.current += 1;
    }
    function clearPendingGenkaEditableRefreshTimer() {
        if (isEmpty(pendingGenkaEditableRefreshTimerRef.current)) return;
        clearTimeout(pendingGenkaEditableRefreshTimerRef.current);
        pendingGenkaEditableRefreshTimerRef.current = null;
    }
    function resetPendingGenkaEditableRefresh() {
        clearPendingGenkaEditableRefreshTimer();
        pendingGenkaEditableRefreshRef.current = { requested: false, reason: "", retries: 0 };
    }
    function clearDeferredColorwayLoadTimer() {
        if (isEmpty(deferredColorwayLoadTimerRef.current)) return;
        clearTimeout(deferredColorwayLoadTimerRef.current);
        deferredColorwayLoadTimerRef.current = null;
    }
    function normalizeColorwayMatrixSectionForCompare(section) {
        const size = Array.isArray(DicVal(section, "size", null))
            ? section.size.map((row) => ({
                sizeCd: String(DicVal(row, "sizeCd", "")),
                sizeNm: String(DicVal(row, "sizeNm", "")),
                sizeSort: String(DicVal(row, "sizeSort", "")),
                field: String(DicVal(row, "field", ""))
            }))
            : [];
        const rows = Array.isArray(DicVal(section, "rows", null))
            ? section.rows.map((row) => JSON.stringify(row ?? {}))
            : [];
        return { size, rows };
    }
    function isSameColorwayMatrixSection(current, next) {
        const left = normalizeColorwayMatrixSectionForCompare(current);
        const right = normalizeColorwayMatrixSectionForCompare(next);
        return JSON.stringify(left) === JSON.stringify(right);
    }
    function setColorwayMatrixSectionIfChanged(sectionId, nextSection) {
        setColorwayMatrixMap((prev) => {
            const currentSection = DicVal(prev, sectionId, { size: [], rows: [], loading: false });
            if (isSameColorwayMatrixSection(currentSection, nextSection)) return prev;
            return { ...prev, [sectionId]: nextSection };
        });
    }
    function scheduleDeferredColorwayMatricesLoad(code) {
        const targetCode = String(code ?? "").trim();
        if (targetCode === "") return;
        pendingColorwayLoadCodeRef.current = targetCode;
        clearDeferredColorwayLoadTimer();
        logEntryVisualTrace("scheduleDeferredColorwayMatricesLoad", {
            code: targetCode
        }, { forceTrace: true });
        deferredColorwayLoadTimerRef.current = setTimeout(() => {
            deferredColorwayLoadTimerRef.current = null;
            const scheduledCode = String(pendingColorwayLoadCodeRef.current ?? "").trim();
            if (scheduledCode === "") return;
            pendingColorwayLoadCodeRef.current = "";
            logEntryVisualTrace("scheduleDeferredColorwayMatricesLoad:run", {
                code: scheduledCode
            }, { forceTrace: true });
            loadColorwayMatrices(scheduledCode);
        }, 0);
    }
    function countTraceObjectKeys(value) {
        if (isEmpty(value) || typeof value !== "object") return 0;
        return Object.keys(value).length;
    }
    function isTraceFilledValue(value) {
        if (value === null || value === undefined) return false;
        if (typeof value === "string") return value.trim() !== "";
        if (typeof value === "number") return !Number.isNaN(value);
        if (typeof value === "boolean") return true;
        if (typeof value === "object") return Object.keys(value).length !== 0;
        return true;
    }
    function getEntryVisualTraceCode(fallback = "") {
        return String(fallback || edittingcode || DicVal(entryLoadTimingRef.current, "code", "") || "").trim();
    }
    function buildEntryVisualFieldSamples(source) {
        if (isEmpty(source) || typeof source !== "object") return {};
        const out = {};
        const remember = (key) => {
            if (Object.keys(out).length >= 8) return;
            if (isEmpty(key)) return;
            if (Object.prototype.hasOwnProperty.call(out, key)) return;
            const value = DicVal(source, key, undefined);
            if (!isTraceFilledValue(value)) return;
            if (typeof value === "object") return;
            out[key] = String(value);
        };
        const preferredKeys = [
            ...primarykeys,
            "SSD_NO",
            "SSDM_NO",
            "SSD_SIIRECD",
            "SSD_KAKOUSAKICD",
            "SSD_KAKOUSAKISUBCD",
            "SSDS_SIIRECD",
            "SSDF_KAKOUSAKICD",
            "SSDZ_ITMCITEMCD",
            "SSDZ_FUKUSIZAICOLORGRP",
            "SSDZ_COLORCD"
        ];
        preferredKeys.forEach((key) => remember(key));
        if (Object.keys(out).length >= 8) return out;
        Object.keys(source).forEach((key) => {
            const upper = String(key ?? "").trim().toUpperCase();
            if (upper === "" || upper.startsWith("__")) return;
            remember(key);
        });
        return out;
    }
    function buildEntryVisualWatchSamples(source) {
        if (isEmpty(source) || typeof source !== "object") return {};
        const out = {};
        entryVisualTraceWatchKeys.forEach((key) => {
            const value = DicVal(source, key, undefined);
            if (!isTraceFilledValue(value) || typeof value === "object") return;
            out[key] = String(value);
        });
        return out;
    }
    function logEntryVisualTrace(stage, extra = {}, options = {}) {
        // 性能調査用トレース。ロード中(またはforceTrace指定時)のみ出力する。
        const force = !isEmpty(options) && options.forceTrace === true;
        if (!force && !shouldLogEntryVisualTrace()) return;
        const requestStartAt = Number(DicVal(entryLoadTimingRef.current, "requestStartAt", 0));
        const sinceLoadMs = requestStartAt > 0 ? Math.round(loadTimingNow() - requestStartAt) : -1;
        try {
            console.info(`[Kakousiji][trace] ${stage}`, { sinceLoadMs, ...extra });
        } catch { /* トレース失敗で業務処理を止めない */ }
    }
    function logInteractionDiagnostics(stage, extra = {}) {
        if (!shouldLogInteractionDiagnostics()) return;
        try {
            console.info(`[Kakousiji][interaction] ${stage}`, extra);
        } catch { /* トレース失敗で業務処理を止めない */ }
    }
    function schedulePostFinishEntryVisualTrace(code = "") {
        activateEntryVisualTraceWindow(3000);
        clearDeferredEntryVisualTraceTimers();
        const seq = entryVisualTraceSeqRef.current;
        [0, 300, 1000, 2000].forEach((delay) => {
            const timerId = setTimeout(() => {
                if (seq !== entryVisualTraceSeqRef.current) return;
                logEntryVisualTrace(`postFinish+${delay}ms`, { code, delayMs: delay });
            }, delay);
            deferredEntryVisualTraceTimersRef.current.push(timerId);
        });
    }
    function schedulePostFinishInteractionDiagnostics(code = "") {
        activateEntryVisualTraceWindow(5000);
        const seq = entryVisualTraceSeqRef.current;
        const timeoutStartedAt = loadTimingNow();
        const timeoutId = setTimeout(() => {
            if (seq !== entryVisualTraceSeqRef.current) return;
            logInteractionDiagnostics("postFinishLoop:setTimeout0", {
                code,
                loopDelayMs: Math.round(loadTimingNow() - timeoutStartedAt)
            });
        }, 0);
        deferredEntryVisualTraceTimersRef.current.push(timeoutId);
        if (typeof requestAnimationFrame === "function") {
            const raf1StartedAt = loadTimingNow();
            requestAnimationFrame(() => {
                if (seq !== entryVisualTraceSeqRef.current) return;
                logInteractionDiagnostics("postFinishLoop:raf1", {
                    code,
                    loopDelayMs: Math.round(loadTimingNow() - raf1StartedAt)
                });
                const raf2StartedAt = loadTimingNow();
                requestAnimationFrame(() => {
                    if (seq !== entryVisualTraceSeqRef.current) return;
                    logInteractionDiagnostics("postFinishLoop:raf2", {
                        code,
                        loopDelayMs: Math.round(loadTimingNow() - raf2StartedAt)
                    });
                });
            });
        }
    }
    function describeInteractionTarget(target) {
        if (isEmpty(target)) return {};
        let pointerEvents = "";
        try {
            if (typeof window !== "undefined" && typeof window.getComputedStyle === "function") {
                pointerEvents = String(window.getComputedStyle(target).pointerEvents ?? "");
            }
        } catch { }
        let disabledAncestor = null;
        try {
            if (typeof target.closest === "function") {
                disabledAncestor = target.closest("[disabled], [aria-disabled='true']");
            }
        } catch { }
        const text = String(target.innerText || target.textContent || "").trim().replace(/\s+/g, " ").slice(0, 40);
        return {
            tagName: String(target.tagName ?? "").toLowerCase(),
            id: String(target.id ?? ""),
            name: String(target.name ?? ""),
            type: String(target.type ?? ""),
            className: typeof target.className === "string" ? target.className : "",
            disabled: !!target.disabled,
            ariaDisabled: typeof target.getAttribute === "function" ? String(target.getAttribute("aria-disabled") ?? "") : "",
            pointerEvents,
            disabledAncestorTag: isEmpty(disabledAncestor) ? "" : String(disabledAncestor.tagName ?? "").toLowerCase(),
            text
        };
    }
    function handleEntryInteractionCapture(name, event) {
        if (!shouldLogInteractionDiagnostics()) return;
        logInteractionDiagnostics(`interaction:${name}`, {
            eventType: String(event?.type ?? ""),
            key: name === "keyDown" ? String(event?.key ?? "") : "",
            isTrusted: event?.isTrusted === true,
            target: describeInteractionTarget(event?.target)
        });
    }
    function dispatchEntryDataWithTrace(nextEntryData, reason = "") {
        const payloadData = isEmpty(nextEntryData) || typeof nextEntryData !== "object"
            ? {}
            : nextEntryData;
        logEntryVisualTrace("dispatchEntrydata:before", {
            reason,
            nextReduxEntrydataKeyCount: countTraceObjectKeys(payloadData),
            nextReduxEntrydataSample: buildEntryVisualFieldSamples(payloadData),
            nextReduxEntrydataWatchedFields: buildEntryVisualWatchSamples(payloadData)
        });
        dispatch(entrydata(payloadData));
    }
    function dispatchEntryRerenderWithTrace(reason = "") {
        logEntryVisualTrace("dispatchEntryrerender", { reason });
        dispatch(entryrerender());
    }



    // typeキーを受注/納品の判定用に正規化する。
    function normalizeTypeKey(key) {
        return columnIdUtil.normalizeTypeKey(key);
    }
    // panel.type を保存・表示で扱う代表値へ正規化する。
    function canonicalPanelType(type) {
        return columnIdUtil.canonicalPanelType(type);
    }
    // パネル情報から受注/納品の代表type（130/131）を解決する。
    function demandTypeKeyByPanel(panelInfo) {
        return columnIdUtil.demandTypeKeyByPanel(panelInfo);
    }
    // 受注/納品の対象パネルか判定する。
    function isDemandPanelInfo(panelInfo) {
        return demandTypeKeyByPanel(panelInfo) !== "";
    }
    function normalizeLayoutMeta(items) {
        if (!Array.isArray(items)) return [];
        const out = [];
        const seen = new Set();
        const boolFieldDefaults = {
            locked: false,
            primary: false,
            primarykey: false,
            unchange: false,
            required: false,
            copyclear: false,
            saveed: true,
            multiple: false
        };
        const pushUnique = (obj) => {
            if (isEmpty(obj) || typeof obj !== "object") return;
            const key = [
                String(obj.type ?? ""),
                String(obj.logpid ?? ""),
                String(obj.table ?? ""),
                String(obj.columnid ?? ""),
                String(obj.columnnm ?? "")
            ].join("|");
            if (seen.has(key)) return;
            seen.add(key);
            out.push(obj);
        };
        items.forEach((item) => {
            if (isEmpty(item) || typeof item !== "object") return item;
            const next = { ...item };
            if ("type" in next) next.type = canonicalPanelType(next.type);
            if ("logpid" in next) next.logpid = String(next.logpid ?? "");
            // EntryGridAr 側の型判定は文字列比較のため、datatype はここで文字列化しておく。
            if ("datatype" in next) next.datatype = String(next.datatype ?? "");
            if ("decimalplace" in next) {
                const dp = Number(next.decimalplace ?? 0);
                next.decimalplace = Number.isFinite(dp) ? dp : 0;
            }
            Object.keys(boolFieldDefaults).forEach((field) => {
                if (!(field in next)) return;
                next[field] = parseBoolLike(next[field], boolFieldDefaults[field]);
            });
            pushUnique(next);
        });
        return out;
    }
    // BASE項目は「表示順/表示有無」はcolumns、「編集可否/型」はcolinfoを優先して合成する。
    // Entry Form のベース項目を組み立てます。
    // type=0 は VIEW 用のため除外し、type>=100 だけを表示対象にします。
    function buildBaseTextFields(layoutColumns, allColInfo) {
        return buildEntryBaseFields(layoutColumns, allColInfo, {
            baseLogpid: G_id.BASE,
            fukushizaiBasePanelType: FUKUSHIZAI_BASE_PANEL_TYPE,
            traceabilityPanelType: PANEL_TYPE.TRACEABILITY,
            sustainableReserveFields: SUSTAINABLE_RESERVE_FIELDS,
            isFukushizaiContextField,
            applyDesignReadonlyToField,
            isEmpty,
            DicVal,
            cellTypeCheck: CELLTYPE.CHECK
        });
    }
    // 解決済みの通常セクションを返します。
    function currentNormalSectionDefs() {
        return Array.isArray(resolvedSections) && resolvedSections.length !== 0 ? resolvedSections : kakouSectionDefs;
    }
    // 解決済みのサンプルセクションを返します。
    function currentSampleSectionDefs() {
        return Array.isArray(resolvedSampleSections) && resolvedSampleSections.length !== 0 ? resolvedSampleSections : kakouSampleSectionDefs;
    }
    // セクション検索で使う全定義を返します。
    function allCurrentSectionDefs() {
        return [...currentNormalSectionDefs(), ...currentSampleSectionDefs()];
    }
    // 固定縦持ち表示パネルの入力枠数（=保存先列数）を行数上限とする。
    // 小物札(114)は投影行数が可変のため上限はセーフティ用。手動追加禁止は rowContext 側で制御する。
    const FIXED_VERTICAL_PANEL_MAXROW = {
        [PANEL_TYPE.BRAND_NAME]: 3,    // SSDZ_BRANDNAMECD1..3
        [PANEL_TYPE.OTHER_NAME]: 6,    // SSDZ_SONOTANAMECD1..6
        [PANEL_TYPE.OTHER_FUKUZAI]: 5, // SSDZ_SONOTAFUZOKUCD1..5
        [PANEL_TYPE.KOMONOFUDA]: 6     // SSDZ_KOMONOSIZERITU1..6
    };
    function normalizePanelMeta(items) {
        if (!Array.isArray(items)) return [];
        return items.map((item) => {
            if (isEmpty(item) || typeof item !== "object") return item;
            const next = { ...item };
            if ("id" in next) next.id = String(next.id ?? "");
            if ("type" in next) next.type = canonicalPanelType(next.type);
            if ("totaltype" in next) next.totaltype = String(next.totaltype ?? "");
            if ("logpid" in next) next.logpid = String(next.logpid ?? "");
            // 固定縦持ちパネルは入力枠数を行数上限にする（上限超の行追加を禁止）。
            // 既にバックエンド由来の maxrow があれば尊重する。
            const fixedMax = FIXED_VERTICAL_PANEL_MAXROW[next.type];
            if (fixedMax && !(Number(next.maxrow) > 0)) {
                next.maxrow = fixedMax;
            }
            return next;
        });
    }
    // searchparam は C# の Dictionary<string,string> に合わせて object へ正規化する。
    function normalizeSearchParamObject(value) {
        if (isEmpty(value)) return {};
        if (Array.isArray(value)) return {};
        if (typeof value === "object") return value;
        const text = String(value ?? "").trim();
        if (text === "") return {};
        const requirementPrefix = "requirement:";
        if (text.toLowerCase().startsWith(requirementPrefix)) {
            return { requirement: text.substring(requirementPrefix.length) };
        }
        return {};
    }
    function normalizeLabelKey(label) {
        return columnIdUtil.normalizeLabelKey(label);
    }
    function normalizeColumnIdUpper(columnid) {
        return columnIdUtil.normalizeColumnIdUpper(columnid);
    }
    function normalizeDesignReadonlyType(type) {
        return normalizeTypeKey(canonicalPanelType(type));
    }
    function designReadonlyColumnIds(type) {
        const typeKey = normalizeDesignReadonlyType(type);
        if (typeKey === "") return null;
        return DESIGN_READONLY_FIELD_IDS_BY_TYPE[typeKey] ?? null;
    }
    function isDesignReadonlyField(type, columnId) {
        const ids = designReadonlyColumnIds(type);
        if (!(ids instanceof Set)) return false;
        const cid = normalizeColumnIdUpper(columnId);
        return cid !== "" && ids.has(cid);
    }
    function isDesignReadonlyColumnMeta(meta, typeCandidates = []) {
        if (isEmpty(meta)) return false;
        const cid = normalizeColumnIdUpper(
            DicVal(meta, "columnid", DicVal(meta, "colId", DicVal(meta, "field", "")))
        );
        if (cid === "") return false;
        const candidates = [
            ...toArray(typeCandidates),
            DicVal(meta, "type", ""),
            DicVal(DicVal(meta, "colinfo", {}), "type", "")
        ];
        return candidates.some(type => isDesignReadonlyField(type, cid));
    }
    function applyDesignReadonlyToField(field) {
        if (!isDesignReadonlyColumnMeta(field)) return field;
        return {
            ...field,
            locked: true,
            unchange: true,
            saveed: parseBoolLike(DicVal(field, "saveed", true), true)
        };
    }
    function applyDesignReadonlyToColDef(col, typeCandidates = []) {
        if (isEmpty(col) || typeof col !== "object") return col;
        if (Array.isArray(col.children) && col.children.length !== 0) {
            return {
                ...col,
                children: col.children.map(child => applyDesignReadonlyToColDef(child, typeCandidates))
            };
        }
        const cinfo = DicVal(col, "colinfo", {});
        const cid = normalizeColumnIdUpper(
            DicVal(col, "colId", DicVal(col, "field", DicVal(cinfo, "columnid", "")))
        );
        const candidates = [
            ...toArray(typeCandidates),
            DicVal(col, "type", ""),
            DicVal(cinfo, "type", "")
        ];
        const shouldLock = cid !== "" && candidates.some(type => isDesignReadonlyField(type, cid));
        if (!shouldLock) return col;
        const nextColInfo = isEmpty(cinfo)
            ? cinfo
            : {
                ...cinfo,
                locked: true,
                unchange: true,
                saveed: parseBoolLike(DicVal(cinfo, "saveed", true), true)
            };
        return {
            ...col,
            editable: false,
            suppressClickEdit: true,
            locked: true,
            unchange: true,
            saveed: parseBoolLike(DicVal(col, "saveed", true), true),
            colinfo: nextColInfo
        };
    }
    function applyDesignReadonlyToColDefs(colDefs, typeCandidates = []) {
        if (!Array.isArray(colDefs)) return colDefs;
        return colDefs.map(col => applyDesignReadonlyToColDef(col, typeCandidates));
    }
    function normalizeColumnIdSuffix(columnid) {
        return columnIdUtil.normalizeColumnIdSuffix(columnid);
    }
    // 画面操作用の値を安全な文字列へ寄せる。
    function normalizeKakousijiUiString(value) {
        return String(value ?? "").trim();
    }
    function buildOrderHistoryOptionRows(history) {
        return (Array.isArray(history) ? history : [])
            .map((row, index) => {
                const date = normalizeKakousijiUiString(DicVal(row, "date", ""));
                const denpyoNo = normalizeKakousijiUiString(DicVal(row, "denpyoNo", ""));
                const value = denpyoNo !== "" ? denpyoNo : `${date}|${index}`;
                const label = denpyoNo === "" ? date : `${date} [${denpyoNo}]`;
                return { value, label, date, denpyoNo, row };
            })
            .filter((item) => item.date !== "" || item.denpyoNo !== "");
    }
    // 真偽値相当（0/1,true/false,yes/no）をboolへ正規化する。
    function parseBoolLike(value, defaultVal = false) {
        if (value === undefined || value === null) return defaultVal;
        if (typeof value === "boolean") return value;
        if (typeof value === "number") return value !== 0;
        const s = String(value).trim().toLowerCase();
        if (s === "") return defaultVal;
        if (s === "1" || s === "true" || s === "yes" || s === "y" || s === "on") return true;
        if (s === "0" || s === "false" || s === "no" || s === "n" || s === "off") return false;
        return defaultVal;
    }
    function readRowValueIgnoreCase(row, columnId) {
        if (isEmpty(row) || isEmpty(columnId)) return undefined;
        const target = String(columnId ?? "").trim().toUpperCase();
        const key = Object.keys(row).find(k => String(k ?? "").trim().toUpperCase() === target);
        return isEmpty(key) ? undefined : row[key];
    }

    // gridパネルの定義から section id を解決する（type優先）。
    function resolveSectionIdByGridPanel(gridPanel) {
        if (isEmpty(gridPanel)) return "";
        const allSections = allCurrentSectionDefs();
        const panelId = String(gridPanel.id ?? "");
        const panelType = String(gridPanel.type ?? "");
        const typeKey = normalizeTypeKey(panelType);
        const foundByType = allSections.find(s =>
            s.component === "grid" &&
            typeKey !== "" &&
            normalizeTypeKey(String(s.panelType ?? "")) === typeKey
        );
        if (!isEmpty(foundByType)) return String(foundByType.id ?? "");
        const foundById = allSections.find(s => s.component === "grid" && String(s.panelId ?? "") === panelId);
        if (!isEmpty(foundById)) return String(foundById.id ?? "");
        return "";
    }
    function mergeDetailRowIntoEntry(entryObj, detailData, panelType) {
        if (isEmpty(entryObj) || isEmpty(detailData)) return false;
        const row = getFirstDetailRowByPanelType(detailData, panelType);
        if (isEmpty(row)) return false;
        Object.keys(row).forEach((key) => {
            const value = row[key];
            if (value === null || value === undefined) return;
            if (String(key ?? "").trim() === "") return;
            entryObj[key] = value;
        });
        return true;
    }
    function mergeSampleDetailRowsToEntry(entryObj, detailData) {
        if (isEmpty(entryObj) || isEmpty(detailData)) return false;
        let changed = false;
        changed = mergeDetailRowIntoEntry(entryObj, detailData, PANEL_TYPE.SAMPLE_INFO) || changed;
        changed = mergeDetailRowIntoEntry(entryObj, detailData, PANEL_TYPE.SAMPLE_COMMENT) || changed;
        changed = mergeDetailRowIntoEntry(entryObj, detailData, PANEL_TYPE.SAMPLE_COMMON_COMMENT) || changed;
        return changed;
    }
    const dispatch = useDispatch();
    const CELLTYPE = CellType();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const sectionRefs = useRef({});
    const GridPanelRef = useRef(null);

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);
    const masterNameHydrationPendingRef = useRef({});
    const fukushizaiGroupRowsRef = useRef([]);
    const pendingGridApplyRef = useRef({});
    const pendingGridRerenderIdsRef = useRef({});
    const pendingGridRerenderTimerRef = useRef(null);
    const pendingVisibleGridRefreshRef = useRef("");
    const pendingGenkaEditableRefreshRef = useRef({ requested: false, reason: "", retries: 0 });
    const pendingGenkaEditableRefreshTimerRef = useRef(null);
    const finishEntryLoadingTimerRef = useRef(null);
    const genkaPostLoadRefreshSkipRef = useRef(false);
    const deferredColorwayLoadTimerRef = useRef(null);
    const pendingColorwayLoadCodeRef = useRef("");
    const genkaTouchedRef = useRef({ cells: {}, summary: {} });
    const totalgriddataRefs = useRef({});
    const totalgridcolRefs = useRef({});
    const totalgridapiRefs = useRef({});
    const suppressTotalValueChangedRef = useRef(false);

    //データ
    const entrydataRef = useRef(null);
    const entrydetailRef = useRef(null);
    const loadedEntryDetailRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル
    // 金額の端数処理設定。GetEntryData のレスポンス(amountrounding)を保持する。
    // 円建てはS_ENV/M_ICPC、外貨は名称マスタ(m_code 6480)由来でサーバが解決済み。
    const amountRoundingRef = useRef(null);

    // =====================================================================
    // 保存payload補助
    // ---------------------------------------------------------------------
    // 表示用項目を除外し、画面typeを保存先typeへ集約する。
    // =====================================================================

    // 基本情報のUI専用疑似列（保存不要）を列定義から収集する。
    function getBaseUiOnlyColumnIds() {
        const ids = new Set((BASE_UI_ONLY_COL_IDS || []).map(v => normalizeColumnIdUpper(v)).filter(v => v !== ""));
        if (!Array.isArray(columninfo)) return [...ids];
        columninfo.forEach((c) => {
            const cid = normalizeColumnIdUpper(DicVal(c, "columnid", ""));
            if (cid === "") return;
            const table = String(DicVal(c, "table", "") ?? "").trim();
            const logpid = String(DicVal(c, "logpid", "") ?? "").trim();
            const saveed = parseBoolLike(DicVal(c, "saveed", true), true);
            if ((table === "-" && logpid === "0") || !saveed) {
                ids.add(cid);
            }
        });
        return [...ids];
    }
    function resolveDetailSaveTargetType(panelType) {
        const typeKey = canonicalPanelType(panelType);
        if (typeKey === "") return "";
        return String(DicVal(DETAIL_SAVE_TARGET_TYPE_MAP, typeKey, typeKey) ?? "");
    }
    function isSustainableSaveSourcePanelType(panelType) {
        return SUSTAINABLE_SAVE_SOURCE_PANEL_TYPES.includes(canonicalPanelType(panelType));
    }
    function matchesBaseDetailSavePanelType(sourceType, targetType) {
        const source = canonicalPanelType(sourceType);
        const target = canonicalPanelType(targetType);
        if (target === PANEL_TYPE.SUSTAINABLE_MARK) return isSustainableSaveSourcePanelType(source);
        return source === target;
    }
    function ensureSustainableDetailSaveKeys(row) {
        if (isEmpty(row) || typeof row !== "object") return row;
        const currentNo = normalizeKakousijiUiString(readRowValueIgnoreCase(row, "SSDSAS_NO"));
        if (currentNo === "") {
            const no = normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "SSDSAS_NO"))
                || normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "SSD_NO"))
                || normalizeKakousijiUiString(edittingcode);
            if (no !== "") row.SSDSAS_NO = no;
        }
        return row;
    }
    function hasSustainableDetailSaveFields(row) {
        if (isEmpty(row) || typeof row !== "object") return false;
        return [SUSTAINABLE_IMAGE_FILE_FIELD, ...SUSTAINABLE_RESERVE_FIELDS].some((fieldId) =>
            Object.prototype.hasOwnProperty.call(row, fieldId)
        );
    }
    function getGroupedBaseDetailColumnIds() {
        const ids = new Set();
        if (!Array.isArray(columninfo)) return [...ids];
        columninfo.forEach((c) => {
            const typeKey = canonicalPanelType(DicVal(c, "type", ""));
            const logpid = String(DicVal(c, "logpid", "") ?? "").trim();
            const cid = normalizeColumnIdUpper(DicVal(c, "columnid", ""));
            const table = String(DicVal(c, "table", "") ?? "").trim();
            const saveed = parseBoolLike(DicVal(c, "saveed", true), true);
            if (typeKey === "" || logpid !== G_id.BASE || cid === "" || table === "-" || !saveed) return;
            if (!GROUPED_DETAIL_TARGET_TYPES.includes(resolveDetailSaveTargetType(typeKey))) return;
            ids.add(cid);
        });
        return [...ids];
    }
    function buildBaseDetailSaveRows(panelType) {
        const typeKey = canonicalPanelType(panelType);
        if (typeKey === "" || !Array.isArray(columninfo) || isEmpty(entrydataRef.current)) return [];
        const row = { rowid: "0" };
        columninfo.forEach((c) => {
            if (!matchesBaseDetailSavePanelType(DicVal(c, "type", ""), typeKey)) return;
            if (String(DicVal(c, "logpid", "") ?? "").trim() !== G_id.BASE) return;
            const cid = String(DicVal(c, "columnid", "") ?? "").trim();
            const table = String(DicVal(c, "table", "") ?? "").trim();
            const saveed = parseBoolLike(DicVal(c, "saveed", true), true);
            if (cid === "" || table === "-" || !saveed || isKakousijiSavePayloadUiOnlyField(cid, typeKey)) return;
            const value = readRowValueIgnoreCase(entrydataRef.current, cid);
            if (value !== undefined) row[cid] = value;
        });
        if (typeKey === PANEL_TYPE.SUSTAINABLE_MARK) {
            if (!hasSustainableDetailSaveFields(row)) return [];
            ensureSustainableDetailSaveKeys(row);
        }
        return stripKakousijiDetailSaveRows([row], typeKey);
    }
    // 商品情報(101)のD_SSDX項目(仕入先公開/ささげ連携等)の保存行を単票編集値から作る。
    // 101はDETAIL_SAVE_TARGET_TYPE_MAPへ加えない(加えるとgetGroupedBaseDetailColumnIdsが
    // 101のD_SSD項目をヘッダ保存dataから除外してしまうため)。ロード時snapshotの101行は
    // 読込時の値のままなので、この行を後勝ちで追加してサーバの101マージ(D_SSDX)で反映させる。
    function buildProductInfoSsdxSaveRows() {
        if (!Array.isArray(columninfo) || isEmpty(entrydataRef.current)) return [];
        const row = { rowid: "0" };
        let hasValue = false;
        columninfo.forEach((c) => {
            if (canonicalPanelType(DicVal(c, "type", "")) !== PANEL_TYPE.PRODUCT_INFO) return;
            if (String(DicVal(c, "logpid", "") ?? "").trim() !== G_id.BASE) return;
            if (String(DicVal(c, "table", "") ?? "").trim().toUpperCase() !== "D_SSDX") return;
            if (!parseBoolLike(DicVal(c, "saveed", true), true)) return;
            const cid = String(DicVal(c, "columnid", "") ?? "").trim();
            if (cid === "" || isKakousijiSavePayloadUiOnlyField(cid, PANEL_TYPE.PRODUCT_INFO)) return;
            const value = readRowValueIgnoreCase(entrydataRef.current, cid);
            if (value === undefined) return;
            row[cid] = value;
            hasValue = true;
        });
        return hasValue ? [row] : [];
    }
    // 素材(106)/附属(109)の単票項目(注意フラグ/注意内容)は物理テーブルが明細(107/110)と同じ
    // D_SSDS/D_SSDF で、s_tbl に 106/109 の子定義が無く detail["106"]/["109"] はサーバで破棄される。
    // 単票の編集値を明細行へ書き込んで保存する(全明細行が同じ値を共有する)。
    function applyBaseSectionFieldsToDetailRows(detailObj, baseType, detailType, tableName) {
        const rows = DicVal(detailObj, canonicalPanelType(detailType), null);
        if (!Array.isArray(rows) || rows.length === 0) return;
        const fieldIds = collectBaseSectionDetailFieldIds(baseType, tableName);
        if (fieldIds.length === 0 || isEmpty(entrydataRef.current)) return;
        rows.forEach((row) => {
            if (isEmpty(row) || typeof row !== "object") return;
            fieldIds.forEach((cid) => {
                const value = readRowValueIgnoreCase(entrydataRef.current, cid);
                if (value === undefined) return;
                row[cid] = value;
            });
        });
    }
    // baseType(106/109)の単票項目のうち、指定物理テーブルに属する保存対象列IDを返す。
    function collectBaseSectionDetailFieldIds(baseType, tableName) {
        if (!Array.isArray(columninfo)) return [];
        const targetTable = String(tableName ?? "").trim().toUpperCase();
        return columninfo
            .filter((c) => canonicalPanelType(DicVal(c, "type", "")) === canonicalPanelType(baseType))
            .filter((c) => String(DicVal(c, "logpid", "") ?? "").trim() === G_id.BASE)
            .filter((c) => String(DicVal(c, "table", "") ?? "").trim().toUpperCase() === targetTable)
            .filter((c) => parseBoolLike(DicVal(c, "saveed", true), true))
            .map((c) => String(DicVal(c, "columnid", "") ?? "").trim())
            .filter((cid) => cid !== "" && !isKakousijiSavePayloadUiOnlyField(cid, baseType));
    }
    // 素材(106)/附属(109)の単票項目を、読込済み明細(107/110)の先頭行から entrydata へ投影する。
    function mergeSozaiFuzokuBaseFieldsToEntry(entryObj, detailData) {
        if (isEmpty(entryObj) || isEmpty(detailData)) return;
        [
            { baseType: PANEL_TYPE.MATERIAL, detailType: PANEL_TYPE.MATERIAL_DETAIL, tableName: "D_SSDS" },
            { baseType: PANEL_TYPE.ACCESSORY, detailType: PANEL_TYPE.ACCESSORY_DETAIL, tableName: "D_SSDF" }
        ].forEach(({ baseType, detailType, tableName }) => {
            const row = getFirstDetailRowByPanelType(detailData, detailType);
            if (isEmpty(row)) return;
            collectBaseSectionDetailFieldIds(baseType, tableName).forEach((cid) => {
                const value = readRowValueIgnoreCase(row, cid);
                if (value === undefined) return;
                entryObj[cid] = value;
            });
        });
    }
    // 摘要(SSDE_TEKIYO)は品質表示(118)の単票項目だが、物理列は洗濯表示(D_SSDE)側にある。
    // 現在の品質アイテム+グループの洗濯明細/洗濯グリッド行へ書き込む。
    //   ・絵表示(SSDE_STPCD)指定の行がある場合: 指定行すべての摘要を更新する
    //   ・絵表示指定が無い場合: 絵表示の指定なしで摘要を保持する行を1行生成する
    // 保存payloadは洗濯グリッドの表示行から生成される(toWashSaveRows)ため、明細と表示行の両方を更新する。
    function syncQualityTekiyoToWashDetail(value) {
        const context = resolveQualityBaseEditContext();
        if (context.itemCd === "" || context.groupNo === "") return false;
        const nextValue = String(value ?? "");
        let detailUpdated = 0;
        let detailCreated = false;
        let gridUpdated = 0;

        // 明細(124)側: コンテキスト一致行を更新
        const detail = ensureDetailRowsByTypeForMutation(PANEL_TYPE.WASH);
        const rows = Array.isArray(detail.rows) ? detail.rows : [];
        const matchedIndexes = [];
        rows.forEach((row, index) => {
            if (isEmpty(row) || typeof row !== "object") return;
            if (!rowMatchesFukushizaiItemGroup(row, context.itemCd, context.groupNo)) return;
            matchedIndexes.push(index);
        });
        const stpIndexes = matchedIndexes.filter((index) =>
            normalizeKakousijiUiString(readRowValueIgnoreCase(rows[index], WASH_STP_CODE_FIELD)) !== "");
        const targetIndexes = stpIndexes.length !== 0 ? stpIndexes : matchedIndexes;
        targetIndexes.forEach((index) => {
            if (rows[index].SSDE_TEKIYO === nextValue) return;
            rows[index] = { ...rows[index], SSDE_TEKIYO: nextValue };
            detailUpdated += 1;
        });
        if (matchedIndexes.length === 0 && nextValue !== "") {
            // 絵表示の指定なしで摘要を保持する行を生成する(表示順=1、絵表示コードなし)。
            const colors = qualityTargetColorsForContext(context);
            const colorCd = colors.length !== 0 ? colors[0] : normalizeColorCd(context.colorCd);
            const created = { [ROW_ID_FIELD]: String(nextDetailRowIdForRows(rows)), SSDE_TEKIYO: nextValue };
            setRowContextForPanel(created, PANEL_TYPE.WASH, context.itemCd, context.groupNo, colorCd);
            rows.push(created);
            detailCreated = true;
        }
        if (detailUpdated !== 0 || detailCreated) entrydetailRef.current[detail.key] = rows;

        // グリッド表示行側: 絵表示指定行があればその全行、無ければ全行(空プレースホルダ含む)へ反映
        const panelInfo = resolveGridPanelByType(PANEL_TYPE.WASH);
        if (!isEmpty(panelInfo)) {
            const gridRows = GridData(panelInfo);
            if (Array.isArray(gridRows) && gridRows.length !== 0) {
                const gridStpIndexes = gridRows
                    .map((row, index) => ({ row, index }))
                    .filter(({ row }) => !isEmpty(row) && normalizeKakousijiUiString(readRowValueIgnoreCase(row, WASH_STP_CODE_FIELD)) !== "")
                    .map(({ index }) => index);
                const gridTargets = gridStpIndexes.length !== 0 ? gridStpIndexes : gridRows.map((_, index) => index);
                const nextRows = gridRows.map((row, index) => {
                    if (isEmpty(row) || typeof row !== "object" || gridTargets.indexOf(index) === -1) return row;
                    if (row.SSDE_TEKIYO === nextValue) return row;
                    const next = { ...row, SSDE_TEKIYO: nextValue };
                    if (nextValue !== "") {
                        // 摘要を持った時点で保存対象の実データ行になるため、空表示プレースホルダの印は外す。
                        delete next.__displayOnly;
                        delete next.__QUALITY_EMPTY_INPUT_ROW;
                    }
                    gridUpdated += 1;
                    return next;
                });
                if (gridUpdated !== 0) SetGridData(panelInfo, nextRows);
            }
        }

        const changed = detailUpdated !== 0 || detailCreated || gridUpdated !== 0;
        if (changed && !isEmpty(fnc.current) && typeof fnc.current.modify === "function") fnc.current.modify(true);
        return changed;
    }
    // 条件仕入チェック(UI専用KIHON2_JOKEN_SHIIRE)と物理列SSD_JYOKENSIIREFLGの同期。
    function isJokenSiireFlagOn(value) {
        const text = String(value ?? "").trim().toLowerCase();
        return text === "1" || text === "true";
    }
    function syncJokenSiireCheckboxFromEntry(entryObj) {
        if (isEmpty(entryObj) || typeof entryObj !== "object") return;
        entryObj.KIHON2_JOKEN_SHIIRE = isJokenSiireFlagOn(readRowValueIgnoreCase(entryObj, "SSD_JYOKENSIIREFLG")) ? "1" : "0";
    }
    function syncJokenSiireFlagFromCheckbox(entryObj) {
        if (isEmpty(entryObj) || typeof entryObj !== "object") return;
        entryObj.SSD_JYOKENSIIREFLG = isJokenSiireFlagOn(readRowValueIgnoreCase(entryObj, "KIHON2_JOKEN_SHIIRE")) ? "1" : "0";
    }
    // 保存payload用のcolinfo補完(既存columninfo stateは変更しない)。
    // 1) 条件仕入フラグ: s_layoutに無いD_SSD物理列のため、ヘッダ保存(SaveHeaderRecord)が
    //    参照するcolinfoへ保存用の列定義を補う。
    // 2) 摘要(SSDE_TEKIYO): s_layout上type118のため洗濯表示(124)のcolinfoに定義が無く、
    //    サーバの空行判定(NothingDataRow)が「摘要のみで絵表示なしの行」を空行として捨てる。
    //    type=124の列定義を複製して補う。
    function buildSaveColinfoWithJokenSiireFlag() {
        if (!Array.isArray(columninfo)) return columninfo;
        const additions = [];
        const baseCol = columninfo.find((c) => normalizeColumnIdUpper(DicVal(c, "columnid", "")) === "SSD_JOKENSIIRENAIYOU");
        if (!isEmpty(baseCol)
            && !columninfo.some((c) => normalizeColumnIdUpper(DicVal(c, "columnid", "")) === "SSD_JYOKENSIIREFLG")) {
            additions.push({
                ...baseCol,
                columnid: "SSD_JYOKENSIIREFLG",
                columnnm: "条件仕入フラグ",
                datatype: "13",
                length: 1,
                decimalplace: 0,
                format: "",
                formula: "",
                sql: "",
                dbcolumn: "",
                dataid: "",
                dataidctrl: "",
                trigger: [],
                required: false,
                primary: false,
                multiple: false,
                locked: true,
                hidden: "1",
                saveed: true
            });
        }
        const tekiyoCol = columninfo.find((c) => normalizeColumnIdUpper(DicVal(c, "columnid", "")) === "SSDE_TEKIYO");
        if (!isEmpty(tekiyoCol)
            && !columninfo.some((c) =>
                normalizeColumnIdUpper(DicVal(c, "columnid", "")) === "SSDE_TEKIYO"
                && canonicalPanelType(DicVal(c, "type", "")) === PANEL_TYPE.WASH)) {
            additions.push({
                ...tekiyoCol,
                type: PANEL_TYPE.WASH,
                formula: "",
                sql: "",
                trigger: [],
                required: false,
                primary: false,
                multiple: false,
                locked: true,
                hidden: "1",
                saveed: true
            });
        }
        if (additions.length === 0) return columninfo;
        return [...columninfo, ...additions];
    }
    // 画面typeを保存先typeへ変換し、保存対象detailへ追加する。
    function appendDetailRows(detailObj, panelType, rows) {
        const sourceType = canonicalPanelType(panelType);
        const targetType = ["134", "137"].includes(sourceType) ? "133" : sourceType;
        if (targetType === "" || !Array.isArray(rows) || rows.length === 0) return;
        if (!Array.isArray(detailObj[targetType])) detailObj[targetType] = [];
        detailObj[targetType].push(...rows);
    }
    function hasGridPanelForDetailType(panelType) {
        const targetType = canonicalPanelType(panelType);
        if (targetType === "") return false;
        return Array.isArray(gridlist) && gridlist.some((panelInfo) => {
            if (DicVal(panelInfo, "id", "") === G_id.PL) return false;
            return canonicalPanelType(DicVal(panelInfo, "type", "")) === targetType;
        });
    }
    function shouldPreserveLoadedDetailType(panelType) {
        const typeKey = canonicalPanelType(panelType);
        if (typeKey === "") return false;

        // 画面で明示的に再構築する type は snapshot から戻さない
        if (typeKey === "100") return false;
        if (typeKey === PANEL_TYPE.BASE_INFO1) return false;
        if (hasGridPanelForDetailType(typeKey)) return false;

        // 138(サンプル組成)は 118/119/125 と同じ D_SSDQ を読み直した別名キーで、
        // 通常モードでは 118(buildQualityDssdqSaveRows)が同テーブル全行から payload を生成するため
        // snapshot からの引き継ぎは不要。引き継ぐと、画面上で削除(無効化)した品質行が
        // ロード時スナップショット経由で payload に紛れ込み、サーバの 138→118 統合
        // (118 に無いキーの追加)で削除したはずの行が復活する。
        // sample モードでは 138 パネルがグリッドを持つため上の hasGridPanelForDetailType で
        // 除外され、グリッド経路から送信される(この分岐の影響を受けない)。
        if (typeKey === PANEL_TYPE.SAMPLE_SOSEI) return false;

        // フロントで明示的に保存生成している type は snapshot 不要
        if (typeKey === PANEL_TYPE.QUALITY_BASE) return false;
        if (typeKey === FUKUSHIZAI_BASE_PANEL_TYPE) return false;

        return shouldSaveDetailType(typeKey);
    }

    function buildInitialDetailPayloadFromLoadedData() {
        const source = loadedEntryDetailRef.current;
        const detail = {};
        if (isEmpty(source) || typeof source !== "object") return detail;

        Object.keys(source).forEach((key) => {
            const typeKey = canonicalPanelType(key);
            const rows = source[key];
            if (!shouldPreserveLoadedDetailType(typeKey)) return;
            if (!Array.isArray(rows) || rows.length === 0) return;
            detail[typeKey] = DeepCopy(rows);
        });

        return detail;
    }
    // 保存payloadへ送らない基本情報UI専用項目を除外する。
    function stripBaseUiOnlyFields(data) {
        if (!data || typeof data !== "object") return data;
        const uiOnlyIds = new Set([...getBaseUiOnlyColumnIds(), ...getGroupedBaseDetailColumnIds()]);
        const out = { ...data };
        Object.keys(out).forEach((key) => {
            const cid = normalizeColumnIdUpper(key);
            // "__" 始まりは UI 専用マーカー(__FUKUSHIZAI_*/__QUALITY_*/__PREVIEW_* 等)。物理列には存在しない。
            if (uiOnlyIds.has(cid) || cid.startsWith("__") || cid.startsWith("SSDZ_") || QUALITY_ROOT_DATA_PREFIXES.some((prefix) => cid.startsWith(prefix))) {
                delete out[key];
            }
        });
        getFukushizaiBaseFieldIds().forEach((fieldId) => {
            delete out[fieldId];
            delete out[`${fieldId}_nm`];
            delete out[`${fieldId}_NM`];
            delete out[`${fieldId}_cd`];
            delete out[`${fieldId}_CD`];
        });
        getQualityBaseFieldIds().forEach((fieldId) => {
            delete out[fieldId];
            delete out[`${fieldId}_nm`];
            delete out[`${fieldId}_NM`];
            delete out[`${fieldId}_cd`];
            delete out[`${fieldId}_CD`];
        });
        return out;
    }
    function readFukushizaiOptionsFromEntryDataSource(source, rootKey, dataKey) {
        if (Array.isArray(DicVal(source, rootKey, null))) return DicVal(source, rootKey, []);
        const data = DicVal(source, "data", null);
        if (!isEmpty(data) && Array.isArray(DicVal(data, dataKey, null))) return DicVal(data, dataKey, []);
        return [];
    }
    function clearFukushizaiOptionPayloadFields(data) {
        if (isEmpty(data) || typeof data !== "object") return;
        delete data.__fukushizaiItemOptions;
        delete data.__fukushizaiColorOptions;
        delete data[QUALITY_HSITUHABA_OPTIONS_DATA_KEY];
        delete data[ITEM_NAME_MASTER_OPTIONS_DATA_KEY];
    }
    // NOTE: 表示補助項目だけを除外し、実DB列は残す。
    function isKakousijiSavePayloadUiOnlyField(key, panelType = "") {
        const raw = String(key ?? "");
        const cid = raw.trim().toUpperCase();
        if (cid === "") return false;
        if (/_CD$/.test(cid) || /_NM$/.test(cid) || /_NAME$/.test(cid) || /_DISPLAY$/.test(cid)) return true;
        if (/_DMY$/.test(cid) || /^MARK[1-7]$/.test(cid) || /^STP_SENTAKU[1-7]$/.test(cid)) return true;
        if (Object.values(FUKUSHIZAI_DISPLAY_DMY_FIELD).some((fieldId) => cid === fieldId)) return true;
        if (cid === "ITEMNAME" || cid === "ITEMNM" || cid === "ITEM_NAME" || cid === "SSDZ_ITMCITEMNM" || cid === "SSDZ_ITMCITEM_NM") return true;
        if (FUKUSHIZAI_UI_META_PREFIXES.some((prefix) => cid.startsWith(prefix))) return true;
        if (canonicalPanelType(panelType) === PANEL_TYPE.OTHER_FUKUZAI && cid === "SSDZ_SONOTAFUZOKUCD6") return true;
        return false;
    }
    function getSaveableColumnIdSetByPanelType(panelType) {
        const ids = new Set();
        if (Array.isArray(columninfo)) {
            columninfo.forEach((c) => {
                if (!matchesBaseDetailSavePanelType(DicVal(c, "type", ""), panelType)) return;
                const cid = normalizeColumnIdUpper(DicVal(c, "columnid", ""));
                if (cid === "") return;
                const table = String(DicVal(c, "table", "") ?? "").trim();
                const saveed = parseBoolLike(DicVal(c, "saveed", true), true);
                if (table === "-" || !saveed) return;
                ids.add(cid);
            });
        }
        if (canonicalPanelType(panelType) === PANEL_TYPE.SUSTAINABLE_MARK) {
            SUSTAINABLE_SAVE_KEY_FIELDS.forEach((fieldId) => {
                const cid = normalizeColumnIdUpper(fieldId);
                if (cid !== "") ids.add(cid);
            });
        }
        const qualityMap = getQualityPanelFieldMap(panelType);
        if (!isEmpty(qualityMap)) {
            [qualityMap.no, qualityMap.item, qualityMap.group, qualityMap.color, qualityMap.order].forEach((fieldId) => {
                const cid = normalizeColumnIdUpper(fieldId);
                if (cid !== "") ids.add(cid);
            });
            const fallbackGroup = normalizeColumnIdUpper(qualityMap.groupFallback);
            if (fallbackGroup !== "") ids.delete(fallbackGroup);
        }
        if (canonicalPanelType(panelType) === PANEL_TYPE.QUALITY_BASE) {
            QUALITY_BASE_EXTRA_SAVE_FIELD_IDS.forEach((fieldId) => {
                const cid = normalizeColumnIdUpper(fieldId);
                if (cid !== "") ids.add(cid);
            });
        }
        // 摘要(SSDE_TEKIYO)はs_layout上type118のためtype一致では124の保存列に入らない。明示追加する。
        if (canonicalPanelType(panelType) === PANEL_TYPE.WASH) {
            WASH_EXTRA_SAVE_FIELD_IDS.forEach((fieldId) => {
                const cid = normalizeColumnIdUpper(fieldId);
                if (cid !== "") ids.add(cid);
            });
        }
        if (canonicalPanelType(panelType) === FUKUSHIZAI_LIST_PANEL_TYPE) {
            FUKUSHIZAI_LIST_SAVE_FIELD_IDS.forEach((fieldId) => {
                const cid = normalizeColumnIdUpper(fieldId);
                if (cid !== "") ids.add(cid);
            });
        }
        if (canonicalPanelType(panelType) === PANEL_TYPE.DEMERIT) {
            [
                "SSDD_NO",
                "SSDD_ITMCITEMCD",
                "SSDD_GROUPNO",
                "SSDD_COLORCD",
                "SSDD_HYOJIJUN",
                DEMERIT_NAME_FLG,
                DEMERIT_HUDA_FLG,
                DEMERIT_DMT_CD
            ].forEach((fieldId) => {
                const cid = normalizeColumnIdUpper(fieldId);
                if (cid !== "") ids.add(cid);
            });
        }
        return ids;
    }
    function getFukushizaiSsdzSaveColumnIdSet() {
        const ids = new Set([
            FUKUSHIZAI_FIELD.NO,
            FUKUSHIZAI_FIELD.ITEM_CD,
            FUKUSHIZAI_FIELD.GROUP_NO,
            FUKUSHIZAI_FIELD.COLOR_CD
        ].map((value) => normalizeColumnIdUpper(value)));
        FUKUSHIZAI_BASE_MASTER_FIELD_IDS.forEach((fieldId) => {
            const cid = normalizeColumnIdUpper(fieldId);
            if (cid !== "") ids.add(cid);
        });
        FUKUSHIZAI_BASE_EXTRA_FIELD_IDS.forEach((fieldId) => {
            const cid = normalizeColumnIdUpper(fieldId);
            if (cid !== "") ids.add(cid);
        });
        FUKUSHIZAI_SSDZ_TEMPLATE_FIELD_IDS.forEach((fieldId) => {
            const cid = normalizeColumnIdUpper(fieldId);
            if (cid !== "") ids.add(cid);
        });
        if (Array.isArray(columninfo)) {
            columninfo.forEach((c) => {
                const type = canonicalPanelType(DicVal(c, "type", ""));
                if (!FUKUSHIZAI_PANEL_TYPES.includes(type)) return;
                const table = String(DicVal(c, "table", "") ?? "").trim().toUpperCase();
                if (table !== "D_SSDZ") return;
                const saveed = parseBoolLike(DicVal(c, "saveed", true), true);
                const primary = parseBoolLike(DicVal(c, "primary", false), false);
                if (!saveed && !primary) return;
                const cid = normalizeColumnIdUpper(DicVal(c, "columnid", ""));
                if (cid === "" || isKakousijiSavePayloadUiOnlyField(cid, type)) return;
                if (cid === "ROWID" || cid === "GRIP" || cid === "ROW_KIND") return;
                ids.add(cid);
            });
        }
        return ids;
    }
    function stripKakousijiSavePayloadUiOnlyFields(row, panelType = "") {
        if (isEmpty(row) || typeof row !== "object") return row;
        const out = { ...row };
        const type = canonicalPanelType(panelType);
        const saveableColumnIds = type === ""
            ? null
            : (type === FUKUSHIZAI_BASE_PANEL_TYPE ? getFukushizaiSsdzSaveColumnIdSet() : getSaveableColumnIdSetByPanelType(type));
        const preservedPhysicalIds = isColorwaySaveType(type)
            ? new Set(colorwayRequiredPhysicalKeyIds(type).map((columnId) => normalizeColumnIdUpper(columnId)))
            : (type === PANEL_TYPE.ACCESSORY_DETAIL
                ? new Set(["SSDF_GYONO"])
                : (type === PANEL_TYPE.GENKA ? new Set(["SSDGM_HACHUKEITAI", "SSDGM_KAIGAIKBN", "SSDGM_ZANFLG"]) : null));
        Object.keys(out).forEach((key) => {
            const cid = String(key ?? "").trim().toUpperCase();
            if (cid === "ROWID") return;
            if (cid === "SSDZ_SONOTAFUZOKUCD6" && String(out[key] ?? "").trim() === "") {
                delete out[key];
                return;
            }
            if (preservedPhysicalIds && preservedPhysicalIds.has(cid)) return;
            if (saveableColumnIds && saveableColumnIds.has(cid)) return;
            if (isKakousijiSavePayloadUiOnlyField(key, panelType)) delete out[key];
            if (saveableColumnIds && !saveableColumnIds.has(cid)) delete out[key];
        });
        return out;
    }
    function isSyntheticFukushizaiListRowId(rowid) {
        const text = normalizeFukushizaiText(rowid);
        if (text === "") return false;
        return text.split("|").length >= 5;
    }
    function normalizeFukushizaiListRowForSave(row, panelType = "", rowIndex = -1) {
        if (canonicalPanelType(panelType) !== FUKUSHIZAI_LIST_PANEL_TYPE || isEmpty(row) || typeof row !== "object") return row;
        const out = { ...row };
        const rowid = normalizeKakousijiUiString(DicVal(out, ROW_ID_FIELD, ""));
        const parts = rowid.includes("|") ? rowid.split("|") : [];
        const ensureValue = (fieldId, value) => {
            if (normalizeKakousijiUiString(readRowValueIgnoreCase(out, fieldId)) !== "") return;
            const normalized = normalizeKakousijiUiString(value);
            if (normalized !== "") out[fieldId] = normalized;
        };
        ensureValue("SSDZM_NO", entrydataRef.current?.SSD_NO);
        ensureValue("SSDZM_OPPICD", entrydataRef.current?.SSD_OPPICD);
        if (parts.length >= 5) {
            ensureValue("SSDZM_FUSIZAIKBN", parts[0]);
            ensureValue("SSDZM_FUZOKU_HINBAN", parts[1]);
            ensureValue("SSDZM_TORKUBUN", parts[2]);
            ensureValue("SSDZM_TORCODE", parts[3]);
            ensureValue("SSDZM_TORSUBCODE", parts[4]);
        }
        if (normalizeKakousijiUiString(readRowValueIgnoreCase(out, "SSDZM_HYOJIJUN")) === "") {
            out.SSDZM_HYOJIJUN = String(Number.isFinite(rowIndex) && rowIndex >= 0 ? rowIndex + 1 : 1);
        }
        if (rowid === "" || isSyntheticFukushizaiListRowId(rowid)) {
            out[ROW_ID_FIELD] = String(Number.isFinite(rowIndex) && rowIndex >= 0 ? rowIndex : 0);
        }
        return out;
    }
    // Kakousiji固有の表示補助項目をdetail保存行から除外する。
    function stripKakousijiDetailSaveRows(rows, panelType = "") {
        return Array.isArray(rows)
            ? rows
                .map((row, rowIndex) => stripKakousijiSavePayloadUiOnlyFields(
                    normalizeQualityRowForSave(normalizeFukushizaiListRowForSave(row, panelType, rowIndex), panelType),
                    panelType
                ))
                .filter((row) => {
                    if (isEmpty(row)) return false;
                    const keys = Object.keys(row);
                    const meaningfulKeys = keys.filter((key) => {
                        const cid = normalizeColumnIdUpper(key);
                        return cid !== "" && cid !== "ROWID" && cid !== "GRIP" && cid !== "ROW_KIND";
                    });
                    if (meaningfulKeys.length === 0) return false;
                    if (!meaningfulKeys.some((key) => {
                        const value = row[key];
                        return value !== null && value !== undefined && String(value ?? "").trim() !== "";
                    })) return false;
                    return true;
                })
            : rows;
    }

    // グループ行(state)の生成・同期 helper へ渡す依存関係をまとめます。
    // 登録グループ(125)の画面・明細は廃止済み。groupRows state の維持のみを担う。
    function buildFukushizaiRegisteredGroupServiceDeps() {
        return {
            fukushizaiGroupRowsRef,
            setGroupRows,
            DicVal,
            normalizeGroupNo,
            normalizeColorCd,
            normalizeKakousijiUiString,
            groupNoToLabel,
            normalizeGroupRows,
            // 初期化順の循環を避けるため、参照先は実行時に解決します。
            resolveRegisteredGroupRows: () => {
                return resolveRegisteredGroupRows;
            },
            readFukushizaiItemGroupFromAnyRow: (...args) => {
                return readFukushizaiItemGroupFromAnyRow(...args);
            }
        };
    }

    // 登録グループ行の生成・同期 helper は専用 service へ委譲します。
    const {
        makeRegisteredGroupRow,
        syncRegisteredGroupRowsForContext,
        syncRegisteredGroupRowsForGroupEdit,
        ensureRegisteredGroupRowForContext
    } = createFukushizaiRegisteredGroupService(buildFukushizaiRegisteredGroupServiceDeps());

    // 明細行アクセス系 helper へ渡す依存関係をまとめます。
    function buildDetailRowAccessorServiceDeps() {
        return {
            entrydetailRef,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            FUKUSHIZAI_FIELD,
            isEmpty,
            normalizeTypeKey,
            normalizeItemCd,
            normalizeGroupNo,
            normalizeColorCd,
            readRowValueIgnoreCase,
            makeRegisteredGroupRow
        };
    }

    // 明細行アクセス系 helper は専用 service へ委譲します。
    const {
        pickDetailRows,
        getDetailRowsByPanelType,
        getFirstDetailRowByPanelType,
        resolveRegisteredGroupRows
    } = createDetailRowAccessorService(buildDetailRowAccessorServiceDeps());

    // 副資材 context / color 参照 helper へ渡す依存関係をまとめます。
    function buildFukushizaiContextColorServiceDeps() {
        return {
            entrydetailRef,
            selectedFukushizaiContextRef,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            PANEL_TYPE,
            QUALITY_DISPLAY_PANEL_TYPES,
            normalizeItemCd,
            normalizeGroupNo,
            normalizeColorCd,
            getDetailRowsByPanelType,
            resolveRegisteredGroupRows,
            // 後続 helper / service 依存は実行時に解決します。
            isInvalidDisplayRow: (...args) => {
                return isInvalidDisplayRow(...args);
            },
            rowMatchesFukushizaiItemGroup: (...args) => {
                return rowMatchesFukushizaiItemGroup(...args);
            },
            readFukushizaiItemGroupFromAnyRow: (...args) => {
                return readFukushizaiItemGroupFromAnyRow(...args);
            },
            createEmptyFukushizaiContext: () => {
                return createEmptyFukushizaiContext();
            }
        };
    }

    // 副資材 context / color 参照 helper は専用 service へ委譲します。
    const {
        contextColorCodesFromRows,
        registeredColorCodesForContext,
        fukushizaiColorCodesForContext,
        getFukushizaiCopyTargetColorCodes,
        resolveFukushizaiGroupCopyTargetContext,
        sourceRowsForCopy
    } = createFukushizaiContextColorService(buildFukushizaiContextColorServiceDeps());

    // 副資材複写の内容列選定・列値複写 helper へ渡す依存関係をまとめます。
    function buildFukushizaiCopyContentServiceDeps() {
        return {
            ROW_ID_FIELD,
            FUKUSHIZAI_FIELD,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            DicVal,
            getFukushizaiSsdzSaveColumnIdSet,
            isKakousijiSavePayloadUiOnlyField,
            readRowValueIgnoreCase,
            isFukushizaiVerticalMasterSourceColumnId,
            clearFukushizaiMasterNameFields,
            // 後続で初期化される helper は実行時に解決します。
            clearFukushizaiDisplayProjectionFields: () => {
                return clearFukushizaiDisplayProjectionFields;
            },
            extractMasterCodeFromDisplayValue: () => {
                return extractMasterCodeFromDisplayValue;
            }
        };
    }

    // 副資材複写の内容列選定・列値複写 helper は専用 service へ委譲します。
    const {
        getFukushizaiBaseCopyContentColumnIds,
        copyFukushizaiContentColumns
    } = createFukushizaiCopyContentService(buildFukushizaiCopyContentServiceDeps());

    // 副資材複写/色展開 mutation 本体へ渡す依存関係をまとめます。
    function buildFukushizaiCopyMutationServiceDeps() {
        return {
            entrydetailRef,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            QUALITY_DISPLAY_PANEL_TYPES,
            WASH_PANEL_TYPE: PANEL_TYPE.WASH,
            WASH_COPY_DISPLAY_FIELD_IDS,
            ROW_ID_FIELD,
            isEmpty,
            DicVal,
            canonicalPanelType,
            normalizeItemCd,
            normalizeGroupNo,
            normalizeColorCd,
            getQualityInvalidField: (...args) => {
                return getQualityInvalidField(...args);
            },
            getQualityPanelFieldMap: (...args) => {
                return getQualityPanelFieldMap(...args);
            },
            getSaveableColumnIdSetByPanelType,
            isKakousijiSavePayloadUiOnlyField,
            readRowValueIgnoreCase,
            ensureDetailRowsByTypeForMutation,
            nextDetailRowIdForRows,
            setRowContextForPanel,
            readFukushizaiItemGroupFromAnyRow,
            rowMatchesFukushizaiItemGroup,
            sameItemGroupColor,
            getFukushizaiCopyTargetColorCodes,
            sourceRowsForCopy,
            fukushizaiColorCodesForContext,
            updateSagefudaItemFlags,
            debugFukushizaiSyncLog,
            getFukushizaiBaseCopyContentColumnIds,
            copyFukushizaiContentColumns,
            // 後続 helper は実行時に解決します。
            isInvalidDisplayRow: (...args) => {
                return isInvalidDisplayRow(...args);
            },
            createFukushizaiGroupDetailRow: (...args) => {
                return createFukushizaiGroupDetailRow(...args);
            },
            expandRowsToAddedColors: (...args) => {
                return expandRowsToAddedColors(...args);
            }
        };
    }

    // 副資材複写/色展開 mutation 本体は専用 service へ委譲します。
    const {
        mergeFukushizaiBaseContentIntoTargetColors,
        getQualityCopyContentColumnIds,
        representativeQualityRowsForCopy,
        replaceQualityRowsForContext,
        rebuildFukushizaiBaseRowsForEditedGroup,
        rebuildQualityRowsForEditedGroup,
        expandQualityRowsToAddedColors,
        applyFukushizaiGroupCopyToState
    } = createFukushizaiCopyMutationService(buildFukushizaiCopyMutationServiceDeps());

    // 品質表示の保存行変換へ渡す依存関係をまとめます。
    function buildQualityDetailSaveServiceDeps() {
        return {
            entrydetailRef,
            selectedQualityContextRef,
            PANEL_TYPE,
            ROW_ID_FIELD,
            isEmpty,
            isEnabled,
            DicVal,
            canonicalPanelType,
            normalizeKakousijiUiString,
            normalizeFukushizaiContext,
            normalizeItemCd,
            normalizeGroupNo,
            normalizeColorCd,
            getQualityPanelFieldMap: (...args) => getQualityPanelFieldMap(...args),
            qualityPanelContentColumnIds: (...args) => qualityPanelContentColumnIds(...args),
            readRowValueIgnoreCase,
            readCurrentFukushizaiNo,
            ensureDetailRowsByTypeForMutation,
            getDetailRowsByPanelType,
            qualityTargetColorsForContext,
            readQualityDisplayTargetColors: (row) => readQualityDisplayTargetColors(row),
            isQualityDisplayRowMeaningful: (...args) => isQualityDisplayRowMeaningful(...args),
            readFukushizaiItemGroupFromAnyRow,
            rowMatchesFukushizaiItemGroup,
            setRowContextForPanel,
            nextDetailRowIdForRows,
            normalizeQualityDisplayRowForSave: (...args) => normalizeQualityDisplayRowForSave(...args),
            isInvalidDisplayRow: (...args) => isInvalidDisplayRow(...args),
            // 「全行削除の確定」判定用。dirty サービスは後方で生成されるため遅延参照にする。
            isQualityPanelDirty: (type, context) => isFukushizaiDirtyPanel({ type }, context)
        };
    }
    // 品質表示の保存行変換は専用 service へ委譲します。
    const {
        normalizeQualityRowForSave,
        toQualitySaveRows,
        qualitySaveKey,
        buildQualityDssdqSaveRows
    } = createQualityDetailSaveService(buildQualityDetailSaveServiceDeps());
    // ※ toDetailSaveRows は同名の後方宣言(保存ループ直前)が有効。
    //    以前ここにあった旧実装は関数宣言の上書きで無効化されていたため削除した。
    function fukushizaiDetail113SaveRejectReason(row) {
        if (isEmpty(row)) return "empty row";
        const itemCd = normalizeItemCd(readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.ITEM_CD));
        const groupNo = normalizeGroupNo(readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.GROUP_NO));
        const colorCd = normalizeColorCd(readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.COLOR_CD));
        if (itemCd === "" || groupNo === "" || colorCd === "") return "missing item/group/color";
        return "";
    }
    // 副資材113〜117の表示状態から113保存行を組み立てる。
    function buildFukushizaiDetail113SaveRows() {
        const rows = getDetailRowsByPanelType(entrydetailRef.current, FUKUSHIZAI_BASE_PANEL_TYPE);
        const saveColumnIds = [...getFukushizaiSsdzSaveColumnIdSet()];
        const outRows = [];
        const seen = new Set();
        (Array.isArray(rows) ? rows : []).forEach((row) => {
            applyFukushizaiSsdzRowTemplateDefaults(row);
            const rejectReason = fukushizaiDetail113SaveRejectReason(row);
            if (rejectReason !== "") return;
            const itemCd = normalizeItemCd(readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.ITEM_CD));
            const groupNo = normalizeGroupNo(readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.GROUP_NO));
            const colorCd = normalizeColorCd(readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.COLOR_CD));
            const key = `${itemCd}\u0001${groupNo}\u0001${colorCd}`;
            if (seen.has(key)) return;
            seen.add(key);
            const out = {};
            const requiredBaseMasterFieldIds = new Set(FUKUSHIZAI_BASE_MASTER_FIELD_IDS.map((fieldId) => normalizeColumnIdUpper(fieldId)));
            saveColumnIds.forEach((columnId) => {
                const normalizedColumnId = normalizeColumnIdUpper(columnId);
                const isRequiredBaseMasterField = requiredBaseMasterFieldIds.has(normalizedColumnId);
                if (!isRequiredBaseMasterField && isKakousijiSavePayloadUiOnlyField(columnId, FUKUSHIZAI_BASE_PANEL_TYPE)) return;
                const value = readRowValueIgnoreCase(row, columnId);
                if (value === undefined) return;
                if (columnId === "SSDZ_SONOTAFUZOKUCD6" && String(value ?? "").trim() === "") return;
                out[columnId] = value;
            });
            out[FUKUSHIZAI_FIELD.NO] = String(DicVal(out, FUKUSHIZAI_FIELD.NO, "") ?? "").trim() || readCurrentFukushizaiNo();
            out[FUKUSHIZAI_FIELD.ITEM_CD] = itemCd;
            out[FUKUSHIZAI_FIELD.GROUP_NO] = groupNo;
            out[FUKUSHIZAI_FIELD.COLOR_CD] = colorCd;
            outRows.push(out);
        });
        return stripKakousijiDetailSaveRows(outRows, FUKUSHIZAI_BASE_PANEL_TYPE);
    }
    // =====================================================================
    // Grid共通制御
    // ---------------------------------------------------------------------
    // Grid参照、行データ、再描画、受注数/納品予定の表示補助を扱う。
    // =====================================================================

    function resolveGridIndex(panel) {
        const direct = fnc.current.gridindex(panel);
        if (direct !== -1) return direct;
        if (!Array.isArray(gridlist) || gridlist.length === 0) return -1;
        if (isEmpty(panel)) return -1;
        if (typeof panel !== "object") {
            const pid = String(panel ?? "");
            const byId = gridlist.find(e => String(e.id ?? "") === pid);
            return isEmpty(byId) ? -1 : byId.index;
        }
        const pid = String(DicVal(panel, "id", ""));
        const ptype = String(DicVal(panel, "type", ""));
        const byIdType = gridlist.find(e => {
            const eid = String(e.id ?? "");
            const etype = normalizeTypeKey(String(e.type ?? ""));
            return eid === pid && etype === normalizeTypeKey(ptype);
        });
        if (!isEmpty(byIdType)) return byIdType.index;
        const byId = gridlist.find(e => String(e.id ?? "") === pid);
        if (!isEmpty(byId)) return byId.index;
        return -1;
    }

    function ensureGridRefArray(refArray, idx) {
        if (idx === -1 || isEmpty(idx)) return { current: null };
        if (isEmpty(refArray.current[idx])) refArray.current[idx] = createRef();
        return refArray.current[idx];
    }

    function ensureGridDataRef(panel) {
        const dref = ensureGridRefArray(griddataRefs, resolveGridIndex(panel));
        if (!Array.isArray(dref.current)) dref.current = [];
        return dref;
    }

    function ensureGridColRef(panel) {
        const cref = ensureGridRefArray(gridcolRefs, resolveGridIndex(panel));
        if (!Array.isArray(cref.current)) cref.current = [];
        return cref;
    }

    function SetGridData(panel, data) {
        let gidx = resolveGridIndex(panel);
        if (gidx === -1) return;
        ensureGridRefArray(griddataRefs, gidx).current = normalizeGridRowsForDisplay(panel, Array.isArray(data) ? data : []);
    }

    // 明細グリッドのデータを取得する。
    function GridData(panel) {
        let gidx = resolveGridIndex(panel);
        if (gidx === -1) return [];
        const data = ensureGridRefArray(griddataRefs, gidx).current;
        return Array.isArray(data) ? data : [];
    }

    // 明細グリッドの列定義を保存する。
    function SetGridColDef(panel, coldef) {
        let gidx = resolveGridIndex(panel);
        if (gidx === -1) return;
        ensureGridRefArray(gridcolRefs, gidx).current = Array.isArray(coldef) ? coldef : [];
    }

    // グリッドAPIを保存する。
    function SetGridApi(panel, api) {
        let gidx = resolveGridIndex(panel);
        if (gidx === -1) return;
        ensureGridRefArray(gridapiRefs, gidx).current = api;
        if (isGenkaGridPanelInfo(panel)) {
            gridRefreshCoordinator.flushPendingGenkaEditableRefresh("SetGridApi");
        }
    }

    // 保存したグリッドAPIを取得する。
    function GridApi(panel) {
        let gidx = resolveGridIndex(panel);
        if (gidx === -1) return null;
        return ensureGridRefArray(gridapiRefs, gidx).current;
    }

    function findGridPanelInfoByGridId(gridId) {
        if (isEmpty(gridId) || isEmpty(fnc.current) || typeof fnc.current.GridID !== "function") return null;
        if (!Array.isArray(gridlist) || gridlist.length === 0) return null;
        return gridlist.find((panelInfo) => fnc.current.GridID(panelInfo) === gridId) || null;
    }

    function refreshGridPanelByApi(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        const api = GridApi(panelInfo);
        if (isEmpty(api) || !isGridDomReady(panelInfo)) return false;

        const rows = GridData(panelInfo);
        setGridRowsByApi(api, Array.isArray(rows) ? rows : []);

        if (isDemandPanelInfo(panelInfo)) {
            enforceDemandLeftColumns(panelInfo, api);
            fitDemandColumns(panelInfo, api);
        } else if (isGenkaGridPanelInfo(panelInfo)) {
            hideGridAuxColumns(api);
        }

        if (typeof api.refreshCells === "function") {
            api.refreshCells({ force: true });
        }
        if (typeof api.redrawRows === "function") {
            api.redrawRows();
        }
        return true;
    }

    // 列APIを保存する。
    function SetGridColApi(panel, api) {
        let gidx = resolveGridIndex(panel);
        if (gidx === -1) return;
        ensureGridRefArray(gridcolapiRefs, gidx).current = api;
    }

   // 保存した列APIを取得する。
   function GridColApi(panel) {
        let gidx = resolveGridIndex(panel);
        if (gidx === -1) return null;
        return ensureGridRefArray(gridcolapiRefs, gidx).current;
    }

    // 合計グリッド保存用のキーを作る。
    function totalRefKey(panel) {
        return panel.id + "_" + panel.totaltype;
    }

    // 合計データの保存先Refを必ず用意する。
    function ensureTotalDataRef(panel) {
        const key = totalRefKey(panel);
        if (isEmpty(totalgriddataRefs.current[key])) totalgriddataRefs.current[key] = { current: null };
        return totalgriddataRefs.current[key];
    }

    // 合計列定義の保存先Refを必ず用意する。
    function ensureTotalColRef(panel) {
        const key = totalRefKey(panel);
        if (isEmpty(totalgridcolRefs.current[key])) totalgridcolRefs.current[key] = { current: [] };
        if (!Array.isArray(totalgridcolRefs.current[key].current)) totalgridcolRefs.current[key].current = [];
        return totalgridcolRefs.current[key];
    }

    // 合計グリッドAPIの保存先Refを必ず用意する。
    function ensureTotalApiRef(panel) {
        const key = totalRefKey(panel);
        if (isEmpty(totalgridapiRefs.current[key])) totalgridapiRefs.current[key] = createRef();
        return totalgridapiRefs.current[key];
    }

    // 合計グリッドAPIを保存する。
    function SetTotalGridApi(panel, api) {
        if (isEmpty(panel)) return;
        ensureTotalApiRef(panel).current = api;
    }

    // 保存した合計グリッドAPIを取得する。
    function TotalGridApi(panel) {
        if (isEmpty(panel)) return null;
        return ensureTotalApiRef(panel).current;
    }

    // グリッドAPIへ rowData を反映する。
    function setGridRowsByApi(api, rows) {
        if (isEmpty(api) || !Array.isArray(rows)) return;
        if (typeof api.setGridOption === "function") {
            api.setGridOption("rowData", rows);
            return;
        }
        if (typeof api.setRowData === "function") {
            api.setRowData(rows);
        }
    }

    // グリッドAPIへ columnDefs を反映する。
    // AG Grid が既に保持している列定義から、React 側で付与された描画用プロパティを引き継ぐ。
    //
    // valueFormatter / cellRenderer 等は EntryGridAr の columnDefs(useMemo) でのみ付与される。
    // createPanelColumnDefsByType が返す定義にはそれらが無いため、そのまま columnDefs を差し替えると
    // MASTER 列の「コード:名称」整形が失われ、コードだけの表示になる。
    const GRID_RENDER_COLDEF_KEYS = [
        "valueFormatter", "valueParser", "cellRenderer", "cellRendererParams", "cellEditorSelector"
    ];
    function mergeGridRenderColumnProps(api, defs) {
        if (isEmpty(api) || typeof api.getColumnDefs !== "function") return defs;
        let currentDefs = null;
        try { currentDefs = api.getColumnDefs(); } catch (e) { return defs; }
        if (!Array.isArray(currentDefs) || currentDefs.length === 0) return defs;
        const byColId = {};
        currentDefs.forEach((col) => {
            const colId = String(DicVal(col, "colId", DicVal(col, "field", "")) ?? "").trim();
            if (colId !== "") byColId[colId] = col;
        });
        return defs.map((col) => {
            const colId = String(DicVal(col, "colId", DicVal(col, "field", "")) ?? "").trim();
            const before = byColId[colId];
            if (colId === "" || isEmpty(before)) return col;
            const next = { ...col };
            GRID_RENDER_COLDEF_KEYS.forEach((key) => {
                if (next[key] === undefined && before[key] !== undefined) next[key] = before[key];
            });
            return next;
        });
    }
    function setGridColumnDefsByApi(api, defs) {
        if (isEmpty(api) || !Array.isArray(defs) || defs.length === 0) return;
        const nextDefs = mergeGridRenderColumnProps(api, defs);
        if (typeof api.setGridOption === "function") {
            api.setGridOption("columnDefs", nextDefs);
            return;
        }
        if (typeof api.setColumnDefs === "function") {
            api.setColumnDefs(nextDefs);
        }
    }

    // 左補助列（grip/rowid）を非表示にする。
    function hideGridAuxColumns(api) {
        if (isEmpty(api)) return;
        if (typeof api.applyColumnState === "function") {
            api.applyColumnState({
                state: [{ colId: "grip", hide: true }, { colId: "rowid", hide: true }],
                applyOrder: false
            });
            return;
        }
        if (typeof api.setColumnVisible === "function") {
            api.setColumnVisible("grip", false);
            api.setColumnVisible("rowid", false);
            return;
        }
        if (typeof api.setColumnsVisible === "function") {
            api.setColumnsVisible(["grip", "rowid"], false);
        }
    }

    // マウント済みグリッドへ rowData を直接反映する。
    function applyGridRowsNow(panelInfo, rows) {
        try {
            const api = GridApi(panelInfo);
            if (isEmpty(api)) return;
            const displayRows = normalizeGridRowsForDisplay(panelInfo, Array.isArray(rows) ? rows : []);
            if (typeof api.setGridOption === "function") {
                api.setGridOption("rowData", displayRows);
                return;
            }
            if (typeof api.setRowData === "function") {
                api.setRowData(displayRows);
                return;
            }
        } catch (e) { console.error(e); }
    }

    // Grid操作時に使うDOM-IDを安全に取得する。
    function getGridDomIdSafe(panelInfo) {
        try {
            if (isEmpty(panelInfo)) return "";
            if (isEmpty(fnc.current) || typeof fnc.current.GridID !== "function") return "";
            return fnc.current.GridID(panelInfo);
        } catch (e) {
            return "";
        }
    }

    // GridがDOM上に存在するかを確認する。非表示/未マウントGridの古いAPI参照へ流さないために使う。
    function isGridDomReady(panelInfo) {
        const id = getGridDomIdSafe(panelInfo);
        if (isEmpty(id)) return false;
        if (typeof document === "undefined") return false;
        return !isEmpty(document.getElementById(id));
    }

    // Grid 再描画まわりの pending 制御を coordinator へ委譲します。
    function buildGridRefreshCoordinatorDeps() {
        return {
            isEmpty,
            DicVal,
            // ブラウザ組み込み関数は this 文脈を失わないよう、ラッパー経由で渡します。
            requestAnimationFrame: typeof requestAnimationFrame === "function"
                ? ((callback) => requestAnimationFrame(callback))
                : null,
            cancelAnimationFrame: typeof cancelAnimationFrame === "function"
                ? ((timerId) => cancelAnimationFrame(timerId))
                : null,
            setTimeout: (callback, delay = 0) => setTimeout(callback, delay),
            clearTimeout: (timerId) => clearTimeout(timerId),
            getGridApi: GridApi,
            isGridDomReady,
            getGridDomId: getGridDomIdSafe,
            getGridRows: GridData,
            applyGridRowsNow,
            rerenderGridById: (gridId) => {
                // rerenderGrid が使える場合だけ既存の再描画経路へ流します。
                if (!isEmpty(fnc.current) && typeof fnc.current.rerenderGrid === "function") {
                    fnc.current.rerenderGrid(gridId);
                }
            },
            isGenkaGridPanelInfo,
            isDemandPanelInfo,
            isWashPanelInfo,
            getGenkaPanel: () => Array.isArray(gridlist) ? gridlist.find((g) => isGenkaGridPanelInfo(g)) : null,
            refreshGenkaGridEditableState,
            resetPendingGenkaEditableRefresh,
            getGenkaPostLoadRefreshSkip: () => genkaPostLoadRefreshSkipRef.current === true,
            getPendingGridApplyMap: () => pendingGridApplyRef.current,
            setPendingGridApplyMap: (value) => { pendingGridApplyRef.current = value; },
            getPendingGridRerenderIds: () => pendingGridRerenderIdsRef.current,
            setPendingGridRerenderIds: (value) => { pendingGridRerenderIdsRef.current = value; },
            getPendingGridRerenderTimer: () => pendingGridRerenderTimerRef.current,
            setPendingGridRerenderTimer: (value) => { pendingGridRerenderTimerRef.current = value; },
            getPendingGenkaEditableRefresh: () => pendingGenkaEditableRefreshRef.current,
            setPendingGenkaEditableRefresh: (value) => { pendingGenkaEditableRefreshRef.current = value; },
            getPendingGenkaEditableRefreshTimer: () => pendingGenkaEditableRefreshTimerRef.current,
            setPendingGenkaEditableRefreshTimer: (value) => { pendingGenkaEditableRefreshTimerRef.current = value; }
        };
    }
    const gridRefreshCoordinator = createGridRefreshCoordinator(buildGridRefreshCoordinatorDeps());

    // 副資材 context 表示グリッドの再描画制御へ渡す依存関係をまとめます。
    function buildFukushizaiContextGridServiceDeps() {
        return {
            getTargetPanels: getFukushizaiContextDisplayGridPanels,
            isEmpty,
            DeepCopy,
            resolveTypeCandidatesForPanel,
            createPanelColumnDefsByType,
            setGridColDef: SetGridColDef,
            getGridApi: GridApi,
            getGridRows: GridData,
            setGridColumnDefsByApi,
            setGridRowsByApi,
            scheduleGridDataRerender: (panelInfo) => {
                gridRefreshCoordinator.scheduleGridDataRerender(panelInfo);
            },
            // requestAnimationFrame は直接渡さず coordinator 経由で遅延実行します。
            scheduleDeferred: (callback) => {
                gridRefreshCoordinator.scheduleDeferred(callback);
            }
        };
    }

    // 副資材 context 表示グリッドの再描画制御は専用 service へ委譲します。
    const {
        refreshFukushizaiCopyPreviewGridEditLock,
        rerenderFukushizaiSectionGrids,
        resetFukushizaiContextDisplayGridRowState,
        scheduleFukushizaiSectionGridRepaint
    } = createFukushizaiContextGridService(buildFukushizaiContextGridServiceDeps());

    // 副資材 group 操作後の UI/投影再同期へ渡す依存関係をまとめます。
    function buildFukushizaiContextMutationUiServiceDeps() {
        return {
            entrydataRef,
            entrydetailRef,
            selectedFukushizaiContextRef,
            getPendingFukushizaiCopy: () => pendingFukushizaiCopy,
            setPendingFukushizaiCopy,
            fnc,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            isEmpty,
            DicVal,
            normalizeItemCd,
            normalizeGroupNo,
            updateSelectedFukushizaiContext,
            setSelectedSetItem,
            setSelectedGroup,
            // projection context helper は後続で初期化されるため実行時に解決します。
            clearFukushizaiMergedFields: (entryObj) => {
                return clearFukushizaiMergedFields(entryObj);
            },
            // 代表行投影は後続で初期化されるため実行時に解決します。
            mergeFukushizaiRepresentativeRowToEntry: (entryObj, detailData, context) => {
                return mergeFukushizaiRepresentativeRowToEntry(entryObj, detailData, context);
            },
            getDetailRowsByPanelType,
            primeFukushizaiMasterStoreFromRows,
            // projection 本体は後続で初期化されるため実行時に解決します。
            refreshSectionViews: (itemCd, groupNo, previewOverride, context) => {
                fukushizaiProjection.refreshSectionViews(itemCd, groupNo, previewOverride, context);
            },
            scheduleFukushizaiSectionGridRepaint,
            refreshFukushizaiCopyPreviewGridEditLock,
            // 単票(BASE)の表示を entrydata から再同期させる(グループ追加後の旧値残り対策)。
            dispatchEntryRerender: (reason) => dispatchEntryRerenderWithTrace(reason),
            rerender
        };
    }

    // 副資材 group 操作後の UI/投影再同期は専用 service へ委譲します。
    const {
        refreshAfterFukushizaiGroupMutation,
        applyFukushizaiMutationRefresh,
        cancelFukushizaiCopyPreviewUi
    } = createFukushizaiContextMutationUiService(buildFukushizaiContextMutationUiServiceDeps());

    // 副資材の group add/delete/edit 本体へ渡す依存関係をまとめます。
    function buildFukushizaiGroupActionServiceDeps() {
        return {
            entrydetailRef,
            selectedFukushizaiContextRef,
            getSelectedSetItem: () => selectedSetItem,
            getSelectedGroup: () => selectedGroup,
            getGroupDialogState: () => groupDialogState,
            setGroupOptions,
            fukushizaiGroupClearedByUserRef,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            QUALITY_DISPLAY_PANEL_TYPES,
            isEmpty,
            DicVal,
            DeepCopy,
            normalizeItemCd,
            normalizeGroupNo,
            normalizeTypeKey,
            normalizeColorCd,
            normalizeKakousijiUiString,
            normalizeEditableGroupNo,
            // dialog service 側の関数は実行時に解決します。
            checkedGroupDialogColorCodes: () => {
                return checkedGroupDialogColorCodes();
            },
            getKnownFukushizaiGroupNos,
            ensureFukushizaiBaseKeyRowsForColors,
            syncRegisteredGroupRowsForContext,
            ensureRegisteredGroupRowForContext,
            clearQualityDisplayRowsForContext,
            getFukushizaiRowsByContext,
            sourceRowsForCopy,
            fukushizaiColorCodesForContext,
            rebuildFukushizaiBaseRowsForEditedGroup,
            rebuildQualityRowsForEditedGroup,
            syncRegisteredGroupRowsForGroupEdit,
            updateSagefudaItemFlags,
            debugFukushizaiSyncLog,
            resolveGridPanelByType,
            setGridData: SetGridData,
            filterRowsByFukushizaiContextIfKeyed,
            sameItemGroup,
            // 後続 service は実行時に解決します。
            refreshAfterFukushizaiGroupMutation: (itemCd, groupNo, changed) => {
                return refreshAfterFukushizaiGroupMutation(itemCd, groupNo, changed);
            }
        };
    }

    // 副資材の group add/delete/edit 本体は専用 service へ委譲します。
    const {
        removeFukushizaiGroupFromDetailRows,
        nextFukushizaiGroupAfterDelete,
        applyFukushizaiGroupAddFromDialog,
        applyFukushizaiGroupDelete,
        applyFukushizaiGroupEditFromDialog
    } = createFukushizaiGroupActionService(buildFukushizaiGroupActionServiceDeps());

    // 副資材の group dialog 制御へ渡す依存関係をまとめます。
    function buildFukushizaiGroupDialogServiceDeps() {
        return {
            DicVal,
            UI_ACTION,
            normalizeGroupNo,
            normalizeKakousijiUiString,
            getSelectedSetItem: () => selectedSetItem,
            getSelectedGroup: () => selectedGroup,
            // 品質表示(hinshitsu)セクションのグループ操作は品質側の選択と候補を使う。
            getSelectedQualityItem: () => selectedQualityItem,
            getSelectedQualityGroup: () => selectedQualityGroup,
            getCopyItem: () => copyItem,
            getCopyGroup: () => copyGroup,
            getKnownFukushizaiGroupNos,
            getKnownQualityGroupNos,
            getFukushizaiColorOptions,
            getQualityColorOptions,
            hasFukushizaiUiGroupOption,
            hasFukushizaiGroupRows,
            getGroupDialogState: () => groupDialogState,
            setGroupDialogState,
            // group action service 側の関数は実行時に解決します。
            applyFukushizaiGroupAddFromDialog: () => {
                return applyFukushizaiGroupAddFromDialog();
            },
            applyFukushizaiGroupEditFromDialog: () => {
                return applyFukushizaiGroupEditFromDialog();
            },
            applyFukushizaiGroupDelete: (itemCd, groupNo) => {
                return applyFukushizaiGroupDelete(itemCd, groupNo);
            },
            // 品質表示側のグループ操作(副資材とは独立)。
            applyQualityGroupAddFromDialog: () => {
                return applyQualityGroupAddFromDialog();
            },
            applyQualityGroupEditFromDialog: () => {
                return applyQualityGroupEditFromDialog();
            },
            applyQualityGroupDelete: (itemCd, groupNo) => {
                return applyQualityGroupDelete(itemCd, groupNo);
            }
        };
    }

    // 副資材の group dialog 制御は専用 service へ委譲します。
    const {
        checkedGroupDialogColorCodes,
        openGroupActionDialog,
        closeGroupActionDialog,
        updateGroupDialogColorChecked,
        commitGroupActionDialog,
        isQualityGroupSection
    } = createFukushizaiGroupDialogService(buildFukushizaiGroupDialogServiceDeps());

    // 副資材の複写/preview 確定フローへ渡す依存関係をまとめます。
    function buildFukushizaiGroupCopyServiceDeps() {
        return {
            entrydetailRef,
            getPendingFukushizaiCopy: () => pendingFukushizaiCopy,
            setPendingFukushizaiCopy,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            FUKUSHIZAI_FIELD,
            ROW_ID_FIELD,
            isEmpty,
            DicVal,
            normalizeItemCd,
            normalizeGroupNo,
            normalizeTypeKey,
            getFukushizaiContextFieldIds,
            getFukushizaiBaseFieldIds,
            getDetailRowsByPanelType,
            sameItemGroup,
            resolveFukushizaiGroupCopyTargetContext,
            applyFukushizaiGroupCopyToState,
            updateSagefudaItemFlags,
            debugFukushizaiSyncLog,
            refreshFukushizaiCopyPreviewGridEditLock,
            // 後続初期化の helper は実行時に解決します。
            clearFukushizaiDisplayProjectionFields: (row) => {
                return clearFukushizaiDisplayProjectionFields(row);
            },
            applyFukushizaiMutationRefresh: (options) => {
                return applyFukushizaiMutationRefresh(options);
            },
            cancelFukushizaiCopyPreviewUi: () => {
                return cancelFukushizaiCopyPreviewUi();
            }
        };
    }

    // 副資材の複写/preview 確定フローは専用 service へ委譲します。
    const {
        getFukushizaiGroupCopyFieldIds,
        applyFukushizaiGroupCopyNow,
        commitFukushizaiCopyPreview,
        cancelFukushizaiCopyPreview
    } = createFukushizaiGroupCopyService(buildFukushizaiGroupCopyServiceDeps());

    // 副資材の複写 preview 参照ロジックへ渡す依存関係をまとめます。
    function buildFukushizaiCopyPreviewServiceDeps() {
        return {
            FUKUSHIZAI_BASE_PANEL_TYPE,
            ROW_ID_FIELD,
            isEmpty,
            DicVal,
            DeepCopy,
            normalizeItemCd,
            normalizeGroupNo,
            normalizeKakousijiUiString,
            normalizeFukushizaiContext,
            getPendingFukushizaiCopy: () => pendingFukushizaiCopy,
            getSelectedFukushizaiContext: () => selectedFukushizaiContextRef.current,
            getEntryData: () => entrydataRef.current,
            getFukushizaiAllFieldIds,
            getFukushizaiContextFieldIds,
            // 後続定義の helper は実行時に解決します。
            getFukushizaiCopyTargetColorCodes: () => {
                return getFukushizaiCopyTargetColorCodes;
            },
            sourceRowsForCopy: () => {
                return sourceRowsForCopy;
            },
            setRowContextForPanel: () => {
                return setRowContextForPanel;
            },
            getFukushizaiBaseCopyContentColumnIds: () => {
                return getFukushizaiBaseCopyContentColumnIds;
            },
            createFukushizaiGroupDetailRow: () => {
                return createFukushizaiGroupDetailRow;
            },
            copyFukushizaiContentColumns: () => {
                return copyFukushizaiContentColumns;
            },
            clearFukushizaiMergedFields: () => {
                return clearFukushizaiMergedFields;
            }
        };
    }

    // 副資材の複写 preview 参照ロジックは専用 service へ委譲します。
    const {
        buildFukushizaiCopyPreviewRows,
        isActiveFukushizaiCopyPreview,
        getActiveFukushizaiCopyPreviewRows,
        buildFukushizaiPreviewEntryDataForBase
    } = createFukushizaiCopyPreviewService(buildFukushizaiCopyPreviewServiceDeps());

    // 副資材パネルの表示行組み立てへ渡す依存関係をまとめます。
    function buildFukushizaiPanelDisplayServiceDeps() {
        return {
            FUKUSHIZAI_BASE_PANEL_TYPE,
            isEmpty,
            normalizeFukushizaiContext,
            hasCompleteFukushizaiContext,
            getActiveFukushizaiCopyPreviewRows,
            getDetailRowsByPanelType,
            readFukushizaiContextFromRow,
            isBrandNamePanelInfo,
            isOtherNamePanelInfo,
            isOtherFukuzaiPanelInfo,
            isKomonofudaPanelInfo,
            // 後続 service 依存は実行時に解決します。
            pickFukushizaiRepresentativeRow: (...args) => {
                return pickFukushizaiRepresentativeRow(...args);
            },
            createFukushizaiEmptyRow: (...args) => {
                return createFukushizaiEmptyRow(...args);
            },
            buildBrandNameDisplayRows: (...args) => {
                return buildBrandNameDisplayRows(...args);
            },
            buildOtherNameDisplayRows: (...args) => {
                return buildOtherNameDisplayRows(...args);
            },
            buildOtherFukuzaiDisplayRows: (...args) => {
                return buildOtherFukuzaiDisplayRows(...args);
            },
            requestKomonoFudaLabelsForRow: (...args) => {
                return requestKomonoFudaLabelsForRow(...args);
            },
            buildKomonoFudaDisplayRows: (...args) => {
                return buildKomonoFudaDisplayRows(...args);
            }
        };
    }

    // 副資材パネルの表示行組み立ては専用 service へ委譲します。
    const {
        buildFukushizaiContextDisplayRows,
        decorateFukushizaiSupplementDisplayRows
    } = createFukushizaiPanelDisplayService(buildFukushizaiPanelDisplayServiceDeps());

    // 明細表示後処理へ渡す依存関係をまとめます。
    function buildPanelDetailPostProcessServiceDeps() {
        return {
            isQualityPanelType,
            isFukushizaiSharedContextPanelInfo,
            isGenkaGridPanelInfo,
            isDemeritPanelInfo,
            isWashPanelInfo,
            isSoseiPanelInfo,
            getPanelType,
            demandTypeKeyByPanel,
            filterRowsByFukushizaiContextIfKeyed,
            normalizeJutyuRows,
            normalizeNouhinYoteiRows,
            buildQualityRepresentativeDisplayRows,
            ensureGenkaDisplayRows,
            // 後続 service 依存は実行時に解決します。
            filterInvalidRowsForPanel: (rows, panelInfo) => {
                return filterInvalidRowsForPanel(panelInfo, rows);
            },
            decorateFukushizaiSupplementDisplayRows: (rows, panelInfo, context) => {
                return decorateFukushizaiSupplementDisplayRows(panelInfo, rows, context);
            },
            normalizeDemeritRows: (rows) => {
                return normalizeDemeritRows(rows);
            },
            normalizeWashRowsForDisplay: (rows) => {
                return normalizeWashRowsForDisplay(rows);
            },
            normalizeSoseiRowsForPanel: (rows, panelInfo) => {
                return normalizeSoseiRowsForPanel(panelInfo, rows);
            }
        };
    }

    // 明細表示の共通後処理は専用 service へ委譲します。
    const {
        postProcessPanelDetailRows
    } = createPanelDetailPostProcessService(buildPanelDetailPostProcessServiceDeps());

    // 明細表示元の解決へ渡す依存関係をまとめます。
    function buildPanelDetailSourceResolverServiceDeps() {
        return {
            getPanelType,
            isFukushizaiSharedContextPanelInfo,
            isFukushizaiContextDisplayPanelInfo,
            hasCompleteFukushizaiContext,
            normalizeFukushizaiContext,
            pickDetailRows,
            // 後続 helper / service 依存は実行時に解決します。
            buildFukushizaiContextDisplayRows: (panelInfo, detailData, previewOverride, context) => {
                return buildFukushizaiContextDisplayRows(panelInfo, detailData, previewOverride, context);
            }
        };
    }

    // 明細表示元の解決は専用 service へ委譲します。
    const {
        resolvePanelDetailSourceRows
    } = createPanelDetailSourceResolverService(buildPanelDetailSourceResolverServiceDeps());

    // セクション表示先の解決ロジックを resolver へ委譲します。
    function buildSectionPanelResolverDeps() {
        return {
            isEmpty,
            DicVal,
            canonicalPanelType,
            G_id,
            PANEL_TYPE,
            getPanel: () => panel,
            getColumnInfo: () => columninfo,
            getKakouType: () => kakouType,
            getKakouShijiKubun: () => kakouShijiKubun,
            getCurrentNormalSectionDefs: () => currentNormalSectionDefs(),
            getCurrentSampleSectionDefs: () => currentSampleSectionDefs(),
            getKakouShijiKubunColumnId,
            resolveFukushizaiGridPanel,
            getDetailRowsByPanelType
        };
    }
    const sectionPanelResolver = createSectionPanelResolver(buildSectionPanelResolverDeps());
    // sectionRenderModelResolver は初期化順の都合で先に demand 判定を必要とします。
    function resolveDemandSectionIdForRenderModel(sectionId) {
        return sectionId === "jutyusu" || sectionId === "nouhinyotei";
    }
    // sectionDisplayHelperService を先行初期化するため、autoHeight 補正をここで先に解決します。
    function resolveStableAutoHeightPanelForDisplay(panelInfo, sectionId) {
        if (isEmpty(panelInfo)) return panelInfo;
        if (resolveDemandSectionIdForRenderModel(sectionId)) {
            const normalizedType = demandTypeKeyByPanel(panelInfo) || String(DicVal(panelInfo, "type", ""));
            return { ...panelInfo, type: normalizedType, gridmax: "99999" };
        }
        if (sectionId === "genka") {
            return { ...panelInfo, gridmax: "99999" };
        }
        return panelInfo;
    }
    // セクション描画補助は renderer / resolver より先に初期化します。
    function buildSectionDisplayHelperServiceDeps() {
        return {
            GridData,
            normalizeTotalTypeForColumns,
            toStableAutoHeightPanel: resolveStableAutoHeightPanelForDisplay,
            isEmpty,
            DicVal,
            colorwayMatrixMap,
            warndescriptionRef
        };
    }
    const {
        demandGridFixedHeight,
        sijisuGridFixedHeight,
        basicGridFixedHeight,
        genkaGridFixedHeight,
        totalTitle,
        totalContainerStyle,
        buildTotalPanel,
        isDemandSectionId,
        sectionGridRowStyle,
        isColorwayPanel,
        colorwayDetailParams
    } = createSectionDisplayHelperService(buildSectionDisplayHelperServiceDeps());
    // 原価表示用の固定列定義は専用 service へ委譲します。
    function buildGenkaDisplayColumnServiceDeps() {
        return {
            PANEL_TYPE,
            DicVal,
            isEmpty,
            columns,
            columninfo,
            findColumnInfoByCandidates,
            mapGenkaByColumnId,
            normalizeLabelKey,
            formatGenkaDisplayValue,
            formatGenkaKouseiDisplayValue,
            isGenkaCellEditable,
            genkaCellStyleByEditable
        };
    }
    const {
        buildGenkaFixedColumns
    } = createGenkaDisplayColumnService(buildGenkaDisplayColumnServiceDeps());
    // セクション描画前の表示モデル解決を resolver へ委譲します。
    function buildSectionRenderModelResolverDeps() {
        return {
            isEmpty,
            DicVal,
            PANEL_TYPE,
            isDemandSectionId: resolveDemandSectionIdForRenderModel,
            demandTypeKeyByPanel,
            resolveSectionPanel,
            resolveRemarksSectionPanel,
            resolveGridSectionPanel,
            resolveTotalHostPanel,
            sectionTotalType,
            normalizeTotalTypeForColumns,
            // GridID は this 文脈を保つためラッパーで呼びます。
            getGridId: (panelInfo) => {
                if (isEmpty(panelInfo)) return "";
                if (isEmpty(fnc.current) || typeof fnc.current.GridID !== "function") return "";
                return fnc.current.GridID(panelInfo);
            },
            getGridRowCount: (panelInfo) => {
                const rows = GridData(panelInfo);
                return Array.isArray(rows) ? rows.length : 0;
            },
            getColumnInfo: () => columninfo,
            getColumns: () => columns,
            getKakouType: () => kakouType,
            // 副資材(114-117)/品質表示(119-123)の表示グリッドは、アイテム/グループ切替のたびに
            // インスタンスごと再生成する(renderKeyに「dataRefを最後に構築したcontext」を含める)。
            // 使い回しインスタンスへの書き換えはAPI準備待ち・保留反映のタイミング次第で
            // 反映漏れを起こすため、切替時は新規マウントで dataRef から初期化させる。
            // 選択stateではなく構築記録を使うことで、再マウントは必ず新データ構築後に発生する。
            itemGroupContextRenderKey: (panelInfo) => {
                const type = canonicalPanelType(DicVal(panelInfo, "type", ""));
                return DicVal(fukushizaiGridRenderContextKeyRef.current, type, "");
            }
        };
    }
    const sectionRenderModelResolver = createSectionRenderModelResolver(buildSectionRenderModelResolverDeps());

    // セクション操作描画へ渡す依存関係をまとめます。
    function buildSectionActionRendererDeps() {
        return {
            fnc,
            isEmpty,
            DicVal,
            uiActionBusy,
            orderHistoryDefs,
            orderHistoryData,
            selectedOrderHistoryDenpyoMap,
            setSelectedOrderHistoryDenpyoMap,
            buildOrderHistoryOptionRows,
            normalizeKakousijiUiString,
            resolveOrderHistoryAction,
            resolveOrderActionBySectionId,
            openOrderHistoryButton,
            openHistorySlip,
            openTemporaryOrderTab,
            getSectionBulkInputValue,
            setSectionBulkInputValue,
            getBulkShikyuKbnOptions,
            loadBulkShikyuKbnOptions,
            runDetailAction,
            runGroupAction,
            runHeaderAction,
            DETAIL_COPY_MODE,
            UI_ACTION,
            selectedSetItem,
            setSelectedSetItem,
            selectedGroup,
            setSelectedGroup,
            selectedQualityItem,
            setSelectedQualityItem,
            selectedQualityGroup,
            setSelectedQualityGroup,
            selectedQualityContextRef,
            refreshQualityContextSelection,
            copyItem,
            setCopyItem,
            copyGroup,
            setCopyGroup,
            qualityCopyItem,
            setQualityCopyItem,
            qualityCopyGroup,
            setQualityCopyGroup,
            qualityCopyContextTouchedRef,
            setItemOptions,
            groupOptions,
            fukushizaiItemMasterOptions,
            selectedFukushizaiContextRef,
            fukushizaiGroupClearedByUserRef,
            copyContextTouchedRef,
            isFukushizaiCopyPreviewing,
            normalizeFukushizaiContext,
            normalizeGroupNo,
            groupNoToLabel,
            formatNamedOptionLabel,
            getNamedOptionCode,
            getNamedOptionName,
            getKnownFukushizaiGroupNos,
            getKnownQualityGroupNos,
            getFukushizaiColorOptions,
            getQualityColorOptions,
            getQualityItemTabOptions,
            getFukushizaiItemTabOptions,
            runItemTabAction,
            itemTabDialogState,
            closeItemTabActionDialog,
            updateItemTabDialogChecked,
            commitItemTabActionDialog,
            commitFukushizaiActiveContextBeforeLeave: (...args) => commitFukushizaiActiveContextBeforeLeave(...args),
            refreshFukushizaiContextSelection,
            scheduleFukushizaiSectionGridRepaint,
            applyFukushizaiGroupCopyNow,
            applyQualityGroupCopyNow,
            groupDialogState,
            setGroupDialogState,
            closeGroupActionDialog,
            updateGroupDialogColorChecked,
            commitGroupActionDialog,
            pendingOrderLaunches,
            setPendingOrderLaunches,
            pendingOrderLaunchLabel,
            openPendingOrderLaunch,
            sangenDialogState,
            openSangenDisplayDialog
        };
    }

    // セクション上部操作とダイアログ描画は専用 renderer へ委譲します。
    const {
        renderActionArea,
        renderItemGroupTabBar,
        renderSectionHeaderAction,
        renderGroupActionDialog,
        renderItemTabActionDialog,
        renderPendingOrderLaunchDialog
    } = createSectionActionRenderer(buildSectionActionRendererDeps());

    // 原価ヘッダ描画へ渡す依存関係をまとめます。
    function buildGenkaHeaderRendererDeps() {
        return {
            PANEL_TYPE,
            entrydataRef,
            genkaPattern,
            genkaCurrency,
            genkaCurrencyOptions,
            isEmpty,
            DicVal,
            layoutDisplayName,
            genkaPatternLabelByNo,
            deriveGenkaPatternFromEntry,
            findGenkaCurrencyLayoutMeta,
            isGenkaCurrencyEditableByLayout,
            shouldForceGenkaCurrencyJpy,
            resolveGenkaCurrencyFromEntry,
            genkaCurrencyDisplayLabel,
            handleGenkaCurrencyChanged
        };
    }

    // 原価ヘッダ描画は専用 renderer へ委譲します。
    const {
        renderGenkaHeader
    } = createGenkaHeaderRenderer(buildGenkaHeaderRendererDeps());

    // 受注数/納品予定ヘッダ描画へ渡す依存関係をまとめます。
    function buildDemandHeaderRendererDeps() {
        return {
            PANEL_TYPE,
            entrydataRef,
            findEntryValue,
            resolveDemandHeaderFallbackValue
        };
    }

    // 受注数/納品予定ヘッダ描画は専用 renderer へ委譲します。
    const {
        renderDemandHeader
    } = createDemandHeaderRenderer(buildDemandHeaderRendererDeps());

    // 受注数・納品予定グリッド補助は専用 service へ委譲します。
    function buildDemandGridSupportServiceDeps() {
        return {
            JUTYU_SUMMARY_COL_ID,
            NOUHIN_SUMMARY_COL_ID,
            isEmpty,
            DicVal,
            parseBoolLike,
            normalizeKakousijiUiString,
            normalizeColumnIdUpper,
            normalizeColumnIdSuffix,
            readRowValueIgnoreCase,
            isDemandPanelInfo
        };
    }

    const {
        isGridAuxColId,
        isDemandSummaryRowKind,
        isDemandCellEditableByLayout,
        demandJutyuDisplayFieldId,
        normalizeDemandJutyuDisplayRows,
        isDemandUiOnlyColumnId,
        resolveDemandCellStyle,
        fitDemandColumns
    } = createDemandGridSupportService(buildDemandGridSupportServiceDeps());

    // 受注数/納品予定の列構築へ渡す依存関係をまとめます。
    function buildDemandGridColumnBuilderDeps() {
        return {
            griddataRefs,
            entrydataRef,
            isEmpty,
            isEnabled,
            DicVal,
            resolveGridIndex,
            ensureGridRefArray,
            findEntryValue,
            normalizeColumnIdUpper,
            normalizeColumnIdSuffix,
            normalizeLabelKey,
            isGridAuxColId,
            resolveTypeColumnIdBySuffix,
            resolveTypeColumnIdByName,
            demandTypeKeyByPanel,
            demandJutyuDisplayFieldId,
            isDemandCellEditableByLayout,
            resolveDemandCellStyle,
            NOUHIN_SUMMARY_COL_ID
        };
    }

    // 受注数/納品予定の列定義は専用 builder へ委譲します。
    const {
        buildNouhinHeaderColumns,
        buildDemandColumns
    } = createDemandGridColumnBuilder(buildDemandGridColumnBuilderDeps());

    // 原価サマリグリッドの表示・列定義へ渡す依存関係をまとめます。
    function buildGenkaSummaryGridServiceDeps() {
        return {
            PANEL_TYPE,
            entrydataRef,
            ensureTotalDataRef,
            isEmpty,
            DicVal,
            findColumnInfoByCandidates,
            genkaTradeConditionColInfo,
            genkaSummaryColInfoByField,
            getGenkaTradeConditionDataId: () => GENKA_TRADE_CONDITION_DATAID,
            currentGenkaPatternNo,
            resolveGenkaSummaryItem,
            resolveGenkaSummaryLabel,
            getGenkaSummaryOrder: () => genkaSummaryOrder,
            emptyGenkaSummaryRow,
            getGenkaSummaryGridDisplayValue,
            setGenkaSummaryGridValue,
            formatGenkaSummaryDisplayValue,
            isGenkaOverseasEntry,
            normalizeColumnIdUpper,
            normalizeSearchParamObject
        };
    }

    // 原価サマリグリッド固有の処理は専用 service へ委譲します。
    const {
        defaultGenkaSummaryRows,
        genkaSummaryFixedHeight,
        normalizeGenkaSummaryRows,
        buildGenkaTotalGridColumns,
        buildTotalGridColumns
    } = createGenkaSummaryGridService(buildGenkaSummaryGridServiceDeps());

    // Grid のマスタ検索条件補正へ渡す依存関係をまとめます。
    // 対象行が属するグループの副資材仕入先(SSDZ_TORCODE)を返します。
    //
    // 副資材の仕入先はアイテム＋グループごとに異なるため、行の所属コンテキストで 113 明細を引きます。
    // 行から所属を特定できない場合は、現在選択中のコンテキストが投影されている単票値へフォールバックします。
    function resolveFukushizaiSupplierCodeForRow(row) {
        const readSupplier = (source) => extractMasterCodeFromDisplayValue(
            normalizeKakousijiUiString(
                readRowValueIgnoreCase(source, "SSDZ_TORCODE_cd")
                || readRowValueIgnoreCase(source, "SSDZ_TORCODE")
            )
        );
        const context = readFukushizaiItemGroupFromAnyRow(row);
        if (context.hasItemGroupKey === true && context.itemCd !== "" && context.groupNo !== "") {
            const fukushizaiRows = getDetailRowsByPanelType(entrydetailRef.current, FUKUSHIZAI_BASE_PANEL_TYPE);
            const matched = (Array.isArray(fukushizaiRows) ? fukushizaiRows : [])
                .filter((item) => !isEmpty(item) && rowMatchesFukushizaiItemGroup(item, context.itemCd, context.groupNo))
                .map((item) => readSupplier(item))
                .find((code) => code !== "");
            if (!isEmpty(matched) && matched !== "") return matched;
        }
        return readSupplier(entrydataRef.current);
    }
    function buildGridMasterSearchServiceDeps() {
        return {
            entrydataRef,
            isEmpty,
            DicVal,
            normalizeKakousijiUiString,
            readRowValueIgnoreCase,
            getFukushizaiColumnInfoById,
            isSijisuPdtcMasterColumn,
            applySijisuPdtcMasterSearchParamToColInfo,
            isDemeritPanelInfo,
            isBrandNamePanelInfo,
            resolveFukushizaiSupplierCodeForRow,
            DEMERIT_NAME_DMY,
            DEMERIT_HUDA_DMY
        };
    }

    // Grid のマスタ検索条件補正は専用 service へ委譲します。
    const {
        buildDemeritMasterSearchParam,
        handlePanelGridCellClicked
    } = createGridMasterSearchService(buildGridMasterSearchServiceDeps());

    // 114/115/116/117 の表示専用メタ行 helper へ渡す依存関係をまとめます。
    function buildFukushizaiDisplayMetaServiceDeps() {
        return {
            PANEL_TYPE,
            KOMONOFUDA_SIZE_RATE_FIELD_IDS,
            isEmpty,
            DicVal,
            canonicalPanelType,
            brandNameSourceColumnId,
            otherNameSourceColumnId,
            otherFukuzaiSourceColumnId,
            readFukushizaiMasterCodeNameFromValue
        };
    }

    // 表示専用メタ行 helper は専用 service へ委譲します。
    const {
        setFukushizaiDisplayMeta,
        readFukushizaiDisplayBaseRowId,
        readFukushizaiDisplayExplicitBaseRowId,
        readFukushizaiDisplaySourceColumnId,
        extractMasterCodeFromDisplayValue,
        extractMasterNameFromDisplayValue,
        getFukushizaiDisplayFieldIdByPanelType,
        getFukushizaiDisplayRowIndex,
        getFukushizaiDisplaySourceColumnIdByIndex,
        resolveFukushizaiDisplaySourceColumnId,
        readFukushizaiDisplaySaveCode,
        readFirstFukushizaiDisplayText,
        extractFukushizaiDisplayCodeName
    } = createFukushizaiDisplayMetaService(buildFukushizaiDisplayMetaServiceDeps());

    // デメリットパネル固有の表示・保存補助へ渡す依存関係をまとめます。
    function buildDemeritPanelServiceDeps() {
        return {
            PANEL_TYPE,
            CELLTYPE,
            DEMERIT_KIND_OPTIONS,
            DEMERIT_KIND_FIELD,
            DEMERIT_KIND_NAME,
            DEMERIT_KIND_HUDA,
            DEMERIT_NAME_FLG,
            DEMERIT_HUDA_FLG,
            DEMERIT_DMT_CD,
            DEMERIT_NAME_DMY,
            DEMERIT_HUDA_DMY,
            DEMERIT_UI_FIELDS,
            DEMERIT_HIDDEN_DB_FIELDS,
            isEmpty,
            DicVal,
            parseBoolLike,
            normalizeColumnIdUpper,
            extractMasterCodeFromDisplayValue,
            buildDemeritMasterSearchParam,
            getFukushizaiColumnInfoById,
            entrydataRef
        };
    }

    // デメリットパネル固有の処理は専用 service へ委譲します。
    const {
        resolveDemeritKind,
        normalizeDemeritRows,
        applyDemeritKindToRow,
        syncDemeritDmtCd,
        normalizeDemeritRowForSave,
        buildDemeritGridColumns
    } = createDemeritPanelService(buildDemeritPanelServiceDeps());

    // 固定縦持ち表示 panel へ渡す依存関係をまとめます。
    function buildFixedVerticalDisplayServiceDeps() {
        return {
            PANEL_TYPE,
            columninfo,
            selectedFukushizaiContextRef,
            isEmpty,
            DicVal,
            canonicalPanelType,
            normalizeSearchParamObject,
            normalizeFukushizaiContext,
            normalizeItemCd,
            normalizeGroupNo,
            normalizeColorCd,
            resolveFukushizaiDisplayMasterValue,
            setFukushizaiDisplayMeta,
            isKomonofudaPanelInfo
        };
    }

    // 固定縦持ち表示 panel の列定義と表示行生成は専用 service へ委譲します。
    const {
        buildBrandNameDisplayColInfo,
        buildOtherNameDisplayColInfo,
        buildOtherFukuzaiDisplayColInfo,
        buildBrandNameGridColumns,
        isFixedVerticalDisplayPanelInfo,
        normalizeFixedVerticalDisplayRows,
        buildBrandNameDisplayRows,
        buildOtherNameDisplayRows,
        buildOtherFukuzaiDisplayRows
    } = createFixedVerticalDisplayService(buildFixedVerticalDisplayServiceDeps());

    // datatype=6(MASTER) の名称補完へ渡す依存関係をまとめます。
    function buildMasterNameHydratorServiceDeps() {
        return {
            CELLTYPE,
            fnc,
            entrydataRef,
            masterNameHydrationPendingRef,
            isEmpty,
            DicVal,
            normalizeColumnIdUpper,
            normalizeKakousijiUiString,
            readRowValueIgnoreCase,
            extractMasterCodeFromDisplayValue,
            extractMasterNameFromDisplayValue,
            resolvePanelMasterColumnDefs: resolvePanelMasterColumnDefsForHydration,
            getGridRows: (panelInfo) => GridData(panelInfo),
            setGridRows: (panelInfo, rows) => SetGridData(panelInfo, rows),
            isGridReady: (panelInfo) => !isEmpty(GridApi(panelInfo)) && isGridDomReady(panelInfo),
            applyGridRowsNow,
            getGridList: () => gridlist
        };
    }

    // datatype=6 の名称補完は横断 service へ委譲します。
    const {
        hydrateRowsForDisplay,
        hydratePanelRowsAsync,
        hydrateAllGridRowsAsync
    } = createMasterNameHydratorService(buildMasterNameHydratorServiceDeps());

    // 114/115/116/117 の表示行マージ・明細照合 helper へ渡す依存関係をまとめます。
    function buildFukushizaiDisplayRowMergeServiceDeps() {
        return {
            isEmpty,
            DicVal,
            canonicalPanelType,
            normalizeGroupNo,
            readRowValueIgnoreCase,
            normalizeFixedVerticalDisplayRows,
            readFukushizaiDisplayBaseRowId,
            readFukushizaiDisplayExplicitBaseRowId,
            readFukushizaiDisplaySourceColumnId,
            debugFukushizaiSyncLog
        };
    }

    // 表示行イベントのマージと副資材明細の行照合は専用 service へ委譲します。
    const {
        mergeFukushizaiEventRowIntoRows,
        restoreFukushizaiDisplayMetaFromCurrentRows,
        readFukushizaiEventRow,
        normalizeFukushizaiDetailMatchInfo,
        findFukushizaiDetailRowIndexByMatchInfo,
        findFukushizaiDetailExactRowIndexByMatchInfo
    } = createFukushizaiDisplayRowMergeService(buildFukushizaiDisplayRowMergeServiceDeps());

    // 副資材の dirty 状態管理へ渡す依存関係をまとめます。
    function buildFukushizaiDirtyStateServiceDeps() {
        return {
            selectedFukushizaiContextRef,
            selectedQualityContextRef,
            isQualityPanelType,
            fukushizaiDirtyPanelRef,
            fukushizaiBaseDirtyRef,
            fukushizaiDetailSyncingRef,
            entryLoadingRef,
            isEmpty,
            isEnabled,
            DicVal,
            canonicalPanelType,
            normalizeFukushizaiContext,
            isSameFukushizaiItemGroupContext,
            createEmptyFukushizaiContext,
            isFukushizaiBaseField
        };
    }

    // 副資材の dirty 状態管理は専用 service へ委譲します。
    const {
        buildFukushizaiDirtyKey,
        markFukushizaiDirtyPanel,
        clearFukushizaiDirtyPanel,
        isFukushizaiDirtyPanel,
        readFukushizaiBaseDirtyState,
        hasFukushizaiBaseDirty,
        markFukushizaiBaseDirtyField,
        clearFukushizaiBaseDirtyFields
    } = createFukushizaiDirtyStateService(buildFukushizaiDirtyStateServiceDeps());

    // 副資材の投影 context 操作へ渡す依存関係をまとめます。
    function buildFukushizaiProjectionContextServiceDeps() {
        return {
            entrydataRef,
            selectedFukushizaiContextRef,
            selectedQualityContextRef,
            fukushizaiProjectionGuardRef,
            fukushizaiProjectionGuardTimerRef,
            QUALITY_ROOT_DATA_PREFIXES,
            isEmpty,
            DicVal,
            normalizeFukushizaiContext,
            createEmptyFukushizaiContext,
            getFukushizaiAllFieldIds,
            // quality 側 helper は後続で初期化されるため実行時に解決します。
            clearQualityBaseMergedFields: (entryObj) => clearQualityBaseMergedFields(entryObj),
            logEntryVisualTrace
        };
    }

    // 副資材の投影 context 操作は専用 service へ委譲します。
    const {
        clearFukushizaiMergedFields,
        setFukushizaiEntryProjectionContext,
        getFukushizaiEntryProjectionContext,
        resolveFukushizaiBaseEditContext,
        setQualityEntryProjectionContext,
        getQualityEntryProjectionContext,
        resolveQualityBaseEditContext,
        clearFukushizaiDisplayProjectionFields,
        activateFukushizaiProjectionGuard
    } = createFukushizaiProjectionContextService(buildFukushizaiProjectionContextServiceDeps());

    // 副資材の代表行選定と entry 投影へ渡す依存関係をまとめます。
    function buildFukushizaiRepresentativeProjectionServiceDeps() {
        return {
            selectedFukushizaiContextRef,
            fukushizaiRepresentativeRowRef,
            fukushizaiDetailSyncingRef,
            fukushizaiGroupClearedByUserRef,
            selectedSetItem,
            selectedGroup,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            isEmpty,
            isEnabled,
            DicVal,
            normalizeFukushizaiContext,
            createEmptyFukushizaiContext,
            normalizeGroupNo,
            readRowValueIgnoreCase,
            readFukushizaiContextFromRow,
            getItemCdFromRow,
            getColorCdFromRow,
            getGroupNoFromRow,
            sameItemGroupColor,
            resolveFukushizaiContext,
            hasCompleteFukushizaiContext,
            countTraceObjectKeys,
            getDetailRowsByPanelType,
            getFukushizaiAllFieldIds,
            updateSelectedFukushizaiContext,
            setSelectedSetItem,
            setSelectedGroup,
            runBatched,
            createTimingCollector,
            clearFukushizaiMergedFields,
            setFukushizaiEntryProjectionContext,
            activateFukushizaiProjectionGuard,
            // quality 側 helper は後続で初期化されるため実行時に解決します。
            // 品質表示は副資材と独立した選択のため、副資材側から渡されるcontextではなく
            // 常に品質側contextで投影する(グループずれ時の誤書き込み防止)。
            mergeQualityRepresentativeRowToEntry: (entryObj, detailData) => {
                return mergeQualityRepresentativeRowToEntry(entryObj, detailData, selectedQualityContextRef.current);
            },
            logEntryVisualTrace
        };
    }

    // 副資材の代表行選定と entry 投影は専用 service へ委譲します。
    const {
        createFukushizaiEmptyRow,
        findFukushizaiRepresentativeRowIndex,
        pickFukushizaiRepresentativeRow,
        resolveInitialFukushizaiContextFromDetailRows,
        mergeFukushizaiRepresentativeRowToEntry
    } = createFukushizaiRepresentativeProjectionService(buildFukushizaiRepresentativeProjectionServiceDeps());

    // 副資材明細の更新と同期完了処理へ渡す依存関係をまとめます。
    function buildFukushizaiDetailSyncServiceDeps() {
        return {
            entrydataRef,
            entrydetailRef,
            selectedFukushizaiContextRef,
            fukushizaiDetailSyncingRef,
            fukushizaiRepresentativeRowRef,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            pendingFukushizaiCopy,
            selectedSetItem,
            selectedGroup,
            isEmpty,
            isEnabled,
            DicVal,
            normalizeGroupNo,
            readRowValueIgnoreCase,
            normalizeFukushizaiContext,
            readFukushizaiContextFromRow,
            normalizeFukushizaiDetailMatchInfo,
            findFukushizaiDetailRowIndexByMatchInfo,
            findFukushizaiDetailExactRowIndexByMatchInfo,
            getDetailRowsByPanelType,
            pickFukushizaiRepresentativeRow,
            resolveFukushizaiLazyDetailColorNow: (context) => {
                return resolveFukushizaiLazyDetailColor(context);
            },
            createFukushizaiGroupDetailRow,
            isFukushizaiVerticalMasterSourceColumnId,
            clearFukushizaiMasterNameFields,
            extractMasterCodeFromDisplayValue,
            clearFukushizaiDisplayProjectionFields,
            updateSelectedFukushizaiContext,
            clearFukushizaiMergedFields,
            mergeFukushizaiRepresentativeRowToEntry,
            rerender,
            setSelectedSetItem,
            setSelectedGroup,
            debugFukushizaiSyncLog,
            refreshFukushizaiSectionViews: (itemCd, groupNo, previewOverride, context) => {
                fukushizaiProjection.refreshSectionViews(itemCd, groupNo, previewOverride, context);
            }
        };
    }

    // 副資材明細の更新と同期完了処理は専用 service へ委譲します。
    const {
        applyFukushizaiDetailRowUpdates,
        finishFukushizaiDetailSync,
        updateFukushizaiDetailRowValue
    } = createFukushizaiDetailSyncService(buildFukushizaiDetailSyncServiceDeps());

    // 副資材表示セルの detail 同期へ渡す依存関係をまとめます。
    function buildFukushizaiDisplaySyncServiceDeps() {
        return {
            entrydetailRef,
            selectedFukushizaiContextRef,
            fukushizaiRepresentativeRowRef,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            FUKUSHIZAI_CONTEXT_DISPLAY_PANEL_TYPES,
            isEmpty,
            isEnabled,
            DicVal,
            canonicalPanelType,
            normalizeColorCd,
            normalizeFukushizaiContext,
            readFukushizaiContextFromRow,
            resolveFukushizaiDisplaySourceColumnId,
            getDetailRowsByPanelType,
            readFukushizaiDisplayExplicitBaseRowId,
            createFukushizaiGroupDetailRow,
            ensureFukushizaiDetailRowsForMutation,
            sameItemGroupColor,
            fukushizaiColorCodesForContext,
            contextColorCodesFromRows,
            readFukushizaiMasterCodeNameFromValue,
            extractMasterCodeFromDisplayValue,
            getFukushizaiDisplayFieldIdByPanelType,
            clearFukushizaiMasterNameFields,
            formatFukushizaiMasterDisplayValue,
            clearFukushizaiDisplayProjectionFields,
            isFukushizaiVerticalMasterSourceColumnId,
            debugFukushizaiSyncLog
        };
    }

    // 副資材表示セルの detail 同期は専用 service へ委譲します。
    const {
        resolveFukushizaiDisplaySyncTarget,
        readFukushizaiDisplayRawValue,
        normalizeFukushizaiDisplaySaveValue,
        resolveFukushizaiDisplayTargetColors,
        syncFukushizaiDisplayCellToDetail,
        applyFukushizaiDisplayRowToDetail
    } = createFukushizaiDisplaySyncService(buildFukushizaiDisplaySyncServiceDeps());

    // 副資材表示グリッドの flush 処理へ渡す依存関係をまとめます。
    function buildFukushizaiDisplayFlushServiceDeps() {
        return {
            selectedFukushizaiContextRef,
            pendingFukushizaiCopy,
            selectedSetItem,
            selectedGroup,
            gridlist,
            FUKUSHIZAI_CONTEXT_DISPLAY_PANEL_TYPES,
            isEmpty,
            isEnabled,
            DicVal,
            canonicalPanelType,
            normalizeFukushizaiContext,
            readFukushizaiContextFromRow,
            normalizeFixedVerticalDisplayRows,
            restoreFukushizaiDisplayMetaFromCurrentRows,
            isFukushizaiDirtyPanel,
            clearFukushizaiDirtyPanel,
            readGridRowsPreferApi,
            applyFukushizaiDisplayRowToDetail,
            finishFukushizaiDetailSync,
            debugFukushizaiSyncLog,
            GridData,
            SetGridData
        };
    }

    // 副資材表示グリッドの flush 処理は専用 service へ委譲します。
    const {
        syncFukushizaiDisplayRowsToDetail,
        flushFukushizaiDisplayGridsToDetail
    } = createFukushizaiDisplayFlushService(buildFukushizaiDisplayFlushServiceDeps());

    // 小物札表示・ラベルキャッシュ補助へ渡す依存関係をまとめます。
    function buildKomonoFudaDisplayServiceDeps() {
        return {
            entrydataRef,
            entrydetailRef,
            selectedFukushizaiContextRef,
            pendingFukushizaiCopy,
            komonoFudaLabelCacheRef,
            komonoFudaLabelLoadingRef,
            KOMONOFUDA_SIZE_RATE_FIELD_IDS,
            gridlist,
            fnc,
            corpkey,
            account,
            komonoFudaLabelsUrl,
            isEmpty,
            isEnabled,
            DicVal,
            normalizeFukushizaiContext,
            setFukushizaiDisplayMeta,
            extractMasterCodeFromDisplayValue,
            readFukushizaiBaseMasterName,
            isKomonofudaPanelInfo,
            debugFukushizaiSyncLog,
            fukushizaiDetailSyncingRef,
            applyFukushizaiSectionPanelRows,
            GridData,
            SetGridData,
            GridApi,
            entryLoadingRef,
            isGridDomReady,
            applyFukushizaiDisplayRowsNow: (panelInfo, rows) => {
                fukushizaiProjection.applyDisplayRowsNow(panelInfo, rows);
            }
        };
    }

    // 小物札(114) の表示生成とラベルキャッシュ補助は専用 service へ委譲します。
    const {
        isKomonofudaUiOnlyField,
        normalizeKomonoFudaLabelRows,
        normalizeKomonoFudaLabelResponse,
        readKomonoFudaBrandCode,
        buildKomonoFudaLabelCacheKey,
        getKomonoFudaLabelCache,
        isCurrentKomonoFudaLabelRequest,
        requestKomonoFudaLabelsForRow,
        requestKomonoFudaLabels,
        findKomonoFudaPanelInfo,
        refreshKomonoFudaDisplayPanelOnly,
        clearKomonoFudaDisplayGridContents,
        buildKomonoFudaDisplayRows
    } = createKomonoFudaDisplayService(buildKomonoFudaDisplayServiceDeps());

    // 副資材BASE入力の dirty/detail 同期へ渡す依存関係をまとめます。
    function buildFukushizaiBaseSyncServiceDeps() {
        return {
            entrydataRef,
            entrydetailRef,
            fnc,
            entryLoadingRef,
            fukushizaiBaseDirtyRef,
            fukushizaiDetailSyncingRef,
            fukushizaiProjectionGuardRef,
            fukushizaiRepresentativeRowRef,
            fukushizaiMasterNameCacheRef,
            fukushizaiMasterNameLoadingRef,
            selectedFukushizaiContextRef,
            pendingFukushizaiCopy,
            selectedSetItem,
            selectedGroup,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            KOMONOFUDA_SIZE_RATE_FIELD_IDS,
            isEmpty,
            isEnabled,
            DicVal,
            normalizeFukushizaiContext,
            normalizeItemCd,
            normalizeGroupNo,
            normalizeColorCd,
            isSameFukushizaiItemGroupContext,
            extractMasterCodeFromDisplayValue,
            formatFukushizaiMasterDisplayValue,
            getDetailRowsByPanelType,
            getFukushizaiBaseFieldIds,
            getFukushizaiMasterFieldMeta,
            getFukushizaiEntryProjectionContext,
            pickFirstFukushizaiText,
            pickFukushizaiRepresentativeRow,
            readFukushizaiMasterCodeNameFromValue,
            readFukushizaiMasterNameFromStore,
            readFukushizaiContextFromRow,
            readRowValueIgnoreCase,
            registeredColorCodesForContext,
            fukushizaiColorCodesForContext,
            buildFukushizaiMasterValueUpdates,
            buildFukushizaiDebugGroupSnapshot,
            buildKomonoFudaLabelCacheKey,
            resolveFukushizaiBaseEditContext,
            resolveFukushizaiContext,
            resolveFukushizaiDisplayTargetColors,
            ensureDetailRowsByTypeForMutation,
            clearFukushizaiDisplayProjectionFields,
            primeFukushizaiMasterNameCache,
            primeFukushizaiMasterStoreFromRows,
            isFukushizaiBaseField,
            isFukushizaiBaseMasterField,
            applyFukushizaiDetailRowUpdates,
            finishFukushizaiDetailSync,
            createFukushizaiGroupDetailRow,
            requestKomonoFudaLabels,
            refreshKomonoFudaDisplayPanelOnly,
            clearKomonoFudaDisplayGridContents,
            readFukushizaiBaseDirtyState,
            clearFukushizaiBaseDirtyFields,
            logFukushizaiBaseSyncFlat,
            logFukushizaiMasterNameResolveFlat,
            debugFukushizaiSyncLog,
            rerender,
            refreshFukushizaiSectionViews
        };
    }

    // 副資材BASE入力から detail/表示へ反映する流れは専用 service へ委譲します。
    const {
        syncFukushizaiDetailRowsFromEntryData,
        normalizeFukushizaiBaseMasterCodeName,
        hasNonEmptyFukushizaiBaseUpdate,
        resolveFukushizaiLazyDetailColor,
        createFukushizaiLazyDetailRowForBaseUpdate,
        applyFukushizaiBaseUpdatesToCurrentContext,
        syncFukushizaiBaseDirtyFieldsToDetail,
        applyResolvedFukushizaiMasterName,
        requestFukushizaiMasterName,
        syncFukushizaiBaseFieldValueToDetail
    } = createFukushizaiBaseSyncService(buildFukushizaiBaseSyncServiceDeps());

    // Kakousiji 専用の検索 URL 切替へ渡す依存関係をまとめます。
    function buildMasterSearchRoutingServiceDeps() {
        return {
            dispatch,
            setchangeurl,
            changeurl,
            KAKOUSIJI_SEARCH_MASTER_CHANGE_URL,
            kakousijiSearchMasterChangeUrlBackupRef,
            kakousijiSearchMasterRoutingActiveRef
        };
    }

    // Kakousiji 専用の検索 URL 切替は service へ委譲します。
    const {
        ensureKakousijiSearchMasterChangeUrl,
        restoreKakousijiSearchMasterChangeUrl
    } = createMasterSearchRoutingService(buildMasterSearchRoutingServiceDeps());

    // 洗濯表示パネルの保存・表示補助へ渡す依存関係をまとめます。
    function buildWashPanelServiceDeps() {
        return {
            fnc,
            isEmpty,
            isEnabled,
            DeepCopy,
            CELLTYPE,
            DicVal,
            GridData,
            SetGridData,
            GridApi,
            entrydataRef,
            entrydetailRef,
            normalizeKakousijiUiString,
            findColumnInfoByCandidates,
            normalizeFukushizaiContext,
            normalizeColorCd,
            readRowValueIgnoreCase,
            readFukushizaiItemGroupFromAnyRow,
            rowMatchesFukushizaiItemGroup,
            WASH_PANEL_SECTION_IDS,
            WASH_STP_SEARCH_CHANGE_URL,
            dispatch,
            setchangeurl,
            changeurl,
            washStpSearchChangeUrlBackupRef,
            washStpSearchRoutingActiveRef,
            washlists: [washlist1, washlist2, washlist3, washlist4, washlist5, washlist6, washlist7],
            ensureDetailRowsByTypeForMutation,
            qualityTargetColorsForContext,
            readQualityDisplayTargetColors: (row) => readQualityDisplayTargetColors(row),
            nextDetailRowIdForRows,
            stripQualityDisplayMetaFields: (row) => stripQualityDisplayMetaFields(row),
            isInvalidDisplayRow: (...args) => isInvalidDisplayRow(...args),
            setRowContextForPanel,
            applyGridRowsNow,
            ROW_ID_FIELD,
            WASH_PANEL_TYPE: PANEL_TYPE.WASH,
            WASH_STP_CODE_FIELD,
            WASH_STP_CODE_DISPLAY_FIELDS,
            WASH_STP_SEARCH_DATAID,
            WASH_STP_SENTAKU_FIELDS,
            isGridDomReady,
            selectedQualityContextRef,
            scheduleGridDataRerender: (panelInfo) => {
                gridRefreshCoordinator.scheduleGridDataRerender(panelInfo);
            },
            rerender,
            entrylock,
            layoutlock
        };
    }

    // 洗濯表示パネル固有の処理は専用 service へ委譲します。
    const {
        toWashSaveRows,
        applyWashMarkDisplayFields,
        normalizeWashRowsForDisplay,
        defaultWashRows,
        restoreWashStpSearchChangeUrl,
        applyWashStpRows,
        buildWashGridFunctionRef
    } = createWashPanelService(buildWashPanelServiceDeps());

    // パネル本体描画へ渡す依存関係をまとめます。
    function buildPanelContentRendererDeps() {
        return {
            G_id,
            PANEL_TYPE,
            FUKUSHIZAI_BASE_PANEL_TYPE,
            fnc,
            controller,
            edittingcode,
            isEmpty,
            isEnabled,
            DicVal,
            textfields,
            settextfields,
            entrydataRef,
            EntrybodyRef,
            layoutlock,
            imageRef,
            fileRef,
            columninfo,
            rerender,
            ValueChanged,
            onFirstDataRendered,
            handleGridValueChanged,
            storeRowData,
            ensureGridDataRef,
            ensureGridColRef,
            buildEntryGridProps,
            buildWashGridFunctionRef,
            gridRenderKey,
            demandGridFixedHeight,
            sijisuGridFixedHeight,
            genkaGridFixedHeight,
            basicGridFixedHeight,
            isWashPanelInfo,
            isDemandPanelInfo,
            isColorwayPanel,
            handlePanelGridCellClicked,
            sustainableDisplayTextFields,
            isFukushizaiCopyPreviewing,
            fukushizaiPreviewEntryDataRef,
            buildFukushizaiPreviewEntryDataForBase,
            pendingFukushizaiCopy
        };
    }

    // パネル本体描画の切り替えは専用 renderer へ委譲します。
    const {
        renderPanelContents
    } = createPanelContentRenderer(buildPanelContentRendererDeps());

    // 合計グリッド反映は専用 service へ委譲します。
    function buildTotalGridServiceDeps() {
        return {
            PANEL_TYPE,
            SIJISU_TOTAL_COL_ID,
            isEmpty,
            DicVal,
            normalizeTypeKey,
            measureTimedLoop,
            panel,
            GridData,
            entrydataRef,
            currentNormalSectionDefs,
            currentSampleSectionDefs,
            allCurrentSectionDefs,
            resolveSectionIdByGridPanel,
            resolveGridSectionPanel,
            resolveTotalHostPanel,
            sectionTotalType,
            normalizeTotalTypeForColumns,
            buildTotalPanel,
            getDetailRowsByPanelType,
            pickTotalRows,
            buildGenkaSummaryRowsFromFlatData,
            normalizeGenkaSummaryRows,
            ensureTotalDataRef,
            TotalGridApi,
            SetTotalGridApi,
            setGridRowsByApi,
            hideGridAuxColumns,
            suppressTotalValueChangedRef,
            canonicalPanelType
        };
    }

    const {
        applyTotalRowsNow,
        onFirstTotalDataRendered,
        recalcSijisuTotalRows,
        recalcSampleTotalRows,
        applyTotalRowsByPanelDefinition,
        applyTotalRowsBySectionDefinition
    } = createTotalGridService(buildTotalGridServiceDeps());

    // セクションカード本体描画へ渡す依存関係をまとめます。
    function buildSectionLayoutRendererDeps() {
        return {
            PANEL_TYPE,
            fnc,
            formid,
            isEmpty,
            isEnabled,
            DicVal,
            columns,
            columninfo,
            entrydataRef,
            EntrybodyRef,
            ensureTotalDataRef,
            ensureTotalColRef,
            onFirstTotalDataRendered,
            storeTotalRowData,
            buildTotalGridColumns,
            buildTotalPanel,
            totalTitle,
            totalContainerStyle,
            normalizeGenkaSummaryRows,
            genkaSummaryFixedHeight,
            resolveSectionPanel,
            resolveRemarksSectionPanel,
            resolveGridSectionPanel,
            sectionTotalType,
            sectionGridRowStyle,
            sectionRenderModelResolver,
            resolveGridIndex,
            EmptyPanel,
            Contents: renderPanelContents,
            renderActionArea,
            renderSustainableImagePanel,
            renderGenkaHeader,
            renderDemandHeader,
            buildDemandColumns,
            buildNouhinHeaderColumns,
            buildGenkaFixedColumns,
            buildBrandNameGridColumns,
            buildDemeritGridColumns,
            colorwayDetailParams,
            toStableAutoHeightPanel,
            genkaGridFixedHeight,
            isDemandSectionId,
            collapsedSections,
            sectionclose,
            sectionRefs,
            setCollapsedSections,
            renderSectionHeaderAction
        };
    }

    // セクションカード全体の JSX 組み立ては layout renderer へ委譲します。
    const {
        renderTotalGrid,
        renderSectionBody,
        renderSection
    } = createSectionLayoutRenderer(buildSectionLayoutRendererDeps());

    // 全グリッドへ明細行を反映する。
    function applyDetailRowsToGrids(detailData) {
        primeFukushizaiMasterStoreFromRow(entrydataRef.current);
        primeFukushizaiMasterStoreFromRows(getDetailRowsByPanelType(detailData, "113"));
        measureTimedLoop(
            gridlist,
            (panelInfo, index) => {
                const sectionId = resolveSectionIdByGridPanel(panelInfo);
                const panelType = canonicalPanelType(DicVal(panelInfo, "type", ""));
                const panelId = String(DicVal(panelInfo, "id", index));
                return `${sectionId || panelId}:${panelType}`;
            },
              (panelInfo) => {
                  try {
                      const nextRows = normalizeDetailRowsForPanel(panelInfo, detailData);
                      SetGridData(panelInfo, nextRows);
                      if (isFukushizaiDetailPanelInfo(panelInfo) && isFukushizaiBaseDisplaySection()) {
                          gridRefreshCoordinator.clearPendingGridApply(panelInfo);
                          return;
                      }
                      const hasRows = Array.isArray(nextRows) && nextRows.length !== 0;
                      const apiReady = !isEmpty(GridApi(panelInfo)) && isGridDomReady(panelInfo);
                      if (!apiReady) {
                          if (hasRows) {
                              gridRefreshCoordinator.markPendingGridApply(panelInfo);
                              gridRefreshCoordinator.scheduleGridDataRerender(panelInfo);
                          } else {
                              gridRefreshCoordinator.clearPendingGridApply(panelInfo);
                          }
                      } else {
                          gridRefreshCoordinator.clearPendingGridApply(panelInfo);
                          applyGridRowsNow(panelInfo, nextRows);
                      }
                  } catch (e) {
                      // 1つのパネル失敗で他パネルの反映まで止めない。
                      console.error("[Kakousiji][applyDetailRowsToGrids]", {
                          panelId: String(DicVal(panelInfo, "id", "")),
                          panelType: String(DicVal(panelInfo, "type", "")),
                          sectionId: resolveSectionIdByGridPanel(panelInfo)
                      }, e);
                      try {
                          gridRefreshCoordinator.clearPendingGridApply(panelInfo);
                      } catch (_ignore) {
                      }
                  }
              },
            "applyDetailRowsToGrids"
        );
    }

    // ---------------------------------------------------------------------
    // 受注数・納品予定Grid補助
    // ---------------------------------------------------------------------
    // 集計行、表示用列、編集可否の判定をまとめる。
    // 受注納品の左端補助列（rowNumbers/grip）が再描画で復活するため、複数回強制で非表示にする。
    function enforceDemandLeftColumns(panelInfo, api) {
        try {
            if (isEmpty(panelInfo) || isEmpty(api)) return;
            if (!isDemandPanelInfo(panelInfo)) return;
            const apply = () => {
                try {
                    hideGridAuxColumns(api);
                } catch (e) { console.error(e); }
            };
            apply();
            if (typeof requestAnimationFrame === "function") {
                requestAnimationFrame(() => apply());
            }
        } catch (e) { console.error(e); }
    }






    // Show実行に必要な最小準備ができているか判定する。
    function canExecuteShow() {
        if (!tabsReady) return false;
        if (isEmpty(columninfo) || !Array.isArray(columninfo) || columninfo.length === 0) return false;
        if (isEmpty(gridlist) || !Array.isArray(gridlist) || gridlist.length === 0) return false;
        return true;
    }

    // 明細グリッドのデータを保存する。























    // 原価パターン変更時に、原価グリッドの編集可否/色を即時反映する。
    function refreshGenkaGridEditableState(panelInfo = null, options = {}) {
        try {
            if (isEmpty(gridlist) || gridlist.length === 0) return;
            const p = !isEmpty(panelInfo) ? panelInfo : gridlist.find(g => isGenkaGridPanelInfo(g));
            const source = String(DicVal(options, "source", ""));
            if (isEmpty(p)) {
                gridRefreshCoordinator.schedulePendingGenkaEditableRefresh(source !== "" ? source : "noPanel");
                return false;
            }
            const api = GridApi(p);
            const domReady = isGridDomReady(p);
            if (isEmpty(api) || !domReady) {
                gridRefreshCoordinator.schedulePendingGenkaEditableRefresh(source !== "" ? source : "apiNotReady");
                return false;
            }
            // editable/cellStyle の関数クロージャを最新化するため、列定義を再適用
            const defs = (typeof api.getColumnDefs === "function") ? api.getColumnDefs() : null;
            let applyMethod = "";
            if (Array.isArray(defs) && defs.length !== 0) {
                const nextDefs = buildGenkaFixedColumns(DeepCopy(defs), "genka");
                if (typeof api.setGridOption === "function") {
                    api.setGridOption("columnDefs", nextDefs);
                    applyMethod = "setGridOption";
                } else if (typeof api.setColumnDefs === "function") {
                    api.setColumnDefs(nextDefs);
                    applyMethod = "setColumnDefs";
                }
            }
            if (typeof api.refreshCells === "function") {
                api.refreshCells({ force: true });
            }
            if (typeof api.redrawRows === "function") {
                api.redrawRows();
            }
            if (typeof api.refreshHeader === "function") {
                api.refreshHeader();
            }
            return true;
        } catch (e) { console.error(e); }
        return false;
    }
    function refreshGenkaGridView() {
        try {
            if (isEmpty(gridlist) || gridlist.length === 0) return;
            const p = gridlist.find(g => isGenkaGridPanelInfo(g));
            if (isEmpty(p)) return;
            // パターン変更時はセル式優先で再計算して表示へ反映する。
            recalcGenkaGridAndSummary(p);
            refreshGenkaGridEditableState(p);
        } catch (e) { console.error(e); }
    }
    function requestGenkaGridEditableRefresh() {
        setGenkaGridRefreshToken((prev) => prev + 1);
    }

    // =====================================================================
    // 共通処理
    // ---------------------------------------------------------------------
    // 表示更新、入力補助、保存前同期で共通利用する処理をまとめる。
    // Grid表示と保存用データが密結合しているため、参照順序を崩さない。
    // =====================================================================

    // ---------------------------------------------------------------------
    // 表示制御・再描画ユーティリティ
    // ---------------------------------------------------------------------
    // 画面を再描画する。

    function rerender() {
        setUpdata((prev) => !prev);
    }

    // =====================================================================
    // useEffect
    // ---------------------------------------------------------------------
    // 画面初期化、セクション選択、履歴、原価、サステナブル画像などの副作用を
    // 既存の相対順序で維持する。Hooks順序に関わるため、整理時も安易に移動しない。
    // =====================================================================
    // 原価パターン確定時に、原価グリッドの再計算と入力可否を再反映する。
    useEffect(() => {
        if (genkaGridRefreshToken === 0) return;
        refreshGenkaGridView();
    }, [genkaGridRefreshToken, gridlist]);
    // 共通trigger反映後に、原価判定に必要な値が揃っていれば原価パターンを再判定する。
    // entrydataは購読せず、entryinputrenderを完了通知としてentrydataRef.currentを読み直す。
    useEffect(() => {
        if (entryLoadingRef.current) return;
        if (isEmpty(entrydataRef.current)) return;
        if (formstatus !== "NEW FORM" && formstatus !== "ENTRY FORM" && formstatus !== "COPY FORM") return;

        const supplierCode = String(DicVal(entrydataRef.current, "SSD_SIIRECD", "") ?? "").trim();
        if (supplierCode === "") {
            supplierCostAttributeWatchKeyRef.current = "";
        } else if (supplierCostAttributeWatchKeyRef.current !== supplierCode
            && !isEmpty(fnc.current)
            && typeof fnc.current.getMasterdata === "function") {
            supplierCostAttributeWatchKeyRef.current = supplierCode;
            fnc.current.getMasterdata("V_SUPPLIER", supplierCode, "", [
                { columnid: "SSD_TSUKATANI", dbcolumn: "TOR_TUKACD" }
            ], entrydataRef.current, (data) => {
                if (String(DicVal(entrydataRef.current, "SSD_SIIRECD", "") ?? "").trim() !== supplierCode) return;
                if (isEmpty(data)) return;
                const tsukaTani = String(DicVal(data, "SSD_TSUKATANI", DicVal(data, "TOR_TUKACD", "")) ?? "").trim();
                if (tsukaTani === "") return;

                const applySupplierCurrency = (tsukaTaniName) => {
                    if (String(DicVal(entrydataRef.current, "SSD_SIIRECD", "") ?? "").trim() !== supplierCode) return;
                    if (String(DicVal(entrydataRef.current, "SSD_TSUKATANI", "") ?? "").trim() === tsukaTani
                        && String(DicVal(entrydataRef.current, "SSD_TSUKATANI_nm", "") ?? "").trim() === tsukaTaniName) return;

                    // SSD_TSUKATANI は別パネル項目のため、共通triggerではなく画面内で明示的に反映する。
                    entrydataRef.current = {
                        ...entrydataRef.current,
                        SSD_TSUKATANI: tsukaTani,
                        SSD_TSUKATANI_cd: tsukaTani,
                        SSD_TSUKATANI_nm: tsukaTaniName
                    };
                    dispatchEntryRerenderWithTrace("supplierCostAttribute:currency");

                    const latestWatchState = buildGenkaPatternWatchState(entrydataRef.current);
                    if (latestWatchState.ready) {
                        syncGenkaPatternByEntry(entrydataRef.current);
                    }
                };

                const cachedCurrency = fnc.current.getMaster("m_code:3130", tsukaTani, "");
                const cachedCurrencyName = String(DicVal(cachedCurrency, "m_code_name", "") ?? "").trim();
                if (cachedCurrencyName !== "") {
                    applySupplierCurrency(cachedCurrencyName);
                    return;
                }

                fnc.current.getMasterdata("m_code:3130", tsukaTani, "", [
                    { columnid: "SSD_TSUKATANI", dbcolumn: "m_code_name" }
                ], null, (currencyData) => {
                    const tsukaTaniName = String(DicVal(currencyData, "SSD_TSUKATANI", DicVal(currencyData, "m_code_name", "")) ?? "").trim();
                    applySupplierCurrency(tsukaTaniName);
                });
            });
        }

        const watchState = buildGenkaPatternWatchState(entrydataRef.current);
        if (autoGenkaPatternWatchKeyRef.current === watchState.watchKey) return;
        autoGenkaPatternWatchKeyRef.current = watchState.watchKey;
        if (!watchState.ready) return;
        syncGenkaPatternByEntry(entrydataRef.current);
    }, [entryinputrender, formstatus]);
    // 配色下段マトリクスを初期化する。
    function resetColorwayMatrix() {
        setColorwayMatrixMap({
            sozai_haisyoku: { size: [], rows: [], loading: false },
            fuzoku_haisyoku: { size: [], rows: [], loading: false }
        });
    }
    // セクション別の一括入力値を取得する。
    function getSectionBulkInputValue(sectionId, fieldId) {
        const normalizedSectionId = normalizeKakousijiUiString(sectionId);
        const normalizedFieldId = normalizeKakousijiUiString(fieldId);
        if (normalizedSectionId === "" || normalizedFieldId === "") return "";
        return normalizeKakousijiUiString(DicVal(DicVal(sectionBulkInputMap, normalizedSectionId, null), normalizedFieldId, ""));
    }
    // セクション別の一括入力値を更新する。
    function setSectionBulkInputValue(sectionId, fieldId, value) {
        const normalizedSectionId = normalizeKakousijiUiString(sectionId);
        const normalizedFieldId = normalizeKakousijiUiString(fieldId);
        if (normalizedSectionId === "" || normalizedFieldId === "") return;
        const nextValue = normalizeKakousijiUiString(value);
        setSectionBulkInputMap((prev) => {
            const currentSection = isEmpty(prev) ? {} : (DicVal(prev, normalizedSectionId, null) || {});
            return {
                ...(isEmpty(prev) ? {} : prev),
                [normalizedSectionId]: {
                    ...currentSection,
                    [normalizedFieldId]: nextValue
                }
            };
        });
    }
    // UI操作対象のsectionに紐づくGRID panelを厳密に解決する。
    function resolveUiActionGridPanel(section) {
        if (isEmpty(section) || section.component !== "grid") return null;
        if (isEmpty(panel) || !Array.isArray(panel) || panel.length === 0) return null;
        const targetId = normalizeKakousijiUiString(DicVal(section, "panelId", ""));
        const targetType = normalizeKakousijiUiString(DicVal(section, "panelType", ""));
        if (targetId === "" || targetType === "") return null;
        const exactPanel = panel.find((p) => p && p.grid && normalizeKakousijiUiString(DicVal(p, "id", "")) === targetId && normalizeKakousijiUiString(DicVal(p, "type", "")) === targetType);
        return isEmpty(exactPanel) ? null : exactPanel;
    }
    // sectionに対応するGRID行を取得する。
    function getSectionGridRows(section) {
        const gridPanel = resolveUiActionGridPanel(section);
        if (isEmpty(gridPanel)) return [];
        const rows = GridData(gridPanel);
        return Array.isArray(rows) ? rows : [];
    }
    function getSectionDefById(sectionId) {
        return allCurrentSectionDefs().find((s) => String(s.id ?? "") === String(sectionId ?? ""));
    }
    function resolveDemandHeaderFallbackValue(sectionId, primaryKeys, detailPanelType, fallbackGridSectionId) {
        const primary = String(findEntryValue(entrydataRef.current, primaryKeys) ?? "").trim();
        if (primary !== "") return primary;

        const detailRow = getFirstDetailRowByPanelType(entrydetailRef.current, detailPanelType);
        if (!isEmpty(detailRow)) {
            for (let i = 0; i < primaryKeys.length; i++) {
                const key = primaryKeys[i];
                const value = String(DicVal(detailRow, key, "") ?? "").trim();
                if (value !== "") return value;
            }
        }

        const section = getSectionDefById(fallbackGridSectionId || sectionId);
        const gridRows = isEmpty(section) ? [] : getSectionGridRows(section);
        if (Array.isArray(gridRows) && gridRows.length !== 0) {
            const gridRow = gridRows.find((row) => !isEmpty(row));
            if (!isEmpty(gridRow)) {
                for (let i = 0; i < primaryKeys.length; i++) {
                    const key = primaryKeys[i];
                    const value = String(DicVal(gridRow, key, "") ?? "").trim();
                    if (value !== "") return value;
                }
            }
        }

        return "";
    }
    // =====================================================================
    // 13. UiAction / 画面ボタン処理
    // ---------------------------------------------------------------------
    // セクション操作ボタンはここでpayload化し、既存APIへ送る。
    // SAFETY: API URLとpayload形はバックエンドの既存分岐と対応している。
    // =====================================================================

    // UiAction送信用payloadを組み立てる。
    function buildKakousijiUiActionPayload(section, action, extra = {}) {
        const sectionId = normalizeKakousijiUiString(DicVal(section, "id", ""));
        const panelId = normalizeKakousijiUiString(DicVal(section, "panelId", ""));
        const panelType = normalizeKakousijiUiString(DicVal(section, "panelType", ""));
        const mode = normalizeKakousijiUiString(DicVal(extra, "mode", ""));
        const bulkLossRate = getSectionBulkInputValue(sectionId, "lossRate");
        const bulkShikyuKbn = getSectionBulkInputValue(sectionId, "shikyuKbn");
        const payload = {
            action: normalizeKakousijiUiString(action),
            mode: mode,
            code: normalizeKakousijiUiString(edittingcode),
            sectionId: sectionId,
            sectionLabel: normalizeKakousijiUiString(DicVal(section, "label", "")),
            panelId: panelId,
            panelType: panelType,
            kakouType: normalizeKakousijiUiString(kakouType),
            kakouShijiKubun: normalizeKakousijiUiString(kakouShijiKubun),
            selectedSetItem: normalizeKakousijiUiString(selectedSetItem),
            selectedGroup: normalizeKakousijiUiString(selectedGroup),
            copyItem: normalizeKakousijiUiString(copyItem),
            copyGroup: normalizeKakousijiUiString(copyGroup),
            bulkLossRate: normalizeKakousijiUiString(bulkLossRate),
            bulkShikyuKbn: normalizeKakousijiUiString(bulkShikyuKbn),
            rows: DeepCopy(getSectionGridRows(section)),
            entryData: DeepCopy(entrydataRef.current ?? {})
        };
        Object.keys(extra || {}).forEach((key) => {
            if (key === "mode") return;
            payload[key] = extra[key];
        });
        return payload;
    }
    // UiAction送信を共通化する。
    function runKakousijiUiAction(section, action, extra = {}) {
        const payload = buildKakousijiUiActionPayload(section, action, extra);
        callKakousijiUiAction(action, payload);
    }
    async function runGroupAction(section, action, extra = {}) {
        const normalizedAction = String(action ?? "");
        if (normalizedAction === UI_ACTION.GROUP_ADD || normalizedAction === UI_ACTION.GROUP_DELETE || normalizedAction === UI_ACTION.GROUP_EDIT || normalizedAction === UI_ACTION.GROUP_COPY) {
            if (isFukushizaiCopyPreviewing) return;
            // グループ操作の適用経路(refreshAfter*GroupMutation)はタブ/トグル切替と違い
            // commit(切替前確定)を通らないため、操作前に現在 context の未確定編集を
            // 操作対象ドメインに限定して確定しておく(確定漏れで編集が失われるのを防ぐ)。
            const domain = isQualityGroupSection(String(DicVal(section, "id", "") ?? "")) ? "quality" : "fukushizai";
            const activeContext = domain === "quality"
                ? selectedQualityContextRef.current
                : selectedFukushizaiContextRef.current;
            await commitFukushizaiActiveContextBeforeLeave(activeContext, { domain });
            openGroupActionDialog(section, normalizedAction, extra);
            return;
        }
        runKakousijiUiAction(section, action, extra);
    }
    function runDetailAction(section, mode, extra = {}) {
        if (mode === DETAIL_COPY_MODE.LIST_REFLECT) {
            applyFukushizaiListReflect(section);
            return;
        }
        if (mode === DETAIL_COPY_MODE.BULK_LOSS) {
            applyBulkLossRate(section, extra);
            return;
        }
        if (mode === DETAIL_COPY_MODE.BULK_SHIKYU) {
            applyBulkShikyuKbn(section, extra);
            return;
        }
        runKakousijiUiAction(section, UI_ACTION.DETAIL_COPY, { ...extra, mode: mode });
    }
    function isSoseiCalcSection(section) {
        const sectionId = normalizeKakousijiUiString(DicVal(section, "id", ""));
        return sectionId === "sosei" || sectionId === "sample_sosei";
    }
    function normalizeSoseiText(value) {
        return String(value ?? "").trim();
    }
    function normalizeSoseiColumnId(value) {
        return normalizeSoseiText(value).toUpperCase();
    }
    function getSoseiPanelColumnInfo(panelInfo, section) {
        const panelType = normalizeKakousijiUiString(DicVal(panelInfo, "type", DicVal(section, "panelType", "")));
        const sectionType = normalizeKakousijiUiString(DicVal(section, "panelType", ""));
        const typeCandidates = [panelType, sectionType].filter(v => v !== "");
        const cols = Array.isArray(columninfo)
            ? columninfo.filter(c => typeCandidates.includes(normalizeKakousijiUiString(DicVal(c, "type", ""))))
            : [];
        const findById = (ids) => {
            const uppers = ids.map(normalizeSoseiColumnId);
            return cols.find(c => uppers.includes(normalizeSoseiColumnId(DicVal(c, "columnid", "")))) || null;
        };
        const findByDataId = (dataid) => cols.find(c => {
            const target = normalizeSoseiColumnId(dataid);
            return [
                DicVal(c, "dataid", ""),
                DicVal(c, "mastertype", ""),
                DicVal(c, "dataidctrl", "")
            ].some(value => normalizeSoseiColumnId(value) === target);
        }) || null;
        const findByName = (predicate) => cols.find(c => predicate(normalizeSoseiText(DicVal(c, "columnnm", "")), normalizeSoseiColumnId(DicVal(c, "columnid", "")), normalizeSoseiColumnId(DicVal(c, "table", "")))) || null;
        const partColInfo = findById(["SSDQ_BUICD", "SSDH_BUICD"])
            || findByName((name, id) => name.indexOf("部位") !== -1 || id.indexOf("BUICD") !== -1);
        const mainColInfo = findById(["SSDQ_SOSEICD", "SSDH_SOSEICD"])
            || findByDataId("M_SOS")
            || findByName((name, id) => id.indexOf("SOSEICD") !== -1 && id.indexOf("SUB") === -1 && name.indexOf("サブ") === -1);
        const mainRateColInfo = findById(["SSDQ_KONRITU"])
            || findByName((name, id) => name === "混率" || (id.indexOf("KONRITU") !== -1 && id.indexOf("SUB") === -1));
        const subColInfo = findById(["SSDQ_SUB_SOSEICD", "SSDQNR_SUBSOSEICD1"])
            || findByDataId("M_SSOS")
            || findByName((name, id) => (id.indexOf("SUB") !== -1 && id.indexOf("SOSEI") !== -1) || (name.indexOf("サブ組成") !== -1 && name.indexOf("混率") === -1));
        const subNameColInfo = findById(["SSOS_NAME", "SSDQNR_SUBSOSEI_NM1"])
            || cols.find(c => normalizeSoseiColumnId(DicVal(c, "table", "")) === "M_SSOS" && normalizeSoseiColumnId(DicVal(c, "columnid", "")).indexOf("NAME") !== -1)
            || null;
        const subRateColInfo = findById(["SSDQ_SUB_KONRITU"])
            || findByName((name, id) => (id.indexOf("SUB") !== -1 && id.indexOf("KONRITU") !== -1) || name.indexOf("サブ組成混率") !== -1);
        const pickMetaText = (info, keys) => {
            for (let i = 0; i < keys.length; i++) {
                const value = normalizeSoseiText(DicVal(info, keys[i], ""));
                if (value !== "") return value;
            }
            return "";
        };
        return {
            partCol: normalizeSoseiText(DicVal(partColInfo, "columnid", "")),
            mainCol: normalizeSoseiText(DicVal(mainColInfo, "columnid", "")),
            mainDataId: pickMetaText(mainColInfo, ["dataid", "mastertype", "dataidctrl"]),
            mainDbColumn: pickMetaText(mainColInfo, ["dbcolumn", "dbcolumnnm"]),
            mainRateCol: normalizeSoseiText(DicVal(mainRateColInfo, "columnid", "")),
            mainRateDecimalPlaces: Number(DicVal(mainRateColInfo, "decimalplace", DicVal(mainRateColInfo, "decimalplaces", 0))) || 0,
            subCol: normalizeSoseiText(DicVal(subColInfo, "columnid", "")),
            subNameCol: normalizeSoseiText(DicVal(subNameColInfo, "columnid", "")),
            subRateCol: normalizeSoseiText(DicVal(subRateColInfo, "columnid", "")),
            subRateDecimalPlaces: Number(DicVal(subRateColInfo, "decimalplace", DicVal(subRateColInfo, "decimalplaces", 0))) || 0
        };
    }
    function readSoseiRowValue(row, field) {
        if (isEmpty(row) || isEmpty(field)) return "";
        const direct = DicVal(row, field, null);
        if (direct !== null && direct !== undefined) {
            const directText = normalizeSoseiText(direct);
            if (directText !== "") return directText;
        }
        const cd = DicVal(row, `${field}_cd`, DicVal(row, `${field}_CD`, null));
        if (cd !== null && cd !== undefined) return normalizeSoseiText(cd);
        return "";
    }
    function readSoseiRowName(row, codeField, nameField, fallbackToCode = false) {
        if (isEmpty(row)) return "";
        const code = !isEmpty(codeField) ? readSoseiRowValue(row, codeField) : "";
        const fromCodeName = !isEmpty(codeField)
            ? normalizeSoseiText(DicVal(row, `${codeField}_nm`, DicVal(row, `${codeField}_NM`, "")))
            : "";
        if (fromCodeName !== "" && fromCodeName !== code) return fromCodeName;
        const fromNameField = !isEmpty(nameField) ? readSoseiRowValue(row, nameField) : "";
        if (fromNameField !== "" && fromNameField !== code) return fromNameField;
        return fallbackToCode ? code : "";
    }
    function writeSoseiRowField(row, field, value) {
        if (isEmpty(row) || isEmpty(field)) return;
        row[field] = value;
    }
    function clearSoseiMasterValue(row, field) {
        if (isEmpty(row) || isEmpty(field)) return;
        row[field] = "";
        row[`${field}_cd`] = "";
        row[`${field}_CD`] = "";
        row[`${field}_nm`] = "";
        row[`${field}_NM`] = "";
    }
    function clearSoseiParentDisplayFields(row, meta) {
        clearSoseiMasterValue(row, meta.partCol);
        clearSoseiMasterValue(row, meta.mainCol);
        writeSoseiRowField(row, meta.mainRateCol, "");
    }
    function parseSoseiRate(value) {
        const raw = normalizeSoseiText(value).replace(/,/g, "").replace(/%/g, "");
        if (raw === "") return null;
        const num = Number(raw);
        if (!Number.isFinite(num)) return null;
        return num;
    }
    // 混率が「未入力」かどうか。
    // 混率・サブ組成混率はDBの数値列で、未入力は 0 として読み込まれる（画面上は空欄に見える）。
    // そのため空文字だけでなく 0 も未入力として扱わないと、既存データが計算対象から外れてしまう。
    function isUnenteredSoseiRate(row, rateField) {
        const rate = parseSoseiRate(readSoseiRowValue(row, rateField));
        return rate === null || rate === 0;
    }
    function isBlankSoseiSubFiber(row, meta) {
        return readSoseiRowValue(row, meta.subCol) === "" && readSoseiRowName(row, meta.subCol, meta.subNameCol) === "";
    }
    function formatSoseiRate(value, decimalPlaces) {
        const scale = Math.pow(10, Math.max(0, decimalPlaces || 0));
        const rounded = Math.round((Number(value) || 0) * scale) / scale;
        if ((decimalPlaces || 0) <= 0) return String(Math.round(rounded));
        return rounded.toFixed(decimalPlaces).replace(/\.?0+$/, "");
    }
    function buildSoseiAppendRow(baseRow, gridPanel, nextRows, appendIndex) {
        const next = DeepCopy(baseRow || {});
        const panelId = normalizeSoseiText(DicVal(gridPanel, "id", "sosei")) || "sosei";
        next.rowid = `${panelId}_${Date.now()}_${appendIndex}_${nextRows.length}`;
        return next;
    }
    function hasSoseiParentValue(row, meta) {
        return readSoseiRowValue(row, meta.mainCol) !== "";
    }

    function isSoseiPanelInfo(panelInfo) {
        const type = canonicalPanelType(DicVal(panelInfo, "type", ""));
        return type === "119" || type === PANEL_TYPE.SAMPLE_SOSEI;
    }

    function isBlankSoseiDisplayRow(row, meta) {
        if (isEmpty(row)) return true;
        const fields = [meta.partCol, meta.mainCol, meta.mainRateCol, meta.subCol, meta.subNameCol, meta.subRateCol]
            .filter(v => !isEmpty(v));
        if (fields.length === 0) return false;
        return fields.every(field => {
            const value = readSoseiRowValue(row, field);
            return value === "" || value === "-";
        });
    }
    function normalizeSoseiRowsByBlankSeparator(rows, meta) {
        const source = Array.isArray(rows) ? rows : [];
        const result = [];
        let segment = [];
        const flush = () => {
            if (segment.length === 0) return;
            result.push(...normalizeSoseiOrderGroup(segment, meta));
            segment = [];
        };
        source.forEach(row => {
            if (isBlankSoseiDisplayRow(row, meta)) {
                flush();
                result.push(row);
                return;
            }
            segment.push(row);
        });
        flush();
        return result;
    }
    function resolveSoseiDisplayOrderCol(rows) {
        const candidates = ["SSDQ_HYOJIJUN", "SSDH_HYOJIJUN"];
        for (let i = 0; i < candidates.length; i++) {
            const key = candidates[i];
            if ((Array.isArray(rows) ? rows : []).some(row => readSoseiRowValue(row, key) !== "")) return key;
        }
        return "";
    }
    function normalizeSoseiOrderGroup(group, meta) {
        if (!Array.isArray(group) || group.length <= 1) return Array.isArray(group) ? group : [];
        if (hasSoseiParentValue(group[0], meta)) return group;

        const parentIndex = group.findIndex(row => hasSoseiParentValue(row, meta));
        if (parentIndex <= 0) return group;

        return [group[parentIndex], ...group.filter((_, index) => index !== parentIndex)];
    }
    function normalizeSoseiRowsByDisplayOrder(rows, meta) {
        const source = Array.isArray(rows) ? rows : [];
        const orderCol = resolveSoseiDisplayOrderCol(source);
        if (orderCol === "") return normalizeSoseiRowsByBlankSeparator(source, meta);
        const result = [];
        let index = 0;
        while (index < source.length) {
            const orderValue = readSoseiRowValue(source[index], orderCol);
            if (orderValue === "") {
                result.push(source[index]);
                index++;
                continue;
            }
            const group = [];
            while (index < source.length && readSoseiRowValue(source[index], orderCol) === orderValue) {
                group.push(source[index]);
                index++;
            }
            result.push(...normalizeSoseiOrderGroup(group, meta));
        }
        return normalizeSoseiRowsByBlankSeparator(result, meta);
    }
    function resetSoseiRowIds(rows) {
        return (Array.isArray(rows) ? rows : []).map((row, index) => ({
            ...row,
            rowid: String(index)
        }));
    }
    function normalizeSoseiRowsForPanel(panelInfo, rows) {
        if (!isSoseiPanelInfo(panelInfo)) return rows;
        const section = getSectionDefById(resolveSectionIdByGridPanel(panelInfo));
        const meta = getSoseiPanelColumnInfo(panelInfo, section);
        if (isEmpty(meta.mainCol)) return rows;
        const normalized = normalizeSoseiRowsByDisplayOrder(DeepCopy(Array.isArray(rows) ? rows : []), meta);
        return resetSoseiRowIds(normalized);
    }
    // 部位コード＋組成コード単位に行をまとめる（これを「組成エントリ」と呼ぶ）。
    // 部位・組成が空の行は直前の値を引き継ぐ。離れて同じ組み合わせが再度現れた場合も同一エントリへまとめる。
    //
    // 1つの組成に複数のサブ組成をぶら下げる運用のため、同じ組成が行数分だけ繰り返し並ぶ。
    // 混率は「部位＋組成」に対する値なので、行単位ではなくこのエントリ単位で扱う必要がある。
    function buildSoseiEntries(rows, meta) {
        const entries = [];
        const entryByKey = {};
        let currentPart = "";
        let currentMain = "";
        (Array.isArray(rows) ? rows : []).forEach((row) => {
            if (isEmpty(row)) return;
            if (!isEmpty(meta.partCol)) {
                const part = readSoseiRowValue(row, meta.partCol);
                if (part !== "") currentPart = part;
            }
            if (!isEmpty(meta.mainCol)) {
                const main = readSoseiRowValue(row, meta.mainCol);
                if (main !== "") currentMain = main;
            }
            const key = currentPart + "\u001f" + currentMain;
            if (!Object.prototype.hasOwnProperty.call(entryByKey, key)) {
                entryByKey[key] = { part: currentPart, main: currentMain, rows: [] };
                entries.push(entryByKey[key]);
            }
            entryByKey[key].rows.push(row);
        });
        return entries;
    }
    // 組成エントリの混率。同じ組成の行は同一の混率を共有するため、最初の入力済みの値を代表値とする。
    function readSoseiEntryRate(entry, rateField) {
        const rows = DicVal(entry, "rows", []);
        for (let i = 0; i < rows.length; i++) {
            const rate = parseSoseiRate(readSoseiRowValue(rows[i], rateField));
            if (rate !== null && rate !== 0) return rate;
        }
        return 0;
    }
    function isUnenteredSoseiEntryRate(entry, rateField) {
        return DicVal(entry, "rows", []).every((row) => isUnenteredSoseiRate(row, rateField));
    }
    // 組成混率を部位コード単位で合計100%になるよう計算する。
    //   パターン1：組成N件のうち未入力が1件だけ  → その1件へ残りをセット
    //   パターン2：組成N件のうち未入力が2件以上  → 何もしない（どこへ配分すべきか決められないため）
    //   パターン3：組成1件だけで未入力           → 100%をセット（パターン1のN=1）
    function calculateSoseiMainRates(rows, meta) {
        if (isEmpty(meta.mainRateCol)) return false;
        let changed = false;
        const entriesByPart = {};
        const partOrder = [];
        buildSoseiEntries(rows, meta).forEach((entry) => {
            // 組成が未入力の行は計算対象外（空行・入力途中の行を巻き込まない）
            if (entry.main === "") return;
            if (!Object.prototype.hasOwnProperty.call(entriesByPart, entry.part)) {
                entriesByPart[entry.part] = [];
                partOrder.push(entry.part);
            }
            entriesByPart[entry.part].push(entry);
        });
        partOrder.forEach((part) => {
            const entries = entriesByPart[part];
            const blankEntries = entries.filter((entry) => isUnenteredSoseiEntryRate(entry, meta.mainRateCol));
            if (blankEntries.length !== 1) return;
            const enteredTotal = entries
                .filter((entry) => entry !== blankEntries[0])
                .reduce((sum, entry) => sum + readSoseiEntryRate(entry, meta.mainRateCol), 0);
            const remaining = 100 - enteredTotal;
            // 入力済みだけで100%を超えている場合は100%に出来ないため何もしない。
            if (remaining < 0) return;
            const nextValue = formatSoseiRate(remaining, meta.mainRateDecimalPlaces);
            // 混率は組成コードが入力されている行へのみ設定する。
            // 組成コード＝ブランクの行（サブ組成の続き行・空行）は直前行の組成エントリへ
            // まとめられるが、そこへ書き込むと上の行の混率が設定されてしまうため対象外とする。
            blankEntries[0].rows.forEach((row) => {
                if (readSoseiRowValue(row, meta.mainCol) === "") return;
                const before = readSoseiRowValue(row, meta.mainRateCol);
                writeSoseiRowField(row, meta.mainRateCol, nextValue);
                if (before !== readSoseiRowValue(row, meta.mainRateCol)) changed = true;
            });
        });
        return changed;
    }
    // サブ組成混率を部位コード＋組成コード単位で合計100%になるよう計算する。
    //   パターン1：サブ組成N件のうち未入力が1件だけ → その1件へ残りをセット
    //   パターン2：サブ組成N件のうち未入力が2件以上 → 何もしない
    //   パターン3：サブ組成1件のみで未入力         → 100%をセット（パターン1のN=1）
    //
    // サブ組成がブランクの行は計算対象にしない。
    // サブ組成コードと組成コードに互換性は無いため、組成コードの流用（旧実装）は行わない。
    function calculateSoseiSubRates(rows, meta) {
        if (isEmpty(meta.subCol) || isEmpty(meta.subRateCol)) return false;
        let changed = false;
        buildSoseiEntries(rows, meta).forEach((entry) => {
            const targetRows = entry.rows.filter((row) => !isBlankSoseiSubFiber(row, meta));
            if (targetRows.length === 0) return;
            const blankRows = targetRows.filter((row) => isUnenteredSoseiRate(row, meta.subRateCol));
            if (blankRows.length !== 1) return;
            const enteredTotal = targetRows
                .filter((row) => !isUnenteredSoseiRate(row, meta.subRateCol))
                .reduce((sum, row) => sum + (parseSoseiRate(readSoseiRowValue(row, meta.subRateCol)) || 0), 0);
            const remaining = 100 - enteredTotal;
            if (remaining < 0) return;
            const targetRow = blankRows[0];
            const before = readSoseiRowValue(targetRow, meta.subRateCol);
            writeSoseiRowField(targetRow, meta.subRateCol, formatSoseiRate(remaining, meta.subRateDecimalPlaces));
            if (before !== readSoseiRowValue(targetRow, meta.subRateCol)) changed = true;
        });
        return changed;
    }
    function calculateSoseiRows(rows, meta, gridPanel) {
        const nextRows = DeepCopy(Array.isArray(rows) ? rows : []);
        let changed = false;
        // 組成混率（部位コード単位）→ サブ組成混率（部位コード＋組成コード単位）の順に確定させる。
        if (calculateSoseiMainRates(nextRows, meta)) changed = true;
        if (calculateSoseiSubRates(nextRows, meta)) changed = true;
        const groupCount = buildSoseiEntries(nextRows, meta).filter((entry) => entry.main !== "").length;
        return { rows: nextRows, changed: changed, groupCount: groupCount };
    }
    function runSoseiCalcAction(section) {
        const gridPanel = resolveUiActionGridPanel(section) || resolveGridSectionPanel(section);
        if (isEmpty(gridPanel)) {
            fnc.current.warnmsg("組成グリッドが見つかりません。");
            return;
        }
        // 編集中のセルを先に確定させる。
        //
        // ボタンを押した時点でセルが編集中だと、storeRowData は確定前の値を読む。
        // 例：既存の混率を消してすぐ「計算」を押すと、消す前の値のままと判定され計算されない。
        const gridApi = GridApi(gridPanel);
        if (!isEmpty(gridApi) && typeof gridApi.stopEditing === "function") gridApi.stopEditing();
        try {
            storeRowData(gridPanel);
        } catch (e) { console.error(e); }
        const meta = getSoseiPanelColumnInfo(gridPanel, section);
        if (isEmpty(meta.mainCol) || isEmpty(meta.subCol) || isEmpty(meta.subRateCol)) {
            fnc.current.warnmsg("組成計算に必要な列定義が見つかりません。");
            return;
        }
        const rows = GridData(gridPanel);
        const result = calculateSoseiRows(rows, meta, gridPanel);
        if (result.groupCount === 0) {
            fnc.current.warnmsg("計算対象の組成がありません。");
            return;
        }
        SetGridData(gridPanel, result.rows);
        applyGridRowsNow(gridPanel, result.rows);
        fnc.current.modify(true);
    }
    function runHeaderAction(section, action, extra = {}) {
        if (action === UI_ACTION.CALC && isSoseiCalcSection(section)) {
            runSoseiCalcAction(section);
            return;
        }
        runKakousijiUiAction(section, action, extra);
    }
    // 配色API返却を正式形式（rows + size + callRecords）として表示用に正規化する。
    function normalizeColorwayMatrix(source) {
        if (isEmpty(source)) return { size: [], rows: [] };
        const rows = Array.isArray(source.rows) ? source.rows : [];
        const size = Array.isArray(source.size)
            ? source.size
                .map(s => ({
                    sizeCd: String(DicVal(s, "sizeCd", "")),
                    sizeNm: String(DicVal(s, "sizeNm", DicVal(s, "sizeCd", ""))),
                    sizeSort: DicVal(s, "sizeSort", ""),
                    field: String(DicVal(s, "field", ""))
                }))
                .filter(s => s.field !== "")
            : [];
        return { size: size, rows: rows };
    }
    // 配色APIの上段行を該当グリッドへ反映する。
    function applyColorwayRowsToGrid(sectionId, rows) {
        const section = allCurrentSectionDefs().find(s => s.id === sectionId);
        if (isEmpty(section)) return;
        const gridPanel = resolveGridSectionPanel(section);
        if (isEmpty(gridPanel)) return;
        const nextRows = Array.isArray(rows) ? rows : [];
        SetGridData(gridPanel, nextRows);
        applyGridRowsNow(gridPanel, nextRows);
    }
    // 配色下段マトリクスをサーバーから取得する。
    function loadColorwayMatrix(sectionId, code) {
        if (isEmpty(code)) return;
        if (sectionId !== "sozai_haisyoku" && sectionId !== "fuzoku_haisyoku") return;
        const startedAt = loadTimingNow();
        logEntryVisualTrace("loadColorwayMatrix:start", {
            code,
            sectionId
        }, { forceTrace: true });

        const param = {
            controller: controller,
            code: code,
            sectionId: sectionId,
            colinfo: columninfo,
            corpkey: corpkey,
            account: account
        };
        const url = DicVal(kakousijiColorwayMatrixUrlBySection, sectionId, "kakousiji/GetColorwayDetailMatrix");
        fnc.current.postaxios(url, param,
            {
                onSuccess: function (data) {
                    const successStartedAt = loadTimingNow();
                    const matrix = normalizeColorwayMatrix(data);
                    const normalizedAt = loadTimingNow();
                    setColorwayMatrixSectionIfChanged(sectionId, { ...matrix, loading: false });
                    const applyStartedAt = loadTimingNow();
                    applyColorwayRowsToGrid(sectionId, matrix.rows);
                    const doneAt = loadTimingNow();
                    logEntryVisualTrace("loadColorwayMatrix:onSuccess", {
                        code,
                        sectionId,
                        responseMs: Math.round(successStartedAt - startedAt),
                        normalizeMs: Math.round(normalizedAt - successStartedAt),
                        applyGridMs: Math.round(doneAt - applyStartedAt),
                        totalMs: Math.round(doneAt - startedAt),
                        rowCount: Array.isArray(matrix.rows) ? matrix.rows.length : 0,
                        sizeCount: Array.isArray(matrix.size) ? matrix.size.length : 0
                    }, { forceTrace: true });
                },
                onError: function () {
                    logEntryVisualTrace("loadColorwayMatrix:onError", {
                        code,
                        sectionId,
                        elapsedMs: Math.round(loadTimingNow() - startedAt)
                    }, { forceTrace: true });
                    setColorwayMatrixSectionIfChanged(sectionId, { size: [], rows: [], loading: false });
                }
            },
            true
        );
    }
    // 配色下段マトリクス2セクションをまとめて取得する。
    function loadColorwayMatrices(code) {
        const startedAt = loadTimingNow();
        logEntryVisualTrace("loadColorwayMatrices:start", { code }, { forceTrace: true });
        loadColorwayMatrix("sozai_haisyoku", code);
        loadColorwayMatrix("fuzoku_haisyoku", code);
        logEntryVisualTrace("loadColorwayMatrices:kickoffDone", {
            code,
            elapsedMs: Math.round(loadTimingNow() - startedAt)
        }, { forceTrace: true });
    }
    // 一括設定対象の副資材一覧パネルを厳密に解決する。
    function getBulkTargetGridPanel(section) {
        if (isEmpty(section)) return null;
        const sectionId = String(DicVal(section, "id", ""));
        if (["fukushizai_ichiran", "sozai_meisai", "fuzoku_meisai"].indexOf(sectionId) === -1) return null;
        const gridPanel = resolveUiActionGridPanel(section);
        if (isEmpty(gridPanel)) return null;
        const panelType = String(DicVal(gridPanel, "type", ""));
        if (![FUKUSHIZAI_LIST_PANEL_TYPE, PANEL_TYPE.MATERIAL_DETAIL, PANEL_TYPE.ACCESSORY_DETAIL].includes(panelType)) return null;
        return gridPanel;
    }
    function resolveBulkTargetColumnId(section, kind) {
        const gridPanel = getBulkTargetGridPanel(section);
        if (isEmpty(gridPanel)) return "";
        const panelType = String(DicVal(gridPanel, "type", ""));
        const normalizedKind = String(kind ?? "").trim().toLowerCase();
        const panelColumns = [
            ...(Array.isArray(columninfo) ? columninfo : []),
            ...(Array.isArray(columns) ? columns : [])
        ].filter((col) => String(DicVal(col, "type", "") ?? "").trim().toLowerCase() === String(panelType ?? "").trim().toLowerCase());
        const visibleIds = getVisibleOrKnownColumnIds(panelType);
        if (visibleIds.length === 0 && panelColumns.length === 0) return "";
        const buildCandidates = (predicates) => {
            const ids = [];
            panelColumns.forEach((col) => {
                const columnId = normalizeColumnIdUpper(DicVal(col, "columnid", ""));
                if (columnId === "" || ids.indexOf(columnId) !== -1) return;
                const columnName = normalizeKakousijiUiString(DicVal(col, "columnnm", ""));
                if (!predicates.some((predicate) => predicate(columnId, columnName))) return;
                ids.push(columnId);
            });
            visibleIds.forEach((columnId) => {
                if (ids.indexOf(columnId) !== -1) return;
                if (!predicates.some((predicate) => predicate(columnId, ""))) return;
                ids.push(columnId);
            });
            return ids;
        };
        if (normalizedKind === "shikyu") {
            const candidates = buildCandidates([
                (columnId, columnName) => columnName.indexOf("支給区分") !== -1,
                (columnId) => /SIKYUKBN$/i.test(columnId),
                (columnId) => /SHIKYUKBN$/i.test(columnId)
            ]);
            return candidates[0] || "";
        }
        const candidates = buildCandidates([
            (columnId, columnName) => columnName.indexOf("ロス率") !== -1,
            (columnId) => /LOSSRATE$/i.test(columnId),
            (columnId) => /LOSRITU$/i.test(columnId),
            (columnId) => /LOSS$/i.test(columnId)
        ]);
        return candidates[0] || "";
    }
    // 指定panelTypeで表示/既知のcolumnid一覧を返す。
    function getVisibleOrKnownColumnIds(panelType) {
        const typeKey = String(panelType ?? "").trim().toLowerCase();
        if (typeKey === "") return [];
        const ids = [];
        const add = (value) => {
            const cid = normalizeColumnIdUpper(value);
            if (cid === "") return;
            if (ids.indexOf(cid) === -1) ids.push(cid);
        };
        const typedColumninfo = Array.isArray(columninfo)
            ? columninfo.filter(c => String(c.type ?? "").trim().toLowerCase() === typeKey)
            : [];
        const typedColumns = Array.isArray(columns)
            ? columns.filter(c => String(c.type ?? "").trim().toLowerCase() === typeKey)
            : [];
        typedColumninfo.forEach((c) => add(DicVal(c, "columnid", "")));
        typedColumns.forEach((c) => add(DicVal(c, "columnid", "")));
        return ids;
    }
    // 指定columnidが一括更新対象として存在するか確認する。
    function hasColumnForBulkUpdate(panelType, columnId) {
        const target = normalizeColumnIdUpper(columnId);
        if (target === "") return false;
        return getVisibleOrKnownColumnIds(panelType).indexOf(target) !== -1;
    }
    // 空のプレースホルダ行ならtrueを返す。
    function isEmptyGridDataRow(row, targetColumns) {
        if (isEmpty(row) || typeof row !== "object") return true;
        const ignoreKeys = new Set(["ROWID", "GRIP", "EXPAND", "ROW_KIND", "DETAIL", "ROWKEY"]);
        const targets = Array.isArray(targetColumns)
            ? targetColumns.map(v => normalizeColumnIdUpper(v)).filter(v => v !== "")
            : [];
        const keys = Object.keys(row);
        for (let i = 0; i < keys.length; i++) {
            const key = String(keys[i] ?? "");
            const norm = normalizeColumnIdUpper(key);
            if (ignoreKeys.has(norm)) continue;
            if (targets.length !== 0 && targets.indexOf(norm) === -1) continue;
            if (String(row[key] ?? "").trim() !== "") return false;
        }
        return true;
    }
    // 使用副資材一覧に対して一括値を反映する。
    function applyBulkValueToSectionGrid(section, targetColumnId, value, masterName = "") {
        const gridPanel = getBulkTargetGridPanel(section);
        if (isEmpty(gridPanel)) {
            return;
        }
        const panelType = String(DicVal(gridPanel, "type", ""));
        if (!hasColumnForBulkUpdate(panelType, targetColumnId)) {
            return;
        }
        const nextValue = String(value ?? "").trim();
        if (nextValue === "") {
            return;
        }
        const targetColumns = getVisibleOrKnownColumnIds(panelType);
        const currentRows = DeepCopy(getSectionGridRows(section));
        if (!Array.isArray(currentRows) || currentRows.length === 0) {
            return;
        }
        const upperTargetId = normalizeColumnIdUpper(targetColumnId);
        const nextName = String(masterName ?? "").trim();
        const nextRows = currentRows.map((row) => {
            const nextRow = isEmpty(row) ? {} : { ...row };
            if (isEmptyGridDataRow(nextRow, targetColumns)) return nextRow;
            nextRow[upperTargetId] = nextValue;
            // マスタ参照項目は「コード:名称」で表示されるため、確定済みのコード/名称も更新する。
            if (nextName !== "") {
                nextRow[upperTargetId + "_cd"] = nextValue;
                nextRow[upperTargetId + "_CD"] = nextValue;
                nextRow[upperTargetId + "_nm"] = nextName;
                nextRow[upperTargetId + "_NM"] = nextName;
            }
            return nextRow;
        });
        const finalRows = canonicalPanelType(panelType) === FUKUSHIZAI_LIST_PANEL_TYPE
            ? recalcFukushizaiListCalcRows(nextRows)
            : canonicalPanelType(panelType) === PANEL_TYPE.ACCESSORY_DETAIL
                ? recalcAccessoryDetailCalcRows(nextRows)
                : nextRows;
        SetGridData(gridPanel, finalRows);
        applyGridRowsNow(gridPanel, finalRows);
        fnc.current.modify(true);
        rerender();
    }
    function applyBulkLossRate(section, extra = {}) {
        const sectionId = normalizeKakousijiUiString(DicVal(section, "id", ""));
        const targetColumnId = resolveBulkTargetColumnId(section, "loss");
        if (targetColumnId === "") return;
        applyBulkValueToSectionGrid(section, targetColumnId, DicVal(extra, "value", getSectionBulkInputValue(sectionId, "lossRate")));
    }
    function applyBulkShikyuKbn(section, extra = {}) {
        const sectionId = normalizeKakousijiUiString(DicVal(section, "id", ""));
        const targetColumnId = resolveBulkTargetColumnId(section, "shikyu");
        if (targetColumnId === "") return;
        const nextValue = normalizeKakousijiUiString(DicVal(extra, "value", getSectionBulkInputValue(sectionId, "shikyuKbn")));
        // 一覧へ「コード:名称」で表示させるため、選択肢から名称も渡す。
        const option = getBulkShikyuKbnOptions(section).find((item) => item.code === nextValue);
        applyBulkValueToSectionGrid(section, targetColumnId, nextValue, normalizeKakousijiUiString(DicVal(option, "name", "")));
    }
    // 支給区分一括設定の候補を取得する。グリッドの支給区分セルと同じ dataid を使うため、
    // 加工指示の条件（ブランド区分/海外区分/有償無償区分/通貨/商品区分）による絞り込みも同じ結果になる。
    function loadBulkShikyuKbnOptions(section) {
        const sectionId = normalizeKakousijiUiString(DicVal(section, "id", ""));
        if (sectionId === "") return;

        const gridPanel = getBulkTargetGridPanel(section);
        if (isEmpty(gridPanel)) return;
        const panelType = normalizeKakousijiUiString(DicVal(gridPanel, "type", ""));
        const targetColumnId = resolveBulkTargetColumnId(section, "shikyu");
        if (targetColumnId === "") return;

        const upperTargetId = normalizeColumnIdUpper(targetColumnId);
        const colInfo = (Array.isArray(columninfo) ? columninfo : []).find((col) =>
            normalizeColumnIdUpper(DicVal(col, "columnid", "")) === upperTargetId
            && normalizeKakousijiUiString(DicVal(col, "type", "")) === panelType);
        const dataid = normalizeKakousijiUiString(DicVal(colInfo, "dataid", ""));
        if (dataid === "") return;

        // 同一条件での多重取得を避ける。加工指示や原価パターン条件が変われば再取得する。
        const requestKey = [
            sectionId,
            dataid,
            normalizeKakousijiUiString(edittingcode),
            normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "SSD_KAIGAIKBN")),
            normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "SSD_TSUKATANI")),
            normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "SSD_KAKOUSAKISUBCD"))
        ].join("|");
        if (DicVal(bulkShikyuKbnRequestKeyRef.current, sectionId, "") === requestKey) return;
        bulkShikyuKbnRequestKeyRef.current[sectionId] = requestKey;

        fnc.current.postaxios("common/GetSearchMasterList",
            {
                dataid: dataid,
                items: null,
                values: null,
                rowdata: { ...(entrydataRef.current || {}) },
                keyinfo: null,
                datainfo: colInfo,
                initial: true
            },
            {
                onSuccess: function (data) {
                    const rows = Array.isArray(DicVal(data, "rowdata", null)) ? data.rowdata : [];
                    const options = [];
                    rows.forEach((row) => {
                        const code = normalizeKakousijiUiString(
                            readRowValueIgnoreCase(row, "code") || readRowValueIgnoreCase(row, "m_code_code"));
                        if (code === "" || options.some((item) => item.code === code)) return;
                        const name = normalizeKakousijiUiString(
                            readRowValueIgnoreCase(row, "m_code_name") || readRowValueIgnoreCase(row, "name"));
                        options.push({ code: code, name: name });
                    });
                    setBulkShikyuKbnOptions((prev) => ({ ...prev, [sectionId]: options }));
                    // Grid のマスタ参照表示（コード:名称）でも解決できるようキャッシュへ登録する。
                    // 検索リスト同様、要求した dataid で引けるように付け替える。
                    if (rows.length !== 0) {
                        fnc.current.margeMaster(rows.map((row) => ({ ...row, dataid: dataid })));
                    }
                },
                onError: function () {
                    // 次回描画で再取得できるようにキーを戻す。
                    bulkShikyuKbnRequestKeyRef.current[sectionId] = "";
                }
            },
            true
        );
    }
    // 支給区分一括設定の候補は、レイアウト確定後と絞り込み条件の変化時に取得する。
    useEffect(() => {
        if (!tabsReady) return;
        ["fuzoku_meisai", "fukushizai_ichiran"].forEach((sectionId) => {
            const section = getSectionDefById(sectionId);
            if (isEmpty(section)) return;
            loadBulkShikyuKbnOptions(section);
        });
    }, [tabsReady, edittingcode, genkaPatternNo, formstatus]);
    // 支給区分一括設定の候補一覧を返す。
    function getBulkShikyuKbnOptions(section) {
        const sectionId = normalizeKakousijiUiString(DicVal(section, "id", ""));
        if (sectionId === "") return [];
        const options = DicVal(bulkShikyuKbnOptions, sectionId, null);
        return Array.isArray(options) ? options : [];
    }
    function normalizeFukushizaiText(value) {
        return String(value ?? "").trim();
    }
    function normalizeQualityHsituhabaOptions(options) {
        return (Array.isArray(options) ? options : [])
            .map((option) => {
                const hsituhabaCd = normalizeFukushizaiText(DicVal(option, "hsituhabaCd", DicVal(option, "code", DicVal(option, "FZK_HSITUHABACD", ""))));
                const code = normalizeFukushizaiText(DicVal(option, "code", hsituhabaCd)) || hsituhabaCd;
                const fuzokuHinban = normalizeFukushizaiText(DicVal(option, "fuzokuHinban", DicVal(option, "FZK_FUZOKU_HINBAN", "")));
                const name = normalizeFukushizaiText(DicVal(option, "name", DicVal(option, "FZK_FUZOKU_NM", "")));
                return {
                    ...option,
                    code,
                    name,
                    fuzokuHinban,
                    hsituhabaCd,
                    display: normalizeFukushizaiText(DicVal(option, "display", "")) || (name === "" ? code : `${code}:${name}`)
                };
            })
            .filter((option) => option.code !== "" || option.fuzokuHinban !== "" || option.hsituhabaCd !== "");
    }
    function upsertQualityHsituhabaResolvedItems(items) {
        const nextMap = { ...(qualityHsituhabaResolvedMapRef.current || {}) };
        normalizeQualityHsituhabaOptions(items).forEach((option) => {
            const hsituhabaCd = normalizeFukushizaiText(DicVal(option, "hsituhabaCd", DicVal(option, "code", "")));
            if (hsituhabaCd === "") return;
            nextMap[hsituhabaCd] = {
                hsituhabaCd,
                fuzokuHinban: normalizeFukushizaiText(DicVal(option, "fuzokuHinban", "")),
                name: normalizeFukushizaiText(DicVal(option, "name", "")),
                count: normalizeFukushizaiText(DicVal(option, "count", ""))
            };
        });
        qualityHsituhabaResolvedMapRef.current = nextMap;
        return nextMap;
    }
    function readQualityHsituhabaOptionsFromEntryDataSource(source) {
        if (Array.isArray(DicVal(source, QUALITY_HSITUHABA_OPTIONS_DATA_KEY, null))) {
            return DicVal(source, QUALITY_HSITUHABA_OPTIONS_DATA_KEY, []);
        }
        const data = DicVal(source, "data", null);
        if (!isEmpty(data) && Array.isArray(DicVal(data, QUALITY_HSITUHABA_OPTIONS_DATA_KEY, null))) {
            return DicVal(data, QUALITY_HSITUHABA_OPTIONS_DATA_KEY, []);
        }
        return [];
    }
    function findQualityHsituhabaOption(value) {
        const code = extractMasterCodeFromDisplayValue(normalizeFukushizaiText(value));
        if (code === "") return null;
        const options = Array.isArray(qualityHsituhabaOptionsRef.current) ? qualityHsituhabaOptionsRef.current : [];
        return options.find((option) => normalizeFukushizaiText(DicVal(option, "code", "")) === code)
            || options.find((option) => normalizeFukushizaiText(DicVal(option, "hsituhabaCd", "")) === code)
            || null;
    }
    function findQualityHsituhabaOptionByFuzokuHinban(value) {
        const code = extractMasterCodeFromDisplayValue(normalizeFukushizaiText(value));
        if (code === "") return null;
        const options = Array.isArray(qualityHsituhabaOptionsRef.current) ? qualityHsituhabaOptionsRef.current : [];
        return options.find((option) => normalizeFukushizaiText(DicVal(option, "fuzokuHinban", "")) === code) || null;
    }
    function isQualityHsituhabaColumnId(columnId) {
        return normalizeColumnIdUpper(columnId) === QUALITY_LIST_HABACD_FIELD;
    }
    function qualityHsituhabaSelectOptionsForColInfo(colInfo) {
        const localOptions = normalizeQualityHsituhabaOptions(qualityHsituhabaOptionsRef.current);
        if (localOptions.length !== 0) {
            return localOptions.map((option) => ({
                code: normalizeFukushizaiText(DicVal(option, "hsituhabaCd", DicVal(option, "code", ""))),
                name: normalizeFukushizaiText(DicVal(option, "name", DicVal(option, "display", "")))
            })).filter((option) => option.code !== "");
        }
        return normalizeQualityHsituhabaOptions(DicVal(colInfo, "options", []))
            .map((option) => ({
                code: normalizeFukushizaiText(DicVal(option, "code", DicVal(option, "hsituhabaCd", ""))),
                name: normalizeFukushizaiText(DicVal(option, "name", DicVal(option, "display", "")))
            }))
            .filter((option) => option.code !== "");
    }
    function applyQualityHsituhabaLocalSelectColDef(col) {
        if (isEmpty(col) || typeof col !== "object") return col;
        const colId = DicVal(col, "colId", DicVal(col, "field", ""));
        if (!isQualityHsituhabaColumnId(colId)) return col;
        const sourceColInfo = isEmpty(col.colinfo) ? {} : col.colinfo;
        const options = qualityHsituhabaSelectOptionsForColInfo(sourceColInfo);
        const nextColInfo = {
            ...sourceColInfo,
            datatype: CELLTYPE.SELECT,
            dataid: "",
            dataidctrl: "",
            dbcolumn: "",
            searchtype: "",
            searchparam: {},
            trigger: [],
            extrigger: [],
            extriggerref: false,
            options
        };
        return {
            ...col,
            datatype: CELLTYPE.SELECT,
            dataid: "",
            dataidctrl: "",
            dbcolumn: "",
            searchtype: "",
            suppressClickEdit: false,
            colinfo: nextColInfo,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: { values: options.map((option) => option.code) },
            valueFormatter: (params) => {
                const value = extractMasterCodeFromDisplayValue(DicVal(params, "value", ""));
                const hit = options.find((option) => option.code === value);
                return isEmpty(hit) ? value : `${value} ${DicVal(hit, "name", "")}`.trim();
            }
        };
    }
    function resolveQualityHsituhabaFuzokuHinban(row) {
        const habaCd = extractMasterCodeFromDisplayValue(readFukushizaiRowField(row, QUALITY_LIST_HABACD_FIELD));
        if (habaCd === "" || habaCd === "99") {
            return { habaCd, code: "", option: null, source: habaCd === "99" ? "excluded-99" : "empty" };
        }

        const mapItem = DicVal(qualityHsituhabaResolvedMapRef.current || {}, habaCd, null);
        if (!isEmpty(mapItem)) {
            const resolved = normalizeFukushizaiText(DicVal(mapItem, "fuzokuHinban", ""));
            const name = normalizeFukushizaiText(DicVal(mapItem, "name", ""));
            if (resolved !== "") return { habaCd, code: resolved, name, option: mapItem, source: "resolved-map" };
        }

        const option = findQualityHsituhabaOption(habaCd);
        if (!isEmpty(option)) {
            const resolved = normalizeFukushizaiText(DicVal(option, "fuzokuHinban", ""));
            const name = normalizeFukushizaiText(DicVal(option, "name", ""));
            if (resolved !== "") return { habaCd, code: resolved, name, option, source: "initial-options" };
        }

        return { habaCd, code: "", name: "", option, source: "unresolved" };
    }
    function qualityHsituhabaResolvedMapHasValues() {
        const map = qualityHsituhabaResolvedMapRef.current || {};
        return Object.keys(map).some((key) => normalizeFukushizaiText(DicVal(map[key], "fuzokuHinban", "")) !== "");
    }
    function extractQualityHsituhabaResolveItems(response) {
        if (Array.isArray(DicVal(response, "items", null))) return DicVal(response, "items", []);
        if (Array.isArray(DicVal(response, "rows", null))) return DicVal(response, "rows", []);
        if (Array.isArray(DicVal(response, "rowdata", null))) return DicVal(response, "rowdata", []);
        const data = DicVal(response, "data", null);
        if (!isEmpty(data) && Array.isArray(DicVal(data, "items", null))) return DicVal(data, "items", []);
        return [];
    }
    function requestQualityHsituhabaResolve(codes = [], fuzokuHinbans = [], callback = null) {
        const targetCodes = [...new Set((Array.isArray(codes) ? codes : [])
            .map((value) => extractMasterCodeFromDisplayValue(value))
            .filter((value) => value !== "" && value !== "99"))];
        const targetHinbans = [...new Set((Array.isArray(fuzokuHinbans) ? fuzokuHinbans : [])
            .map((value) => extractMasterCodeFromDisplayValue(value))
            .filter((value) => value !== ""))];
        if (targetCodes.length === 0 && targetHinbans.length === 0) {
            if (typeof callback === "function") callback(true, []);
            return false;
        }
        const param = {
            controller,
            code: edittingcode,
            codes: targetCodes,
            fuzokuHinbans: targetHinbans
        };
        // NOTE: postaxios は onSuccess/onError を指定すると wait(false) を呼ばないため、
        //       コールバック側で必ず解除する。解除しないとローディングが表示されたままになる。
        fnc.current.postaxios(qualityHsituhabaResolveUrl, param, {
            onSuccess: function (data) {
                try {
                    const items = extractQualityHsituhabaResolveItems(data);
                    upsertQualityHsituhabaResolvedItems(items);
                    if (typeof callback === "function") callback(true, items);
                } finally {
                    if (!isEmpty(fnc.current)) fnc.current.wait(false);
                }
            },
            onError: function () {
                try {
                    if (typeof fnc.current?.warnmsg === "function") {
                        fnc.current.warnmsg("品質表示幅の附属品番解決に失敗しました。");
                    }
                    if (typeof callback === "function") callback(false, []);
                } finally {
                    if (!isEmpty(fnc.current)) fnc.current.wait(false);
                }
            }
        });
        return true;
    }
    function collectUnresolvedQualityHsituhabaCodesForRows(rows) {
        const codes = new Set();
        (Array.isArray(rows) ? rows : []).forEach((row) => {
            if (isEmpty(row)) return;
            const code = extractMasterCodeFromDisplayValue(readFukushizaiRowField(row, QUALITY_LIST_HABACD_FIELD));
            if (code === "" || code === "99") return;
            const item = DicVal(qualityHsituhabaResolvedMapRef.current || {}, code, null);
            if (!isEmpty(item) && normalizeFukushizaiText(DicVal(item, "fuzokuHinban", "")) !== "") return;
            codes.add(code);
        });
        return [...codes];
    }
    function ensureQualityHsituhabaResolvedForRows(rows, callback) {
        const unresolvedCodes = collectUnresolvedQualityHsituhabaCodesForRows(rows);
        if (unresolvedCodes.length === 0) {
            if (typeof callback === "function") callback(true);
            return;
        }
        if (qualityHsituhabaResolvedMapHasValues() || qualityHsituhabaFallbackLoadedRef.current) {
            if (typeof callback === "function") callback(true);
            return;
        }
        qualityHsituhabaFallbackLoadedRef.current = true;
        requestQualityHsituhabaResolve(unresolvedCodes, [], (ok) => {
            if (typeof callback === "function") callback(ok);
        });
    }
    function readQualityHsituhabaCdFromSelectionValue(value) {
        if (!isEmpty(value) && typeof value === "object") {
            const explicit = normalizeFukushizaiText(
                readRowValueIgnoreCase(value, "FZK_HSITUHABACD")
                ?? readRowValueIgnoreCase(value, "hsituhabaCd")
                ?? readRowValueIgnoreCase(value, QUALITY_LIST_HABACD_FIELD)
            );
            if (explicit !== "") return extractMasterCodeFromDisplayValue(explicit);
        }
        return extractMasterCodeFromDisplayValue(value);
    }
    function resolveQualityHsituhabaCdFromLocalSelectionValue(value) {
        const selectedCode = readQualityHsituhabaCdFromSelectionValue(value);
        if (selectedCode === "") return "";
        const option = findQualityHsituhabaOption(selectedCode);
        if (!isEmpty(option)) return normalizeFukushizaiText(DicVal(option, "hsituhabaCd", DicVal(option, "code", selectedCode))) || selectedCode;
        const byHinban = findQualityHsituhabaOptionByFuzokuHinban(selectedCode);
        if (!isEmpty(byHinban)) return normalizeFukushizaiText(DicVal(byHinban, "hsituhabaCd", DicVal(byHinban, "code", "")));
        return selectedCode;
    }
    function normalizeFukushizaiListTorkubun(value) {
        const next = normalizeFukushizaiText(value);
        return next === "" ? "1" : next;
    }
    function buildFukushizaiListKey(kind, code, torkubun, torcode, torsubcode) {
        return [
            normalizeFukushizaiText(kind),
            normalizeFukushizaiText(code),
            normalizeFukushizaiListTorkubun(torkubun),
            normalizeFukushizaiText(torcode),
            normalizeFukushizaiText(torsubcode)
        ].join("|");
    }
    function resolveFukushizaiListKind(ruleKind, sourceField) {
        const fieldId = normalizeColumnIdUpper(sourceField);
        if (fieldId === "SSDZ_KOMONOFUDACD" || fieldId === "SSDZ_SAGEFUDASIZECD") return "12";
        if (/^SSDZ_BRANDNAMECD[1-3]$/.test(fieldId) || /^SSDZ_SONOTANAMECD[1-6]$/.test(fieldId)) return "13";
        return normalizeFukushizaiText(ruleKind);
    }
    function readFukushizaiRowField(row, field) {
        const value = readRowValueIgnoreCase(row, field);
        return normalizeFukushizaiText(value);
    }
    function normalizeFukushizaiCalcText(value) {
        return String(value ?? "").replace(/[\s　]/g, "").trim();
    }
    function toFukushizaiCalcNumber(value) {
        const raw = String(value ?? "").replace(/,/g, "").trim();
        if (raw === "") return 0;
        const num = Number(raw);
        return Number.isFinite(num) ? num : 0;
    }
    function roundFukushizaiCalcNumber(value, decimalPlaces = 2, rounding = 1) {
        const num = toFukushizaiCalcNumber(value);
        const dpRaw = Number(decimalPlaces ?? 2);
        const dp = Number.isFinite(dpRaw) ? Math.max(0, dpRaw) : 2;
        const scale = Math.pow(10, dp);
        const mode = String(rounding ?? "1").trim();
        if (mode === "0") return Math.floor(num * scale + 1e-9) / scale;
        if (mode === "2") return Math.ceil(num * scale - 1e-9) / scale;
        return Math.round((num + Number.EPSILON) * scale) / scale;
    }
    function formatFukushizaiCalcNumber(value, decimalPlaces = 2, rounding = 1) {
        const dpRaw = Number(decimalPlaces ?? 2);
        const dp = Number.isFinite(dpRaw) ? Math.max(0, dpRaw) : 2;
        const rounded = roundFukushizaiCalcNumber(value, dp, rounding);
        if (!Number.isFinite(rounded)) return "";
        return rounded.toFixed(dp).replace(/\.?0+$/, "").replace(/^-0$/, "0");
    }
    // table="-" の画面計算項目は、s_layoutで定義されたcolumnidと完全一致する列定義だけを参照する。
    // 表示名や類似columnidからの推測は行わない（項目名の変更で計算が止まるのを防ぐ）。
    function resolveDetailCalcDisplayColumnMeta(panelType, columnId) {
        const targetId = normalizeColumnIdUpper(columnId);
        if (targetId === "") return null;
        const sources = [
            ...(Array.isArray(columninfo) ? columninfo : []),
            ...(Array.isArray(columns) ? columns : [])
        ];
        const hit = sources.find((col) => {
            if (canonicalPanelType(DicVal(col, "type", "")) !== canonicalPanelType(panelType)) return false;
            const candidate = normalizeColumnIdUpper(DicVal(col, "columnid", DicVal(col, "colId", DicVal(col, "field", ""))));
            return candidate === targetId;
        });
        if (isEmpty(hit)) return null;
        return { columnId: targetId };
    }
    // 円建て金額の端数処理。サーバがS_ENV/M_ICPCから解決した設定を使う。
    function resolveAmountRoundingRule() {
        const rule = DicVal(amountRoundingRef.current, "amount", null);
        return normalizeAmountRoundingRule(rule, 0, "1");
    }
    // 外貨金額の端数処理。行の通貨単位に対応する名称マスタ(6480)の設定を使う。
    function resolveForeignAmountRoundingRule(currencyCode) {
        const settings = amountRoundingRef.current;
        const fallback = normalizeAmountRoundingRule(DicVal(settings, "amountforeigndefault", null), 2, "1");
        const code = normalizeFukushizaiCalcText(currencyCode).toUpperCase();
        if (code === "") return fallback;
        const map = DicVal(settings, "amountforeign", null);
        if (isEmpty(map) || typeof map !== "object") return fallback;
        const hitKey = Object.keys(map).find((key) => String(key ?? "").trim().toUpperCase() === code);
        if (isEmpty(hitKey)) return fallback;
        return normalizeAmountRoundingRule(map[hitKey], fallback.decimalplace, fallback.rounding);
    }
    function normalizeAmountRoundingRule(rule, defaultDecimalPlaces, defaultRounding) {
        const decimalRaw = Number(DicVal(rule, "decimalplace", defaultDecimalPlaces));
        const roundingRaw = String(DicVal(rule, "rounding", defaultRounding) ?? defaultRounding).trim();
        return {
            decimalplace: Number.isFinite(decimalRaw) ? Math.max(0, decimalRaw) : defaultDecimalPlaces,
            rounding: roundingRaw === "" ? defaultRounding : roundingRaw
        };
    }
    // 明細行の通貨単位を取得する。未設定の行は基本情報の通貨単位で補う。
    function resolveDetailRowCurrency(row, currencyField) {
        const field = String(currencyField ?? "").trim();
        const rowValue = field === "" ? "" : normalizeFukushizaiCalcText(DicVal(row, field, ""));
        if (rowValue !== "") return rowValue;
        return normalizeFukushizaiCalcText(DicVal(entrydataRef.current, "SSD_TSUKATANI", ""));
    }
    function resolveCurrencyInputLockConfig(panelType) {
        const typeKey = canonicalPanelType(panelType);
        if (typeKey === "") return null;
        return CURRENCY_INPUT_LOCK_BY_TYPE[typeKey] ?? null;
    }
    // 円建て(JPY)かどうか。通貨単位が行にも基本情報にも無い場合は円建て扱いとする。
    function isDomesticCurrencyRow(row, currencyField) {
        const code = resolveDetailRowCurrency(row, currencyField).toUpperCase();
        return code === "" || code === DOMESTIC_CURRENCY_CODE;
    }
    // 通貨制御の対象列かどうかを判定し、円建て側/外貨側のどちらかを返す。
    function resolveCurrencyInputLockSide(config, columnId) {
        const cid = normalizeColumnIdUpper(columnId);
        if (cid === "" || isEmpty(config)) return "";
        if ((config.domesticFields ?? []).some((id) => normalizeColumnIdUpper(id) === cid)) return "domestic";
        if ((config.foreignFields ?? []).some((id) => normalizeColumnIdUpper(id) === cid)) return "foreign";
        return "";
    }
    function resolveColDefColumnId(colDef) {
        return normalizeColumnIdUpper(DicVal(colDef, "colId", DicVal(colDef, "field", "")));
    }
    // 通貨単位に応じて単価/金額セルの入力可否を切り替える（EntryGridArのlockcell）。
    function lockGridCellByCurrency(params, edit, formstatus, panelType) {
        if (edit === false) return false;   // 元々編集不可のセルは緩めない
        const config = resolveCurrencyInputLockConfig(panelType);
        if (isEmpty(config)) return edit;
        const side = resolveCurrencyInputLockSide(config, resolveColDefColumnId(DicVal(params, "colDef", {})));
        if (side === "") return edit;
        const domestic = isDomesticCurrencyRow(DicVal(params, "data", null), config.currencyField);
        return domestic ? side === "domestic" : side === "foreign";
    }
    // 通貨で入力不可になったセルは、同じ列の編集可の行と区別できるよう背景色を落とす。
    function applyCurrencyInputLockColDef(column) {
        if (isEmpty(column) || typeof column !== "object") return;
        const config = resolveCurrencyInputLockConfig(DicVal(DicVal(column, "colinfo", {}), "type", ""));
        if (isEmpty(config)) return;
        const side = resolveCurrencyInputLockSide(config, resolveColDefColumnId(column));
        if (side === "") return;
        column.cellStyle = function (params) {
            const domestic = isDomesticCurrencyRow(DicVal(params, "data", null), config.currencyField);
            const enabled = domestic ? side === "domestic" : side === "foreign";
            return enabled ? { backgroundColor: "inherit" } : { backgroundColor: "#f2f2f2" };
        };
    }
    // 通貨に応じて単価/単価(外)を正規化する（画面表示と保存値で同じ規則を使う）。
    //   通貨=JPY  ：単価(外)=0。単価は入力値のまま
    //   通貨≠JPY ：単価=単価(外)×見積レート。単価(外)は入力値のまま（丸めない）
    //              見積レートが未設定(0)なら換算できないため単価は0にする
    // 換算後の単価は円建ての値なので、丸めは名称マスタ(6480)の JPY 設定に従う。
    function applyCurrencyPriceRuleToRow(row, calcConfig = {}) {
        if (isEmpty(row) || typeof row !== "object") return row;
        const unitField = String(DicVal(calcConfig, "unitField", "") ?? "").trim();
        const unitForeignField = String(DicVal(calcConfig, "unitForeignField", "") ?? "").trim();
        if (unitField === "" || unitForeignField === "") return row;
        const currencyField = String(DicVal(calcConfig, "currencyField", "") ?? "").trim();
        if (isDomesticCurrencyRow(row, currencyField)) {
            row[unitForeignField] = 0;
            return row;
        }
        const rateField = String(DicVal(calcConfig, "rateField", "") ?? "").trim();
        const rate = rateField === "" ? 0 : toFukushizaiCalcNumber(DicVal(row, rateField, ""));
        if (rate === 0) {
            row[unitField] = 0;
            return row;
        }
        const rule = resolveDomesticPriceRoundingRule();
        const unitForeign = toFukushizaiCalcNumber(DicVal(row, unitForeignField, ""));
        row[unitField] = roundFukushizaiCalcNumber(unitForeign * rate, rule.decimalplace, rule.rounding);
        return row;
    }
    // 円建て単価の桁数・まるめ。名称マスタ(6480)の JPY 設定を使う。
    // 新規登録は GetEntryData を通らず設定が未取得のことがあるため、既定は円建ての 0桁・四捨五入とする。
    function resolveDomesticPriceRoundingRule() {
        const map = DicVal(amountRoundingRef.current, "amountforeign", null);
        if (isEmpty(map) || typeof map !== "object") return { decimalplace: 0, rounding: "1" };
        const hitKey = Object.keys(map).find((key) => String(key ?? "").trim().toUpperCase() === DOMESTIC_CURRENCY_CODE);
        if (isEmpty(hitKey)) return { decimalplace: 0, rounding: "1" };
        return normalizeAmountRoundingRule(map[hitKey], 0, "1");
    }
    function recalcLossBasedDetailRow(row, calcConfig = {}) {
        if (isEmpty(row) || typeof row !== "object") return row;
        const next = { ...row };
        // 単価の正規化は数量・ロス率の有無に関わらず行う。
        applyCurrencyPriceRuleToRow(next, calcConfig);
        const qtyField = String(DicVal(calcConfig, "qtyField", "") ?? "").trim();
        const lossField = String(DicVal(calcConfig, "lossField", "") ?? "").trim();
        const outputField = String(DicVal(calcConfig, "outputField", "") ?? "").trim();
        const unitField = String(DicVal(calcConfig, "unitField", "") ?? "").trim();
        const unitForeignField = String(DicVal(calcConfig, "unitForeignField", "") ?? "").trim();
        const outputDecimalPlaces = Number(DicVal(calcConfig, "outputDecimalPlaces", 2));
        const outputRounding = String(DicVal(calcConfig, "outputRounding", 1) ?? "1");
        const currencyField = String(DicVal(calcConfig, "currencyField", "") ?? "").trim();
        const panelType = String(DicVal(calcConfig, "panelType", "") ?? "").trim();
        const amountMeta = resolveDetailCalcDisplayColumnMeta(panelType, DicVal(calcConfig, "amountColumnId", ""));
        const amountForeignMeta = resolveDetailCalcDisplayColumnMeta(panelType, DicVal(calcConfig, "amountForeignColumnId", ""));
        const qtyRaw = DicVal(next, qtyField, "");
        const lossRaw = DicVal(next, lossField, "");
        const hasQty = normalizeFukushizaiCalcText(qtyRaw) !== "";
        const hasLoss = normalizeFukushizaiCalcText(lossRaw) !== "";
        if (!hasQty && !hasLoss) {
            if (outputField !== "") next[outputField] = "";
            if (!isEmpty(amountMeta)) next[amountMeta.columnId] = "";
            if (!isEmpty(amountForeignMeta)) next[amountForeignMeta.columnId] = "";
            return next;
        }
        const qty = toFukushizaiCalcNumber(qtyRaw);
        const lossRate = toFukushizaiCalcNumber(lossRaw);
        const unit = toFukushizaiCalcNumber(DicVal(next, unitField, ""));
        const unitForeign = toFukushizaiCalcNumber(DicVal(next, unitForeignField, ""));
        const calcQty = qty * (1 + (lossRate / 100));
        // 金額は画面に表示されるロス込要尺（丸め後）×単価とする。画面から手計算した値と一致させる。
        const lossQty = roundFukushizaiCalcNumber(calcQty, outputDecimalPlaces, outputRounding);
        if (outputField !== "") next[outputField] = formatFukushizaiCalcNumber(lossQty, outputDecimalPlaces, outputRounding);
        if (!isEmpty(amountMeta)) {
            const amountRule = resolveAmountRoundingRule();
            next[amountMeta.columnId] = roundFukushizaiCalcNumber(lossQty * unit, amountRule.decimalplace, amountRule.rounding);
        } else if (panelType !== "") {
            // 金額表示列が列定義から特定できない場合は、DB保存対象の出力列のみ更新する。
        }
        if (!isEmpty(amountForeignMeta)) {
            const foreignRule = resolveForeignAmountRoundingRule(resolveDetailRowCurrency(next, currencyField));
            next[amountForeignMeta.columnId] = roundFukushizaiCalcNumber(lossQty * unitForeign, foreignRule.decimalplace, foreignRule.rounding);
        }
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => recalcLossBasedDetailRow(sourceRow, calcConfig));
        }
        return next;
    }
    // 明細ごとの計算対象列。画面の再計算と保存直前の通貨正規化で同じ定義を使う。
    const DETAIL_CALC_CONFIG_BY_TYPE = {
        [PANEL_TYPE.MATERIAL_DETAIL]: {
            panelType: PANEL_TYPE.MATERIAL_DETAIL,
            qtyField: "SSDS_YOJAKU",
            lossField: "SSDS_LOSSRITU",
            outputField: "SSDS_LYOJAKU",
            unitField: "SSDS_TANKA",
            unitForeignField: "SSDS_TANKAF",
            currencyField: "SSDS_CUR",
            rateField: "SSDS_MITUMORIRATE",
            outputDecimalPlaces: 2,
            outputRounding: 1,
            amountColumnId: "SOZAI_KINGAKU",
            amountForeignColumnId: "SOZAI_KINGAKU_GAIKA"
        },
        [PANEL_TYPE.ACCESSORY_DETAIL]: {
            panelType: PANEL_TYPE.ACCESSORY_DETAIL,
            qtyField: "SSDF_YOJAKU",
            lossField: "SSDF_LOSSRITU",
            outputField: "SSDF_LYOJAKU",
            unitField: "SSDF_TANKA",
            unitForeignField: "SSDF_TANKAF",
            currencyField: "SSDF_CUR",
            rateField: "SSDF_MITUMORIRATE",
            outputDecimalPlaces: 2,
            outputRounding: 1,
            amountColumnId: "FUZOKU_KINGAKU",
            amountForeignColumnId: "FUZOKU_KINGAKU_GAIKA"
        },
        [PANEL_TYPE.FUKUSHIZAI_LIST]: {
            panelType: PANEL_TYPE.FUKUSHIZAI_LIST,
            qtyField: "SSDZM_YOJAKUKOSU",
            lossField: "SSDZM_LOSSRITU",
            outputField: "SSDZM_LSURYO",
            unitField: "SSDZM_TANKA",
            unitForeignField: "SSDZM_TANKAF",
            currencyField: "SSDZM_CUR",
            rateField: "SSDZM_MITUMORIRATE",
            outputDecimalPlaces: 2,
            outputRounding: 1,
            amountColumnId: "FUKUSHIZAI_ICHIRAN_KINGAKU",
            amountForeignColumnId: "FUKUSHIZAI_ICHIRAN_KINGAKU_GAIKA"
        }
    };
    function recalcFukushizaiListCalcRow(row) {
        return recalcLossBasedDetailRow(row, DETAIL_CALC_CONFIG_BY_TYPE[PANEL_TYPE.FUKUSHIZAI_LIST]);
    }
    function recalcAccessoryDetailCalcRow(row) {
        return recalcLossBasedDetailRow(row, DETAIL_CALC_CONFIG_BY_TYPE[PANEL_TYPE.ACCESSORY_DETAIL]);
    }
    function recalcMaterialDetailCalcRow(row) {
        return recalcLossBasedDetailRow(row, DETAIL_CALC_CONFIG_BY_TYPE[PANEL_TYPE.MATERIAL_DETAIL]);
    }
    function recalcFukushizaiListCalcRows(rows) {
        const list = Array.isArray(rows) ? rows : [];
        if (list.length === 0) return list;
        return list.map((row) => recalcFukushizaiListCalcRow(row));
    }
    function recalcAccessoryDetailCalcRows(rows) {
        const list = Array.isArray(rows) ? rows : [];
        if (list.length === 0) return list;
        return list.map((row) => recalcAccessoryDetailCalcRow(row));
    }
    function recalcMaterialDetailCalcRows(rows) {
        const list = Array.isArray(rows) ? rows : [];
        if (list.length === 0) return list;
        return list.map((row) => recalcMaterialDetailCalcRow(row));
    }
    function normalizeFukushizaiDisplayName(value) {
        const text = normalizeFukushizaiText(value);
        const lower = text.toLowerCase();
        if (lower === "undefined" || lower === "null") return "";
        return text;
    }
    function resolveFukushizaiSourceFieldName(row, fieldId, rawValue = "") {
        if (isEmpty(row) || normalizeFukushizaiText(fieldId) === "") return "";
        const candidates = [
            `${fieldId}_nm`,
            `${fieldId}_NM`,
            `${fieldId}_name`,
            `${fieldId}_NAME`,
            `${fieldId}_display`,
            `${fieldId}_DISPLAY`
        ];
        for (let i = 0; i < candidates.length; i++) {
            const value = normalizeFukushizaiDisplayName(readRowValueIgnoreCase(row, candidates[i]));
            if (value !== "") return value;
        }
        const displayName = normalizeFukushizaiDisplayName(extractMasterNameFromDisplayValue(rawValue));
        if (displayName !== "") return displayName;
        return "";
    }
    function readFirstFukushizaiRowField(row, fields) {
        const list = Array.isArray(fields) ? fields : [];
        for (let i = 0; i < list.length; i++) {
            const value = readFukushizaiRowField(row, list[i]);
            if (value !== "") return value;
        }
        return "";
    }
    function fukushizaiSortNumber(value, fallback = 999999) {
        const num = Number(String(value ?? "").replace(/,/g, ""));
        return Number.isFinite(num) ? num : fallback;
    }
    function fukushizaiSortPart(value, width = 8, fallback = 999999) {
        return String(fukushizaiSortNumber(value, fallback)).padStart(width, "0");
    }
    function buildFukushizaiListItemOrderMap(rows) {
        const map = {};
        const addItem = (value) => {
            const itemCd = normalizeItemCd(value);
            if (itemCd === "" || Object.prototype.hasOwnProperty.call(map, itemCd)) return;
            map[itemCd] = Object.keys(map).length + 1;
        };
        const optionSource = Array.isArray(fukushizaiItemMasterOptions) && fukushizaiItemMasterOptions.length !== 0
            ? fukushizaiItemMasterOptions
            : setItemOptions;
        (Array.isArray(optionSource) ? optionSource : []).forEach((option) => addItem(getNamedOptionCode(option) || option));
        (Array.isArray(rows) ? rows : []).forEach((row) => {
            const context = readFukushizaiItemGroupFromAnyRow(row);
            addItem(context.itemCd);
        });
        return map;
    }
    function buildFukushizaiListGroupOrderMap(rows) {
        const map = {};
        (Array.isArray(rows) ? rows : []).forEach((row) => {
            const context = readFukushizaiItemGroupFromAnyRow(row);
            const itemCd = normalizeItemCd(context.itemCd);
            const groupNo = normalizeGroupNo(context.groupNo);
            if (itemCd === "" || groupNo === "" || /^\d+$/.test(groupNo)) return;
            const key = `${itemCd}|${groupNo}`;
            if (!Object.prototype.hasOwnProperty.call(map, key)) map[key] = Object.keys(map).length + 1;
        });
        return map;
    }
    function getFukushizaiListItemIndex(itemCd, itemOrderMap, fallbackIndex) {
        const item = normalizeItemCd(itemCd);
        if (item !== "" && !isEmpty(itemOrderMap) && Object.prototype.hasOwnProperty.call(itemOrderMap, item)) {
            return fukushizaiSortNumber(itemOrderMap[item], fallbackIndex);
        }
        return fukushizaiSortNumber(fallbackIndex, 999999);
    }
    function getFukushizaiListGroupOrder(itemCd, groupNo, groupOrderMap) {
        const group = normalizeGroupNo(groupNo);
        if (group === "") return 999999;
        if (/^\d+$/.test(group)) return fukushizaiSortNumber(group, 999999);
        const key = `${normalizeItemCd(itemCd)}|${group}`;
        if (!isEmpty(groupOrderMap) && Object.prototype.hasOwnProperty.call(groupOrderMap, key)) {
            return fukushizaiSortNumber(groupOrderMap[key], 999999);
        }
        return 999999;
    }
    function fukushizaiSourceRegistrationOrder(itemIndex, groupOrder, rowOrder, fieldOrder = 0) {
        return [
            fukushizaiSortPart(itemIndex),
            fukushizaiSortPart(groupOrder, 6),
            fukushizaiSortPart(rowOrder),
            fukushizaiSortPart(fieldOrder, 4, 0)
        ].join("|");
    }
    function fukushizaiSourceSortValue(sortKind, itemIndex, groupOrder, rowOrder, fieldOrder = 0) {
        return `${fukushizaiSortPart(sortKind, 4)}|${fukushizaiSourceRegistrationOrder(itemIndex, groupOrder, rowOrder, fieldOrder)}`;
    }
    function compareFukushizaiListSourceItems(a, b) {
        const sortCompare = normalizeFukushizaiText(a?.sortIndex).localeCompare(normalizeFukushizaiText(b?.sortIndex), "ja", { numeric: true, sensitivity: "base" });
        if (sortCompare !== 0) return sortCompare;
        const aKey = buildFukushizaiListKey(DicVal(a, "saveKind", DicVal(a, "kind", "")), DicVal(a, "code", ""), DicVal(a, "torkubun", ""), DicVal(a, "torcode", ""), DicVal(a, "torsubcode", ""));
        const bKey = buildFukushizaiListKey(DicVal(b, "saveKind", DicVal(b, "kind", "")), DicVal(b, "code", ""), DicVal(b, "torkubun", ""), DicVal(b, "torcode", ""), DicVal(b, "torsubcode", ""));
        return aKey.localeCompare(bKey, "ja", { numeric: true, sensitivity: "base" });
    }
    function readQualityFuzokuTorInfo(row) {
        return {
            torkubun: normalizeFukushizaiListTorkubun(readFirstFukushizaiRowField(row, ["SSDQ_FUZOKU_TORKUBUN", "SSDQ_TORKUBUN"])),
            torcode: readFirstFukushizaiRowField(row, ["SSDQ_FUZOKU_TORCODE", "SSDQ_TORCODE"]),
            torsubcode: readFirstFukushizaiRowField(row, ["SSDQ_FUZOKU_TORSUBCODE", "SSDQ_TORSUBCODE"])
        };
    }
    // =====================================================================
    // 副資材 112〜117
    // ---------------------------------------------------------------------
    // D_SSDZを画面用途別に表示し、保存時は113へ集約する。
    // =====================================================================

    function collectQualityDisplaySourceItems(debugSummary, orderContext = {}) {
        const rows = [
            ...getDetailRowsByPanelType(entrydetailRef.current, PANEL_TYPE.QUALITY_BASE),
            ...getDetailRowsByPanelType(entrydetailRef.current, "119")
        ];
        const out = [];
        const seenPhysicalRows = new Set();
        (Array.isArray(rows) ? rows : []).forEach((row, rowIndex) => {
            if (isEmpty(row)) return;
            const context = readFukushizaiItemGroupFromAnyRow(row);
            const physicalKey = [
                readFukushizaiRowField(row, "SSDQ_NO"),
                context.itemCd,
                context.groupNo,
                context.colorCd,
                readFukushizaiRowField(row, "SSDQ_HYOJIJUN"),
                extractMasterCodeFromDisplayValue(readFukushizaiRowField(row, QUALITY_LIST_HABACD_FIELD)),
                extractMasterCodeFromDisplayValue(readFukushizaiRowField(row, QUALITY_LIST_FUZOKU_HINBAN_FIELD))
            ].join("|");
            if (seenPhysicalRows.has(physicalKey)) return;
            seenPhysicalRows.add(physicalKey);
            const resolvedQualityHaba = resolveQualityHsituhabaFuzokuHinban(row);
            const habaCd = resolvedQualityHaba.habaCd;
            if (habaCd === "" || habaCd === "99") {
                if (!isEmpty(debugSummary)) {
                    debugSummary.excludedCandidates += 1;
                    const reason = habaCd === "99" ? "quality-habacd-99" : "quality-habacd-empty";
                    debugSummary.excludeReasons[reason] = (Number(debugSummary.excludeReasons[reason]) || 0) + 1;
                }
                return;
            }
            const code = resolvedQualityHaba.code;
            const sourceName = normalizeFukushizaiDisplayName(DicVal(resolvedQualityHaba, "name", DicVal(DicVal(resolvedQualityHaba, "option", {}), "name", "")));
            if (code === "") {
                if (!isEmpty(debugSummary)) {
                    debugSummary.excludedCandidates += 1;
                    debugSummary.excludeReasons["quality-fuzoku-empty"] = (Number(debugSummary.excludeReasons["quality-fuzoku-empty"]) || 0) + 1;
                }
                return;
            }
            const tor = readQualityFuzokuTorInfo(row);
            const itemIndex = getFukushizaiListItemIndex(context.itemCd, DicVal(orderContext, "itemOrderMap", {}), rowIndex + 1);
            const groupOrder = getFukushizaiListGroupOrder(context.itemCd, context.groupNo, DicVal(orderContext, "groupOrderMap", {}));
            const rowOrder = rowIndex + 1;
            if (!isEmpty(debugSummary)) debugSummary.extractedCandidates += 1;
            out.push({
                sourceOrigin: "qualityHsituhaba",
                sourceKind: FUKUSHIZAI_LIST_QUALITY_KIND,
                saveKind: FUKUSHIZAI_LIST_QUALITY_KIND,
                kind: FUKUSHIZAI_LIST_QUALITY_KIND,
                code,
                sourceName,
                displayName: sourceName,
                sourceSectionId: PANEL_TYPE.QUALITY_BASE,
                sourceField: QUALITY_LIST_HABACD_FIELD,
                sourceItemCd: context.itemCd,
                sourceGroupNo: context.groupNo,
                sourceColorCd: context.colorCd,
                sourceRowIndex: rowIndex,
                sourceRowId: normalizeFukushizaiText(DicVal(row, ROW_ID_FIELD, rowIndex)),
                sectionOrder: 1,
                ruleOrder: FUKUSHIZAI_LIST_QUALITY_SOURCE_ORDER,
                sortKind: FUKUSHIZAI_LIST_QUALITY_SOURCE_ORDER,
                itemIndex,
                groupOrder,
                rowOrder,
                fieldOrder: 0,
                sortIndex: fukushizaiSourceSortValue(FUKUSHIZAI_LIST_QUALITY_SOURCE_ORDER, itemIndex, groupOrder, rowOrder, 0),
                torkubun: tor.torkubun,
                torcode: tor.torcode,
                torsubcode: tor.torsubcode,
                qualityHabaCd: habaCd,
                qualityHabaName: sourceName,
                qualityHabaResolveSource: resolvedQualityHaba.source
            });
        });
        return out;
    }
    function collectFukushizaiSourceItems() {
        const sourceItems = [];
        const rows = getDetailRowsByPanelType(entrydetailRef.current, FUKUSHIZAI_BASE_PANEL_TYPE);
        const debugSummary = {
            scannedRows: Array.isArray(rows) ? rows.length : 0,
            extractedCandidates: 0,
            excludedCandidates: 0,
            excludeReasons: {}
        };
        const addExcludeReason = (reason) => {
            debugSummary.excludedCandidates += 1;
            debugSummary.excludeReasons[reason] = (Number(debugSummary.excludeReasons[reason]) || 0) + 1;
        };
        const orderContext = {
            itemOrderMap: buildFukushizaiListItemOrderMap(rows),
            groupOrderMap: buildFukushizaiListGroupOrderMap(rows)
        };
        (Array.isArray(rows) ? rows : []).forEach((row, rowIndex) => {
            if (isEmpty(row)) {
                addExcludeReason("empty-row");
                return;
            }
            const rejectReason = fukushizaiDetail113SaveRejectReason(row);
            if (rejectReason !== "") {
                addExcludeReason(rejectReason);
                return;
            }
            const rowId = normalizeFukushizaiText(DicVal(row, "rowid", rowIndex));
            const torkubun = normalizeFukushizaiListTorkubun(readFukushizaiRowField(row, "SSDZ_TORKUBUN"));
            const torcode = readFukushizaiRowField(row, "SSDZ_TORCODE");
            const torsubcode = readFukushizaiRowField(row, "SSDZ_TORSUBCODE");
            const sortIndexRaw = readRowValueIgnoreCase(row, "SSDZ_HYOJIJUN");
            const rowSortIndex = Number(String(sortIndexRaw ?? "").replace(/,/g, ""));
            const rowOrder = Number.isFinite(rowSortIndex) ? rowSortIndex : (rowIndex + 1);
            const context = readFukushizaiItemGroupFromAnyRow(row);
            const itemIndex = getFukushizaiListItemIndex(context.itemCd, orderContext.itemOrderMap, rowIndex + 1);
            const groupOrder = getFukushizaiListGroupOrder(context.itemCd, context.groupNo, orderContext.groupOrderMap);
            FUKUSHIZAI_LIST_FIELD_RULES.forEach((rule, ruleIndex) => {
                const fields = Array.isArray(rule.fields) ? rule.fields : [];
                fields.forEach((field, fieldIndex) => {
                    const rawCode = readFukushizaiRowField(row, field);
                    const code = extractMasterCodeFromDisplayValue(rawCode);
                    if (code === "") {
                        addExcludeReason("empty-code");
                        return;
                    }
                    const sourceKind = String(rule.kind ?? "");
                    const saveKind = resolveFukushizaiListKind(sourceKind, field);
                    const sourceName = resolveFukushizaiSourceFieldName(row, field, rawCode);
                    debugSummary.extractedCandidates += 1;
                    sourceItems.push({
                        sourceOrigin: "fukushizai",
                        sourceKind: sourceKind,
                        saveKind: saveKind,
                        kind: saveKind,
                        code: code,
                        sourceName,
                        displayName: sourceName,
                        sourceSectionId: FUKUSHIZAI_BASE_PANEL_TYPE,
                        sourceField: field,
                        sourceItemCd: context.itemCd,
                        sourceGroupNo: context.groupNo,
                        sourceColorCd: context.colorCd,
                        sourceRowIndex: rowIndex,
                        sourceRowId: rowId,
                        sectionOrder: 0,
                        ruleOrder: ruleIndex,
                        sortKind: ruleIndex,
                        itemIndex,
                        groupOrder,
                        rowOrder,
                        fieldOrder: fieldIndex,
                        sortIndex: fukushizaiSourceSortValue(ruleIndex, itemIndex, groupOrder, rowOrder, fieldIndex),
                        torkubun: torkubun,
                        torcode: torcode,
                        torsubcode: torsubcode
                    });
                });
            });
        });
        // 品質表示幅は一覧反映・反映チェックの対象外(2026-08 仕様変更)。
        // 品質表示(118/119)由来のsource(collectQualityDisplaySourceItems)はここに連結しない。
        sourceItems.sort(compareFukushizaiListSourceItems);
        debugFukushizaiSyncLog("[Kakousiji][fukushizai list reflect source]", {
            scannedDetail113Rows: debugSummary.scannedRows,
            extractedCandidateCount: debugSummary.extractedCandidates,
            excludedCandidateCount: debugSummary.excludedCandidates,
            excludeReasons: debugSummary.excludeReasons,
            finalCandidateCount: sourceItems.length
        });
        return sourceItems;
    }
    function buildExistingFukushizaiListRowMap(existingRows) {
        const map = {};
        if (!Array.isArray(existingRows) || existingRows.length === 0) return map;
        existingRows.forEach((row, index) => {
            if (isEmpty(row) || typeof row !== "object") return;
            const kind = readFukushizaiRowField(row, "SSDZM_FUSIZAIKBN");
            const code = readFukushizaiRowField(row, "SSDZM_FUZOKU_HINBAN");
            const torkubun = normalizeFukushizaiListTorkubun(readFukushizaiRowField(row, "SSDZM_TORKUBUN"));
            const torcode = readFukushizaiRowField(row, "SSDZM_TORCODE");
            const torsubcode = readFukushizaiRowField(row, "SSDZM_TORSUBCODE");
            if (kind === "" && code === "" && torcode === "" && torsubcode === "") return;
            const key = buildFukushizaiListKey(kind, code, torkubun, torcode, torsubcode);
            map[key] = { row, index, key };
        });
        return map;
    }
    function hasFukushizaiRowStaleFields(row) {
        if (isEmpty(row) || typeof row !== "object") return false;
        const keyFields = [
            "SSDZM_FUSIZAIKBN",
            "SSDZM_FUZOKU_HINBAN",
            "SSDZM_TORKUBUN",
            "SSDZM_TORCODE",
            "SSDZM_TORSUBCODE",
            "SSDZM_YOJAKUKOSU",
            "SSDZM_TANKA",
            "SSDZM_TANKAF",
            "SSDZM_CUR",
            "SSDZM_MITUMORIRATE",
            "SSDZM_LOSSRITU",
            "SSDZM_LSURYO",
            "SSDZM_SIKYUKBN",
            "SSDZM_HACHUTAISYOFLG",
            "SSDZM_HACHUJYOKYOFLG",
            "SSDZM_FUKUSIZAIHACHUDENNO",
            "SSDZM_GENKADSPFLG"
        ];
        return keyFields.some((field) => readFukushizaiRowField(row, field) !== "");
    }
    function countFukushizaiDebugRows(rows) {
        return (Array.isArray(rows) ? rows : []).filter((row) => !isEmpty(row) && typeof row === "object").length;
    }
    // 一覧反映用の副資材sourceを112表示行へまとめる。
    function buildFukushizaiListRowsFromSourceItems(sourceItems, existingRows) {
        const existingMap = buildExistingFukushizaiListRowMap(existingRows);
        const usedKeys = new Set();
        const nextRows = [];
        const sourceList = (Array.isArray(sourceItems) ? [...sourceItems] : []).sort(compareFukushizaiListSourceItems);
        const kindOrderCounters = {};
        const sourceUsedKeys = new Set();
        let duplicateSourceCount = 0;
        sourceList.forEach((sourceItem, index) => {
            const saveKind = normalizeFukushizaiText(DicVal(sourceItem, "saveKind", DicVal(sourceItem, "kind", "")));
            const key = buildFukushizaiListKey(saveKind, sourceItem.code, sourceItem.torkubun, sourceItem.torcode, sourceItem.torsubcode);
            if (sourceUsedKeys.has(key)) {
                duplicateSourceCount += 1;
                debugFukushizaiSyncLog("[Kakousiji][fukushizai list reflect duplicate]", {
                    duplicateKey: key,
                    sourceColumnId: sourceItem.sourceField,
                    sourceCode: sourceItem.code,
                    sourceItemCd: sourceItem.sourceItemCd,
                    sourceGroupNo: sourceItem.sourceGroupNo,
                    sourceColorCd: sourceItem.sourceColorCd
                });
                return;
            }
            sourceUsedKeys.add(key);
            const hit = DicVal(existingMap, key, null);
            const base = isEmpty(hit) ? {} : DeepCopy(hit.row);
            if (!isEmpty(hit)) usedKeys.add(key);
            base.rowid = String(nextRows.length);
            base.SSDZM_NO = normalizeFukushizaiText(entrydataRef.current?.SSD_NO);
            base.SSDZM_OPPICD = normalizeFukushizaiText(entrydataRef.current?.SSD_OPPICD);
            base.SSDZM_TORKUBUN = normalizeFukushizaiListTorkubun(sourceItem.torkubun);
            base.SSDZM_TORCODE = normalizeFukushizaiText(sourceItem.torcode);
            base.SSDZM_TORSUBCODE = normalizeFukushizaiText(sourceItem.torsubcode);
            const nextCode = normalizeFukushizaiText(sourceItem.code);
            const previousDisplayCode = normalizeFukushizaiText(base.SSDZM_FUZOKU_HINBAN_cd);
            const previousDisplayName = normalizeFukushizaiDisplayName(base.SSDZM_FUZOKU_HINBAN_nm);
            const sourceName = normalizeFukushizaiDisplayName(DicVal(sourceItem, "sourceName", DicVal(sourceItem, "displayName", "")));
            base.SSDZM_FUZOKU_HINBAN = nextCode;
            base.SSDZM_FUZOKU_HINBAN_cd = nextCode;
            if (sourceName !== "") {
                base.SSDZM_FUZOKU_HINBAN_nm = sourceName;
            } else if (previousDisplayName !== "" && previousDisplayCode === nextCode) {
                base.SSDZM_FUZOKU_HINBAN_nm = previousDisplayName;
            } else if (previousDisplayName !== "" && previousDisplayCode !== nextCode) {
                base.SSDZM_FUZOKU_HINBAN_nm = "";
            } else {
                base.SSDZM_FUZOKU_HINBAN_nm = "";
            }
            base.SSDZM_FUSIZAIKBN = saveKind;
            if (normalizeFukushizaiText(base.SSDZM_YOJAKUKOSU) === "") base.SSDZM_YOJAKUKOSU = "1";
            const kindKey = saveKind;
            kindOrderCounters[kindKey] = (Number(kindOrderCounters[kindKey]) || 0) + 1;
            base.SSDZM_HYOJIJUN = String(kindOrderCounters[kindKey]);
            nextRows.push(recalcFukushizaiListCalcRow(base));
        });
        const staleRows = [];
        if (Array.isArray(existingRows)) {
            existingRows.forEach((row) => {
                if (isEmpty(row) || typeof row !== "object") return;
                if (!hasFukushizaiRowStaleFields(row)) return;
                const kind = readFukushizaiRowField(row, "SSDZM_FUSIZAIKBN");
                const code = readFukushizaiRowField(row, "SSDZM_FUZOKU_HINBAN");
                const torkubun = normalizeFukushizaiListTorkubun(readFukushizaiRowField(row, "SSDZM_TORKUBUN"));
                const torcode = readFukushizaiRowField(row, "SSDZM_TORCODE");
                const torsubcode = readFukushizaiRowField(row, "SSDZM_TORSUBCODE");
                const key = buildFukushizaiListKey(kind, code, torkubun, torcode, torsubcode);
                if (!usedKeys.has(key)) staleRows.push(row);
            });
        }
                debugFukushizaiSyncLog("[Kakousiji][fukushizai list reflect build]", {
            scannedCandidateCount: sourceList.length,
            duplicateCandidateCount: duplicateSourceCount,
            existingRowsCount: countFukushizaiDebugRows(existingRows),
            existingKeyCount: Object.keys(existingMap).length,
            finalRowsCount: nextRows.length,
            finalKeyCount: fukushizaiListCompositionKeysFromRows(nextRows).length,
            staleRowsCount: staleRows.length
        });
        return { rows: nextRows, staleRows, sourceItems: sourceList };
    }
    function fukushizaiListCompositionKeyFromRow(row) {
        if (isEmpty(row) || typeof row !== "object") return "";
        const kind = readFukushizaiRowField(row, "SSDZM_FUSIZAIKBN");
        const code = readFukushizaiRowField(row, "SSDZM_FUZOKU_HINBAN");
        const torkubun = normalizeFukushizaiListTorkubun(readFukushizaiRowField(row, "SSDZM_TORKUBUN"));
        const torcode = readFukushizaiRowField(row, "SSDZM_TORCODE");
        const torsubcode = readFukushizaiRowField(row, "SSDZM_TORSUBCODE");
        if (kind === "" && code === "" && torcode === "" && torsubcode === "") return "";
        return buildFukushizaiListKey(kind, code, torkubun, torcode, torsubcode);
    }
    function fukushizaiListCompositionKeysFromRows(rows) {
        return [...new Set((Array.isArray(rows) ? rows : [])
            .map((row) => fukushizaiListCompositionKeyFromRow(row))
            .filter((key) => key !== ""))]
            .sort((a, b) => a.localeCompare(b, "ja", { numeric: true, sensitivity: "base" }));
    }
    function fukushizaiListCompositionKeysFromSourceItems(sourceItems) {
        return [...new Set((Array.isArray(sourceItems) ? sourceItems : [])
            .map((item) => buildFukushizaiListKey(
                DicVal(item, "saveKind", DicVal(item, "kind", "")),
                DicVal(item, "code", ""),
                DicVal(item, "torkubun", ""),
                DicVal(item, "torcode", ""),
                DicVal(item, "torsubcode", "")
            ))
            .filter((key) => key.replace(/\|/g, "") !== ""))]
            .sort((a, b) => a.localeCompare(b, "ja", { numeric: true, sensitivity: "base" }));
    }
    function fukushizaiListKeysEqual(left, right) {
        const a = Array.isArray(left) ? left : [];
        const b = Array.isArray(right) ? right : [];
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    function applyFukushizaiListReflect(section) {
        if (String(DicVal(section, "id", "")) !== FUKUSHIZAI_LIST_TARGET_SECTION_ID) return;
        const targetPanel = resolveUiActionGridPanel(section);
        if (isEmpty(targetPanel)) {
            return;
        }
        syncFukushizaiBaseDirtyFieldsToDetail({
            context: selectedFukushizaiContextRef.current,
            timing: "list-reflect-before-source",
            reason: "before-list-reflect"
        });
        flushFukushizaiDisplayGridsToDetail({
            context: selectedFukushizaiContextRef.current,
            dirtyOnly: false,
            stopEditing: true,
            timing: "list-reflect-before-source"
        });
        // 品質表示幅は一覧反映の対象外のため、附属品番解決(ResolveQualityHsituhaba)は不要。
        applyFukushizaiListReflectResolved(section, targetPanel);
    }
    function applyFukushizaiListReflectResolved(section, targetPanel) {
        if (String(DicVal(section, "id", "")) !== FUKUSHIZAI_LIST_TARGET_SECTION_ID || isEmpty(targetPanel)) return;
        const sourceItems = collectFukushizaiSourceItems();
        if (!Array.isArray(sourceItems) || sourceItems.length === 0) {
            return;
        }
                const existingRows = DeepCopy(GridData(targetPanel));
        const built = buildFukushizaiListRowsFromSourceItems(sourceItems, existingRows);
        if (!Array.isArray(built.rows) || built.rows.length === 0) return;
        debugFukushizaiSyncLog("[Kakousiji][fukushizai list reflect apply]", {
            existingRowsCount: countFukushizaiDebugRows(existingRows),
            existingKeyCount: fukushizaiListCompositionKeysFromRows(existingRows).length,
            sourceItemCount: sourceItems.length,
            sourceKeyCount: fukushizaiListCompositionKeysFromSourceItems(sourceItems).length,
            builtRowsCount: countFukushizaiDebugRows(built.rows),
            builtKeyCount: fukushizaiListCompositionKeysFromRows(built.rows).length,
            staleRowsCount: countFukushizaiDebugRows(built.staleRows)
        });
        SetGridData(targetPanel, built.rows);
        applyGridRowsNow(targetPanel, built.rows);
        updateSagefudaItemFlags();
        fnc.current.modify(true);
        rerender();
    }
    // ---------------------------------------------------------------------
    // 受注数・納品予定の行整形と集計
    // ---------------------------------------------------------------------
    // 受注数の明細行を「カラー計」「数量合計」付きへ整形する。
    function normalizeJutyuRows(rows) {
        return demandRowNormalizer.normalizeJutyuRows(rows);
    }
    // 納品予定の明細行から集計2行（見出し/計）を作成する。
    function normalizeNouhinYoteiRows(rows) {
        return demandRowNormalizer.normalizeNouhinYoteiRows(rows);
    }
    // ---------------------------------------------------------------------
    // 原価の行・列マッピングと編集制御
    // ---------------------------------------------------------------------
    // 原価: 内部行キー（IDベース）定義。判定はこのキーのみで行う。
    const genkaRowDefs = [
        { key: "MAT_AMOUNT", label: "素材金額" },
        { key: "MAT_LOSS", label: "素材ロス率" },
        { key: "MAT_TOTAL", label: "素材金額計" },
        { key: "SUB_AMOUNT", label: "附属金額" },
        { key: "SUB_LOSS", label: "附属ロス率" },
        { key: "NAME_AMOUNT", label: "ネーム類" },
        { key: "DELIVERY_MAT", label: "納品資材" },
        { key: "ETC_LOSS", label: "その他附属ロス率" },
        { key: "SUB_TOTAL", label: "附属金額計" },
        { key: "PROCESS", label: "加工賃" },
        { key: "PRODUCT", label: "商品金額" },
        { key: "SECONDARY", label: "二次加工賃" },
        { key: "MARGIN", label: "マージン％" },
        { key: "EXPENSE_OUT", label: "輸出諸掛" },
        { key: "EXPENSE_IN", label: "輸入諸掛" },
        { key: "TARIFF", label: "輸入関税" },
        { key: "ZAN8", label: "暫８金額" },
        { key: "POST_SUB", label: "後付附属金額" },
        { key: "DOMESTIC_WORK", label: "国内作業" },
        { key: "ADJUST", label: "調整" },
        { key: "EST_COST", label: "見積原価" }
    ];
    const genkaRowKeyOrder = genkaRowDefs.map((e) => e.key);
    const genkaRowLabelByKey = genkaRowDefs.reduce((m, e) => { m[e.key] = e.label; return m; }, {});
    const genkaRowKeyByLabel = (() => {
        const m = {};
        genkaRowDefs.forEach((e) => {
            m[normalizeGenkaItemLabel(e.label)] = e.key;
        });
        return m;
    })();
    // 原価: 構成比率表示対象（仕様書寄せ）
    const genkaKouseiEnabledRows = {
        MAT_TOTAL: true,
        SUB_TOTAL: true,
        PROCESS: true,
        SECONDARY: true,
        ADJUST: true,
        EST_COST: false
    };
    function isGenkaKouseiEnabledRow(rowKey, patternNo) {
        if (rowKey === "EST_COST") return false;
        if (rowKey === "PRODUCT") return Number(patternNo) === 3;
        return isEnabled(genkaKouseiEnabledRows[rowKey]);
    }
    // 原価合計: 右側項目（定義書Column ID基準）
    const genkaSummaryDefs = [
        { id: "SSDGM_BOUEKIJYOKEN", label: "貿易条件区分", value: ["SSDGM_BOUEKIJYOKEN"], value2: ["SSDGM_FOBKINF"] },
        { id: "SSDGM_TSUKATANI", label: "通貨", value: ["SSDGM_TSUKATANI"] },
        { id: "SSDGM_RATE", label: "レート", value: ["SSDGM_RATE"] },
        { id: "SSDGM_FOBKIN", label: "小計", value: ["SSDGM_FOBKIN"] },
        { id: "SSDGM_SYOKAKARITAKA", label: "諸掛計", value: ["SSDGM_SYOKAKARITAKA"] },
        { id: "SSDGM_SEIHINGENKA", label: "仕入原価", value: ["SSDGM_SEIHINGENKA"] },
        { id: "SSDGM_JYODAI", label: "上代", value: ["SSDGM_JYODAI"] },
        { id: "SSDGM_JYODAIRITU", label: "設定率", value: ["SSDGM_JYODAIRITU"] },
        { id: "SSDGM_HACHUTANKA", label: "発注単価", value: ["SSDGM_HACHUTANKA"] },
        { id: "SSDGM_HACHUTANKAF", label: "発注単価（外）", value: ["SSDGM_HACHUTANKAF"] },
        { id: "SSDGM_FIXTANKA", label: "確定単価", value: ["SSDGM_FIXTANKA"] },
        { id: "SSDGM_FIXTANKAF", label: "確定単価（外）", value: ["SSDGM_FIXTANKAF"] }
    ];
    const GENKA_TRADE_CONDITION_DATAID = "m_code:0033";
    const genkaSummaryOrder = genkaSummaryDefs.map((d) => d.id);
    const genkaSummaryLabelById = genkaSummaryDefs.reduce((m, d) => {
        m[String(d.id).toUpperCase()] = d.label;
        return m;
    }, {});
    function buildGenkaCellKey(rowName, colId) {
        const rowKey = toGenkaRowKey(rowName);
        const slot = genkaColSlot(colId);
        if (rowKey === "" || slot === "") return "";
        return rowKey + "::" + slot;
    }
    function createGenkaEditableCellSet(groups) {
        const set = new Set();
        if (groups === null || typeof groups !== "object") return set;
        Object.keys(groups).forEach((slot) => {
            const rows = Array.isArray(groups[slot]) ? groups[slot] : [];
            rows.forEach((rowName) => {
                const key = buildGenkaCellKey(rowName, slot);
                if (key !== "") set.add(key);
            });
        });
        return set;
    }
    // 原価: パターン1?9のセル単位編集可否（白/灰表示の元データ）。
    // 仕様書の白背景セルのみ editable=true とする。
    const GENKA_PATTERN_EDITABLE_CELLS = {
        1: createGenkaEditableCellSet({
            muryo: ["MAT_AMOUNT", "MAT_LOSS", "SUB_AMOUNT", "SUB_LOSS", "SECONDARY", "ADJUST", "EST_COST"],
            kojo: ["PROCESS", "MARGIN", "EST_COST"]
        }),
        2: createGenkaEditableCellSet({
            yusho: ["MAT_AMOUNT", "MAT_LOSS", "MAT_TOTAL"],
            kojo: ["SUB_AMOUNT", "SUB_LOSS", "NAME_AMOUNT", "DELIVERY_MAT", "ETC_LOSS", "SUB_TOTAL", "PROCESS", "SECONDARY", "MARGIN", "ADJUST", "EST_COST"]
        }),
        3: createGenkaEditableCellSet({
            muryo: ["SUB_AMOUNT", "SUB_LOSS", "NAME_AMOUNT", "DELIVERY_MAT", "ETC_LOSS", "SUB_TOTAL", "SECONDARY", "EST_COST"],
            kojo: ["PRODUCT", "ADJUST", "EST_COST"]
        }),
        4: createGenkaEditableCellSet({
            muryo: ["MAT_AMOUNT", "MAT_LOSS", "MAT_TOTAL", "SUB_AMOUNT", "SUB_LOSS", "NAME_AMOUNT", "DELIVERY_MAT", "ETC_LOSS", "SUB_TOTAL", "EXPENSE_OUT", "EXPENSE_IN", "TARIFF", "ZAN8", "POST_SUB", "DOMESTIC_WORK", "ADJUST", "EST_COST"],
            kojo: ["PROCESS", "EST_COST"]
        }),
        5: createGenkaEditableCellSet({
            muryo: ["MAT_AMOUNT", "MAT_LOSS", "MAT_TOTAL", "SUB_AMOUNT", "SUB_LOSS", "NAME_AMOUNT", "DELIVERY_MAT", "ETC_LOSS", "SUB_TOTAL", "EXPENSE_OUT", "EXPENSE_IN", "TARIFF", "ZAN8", "POST_SUB", "DOMESTIC_WORK", "ADJUST", "EST_COST"],
            kojo: ["PROCESS", "EST_COST"],
            kojo_f: ["PROCESS", "EST_COST"]
        }),
        6: createGenkaEditableCellSet({
            yusho: ["MAT_AMOUNT", "MAT_LOSS", "MAT_TOTAL", "SUB_AMOUNT", "SUB_LOSS", "NAME_AMOUNT", "DELIVERY_MAT", "ETC_LOSS", "SUB_TOTAL", "EXPENSE_OUT", "EXPENSE_IN", "TARIFF", "ZAN8", "POST_SUB", "DOMESTIC_WORK", "ADJUST"],
            kojo: ["PROCESS", "MARGIN", "EST_COST"]
        }),
        7: createGenkaEditableCellSet({
            yusho: ["MAT_AMOUNT", "MAT_LOSS", "MAT_TOTAL", "SUB_AMOUNT", "SUB_LOSS", "NAME_AMOUNT", "DELIVERY_MAT", "ETC_LOSS", "SUB_TOTAL", "EXPENSE_OUT", "EXPENSE_IN", "TARIFF", "ZAN8", "POST_SUB", "DOMESTIC_WORK", "ADJUST", "EST_COST"],
            yusho_f: ["MAT_AMOUNT", "MAT_LOSS", "MAT_TOTAL", "SUB_AMOUNT", "SUB_LOSS", "NAME_AMOUNT", "ETC_LOSS", "SUB_TOTAL", "SECONDARY", "EST_COST"],
            kojo: ["PROCESS", "EST_COST"],
            kojo_f: ["PROCESS", "EST_COST"]
        }),
        8: createGenkaEditableCellSet({
            muryo: ["SUB_AMOUNT", "SUB_LOSS", "NAME_AMOUNT", "DELIVERY_MAT", "ETC_LOSS", "SUB_TOTAL", "EXPENSE_OUT", "EXPENSE_IN", "TARIFF", "ZAN8", "POST_SUB", "DOMESTIC_WORK", "EST_COST"],
            kojo: ["PRODUCT", "ADJUST", "EST_COST"]
        }),
        9: createGenkaEditableCellSet({
            muryo: ["SUB_AMOUNT", "SUB_LOSS", "NAME_AMOUNT", "DELIVERY_MAT", "ETC_LOSS", "SUB_TOTAL", "EXPENSE_OUT", "EXPENSE_IN", "TARIFF", "ZAN8", "POST_SUB", "DOMESTIC_WORK", "EST_COST"],
            kojo: ["PRODUCT", "EST_COST"],
            kojo_f: ["PRODUCT", "EST_COST"]
        })
    };
    // 原価: DB定義書 Column ID（大文字）基準の完全一致マップ
    const genkaColumnMapByColumnIdUpper = {
        "SSDGM_KIJIKIN_MSIKYU": { row: "MAT_AMOUNT", cols: ["muryo"] },
        "SSDGM_KIJIKIN_YSIKYU": { row: "MAT_AMOUNT", cols: ["yusho"] },
        "SSDGM_KIJIKIN_YSIKYUF": { row: "MAT_AMOUNT", cols: ["yusho_f"] },
        "SSDGM_KIJIKIN_KTEHAI": { row: "MAT_AMOUNT", cols: ["kojo"] },
        "SSDGM_KIJIKIN_KTEHAIF": { row: "MAT_AMOUNT", cols: ["kojo_f"] },
        "SSDGM_KIJILOSRITU_MSIKYU": { row: "MAT_LOSS", cols: ["muryo"] },
        "SSDGM_KIJILOSRITU_YSIKYU": { row: "MAT_LOSS", cols: ["yusho", "yusho_f"] },
        "SSDGM_KIJILOSRITU_KTEHAI": { row: "MAT_LOSS", cols: ["kojo", "kojo_f"] },
        "SSDGM_FUZOKUKIN_MSIKYU": { row: "SUB_AMOUNT", cols: ["muryo"] },
        "SSDGM_FUZOKUKIN_YSIKYU": { row: "SUB_AMOUNT", cols: ["yusho"] },
        "SSDGM_FUZOKUKIN_YSIKYUF": { row: "SUB_AMOUNT", cols: ["yusho_f"] },
        "SSDGM_FUZOKUKIN_KTEHAI": { row: "SUB_AMOUNT", cols: ["kojo"] },
        "SSDGM_FUZOKUKIN_KTEHAIF": { row: "SUB_AMOUNT", cols: ["kojo_f"] },
        "SSDGM_FUZOKULOSRITU_MSIKYU": { row: "SUB_LOSS", cols: ["muryo"] },
        "SSDGM_FUZOKULOSRITU_YSIKYU": { row: "SUB_LOSS", cols: ["yusho", "yusho_f"] },
        "SSDGM_FUZOKULOSRITU_KTEHAI": { row: "SUB_LOSS", cols: ["kojo", "kojo_f"] },
        "SSDGM_NAMEKIN_MSIKYU": { row: "NAME_AMOUNT", cols: ["muryo"] },
        "SSDGM_NAMEKIN_YSIKYU": { row: "NAME_AMOUNT", cols: ["yusho"] },
        "SSDGM_NAMEKIN_YSIKYUF": { row: "NAME_AMOUNT", cols: ["yusho_f"] },
        "SSDGM_NAMEKIN_KTEHAI": { row: "NAME_AMOUNT", cols: ["kojo"] },
        "SSDGM_NAMEKIN_KTEHAIF": { row: "NAME_AMOUNT", cols: ["kojo_f"] },
        "SSDGM_SIZAIKIN_MSIKYU": { row: "DELIVERY_MAT", cols: ["muryo"] },
        "SSDGM_SIZAIKIN_YSIKYU": { row: "DELIVERY_MAT", cols: ["yusho"] },
        "SSDGM_SIZAIKIN_YSIKYUF": { row: "DELIVERY_MAT", cols: ["yusho_f"] },
        "SSDGM_SIZAIKIN_KTEHAI": { row: "DELIVERY_MAT", cols: ["kojo"] },
        "SSDGM_SIZAIKIN_KTEHAIF": { row: "DELIVERY_MAT", cols: ["kojo_f"] },
        "SSDGM_NAMESIZAILOSRITU_MSIKYU": { row: "ETC_LOSS", cols: ["muryo"] },
        "SSDGM_NAMESIZAILOSRITU_YSIKYU": { row: "ETC_LOSS", cols: ["yusho", "yusho_f"] },
        "SSDGM_NAMESIZAILOSRITU_KTEHAI": { row: "ETC_LOSS", cols: ["kojo", "kojo_f"] },
        "SSDGM_KAKOKIN_KTEHAI": { row: "PROCESS", cols: ["kojo"] },
        "SSDGM_KAKOKIN_KTEHAIF": { row: "PROCESS", cols: ["kojo_f"] },
        "SSDGM_SHOHINKIN_KTEHAI": { row: "PRODUCT", cols: ["kojo"] },
        "SSDGM_SHOHINKIN_KTEHAIF": { row: "PRODUCT", cols: ["kojo_f"] },
        "SSDGM_NKAKOKIN_MSIKYU": { row: "SECONDARY", cols: ["muryo"] },
        "SSDGM_NKAKOKIN_YSIKYU": { row: "SECONDARY", cols: ["yusho"] },
        "SSDGM_NKAKOKIN_YSIKYUF": { row: "SECONDARY", cols: ["yusho_f"] },
        "SSDGM_NKAKOKIN_KTEHAI": { row: "SECONDARY", cols: ["kojo"] },
        "SSDGM_NKAKOKIN_KTEHAIF": { row: "SECONDARY", cols: ["kojo_f"] },
        "SSDGM_MARGINKIN_YSIKYU": { row: "MARGIN", cols: ["yusho"] },
        "SSDGM_MARGINKIN_KTEHAI": { row: "MARGIN", cols: ["kojo", "kojo_f"] },
        "SSDGM_EXPSYOKAKARIKIN_MSIKYU": { row: "EXPENSE_OUT", cols: ["muryo"] },
        "SSDGM_EXPSYOKAKARIKIN_YSIKYU": { row: "EXPENSE_OUT", cols: ["yusho"] },
        "SSDGM_IMPSYOKAKARIKIN_MSIKYU": { row: "EXPENSE_IN", cols: ["muryo"] },
        "SSDGM_IMPSYOKAKARIKIN_YSIKYU": { row: "EXPENSE_IN", cols: ["yusho"] },
        "SSDGM_IMPKANZEI_MSIKYU": { row: "TARIFF", cols: ["muryo"] },
        "SSDGM_IMPKANZEI_YSIKYU": { row: "TARIFF", cols: ["yusho"] },
        "SSDGM_ZANTEIKIN_MSIKYU": { row: "ZAN8", cols: ["muryo"] },
        "SSDGM_ZANTEIKIN_YSIKYU": { row: "ZAN8", cols: ["yusho"] },
        "SSDGM_ATOFUZOKUKIN_MSIKYU": { row: "POST_SUB", cols: ["muryo"] },
        "SSDGM_ATOFUZOKUKIN_YSIKYU": { row: "POST_SUB", cols: ["yusho"] },
        "SSDGM_KOKUSAGYOKIN_MSIKYU": { row: "DOMESTIC_WORK", cols: ["muryo"] },
        "SSDGM_KOKUSAGYOKIN_YSIKYU": { row: "DOMESTIC_WORK", cols: ["yusho"] },
        "SSDGM_CHOUSEIKIN_MSIKYU": { row: "ADJUST", cols: ["muryo"] },
        "SSDGM_CHOUSEIKIN_YSIKYU": { row: "ADJUST", cols: ["yusho"] },
        "SSDGM_CHOUSEIKIN_KTEHAI": { row: "ADJUST", cols: ["kojo"] },
        "SSDGM_MITUMORIGENKA_MSIKYU": { row: "EST_COST", cols: ["muryo"] },
        "SSDGM_MITUMORIGENKA_YSIKYU": { row: "EST_COST", cols: ["yusho"] },
        "SSDGM_MITUMORIGENKA_YSIKYUF": { row: "EST_COST", cols: ["yusho_f"] },
        "SSDGM_MITUMORIGENKA_KTEHAI": { row: "EST_COST", cols: ["kojo"] },
        "SSDGM_MITUMORIGENKA_KTEHAIF": { row: "EST_COST", cols: ["kojo_f"] }
    };
    // 原価合計（右側）: 行IDごとのColumn ID候補（定義書Column ID基準）
    const genkaSummaryColumnCandidates = genkaSummaryDefs.reduce((m, d) => {
        m[d.id] = {
            value: Array.isArray(d.value) ? [...d.value] : [],
            value2: Array.isArray(d.value2) ? [...d.value2] : []
        };
        return m;
    }, {});
    // 原価右合計: any summary-related Column ID -> 行ID
    const genkaSummaryRowIdByColumnIdUpper = (() => {
        const m = {};
        genkaSummaryDefs.forEach((d) => {
            const ids = [d.id, ...(d.value || []), ...(d.value2 || [])];
            ids.forEach((cid) => {
                const upper = String(cid ?? "").trim().toUpperCase();
                if (upper !== "") m[upper] = String(d.id).toUpperCase();
            });
        });
        return m;
    })();
    // 原価右合計: total_item は Column ID のみ許可する。
    function resolveGenkaSummaryItem(itemLike) {
        const upper = normalizeColumnIdUpper(itemLike);
        if (upper === "") return "";
        return DicVal(genkaSummaryRowIdByColumnIdUpper, upper, "");
    }
    // 原価右合計: 主キー行ID（Column ID）
    function resolveGenkaSummaryKeyId(itemLike) {
        return resolveGenkaSummaryItem(itemLike);
    }
    // 候補Column IDから、現在画面で有効な正規IDを選ぶ。
    function resolveEntryColumnId(candidates, entryObj) {
        if (!Array.isArray(candidates) || candidates.length === 0) return "";
        const uppers = candidates.map(c => String(c ?? "").trim().toUpperCase()).filter(c => c !== "");
        if (uppers.length === 0) return "";
        if (Array.isArray(columninfo) && columninfo.length !== 0) {
            const hit = columninfo.find(c => uppers.includes(String(c.columnid ?? "").trim().toUpperCase()));
            if (!isEmpty(hit)) return String(hit.columnid ?? "").trim();
        }
        const keys = isEmpty(entryObj) ? [] : Object.keys(entryObj);
        for (let i = 0; i < uppers.length; i++) {
            const byKey = keys.find(k => String(k ?? "").trim().toUpperCase() === uppers[i]);
            if (!isEmpty(byKey)) return String(byKey);
        }
        return uppers[0];
    }
    // 原価右「合計」行を entrydata へ反映する（保存用）。
    function applyGenkaSummaryRowsToEntryData(entryObj) {
        if (isEmpty(entryObj)) return;
        const genkaPanel = Array.isArray(gridlist) ? gridlist.find(g => isGenkaGridPanelInfo(g)) : null;
        const currentGenkaRows = isEmpty(genkaPanel) ? [] : GridData(genkaPanel);
        if (!hasActualGenkaEntryValues(entryObj)
            && !hasActualGenkaGridValues(currentGenkaRows)
            && !hasActualGenkaSummaryValues(currentGenkaSummaryRowsForActualCheck())) {
            return;
        }
        const keys = Object.keys(totalgriddataRefs.current || {});
        const resolvedType = normalizeTotalTypeForColumns(PANEL_TYPE.GENKA_SUMMARY, "genka");
        const preferred = [
            "19_" + String(resolvedType ?? ""),
            "19_" + String(PANEL_TYPE.GENKA_SUMMARY ?? "")
        ];
        const fallback = keys.filter((k) => {
            const s = String(k ?? "");
            return s.startsWith("19_") || s.startsWith("genka_");
        });
        const orderedKeys = [...new Set([...preferred, ...fallback])];
        const genkaKey = orderedKeys.find((k) => {
            const cur = DicVal(totalgriddataRefs.current, k, null);
            const rows = normalizeGenkaSummaryRows(DicVal(cur, "current", null));
            if (!Array.isArray(rows) || rows.length === 0) return false;
            return rows.some((r) => String(DicVal(r, "total_value", "") ?? "").trim() !== "" || String(DicVal(r, "total_value2", "") ?? "").trim() !== "");
        }) || orderedKeys[0];
        if (isEmpty(genkaKey)) return;
        const rows = normalizeGenkaSummaryRows(DicVal(DicVal(totalgriddataRefs.current, genkaKey, null), "current", null));
        if (!Array.isArray(rows) || rows.length === 0) return;

        rows.forEach((r) => {
            const item = resolveGenkaSummaryItem(DicVal(r, "total_key", "") || DicVal(r, "total_item", ""));
            if (item === "") return;
            const conf = genkaSummaryColumnCandidates[item];
            if (isEmpty(conf)) return;

            const v1 = String(DicVal(r, "total_value", "") ?? "").trim();
            const v2 = String(DicVal(r, "total_value2", "") ?? "").trim();

            const cid1 = resolveEntryColumnId(conf.value || [], entryObj);
            const cid2 = resolveEntryColumnId(conf.value2 || [], entryObj);

            if (cid1 !== "") {
                const keepValue1 = isGenkaKeepZeroSummaryField(item, false) || hasActualGenkaSummaryEntryValueForField(item, false);
                entryObj[cid1] = (v1 === "" || (isZeroLikeGenkaDisplayValue(v1) && !keepValue1)) ? "" : v1;
            }
            if (cid2 !== "") {
                const keepValue2 = isGenkaKeepZeroSummaryField(item, true) || hasActualGenkaSummaryEntryValueForField(item, true);
                entryObj[cid2] = (v2 === "" || (isZeroLikeGenkaDisplayValue(v2) && !keepValue2)) ? "" : v2;
            }
        });
    }
    // =====================================================================
    // 原価 126/127
    // ---------------------------------------------------------------------
    // 原価明細と原価サマリの表示、再計算、保存値反映を扱う。
    // 空欄由来の0と入力された0を区別する。
    // =====================================================================
    // ---------------------------------------------------------------------
    // 原価行の正規化・再計算
    // ---------------------------------------------------------------------
    // 原価行の表示設定と再計算の補助処理をまとめる。

    // 原価明細の行キーと表示名をパターン前提で正規化する。
    function normalizeGenkaRowsByPattern(rows) {
        if (!Array.isArray(rows) || rows.length === 0) return rows;
        return rows.map((r) => {
            const rowKey = toGenkaRowKey(DicVal(r, "row_key", "") || DicVal(r, "item_name", ""));
            return isEmpty(rowKey) ? r : {
                ...r,
                row_key: rowKey,
                item_name: String(genkaRowLabelByKey[rowKey] ?? DicVal(r, "item_name", ""))
            };
        });
    }
    // 原価（セル式優先）: 仕様書の実セル式を基準に、左グリッドと右合計を再計算する。
    const genkaCalcSlots = ["muryo", "muryo_f", "yusho", "yusho_f", "kojo", "kojo_f", "syokei", "syokei_f", "kousei"];
    const genkaSourceSlots = ["muryo", "muryo_f", "yusho", "yusho_f", "kojo", "kojo_f"];
    const genkaCalculatedRowKeys = ["MAT_TOTAL", "SUB_TOTAL", "EST_COST"];
    const genkaSummarySourceItems = ["SSDGM_BOUEKIJYOKEN", "SSDGM_JYODAI"];
    function toGenkaCalcNumber(value) {
        if (isEmpty(value)) return 0;
        const raw = String(value ?? "")
            .replace(/[,\s　]/g, "")
            .replace(/―/g, "-")
            .trim();
        if (raw === "" || raw === "-" || raw === "―") return 0;
        const n = Number(raw);
        return Number.isFinite(n) ? n : 0;
    }
    function roundGenkaCalc(value) {
        const n = Number(value);
        if (!Number.isFinite(n)) return 0;
        return Math.round((n + Number.EPSILON) * 1000000) / 1000000;
    }
    function calcRate(value) {
        return toGenkaCalcNumber(value) / 100;
    }
    function resetGenkaTouchedRef() {
        genkaTouchedRef.current = { cells: {}, summary: {} };
    }
    function genkaCellTouchKey(rowKey, slot) {
        const row = toGenkaRowKey(rowKey);
        const col = String(slot ?? "").trim().toLowerCase();
        if (row === "" || col === "") return "";
        return row + "::" + col;
    }
    function genkaSummaryTouchKey(item, field) {
        const key = resolveGenkaSummaryItem(item);
        const fld = String(field ?? "").trim().toLowerCase();
        if (key === "" || fld === "") return "";
        return key + "::" + fld;
    }
    function markGenkaTouchedCell(rowKey, slot) {
        const touchKey = genkaCellTouchKey(rowKey, slot);
        if (touchKey === "") return;
        genkaTouchedRef.current.cells[touchKey] = true;
    }
    function markGenkaTouchedCellByColumnId(columnId) {
        const cid = normalizeColumnIdUpper(columnId);
        if (cid === "") return;
        genkaTouchedRef.current.cells[cid] = true;
    }
    function isGenkaTouchedColumnId(columnId) {
        const cid = normalizeColumnIdUpper(columnId);
        if (cid === "") return false;
        return genkaTouchedRef.current.cells[cid] === true;
    }
    function markGenkaTouchedSummary(item, field) {
        const touchKey = genkaSummaryTouchKey(item, field);
        if (touchKey === "") return;
        genkaTouchedRef.current.summary[touchKey] = true;
    }
    function isGenkaTouchedCell(rowKey, slot) {
        const touchKey = genkaCellTouchKey(rowKey, slot);
        if (touchKey === "") return false;
        return genkaTouchedRef.current.cells[touchKey] === true;
    }
    function isGenkaTouchedSummary(item, field) {
        const touchKey = genkaSummaryTouchKey(item, field);
        if (touchKey === "") return false;
        return genkaTouchedRef.current.summary[touchKey] === true;
    }
    function isGenkaKeepZeroColumnId(columnId) {
        const cid = normalizeColumnIdUpper(columnId);
        if (cid === "") return false;
        const conf = genkaSummaryColumnCandidates["SSDGM_BOUEKIJYOKEN"];
        const ids = [...(DicVal(conf, "value", []) || [])]
            .map(v => normalizeColumnIdUpper(v));
        return ids.includes(cid);
    }
    function hasActualEntryValueByColumnId(entryObj, columnId) {
        if (isEmpty(entryObj) || isEmpty(columnId)) return false;
        const target = String(columnId ?? "").trim().toUpperCase();
        const keys = Object.keys(entryObj);
        const key = keys.find((k) => String(k ?? "").trim().toUpperCase() === target);
        if (isEmpty(key)) return false;
        const raw = String(entryObj[key] ?? "").trim();
        return isMeaningfulGenkaValue(raw, isGenkaTouchedColumnId(target) || isGenkaKeepZeroColumnId(target));
    }
    function hasActualGenkaEntryValues(entryObj) {
        if (isEmpty(entryObj)) return false;
        const leftColumnIds = Object.keys(genkaColumnMapByColumnIdUpper || {});
        if (leftColumnIds.some((cid) => hasActualEntryValueByColumnId(entryObj, cid))) return true;
        return genkaSummarySourceItems.some((item) => {
            const conf = genkaSummaryColumnCandidates[item];
            if (isEmpty(conf)) return false;
            const ids = [...(conf.value || []), ...(conf.value2 || [])];
            return ids.some((cid) => hasActualEntryValueByColumnId(entryObj, cid));
        });
    }
    function hasActualGenkaEntryValueForCell(rowKey, slot) {
        const targetRow = toGenkaRowKey(rowKey);
        const targetSlot = String(slot ?? "");
        return Object.keys(genkaColumnMapByColumnIdUpper || {}).some((cid) => {
            const map = genkaColumnMapByColumnIdUpper[cid];
            if (toGenkaRowKey(DicVal(map, "row", "")) !== targetRow) return false;
            const slots = Array.isArray(DicVal(map, "cols", null)) ? map.cols : [];
            if (!slots.includes(targetSlot)) return false;
            return hasActualEntryValueByColumnId(entrydataRef.current, cid);
        });
    }
    function hasActualGenkaGridValues(rows) {
        if (!Array.isArray(rows) || rows.length === 0) return false;
        return rows.some((row) => {
            const rowKey = toGenkaRowKey(DicVal(row, "row_key", "") || DicVal(row, "item_name", ""));
            if (isEmpty(rowKey) || genkaCalculatedRowKeys.includes(rowKey)) return false;
            return genkaSourceSlots.some((slot) => {
                const raw = String(DicVal(row, slot, "") ?? "").trim();
                return isMeaningfulGenkaValue(raw, hasActualGenkaEntryValueForCell(rowKey, slot));
            });
        });
    }
    function hasActualGenkaSummaryValues(source) {
        if (Array.isArray(source)) {
            return source.some((row) => {
                const item = resolveGenkaSummaryItem(DicVal(row, "total_key", "") || DicVal(row, "total_item", ""));
                if (!genkaSummarySourceItems.includes(item)) return false;
                const raw1 = String(DicVal(row, "total_value", "") ?? "").trim();
                const raw2 = String(DicVal(row, "total_value2", "") ?? "").trim();
                const keep1 = isMeaningfulGenkaValue(raw1, hasActualGenkaSummaryEntryValueForField(item, false) || isGenkaKeepZeroSummaryField(item, false));
                const keep2 = isMeaningfulGenkaValue(raw2, hasActualGenkaSummaryEntryValueForField(item, true) || isGenkaKeepZeroSummaryField(item, true));
                return keep1 || keep2;
            });
        }
        if (isEmpty(source)) return false;
        return genkaSummarySourceItems.some((item) => {
            const conf = genkaSummaryColumnCandidates[item];
            if (isEmpty(conf)) return false;
            const ids = [...(conf.value || []), ...(conf.value2 || [])];
            return ids.some((cid) => hasActualEntryValueByColumnId(source, cid));
        });
    }
    function hasActualGenkaSummaryEntryValue(item) {
        const conf = genkaSummaryColumnCandidates[item];
        if (isEmpty(conf)) return false;
        const ids = [...(conf.value || []), ...(conf.value2 || [])];
        return ids.some((cid) => hasActualEntryValueByColumnId(entrydataRef.current, cid));
    }
    function currentGenkaSummaryRowsForActualCheck() {
        const keys = Object.keys(totalgriddataRefs.current || {});
        for (let i = 0; i < keys.length; i++) {
            const key = String(keys[i] ?? "");
            if (!key.startsWith("19_") && !key.startsWith("genka_")) continue;
            const rows = DicVal(DicVal(totalgriddataRefs.current, key, null), "current", null);
            if (Array.isArray(rows) && rows.length !== 0) return rows;
        }
        return [];
    }
    function hasActualGenkaRecalcSource(baseRows) {
        return hasActualGenkaEntryValues(entrydataRef.current)
            || hasActualGenkaGridValues(baseRows)
            || hasActualGenkaSummaryValues(currentGenkaSummaryRowsForActualCheck());
    }
    function resolveTempGenkaPatternNo() {
        return 0;
    }
    function getGenkaRowMap(rows) {
        const map = {};
        genkaRowKeyOrder.forEach((k) => { map[k] = emptyGenkaRow(k, genkaRowLabelByKey[k], "0"); });
        if (!Array.isArray(rows)) return map;
        rows.forEach((r, idx) => {
            const rowKey = toGenkaRowKey(DicVal(r, "row_key", "") || DicVal(r, "item_name", ""));
            if (isEmpty(rowKey) || isEmpty(map[rowKey])) return;
            const base = {
                ...map[rowKey],
                ...r,
                rowid: String(DicVal(r, "rowid", idx)),
                row_key: rowKey,
                item_name: String(genkaRowLabelByKey[rowKey] ?? DicVal(r, "item_name", ""))
            };
            genkaCalcSlots.forEach((slot) => {
                const raw = DicVal(r, slot, "");
                base[slot] = isEmpty(raw) ? "" : String(raw);
            });
            map[rowKey] = base;
        });
        return map;
    }
    function genkaMainSlotByPatternNo(no) {
        if ([2, 6, 7].includes(no)) return "yusho";
        return "muryo";
    }
    function genkaMainFSlotByPatternNo(no) {
        if (no === 7) return "yusho_f";
        return "muryo_f";
    }
    function genkaExpenseSlotByPatternNo(no) {
        if ([6, 7].includes(no)) return "yusho";
        return "muryo";
    }
    function genkaParsePatternNoForCalc() {
        const forced = resolveTempGenkaPatternNo();
        if (forced !== 0) return forced;
        const stateNo = Number(genkaPatternNo);
        if (Number.isFinite(stateNo) && stateNo !== 0) return stateNo;
        const derived = Number(deriveGenkaPatternFromEntry(entrydataRef.current));
        if (Number.isFinite(derived)) return derived;
        const m = String(genkaPattern ?? "").match(/^\s*(\d+)/);
        if (!isEmpty(m)) return Number(m[1]);
        return 0;
    }
    function getGenkaSummaryBaseRows(options = {}) {
        const keys = Object.keys(totalgriddataRefs.current || {});
        const hitKey = keys.find((k) => {
            const s = String(k ?? "");
            return s.startsWith("19_") || s.startsWith("genka_");
        });
        if (!isEmpty(hitKey)) {
            const cur = DicVal(totalgriddataRefs.current, hitKey, null);
            if (!isEmpty(cur) && Array.isArray(cur.current) && cur.current.length !== 0) {
                return applyForcedGenkaJpyToSummaryRows(normalizeGenkaSummaryRows(cur.current));
            }
        }
        const rebuilt = buildGenkaSummaryRowsFromFlatData(entrydataRef.current);
        if (Array.isArray(rebuilt) && rebuilt.length !== 0) return applyForcedGenkaJpyToSummaryRows(normalizeGenkaSummaryRows(rebuilt));
        return applyForcedGenkaJpyToSummaryRows(defaultGenkaSummaryRows());
    }
    function setGenkaSummaryCell(summaryMap, item, field, value) {
        if (isEmpty(summaryMap) || isEmpty(summaryMap[item])) return;
        summaryMap[item][field] = String(value ?? "");
    }
    function genkaRateForLeftCalc(options = {}) {
        if (shouldForceGenkaCurrencyJpy(entrydataRef.current)) return 1;
        const rows = normalizeGenkaSummaryRows(getGenkaSummaryBaseRows(options));
        const rateRow = rows.find((r) => resolveGenkaSummaryItem(DicVal(r, "total_item", "") || DicVal(r, "total_key", "")) === "SSDGM_RATE");
        const raw = String(DicVal(rateRow, "total_value", "") ?? "").trim();
        if (raw === "") return 0;
        const rate = toGenkaCalcNumber(raw);
        return Number.isFinite(rate) ? rate : 0;
    }
    function applyGenkaForeignCurrencyToYen(rows, patternNo, rate) {
        if (![5, 7, 9].includes(Number(patternNo)) || rate === 0) return;
        const moneyRows = ["MAT_AMOUNT", "SUB_AMOUNT", "NAME_AMOUNT", "DELIVERY_MAT", "PROCESS", "SECONDARY", "PRODUCT"];
        const rateRows = ["MAT_LOSS", "SUB_LOSS", "ETC_LOSS", "MARGIN"];
        const pairs = Number(patternNo) === 7
            ? [{ from: "yusho_f", to: "yusho" }, { from: "kojo_f", to: "kojo" }]
            : [{ from: "kojo_f", to: "kojo" }];
        rateRows.forEach((rowKey) => {
            if (isEmpty(rows[rowKey])) return;
            pairs.forEach((pair) => {
                const raw = String(DicVal(rows[rowKey], pair.from, "") ?? "").trim();
                if (raw === "") return;
                rows[rowKey][pair.to] = raw;
            });
        });
        moneyRows.forEach((rowKey) => {
            if (isEmpty(rows[rowKey])) return;
            pairs.forEach((pair) => {
                const raw = String(DicVal(rows[rowKey], pair.from, "") ?? "").trim();
                if (raw === "") return;
                rows[rowKey][pair.to] = String(roundGenkaCalc(toGenkaCalcNumber(raw) * rate));
            });
        });
    }
    // 原価左グリッドの派生行を再計算する。
    // 入力セルは保持し、計算行のみ上書きする。
    // パターン1はExcelセル式に不足があるため、工場手配側の素材金額計/附属金額計を見積原価へ含める業務補正を行う。
    // 金額計・小計は表示上丸めるが、計算順序は既存仕様を維持する。
    function calcGenkaRowsByCellFormula(inputRows, options = {}) {
        const patternNo = genkaParsePatternNoForCalc();
        const main = genkaMainSlotByPatternNo(patternNo);
        const mainF = genkaMainFSlotByPatternNo(patternNo);
        const expenseSlot = genkaExpenseSlotByPatternNo(patternNo);
        const rows = getGenkaRowMap(inputRows);
        const n = (rowKey, slot) => toGenkaCalcNumber(DicVal(rows[rowKey], slot, 0));
        const has = (rowKey, slot) => String(DicVal(rows[rowKey], slot, "") ?? "").trim() !== "";
        const w = (rowKey, slot, value) => { rows[rowKey][slot] = String(roundGenkaCalc(value)); };
        const hasAny = (pairs) => pairs.some((p) => has(p[0], p[1]));
        const hasMainEstSource = (slot) => {
            const pairs = [
                ["MAT_TOTAL", slot],
                ["SUB_TOTAL", slot],
                ["SECONDARY", slot],
                ["ADJUST", slot]
            ];
            if (patternNo !== 1) {
                pairs.push(
                    ["EXPENSE_OUT", expenseSlot],
                    ["EXPENSE_IN", expenseSlot],
                    ["TARIFF", expenseSlot],
                    ["ZAN8", expenseSlot],
                    ["POST_SUB", expenseSlot],
                    ["DOMESTIC_WORK", expenseSlot]
                );
            }
            return hasAny(pairs);
        };
        const hasKojoEstSource = (slot) => {
            if (patternNo === 1) return hasAny([
                ["MAT_TOTAL", slot],
                ["SUB_TOTAL", slot],
                ["PROCESS", slot],
                ["SECONDARY", slot],
                ["MARGIN", slot],
                ["ADJUST", slot]
            ]);
            if (patternNo === 2) return hasAny([
                ["SUB_TOTAL", slot],
                ["PROCESS", slot],
                ["SECONDARY", slot],
                ["MARGIN", slot],
                ["ADJUST", slot]
            ]);
            if (patternNo === 3) return hasAny([["PRODUCT", slot], ["MARGIN", slot], ["ADJUST", slot]]);
            return hasAny([["PROCESS", slot], ["MARGIN", slot], ["ADJUST", slot]]);
        };
        const originalEstCostValues = {
            main: String(DicVal(rows.EST_COST, main, "") ?? "").trim(),
            kojo: String(DicVal(rows.EST_COST, "kojo", "") ?? "").trim(),
            kojo_f: String(DicVal(rows.EST_COST, "kojo_f", "") ?? "").trim(),
            yusho_f: String(DicVal(rows.EST_COST, "yusho_f", "") ?? "").trim()
        };

        applyGenkaForeignCurrencyToYen(rows, patternNo, genkaRateForLeftCalc(options));

        const rowKeysForLoss = ["muryo", "muryo_f", "yusho", "yusho_f", "kojo", "kojo_f"];
        rowKeysForLoss.forEach((slot) => {
            w("MAT_TOTAL", slot, n("MAT_AMOUNT", slot) * (1 + calcRate(n("MAT_LOSS", slot))));
            if (!has("MAT_AMOUNT", slot) && !has("MAT_LOSS", slot)) rows.MAT_TOTAL[slot] = "";
        });

        // 業務上、納品資材は附属金額計に含める。
        ["muryo", "muryo_f", "yusho", "yusho_f"].forEach((slot) => {
            const sub = n("SUB_AMOUNT", slot) * (1 + calcRate(n("SUB_LOSS", slot)));
            const name = n("NAME_AMOUNT", slot) * (1 + calcRate(n("ETC_LOSS", slot)));
            w("SUB_TOTAL", slot, sub + name + n("DELIVERY_MAT", slot));
            if (!has("SUB_AMOUNT", slot) && !has("SUB_LOSS", slot) && !has("NAME_AMOUNT", slot) && !has("ETC_LOSS", slot) && !has("DELIVERY_MAT", slot)) rows.SUB_TOTAL[slot] = "";
        });
        // 工場手配/工場手配(外)ともにロス率（附属/その他附属）を加味して合算する。
        const subKojo = n("SUB_AMOUNT", "kojo") * (1 + calcRate(n("SUB_LOSS", "kojo")));
        const nameKojo = n("NAME_AMOUNT", "kojo") * (1 + calcRate(n("ETC_LOSS", "kojo")));
        w("SUB_TOTAL", "kojo", subKojo + nameKojo + n("DELIVERY_MAT", "kojo"));
        if (!has("SUB_AMOUNT", "kojo") && !has("SUB_LOSS", "kojo") && !has("NAME_AMOUNT", "kojo") && !has("ETC_LOSS", "kojo") && !has("DELIVERY_MAT", "kojo")) rows.SUB_TOTAL.kojo = "";
        const subKojoF = n("SUB_AMOUNT", "kojo_f") * (1 + calcRate(n("SUB_LOSS", "kojo_f")));
        const nameKojoF = n("NAME_AMOUNT", "kojo_f") * (1 + calcRate(n("ETC_LOSS", "kojo_f")));
        w("SUB_TOTAL", "kojo_f", subKojoF + nameKojoF + n("DELIVERY_MAT", "kojo_f"));
        if (!has("SUB_AMOUNT", "kojo_f") && !has("SUB_LOSS", "kojo_f") && !has("NAME_AMOUNT", "kojo_f") && !has("ETC_LOSS", "kojo_f") && !has("DELIVERY_MAT", "kojo_f")) rows.SUB_TOTAL.kojo_f = "";

        const ratioRows = new Set(["MAT_LOSS", "SUB_LOSS", "ETC_LOSS", "MARGIN"]);
        genkaRowKeyOrder.forEach((rowKey) => {
            if (ratioRows.has(rowKey)) {
                rows[rowKey].syokei = "";
                return;
            }
            w(rowKey, "syokei", n(rowKey, main) + n(rowKey, "kojo"));
            if (!has(rowKey, main) && !has(rowKey, "kojo") && toGenkaCalcNumber(DicVal(rows[rowKey], "syokei", 0)) === 0) rows[rowKey].syokei = "";
        });
        genkaRowKeyOrder.forEach((rowKey) => {
            if (ratioRows.has(rowKey)) {
                rows[rowKey].syokei_f = "";
                return;
            }
            if (patternNo === 5 || patternNo === 9 || patternNo === 8) {
                rows[rowKey].syokei_f = "";
                return;
            }
            w(rowKey, "syokei_f", n(rowKey, mainF) + n(rowKey, "kojo_f"));
            if (!has(rowKey, mainF) && !has(rowKey, "kojo_f") && toGenkaCalcNumber(DicVal(rows[rowKey], "syokei_f", 0)) === 0) rows[rowKey].syokei_f = "";
        });

        const expense = n("EXPENSE_OUT", expenseSlot)
            + n("EXPENSE_IN", expenseSlot)
            + n("TARIFF", expenseSlot)
            - n("ZAN8", expenseSlot)
            + n("POST_SUB", expenseSlot)
            + n("DOMESTIC_WORK", expenseSlot);
        const mainEst = (patternNo === 1)
            ? (
                n("MAT_TOTAL", main)
                + n("SUB_TOTAL", main)
                + n("SECONDARY", main)
                + n("ADJUST", main)
            )
            : (
                n("MAT_TOTAL", main)
                + n("SUB_TOTAL", main)
                + n("SECONDARY", main)
                + n("ADJUST", main)
                + expense
            );
        w("EST_COST", main, mainEst);
        if (!hasMainEstSource(main)) rows.EST_COST[main] = hasActualGenkaEntryValueForCell("EST_COST", main) ? originalEstCostValues.main : "";

        let kojoEst = 0;
        if (patternNo === 1) {
            // 業務補正: Excelセル式(AL815)は素材金額計/二次加工賃の寄与が不足するため、
            // パターン1は「素材金額計+附属金額計+加工賃+二次加工賃」にマージンを掛け、最後に調整を加算する。
            kojoEst = (
                n("MAT_TOTAL", "kojo")
                + n("SUB_TOTAL", "kojo")
                + n("PROCESS", "kojo")
                + n("SECONDARY", "kojo")
            ) * (1 + calcRate(n("MARGIN", "kojo"))) + n("ADJUST", "kojo");
        } else if (patternNo === 2) {
            kojoEst = (n("SUB_TOTAL", "kojo") + n("PROCESS", "kojo") + n("SECONDARY", "kojo")) * (1 + calcRate(n("MARGIN", "kojo"))) + n("ADJUST", "kojo");
        } else if (patternNo === 3) {
            kojoEst = n("PRODUCT", "kojo") * (1 + calcRate(n("MARGIN", "kojo"))) + n("ADJUST", "kojo");
        } else {
            kojoEst = n("PROCESS", "kojo") * (1 + calcRate(n("MARGIN", "kojo"))) + n("ADJUST", "kojo");
        }
        w("EST_COST", "kojo", kojoEst);
        if (!hasKojoEstSource("kojo")) rows.EST_COST.kojo = hasActualGenkaEntryValueForCell("EST_COST", "kojo") ? originalEstCostValues.kojo : "";

        let kojoFEst = 0;
        if ([5, 7, 9].includes(patternNo)) {
            kojoFEst = n("PROCESS", "kojo_f") * (1 + calcRate(n("MARGIN", "kojo_f"))) + n("ADJUST", "kojo_f");
            w("EST_COST", "kojo_f", kojoFEst);
            if (!hasKojoEstSource("kojo_f")) rows.EST_COST.kojo_f = hasActualGenkaEntryValueForCell("EST_COST", "kojo_f") ? originalEstCostValues.kojo_f : "";
        } else {
            rows.EST_COST.kojo_f = "";
        }

        let estF = 0;
        if (patternNo === 7) {
            const extMain = n("MAT_TOTAL", "yusho_f") + n("SUB_TOTAL", "yusho_f") + n("SECONDARY", "yusho_f");
            w("EST_COST", "yusho_f", extMain);
            if (!hasAny([["MAT_TOTAL", "yusho_f"], ["SUB_TOTAL", "yusho_f"], ["SECONDARY", "yusho_f"]])) rows.EST_COST.yusho_f = hasActualGenkaEntryValueForCell("EST_COST", "yusho_f") ? originalEstCostValues.yusho_f : "";
            estF = extMain + kojoFEst;
            rows.EST_COST.syokei_f = (has("EST_COST", "yusho_f") || has("EST_COST", "kojo_f")) ? String(roundGenkaCalc(estF)) : "";
        } else if ([5, 9].includes(patternNo)) {
            rows.EST_COST.syokei_f = "";
        } else {
            rows.EST_COST.syokei_f = "";
        }
        rows.EST_COST.syokei = (has("EST_COST", main) || has("EST_COST", "kojo")) ? String(roundGenkaCalc(n("EST_COST", main) + n("EST_COST", "kojo"))) : "";

        const estSyokei = toGenkaCalcNumber(rows.EST_COST.syokei);
        genkaRowKeyOrder.forEach((rowKey) => {
            if (!isGenkaKouseiEnabledRow(rowKey, patternNo)) {
                rows[rowKey].kousei = "";
                return;
            }
            const syokeiRaw = String(DicVal(rows[rowKey], "syokei", "") ?? "").trim();
            if (syokeiRaw === "") {
                rows[rowKey].kousei = "";
                return;
            }
            const ratio = estSyokei === 0 ? 0 : (toGenkaCalcNumber(rows[rowKey].syokei) / estSyokei);
            rows[rowKey].kousei = String(Math.round(ratio * 100));
        });

        const normalizedRows = genkaRowKeyOrder.map((k, idx) => ({
            ...rows[k],
            rowid: String(DicVal(rows[k], "rowid", idx)),
            row_key: k,
            item_name: String(genkaRowLabelByKey[k] ?? DicVal(rows[k], "item_name", ""))
        }));

        return {
            rows: applyGenkaCalcDisplayRounding(normalizeGenkaRowsByLayoutPrecision(normalizedRows)),
            patternNo: patternNo,
            expenseSlot: expenseSlot
        };
    }
    function formatGenkaSummaryNumberByItem(item, isValue2, value) {
        const cands = DicVal(genkaSummaryColumnCandidates, item, null);
        if (isEmpty(cands)) return String(roundGenkaCalc(value));
        const list = isValue2 ? (cands.value2 || []) : (cands.value || []);
        const cinfo = findColumnInfoByCandidates(list, [PANEL_TYPE.GENKA_SUMMARY, "127"]);
        if (isEmpty(cinfo) || String(cinfo.datatype ?? "") !== "1") return String(roundGenkaCalc(value));
        return roundByDecimal(roundGenkaCalc(value), DicVal(cinfo, "decimalplace", 0));
    }
    // 原価右「合計」を再計算する。
    // 仕入原価・設定率・発注単価は左原価計算結果を元に作る。
    // FOB小計/諸掛計/発注単価(外)は、対象パターン・元入力の有無に応じて空欄/計算値を出し分ける。
    function calcGenkaSummaryRowsByCellFormula(calcRows, patternNo, expenseSlot, options = {}) {
        const baseRows = getGenkaSummaryBaseRows(options);
        const map = {};
        // total_item / total_key がどちらで来ても、内部計算キーはColumn IDへ正規化する。
        baseRows.forEach((r) => {
            const key = resolveGenkaSummaryItem(DicVal(r, "total_key", "") || DicVal(r, "total_item", ""));
            if (key === "") return;
            map[key] = {
                ...r,
                total_item: key,
                total_key: resolveGenkaSummaryKeyId(key)
            };
        });
        // 返却元が空でも、計算対象行が欠けないように固定行を補完。
        genkaSummaryOrder.forEach((item, idx) => {
            if (!isEmpty(map[item])) return;
            map[item] = emptyGenkaSummaryRow(item, idx);
        });
        const rowMap = getGenkaRowMap(calcRows);
        const n = (rowKey, slot) => toGenkaCalcNumber(DicVal(rowMap[rowKey], slot, 0));
        const readSummary = (item, field) => toGenkaCalcNumber(DicVal(DicVal(map, item, {}), field, 0));
        const hasSummaryValue = (item, field) => {
            const raw = String(DicVal(DicVal(map, item, {}), field, "") ?? "").trim();
            return raw !== "";
        };
        const hasGenkaCellValue = (rowKey, slot) => {
            const raw = String(DicVal(DicVal(rowMap, rowKey, {}), slot, "") ?? "").trim();
            return raw !== "";
        };
        const hasAnyGenkaCellValue = (pairs) => pairs.some((p) => hasGenkaCellValue(p[0], p[1]));
        const currentSummaryValue = (item) => String(DicVal(DicVal(map, item, {}), "total_value", "") ?? "").trim();

        const fobf = readSummary("SSDGM_BOUEKIJYOKEN", "total_value2");
        const rate = readSummary("SSDGM_RATE", "total_value");
        const fob = fobf * rate;
        const syokakari = n("EXPENSE_OUT", expenseSlot) + n("EXPENSE_IN", expenseSlot) + n("TARIFF", expenseSlot) - n("ZAN8", expenseSlot);
        const shiire = n("EST_COST", "syokei");
        const shohinGenkaRaw = findEntryValue(entrydataRef.current, ["SSDGM_SHOHINGENKA"]);
        const shohinGenka = toGenkaCalcNumber(shohinGenkaRaw);
        const totalShiireGenka = shiire + shohinGenka;
        const jyodai = readSummary("SSDGM_JYODAI", "total_value");
        const settei = totalShiireGenka === 0 ? 0 : (jyodai / totalShiireGenka);

        let hachu = 0;
        let hachuF = 0;
        if (patternNo === 1) {
            hachu = n("EST_COST", "kojo");
        } else if (patternNo === 2) {
            hachu = shiire;
        } else if (patternNo === 4) {
            // パターン4は仕様書注記「発注単価＝加工賃の小計」を優先する。
            hachu = n("PROCESS", "syokei");
        } else if (patternNo === 3 || patternNo === 5 || patternNo === 8 || patternNo === 9) {
            hachu = n("EST_COST", "kojo");
        } else if (patternNo === 6 || patternNo === 7) {
            const margin = calcRate(n("MARGIN", "kojo"));
            const base = n("MAT_TOTAL", "syokei") + n("SUB_TOTAL", "syokei") + n("PROCESS", "syokei") + n("SECONDARY", "syokei");
            hachu = base * (1 + margin);
        }
        if (patternNo === 5 || patternNo === 9) {
            hachuF = n("EST_COST", "kojo_f");
        } else if (patternNo === 7) {
            const marginF = calcRate(n("MARGIN", "kojo_f"));
            const baseF = n("MAT_TOTAL", "syokei_f") + n("SUB_TOTAL", "syokei_f") + n("PROCESS", "syokei_f") + n("SECONDARY", "syokei_f");
            hachuF = baseF * (1 + marginF);
        }
        const hasShiireSource = hasGenkaCellValue("EST_COST", "syokei");
        const hasShohinGenkaSource = String(shohinGenkaRaw ?? "").trim() !== "";
        const hasTotalShiireSource = hasShiireSource || hasShohinGenkaSource;
        const hasSetteiSource = hasTotalShiireSource && hasSummaryValue("SSDGM_JYODAI", "total_value");
        const hasHachuSource = (() => {
            if (patternNo === 1) return hasGenkaCellValue("EST_COST", "kojo");
            if (patternNo === 2) return hasShiireSource;
            if (patternNo === 4) return hasGenkaCellValue("PROCESS", "syokei");
            if (patternNo === 3 || patternNo === 5 || patternNo === 8 || patternNo === 9) return hasGenkaCellValue("EST_COST", "kojo");
            if (patternNo === 6 || patternNo === 7) {
                return hasAnyGenkaCellValue([
                    ["MAT_TOTAL", "syokei"],
                    ["SUB_TOTAL", "syokei"],
                    ["PROCESS", "syokei"],
                    ["SECONDARY", "syokei"],
                    ["MARGIN", "kojo"]
                ]);
            }
            return false;
        })();
        const hasHachuFSource = (() => {
            if (patternNo === 5 || patternNo === 9) return hasGenkaCellValue("EST_COST", "kojo_f");
            if (patternNo === 7) {
                return hasAnyGenkaCellValue([
                    ["MAT_TOTAL", "syokei_f"],
                    ["SUB_TOTAL", "syokei_f"],
                    ["PROCESS", "syokei_f"],
                    ["SECONDARY", "syokei_f"],
                    ["MARGIN", "kojo_f"]
                ]);
            }
            return false;
        })();

        const hasFobInput = hasSummaryValue("SSDGM_BOUEKIJYOKEN", "total_value2") || hasSummaryValue("SSDGM_RATE", "total_value");
        if (hasFobInput) {
            setGenkaSummaryCell(map, "SSDGM_FOBKIN", "total_value", formatGenkaSummaryNumberByItem("SSDGM_FOBKIN", false, fob));
        } else {
            setGenkaSummaryCell(map, "SSDGM_FOBKIN", "total_value", "");
        }

        const hasSyokakariInput =
            hasGenkaCellValue("EXPENSE_OUT", expenseSlot)
            || hasGenkaCellValue("EXPENSE_IN", expenseSlot)
            || hasGenkaCellValue("TARIFF", expenseSlot)
            || hasGenkaCellValue("ZAN8", expenseSlot);
        if (hasSyokakariInput) {
            setGenkaSummaryCell(map, "SSDGM_SYOKAKARITAKA", "total_value", formatGenkaSummaryNumberByItem("SSDGM_SYOKAKARITAKA", false, syokakari));
        } else {
            setGenkaSummaryCell(map, "SSDGM_SYOKAKARITAKA", "total_value", "");
        }

        setGenkaSummaryCell(map, "SSDGM_SEIHINGENKA", "total_value", hasTotalShiireSource ? formatGenkaSummaryNumberByItem("SSDGM_SEIHINGENKA", false, totalShiireGenka) : (hasActualGenkaSummaryEntryValue("SSDGM_SEIHINGENKA") ? currentSummaryValue("SSDGM_SEIHINGENKA") : ""));
        setGenkaSummaryCell(map, "SSDGM_JYODAIRITU", "total_value", hasSetteiSource ? formatGenkaSummaryNumberByItem("SSDGM_JYODAIRITU", false, settei) : (hasActualGenkaSummaryEntryValue("SSDGM_JYODAIRITU") ? currentSummaryValue("SSDGM_JYODAIRITU") : ""));
        setGenkaSummaryCell(map, "SSDGM_HACHUTANKA", "total_value", hasHachuSource ? formatGenkaSummaryNumberByItem("SSDGM_HACHUTANKA", false, hachu) : (hasActualGenkaSummaryEntryValue("SSDGM_HACHUTANKA") ? currentSummaryValue("SSDGM_HACHUTANKA") : ""));
        if ((patternNo === 5 || patternNo === 7 || patternNo === 9) && (hasHachuFSource || hasActualGenkaSummaryEntryValue("SSDGM_HACHUTANKAF"))) {
            setGenkaSummaryCell(map, "SSDGM_HACHUTANKAF", "total_value", hasHachuFSource ? formatGenkaSummaryNumberByItem("SSDGM_HACHUTANKAF", false, hachuF) : currentSummaryValue("SSDGM_HACHUTANKAF"));
        } else {
            setGenkaSummaryCell(map, "SSDGM_HACHUTANKAF", "total_value", "");
        }
        if (shouldForceGenkaCurrencyJpy(entrydataRef.current)) {
            setGenkaSummaryCell(map, "SSDGM_TSUKATANI", "total_value", "JPY");
            setGenkaSummaryCell(map, "SSDGM_RATE", "total_value", "1");
        }

        return normalizeGenkaSummaryRows(genkaSummaryOrder.map((k) => map[k] || emptyGenkaSummaryRow(k, "0")));
    }
    function isGenkaGridPanelInfo(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        const id = String(panelInfo.id ?? "").trim().toLowerCase();
        const type = String(panelInfo.type ?? "").trim().toLowerCase();
        if (id === "19" || id === "genka" || type === String(PANEL_TYPE.GENKA).toLowerCase() || type === "genka") return true;
        return resolveSectionIdByGridPanel(panelInfo) === "genka";
    }
    function isGenkaTotalPanelInfo(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        const id = String(panelInfo.id ?? "").trim().toLowerCase();
        const type = String(panelInfo.type ?? "").trim().toLowerCase();
        return id === "t19" || id === "tgenka" ||
            type === String(PANEL_TYPE.GENKA_SUMMARY).toLowerCase() ||
            type === "t19" || type === "t2";
    }
    function isWashPanelInfo(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        const id = String(panelInfo.id ?? "").trim().toLowerCase();
        const type = String(panelInfo.type ?? "").trim().toLowerCase();
        if (WASH_PANEL_SECTION_IDS.includes(id) || type === String(PANEL_TYPE.WASH).toLowerCase()) return true;
        return resolveSectionIdByGridPanel(panelInfo) === "sentakuhyoji";
    }
    function isKomonofudaPanelInfo(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return getPanelType(panelInfo) === PANEL_TYPE.KOMONOFUDA;
    }
    const DEBUG_FUKUSHIZAI_SYNC_VERBOSE = false;
    function getPanelType(panelInfo) {
        return canonicalPanelType(DicVal(panelInfo, "type", ""));
    }
    function isFukushizaiPanelType(type) {
        return FUKUSHIZAI_PANEL_TYPES.includes(canonicalPanelType(type));
    }
    function isFukushizaiContextDisplayPanelType(type) {
        return FUKUSHIZAI_CONTEXT_DISPLAY_PANEL_TYPES.includes(canonicalPanelType(type));
    }
    function isQualityPanelType(type) {
        return QUALITY_DISPLAY_PANEL_TYPES.includes(canonicalPanelType(type));
    }
    function isGroupPanelType(type) {
        return canonicalPanelType(type) === PANEL_TYPE.REGISTERED_GROUP;
    }
    function isFukushizaiOrQualityContextPanelType(type) {
        return isFukushizaiPanelType(type) || isQualityPanelType(type) || isGroupPanelType(type);
    }
    function getFukushizaiContextFieldIds() {
        return [FUKUSHIZAI_FIELD.ITEM_CD, FUKUSHIZAI_FIELD.COLOR_CD, FUKUSHIZAI_FIELD.GROUP_NO];
    }
    function isFukushizaiContextField(columnId) {
        const target = String(columnId ?? "").trim().toUpperCase();
        if (target === "") return false;
        return getFukushizaiContextFieldIds().includes(target);
    }
    function getFukushizaiAllFieldIds() {
        const baseMasterIds = Array.isArray(FUKUSHIZAI_BASE_MASTER_FIELD_IDS) ? FUKUSHIZAI_BASE_MASTER_FIELD_IDS : [];
        const baseExtraIds = Array.isArray(FUKUSHIZAI_BASE_EXTRA_FIELD_IDS) ? FUKUSHIZAI_BASE_EXTRA_FIELD_IDS : [];
        if (Array.isArray(columninfo) && columninfo.length !== 0) {
            return [...new Set(
                [
                    ...columninfo
                    .filter((col) => getPanelType(col) === FUKUSHIZAI_BASE_PANEL_TYPE)
                    .map((col) => String(DicVal(col, "columnid", "") ?? "").trim())
                    .filter((fieldId) => fieldId !== ""),
                    ...baseMasterIds,
                    ...baseExtraIds
                ]
            )];
        }
        const textFieldIds = Array.isArray(textfields)
            ? textfields
                .filter((field) => getPanelType(field) === FUKUSHIZAI_BASE_PANEL_TYPE)
                .map((field) => String(DicVal(field, "columnid", "") ?? "").trim())
                .filter((fieldId) => fieldId !== "")
            : [];
        return [...new Set([...textFieldIds, ...baseMasterIds, ...baseExtraIds])];
    }
    function isFukushizaiDetailPanelInfo(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return getPanelType(panelInfo) === FUKUSHIZAI_BASE_PANEL_TYPE && isEnabled(DicVal(panelInfo, "grid", false));
    }
    function isFukushizaiBaseDisplaySection() {
        const section = getSectionDefById("fukushizai");
        return !isEmpty(section) && String(DicVal(section, "component", "")) !== "grid";
    }
    function resolveFukushizaiGridPanel() {
        if (isEmpty(panel) || !Array.isArray(panel)) return null;
        const exactPanel = panel.find((p) => p && p.grid && getPanelType(p) === FUKUSHIZAI_BASE_PANEL_TYPE);
        return isEmpty(exactPanel) ? null : exactPanel;
    }
    function getFukushizaiBaseFieldIds() {
        return getFukushizaiAllFieldIds().filter((fieldId) => !isFukushizaiContextField(fieldId));
    }
    function isFukushizaiBaseField(columnId) {
        const target = String(columnId ?? "").trim().toUpperCase();
        if (target === "") return false;
        return getFukushizaiBaseFieldIds().some((fieldId) => String(fieldId).trim().toUpperCase() === target);
    }
    function isFukushizaiContextDisplayPanelInfo(panelInfo) {
        return isFukushizaiContextDisplayPanelType(getPanelType(panelInfo));
    }
    function isFukushizaiSharedContextPanelInfo(panelInfo) {
        return isFukushizaiOrQualityContextPanelType(getPanelType(panelInfo));
    }
    function hasCompleteFukushizaiContext(context) {
        const normalized = normalizeFukushizaiContext(context);
        return normalized.itemCd !== "" && normalized.groupNo !== "";
    }
    const FUKUSHIZAI_CONTEXT_ITEM_FIELD_CANDIDATES = [
        "SSDZ_ITMCITEMCD",
        "SSDQ_ITMCITEMCD",
        "SSDH_ITMCITEMCD",
        "SSDY_ITMCITEMCD",
        "SSDB_ITMCITEMCD",
        "SSDD_ITMCITEMCD",
        "SSDE_ITMCITEMCD",
        "item",
        "itemCd"
    ];
    const FUKUSHIZAI_CONTEXT_GROUP_FIELD_CANDIDATES = [
        "SSDZ_FUKUSIZAICOLORGRP",
        "SSDQ_GROUPNO",
        "SSDH_GROUPNO",
        "SSDY_GROUPNO",
        "SSDB_GROUPNO",
        "SSDD_GROUPNO",
        "SSDE_GROUPNO",
        "SSDQ_FUKUSIZAICOLORGRP",
        "SSDH_FUKUSIZAICOLORGRP",
        "SSDY_FUKUSIZAICOLORGRP",
        "SSDB_FUKUSIZAICOLORGRP",
        "SSDD_FUKUSIZAICOLORGRP",
        "SSDE_FUKUSIZAICOLORGRP",
        "group",
        "groupNo"
    ];
    function readFukushizaiContextFieldFromRow(row, candidates, normalizer = (value) => String(value ?? "").trim()) {
        if (isEmpty(row) || !Array.isArray(candidates)) return "";
        for (let i = 0; i < candidates.length; i++) {
            const key = candidates[i];
            if (!Object.keys(row).some((rowKey) => String(rowKey).toUpperCase() === String(key).toUpperCase())) continue;
            const value = normalizer(readRowValueIgnoreCase(row, key));
            if (value !== "") return value;
        }
        return "";
    }
    function filterRowsByFukushizaiContextIfKeyed(rows, context) {
        const source = Array.isArray(rows) ? rows : [];
        const normalized = normalizeFukushizaiContext(context);
        if (normalized.itemCd === "" || normalized.groupNo === "") return [];
        return source.filter((row) => {
            if (isEmpty(row)) return false;
            const rowItem = readFukushizaiContextFieldFromRow(row, FUKUSHIZAI_CONTEXT_ITEM_FIELD_CANDIDATES);
            const rowGroup = readFukushizaiContextFieldFromRow(row, FUKUSHIZAI_CONTEXT_GROUP_FIELD_CANDIDATES, normalizeGroupNo);
            if (rowItem === "" && rowGroup === "") return true;
            if (rowItem !== "" && rowItem !== normalized.itemCd) return false;
            if (rowGroup !== "" && rowGroup !== normalized.groupNo) return false;
            return true;
        });
    }
    function getFukushizaiContextDisplayGridPanels() {
        return Array.isArray(gridlist)
            ? gridlist.filter((panelInfo) => isFukushizaiContextDisplayPanelInfo(panelInfo))
            : [];
    }
    function isFukushizaiPreviewLockedPanel(panelInfo) {
        if (!isFukushizaiCopyPreviewing) return false;
        if (isEmpty(panelInfo)) return false;
        const type = getPanelType(panelInfo);
        return type === FUKUSHIZAI_BASE_PANEL_TYPE || isFukushizaiContextDisplayPanelInfo(panelInfo);
    }
    function normalizeFukushizaiContext(context) {
        return {
            itemCd: normalizeItemCd(DicVal(context, "itemCd", "")),
            colorCd: normalizeColorCd(DicVal(context, "colorCd", "")),
            groupNo: normalizeGroupNo(DicVal(context, "groupNo", ""))
        };
    }
    function normalizeItemCd(value) {
        return normalizeKakousijiUiString(value);
    }
    function normalizeColorCd(value) {
        return normalizeKakousijiUiString(value);
    }
    function createEmptyFukushizaiContext() {
        return { itemCd: "", colorCd: "", groupNo: "" };
    }
    function normalizeGroupNo(value) {
        return sharedNormalizeGroupNo(value);
    }
    function normalizeEditableGroupNo(value) {
        const normalized = normalizeGroupNo(value);
        if (!/^\d{2}$/.test(normalized)) return "";
        const num = Number(normalized);
        if (!Number.isFinite(num) || num < 1 || num > 99) return "";
        return normalized;
    }
    function groupNoToLabel(value) {
        return sharedGroupNoToLabel(value);
    }
    function groupLabelToNo(value) {
        return normalizeGroupNo(value);
    }
    function readFukushizaiContextFromRow(row) {
        return normalizeFukushizaiContext({
            itemCd: readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.ITEM_CD),
            colorCd: readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.COLOR_CD),
            groupNo: readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.GROUP_NO)
        });
    }
    function getItemCdFromRow(row) {
        return normalizeItemCd(readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.ITEM_CD));
    }
    function getColorCdFromRow(row) {
        return normalizeColorCd(readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.COLOR_CD));
    }
    function getGroupNoFromRow(row) {
        return normalizeGroupNo(readRowValueIgnoreCase(row, FUKUSHIZAI_FIELD.GROUP_NO));
    }
    function sameItemGroup(row, itemCd, groupNo) {
        return getItemCdFromRow(row) === normalizeItemCd(itemCd)
            && getGroupNoFromRow(row) === normalizeGroupNo(groupNo);
    }
    function sameItemGroupColor(row, itemCd, groupNo, colorCd) {
        return sameItemGroup(row, itemCd, groupNo)
            && getColorCdFromRow(row) === normalizeColorCd(colorCd);
    }
    function updateSelectedFukushizaiContext(nextContext) {
        const normalized = normalizeFukushizaiContext(nextContext);
        const current = selectedFukushizaiContextRef.current || {};
        selectedFukushizaiContextRef.current = normalized;
        if (current.itemCd !== normalized.itemCd || current.colorCd !== normalized.colorCd || current.groupNo !== normalized.groupNo) {
            setSelectedFukushizaiContext(normalized);
        }
        return normalized;
    }
    function updateSelectedQualityContext(nextContext) {
        const normalized = normalizeFukushizaiContext(nextContext);
        const current = selectedQualityContextRef.current || {};
        selectedQualityContextRef.current = normalized;
        if (current.itemCd !== normalized.itemCd || current.colorCd !== normalized.colorCd || current.groupNo !== normalized.groupNo) {
            setSelectedQualityContext(normalized);
        }
        return normalized;
    }
    function distinctTextList(list, fieldId) {
        const seen = new Set();
        const out = [];
        (Array.isArray(list) ? list : []).forEach((row) => {
            const value = String(readRowValueIgnoreCase(row, fieldId) ?? "").trim();
            if (value === "" || seen.has(value)) return;
            seen.add(value);
            out.push(value);
        });
        return out;
    }
    function normalizeNamedOptions(value, codeKeys, nameKeys) {
        const list = [];
        const seen = new Set();
        (Array.isArray(value) ? value : []).forEach((item) => {
            const code = String(
                typeof item === "string" || typeof item === "number"
                    ? item
                    : pickFirstFukushizaiText(item, codeKeys)
            ).trim();
            if (code === "" || seen.has(code)) return;
            seen.add(code);
            const name = String(
                typeof item === "string" || typeof item === "number"
                    ? ""
                    : pickFirstFukushizaiText(item, nameKeys)
            ).trim();
            list.push({ code, name });
        });
        return list;
    }
    function formatNamedOptionLabel(code, name) {
        return sharedFormatNamedOptionLabel(code, name);
    }
    function formatCodeAndNameLabel(code, name) {
        const nextCode = String(code ?? "").trim();
        const nextName = String(name ?? "").trim();
        if (nextCode === "") return "";
        return nextName === "" ? nextCode : `${nextCode} ${nextName}`;
    }
    function getNamedOptionCode(option) {
        if (isEmpty(option)) return "";
        if (typeof option === "string" || typeof option === "number") return String(option ?? "").trim();
        return pickFirstFukushizaiText(option, ["code", "value", "itemCd", "colorCd", "item", "color"]);
    }
    function getNamedOptionName(option) {
        if (isEmpty(option)) return "";
        if (typeof option === "string" || typeof option === "number") return "";
        return pickFirstFukushizaiText(option, ["name", "label", "abbr", "itemName", "colorName"]);
    }
    function readMasterStoreOptionName(dataid, code, nameKeys) {
        const targetDataId = String(dataid ?? "").trim();
        const targetCode = String(code ?? "").trim();
        if (targetDataId === "" || targetCode === "") return "";
        const cacheKey = buildFukushizaiMasterCacheKey(targetDataId, targetCode, "", Array.isArray(nameKeys) ? nameKeys.join(",") : "");
        const cachedName = String(DicVal(fukushizaiMasterNameCacheRef.current, cacheKey, "") ?? "").trim();
        if (cachedName !== "") return cachedName;
        if (isEmpty(fnc) || isEmpty(fnc.current) || typeof fnc.current.getMaster !== "function") return "";
        const masterRow = fnc.current.getMaster(targetDataId, targetCode);
        if (isEmpty(masterRow)) return "";
        const name = pickFirstFukushizaiText(masterRow, nameKeys);
        if (name !== "") fukushizaiMasterNameCacheRef.current[cacheKey] = name;
        return name;
    }
    function buildNamedOptionsFromCodes(codes, dataid, nameKeys) {
        const seen = new Set();
        const out = [];
        (Array.isArray(codes) ? codes : []).forEach((code) => {
            const nextCode = String(code ?? "").trim();
            if (nextCode === "" || seen.has(nextCode)) return;
            seen.add(nextCode);
            out.push({
                code: nextCode,
                name: readMasterStoreOptionName(dataid, nextCode, nameKeys)
            });
        });
        return out;
    }
    function hydrateNamedOptionsFromMasterStore(options, dataid, nameKeys) {
        const seen = new Set();
        return (Array.isArray(options) ? options : [])
            .map((item) => {
                const code = getNamedOptionCode(item);
                if (code === "" || seen.has(code)) return null;
                seen.add(code);
                const name = getNamedOptionName(item) || readMasterStoreOptionName(dataid, code, nameKeys);
                return { code, name };
            })
            .filter((item) => !isEmpty(item));
    }
    function flattenKakousijiOptionSource(value) {
        if (Array.isArray(value)) return value.flatMap((item) => flattenKakousijiOptionSource(item));
        if (isEmpty(value)) return [];
        if (typeof value === "string" || typeof value === "number") {
            const text = String(value ?? "").trim();
            if (text === "") return [];
            if (text.includes(",") || text.includes("\n")) {
                return text.split(/[\n,]/).map((item) => item.trim()).filter((item) => item !== "");
            }
            return [text];
        }
        if (typeof value === "object") {
            const rows = DicVal(value, "rows", DicVal(value, "data", DicVal(value, "items", DicVal(value, "list", null))));
            if (Array.isArray(rows)) return flattenKakousijiOptionSource(rows);
            return [value];
        }
        return [];
    }
    function readColumnMasterDataId(colInfo) {
        return String(DicVal(colInfo, "dataid", DicVal(colInfo, "dataidctrl", DicVal(colInfo, "mastertype", ""))) ?? "").trim();
    }
    function readColumnMasterDbColumn(colInfo) {
        return String(DicVal(colInfo, "dbcolumn", DicVal(colInfo, "dbcolumnnm", "")) ?? "").trim();
    }
    function findListOptionRowsForColumn(colInfo) {
        const dataid = readColumnMasterDataId(colInfo);
        const columnId = String(DicVal(colInfo, "columnid", "") ?? "").trim();
        const candidates = [];
        const source = formListOption;
        if (Array.isArray(source)) {
            candidates.push(...source.filter((row) => {
                if (isEmpty(row) || typeof row !== "object") return false;
                const rowDataId = String(DicVal(row, "dataid", DicVal(row, "mastertype", DicVal(row, "id", ""))) ?? "").trim();
                const rowColumnId = String(DicVal(row, "columnid", DicVal(row, "field", "")) ?? "").trim();
                return (dataid !== "" && rowDataId === dataid) || (columnId !== "" && rowColumnId === columnId);
            }));
        } else if (!isEmpty(source) && typeof source === "object") {
            [columnId, dataid].forEach((key) => {
                if (key !== "" && !isEmpty(DicVal(source, key, null))) candidates.push(DicVal(source, key, null));
            });
        }
        return flattenKakousijiOptionSource(candidates);
    }
    function buildNamedOptionsFromColumnMaster(columnId, typeCandidates, codeKeys, nameKeys) {
        const colInfo = findColumnInfoByCandidates([columnId], typeCandidates) || findColumnInfoByCandidates([columnId], []);
        if (isEmpty(colInfo)) return [];
        const optionRows = [
            ...flattenKakousijiOptionSource(DicVal(colInfo, "options", [])),
            ...flattenKakousijiOptionSource(DicVal(colInfo, "selectlist", [])),
            ...findListOptionRowsForColumn(colInfo)
        ];
        const dataid = readColumnMasterDataId(colInfo);
        const dbcolumn = readColumnMasterDbColumn(colInfo);
        const normalized = normalizeNamedOptions(optionRows, codeKeys, [dbcolumn, ...nameKeys].filter((key) => String(key ?? "").trim() !== ""));
        return hydrateNamedOptionsFromMasterStore(normalized, dataid, [dbcolumn, ...nameKeys].filter((key) => String(key ?? "").trim() !== ""));
    }
    function pickFirstFukushizaiText(row, fieldIds) {
        if (isEmpty(row) || !Array.isArray(fieldIds)) return "";
        for (let i = 0; i < fieldIds.length; i++) {
            const value = String(readRowValueIgnoreCase(row, fieldIds[i]) ?? "").trim();
            if (value !== "") return value;
        }
        return "";
    }
    function buildFukushizaiMasterCacheKey(dataid, code, keyinfo = "", dbcolumn = "", fieldId = "", expectedFusizaiKbn = "") {
        return [
            String(dataid ?? "").trim(),
            String(fieldId ?? "").trim(),
            String(expectedFusizaiKbn ?? "").trim(),
            String(dbcolumn ?? "").trim(),
            String(code ?? "").trim(),
            String(keyinfo ?? "").trim()
        ].join("|");
    }
    function getFukushizaiColumnInfoById(columnId, items = columninfo) {
        const target = String(columnId ?? "").trim().toUpperCase();
        if (target === "" || !Array.isArray(items)) return null;
        return items.find((item) => String(DicVal(item, "columnid", "")).trim().toUpperCase() === target) || null;
    }
    function readFukushizaiExpectedFusizaiKbn(colInfo) {
        const searchparam = normalizeSearchParamObject(DicVal(colInfo, "searchparam", null));
        const requirement = String(DicVal(searchparam, "requirement", DicVal(colInfo, "requirement", "")) ?? "");
        const match = requirement.match(/FZK_FUSIZAIKBN\s*=\s*'([^']+)'/i);
        return match ? String(match[1] ?? "").trim() : "";
    }
    function primeFukushizaiMasterStoreFromRow(row) {
        if (isEmpty(row) || typeof row !== "object") return;
        if (!Array.isArray(FUKUSHIZAI_MASTER_PRIME_FIELD_IDS) || FUKUSHIZAI_MASTER_PRIME_FIELD_IDS.length === 0) return;
        FUKUSHIZAI_MASTER_PRIME_FIELD_IDS.forEach((fieldId) => {
            const colInfo = getFukushizaiColumnInfoById(fieldId);
            if (isEmpty(colInfo)) return;
            const dataid = String(DicVal(colInfo, "dataid", DicVal(colInfo, "dataidctrl", DicVal(colInfo, "mastertype", ""))) ?? "").trim();
            const dbcolumn = String(DicVal(colInfo, "dbcolumn", DicVal(colInfo, "dbcolumnnm", "")) ?? "").trim();
            const keyinfo = String(DicVal(colInfo, "keyinfo", "") ?? "").trim();
            if (dataid === "" || dbcolumn === "") return;
            const code = extractMasterCodeFromDisplayValue(DicVal(row, fieldId, ""));
            const name = readFirstFukushizaiDisplayText(row, [
                `${fieldId}_nm`,
                `${fieldId}_NM`,
                `${fieldId}_name`,
                `${fieldId}_NAME`
            ]);
            if (code === "" || name === "") return;
            const expectedFusizaiKbn = readFukushizaiExpectedFusizaiKbn(colInfo);
            const cacheKey = buildFukushizaiMasterCacheKey(dataid, code, keyinfo, dbcolumn, fieldId, expectedFusizaiKbn);
            if (String(DicVal(fukushizaiMasterNameCacheRef.current, cacheKey, "") ?? "").trim() === name) return;
            fukushizaiMasterNameCacheRef.current[cacheKey] = name;
            if (!isEmpty(fnc) && !isEmpty(fnc.current) && typeof fnc.current.setMaster === "function") {
                const masterRow = { dataid, code };
                if (keyinfo !== "") masterRow.keyinfo = keyinfo;
                masterRow[dbcolumn] = name;
                fnc.current.setMaster(masterRow);
            }
        });
    }
    function primeFukushizaiMasterStoreFromRows(rows) {
        (Array.isArray(rows) ? rows : []).forEach((row) => primeFukushizaiMasterStoreFromRow(row));
    }
    function getFukushizaiMasterFieldMeta(fieldId, code = "") {
        let colInfo = getFukushizaiColumnInfoById(fieldId);
        if (isEmpty(colInfo) && Array.isArray(textfields)) colInfo = getFukushizaiColumnInfoById(fieldId, textfields);
        if (isEmpty(colInfo)) return null;
        const dataid = String(DicVal(colInfo, "dataid", DicVal(colInfo, "dataidctrl", DicVal(colInfo, "mastertype", ""))) ?? "").trim();
        const dbcolumn = String(DicVal(colInfo, "dbcolumn", DicVal(colInfo, "dbcolumnnm", "")) ?? "").trim();
        const keyinfo = String(DicVal(colInfo, "keyinfo", "") ?? "").trim();
        const expectedFusizaiKbn = readFukushizaiExpectedFusizaiKbn(colInfo);
        const targetCode = String(code ?? "").trim();
        if (dataid === "" || dbcolumn === "") return null;
        return {
            colInfo,
            dataid,
            dbcolumn,
            keyinfo,
            expectedFusizaiKbn,
            code: targetCode,
            cacheKey: buildFukushizaiMasterCacheKey(dataid, targetCode, keyinfo, dbcolumn, fieldId, expectedFusizaiKbn),
            noKeyCacheKey: buildFukushizaiMasterCacheKey(dataid, targetCode, "", dbcolumn, fieldId, expectedFusizaiKbn)
        };
    }
    function readFukushizaiMasterNameFromStore(fieldId, code) {
        const targetCode = String(code ?? "").trim();
        if (targetCode === "") return "";
        const meta = getFukushizaiMasterFieldMeta(fieldId, targetCode);
        if (isEmpty(meta)) return "";
        const dataid = meta.dataid;
        const dbcolumn = meta.dbcolumn;
        const keyinfo = meta.keyinfo;
        const cacheKey = buildFukushizaiMasterCacheKey(dataid, targetCode, keyinfo, dbcolumn, fieldId, meta.expectedFusizaiKbn);
        const cachedName = String(DicVal(fukushizaiMasterNameCacheRef.current, cacheKey, "") ?? "").trim();
        if (cachedName !== "") return cachedName;
        if (keyinfo !== "") {
            const noKeyCachedName = String(DicVal(fukushizaiMasterNameCacheRef.current, meta.noKeyCacheKey, "") ?? "").trim();
            if (noKeyCachedName !== "") {
                fukushizaiMasterNameCacheRef.current[cacheKey] = noKeyCachedName;
                return noKeyCachedName;
            }
        }
        if (isEmpty(fnc) || isEmpty(fnc.current) || typeof fnc.current.getMaster !== "function") return "";
        let masterRow = fnc.current.getMaster(dataid, targetCode, keyinfo);
        if (isEmpty(masterRow) && keyinfo !== "") masterRow = fnc.current.getMaster(dataid, targetCode);
        if (isEmpty(masterRow)) return "";
        const name = pickFirstFukushizaiText(masterRow, [
            dbcolumn,
            `${fieldId}_nm`,
            `${fieldId}_NM`,
            "name",
            "label"
        ]);
        if (name !== "") {
            fukushizaiMasterNameCacheRef.current[cacheKey] = name;
            if (keyinfo !== "") fukushizaiMasterNameCacheRef.current[meta.noKeyCacheKey] = name;
        }
        return name;
    }
    function readFukushizaiMasterNameCacheOnly(fieldId, code) {
        const targetCode = String(code ?? "").trim();
        if (targetCode === "") return "";
        const meta = getFukushizaiMasterFieldMeta(fieldId, targetCode);
        if (isEmpty(meta)) return "";
        return String(DicVal(fukushizaiMasterNameCacheRef.current, meta.cacheKey, "") ?? "").trim()
            || String(DicVal(fukushizaiMasterNameCacheRef.current, meta.noKeyCacheKey, "") ?? "").trim();
    }
    function readFukushizaiMasterStoreNameOnly(fieldId, code) {
        const targetCode = String(code ?? "").trim();
        if (targetCode === "") return "";
        const meta = getFukushizaiMasterFieldMeta(fieldId, targetCode);
        if (isEmpty(meta) || isEmpty(fnc) || isEmpty(fnc.current) || typeof fnc.current.getMaster !== "function") return "";
        let masterRow = fnc.current.getMaster(meta.dataid, targetCode, meta.keyinfo);
        if (isEmpty(masterRow) && meta.keyinfo !== "") masterRow = fnc.current.getMaster(meta.dataid, targetCode);
        if (isEmpty(masterRow)) return "";
        return pickFirstFukushizaiText(masterRow, [
            meta.dbcolumn,
            `${fieldId}_nm`,
            `${fieldId}_NM`,
            "name",
            "label"
        ]);
    }
    function isFukushizaiVerticalMasterSourceColumnId(columnId) {
        const cid = String(columnId ?? "").trim().toUpperCase();
        return /^SSDZ_BRANDNAMECD[1-3]$/.test(cid)
            || /^SSDZ_SONOTANAMECD[1-6]$/.test(cid)
            || /^SSDZ_SONOTAFUZOKUCD[1-5]$/.test(cid);
    }
    function getFukushizaiMasterNameFieldKeys(sourceColumnId) {
        const fieldId = String(sourceColumnId ?? "").trim();
        if (fieldId === "") return [];
        return [
            `${fieldId}_cd`,
            `${fieldId}_CD`,
            `${fieldId}_nm`,
            `${fieldId}_NM`,
            `${fieldId}_name`,
            `${fieldId}_NAME`,
            `${fieldId}_display`,
            `${fieldId}_DISPLAY`
        ];
    }
    function logFukushizaiMasterNameClearFlat(payload) {
        return;
    }
    function clearFukushizaiMasterNameFields(row, sourceColumnId, options = {}) {
        if (isEmpty(row) || typeof row !== "object" || isEmpty(sourceColumnId)) return [];
        const fieldId = String(sourceColumnId ?? "").trim();
        const clearedKeys = [];
        getFukushizaiMasterNameFieldKeys(fieldId).forEach((key) => {
            if (!Object.prototype.hasOwnProperty.call(row, key)) return;
            delete row[key];
            clearedKeys.push(key);
        });
        if (isFukushizaiVerticalMasterSourceColumnId(fieldId)) {
            row[`__fukushizaiMasterNameCleared_${fieldId}`] = true;
        }
        if (clearedKeys.length !== 0) {
            const context = readFukushizaiContextFromRow(row);
            logFukushizaiMasterNameClearFlat({
                timing: String(DicVal(options, "timing", "") ?? ""),
                panelType: canonicalPanelType(DicVal(options, "panelType", "")),
                sourceColumnId: fieldId,
                oldCode: String(DicVal(options, "oldCode", "") ?? ""),
                newCode: String(DicVal(options, "newCode", "") ?? ""),
                clearedKeys,
                itemCd: context.itemCd,
                groupNo: context.groupNo,
                colorCd: context.colorCd,
                reason: String(DicVal(options, "reason", "code-changed") ?? "code-changed")
            });
        }
        return clearedKeys;
    }
    function clearFukushizaiVerticalMasterNameFields(row, options = {}) {
        if (isEmpty(row) || typeof row !== "object") return row;
        [
            "SSDZ_BRANDNAMECD1", "SSDZ_BRANDNAMECD2", "SSDZ_BRANDNAMECD3",
            "SSDZ_SONOTANAMECD1", "SSDZ_SONOTANAMECD2", "SSDZ_SONOTANAMECD3", "SSDZ_SONOTANAMECD4", "SSDZ_SONOTANAMECD5", "SSDZ_SONOTANAMECD6",
            "SSDZ_SONOTAFUZOKUCD1", "SSDZ_SONOTAFUZOKUCD2", "SSDZ_SONOTAFUZOKUCD3", "SSDZ_SONOTAFUZOKUCD4", "SSDZ_SONOTAFUZOKUCD5"
        ].forEach((fieldId) => clearFukushizaiMasterNameFields(row, fieldId, options));
        return row;
    }
    function applyFukushizaiMasterValue(row, fieldId, code) {
        if (isEmpty(row) || isEmpty(fieldId)) return row;
        const nextCode = String(code ?? "").trim();
        row[fieldId] = nextCode;
        clearFukushizaiMasterNameFields(row, fieldId, {
            timing: "master-value-update",
            oldCode: "",
            newCode: nextCode,
            reason: "master-value-update"
        });
        return row;
    }
    function buildFukushizaiMasterValueUpdates(fieldId, code) {
        const updates = {};
        applyFukushizaiMasterValue(updates, fieldId, code);
        return updates;
    }
    function primeFukushizaiMasterNameCache(fieldId, code, name) {
        const targetCode = String(code ?? "").trim();
        const targetName = String(name ?? "").trim();
        if (targetCode === "" || targetName === "") return false;
        const meta = getFukushizaiMasterFieldMeta(fieldId, targetCode);
        if (isEmpty(meta)) return false;
        const cacheKey = buildFukushizaiMasterCacheKey(meta.dataid, targetCode, meta.keyinfo, meta.dbcolumn, fieldId, meta.expectedFusizaiKbn);
        fukushizaiMasterNameCacheRef.current[cacheKey] = targetName;
        if (meta.keyinfo !== "") fukushizaiMasterNameCacheRef.current[meta.noKeyCacheKey] = targetName;
        if (!isEmpty(fnc) && !isEmpty(fnc.current) && typeof fnc.current.setMaster === "function") {
            const masterRow = { dataid: meta.dataid, code: targetCode };
            if (meta.keyinfo !== "") masterRow.keyinfo = meta.keyinfo;
            masterRow[meta.dbcolumn] = targetName;
            fnc.current.setMaster(masterRow);
        }
        return true;
    }
    function formatFukushizaiMasterDisplayValue(code, name) {
        const targetCode = String(code ?? "").trim();
        const targetName = String(name ?? "").trim();
        if (targetCode === "") return "";
        return targetName === "" ? targetCode : `${targetCode}:${targetName}`;
    }
    function logFukushizaiMasterNameResolveFlat(payload) {
        return;
    }
    function readExplicitFukushizaiRowMasterName(row, fieldId, code) {
        const targetCode = String(code ?? "").trim();
        if (targetCode === "" || isEmpty(row)) return "";
        if (isEnabled(DicVal(row, `__fukushizaiMasterNameCleared_${fieldId}`, false))) return "";
        const rowCode = extractMasterCodeFromDisplayValue(DicVal(row, fieldId, ""));
        if (rowCode !== "" && rowCode !== targetCode) return "";
        return readFirstFukushizaiDisplayText(row, [
            `${fieldId}_nm`,
            `${fieldId}_NM`,
            `${fieldId}_name`,
            `${fieldId}_NAME`
        ]);
    }
    function readExactFukushizaiMasterNameCache(fieldId, code) {
        const targetCode = String(code ?? "").trim();
        if (targetCode === "") return { name: "", cacheKey: "" };
        const meta = getFukushizaiMasterFieldMeta(fieldId, targetCode);
        if (isEmpty(meta)) return { name: "", cacheKey: "" };
        const name = String(DicVal(fukushizaiMasterNameCacheRef.current, meta.cacheKey, "") ?? "").trim();
        return { name, cacheKey: meta.cacheKey };
    }
    function isStaleFukushizaiDisplayBuildContext(buildContext) {
        const currentContext = normalizeFukushizaiContext(selectedFukushizaiContextRef.current);
        const context = normalizeFukushizaiContext(buildContext);
        if (context.itemCd !== "" && currentContext.itemCd !== "" && context.itemCd !== currentContext.itemCd) return true;
        if (context.groupNo !== "" && currentContext.groupNo !== "" && context.groupNo !== currentContext.groupNo) return true;
        return false;
    }
    function resolveFukushizaiDisplayMasterValue({ panelType, rowIndex, sourceColumnId, row, timing = "display-build", context = selectedFukushizaiContextRef.current }) {
        const fieldId = String(sourceColumnId ?? "").trim();
        const code = extractMasterCodeFromDisplayValue(DicVal(row, fieldId, DicVal(row, `${fieldId}_cd`, DicVal(row, `${fieldId}_CD`, ""))));
        const buildContext = normalizeFukushizaiContext(context);
        const selectedContext = normalizeFukushizaiContext(selectedFukushizaiContextRef.current);
        const displayField = getFukushizaiDisplayFieldIdByPanelType(panelType);
        const staleContext = isStaleFukushizaiDisplayBuildContext(buildContext);
        if (staleContext) {
            logFukushizaiMasterNameResolveFlat({
                timing,
                panelType: canonicalPanelType(panelType),
                rowIndex,
                sourceColumnId: fieldId,
                displayField,
                code,
                resolvedName: "",
                displayValue: "",
                cacheKey: "",
                source: "stale-context",
                detailNmCandidate: "",
                detailNmUsed: false,
                nameClearedBecauseCodeChanged: isEnabled(DicVal(row, `__fukushizaiMasterNameCleared_${fieldId}`, false)),
                oldCode: "",
                newCode: code,
                buildContextItem: buildContext.itemCd,
                buildContextGroup: buildContext.groupNo,
                buildContextColor: buildContext.colorCd,
                selectedContextItem: selectedContext.itemCd,
                selectedContextGroup: selectedContext.groupNo,
                selectedStateItem: selectedSetItem,
                selectedStateGroup: selectedGroup,
                selectedItem: selectedSetItem,
                selectedGroup,
                currentItem: selectedContext.itemCd,
                currentGroup: selectedContext.groupNo,
                applied: false,
                skipReason: "stale-context"
            });
            return { code: "", name: "", displayValue: "", source: "stale-context", cacheKey: "" };
        }
        let resolvedName = "";
        let source = "code-only";
        let cacheKey = "";
        let detailNmCandidate = "";
        let detailNmUsed = false;
        if (code !== "") {
            detailNmCandidate = readExplicitFukushizaiRowMasterName(row, fieldId, code);
            resolvedName = detailNmCandidate;
            if (resolvedName !== "") {
                source = "detail-nm";
                detailNmUsed = true;
                primeFukushizaiMasterNameCache(fieldId, code, resolvedName);
            }
            if (resolvedName === "") {
                resolvedName = readFukushizaiMasterStoreNameOnly(fieldId, code);
                if (resolvedName !== "") {
                    source = "master-store";
                    primeFukushizaiMasterNameCache(fieldId, code, resolvedName);
                }
            }
            if (resolvedName === "") {
                const requested = requestFukushizaiMasterName(fieldId, code, buildContext);
                source = requested ? "on-demand-start" : "code-only";
            }
            if (resolvedName === "" && source === "code-only" && (isEmpty(fnc.current) || typeof fnc.current.getMasterdata !== "function")) {
                const cached = readExactFukushizaiMasterNameCache(fieldId, code);
                resolvedName = cached.name;
                cacheKey = cached.cacheKey;
                if (resolvedName !== "") source = "cache";
            }
        }
        const displayValue = formatFukushizaiMasterDisplayValue(code, resolvedName);
        if (cacheKey === "") {
            const meta = getFukushizaiMasterFieldMeta(fieldId, code);
            cacheKey = String(DicVal(meta, "cacheKey", "") ?? "");
        }
        logFukushizaiMasterNameResolveFlat({
            timing,
            panelType: canonicalPanelType(panelType),
            rowIndex,
            sourceColumnId: fieldId,
            displayField,
            code,
            resolvedName,
            displayValue,
            cacheKey,
            source,
            detailNmCandidate,
            detailNmUsed,
            nameClearedBecauseCodeChanged: isEnabled(DicVal(row, `__fukushizaiMasterNameCleared_${fieldId}`, false)),
            oldCode: "",
            newCode: code,
            buildContextItem: buildContext.itemCd,
            buildContextGroup: buildContext.groupNo,
            buildContextColor: buildContext.colorCd,
            selectedContextItem: selectedContext.itemCd,
            selectedContextGroup: selectedContext.groupNo,
            selectedStateItem: selectedSetItem,
            selectedStateGroup: selectedGroup,
            selectedItem: selectedSetItem,
            selectedGroup,
            currentItem: selectedContext.itemCd,
            currentGroup: selectedContext.groupNo,
            applied: code !== "",
            skipReason: code === "" ? "empty-code" : ""
        });
        return { code, name: resolvedName, displayValue, source, cacheKey };
    }
    function readFukushizaiMasterCodeFromRow(row, fieldId) {
        if (isEmpty(row) || isEmpty(fieldId)) return "";
        const value = String(DicVal(row, fieldId, "") ?? "").trim()
            || String(DicVal(row, `${fieldId}_cd`, "") ?? "").trim()
            || String(DicVal(row, `${fieldId}_CD`, "") ?? "").trim();
        return extractMasterCodeFromDisplayValue(value);
    }
    function isSameFukushizaiItemGroupContext(left, right) {
        const a = normalizeFukushizaiContext(left);
        const b = normalizeFukushizaiContext(right);
        return a.itemCd === b.itemCd && a.groupNo === b.groupNo;
    }
    function readFukushizaiMasterCodeNameFromValue(fieldId, value) {
        if (isEmpty(value) || typeof value !== "object") {
            return {
                code: extractMasterCodeFromDisplayValue(value),
                name: extractMasterNameFromDisplayValue(value),
                source: "value"
            };
        }
        const meta = getFukushizaiMasterFieldMeta(fieldId);
        const dbcolumn = String(DicVal(meta, "dbcolumn", "") ?? "").trim();
        const code = pickFirstFukushizaiText(value, [
            fieldId,
            `${fieldId}_cd`,
            `${fieldId}_CD`,
            "code",
            "value",
            "FZK_FUZOKU_HINBAN"
        ]);
        const name = pickFirstFukushizaiText(value, [
            dbcolumn,
            `${fieldId}_nm`,
            `${fieldId}_NM`,
            `${fieldId}_name`,
            `${fieldId}_NAME`,
            "name",
            "label",
            "FZK_FUZOKU_NM"
        ]);
        return {
            code: extractMasterCodeFromDisplayValue(code),
            name: String(name ?? "").trim(),
            source: "value"
        };
    }
    function readFukushizaiItemName(row) {
        return pickFirstFukushizaiText(row, ["itemName", "itemNm", "item_name", "SSDZ_ITMCITEMNM", "SSDZ_ITMCITEM_NM"]);
    }
    function readFukushizaiColorName(row) {
        return pickFirstFukushizaiText(row, ["colorName", "colorNm", "color_name", "SSDZ_COLORNM", "SSDZ_COLOR_NM"]);
    }
    function getFukushizaiDetailRows(itemCd = "") {
        const rows = getDetailRowsByPanelType(entrydetailRef.current, "113");
        const list = Array.isArray(rows) ? rows.filter((row) => !isEmpty(row)) : [];
        const normalizedItem = String(itemCd ?? "").trim();
        if (normalizedItem === "") return list;
        return list.filter((row) => String(readRowValueIgnoreCase(row, "SSDZ_ITMCITEMCD") ?? "").trim() === normalizedItem);
    }
    function hasFukushizaiGroupRows(itemCd, groupNo) {
        const normalizedItem = String(itemCd ?? "").trim();
        const normalizedGroup = normalizeGroupNo(groupNo);
        if (normalizedItem === "" || normalizedGroup === "") return false;
        return getFukushizaiDetailRows(normalizedItem).some((row) => normalizeGroupNo(readRowValueIgnoreCase(row, "SSDZ_FUKUSIZAICOLORGRP")) === normalizedGroup);
    }
    function hasFukushizaiColorRow(itemCd, groupNo, colorCd) {
        const normalizedItem = String(itemCd ?? "").trim();
        const normalizedGroup = normalizeGroupNo(groupNo);
        const normalizedColor = String(colorCd ?? "").trim();
        if (normalizedItem === "" || normalizedGroup === "" || normalizedColor === "") return false;
        return getFukushizaiDetailRows(normalizedItem).some((row) =>
            normalizeGroupNo(readRowValueIgnoreCase(row, "SSDZ_FUKUSIZAICOLORGRP")) === normalizedGroup &&
            String(readRowValueIgnoreCase(row, "SSDZ_COLORCD") ?? "").trim() === normalizedColor
        );
    }
    function getKnownFukushizaiGroupNos(itemCd) {
        const normalizedItem = String(itemCd ?? "").trim();
        const seen = new Set();
        const out = [];
        const push = (value) => {
            const normalized = normalizeGroupNo(value);
            if (normalized === "" || seen.has(normalized)) return;
            seen.add(normalized);
            out.push(normalized);
        };
        getExistingFukushizaiGroupNos(normalizedItem).forEach(push);
        if (normalizedItem === "") (Array.isArray(groupOptions) ? groupOptions : []).forEach(push);
        getCurrentFukushizaiGroupRows().forEach((row) => {
            if (isEmpty(row)) return;
            const item = String(DicVal(row, "item", "") ?? "").trim();
            if (normalizedItem !== "" && item !== "" && item !== normalizedItem) return;
            push(DicVal(row, "group", ""));
        });
        return out.sort((a, b) => Number(a) - Number(b) || a.localeCompare(b));
    }
    // D_SSDQ を共有する 118/119 の行には、登録グループ(125)由来の「キーのみ行」が
    // 保存→再読込で混入する。品質の内容列に値がある行だけを品質側の導出対象にする
    // (副資材/品質表示のグループ分割管理を保存を跨いで維持するため)。
    function qualityRowHasQualityContent(row, panelType) {
        if (isEmpty(row) || typeof row !== "object") return false;
        const map = getQualityPanelFieldMap(panelType) || {};
        const keyFields = new Set([map.no, map.item, map.group, map.groupFallback, map.color, map.order]
            .map((value) => normalizeColumnIdUpper(String(value ?? "")))
            .filter((value) => value !== ""));
        return Object.keys(row).some((key) => {
            const cid = normalizeColumnIdUpper(key);
            if (cid === "" || cid === "ROWID" || cid === "INDEX" || cid === "GRIP" || cid === "ROW_KIND") return false;
            if (cid.startsWith("__")) return false;
            // 表示補助(_cd/_nm)・キー・OPPICD・監査系は内容と見なさない。
            if (cid.endsWith("_CD") || cid.endsWith("_NM") || cid.endsWith("_DMY")) return false;
            if (keyFields.has(cid)) return false;
            if (cid.endsWith("OPPICD")) return false;
            if (cid.endsWith("_INVALID") || cid.endsWith("_DELDATETIME")
                || cid.endsWith("_CREATEAC") || cid.endsWith("_CREATEDATE")
                || cid.endsWith("_UPDATEAC") || cid.endsWith("_UPDATE")
                || cid.endsWith("_INPCID") || cid.endsWith("_UPPCID")) return false;
            // 登録グループのハイブリッド行が持つUI用フィールドも除外。
            if (cid === "ITEM" || cid === "GROUP" || cid === "GROUPNO" || cid === "COLOR") return false;
            return String(row[key] ?? "").trim() !== "";
        });
    }
    // 品質表示(118-124)の有効detail行からitem/group/color contextを列挙する。
    // グループ追加/削除を副資材と独立させるため、品質側のグループ候補はここから導出する。
    function getQualityDetailGroupContexts(itemCd = "") {
        const normalizedItem = String(itemCd ?? "").trim();
        // D_SSDQ共有パネル(118/119)は登録グループのマーカー行が混ざるため内容判定を行う。
        // ただしこのセッションで品質側から追加したグループ(qualityGroupOptions)は判定を免除する。
        const sharedDssdqTypes = [PANEL_TYPE.QUALITY_BASE, PANEL_TYPE.QUALITY_DISPLAY_EXTRA];
        const sessionAddedKeys = new Set(Array.isArray(qualityGroupOptions) ? qualityGroupOptions : []);
        const out = [];
        QUALITY_DISPLAY_PANEL_TYPES.forEach((panelType) => {
            const invalidField = getQualityInvalidField(panelType);
            const requiresContent = sharedDssdqTypes.includes(canonicalPanelType(panelType));
            const rows = getDetailRowsByPanelType(entrydetailRef.current, panelType);
            (Array.isArray(rows) ? rows : []).forEach((row) => {
                if (isEmpty(row)) return;
                if (invalidField !== "" && String(readRowValueIgnoreCase(row, invalidField) ?? "").trim() === "1") return;
                const context = readFukushizaiItemGroupFromAnyRow(row);
                if (context.itemCd === "" || context.groupNo === "") return;
                if (normalizedItem !== "" && context.itemCd !== normalizedItem) return;
                if (requiresContent
                    && !sessionAddedKeys.has(`${context.itemCd}|${context.groupNo}`)
                    && !qualityRowHasQualityContent(row, panelType)) return;
                out.push(context);
            });
        });
        return out;
    }
    function getKnownQualityGroupNos(itemCd) {
        const normalizedItem = String(itemCd ?? "").trim();
        const seen = new Set();
        const out = [];
        const push = (value) => {
            const normalized = normalizeGroupNo(value);
            if (normalized === "" || seen.has(normalized)) return;
            seen.add(normalized);
            out.push(normalized);
        };
        getQualityDetailGroupContexts(normalizedItem).forEach((context) => push(context.groupNo));
        (Array.isArray(qualityGroupOptions) ? qualityGroupOptions : []).forEach((key) => {
            const parts = String(key ?? "").split("|");
            const item = String(parts[0] ?? "").trim();
            if (normalizedItem !== "" && item !== "" && item !== normalizedItem) return;
            push(parts[1] ?? "");
        });
        return out.sort((a, b) => Number(a) - Number(b) || a.localeCompare(b));
    }
    function hasQualityColorRow(itemCd, groupNo, colorCd) {
        const normalizedItem = String(itemCd ?? "").trim();
        const normalizedGroup = normalizeGroupNo(groupNo);
        const normalizedColor = normalizeColorCd(colorCd);
        if (normalizedItem === "" || normalizedGroup === "" || normalizedColor === "") return false;
        return getQualityDetailGroupContexts(normalizedItem).some((context) =>
            context.groupNo === normalizedGroup && context.colorCd === normalizedColor
        );
    }
    // 品質表示グループの色候補(checked=そのグループの品質detail行に存在するカラー)。
    function getQualityColorOptions(itemCd, groupNo, mode = "edit") {
        const targetItem = String(itemCd ?? "").trim();
        const targetGroup = normalizeGroupNo(groupNo);
        const rows = Array.isArray(fukushizaiColorMasterOptions) ? fukushizaiColorMasterOptions : [];
        const seen = new Set();
        return rows
            .map((row) => {
                const colorCd = getNamedOptionCode(row) || String(row.color ?? "").trim();
                if (colorCd === "" || seen.has(colorCd)) return null;
                seen.add(colorCd);
                return {
                    colorCd,
                    colorName: getNamedOptionName(row) || String(row.colorName ?? "").trim(),
                    checked: mode === "add" ? false : hasQualityColorRow(targetItem, targetGroup, colorCd)
                };
            })
            .filter((item) => !isEmpty(item));
    }
    // 品質表示BASE(118)に指定色のキー行を補完する(品質側グループ追加用)。
    function ensureQualityBaseKeyRowsForColors(itemCd, groupNo, colorCodes) {
        const item = normalizeItemCd(itemCd);
        const group = normalizeGroupNo(groupNo);
        const colors = [...new Set((Array.isArray(colorCodes) ? colorCodes : [])
            .map((value) => normalizeColorCd(value))
            .filter((value) => value !== ""))];
        if (item === "" || group === "" || colors.length === 0) return false;
        const detail = ensureDetailRowsByTypeForMutation(PANEL_TYPE.QUALITY_BASE);
        const rows = Array.isArray(detail.rows) ? detail.rows : [];
        let changed = false;
        colors.forEach((colorCd) => {
            const exists = rows.some((row) => {
                const context = readFukushizaiItemGroupFromAnyRow(row);
                return context.itemCd === item && context.groupNo === group && context.colorCd === colorCd;
            });
            if (exists) return;
            rows.push({
                rowid: nextFukushizaiDetailRowId(rows),
                SSDQ_ITMCITEMCD: item,
                SSDQ_GROUPNO: group,
                SSDQ_COLORCD: colorCd
            });
            changed = true;
        });
        if (changed) entrydetailRef.current[detail.key] = rows;
        return changed;
    }
    function hasFukushizaiGroupOption(itemCd, groupNo) {
        const normalizedGroup = normalizeGroupNo(groupNo);
        if (normalizedGroup === "") return false;
        if (normalizeGroupNo(selectedGroup) === normalizedGroup && normalizedGroup !== "") return true;
        if (normalizeGroupNo(copyGroup) === normalizedGroup && normalizedGroup !== "") return true;
        const seen = new Set();
        const push = (value) => {
            const normalized = normalizeGroupNo(value);
            if (normalized === "" || seen.has(normalized)) return;
            seen.add(normalized);
        };
        (Array.isArray(groupOptions) ? groupOptions : []).forEach(push);
        getCurrentFukushizaiGroupRows().forEach((row) => {
            if (isEmpty(row)) return;
            push(DicVal(row, "group", ""));
        });
        if (seen.has(normalizedGroup)) return true;
        const normalizedItem = String(itemCd ?? "").trim();
        if (normalizedItem === "") return false;
        return getKnownFukushizaiGroupNos(normalizedItem).indexOf(normalizedGroup) !== -1;
    }
    function hasFukushizaiUiGroupOption(itemCd, groupNo) {
        const normalizedGroup = normalizeGroupNo(groupNo);
        if (normalizedGroup === "") return false;
        const normalizedItem = String(itemCd ?? selectedSetItem ?? "").trim();
        const seen = new Set();
        const push = (value) => {
            const normalized = normalizeGroupNo(value);
            if (normalized === "" || seen.has(normalized)) return;
            seen.add(normalized);
        };
        push(selectedGroup);
        push(copyGroup);
        (Array.isArray(groupOptions) ? groupOptions : []).forEach(push);
        getCurrentFukushizaiGroupRows().forEach((row) => {
            if (isEmpty(row)) return;
            push(DicVal(row, "group", ""));
        });
        if (normalizedItem !== "") {
            getExistingFukushizaiGroupNos(normalizedItem).forEach(push);
        }
        return seen.has(normalizedGroup);
    }
    function resolveFukushizaiContext(rows, context) {
        const list = Array.isArray(rows) ? rows.filter((row) => !isEmpty(row)) : [];
        const normalized = normalizeFukushizaiContext(context);
        if (list.length === 0 || normalized.itemCd === "" || normalized.groupNo === "") {
            return { ...normalized, colorCd: normalized.itemCd === "" || normalized.groupNo === "" ? "" : normalized.colorCd };
        }
        const groupRows = list.filter((row) => sameItemGroup(row, normalized.itemCd, normalized.groupNo));
        const hitRow = groupRows.find((row) =>
            normalized.colorCd === "" || sameItemGroupColor(row, normalized.itemCd, normalized.groupNo, normalized.colorCd)
        ) || null;
        const colorCd = isEmpty(hitRow) ? normalized.colorCd : getColorCdFromRow(hitRow);
        return { itemCd: normalized.itemCd, colorCd, groupNo: normalized.groupNo };
    }
    function getFukushizaiGroupOptionsByItem(rows, itemCd) {
        const list = Array.isArray(rows) ? rows.filter((row) => !isEmpty(row)) : [];
        const normalizedItem = normalizeItemCd(itemCd);
        const baseRows = normalizedItem === ""
            ? list
            : list.filter((row) => getItemCdFromRow(row) === normalizedItem);
        return [...new Set(distinctTextList(baseRows, FUKUSHIZAI_FIELD.GROUP_NO).map((value) => normalizeGroupNo(value)).filter((value) => value !== ""))];
    }
    function resolveFukushizaiItemMasterDataId() {
        const hit = findColumnInfoByCandidates(["SSDZ_ITMCITEMCD"], ["113"]) || findColumnInfoByCandidates(["SSDZ_ITMCITEMCD"], []);
        return readColumnMasterDataId(hit);
    }
    function resolveFukushizaiColorMasterDataId() {
        const hit = findColumnInfoByCandidates(["SSDZ_COLORCD"], ["113"]) || findColumnInfoByCandidates(["SSDZ_COLORCD"], []);
        return readColumnMasterDataId(hit);
    }
    function buildFukushizaiItemMasterOptionsFromLayout() {
        return buildNamedOptionsFromColumnMaster(
            "SSDZ_ITMCITEMCD",
            ["113"],
            ["code", "value", "itemCd", "item", "PDT_ITMCITEMCD", "SSDZ_ITMCITEMCD"],
            ["name", "itemName", "label", "abbr", "PDT_ITMCITEMCD"]
        );
    }
    function buildFukushizaiColorMasterOptionsFromLayout() {
        return buildNamedOptionsFromColumnMaster(
            "SSDZ_COLORCD",
            ["113"],
            ["code", "value", "colorCd", "color", "PDTC_COLORCD", "SSDZ_COLORCD"],
            ["name", "colorName", "label", "abbr", "PDTC_COLORNM", "PDTC_COLOR_NM"]
        );
    }
    function collectFukushizaiSourceRows(itemCd) {
        const normalizedItem = String(itemCd ?? "").trim();
        const detailRows = getFukushizaiDetailRows(normalizedItem);
        const sourceRows = [];
        const seen = new Set();
        const pushRow = (item, color, group, row, source) => {
            const nextItem = String(item ?? "").trim();
            const nextColor = String(color ?? "").trim();
            const nextGroup = normalizeGroupNo(group);
            if (nextItem === "") return;
            if (normalizedItem !== "" && nextItem !== normalizedItem) return;
            const key = `${nextItem}\u0001${nextColor}\u0001${nextGroup}`;
            if (seen.has(key)) return;
            seen.add(key);
            sourceRows.push({
                item: nextItem,
                color: nextColor,
                group: nextGroup,
                itemName: readFukushizaiItemName(row),
                colorName: readFukushizaiColorName(row),
                sourceRow: row || null,
                source: source || ""
            });
        };
        (Array.isArray(detailRows) ? detailRows : []).forEach((row) => {
            if (isEmpty(row)) return;
            pushRow(
                readRowValueIgnoreCase(row, "SSDZ_ITMCITEMCD"),
                readRowValueIgnoreCase(row, "SSDZ_COLORCD"),
                readRowValueIgnoreCase(row, "SSDZ_FUKUSIZAICOLORGRP"),
                row,
                "detail"
            );
        });
        getCurrentFukushizaiGroupRows().forEach((row) => {
            if (isEmpty(row)) return;
            pushRow(
                DicVal(row, "item", ""),
                DicVal(row, "color", ""),
                DicVal(row, "group", ""),
                row,
                "groupRows"
            );
        });
        return sourceRows;
    }
    function getFukushizaiColorOptions(itemCd, groupNo, mode = "add", sourceItem = "") {
        const targetItem = String(mode === "copy" ? sourceItem : itemCd ?? "").trim();
        const targetGroup = normalizeGroupNo(groupNo);
        const rows = Array.isArray(fukushizaiColorMasterOptions) ? fukushizaiColorMasterOptions : [];
        const seen = new Set();
        return rows
            .map((row) => {
                const colorCd = getNamedOptionCode(row) || String(row.color ?? "").trim();
                if (colorCd === "" || seen.has(colorCd)) return null;
                seen.add(colorCd);
                const isChecked = mode === "edit"
                    ? hasFukushizaiColorRow(targetItem, targetGroup, colorCd)
                    : mode === "copy"
                        ? hasFukushizaiColorRow(targetItem, targetGroup, colorCd)
                        : false;
                return {
                    colorCd,
                    colorName: getNamedOptionName(row) || String(row.colorName ?? "").trim(),
                    checked: isChecked
                };
            })
            .filter((item) => !isEmpty(item));
    }
    function getExistingFukushizaiGroupNos(itemCd) {
        const rows = getFukushizaiDetailRows(itemCd);
        const seen = new Set();
        const out = [];
        rows.forEach((row) => {
            const groupNo = normalizeGroupNo(readRowValueIgnoreCase(row, "SSDZ_FUKUSIZAICOLORGRP"));
            if (groupNo === "" || seen.has(groupNo)) return;
            seen.add(groupNo);
            out.push(groupNo);
        });
        return out;
    }
    function getFirstFukushizaiGroupNo(itemCd) {
        return getKnownFukushizaiGroupNos(itemCd)
            .map((value) => normalizeGroupNo(value))
            .filter((value) => value !== "")
            .sort((a, b) => Number(a) - Number(b) || a.localeCompare(b))[0] || "";
    }
    function ensureFukushizaiSelectedGroupForItem(itemCd, preferredGroupNo = selectedGroup) {
        const item = normalizeKakousijiUiString(itemCd);
        if (item === "") return "";
        const groups = getKnownFukushizaiGroupNos(item)
            .map((value) => normalizeGroupNo(value))
            .filter((value) => value !== "")
            .sort((a, b) => Number(a) - Number(b) || a.localeCompare(b));
        const preferred = normalizeGroupNo(preferredGroupNo);
        const nextGroup = preferred !== "" && groups.includes(preferred)
            ? preferred
            : (groups[0] || "");
        if (nextGroup === "") return "";
        setSelectedGroup(nextGroup);
        updateSelectedFukushizaiContext({ itemCd: item, groupNo: nextGroup });
        return nextGroup;
    }
    function ensureFukushizaiDetailRowsForMutation() {
        if (isEmpty(entrydetailRef.current) || typeof entrydetailRef.current !== "object") entrydetailRef.current = {};
        const hitKey = Object.keys(entrydetailRef.current).find((key) => normalizeTypeKey(key) === "113") || "113";
        if (!Array.isArray(entrydetailRef.current[hitKey])) entrydetailRef.current[hitKey] = [];
        return entrydetailRef.current[hitKey];
    }
    function readCurrentFukushizaiNo() {
        return String(
            DicVal(entrydataRef.current, "SSDZ_NO",
                DicVal(entrydataRef.current, "SSD_NO",
                    DicVal(entrydataRef.current, "NO",
                        DicVal(entrydataRef.current, "rowid", edittingcode)
                    )
                )
            ) ?? ""
        ).trim() || String(edittingcode ?? "").trim();
    }
    function nextFukushizaiDetailRowId(rows) {
        const nums = (Array.isArray(rows) ? rows : [])
            .map((row) => Number(String(DicVal(row, "rowid", "") ?? "").trim()))
            .filter((value) => Number.isFinite(value) && value >= 0);
        return String(nums.length === 0 ? 0 : Math.max(...nums) + 1);
    }
    function stripFukushizaiRowForState(row) {
        const next = stripKakousijiSavePayloadUiOnlyFields(clearFukushizaiDisplayProjectionFields({ ...(row || {}) }), "113");
        Object.keys(next).forEach((key) => {
            const cid = String(key ?? "").trim().toUpperCase();
            if (cid.startsWith("__") || cid.endsWith("_DMY")) delete next[key];
        });
        delete next.rowid;
        delete next.index;
        delete next.grip;
        return next;
    }
    function getFukushizaiRowsByContext(itemCd, groupNo) {
        const normalizedItem = normalizeKakousijiUiString(itemCd);
        const normalizedGroup = normalizeGroupNo(groupNo);
        if (normalizedItem === "" || normalizedGroup === "") return [];
        return ensureFukushizaiDetailRowsForMutation().filter((row) => {
            if (isEmpty(row)) return false;
            return normalizeKakousijiUiString(readRowValueIgnoreCase(row, "SSDZ_ITMCITEMCD")) === normalizedItem
                && normalizeGroupNo(readRowValueIgnoreCase(row, "SSDZ_FUKUSIZAICOLORGRP")) === normalizedGroup;
        });
    }
    function applyFukushizaiSsdzRowTemplateDefaults(row) {
        if (isEmpty(row) || typeof row !== "object") return row;
        const fieldIds = new Set([
            ...FUKUSHIZAI_SSDZ_TEMPLATE_FIELD_IDS,
            ...getFukushizaiSsdzSaveColumnIdSet()
        ].map((fieldId) => normalizeColumnIdUpper(fieldId)).filter((fieldId) => fieldId !== ""));
        fieldIds.forEach((fieldId) => {
            if (isKakousijiSavePayloadUiOnlyField(fieldId, FUKUSHIZAI_BASE_PANEL_TYPE)) return;
            if (fieldId === "ROWID" || fieldId === "GRIP" || fieldId === "ROW_KIND") return;
            if (!Object.prototype.hasOwnProperty.call(row, fieldId)) row[fieldId] = "";
        });
        return row;
    }
    function createFukushizaiGroupDetailRow(itemCd, groupNo, colorCd, baseRow = null, inheritValues = false) {
        const rows = ensureFukushizaiDetailRowsForMutation();
        const normalizedItem = normalizeKakousijiUiString(itemCd);
        const normalizedGroup = normalizeGroupNo(groupNo);
        const normalizedColor = normalizeKakousijiUiString(colorCd);
        const nextRow = inheritValues && !isEmpty(baseRow)
            ? stripFukushizaiRowForState(baseRow)
            : {};
        if (inheritValues && !isEmpty(baseRow)) {
            const copyFieldIds = getFukushizaiGroupCopyFieldIds();
            Object.keys(nextRow).forEach((key) => {
                const cid = String(key ?? "").trim().toUpperCase();
                if (cid.startsWith("SSDZ_") && !copyFieldIds.some((fieldId) => String(fieldId ?? "").trim().toUpperCase() === cid)) {
                    delete nextRow[key];
                }
            });
        }
        applyFukushizaiSsdzRowTemplateDefaults(nextRow);
        nextRow.rowid = nextFukushizaiDetailRowId(rows);
        nextRow.SSDZ_NO = readCurrentFukushizaiNo();
        nextRow.SSDZ_ITMCITEMCD = normalizedItem;
        nextRow.SSDZ_FUKUSIZAICOLORGRP = normalizedGroup;
        nextRow.SSDZ_COLORCD = normalizedColor;
        delete nextRow.SSDZ_SONOTAFUZOKUCD6;
        clearFukushizaiVerticalMasterNameFields(nextRow, {
            timing: "group-row-create",
            reason: inheritValues ? "copy-or-inherit-row" : "new-key-row"
        });
        return nextRow;
    }
    function ensureFukushizaiBaseKeyRowsForColors(itemCd, groupNo, colorCodes) {
        const item = normalizeItemCd(itemCd);
        const group = normalizeGroupNo(groupNo);
        const colors = [...new Set((Array.isArray(colorCodes) ? colorCodes : [])
            .map((value) => normalizeColorCd(value))
            .filter((value) => value !== ""))];
        if (item === "" || group === "" || colors.length === 0) return false;
        const rows = ensureFukushizaiDetailRowsForMutation();
        let changed = false;
        colors.forEach((colorCd) => {
            if (rows.some((row) => sameItemGroupColor(row, item, group, colorCd))) return;
            const nextRow = createFukushizaiGroupDetailRow(item, group, colorCd, null, false);
            if (isEmpty(nextRow)) return;
            rows.push(nextRow);
            changed = true;
        });
        return changed;
    }
    function hasAnyFukushizaiBaseValue(entryObj) {
        if (isEmpty(entryObj) || typeof entryObj !== "object") return false;
        return getFukushizaiBaseFieldIds().some((fieldId) => {
            if (!Object.prototype.hasOwnProperty.call(entryObj, fieldId)) return false;
            const value = DicVal(entryObj, fieldId, null);
            if (value === null || value === undefined) return false;
            if (typeof value === "object") {
                const codeName = readFukushizaiMasterCodeNameFromValue(fieldId, value);
                return codeName.code !== "" || codeName.name !== "";
            }
            return String(value ?? "").trim() !== "";
        });
    }
    function resolveFukushizaiEntryContextFromData(entryObj) {
        const source = isEmpty(entryObj) ? {} : entryObj;
        const itemCd = normalizeItemCd(
            readRowValueIgnoreCase(source, "SSDZ_ITMCITEMCD")
            || DicVal(source, "selectedSetItem", "")
            || selectedFukushizaiContextRef.current?.itemCd
            || selectedSetItem
        );
        const groupNo = normalizeGroupNo(
            readRowValueIgnoreCase(source, "SSDZ_FUKUSIZAICOLORGRP")
            || DicVal(source, "selectedGroup", "")
            || selectedFukushizaiContextRef.current?.groupNo
            || selectedGroup
        );
        const colorCd = normalizeColorCd(
            readRowValueIgnoreCase(source, "SSDZ_COLORCD")
            || DicVal(source, "selectedColorCd", "")
            || selectedFukushizaiContextRef.current?.colorCd
        );
        return normalizeFukushizaiContext({ itemCd, groupNo, colorCd });
    }
    function ensureFukushizaiDetailRowsFromEntryData(entryObj) {
        if (isEmpty(entryObj) || typeof entryObj !== "object") return false;
        const context = resolveFukushizaiEntryContextFromData(entryObj);
        if (!hasCompleteFukushizaiContext(context) || context.colorCd === "" || !hasAnyFukushizaiBaseValue(entryObj)) {
            return false;
        }
        const detail = ensureDetailRowsByTypeForMutation(FUKUSHIZAI_BASE_PANEL_TYPE);
        const rows = Array.isArray(detail.rows) ? detail.rows : [];
        let targetIndex = rows.findIndex((row) => sameItemGroupColor(row, context.itemCd, context.groupNo, context.colorCd));
        if (targetIndex === -1) {
            targetIndex = rows.findIndex((row) => sameItemGroup(row, context.itemCd, context.groupNo));
        }
        if (targetIndex === -1) {
            const nextRow = createFukushizaiGroupDetailRow(context.itemCd, context.groupNo, context.colorCd, null, false);
            if (isEmpty(nextRow)) return false;
            getFukushizaiBaseFieldIds().forEach((fieldId) => {
                if (!Object.prototype.hasOwnProperty.call(entryObj, fieldId)) return;
                nextRow[fieldId] = entryObj[fieldId];
            });
            rows.push(nextRow);
            return true;
        }
        let changed = false;
        rows.forEach((row, index) => {
            if (!sameItemGroup(row, context.itemCd, context.groupNo)) return;
            const nextRow = { ...row };
            let rowChanged = false;
            getFukushizaiBaseFieldIds().forEach((fieldId) => {
                if (!Object.prototype.hasOwnProperty.call(entryObj, fieldId)) return;
                if (nextRow[fieldId] === entryObj[fieldId]) return;
                nextRow[fieldId] = entryObj[fieldId];
                rowChanged = true;
            });
            if (!rowChanged) return;
            rows[index] = nextRow;
            changed = true;
        });
        return changed;
    }
    function resolveGridPanelByType(panelType) {
        const target = canonicalPanelType(panelType);
        if (target === "" || !Array.isArray(gridlist)) return null;
        return gridlist.find((panelInfo) => canonicalPanelType(DicVal(panelInfo, "type", "")) === target) || null;
    }
    function ensureDetailRowsByTypeForMutation(panelType) {
        if (isEmpty(entrydetailRef.current) || typeof entrydetailRef.current !== "object") entrydetailRef.current = {};
        const typeKey = canonicalPanelType(panelType);
        const hitKey = Object.keys(entrydetailRef.current).find((key) => canonicalPanelType(key) === typeKey) || typeKey;
        if (!Array.isArray(entrydetailRef.current[hitKey])) entrydetailRef.current[hitKey] = [];
        return { key: hitKey, rows: entrydetailRef.current[hitKey] };
    }
    function readFukushizaiItemGroupFromAnyRow(row) {
        const hasAnyKey = [
            "SSDZ_ITMCITEMCD", "SSDQ_ITMCITEMCD", "SSDH_ITMCITEMCD", "SSDY_ITMCITEMCD", "SSDB_ITMCITEMCD", "SSDD_ITMCITEMCD", "SSDE_ITMCITEMCD", "item", "itemCd",
            "SSDZ_FUKUSIZAICOLORGRP", "SSDQ_GROUPNO", "SSDH_GROUPNO", "SSDY_GROUPNO", "SSDB_GROUPNO", "SSDD_GROUPNO", "SSDE_GROUPNO",
            "SSDQ_FUKUSIZAICOLORGRP", "SSDH_FUKUSIZAICOLORGRP", "SSDY_FUKUSIZAICOLORGRP", "SSDB_FUKUSIZAICOLORGRP", "SSDD_FUKUSIZAICOLORGRP", "SSDE_FUKUSIZAICOLORGRP", "group", "groupNo"
        ].some((key) => Object.prototype.hasOwnProperty.call(row || {}, key));
        if (!hasAnyKey) return { itemCd: "", groupNo: "", colorCd: "", hasItemGroupKey: false };
        const itemCd = normalizeKakousijiUiString(
            readRowValueIgnoreCase(row, "SSDZ_ITMCITEMCD")
            ?? readRowValueIgnoreCase(row, "SSDQ_ITMCITEMCD")
            ?? readRowValueIgnoreCase(row, "SSDH_ITMCITEMCD")
            ?? readRowValueIgnoreCase(row, "SSDY_ITMCITEMCD")
            ?? readRowValueIgnoreCase(row, "SSDB_ITMCITEMCD")
            ?? readRowValueIgnoreCase(row, "SSDD_ITMCITEMCD")
            ?? readRowValueIgnoreCase(row, "SSDE_ITMCITEMCD")
            ?? DicVal(row, "item", DicVal(row, "itemCd", ""))
        );
        const groupNo = normalizeGroupNo(
            readRowValueIgnoreCase(row, "SSDZ_FUKUSIZAICOLORGRP")
            ?? readRowValueIgnoreCase(row, "SSDQ_GROUPNO")
            ?? readRowValueIgnoreCase(row, "SSDH_GROUPNO")
            ?? readRowValueIgnoreCase(row, "SSDY_GROUPNO")
            ?? readRowValueIgnoreCase(row, "SSDB_GROUPNO")
            ?? readRowValueIgnoreCase(row, "SSDD_GROUPNO")
            ?? readRowValueIgnoreCase(row, "SSDE_GROUPNO")
            ?? readRowValueIgnoreCase(row, "SSDQ_FUKUSIZAICOLORGRP")
            ?? readRowValueIgnoreCase(row, "SSDH_FUKUSIZAICOLORGRP")
            ?? readRowValueIgnoreCase(row, "SSDY_FUKUSIZAICOLORGRP")
            ?? readRowValueIgnoreCase(row, "SSDB_FUKUSIZAICOLORGRP")
            ?? readRowValueIgnoreCase(row, "SSDD_FUKUSIZAICOLORGRP")
            ?? readRowValueIgnoreCase(row, "SSDE_FUKUSIZAICOLORGRP")
            ?? DicVal(row, "group", DicVal(row, "groupNo", ""))
        );
        const colorCd = normalizeKakousijiUiString(
            readRowValueIgnoreCase(row, "SSDZ_COLORCD")
            ?? readRowValueIgnoreCase(row, "SSDQ_COLORCD")
            ?? readRowValueIgnoreCase(row, "SSDH_COLORCD")
            ?? readRowValueIgnoreCase(row, "SSDY_COLORCD")
            ?? readRowValueIgnoreCase(row, "SSDB_COLORCD")
            ?? readRowValueIgnoreCase(row, "SSDD_COLORCD")
            ?? readRowValueIgnoreCase(row, "SSDE_COLORCD")
            ?? DicVal(row, "color", DicVal(row, "colorCd", ""))
        );
        return { itemCd, groupNo, colorCd, hasItemGroupKey: true };
    }
    function rowMatchesFukushizaiItemGroup(row, itemCd, groupNo) {
        const context = readFukushizaiItemGroupFromAnyRow(row);
        const targetItem = normalizeKakousijiUiString(itemCd);
        const targetGroup = normalizeGroupNo(groupNo);
        return context.hasItemGroupKey === true && targetItem !== "" && targetGroup !== "" && context.itemCd === targetItem && context.groupNo === targetGroup;
    }
    function rowMatchesFukushizaiItemGroupColor(row, itemCd, groupNo, colorCd) {
        const context = readFukushizaiItemGroupFromAnyRow(row);
        const targetColor = normalizeColorCd(colorCd);
        return rowMatchesFukushizaiItemGroup(row, itemCd, groupNo)
            && targetColor !== ""
            && context.colorCd === targetColor;
    }
    // 品質表示メタ判定へ渡す依存関係をまとめます。
    function buildQualityFieldServiceDeps() {
        return {
            PANEL_TYPE,
            ROW_ID_FIELD,
            QUALITY_PANEL_FIELD_MAP,
            DicVal,
            canonicalPanelType,
            normalizeColumnIdUpper,
            getSaveableColumnIdSetByPanelType,
            isKakousijiSavePayloadUiOnlyField
        };
    }
    // 品質表示メタ判定は専用 service へ委譲します。
    const {
        getQualityPanelFieldMap,
        getQualityInvalidField,
        getQualityBaseFieldIds,
        isQualityBaseField
    } = createQualityFieldService(buildQualityFieldServiceDeps());
    function createQualityBaseRow(itemCd, groupNo, colorCd) {
        const detail = ensureDetailRowsByTypeForMutation(PANEL_TYPE.QUALITY_BASE);
        const rows = Array.isArray(detail.rows) ? detail.rows : [];
        const next = {};
        next[ROW_ID_FIELD] = String(nextDetailRowIdForRows(rows));
        setRowContextForPanel(next, PANEL_TYPE.QUALITY_BASE, itemCd, groupNo, colorCd);
        return next;
    }
    // 品質表示の entry 投影へ渡す依存関係をまとめます。
    function buildQualityEntryProjectionServiceDeps() {
        return {
            selectedQualityContextRef,
            fukushizaiDetailSyncingRef,
            PANEL_TYPE,
            QUALITY_ROOT_DATA_PREFIXES,
            isEmpty,
            DicVal,
            normalizeColumnIdUpper,
            normalizeFukushizaiContext,
            getDetailRowsByPanelType,
            rowMatchesFukushizaiItemGroup,
            rowMatchesFukushizaiItemGroupColor,
            getQualityBaseFieldIds,
            readFukushizaiItemGroupFromAnyRow,
            setQualityEntryProjectionContext,
            activateFukushizaiProjectionGuard
        };
    }
    // 品質表示の代表行選定と entry 投影は専用 service へ委譲します。
    const {
        clearQualityBaseMergedFields,
        pickQualityRepresentativeRow,
        mergeQualityRepresentativeRowToEntry
    } = createQualityEntryProjectionService(buildQualityEntryProjectionServiceDeps());
    // 品質表示の表示 row helper へ渡す依存関係をまとめます。
    function buildQualityDisplayRowServiceDeps() {
        return {
            PANEL_TYPE,
            ROW_ID_FIELD,
            DEMERIT_NAME_FLG,
            DEMERIT_HUDA_FLG,
            isEmpty,
            DicVal,
            canonicalPanelType,
            normalizeColumnIdUpper,
            normalizeKakousijiUiString,
            normalizeColorCd,
            getPanelType,
            getQualityPanelFieldMap,
            getQualityInvalidField,
            qualityPanelContentColumnIds,
            isKakousijiSavePayloadUiOnlyField,
            readRowValueIgnoreCase,
            normalizeDemeritRow: (row) => {
                const rows = normalizeDemeritRows([row]);
                return Array.isArray(rows) && rows.length !== 0 ? rows[0] : row;
            },
            normalizeDemeritRowForSave,
            applyWashMarkDisplayFields,
            isQualityPanelType
        };
    }
    // 品質表示の表示 row helper は専用 service へ委譲します。
    const {
        isInvalidDisplayRow,
        filterInvalidRowsForPanel,
        normalizeQualityDisplayRowForPanel,
        stripQualityDisplayMetaFields,
        normalizeQualityDisplayRowForSave,
        isQualityDisplayRowMeaningful,
        readQualityDisplayTargetColors
    } = createQualityDisplayRowService(buildQualityDisplayRowServiceDeps());
    // =====================================================================
    // 洗濯表示 124
    // ---------------------------------------------------------------------
    // WashGridの表示行と D_SSDE 保存行を同期する。
    // =====================================================================
    // =====================================================================
    // マスタ検索ルーティング
    // ---------------------------------------------------------------------
    // 共通検索で不足する条件をKakousiji専用検索へ切り替える。
    // NOTE: M_FZK/FM_FZKは巨大なためpreloadしない。
    // =====================================================================

    function isMaterialAccessoryMasterDataInfo(dataInfo) {
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const colId = normalizeColumnIdUpper(DicVal(dataInfo, "colId", DicVal(dataInfo, "field", DicVal(dataInfo, "columnid", ""))));
        const columnId = normalizeColumnIdUpper(DicVal(dataInfo, "columnid", colId));
        const table = normalizeColumnIdUpper(DicVal(dataInfo, "table", ""));
        if (panelType === PANEL_TYPE.MATERIAL_DETAIL && (colId === "SSDS_ZAIHINBAN" || columnId === "SSDS_ZAIHINBAN")) {
            return table === "" || table === "D_SSDS";
        }
        if (panelType === PANEL_TYPE.ACCESSORY_DETAIL && (colId === "SSDF_FUZOKU_HINBAN" || columnId === "SSDF_FUZOKU_HINBAN")) {
            return table === "" || table === "D_SSDF";
        }
        return false;
    }
    function isSijisuPdtcMasterDataInfo(dataInfo) {
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const colId = normalizeColumnIdUpper(DicVal(dataInfo, "colId", DicVal(dataInfo, "field", DicVal(dataInfo, "columnid", ""))));
        const columnId = normalizeColumnIdUpper(DicVal(dataInfo, "columnid", colId));
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", "")));
        const baseDataId = dataId.split(":")[0].trim().toUpperCase();
        const fieldMatch = colId === "SSDM_COLORCD"
            || columnId === "SSDM_COLORCD"
            || colId === "SSDM_SIZECD"
            || columnId === "SSDM_SIZECD";
        const dataIdMatch = baseDataId === "FM_PDTC_COLOR" || baseDataId === "FM_PDTC_SIZE";
        if (panelType !== PANEL_TYPE.SIJISU && !fieldMatch && !dataIdMatch) return false;
        return fieldMatch || dataIdMatch;
    }
    function resolveSijisuPdtcDataInfo(payload) {
        if (isEmpty(payload)) return {};
        const candidates = [
            DicVal(payload, "data", {}),
            DicVal(payload, "datainfo", {}),
            DicVal(payload, "dataInfo", {}),
            DicVal(payload, "colinfo", {}),
            DicVal(payload, "colInfo", {})
        ];
        for (let i = 0; i < candidates.length; i++) {
            if (isSijisuPdtcMasterDataInfo(candidates[i])) return candidates[i];
        }
        const dataid = normalizeKakousijiUiString(DicVal(payload, "dataid", ""));
        const others = Array.isArray(DicVal(payload, "others", null)) ? DicVal(payload, "others", []) : [];
        const firstOther = others.length !== 0 ? others[0] : {};
        const columnid = normalizeKakousijiUiString(DicVal(firstOther, "columnid", ""));
        const dbcolumn = normalizeKakousijiUiString(DicVal(firstOther, "dbcolumn", ""));
        const inferred = {
            dataid,
            mastertype: dataid,
            columnid,
            colId: columnid,
            field: columnid,
            dbcolumn
        };
        return isSijisuPdtcMasterDataInfo(inferred) ? inferred : {};
    }
    function sijisuPdtcFieldIdFromDataInfo(dataInfo) {
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const colId = normalizeColumnIdUpper(DicVal(dataInfo, "colId", DicVal(dataInfo, "field", DicVal(dataInfo, "columnid", ""))));
        const columnId = normalizeColumnIdUpper(DicVal(dataInfo, "columnid", colId));
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", "")));
        if (panelType === PANEL_TYPE.SIJISU) {
            if (colId === "SSDM_SIZECD" || columnId === "SSDM_SIZECD" || dataId.indexOf("SIZE") !== -1) return "SSDM_SIZECD";
            return "SSDM_COLORCD";
        }
        if (colId === "SSDM_COLORCD" || columnId === "SSDM_COLORCD") return "SSDM_COLORCD";
        if (colId === "SSDM_SIZECD" || columnId === "SSDM_SIZECD") return "SSDM_SIZECD";
        if (dataId.indexOf("SIZE") !== -1) return "SSDM_SIZECD";
        if (dataId.indexOf("COLOR") !== -1) return "SSDM_COLORCD";
        return "";
    }
    function isSijisuPdtcMasterColumn(panelInfo, colDef) {
        const colInfo = DicVal(colDef, "colinfo", {});
        const dataInfo = {
            ...colInfo,
            type: getPanelType(panelInfo),
            colId: DicVal(colDef, "colId", DicVal(colDef, "field", DicVal(colInfo, "columnid", ""))),
            field: DicVal(colDef, "field", DicVal(colInfo, "columnid", ""))
        };
        return isSijisuPdtcMasterDataInfo(dataInfo);
    }
    function buildSijisuPdtcMasterSearchParam(sourceSearchParam, row = null) {
        const next = normalizeSearchParamObject(isEmpty(sourceSearchParam) ? {} : sourceSearchParam);
        if (typeof next !== "object" || Array.isArray(next)) return next;
        const currentRow = isEmpty(row) ? {} : row;
        const ssdNo = normalizeKakousijiUiString(readRowValueIgnoreCase(currentRow, "SSD_NO"))
            || normalizeKakousijiUiString(readRowValueIgnoreCase(currentRow, "SSDM_NO"))
            || normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "SSD_NO"))
            || normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "SSDM_NO"));
        const oppicd = normalizeKakousijiUiString(readRowValueIgnoreCase(currentRow, "SSD_OPPICD"))
            || normalizeKakousijiUiString(readRowValueIgnoreCase(currentRow, "SSDM_OPPICD"))
            || normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "SSD_OPPICD"))
            || normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "SSDM_OPPICD"));
        const nextRowData = {
            ...(isEmpty(DicVal(next, "rowdata", null)) ? {} : DicVal(next, "rowdata", {})),
            ...(isEmpty(currentRow) ? {} : currentRow)
        };
        if (ssdNo !== "") {
            nextRowData.SSD_NO = ssdNo;
            nextRowData.SSDM_NO = ssdNo;
        }
        if (oppicd !== "") {
            nextRowData.SSD_OPPICD = oppicd;
            nextRowData.SSDM_OPPICD = oppicd;
        }
        next.rowdata = nextRowData;
        return next;
    }
    function applySijisuPdtcMasterSearchParamToColInfo(colInfo, row = null) {
        if (isEmpty(colInfo)) return colInfo;
        const original = getFukushizaiColumnInfoById(DicVal(colInfo, "columnid", ""));
        const baseSearchParam = DicVal(original, "searchparam", DicVal(colInfo, "searchparam", null));
        return {
            ...colInfo,
            searchparam: buildSijisuPdtcMasterSearchParam(baseSearchParam, row)
        };
    }
    function isSubSoseiMasterDataInfo(dataInfo) {
        const colId = normalizeColumnIdUpper(DicVal(dataInfo, "colId", DicVal(dataInfo, "field", DicVal(dataInfo, "columnid", ""))));
        const columnId = normalizeColumnIdUpper(DicVal(dataInfo, "columnid", colId));
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", DicVal(dataInfo, "dataidctrl", ""))));
        const baseDataId = String(dataId ?? "").split(":")[0].trim().toUpperCase();
        return colId === "SSDQ_SUB_SOSEICD"
            || colId === "SSDQNR_SUBSOSEICD1"
            || columnId === "SSDQ_SUB_SOSEICD"
            || columnId === "SSDQNR_SUBSOSEICD1"
            || baseDataId === "M_SSOS";
    }
    function resolveSubSoseiSearchParentCode(source) {
        if (isEmpty(source) || typeof source !== "object") return "";
        const candidates = [
            "SSDQ_SOSEICD",
            "SSDQ_SOSEICD_cd",
            "SSDH_SOSEICD",
            "SSDH_SOSEICD_cd"
        ];
        for (let i = 0; i < candidates.length; i++) {
            const value = normalizeKakousijiUiString(extractMasterCodeFromDisplayValue(readRowValueIgnoreCase(source, candidates[i])));
            if (value !== "") return value;
        }
        return "";
    }
    function isColorwayProductColorMasterDataInfo(dataInfo) {
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const colId = normalizeColumnIdUpper(DicVal(dataInfo, "colId", DicVal(dataInfo, "field", DicVal(dataInfo, "columnid", ""))));
        const columnId = normalizeColumnIdUpper(DicVal(dataInfo, "columnid", colId));
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", "")));
        if (panelType === PANEL_TYPE.MATERIAL_COLORWAY && (colId === "SSDSH_COLORCD" || columnId === "SSDSH_COLORCD")) return true;
        if (panelType === PANEL_TYPE.ACCESSORY_COLORWAY && (colId === "SSDFH_COLORCD" || columnId === "SSDFH_COLORCD")) return true;
        return dataId === "FM_PDTC_COLOR:SSDSH"
            || dataId === "FM_PDTC_COLOR:SSDFH"
            || dataId === "M_PDTC:SSDSH"
            || dataId === "M_PDTC:SSDFH";
    }
    function resolveColorwayProductColorDataInfo(payload) {
        if (isEmpty(payload)) return {};
        const candidates = [
            DicVal(payload, "data", {}),
            DicVal(payload, "datainfo", {}),
            DicVal(payload, "dataInfo", {}),
            DicVal(payload, "colinfo", {}),
            DicVal(payload, "colInfo", {})
        ];
        for (let i = 0; i < candidates.length; i++) {
            if (isColorwayProductColorMasterDataInfo(candidates[i])) return candidates[i];
        }
        const dataid = normalizeKakousijiUiString(DicVal(payload, "dataid", ""));
        const others = Array.isArray(DicVal(payload, "others", null)) ? DicVal(payload, "others", []) : [];
        const firstOther = others.length !== 0 ? others[0] : {};
        const columnid = normalizeKakousijiUiString(DicVal(firstOther, "columnid", ""));
        const dbcolumn = normalizeKakousijiUiString(DicVal(firstOther, "dbcolumn", ""));
        const inferred = {
            dataid,
            mastertype: dataid,
            columnid,
            colId: columnid,
            field: columnid,
            dbcolumn
        };
        return isColorwayProductColorMasterDataInfo(inferred) ? inferred : {};
    }
    function colorwayProductColorFieldIdFromDataInfo(dataInfo) {
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const colId = normalizeColumnIdUpper(DicVal(dataInfo, "colId", DicVal(dataInfo, "field", DicVal(dataInfo, "columnid", ""))));
        const columnId = normalizeColumnIdUpper(DicVal(dataInfo, "columnid", colId));
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", "")));
        const byType = colorwayProductColorFieldId(panelType);
        if (byType !== "") return byType;
        if (colId === "SSDSH_COLORCD" || columnId === "SSDSH_COLORCD") return "SSDSH_COLORCD";
        if (colId === "SSDFH_COLORCD" || columnId === "SSDFH_COLORCD") return "SSDFH_COLORCD";
        if (dataId === "FM_PDTC_COLOR:SSDSH" || dataId === "M_PDTC:SSDSH") return "SSDSH_COLORCD";
        if (dataId === "FM_PDTC_COLOR:SSDFH" || dataId === "M_PDTC:SSDFH") return "SSDFH_COLORCD";
        return "";
    }
    function colorwayProductColorTargetDataIds(dataInfo) {
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", "")));
        if (panelType === PANEL_TYPE.MATERIAL_COLORWAY || dataId === "FM_PDTC_COLOR:SSDSH" || dataId === "M_PDTC:SSDSH") {
            return ["FM_PDTC_COLOR:SSDSH", "M_PDTC:SSDSH"];
        }
        if (panelType === PANEL_TYPE.ACCESSORY_COLORWAY || dataId === "FM_PDTC_COLOR:SSDFH" || dataId === "M_PDTC:SSDFH") {
            return ["FM_PDTC_COLOR:SSDFH", "M_PDTC:SSDFH"];
        }
        return dataId === "" ? [] : [dataId];
    }
    function isColorwayProductColorDataId(dataId) {
        const id = normalizeKakousijiUiString(dataId);
        return id === "FM_PDTC_COLOR:SSDSH"
            || id === "FM_PDTC_COLOR:SSDFH"
            || id === "M_PDTC:SSDSH"
            || id === "M_PDTC:SSDFH";
    }
    function isSsdshColorNoMasterDataInfo(dataInfo) {
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const colId = normalizeColumnIdUpper(DicVal(dataInfo, "colId", DicVal(dataInfo, "field", DicVal(dataInfo, "columnid", ""))));
        const columnId = normalizeColumnIdUpper(DicVal(dataInfo, "columnid", colId));
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", "")));
        if (panelType === PANEL_TYPE.MATERIAL_COLORWAY && (colId === "SSDSH_COLORNO" || columnId === "SSDSH_COLORNO")) return true;
        return dataId === "FM_ZAIC_COLOR"
            || dataId === "FM_ZAIC_COLOR:SSDSH"
            || (dataId === "M_ZAIC" && (colId === "SSDSH_COLORNO" || columnId === "SSDSH_COLORNO"));
    }
    function resolveSsdshColorNoDataInfo(payload) {
        if (isEmpty(payload)) return {};
        const candidates = [
            DicVal(payload, "data", {}),
            DicVal(payload, "datainfo", {}),
            DicVal(payload, "dataInfo", {}),
            DicVal(payload, "colinfo", {}),
            DicVal(payload, "colInfo", {})
        ];
        for (let i = 0; i < candidates.length; i++) {
            if (isSsdshColorNoMasterDataInfo(candidates[i])) return candidates[i];
        }
        const dataid = normalizeKakousijiUiString(DicVal(payload, "dataid", ""));
        const others = Array.isArray(DicVal(payload, "others", null)) ? DicVal(payload, "others", []) : [];
        const firstOther = others.length !== 0 ? others[0] : {};
        const columnid = normalizeKakousijiUiString(DicVal(firstOther, "columnid", ""));
        const dbcolumn = normalizeKakousijiUiString(DicVal(firstOther, "dbcolumn", ""));
        const inferred = {
            dataid,
            mastertype: dataid,
            columnid,
            colId: columnid,
            field: columnid,
            dbcolumn
        };
        return isSsdshColorNoMasterDataInfo(inferred) ? inferred : {};
    }
    function isSsdshColorNoField(type, columnId) {
        return canonicalPanelType(type) === PANEL_TYPE.MATERIAL_COLORWAY
            && normalizeColumnIdUpper(columnId) === "SSDSH_COLORNO";
    }
    function ssdshColorNoFieldIdFromDataInfo(dataInfo) {
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const colId = normalizeColumnIdUpper(DicVal(dataInfo, "colId", DicVal(dataInfo, "field", DicVal(dataInfo, "columnid", ""))));
        const columnId = normalizeColumnIdUpper(DicVal(dataInfo, "columnid", colId));
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", "")));
        if (panelType === PANEL_TYPE.MATERIAL_COLORWAY) return "SSDSH_COLORNO";
        if (colId === "SSDSH_COLORNO" || columnId === "SSDSH_COLORNO") return "SSDSH_COLORNO";
        if (dataId === "FM_ZAIC_COLOR" || dataId === "FM_ZAIC_COLOR:SSDSH") return "SSDSH_COLORNO";
        return "";
    }
    function ssdshColorNoTargetDataIds(dataInfo = {}) {
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", "")));
        if (dataId === "FM_ZAIC_COLOR") return ["FM_ZAIC_COLOR", "FM_ZAIC_COLOR:SSDSH", "M_ZAIC"];
        return ["FM_ZAIC_COLOR:SSDSH", "FM_ZAIC_COLOR", "M_ZAIC"];
    }
    function readSsdshColorNoCode(source, fieldId = "SSDSH_COLORNO") {
        if (isEmpty(source) || typeof source !== "object") return "";
        const candidates = ["ZAIC_COLORCD", "code", fieldId, `${fieldId}_cd`];
        for (let i = 0; i < candidates.length; i++) {
            const code = normalizeColorwayMasterCode(readRowValueIgnoreCase(source, candidates[i]), source);
            if (code !== "") return code;
        }
        return "";
    }
    function readSsdshColorNoName(source, fieldId = "SSDSH_COLORNO", code = "") {
        if (isEmpty(source) || typeof source !== "object") return "";
        const candidates = ["ZAIC_COLORNM", "name", `${fieldId}_nm`, "label", fieldId];
        const targetCode = normalizeKakousijiUiString(code);
        for (let i = 0; i < candidates.length; i++) {
            const value = readRowValueIgnoreCase(source, candidates[i]);
            if (targetCode !== "") {
                if (candidates[i] === `${fieldId}_nm`) {
                    const relatedCode = normalizeColorwayMasterCode(readRowValueIgnoreCase(source, `${fieldId}_cd`), source);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
                if (candidates[i] === "ZAIC_COLORNM") {
                    const relatedCode = normalizeColorwayMasterCode(readRowValueIgnoreCase(source, "ZAIC_COLORCD"), source);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
                if (candidates[i] === fieldId) {
                    const relatedCode = normalizeColorwayMasterCode(value, source);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
            }
            if (candidates[i] === fieldId && normalizeKakousijiUiString(value).indexOf(":") === -1 && normalizeKakousijiUiString(value).indexOf("：") === -1) continue;
            const name = normalizeColorwayMasterName(value);
            if (name !== "" && !isRowIdLikeColorwayCode(name, source)) return name;
        }
        return "";
    }
    function resolveSsdshColorNoCachedName(code, fieldId = "SSDSH_COLORNO") {
        const targetCode = normalizeKakousijiUiString(code);
        if (targetCode === "") return "";
        const cache = DicVal(colorwayMaterialColorNoSelectionCacheRef, "current", {});
        const cached = DicVal(cache, targetCode, null);
        if (isEmpty(cached)) return "";
        const cachedFieldId = normalizeColumnIdUpper(DicVal(cached, "fieldId", ""));
        if (fieldId !== "" && cachedFieldId !== "" && cachedFieldId !== normalizeColumnIdUpper(fieldId)) return "";
        return normalizeKakousijiUiString(DicVal(cached, "name", ""));
    }
    function resolveSsdshColorNoMasterName(code, fieldId = "SSDSH_COLORNO") {
        const targetCode = normalizeKakousijiUiString(code);
        if (targetCode === "" || isEmpty(fnc.current) || typeof fnc.current.getMaster !== "function") return "";
        const targetDataIds = ssdshColorNoTargetDataIds({ dataid: "FM_ZAIC_COLOR:SSDSH" });
        for (let i = 0; i < targetDataIds.length; i++) {
            const masterRow = fnc.current.getMaster(targetDataIds[i], targetCode);
            const name = readSsdshColorNoName(masterRow, fieldId, targetCode);
            if (name !== "") return name;
        }
        return "";
    }
    function resolveSsdshColorNoNameFromRows(rows, fieldId, code) {
        const targetCode = normalizeKakousijiUiString(code);
        if (!Array.isArray(rows) || fieldId === "" || targetCode === "") return "";
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            if (isEmpty(row) || typeof row !== "object") continue;
            const rowCode = readSsdshColorNoCode(row, fieldId);
            if (rowCode !== targetCode) continue;
            const name = readSsdshColorNoName(row, fieldId, targetCode);
            if (name !== "") return name;
        }
        return "";
    }
    function resolveSsdshColorNoName(source, fieldId, code, rows = []) {
        const sourceName = readSsdshColorNoName(source, fieldId, code);
        if (sourceName !== "") return sourceName;
        const cachedName = resolveSsdshColorNoCachedName(code, fieldId);
        if (cachedName !== "") return cachedName;
        const masterName = resolveSsdshColorNoMasterName(code, fieldId);
        if (masterName !== "") return masterName;
        return resolveSsdshColorNoNameFromRows(rows, fieldId, code);
    }
    function hasOwnGridValue(source, key) {
        return !isEmpty(source) && Object.prototype.hasOwnProperty.call(source, key);
    }
    function isExplicitEmptyGridValueChange(params) {
        if (isEmpty(params) || typeof params !== "object") return false;
        if (hasOwnGridValue(params, "newValue")) {
            return normalizeKakousijiUiString(DicVal(params, "newValue", "")).trim() === "";
        }
        if (hasOwnGridValue(params, "value")) {
            return normalizeKakousijiUiString(DicVal(params, "value", "")).trim() === "";
        }
        return false;
    }
    function clearColorwayProductColorRow(row, fieldId) {
        if (isEmpty(row) || fieldId === "") return row;
        const next = {
            ...row,
            [fieldId]: "",
            [`${fieldId}_cd`]: "",
            [`${fieldId}_nm`]: "",
            PDTC_COLORCD: "",
            PDTC_COLORNM: ""
        };
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => clearColorwayProductColorRow(sourceRow, fieldId));
        }
        if (Array.isArray(DicVal(row, "callRecords", null))) {
            next.callRecords = row.callRecords.map((record) => {
                if (isEmpty(record) || typeof record !== "object") return record;
                return {
                    ...record,
                    colno: "",
                    colnm: ""
                };
            });
        }
        return next;
    }
    function clearSsdshColorNoRow(row, fieldId = "SSDSH_COLORNO") {
        if (isEmpty(row) || fieldId === "") return row;
        const next = {
            ...row,
            [fieldId]: "",
            [`${fieldId}_cd`]: "",
            [`${fieldId}_nm`]: "",
            ZAIC_COLORCD: "",
            ZAIC_COLORNM: ""
        };
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => clearSsdshColorNoRow(sourceRow, fieldId));
        }
        return next;
    }
    function clearColorwaySelectionCacheEntries(cacheRef, row, fieldId = "") {
        const cache = DicVal(cacheRef, "current", null);
        if (isEmpty(cache) || typeof cache !== "object") return;
        const targetFieldId = normalizeColumnIdUpper(fieldId);
        const rowIdKeys = [];
        const codeKeys = [];
        const addRowId = (value) => {
            const normalized = normalizeKakousijiUiString(value);
            if (normalized !== "" && rowIdKeys.indexOf(normalized) === -1) rowIdKeys.push(normalized);
        };
        const addCode = (value) => {
            const normalized = normalizeColorwayMasterCode(value, row);
            if (normalized !== "" && codeKeys.indexOf(normalized) === -1) codeKeys.push(normalized);
        };
        addRowId(DicVal(row, "rowid", ""));
        addCode(readRowValueIgnoreCase(row, fieldId));
        addCode(readRowValueIgnoreCase(row, `${fieldId}_cd`));
        addCode(readRowValueIgnoreCase(row, "PDTC_COLORCD"));
        addCode(readRowValueIgnoreCase(row, "ZAIC_COLORCD"));
        const sourceRows = Array.isArray(DicVal(row, "__sourceRows", null)) ? row.__sourceRows : [];
        sourceRows.forEach((sourceRow) => {
            addRowId(DicVal(sourceRow, "rowid", ""));
            addCode(readRowValueIgnoreCase(sourceRow, fieldId));
            addCode(readRowValueIgnoreCase(sourceRow, `${fieldId}_cd`));
            addCode(readRowValueIgnoreCase(sourceRow, "PDTC_COLORCD"));
            addCode(readRowValueIgnoreCase(sourceRow, "ZAIC_COLORCD"));
        });
        Object.keys(cache).forEach((key) => {
            const entry = cache[key];
            if (isEmpty(entry) || typeof entry !== "object") {
                if (rowIdKeys.indexOf(normalizeKakousijiUiString(key)) !== -1 || codeKeys.indexOf(normalizeKakousijiUiString(key)) !== -1) {
                    delete cache[key];
                }
                return;
            }
            const cachedFieldId = normalizeColumnIdUpper(DicVal(entry, "fieldId", ""));
            if (targetFieldId !== "" && cachedFieldId !== "" && cachedFieldId !== targetFieldId) return;
            const cacheKey = normalizeKakousijiUiString(key);
            const cachedCode = normalizeKakousijiUiString(DicVal(entry, "code", ""));
            if (rowIdKeys.indexOf(cacheKey) !== -1 || codeKeys.indexOf(cacheKey) !== -1 || (cachedCode !== "" && codeKeys.indexOf(cachedCode) !== -1)) {
                delete cache[key];
            }
        });
    }
    function clearColorwayProductColorCache(row, fieldId) {
        clearColorwaySelectionCacheEntries(colorwayProductColorSelectionCacheRef, row, fieldId);
    }
    function clearSsdshColorNoCache(row, fieldId = "SSDSH_COLORNO") {
        clearColorwaySelectionCacheEntries(colorwayMaterialColorNoSelectionCacheRef, row, fieldId);
    }
    function detailSyncRowIds(row) {
        const ids = [];
        const add = (value) => {
            const normalized = normalizeKakousijiUiString(value);
            if (normalized !== "" && ids.indexOf(normalized) === -1) ids.push(normalized);
        };
        const sourceRows = Array.isArray(DicVal(row, "__sourceRows", null)) ? row.__sourceRows : [];
        sourceRows.forEach((sourceRow) => add(DicVal(sourceRow, "rowid", "")));
        if (ids.length === 0) add(DicVal(row, "rowid", ""));
        return ids;
    }
    function applySsdshColorNoSelectionToRow(row, code, name) {
        const fieldId = "SSDSH_COLORNO";
        if (isEmpty(row)) return row;
        if (code === "") return clearSsdshColorNoRow(row, fieldId);
        const next = {
            ...row,
            [fieldId]: formatColorwayProductColorDisplay(code, name),
            [`${fieldId}_cd`]: code,
            [`${fieldId}_nm`]: name,
            ZAIC_COLORCD: code,
            ZAIC_COLORNM: name
        };
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => applySsdshColorNoSelectionToRow(sourceRow, code, name));
        }
        return next;
    }
    function resolveColorwayProductColorTargetRowIds(payload) {
        const ids = [];
        const add = (value) => {
            const id = normalizeKakousijiUiString(value);
            if (id !== "" && ids.indexOf(id) === -1) ids.push(id);
        };
        add(DicVal(payload, "currowid", ""));
        const payloadRowIds = DicVal(payload, "rowid", null);
        if (Array.isArray(payloadRowIds)) {
            payloadRowIds.forEach((id) => add(id));
        } else {
            add(payloadRowIds);
        }
        add(DicVal(DicVal(payload, "rowdata", {}), "rowid", ""));
        add(DicVal(DicVal(payload, "data", {}), "rowid", ""));
        return ids;
    }
    function readColorwayProductColorCode(source, fieldId = "") {
        if (isEmpty(source) || typeof source !== "object") return "";
        const candidates = [
            "PDTC_COLORCD",
            "code",
            fieldId,
            fieldId === "" ? "" : `${fieldId}_cd`
        ].filter((key) => key !== "");
        for (let i = 0; i < candidates.length; i++) {
            const code = normalizeColorwayMasterCode(readRowValueIgnoreCase(source, candidates[i]), source);
            if (code !== "") return code;
        }
        return "";
    }
    function readColorwayProductColorName(source, fieldId = "", code = "") {
        if (isEmpty(source) || typeof source !== "object") return "";
        const candidates = [
            "PDTC_COLORNM",
            "name",
            fieldId === "" ? "" : `${fieldId}_nm`,
            "label",
            fieldId
        ].filter((key) => key !== "");
        const targetCode = normalizeKakousijiUiString(code);
        for (let i = 0; i < candidates.length; i++) {
            const value = readRowValueIgnoreCase(source, candidates[i]);
            if (targetCode !== "") {
                if (candidates[i] === `${fieldId}_nm`) {
                    const relatedCode = normalizeColorwayMasterCode(readRowValueIgnoreCase(source, `${fieldId}_cd`), source);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
                if (candidates[i] === "PDTC_COLORNM") {
                    const relatedCode = normalizeColorwayMasterCode(readRowValueIgnoreCase(source, "PDTC_COLORCD"), source);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
                if (candidates[i] === fieldId) {
                    const relatedCode = normalizeColorwayMasterCode(value, source);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
            }
            if (candidates[i] === fieldId && normalizeKakousijiUiString(value).indexOf(":") === -1 && normalizeKakousijiUiString(value).indexOf("：") === -1) continue;
            const name = normalizeColorwayMasterName(value);
            if (name !== "" && !isRowIdLikeColorwayCode(name, source)) return name;
        }
        return "";
    }
    function resolveColorwayProductColorCachedName(code, fieldId = "") {
        const targetCode = normalizeKakousijiUiString(code);
        if (targetCode === "") return "";
        const cache = DicVal(colorwayProductColorSelectionCacheRef, "current", {});
        const cached = DicVal(cache, targetCode, null);
        if (isEmpty(cached)) return "";
        const cachedFieldId = normalizeColumnIdUpper(DicVal(cached, "fieldId", ""));
        if (fieldId !== "" && cachedFieldId !== "" && cachedFieldId !== normalizeColumnIdUpper(fieldId)) return "";
        return normalizeKakousijiUiString(DicVal(cached, "name", ""));
    }
    function colorwayProductColorDataInfoFromFieldId(fieldId) {
        const normalizedFieldId = normalizeColumnIdUpper(fieldId);
        if (normalizedFieldId === "SSDSH_COLORCD") {
            return { type: PANEL_TYPE.MATERIAL_COLORWAY, dataid: "FM_PDTC_COLOR:SSDSH", columnid: "SSDSH_COLORCD" };
        }
        if (normalizedFieldId === "SSDFH_COLORCD") {
            return { type: PANEL_TYPE.ACCESSORY_COLORWAY, dataid: "FM_PDTC_COLOR:SSDFH", columnid: "SSDFH_COLORCD" };
        }
        return {};
    }
    function resolveColorwayProductColorMasterName(code, fieldId = "") {
        const targetCode = normalizeKakousijiUiString(code);
        if (targetCode === "" || isEmpty(fnc.current) || typeof fnc.current.getMaster !== "function") return "";
        const targetDataIds = colorwayProductColorTargetDataIds(colorwayProductColorDataInfoFromFieldId(fieldId));
        for (let i = 0; i < targetDataIds.length; i++) {
            const masterRow = fnc.current.getMaster(targetDataIds[i], targetCode);
            const name = readColorwayProductColorName(masterRow, fieldId, targetCode);
            if (name !== "") return name;
        }
        return "";
    }
    function resolveColorwayProductColorNameFromRows(rows, fieldId, code) {
        const targetCode = normalizeKakousijiUiString(code);
        if (!Array.isArray(rows) || fieldId === "" || targetCode === "") return "";
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            if (isEmpty(row) || typeof row !== "object") continue;
            const rowCode = firstColorwayProductColorCode(row, fieldId);
            if (rowCode !== targetCode) continue;
            const name = firstColorwayProductColorName(row, fieldId, targetCode);
            if (name !== "") return name;
        }
        return "";
    }
    function resolveColorwayProductColorName(source, fieldId, code, rows = []) {
        const sourceName = readColorwayProductColorName(source, fieldId, code);
        if (sourceName !== "") return sourceName;
        const cachedName = resolveColorwayProductColorCachedName(code, fieldId);
        if (cachedName !== "") return cachedName;
        const masterName = resolveColorwayProductColorMasterName(code, fieldId);
        if (masterName !== "") return masterName;
        return resolveColorwayProductColorNameFromRows(rows, fieldId, code);
    }
    function normalizeColorwayProductColorSearchData(source, fieldId = "") {
        if (isEmpty(source) || typeof source !== "object") return source;
        const data = { ...source };
        const code = readColorwayProductColorCode(data, fieldId);
        const name = resolveColorwayProductColorName(data, fieldId, code);
        if (code !== "") {
            data.code = code;
            data.PDTC_COLORCD = code;
            data.PDTC_COLORNM = name;
            if (fieldId !== "") {
                data[fieldId] = formatColorwayProductColorDisplay(code, name);
                data[`${fieldId}_cd`] = code;
                data[`${fieldId}_nm`] = name;
            }
        }
        if (name !== "") {
            data.name = name;
        }
        return data;
    }
    function normalizeColorwayProductColorSearchItem(item, fieldId = "") {
        if (isEmpty(item) || isEmpty(DicVal(item, "data", null))) return item;
        const data = normalizeColorwayProductColorSearchData(item.data, fieldId);
        return { ...item, data };
    }
    function selectedColorwayProductColorResultRowIds(result) {
        const ids = [];
        const add = (value) => {
            const id = normalizeKakousijiUiString(value);
            if (id !== "" && ids.indexOf(id) === -1) ids.push(id);
        };
        const rowIds = DicVal(result, "rowid", null);
        if (Array.isArray(rowIds)) {
            rowIds.forEach((rowid) => add(rowid));
        } else {
            add(rowIds);
        }
        add(DicVal(DicVal(result, "rowdata", {}), "rowid", ""));
        return ids;
    }
    function selectedColorwayProductColorRows(result) {
        if (isEmpty(result) || !Array.isArray(result.items)) return [];
        const rows = result.items
            .map((item) => DicVal(item, "data", null))
            .filter((data) => !isEmpty(data));
        const selectedRowIds = selectedColorwayProductColorResultRowIds(result);
        if (selectedRowIds.length === 0) return rows;
        const matchedRows = rows.filter((row) => selectedRowIds.indexOf(normalizeKakousijiUiString(DicVal(row, "rowid", ""))) !== -1);
        return matchedRows.length !== 0 ? matchedRows : rows;
    }
    function primaryColorwayProductColorSelectionData(result, fieldId = "") {
        if (isEmpty(result) || typeof result !== "object") return null;
        const selectedRows = selectedColorwayProductColorRows(result);
        for (let i = 0; i < selectedRows.length; i++) {
            const data = selectedRows[i];
            if (!isEmpty(data) && readColorwayProductColorCode(data, fieldId) !== "") return data;
        }
        const rowdata = DicVal(result, "rowdata", null);
        if (!isEmpty(rowdata) && readColorwayProductColorCode(rowdata, fieldId) !== "") return rowdata;
        if (readColorwayProductColorCode(result, fieldId) !== "") return result;
        return null;
    }
    function applyColorwayProductColorSelectionToRow(row, fieldId, code, name) {
        if (isEmpty(row) || fieldId === "") return row;
        if (code === "") return clearColorwayProductColorRow(row, fieldId);
        const next = {
            ...row,
            [fieldId]: formatColorwayProductColorDisplay(code, name),
            [`${fieldId}_cd`]: code,
            [`${fieldId}_nm`]: name,
            PDTC_COLORCD: code,
            PDTC_COLORNM: name
        };
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => applyColorwayProductColorSelectionToRow(sourceRow, fieldId, code, name));
        }
        if (Array.isArray(DicVal(row, "callRecords", null))) {
            next.callRecords = row.callRecords.map((record) => {
                if (isEmpty(record) || typeof record !== "object") return record;
                return {
                    ...record,
                    colno: code,
                    colnm: name
                };
            });
        }
        return next;
    }
    function colorwayProductColorChangedFieldId(panelInfo, params) {
        const panelType = canonicalPanelType(DicVal(panelInfo, "type", ""));
        const targetFieldId = colorwayProductColorFieldId(panelType);
        if (targetFieldId === "") return "";
        const column = DicVal(params, "column", null);
        const candidates = [
            DicVal(DicVal(params, "colDef", {}), "field", ""),
            DicVal(DicVal(params, "colDef", {}), "colId", ""),
            DicVal(DicVal(column, "colDef", {}), "field", ""),
            DicVal(DicVal(column, "colDef", {}), "colId", ""),
            typeof column?.getColId === "function" ? column.getColId() : "",
            DicVal(params, "field", ""),
            DicVal(params, "columnid", "")
        ];
        for (let i = 0; i < candidates.length; i++) {
            if (normalizeColumnIdUpper(candidates[i]) === normalizeColumnIdUpper(targetFieldId)) return targetFieldId;
        }
        return "";
    }
    function colorwayProductColorChangedCode(params, row, fieldId) {
        const candidates = [
            DicVal(params, "newValue", undefined),
            DicVal(params, "value", undefined),
            readRowValueIgnoreCase(row, fieldId),
            readRowValueIgnoreCase(DicVal(DicVal(params, "node", {}), "data", {}), fieldId)
        ];
        for (let i = 0; i < candidates.length; i++) {
            const code = normalizeColorwayMasterCode(candidates[i], row);
            if (code !== "") return code;
        }
        return "";
    }
    function collectColorwayProductColorGridRows(panelInfo, params) {
        const rows = [];
        const api = DicVal(params, "api", GridApi(panelInfo));
        if (!isEmpty(api) && typeof api.forEachNode === "function") {
            api.forEachNode((node) => {
                if (!isEmpty(node) && !isEmpty(node.data)) rows.push(node.data);
            });
        }
        const refRows = GridData(panelInfo);
        if (Array.isArray(refRows)) {
            refRows.forEach((row) => {
                if (!isEmpty(row) && rows.indexOf(row) === -1) rows.push(row);
            });
        }
        return rows;
    }
    function normalizeColorwayProductColorAfterGridValueChanged(panelInfo, params) {
        const fieldId = colorwayProductColorChangedFieldId(panelInfo, params);
        if (fieldId === "") return false;
        const row = DicVal(params, "data", DicVal(DicVal(params, "node", {}), "data", null));
        if (isEmpty(row)) return false;
        if (isExplicitEmptyGridValueChange(params)) {
            const rowBeforeClear = { ...row };
            const cleared = clearColorwayProductColorRow(row, fieldId);
            clearColorwayProductColorCache(rowBeforeClear, fieldId);
            Object.assign(row, cleared);
            const node = DicVal(params, "node", null);
            if (!isEmpty(node)) {
                if (typeof node.setData === "function") {
                    node.setData(row);
                } else if (!isEmpty(node.data)) {
                    Object.assign(node.data, row);
                }
            }
            syncColorwayProductColorSelectionToDetail(DicVal(panelInfo, "type", ""), row, fieldId, "", "");
            const api = DicVal(params, "api", GridApi(panelInfo));
            if (!isEmpty(api) && typeof api.refreshCells === "function") {
                api.refreshCells({ rowNodes: isEmpty(node) ? undefined : [node], force: true });
            }
            return true;
        }
        const code = colorwayProductColorChangedCode(params, row, fieldId);
        if (code === "") return false;
        const rows = collectColorwayProductColorGridRows(panelInfo, params);
        const changedValue = DicVal(params, "newValue", DicVal(params, "value", readRowValueIgnoreCase(row, fieldId)));
        const name = resolveColorwayProductColorName(
            {
                [fieldId]: changedValue,
                [`${fieldId}_cd`]: code,
                PDTC_COLORCD: code
            },
            fieldId,
            code,
            rows
        );
        const normalized = applyColorwayProductColorSelectionToRow(row, fieldId, code, name);
        Object.assign(row, normalized);
        const node = DicVal(params, "node", null);
        if (!isEmpty(node)) {
            if (typeof node.setData === "function") {
                node.setData(row);
            } else if (!isEmpty(node.data)) {
                Object.assign(node.data, row);
            }
        }
        syncColorwayProductColorSelectionToDetail(DicVal(panelInfo, "type", ""), row, fieldId, code, name);
        const api = DicVal(params, "api", GridApi(panelInfo));
        if (!isEmpty(api) && typeof api.refreshCells === "function") {
            api.refreshCells({ rowNodes: isEmpty(node) ? undefined : [node], force: true });
        }
        return true;
    }
    function buildColorwayProductColorMasterRows(result, dataInfo) {
        const fieldId = colorwayProductColorFieldIdFromDataInfo(dataInfo);
        const targetDataIds = colorwayProductColorTargetDataIds(dataInfo);
        const sourceRows = selectedColorwayProductColorRows(result);
        const primary = primaryColorwayProductColorSelectionData(result, fieldId);
        if (!isEmpty(primary)) sourceRows.push(primary);
        const rows = [];
        sourceRows.forEach((sourceRow) => {
            const normalized = normalizeColorwayProductColorSearchData(sourceRow, fieldId);
            const code = readColorwayProductColorCode(normalized, fieldId);
            const name = resolveColorwayProductColorName(normalized, fieldId, code, sourceRows);
            if (code === "") return;
            const sourceRowId = normalizeKakousijiUiString(DicVal(sourceRow, "rowid", DicVal(normalized, "rowid", "")));
            if (sourceRowId !== "") {
                colorwayProductColorSelectionCacheRef.current[sourceRowId] = { code, name, fieldId };
            }
            colorwayProductColorSelectionCacheRef.current[code] = { code, name, fieldId };
            rows.push({
                ...normalized,
                dataid: normalizeKakousijiUiString(DicVal(normalized, "dataid", "M_PDTC")) || "M_PDTC",
                code,
                name,
                PDTC_COLORCD: code,
                PDTC_COLORNM: name
            });
            targetDataIds.forEach((targetDataId) => {
                rows.push({
                    ...normalized,
                    dataid: targetDataId,
                    code,
                    name,
                    PDTC_COLORCD: code,
                    PDTC_COLORNM: name,
                    [fieldId]: code,
                    [`${fieldId}_cd`]: code,
                    [`${fieldId}_nm`]: name
                });
            });
        });
        return rows;
    }
    function rememberColorwayProductColorMasterRows(result, dataInfo) {
        const rows = buildColorwayProductColorMasterRows(result, dataInfo);
        if (rows.length === 0 || isEmpty(fnc.current) || typeof fnc.current.margeMaster !== "function") return;
        fnc.current.margeMaster(rows);
    }
    function normalizeProductColorSearchListResponseForStandardApply(response, dataInfo) {
        if (isEmpty(response) || !Array.isArray(DicVal(response, "rowdata", null))) return response;
        if (!isColorwayProductColorMasterDataInfo(dataInfo)) return response;
        const fieldId = colorwayProductColorFieldIdFromDataInfo(dataInfo);
        if (fieldId !== "SSDSH_COLORCD" && fieldId !== "SSDFH_COLORCD") return response;
        const next = {
            ...response,
            rowdata: response.rowdata.map((row) => {
                const code = readColorwayProductColorCode(row, fieldId);
                const name = resolveColorwayProductColorName(row, fieldId, code, response.rowdata);
                if (code === "") return row;
                const normalized = {
                    ...row,
                    rowid: code,
                    code,
                    PDTC_COLORCD: code,
                    PDTC_COLORNM: name,
                    [fieldId]: code,
                    [`${fieldId}_cd`]: code,
                    [`${fieldId}_nm`]: name
                };
                colorwayProductColorSelectionCacheRef.current[code] = { code, name, fieldId };
                return normalized;
            })
        };
        return next;
    }
    function wrapProductColorSearchListResponseCallback(url, param, callback) {
        const normalizedUrl = normalizeKakousijiUiString(url).toLowerCase();
        if (normalizedUrl !== "common/getsearchmasterlist"
            && normalizedUrl !== "kakousiji/getsearchmasterlist"
            && normalizedUrl !== "kakousiji/getmaterialaccessorymastersearchlist") return callback;
        if (isEmpty(callback) || typeof callback !== "object" || typeof callback.onSuccess !== "function") return callback;
        const dataInfo = resolveColorwayProductColorDataInfo(param);
        if (!isColorwayProductColorMasterDataInfo(dataInfo)) return callback;
        return {
            ...callback,
            onSuccess: function (data) {
                const normalized = normalizeProductColorSearchListResponseForStandardApply(data, dataInfo);
                return callback.onSuccess(normalized);
            }
        };
    }
    function normalizeSsdshColorNoSearchListResponseForStandardApply(response, dataInfo) {
        if (isEmpty(response) || !Array.isArray(DicVal(response, "rowdata", null))) return response;
        if (!isSsdshColorNoMasterDataInfo(dataInfo)) return response;
        const fieldId = ssdshColorNoFieldIdFromDataInfo(dataInfo);
        if (fieldId !== "SSDSH_COLORNO") return response;
        const targetDataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", ""))) || "FM_ZAIC_COLOR:SSDSH";
        return {
            ...response,
            rowdata: response.rowdata.map((row) => {
                const code = readSsdshColorNoCode(row, fieldId);
                const name = resolveSsdshColorNoName(row, fieldId, code, response.rowdata);
                if (code === "") return row;
                const sourceRowId = normalizeKakousijiUiString(DicVal(row, "rowid", ""));
                if (sourceRowId !== "") {
                    colorwayMaterialColorNoSelectionCacheRef.current[sourceRowId] = { code, name, fieldId };
                }
                colorwayMaterialColorNoSelectionCacheRef.current[code] = { code, name, fieldId };
                return {
                    ...row,
                    dataid: targetDataId,
                    rowid: code,
                    code,
                    name,
                    ZAIC_COLORCD: code,
                    ZAIC_COLORNM: name,
                    [fieldId]: code,
                    [`${fieldId}_cd`]: code,
                    [`${fieldId}_nm`]: name
                };
            })
        };
    }
    function wrapSsdshColorNoSearchListResponseCallback(url, param, callback) {
        const normalizedUrl = normalizeKakousijiUiString(url).toLowerCase();
        if (normalizedUrl !== "common/getsearchmasterlist"
            && normalizedUrl !== "kakousiji/getsearchmasterlist"
            && normalizedUrl !== "kakousiji/getmaterialaccessorymastersearchlist") return callback;
        if (isEmpty(callback) || typeof callback !== "object" || typeof callback.onSuccess !== "function") return callback;
        const dataInfo = resolveSsdshColorNoDataInfo(param);
        if (!isSsdshColorNoMasterDataInfo(dataInfo)) return callback;
        return {
            ...callback,
            onSuccess: function (data) {
                const normalized = normalizeSsdshColorNoSearchListResponseForStandardApply(data, dataInfo);
                return callback.onSuccess(normalized);
            }
        };
    }
    function normalizeColorwayProductColorGetMasterDataRequest(url, param) {
        if (normalizeKakousijiUiString(url).toLowerCase() !== "common/getmasterdata") return { url, param, skip: false };
        if (isEmpty(param) || typeof param !== "object") return { url, param, skip: false };
        const dataInfo = resolveColorwayProductColorDataInfo(param);
        if (!isColorwayProductColorMasterDataInfo(dataInfo)) return { url, param, skip: false };
        const fieldId = colorwayProductColorFieldIdFromDataInfo(dataInfo);
        if (fieldId === "") return { url, param, skip: false };
        const rowdata = DicVal(param, "rowdata", {});
        const requestCode = normalizeKakousijiUiString(DicVal(param, "code", ""));
        const rowdataCode = normalizeKakousijiUiString(readRowValueIgnoreCase(rowdata, fieldId));
        const rowidCode = isRowIdLikeColorwayCode(requestCode, rowdata)
            ? requestCode
            : (isRowIdLikeColorwayCode(rowdataCode, rowdata) ? rowdataCode : "");
        const cacheKey = rowidCode !== "" ? rowidCode : (requestCode !== "" ? requestCode : rowdataCode);
        const cached = DicVal(colorwayProductColorSelectionCacheRef.current, cacheKey, null);
        const code = normalizeKakousijiUiString(DicVal(cached, "code", ""));
        const name = normalizeKakousijiUiString(DicVal(cached, "name", ""));
        const nextRowData = isEmpty(rowdata) ? {} : { ...rowdata };

        if (code !== "") {
            return {
                url,
                param: {
                    ...param,
                    code,
                    rowdata: applyColorwayProductColorSelectionToRow(nextRowData, fieldId, code, name)
                },
                skip: true
            };
        }

        if (rowidCode !== "") {
            nextRowData[fieldId] = "";
            nextRowData[`${fieldId}_cd`] = "";
            nextRowData[`${fieldId}_nm`] = "";
            nextRowData.PDTC_COLORCD = "";
            nextRowData.PDTC_COLORNM = "";
        }
        return {
            url,
            param: {
                ...param,
                code: rowidCode !== "" ? "" : requestCode,
                rowdata: nextRowData
            },
            skip: true
        };
    }
    function syncColorwayProductColorSelectionToDetail(panelType, row, fieldId, code, name) {
        const type = canonicalPanelType(panelType);
        if (type === "" || fieldId === "" || isEmpty(entrydetailRef.current)) return;
        const rows = getDetailRowsByPanelType(entrydetailRef.current, type);
        if (!Array.isArray(rows) || rows.length === 0) return;
        const sourceRowIds = detailSyncRowIds(row);
        if (sourceRowIds.length === 0) return;
        rows.forEach((detailRow) => {
            const rowid = normalizeKakousijiUiString(DicVal(detailRow, "rowid", ""));
            if (rowid === "" || sourceRowIds.indexOf(rowid) === -1) return;
            Object.assign(detailRow, applyColorwayProductColorSelectionToRow(detailRow, fieldId, code, name));
        });
    }
    function findColorwayProductColorGridNode(gridApi, rowId, rowKey = "") {
        if (isEmpty(gridApi)) return null;
        const id = normalizeKakousijiUiString(rowId);
        if (id !== "" && typeof gridApi.getRowNode === "function") {
            const node = gridApi.getRowNode(id);
            if (!isEmpty(node)) return node;
        }
        if (typeof gridApi.forEachNode !== "function") return null;
        let found = null;
        gridApi.forEachNode((node) => {
            if (!isEmpty(found) || isEmpty(node) || isEmpty(node.data)) return;
            const nodeRowId = normalizeKakousijiUiString(DicVal(node.data, "rowid", ""));
            const nodeRowKey = normalizeKakousijiUiString(DicVal(node.data, "rowKey", ""));
            if (id !== "" && nodeRowId === id) found = node;
            if (isEmpty(found) && rowKey !== "" && nodeRowKey === rowKey) found = node;
        });
        return found;
    }
    function applyColorwayProductColorSelectionToGrid(payload, result, dataInfo) {
        const gridApi = DicVal(payload, "gridApi", null);
        if (isEmpty(gridApi) || typeof gridApi.getRowNode !== "function") return false;
        const fieldId = colorwayProductColorFieldIdFromDataInfo(dataInfo);
        if (fieldId === "") return false;
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const rowIds = resolveColorwayProductColorTargetRowIds(payload);
        const rowKey = normalizeKakousijiUiString(DicVal(DicVal(payload, "rowdata", {}), "rowKey", DicVal(DicVal(payload, "data", {}), "rowKey", "")));
        const selectedRows = selectedColorwayProductColorRows(result);
        const primarySelected = primaryColorwayProductColorSelectionData(result, fieldId);
        const refreshedNodes = [];
        rowIds.forEach((rowId, index) => {
            const node = findColorwayProductColorGridNode(gridApi, rowId, rowKey);
            const selected = selectedRows[index] || selectedRows[0] || primarySelected;
            if (isEmpty(node) || isEmpty(node.data) || isEmpty(selected)) return;
            const code = readColorwayProductColorCode(selected, fieldId);
            const name = resolveColorwayProductColorName(selected, fieldId, code, selectedRows);
            if (code === "") return;
            Object.assign(node.data, applyColorwayProductColorSelectionToRow(node.data, fieldId, code, name));
            syncColorwayProductColorSelectionToDetail(panelType, node.data, fieldId, code, name);
            refreshedNodes.push(node);
        });
        if (refreshedNodes.length !== 0 && typeof gridApi.refreshCells === "function") {
            gridApi.refreshCells({ rowNodes: refreshedNodes, force: true });
        }
        if (refreshedNodes.length !== 0 && typeof gridApi.forEachNode === "function") {
            const rows = [];
            gridApi.forEachNode((node) => {
                if (!isEmpty(node) && !isEmpty(node.data)) rows.push(node.data);
            });
            const panelInfo = Array.isArray(gridlist)
                ? gridlist.find((panel) => canonicalPanelType(DicVal(panel, "type", "")) === canonicalPanelType(panelType))
                : null;
            if (!isEmpty(panelInfo)) SetGridData(panelInfo, rows);
        }
        return refreshedNodes.length !== 0;
    }
    function normalizeColorwayProductColorSearchResult(result, dataInfo = {}) {
        if (isEmpty(result)) return result;
        const next = { ...result };
        const fieldId = colorwayProductColorFieldIdFromDataInfo(dataInfo);
        if (Array.isArray(next.items)) {
            next.items = next.items.map((item) => normalizeColorwayProductColorSearchItem(item, fieldId));
            const codes = next.items
                .map((item) => normalizeKakousijiUiString(DicVal(DicVal(item, "data", {}), "code", "")))
                .filter((code) => code !== "");
            if (codes.length !== 0) next.value = codes.join(" ");
            const firstData = DicVal(next.items[0], "data", {});
            const firstCode = normalizeKakousijiUiString(DicVal(firstData, "code", ""));
            const firstName = normalizeKakousijiUiString(DicVal(firstData, "name", DicVal(firstData, "PDTC_COLORNM", "")));
            if (firstCode !== "") {
                next.code = firstCode;
                next.PDTC_COLORCD = firstCode;
                next.PDTC_COLORNM = firstName;
                if (!isEmpty(next.rowdata)) {
                    next.rowdata = applyColorwayProductColorSelectionToRow(next.rowdata, fieldId, firstCode, firstName);
                }
            }
        }
        const selected = primaryColorwayProductColorSelectionData(next, fieldId);
        if (!isEmpty(selected)) {
            const normalizedSelected = normalizeColorwayProductColorSearchData(selected, fieldId);
            const selectedCode = readColorwayProductColorCode(normalizedSelected, fieldId);
            const selectedName = resolveColorwayProductColorName(normalizedSelected, fieldId, selectedCode);
            if (selectedCode !== "") {
                next.code = selectedCode;
                next.PDTC_COLORCD = selectedCode;
                next.PDTC_COLORNM = selectedName;
                if (!isEmpty(next.rowdata)) {
                    next.rowdata = applyColorwayProductColorSelectionToRow(next.rowdata, fieldId, selectedCode, selectedName);
                }
            }
        }
        return next;
    }
    function wrapColorwayProductColorSearchApply(payload) {
        const dataInfo = resolveColorwayProductColorDataInfo(payload);
        if (!isColorwayProductColorMasterDataInfo(dataInfo)) return payload;
        const doApply = DicVal(payload, "doApply", null);
        if (typeof doApply !== "function") {
            return {
                ...payload,
                data: dataInfo,
                datainfo: dataInfo
            };
        }
        return {
            ...payload,
            data: dataInfo,
            datainfo: dataInfo,
            doApply: (result, mode, allsku) => {
                const normalizedResult = normalizeColorwayProductColorSearchResult(result, dataInfo);
                rememberColorwayProductColorMasterRows(normalizedResult, dataInfo);
                const applied = applyColorwayProductColorSelectionToGrid(payload, normalizedResult, dataInfo);
                if (applied) {
                    if (!isEmpty(fnc.current) && typeof fnc.current.modify === "function") fnc.current.modify(true);
                    if (!isEmpty(fnc.current) && typeof fnc.current.searchlistclose === "function") fnc.current.searchlistclose();
                    return;
                }
                if (!isEmpty(fnc.current) && typeof fnc.current.searchlistclose === "function") fnc.current.searchlistclose();
            }
        };
    }
    function isMaterialAccessoryMasterColumn(panelInfo, colDef) {
        const colInfo = DicVal(colDef, "colinfo", {});
        const dataInfo = {
            ...colInfo,
            type: getPanelType(panelInfo),
            colId: DicVal(colDef, "colId", DicVal(colDef, "field", DicVal(colInfo, "columnid", ""))),
            field: DicVal(colDef, "field", DicVal(colInfo, "columnid", ""))
        };
        return isMaterialAccessoryMasterDataInfo(dataInfo);
    }
    // 素材/附属の検索payloadへKakousiji用の補助情報を載せる。
    function routeMaterialAccessoryMasterSearchPayload(payload) {
        const nextPayload = wrapColorwayProductColorSearchApply(payload);
        const dataInfo = DicVal(nextPayload, "data", DicVal(nextPayload, "datainfo", {}));
        if (!isMaterialAccessoryMasterDataInfo(dataInfo)) return nextPayload;
        const rowdata = DicVal(nextPayload, "rowdata", {});
        const brandCode = normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "PDT_BRDCODE"))
            || normalizeKakousijiUiString(readRowValueIgnoreCase(rowdata, "PDT_BRDCODE"));
        const nextRowData = {
            ...(isEmpty(rowdata) ? {} : rowdata),
            ...(brandCode === "" ? {} : { PDT_BRDCODE: brandCode })
        };
        // Kakousiji専用検索で使うブランド情報を検索payloadへ補う。
        return {
            ...nextPayload,
            rowdata: nextRowData
        };
    }
    function routeSijisuPdtcMasterSearchPayload(payload) {
        const dataInfo = DicVal(payload, "data", DicVal(payload, "datainfo", {}));
        if (!isSijisuPdtcMasterDataInfo(dataInfo)) return payload;
        const baseRow = DicVal(payload, "rowdata", {});
        const routedSearchParam = buildSijisuPdtcMasterSearchParam(DicVal(payload, "searchparam", null), baseRow);
        return {
            ...payload,
            searchparam: routedSearchParam,
            rowdata: DicVal(routedSearchParam, "rowdata", baseRow)
        };
    }
    function routeSubSoseiMasterSearchPayload(payload) {
        const dataInfo = DicVal(payload, "data", DicVal(payload, "datainfo", {}));
        if (!isSubSoseiMasterDataInfo(dataInfo)) return payload;
        const rowdata = DicVal(payload, "rowdata", {});
        const parentCode = resolveSubSoseiSearchParentCode(rowdata) || resolveSubSoseiSearchParentCode(entrydataRef.current);
        if (parentCode === "") return payload;
        const nextRowData = {
            ...(isEmpty(rowdata) ? {} : rowdata),
            SSDQ_SOSEICD: parentCode
        };
        return {
            ...payload,
            rowdata: nextRowData
        };
    }
    function normalizeSsdshColorNoGetMasterDataRequest(url, param) {
        if (normalizeKakousijiUiString(url).toLowerCase() !== "common/getmasterdata") return { url, param, skip: false };
        if (isEmpty(param) || typeof param !== "object") return { url, param, skip: false };
        const dataInfo = resolveSsdshColorNoDataInfo(param);
        if (!isSsdshColorNoMasterDataInfo(dataInfo)) return { url, param, skip: false };
        const fieldId = ssdshColorNoFieldIdFromDataInfo(dataInfo);
        if (fieldId !== "SSDSH_COLORNO") return { url, param, skip: false };
        const rowdata = DicVal(param, "rowdata", {});
        const requestCode = normalizeKakousijiUiString(DicVal(param, "code", ""));
        const rowdataCode = normalizeKakousijiUiString(readRowValueIgnoreCase(rowdata, fieldId));
        const rowidCode = isRowIdLikeColorwayCode(requestCode, rowdata)
            ? requestCode
            : (isRowIdLikeColorwayCode(rowdataCode, rowdata) ? rowdataCode : "");
        if (rowidCode === "") return { url, param, skip: false };
        const cached = DicVal(colorwayMaterialColorNoSelectionCacheRef.current, rowidCode, null);
        const code = normalizeKakousijiUiString(DicVal(cached, "code", ""));
        const name = normalizeKakousijiUiString(DicVal(cached, "name", ""));
        const nextRowData = isEmpty(rowdata) ? {} : { ...rowdata };
        if (code !== "") {
            return {
                url,
                param: {
                    ...param,
                    code,
                    rowdata: applySsdshColorNoSelectionToRow(nextRowData, code, name)
                },
                skip: true
            };
        }
        nextRowData[fieldId] = "";
        nextRowData[`${fieldId}_cd`] = "";
        nextRowData[`${fieldId}_nm`] = "";
        nextRowData.ZAIC_COLORCD = "";
        nextRowData.ZAIC_COLORNM = "";
        return {
            url,
            param: {
                ...param,
                code: "",
                rowdata: nextRowData
            },
            skip: true
        };
    }
    function normalizeSijisuPdtcGetMasterDataRequest(url, param) {
        if (normalizeKakousijiUiString(url).toLowerCase() !== "common/getmasterdata") return { url, param, skip: false };
        if (isEmpty(param) || typeof param !== "object") return { url, param, skip: false };
        const dataInfo = resolveSijisuPdtcDataInfo(param);
        if (!isSijisuPdtcMasterDataInfo(dataInfo)) return { url, param, skip: false };
        const fieldId = sijisuPdtcFieldIdFromDataInfo(dataInfo);
        if (fieldId === "") return { url, param, skip: false };
        const rowdata = DicVal(param, "rowdata", {});
        const requestCode = normalizeDetailMasterCode(DicVal(param, "code", ""));
        const rowdataCode = normalizeDetailMasterCode(readRowValueIgnoreCase(rowdata, fieldId));
        const hasOwnField = hasOwnGridValue(rowdata, fieldId)
            || hasOwnGridValue(rowdata, `${fieldId}_cd`)
            || hasOwnGridValue(rowdata, `${fieldId}_nm`);
        if (requestCode === "" && rowdataCode === "" && hasOwnField) {
            return {
                url,
                param: {
                    ...param,
                    code: "",
                    rowdata: clearSijisuPdtcRow(isEmpty(rowdata) ? {} : { ...rowdata }, fieldId)
                },
                skip: true
            };
        }
        const code = requestCode || rowdataCode;
        if (code === "") return { url, param, skip: false };
        const nextRowData = isEmpty(rowdata) ? {} : { ...rowdata };
        return {
            url,
            param: {
                ...param,
                code,
                rowdata: applySijisuPdtcSelectionToRow(nextRowData, fieldId, code)
            },
            skip: false
        };
    }
    function resolveSijisuPdtcSelectionName(source, fieldId, fallbackCode = "") {
        const normalizedFieldId = normalizeColumnIdUpper(fieldId);
        const code = normalizeDetailMasterCode(fallbackCode);
        const isSize = normalizedFieldId === "SSDM_SIZECD";
        const candidates = isSize
            ? [`${fieldId}_nm`, "PDTC_SIZENM", "SZE_SIZENM", "name", "label", fieldId]
            : [`${fieldId}_nm`, "PDTC_COLORNM", "BCOL_BCOLORNM", "name", "label", fieldId];
        for (let i = 0; i < candidates.length; i++) {
            const value = normalizeKakousijiUiString(readRowValueIgnoreCase(source, candidates[i]));
            if (value === "") continue;
            if (candidates[i] === fieldId) {
                const extractedName = extractMasterNameFromDisplayValue(value);
                if (extractedName !== "") return extractedName;
                if (value !== code) return value;
                continue;
            }
            if (value !== code) return value;
        }
        return code;
    }
    function normalizeSijisuPdtcSearchListResponseForStandardApply(response, dataInfo) {
        if (isEmpty(response) || !Array.isArray(DicVal(response, "rowdata", null))) return response;
        if (!isSijisuPdtcMasterDataInfo(dataInfo)) return response;
        const fieldId = sijisuPdtcFieldIdFromDataInfo(dataInfo);
        const isSize = normalizeColumnIdUpper(fieldId) === "SSDM_SIZECD";
        const codeField = isSize ? "PDTC_SIZECD" : "PDTC_COLORCD";
        const nameField = isSize ? "PDTC_SIZENM" : "PDTC_COLORNM";
        return {
            ...response,
            rowdata: response.rowdata.map((row) => {
                const code = normalizeDetailMasterCode(DicVal(row, codeField, DicVal(row, fieldId, DicVal(row, `${fieldId}_cd`, ""))));
                const name = normalizeKakousijiUiString(DicVal(row, nameField, DicVal(row, "name", code)));
                if (code === "") return row;
                return {
                    ...row,
                    rowid: code,
                    code,
                    name,
                    PDTC_COLORCD: isSize ? DicVal(row, "PDTC_COLORCD", "") : code,
                    PDTC_COLORNM: isSize ? DicVal(row, "PDTC_COLORNM", "") : name,
                    PDTC_SIZECD: isSize ? code : DicVal(row, "PDTC_SIZECD", ""),
                    PDTC_SIZENM: isSize ? name : DicVal(row, "PDTC_SIZENM", ""),
                    [fieldId]: code,
                    [`${fieldId}_cd`]: code,
                    [`${fieldId}_nm`]: name
                };
            })
        };
    }
    function selectedSijisuPdtcResultRowIds(result) {
        const ids = [];
        const add = (value) => {
            const id = normalizeKakousijiUiString(value);
            if (id !== "" && ids.indexOf(id) === -1) ids.push(id);
        };
        const rowIds = DicVal(result, "rowid", null);
        if (Array.isArray(rowIds)) {
            rowIds.forEach((rowid) => add(rowid));
        } else {
            add(rowIds);
        }
        add(DicVal(DicVal(result, "rowdata", {}), "rowid", ""));
        return ids;
    }
    function selectedSijisuPdtcRows(result) {
        if (isEmpty(result) || !Array.isArray(result.items)) return [];
        const rows = result.items
            .map((item) => DicVal(item, "data", null))
            .filter((data) => !isEmpty(data));
        const selectedRowIds = selectedSijisuPdtcResultRowIds(result);
        if (selectedRowIds.length === 0) return rows;
        const matchedRows = rows.filter((row) => selectedRowIds.indexOf(normalizeKakousijiUiString(DicVal(row, "rowid", ""))) !== -1);
        return matchedRows.length !== 0 ? matchedRows : rows;
    }
    function primarySijisuPdtcSelectionData(result, fieldId = "") {
        if (isEmpty(result) || typeof result !== "object") return null;
        const selectedRows = selectedSijisuPdtcRows(result);
        const codeField = resolveSijisuPdtcSearchCodeField(fieldId);
        for (let i = 0; i < selectedRows.length; i++) {
            const data = selectedRows[i];
            const code = normalizeDetailMasterCode(DicVal(data, codeField, DicVal(data, fieldId, DicVal(data, `${fieldId}_cd`, ""))));
            if (!isEmpty(data) && code !== "") return data;
        }
        const rowdata = DicVal(result, "rowdata", null);
        if (!isEmpty(rowdata) && normalizeDetailMasterCode(DicVal(rowdata, codeField, DicVal(rowdata, fieldId, DicVal(rowdata, `${fieldId}_cd`, "")))) !== "") return rowdata;
        if (normalizeDetailMasterCode(DicVal(result, codeField, DicVal(result, fieldId, DicVal(result, `${fieldId}_cd`, "")))) !== "") return result;
        return null;
    }
    function resolveSijisuPdtcTargetRowIds(payload) {
        const ids = [];
        const add = (value) => {
            const id = normalizeKakousijiUiString(value);
            if (id !== "" && ids.indexOf(id) === -1) ids.push(id);
        };
        add(DicVal(payload, "rowid", ""));
        add(DicVal(payload, "currowid", ""));
        add(DicVal(DicVal(payload, "rowdata", {}), "rowid", ""));
        add(DicVal(DicVal(payload, "data", {}), "rowid", ""));
        return ids;
    }
    function findSijisuPdtcGridNode(gridApi, rowId, rowKey = "") {
        if (isEmpty(gridApi)) return null;
        const id = normalizeKakousijiUiString(rowId);
        if (id !== "" && typeof gridApi.getRowNode === "function") {
            const node = gridApi.getRowNode(id);
            if (!isEmpty(node)) return node;
        }
        if (typeof gridApi.forEachNode !== "function") return null;
        let found = null;
        gridApi.forEachNode((node) => {
            if (!isEmpty(found) || isEmpty(node) || isEmpty(node.data)) return;
            const nodeRowId = normalizeKakousijiUiString(DicVal(node.data, "rowid", ""));
            const nodeRowKey = normalizeKakousijiUiString(DicVal(node.data, "rowKey", ""));
            if (id !== "" && nodeRowId === id) found = node;
            if (isEmpty(found) && rowKey !== "" && nodeRowKey === rowKey) found = node;
        });
        return found;
    }
    function applySijisuPdtcSelectionToGrid(payload, result, dataInfo) {
        const gridApi = DicVal(payload, "gridApi", null);
        if (isEmpty(gridApi) || typeof gridApi.getRowNode !== "function") return false;
        const fieldId = sijisuPdtcFieldIdFromDataInfo(dataInfo);
        if (fieldId === "") return false;
        const codeField = resolveSijisuPdtcSearchCodeField(fieldId);
        const selectedData = primarySijisuPdtcSelectionData(result, fieldId);
        const code = normalizeDetailMasterCode(DicVal(selectedData, codeField, DicVal(selectedData, fieldId, DicVal(selectedData, `${fieldId}_cd`, ""))));
        const name = resolveSijisuPdtcSelectionName(selectedData, fieldId, code);
        if (code === "") return false;
        const rowKey = normalizeKakousijiUiString(DicVal(DicVal(payload, "rowdata", {}), "rowKey", DicVal(DicVal(payload, "data", {}), "rowKey", "")));
        const rowIds = resolveSijisuPdtcTargetRowIds(payload);
        const panelInfo = Array.isArray(gridlist)
            ? gridlist.find((panel) => canonicalPanelType(DicVal(panel, "type", "")) === canonicalPanelType(DicVal(dataInfo, "type", "")))
            : null;
        if (isEmpty(panelInfo)) return false;
        const currentRows = Array.isArray(GridData(panelInfo)) ? GridData(panelInfo) : [];
        const targetNode = rowIds.length !== 0
            ? findSijisuPdtcGridNode(gridApi, rowIds[0], rowKey)
            : findSijisuPdtcGridNode(gridApi, "", rowKey);
        const targetRow = !isEmpty(targetNode) && !isEmpty(targetNode.data)
            ? targetNode.data
            : (currentRows.find((row) => {
                const rowId = normalizeKakousijiUiString(DicVal(row, "rowid", ""));
                const nodeRowKey = normalizeKakousijiUiString(DicVal(row, "rowKey", ""));
                return (rowIds.length !== 0 && rowIds.indexOf(rowId) !== -1) || (rowKey !== "" && nodeRowKey === rowKey);
            }) || null);
        if (isEmpty(targetRow)) return false;
        const updatedRow = applySijisuPdtcSelectionToRow({ ...targetRow }, fieldId, code, name);
        const nextRows = currentRows.map((row) => {
            const rowId = normalizeKakousijiUiString(DicVal(row, "rowid", ""));
            const nodeRowKey = normalizeKakousijiUiString(DicVal(row, "rowKey", ""));
            if ((rowIds.length !== 0 && rowIds.indexOf(rowId) !== -1) || (rowKey !== "" && nodeRowKey === rowKey)) {
                return updatedRow;
            }
            return row;
        });
        SetGridData(panelInfo, nextRows);
        if (!entryLoadingRef.current && !isEmpty(GridApi(panelInfo)) && isGridDomReady(panelInfo)) {
            applyGridRowsNow(panelInfo, nextRows);
        }
        storeRowData(panelInfo);
        if (!isEmpty(fnc.current) && typeof fnc.current.modify === "function") fnc.current.modify(true);
        return true;
    }
    function wrapSijisuPdtcSearchApply(payload) {
        const dataInfo = resolveSijisuPdtcDataInfo(payload);
        if (!isSijisuPdtcMasterDataInfo(dataInfo)) return payload;
        const doApply = DicVal(payload, "doApply", null);
        if (typeof doApply !== "function") {
            return {
                ...payload,
                data: dataInfo,
                datainfo: dataInfo
            };
        }
        return {
            ...payload,
            data: dataInfo,
            datainfo: dataInfo,
            doApply: (result, mode, allsku) => {
                const normalizedResult = normalizeSijisuPdtcSearchListResponseForStandardApply(result, dataInfo);
                const applied = applySijisuPdtcSelectionToGrid(payload, normalizedResult, dataInfo);
                if (applied) {
                    if (!isEmpty(fnc.current) && typeof fnc.current.searchlistclose === "function") fnc.current.searchlistclose();
                    return;
                }
                return doApply(normalizedResult, mode, allsku);
            }
        };
    }
    function syncSsdshColorNoSelectionToDetail(row, code, name) {
        if (isEmpty(entrydetailRef.current)) return;
        const rows = getDetailRowsByPanelType(entrydetailRef.current, PANEL_TYPE.MATERIAL_COLORWAY);
        if (!Array.isArray(rows) || rows.length === 0) return;
        const sourceRowIds = detailSyncRowIds(row);
        if (sourceRowIds.length === 0) return;
        rows.forEach((detailRow) => {
            const rowid = normalizeKakousijiUiString(DicVal(detailRow, "rowid", ""));
            if (rowid === "" || sourceRowIds.indexOf(rowid) === -1) return;
            Object.assign(detailRow, applySsdshColorNoSelectionToRow(detailRow, code, name));
        });
    }
    function ssdshColorNoChangedFieldId(panelInfo, params) {
        if (canonicalPanelType(DicVal(panelInfo, "type", "")) !== PANEL_TYPE.MATERIAL_COLORWAY) return "";
        const column = DicVal(params, "column", null);
        const candidates = [
            DicVal(DicVal(params, "colDef", {}), "field", ""),
            DicVal(DicVal(params, "colDef", {}), "colId", ""),
            DicVal(DicVal(column, "colDef", {}), "field", ""),
            DicVal(DicVal(column, "colDef", {}), "colId", ""),
            typeof column?.getColId === "function" ? column.getColId() : "",
            DicVal(params, "field", ""),
            DicVal(params, "columnid", "")
        ];
        for (let i = 0; i < candidates.length; i++) {
            if (normalizeColumnIdUpper(candidates[i]) === "SSDSH_COLORNO") return "SSDSH_COLORNO";
        }
        return "";
    }
    function normalizeSsdshColorNoAfterGridValueChanged(panelInfo, params) {
        const fieldId = ssdshColorNoChangedFieldId(panelInfo, params);
        if (fieldId === "") return false;
        const row = DicVal(params, "data", DicVal(DicVal(params, "node", {}), "data", null));
        if (isEmpty(row)) return false;
        if (isExplicitEmptyGridValueChange(params)) {
            const rowBeforeClear = { ...row };
            const cleared = clearSsdshColorNoRow(row, fieldId);
            clearSsdshColorNoCache(rowBeforeClear, fieldId);
            Object.assign(row, cleared);
            const node = DicVal(params, "node", null);
            if (!isEmpty(node)) {
                if (typeof node.setData === "function") {
                    node.setData(row);
                } else if (!isEmpty(node.data)) {
                    Object.assign(node.data, row);
                }
            }
            syncSsdshColorNoSelectionToDetail(row, "", "");
            const api = DicVal(params, "api", GridApi(panelInfo));
            if (!isEmpty(api) && typeof api.refreshCells === "function") {
                api.refreshCells({ rowNodes: isEmpty(node) ? undefined : [node], force: true });
            }
            return true;
        }
        const code = readSsdshColorNoCode({
            code: DicVal(params, "newValue", DicVal(params, "value", readRowValueIgnoreCase(row, fieldId))),
            [fieldId]: DicVal(params, "newValue", DicVal(params, "value", readRowValueIgnoreCase(row, fieldId))),
            [`${fieldId}_cd`]: DicVal(params, "newValue", DicVal(params, "value", readRowValueIgnoreCase(row, fieldId)))
        }, fieldId);
        if (code === "") return false;
        const rows = collectColorwayProductColorGridRows(panelInfo, params);
        const changedValue = DicVal(params, "newValue", DicVal(params, "value", readRowValueIgnoreCase(row, fieldId)));
        const name = resolveSsdshColorNoName({
            [fieldId]: changedValue,
            [`${fieldId}_cd`]: code,
            ZAIC_COLORCD: code
        }, fieldId, code, rows);
        const normalized = applySsdshColorNoSelectionToRow(row, code, name);
        Object.assign(row, normalized);
        const node = DicVal(params, "node", null);
        if (!isEmpty(node)) {
            if (typeof node.setData === "function") {
                node.setData(row);
            } else if (!isEmpty(node.data)) {
                Object.assign(node.data, row);
            }
        }
        syncSsdshColorNoSelectionToDetail(row, code, name);
        const api = DicVal(params, "api", GridApi(panelInfo));
        if (!isEmpty(api) && typeof api.refreshCells === "function") {
            api.refreshCells({ rowNodes: isEmpty(node) ? undefined : [node], force: true });
        }
        return true;
    }
    function sijisuPdtcChangedFieldId(panelInfo, params) {
        if (canonicalPanelType(DicVal(panelInfo, "type", "")) !== "104") return "";
        const column = DicVal(params, "column", null);
        const candidates = [
            DicVal(DicVal(params, "colDef", {}), "field", ""),
            DicVal(DicVal(params, "colDef", {}), "colId", ""),
            DicVal(DicVal(column, "colDef", {}), "field", ""),
            DicVal(DicVal(column, "colDef", {}), "colId", ""),
            typeof column?.getColId === "function" ? column.getColId() : "",
            DicVal(params, "field", ""),
            DicVal(params, "columnid", "")
        ];
        for (let i = 0; i < candidates.length; i++) {
            const cid = normalizeColumnIdUpper(candidates[i]);
            if (cid === "SSDM_COLORCD" || cid === "SSDM_SIZECD") return cid;
        }
        return "";
    }
    function normalizeSijisuPdtcAfterGridValueChanged(panelInfo, params) {
        const fieldId = sijisuPdtcChangedFieldId(panelInfo, params);
        if (fieldId === "") return false;
        const row = DicVal(params, "data", DicVal(DicVal(params, "node", {}), "data", null));
        if (isEmpty(row)) return false;
        if (isExplicitEmptyGridValueChange(params)) {
            Object.assign(row, clearSijisuPdtcRow(row, fieldId));
        } else {
            const changedValue = DicVal(params, "newValue", DicVal(params, "value", readRowValueIgnoreCase(row, fieldId)));
            const code = normalizeDetailMasterCode(changedValue);
            if (code === "") return false;
            Object.assign(row, applySijisuPdtcSelectionToRow(row, fieldId, code));
        }
        const node = DicVal(params, "node", null);
        if (!isEmpty(node)) {
            if (typeof node.setData === "function") {
                node.setData(row);
            } else if (!isEmpty(node.data)) {
                Object.assign(node.data, row);
            }
        }
        const api = DicVal(params, "api", GridApi(panelInfo));
        if (!isEmpty(api) && typeof api.refreshCells === "function") {
            api.refreshCells({ rowNodes: isEmpty(node) ? undefined : [node], force: true });
        }
        return true;
    }
    function normalizeDetailMasterCode(value) {
        const text = normalizeKakousijiUiString(value).replace(/：/g, ":");
        if (text === "") return "";
        return extractMasterCodeFromDisplayValue(text);
    }
    function normalizeDetailMasterName(value) {
        const text = normalizeKakousijiUiString(value).replace(/：/g, ":");
        if (text === "" || text.indexOf(":") === -1) return text;
        return text.substring(text.indexOf(":") + 1).trim();
    }
    function formatDetailMasterDisplayValue(code, name) {
        const normalizedCode = normalizeDetailMasterCode(code);
        const normalizedName = normalizeDetailMasterName(name);
        if (normalizedCode === "" && normalizedName === "") return "";
        if (normalizedCode === "") return normalizedName;
        if (normalizedName === "") return normalizedCode;
        return `${normalizedCode}:${normalizedName}`;
    }
    function isMaterialZaiHinbanMasterDataInfo(dataInfo) {
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const colId = normalizeColumnIdUpper(DicVal(dataInfo, "colId", DicVal(dataInfo, "field", DicVal(dataInfo, "columnid", ""))));
        const columnId = normalizeColumnIdUpper(DicVal(dataInfo, "columnid", colId));
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", "")));
        const baseDataId = dataId.split(":")[0];
        if (panelType === PANEL_TYPE.MATERIAL_DETAIL && (colId === "SSDS_ZAIHINBAN" || columnId === "SSDS_ZAIHINBAN")) return true;
        return (colId === "SSDS_ZAIHINBAN" || columnId === "SSDS_ZAIHINBAN")
            && baseDataId === "FM_ZAI";
    }
    function resolveMaterialZaiHinbanDataInfo(payload) {
        if (isEmpty(payload)) return {};
        const candidates = [
            DicVal(payload, "data", {}),
            DicVal(payload, "datainfo", {}),
            DicVal(payload, "dataInfo", {}),
            DicVal(payload, "colinfo", {}),
            DicVal(payload, "colInfo", {})
        ];
        for (let i = 0; i < candidates.length; i++) {
            if (isMaterialZaiHinbanMasterDataInfo(candidates[i])) return candidates[i];
        }
        const dataid = normalizeKakousijiUiString(DicVal(payload, "dataid", ""));
        const others = Array.isArray(DicVal(payload, "others", null)) ? DicVal(payload, "others", []) : [];
        const firstOther = others.length !== 0 ? others[0] : {};
        const columnid = normalizeKakousijiUiString(DicVal(firstOther, "columnid", ""));
        const dbcolumn = normalizeKakousijiUiString(DicVal(firstOther, "dbcolumn", ""));
        const inferred = {
            dataid,
            mastertype: dataid,
            columnid,
            colId: columnid,
            field: columnid,
            dbcolumn
        };
        return isMaterialZaiHinbanMasterDataInfo(inferred) ? inferred : {};
    }
    function isAccessoryFuzokuHinbanMasterDataInfo(dataInfo) {
        const panelType = normalizeKakousijiUiString(DicVal(dataInfo, "type", ""));
        const colId = normalizeColumnIdUpper(DicVal(dataInfo, "colId", DicVal(dataInfo, "field", DicVal(dataInfo, "columnid", ""))));
        const columnId = normalizeColumnIdUpper(DicVal(dataInfo, "columnid", colId));
        const dataId = normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", "")));
        const baseDataId = dataId.split(":")[0];
        if (panelType === PANEL_TYPE.ACCESSORY_DETAIL && (colId === "SSDF_FUZOKU_HINBAN" || columnId === "SSDF_FUZOKU_HINBAN")) return true;
        return (colId === "SSDF_FUZOKU_HINBAN" || columnId === "SSDF_FUZOKU_HINBAN")
            && baseDataId === "FM_FZK";
    }
    function resolveAccessoryFuzokuHinbanDataInfo(payload) {
        if (isEmpty(payload)) return {};
        const candidates = [
            DicVal(payload, "data", {}),
            DicVal(payload, "datainfo", {}),
            DicVal(payload, "dataInfo", {}),
            DicVal(payload, "colinfo", {}),
            DicVal(payload, "colInfo", {})
        ];
        for (let i = 0; i < candidates.length; i++) {
            if (isAccessoryFuzokuHinbanMasterDataInfo(candidates[i])) return candidates[i];
        }
        const dataid = normalizeKakousijiUiString(DicVal(payload, "dataid", ""));
        const others = Array.isArray(DicVal(payload, "others", null)) ? DicVal(payload, "others", []) : [];
        const firstOther = others.length !== 0 ? others[0] : {};
        const columnid = normalizeKakousijiUiString(DicVal(firstOther, "columnid", ""));
        const dbcolumn = normalizeKakousijiUiString(DicVal(firstOther, "dbcolumn", ""));
        const inferred = {
            dataid,
            mastertype: dataid,
            columnid,
            colId: columnid,
            field: columnid,
            dbcolumn
        };
        return isAccessoryFuzokuHinbanMasterDataInfo(inferred) ? inferred : {};
    }
    function readMaterialZaiHinbanCode(source) {
        if (isEmpty(source) || typeof source !== "object") return "";
        const keys = ["ZAI_HINBAN", "SSDS_ZAIHINBAN_cd", "code", "SSDS_ZAIHINBAN"];
        for (let i = 0; i < keys.length; i++) {
            const code = normalizeDetailMasterCode(readRowValueIgnoreCase(source, keys[i]));
            if (code !== "") return code;
        }
        return "";
    }
    function readMaterialZaiHinbanCodeFromChange(panelInfo, params, row) {
        const changedCandidates = [
            DicVal(params, "newValue", undefined),
            DicVal(params, "value", undefined),
            readRowValueIgnoreCase(row, "SSDS_ZAIHINBAN_cd"),
            readRowValueIgnoreCase(row, "SSDS_ZAIHINBAN"),
            readRowValueIgnoreCase(row, "ZAI_HINBAN")
        ];
        for (let i = 0; i < changedCandidates.length; i++) {
            const code = normalizeDetailMasterCode(changedCandidates[i]);
            if (code !== "") return code;
        }
        const rows = collectColorwayProductColorGridRows(panelInfo, params);
        const rowIndex = resolveDetailMasterRowIndex(params, rows);
        if (rowIndex >= 0) {
            const baseRow = rows[rowIndex];
            const code = normalizeDetailMasterCode(readRowValueIgnoreCase(baseRow, "SSDS_ZAIHINBAN_cd"))
                || normalizeDetailMasterCode(readRowValueIgnoreCase(baseRow, "SSDS_ZAIHINBAN"))
                || normalizeDetailMasterCode(readRowValueIgnoreCase(baseRow, "ZAI_HINBAN"));
            if (code !== "") return code;
        }
        const cache = DicVal(materialZaiHinbanSelectionCacheRef, "current", {});
        const rowIdentityKey = resolveRowIdentityKey(row);
        if (rowIdentityKey !== "") {
            const cachedByRow = DicVal(cache, rowIdentityKey, null);
            const cachedCode = normalizeKakousijiUiString(DicVal(cachedByRow, "code", ""));
            if (cachedCode !== "") return cachedCode;
        }
        return "";
    }
    function readMaterialZaiHinbanName(source, code = "") {
        if (isEmpty(source) || typeof source !== "object") return "";
        const targetCode = normalizeKakousijiUiString(code);
        const nameKeys = ["SSDS_ZAIHINBAN_nm", "ZAI_NAME", "name", "label", "SSDS_ZAIHINBAN"];
        for (let i = 0; i < nameKeys.length; i++) {
            const value = readRowValueIgnoreCase(source, nameKeys[i]);
            if (targetCode !== "") {
                if (nameKeys[i] === "SSDS_ZAIHINBAN_nm") {
                    const relatedCode = normalizeDetailMasterCode(readRowValueIgnoreCase(source, "SSDS_ZAIHINBAN_cd"));
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
                if (nameKeys[i] === "ZAI_NAME") {
                    const relatedCode = normalizeDetailMasterCode(readRowValueIgnoreCase(source, "ZAI_HINBAN"));
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
                if (nameKeys[i] === "SSDS_ZAIHINBAN") {
                    const relatedCode = normalizeDetailMasterCode(value);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
            }
            if (nameKeys[i] === "SSDS_ZAIHINBAN" && normalizeKakousijiUiString(value).indexOf(":") === -1 && normalizeKakousijiUiString(value).indexOf("：") === -1) continue;
            const name = normalizeDetailMasterName(value);
            if (name !== "") return name;
        }
        return "";
    }
    function readAccessoryFuzokuHinbanCode(source) {
        if (isEmpty(source) || typeof source !== "object") return "";
        const keys = ["FZK_FUZOKU_HINBAN", "SSDF_FUZOKU_HINBAN_cd", "code", "SSDF_FUZOKU_HINBAN"];
        for (let i = 0; i < keys.length; i++) {
            const code = normalizeDetailMasterCode(readRowValueIgnoreCase(source, keys[i]));
            if (code !== "") return code;
        }
        return "";
    }
    function readAccessoryFuzokuHinbanCodeFromChange(panelInfo, params, row) {
        const changedCandidates = [
            DicVal(params, "newValue", undefined),
            DicVal(params, "value", undefined),
            readRowValueIgnoreCase(row, "SSDF_FUZOKU_HINBAN_cd"),
            readRowValueIgnoreCase(row, "SSDF_FUZOKU_HINBAN"),
            readRowValueIgnoreCase(row, "FZK_FUZOKU_HINBAN")
        ];
        for (let i = 0; i < changedCandidates.length; i++) {
            const code = normalizeDetailMasterCode(changedCandidates[i]);
            if (code !== "") return code;
        }
        const rows = collectColorwayProductColorGridRows(panelInfo, params);
        const rowIndex = resolveDetailMasterRowIndex(params, rows);
        if (rowIndex >= 0) {
            const baseRow = rows[rowIndex];
            const code = normalizeDetailMasterCode(readRowValueIgnoreCase(baseRow, "SSDF_FUZOKU_HINBAN_cd"))
                || normalizeDetailMasterCode(readRowValueIgnoreCase(baseRow, "SSDF_FUZOKU_HINBAN"))
                || normalizeDetailMasterCode(readRowValueIgnoreCase(baseRow, "FZK_FUZOKU_HINBAN"));
            if (code !== "") return code;
        }
        const cache = DicVal(accessoryFuzokuHinbanSelectionCacheRef, "current", {});
        const rowIdentityKey = resolveRowIdentityKey(row);
        if (rowIdentityKey !== "") {
            const cachedByRow = DicVal(cache, rowIdentityKey, null);
            const cachedCode = normalizeKakousijiUiString(DicVal(cachedByRow, "code", ""));
            if (cachedCode !== "") return cachedCode;
        }
        return "";
    }
    function readAccessoryFuzokuHinbanName(source, code = "") {
        if (isEmpty(source) || typeof source !== "object") return "";
        const targetCode = normalizeKakousijiUiString(code);
        const nameKeys = ["SSDF_FUZOKU_HINBAN_nm", "FZK_FUZOKU_NM", "name", "label", "SSDF_FUZOKU_HINBAN"];
        for (let i = 0; i < nameKeys.length; i++) {
            const value = readRowValueIgnoreCase(source, nameKeys[i]);
            if (targetCode !== "") {
                if (nameKeys[i] === "SSDF_FUZOKU_HINBAN_nm") {
                    const relatedCode = normalizeDetailMasterCode(readRowValueIgnoreCase(source, "SSDF_FUZOKU_HINBAN_cd"));
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
                if (nameKeys[i] === "FZK_FUZOKU_NM") {
                    const relatedCode = normalizeDetailMasterCode(readRowValueIgnoreCase(source, "FZK_FUZOKU_HINBAN"));
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
                if (nameKeys[i] === "SSDF_FUZOKU_HINBAN") {
                    const relatedCode = normalizeDetailMasterCode(value);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
            }
            if (nameKeys[i] === "SSDF_FUZOKU_HINBAN" && normalizeKakousijiUiString(value).indexOf(":") === -1 && normalizeKakousijiUiString(value).indexOf("：") === -1) continue;
            const name = normalizeDetailMasterName(value);
            if (name !== "") return name;
        }
        return "";
    }
    function resolveDetailMasterCacheName(cacheRef, row, code, fieldId) {
        const targetCode = normalizeDetailMasterCode(code);
        if (targetCode === "") return "";
        const cache = DicVal(cacheRef, "current", {});
        const direct = DicVal(cache, targetCode, null);
        const directFieldId = normalizeColumnIdUpper(DicVal(direct, "fieldId", ""));
        const targetFieldId = normalizeColumnIdUpper(fieldId);
        if ((directFieldId === "" || directFieldId === targetFieldId) && normalizeKakousijiUiString(DicVal(direct, "name", "")) !== "") {
            return normalizeKakousijiUiString(DicVal(direct, "name", ""));
        }
        const rowIds = detailSyncRowIds(row);
        for (let i = 0; i < rowIds.length; i++) {
            const cached = DicVal(cache, rowIds[i], null);
            const cachedFieldId = normalizeColumnIdUpper(DicVal(cached, "fieldId", ""));
            const cachedCode = normalizeDetailMasterCode(DicVal(cached, "code", ""));
            const cachedName = normalizeKakousijiUiString(DicVal(cached, "name", ""));
            if (cachedName !== "" && (cachedFieldId === "" || cachedFieldId === targetFieldId) && cachedCode === targetCode) return cachedName;
        }
        return "";
    }
    function upsertDetailMasterSelectionCacheEntry(cacheRef, key, code, name, fieldId, extra = null) {
        const normalizedKey = normalizeKakousijiUiString(key);
        const normalizedCode = normalizeDetailMasterCode(code);
        if (normalizedKey === "" || normalizedCode === "") return;
        const cache = DicVal(cacheRef, "current", null);
        if (isEmpty(cache) || typeof cache !== "object") return;
        const existing = DicVal(cache, normalizedKey, {});
        const existingName = normalizeKakousijiUiString(DicVal(existing, "name", ""));
        const nextName = normalizeKakousijiUiString(name) !== "" ? normalizeKakousijiUiString(name) : existingName;
        const next = {
            ...existing,
            code: normalizedCode,
            name: nextName,
            fieldId
        };
        const extraLinkedFields = isEmpty(extra) || typeof extra !== "object" ? null : DicVal(extra, "linkedFields", null);
        if (!isEmpty(extraLinkedFields) && typeof extraLinkedFields === "object") {
            next.linkedFields = {
                ...(isEmpty(DicVal(existing, "linkedFields", null)) ? {} : DicVal(existing, "linkedFields", {})),
                ...extraLinkedFields
            };
        }
        cache[normalizedKey] = next;
    }
    function resolveMaterialZaiHinbanAppliedName(row, code, name) {
        const targetCode = normalizeDetailMasterCode(code);
        if (targetCode === "") return "";
        const candidates = [
            normalizeDetailMasterName(name),
            readMaterialZaiHinbanName(row, targetCode),
            resolveDetailMasterCacheName(materialZaiHinbanSelectionCacheRef, row, targetCode, "SSDS_ZAIHINBAN")
        ];
        const sourceRows = Array.isArray(DicVal(row, "__sourceRows", null)) ? row.__sourceRows : [];
        sourceRows.forEach((sourceRow) => {
            if (readMaterialZaiHinbanCode(sourceRow) === targetCode) {
                candidates.push(readMaterialZaiHinbanName(sourceRow, targetCode));
            }
        });
        for (let i = 0; i < candidates.length; i++) {
            const candidate = normalizeKakousijiUiString(candidates[i]);
            if (candidate !== "") return candidate;
        }
        return "";
    }
    function resolveAccessoryFuzokuHinbanAppliedName(row, code, name) {
        const targetCode = normalizeDetailMasterCode(code);
        if (targetCode === "") return "";
        const candidates = [
            normalizeDetailMasterName(name),
            readAccessoryFuzokuHinbanName(row, targetCode),
            resolveDetailMasterCacheName(accessoryFuzokuHinbanSelectionCacheRef, row, targetCode, "SSDF_FUZOKU_HINBAN")
        ];
        const sourceRows = Array.isArray(DicVal(row, "__sourceRows", null)) ? row.__sourceRows : [];
        sourceRows.forEach((sourceRow) => {
            if (readAccessoryFuzokuHinbanCode(sourceRow) === targetCode) {
                candidates.push(readAccessoryFuzokuHinbanName(sourceRow, targetCode));
            }
        });
        for (let i = 0; i < candidates.length; i++) {
            const candidate = normalizeKakousijiUiString(candidates[i]);
            if (candidate !== "") return candidate;
        }
        return "";
    }
    function clearMaterialZaiHinbanRow(row) {
        if (isEmpty(row)) return row;
        const next = {
            ...row,
            SSDS_ZAIHINBAN: "",
            SSDS_ZAIHINBAN_cd: "",
            SSDS_ZAIHINBAN_nm: "",
            ZAI_HINBAN: "",
            ZAI_NAME: ""
        };
        MATERIAL_ZAI_LINKED_FIELD_IDS.forEach((fieldId) => {
            next[fieldId] = "";
        });
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => clearMaterialZaiHinbanRow(sourceRow));
        }
        return next;
    }
    function readMaterialZaiHinbanLinkedFields(source) {
        const next = {};
        MATERIAL_ZAI_LINKED_FIELD_IDS.forEach((fieldId) => {
            next[fieldId] = normalizeKakousijiUiString(readRowValueIgnoreCase(source, fieldId));
        });
        return next;
    }
    function resolveMaterialZaiHinbanLinkedFields(row, code) {
        const targetCode = normalizeDetailMasterCode(code);
        const currentCode = readMaterialZaiHinbanCode(row);
        const cached = targetCode === "" ? null : DicVal(DicVal(materialZaiHinbanSelectionCacheRef, "current", {}), targetCode, null);
        const cachedLinkedFields = isEmpty(cached) ? null : DicVal(cached, "linkedFields", null);
        const currentLinkedFields = readMaterialZaiHinbanLinkedFields(row);
        const next = {};
        MATERIAL_ZAI_LINKED_FIELD_IDS.forEach((fieldId) => {
            let value = "";
            if (currentCode !== "" && currentCode === targetCode) {
                value = normalizeKakousijiUiString(DicVal(currentLinkedFields, fieldId, ""));
            }
            if (value === "" && !isEmpty(cachedLinkedFields) && typeof cachedLinkedFields === "object") {
                value = normalizeKakousijiUiString(DicVal(cachedLinkedFields, fieldId, ""));
            }
            next[fieldId] = value;
        });
        return next;
    }
    function clearAccessoryFuzokuHinbanRow(row) {
        if (isEmpty(row)) return row;
        const next = {
            ...row,
            SSDF_FUZOKU_HINBAN: "",
            SSDF_FUZOKU_HINBAN_cd: "",
            SSDF_FUZOKU_HINBAN_nm: "",
            FZK_FUZOKU_HINBAN: "",
            FZK_FUZOKU_NM: ""
        };
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => clearAccessoryFuzokuHinbanRow(sourceRow));
        }
        return next;
    }
    function clearSijisuPdtcRow(row, fieldId = "") {
        if (isEmpty(row)) return row;
        const next = {
            ...row,
            code: "",
            name: ""
        };
        const targetFieldId = normalizeColumnIdUpper(fieldId);
        if (targetFieldId === "" || targetFieldId === "SSDM_COLORCD") {
            next.SSDM_COLORCD = "";
            next.SSDM_COLORCD_cd = "";
            next.SSDM_COLORCD_nm = "";
            next.PDTC_COLORCD = "";
            next.PDTC_COLORNM = "";
        }
        if (targetFieldId === "" || targetFieldId === "SSDM_SIZECD") {
            next.SSDM_SIZECD = "";
            next.SSDM_SIZECD_cd = "";
            next.SSDM_SIZECD_nm = "";
            next.PDTC_SIZECD = "";
            next.PDTC_SIZENM = "";
        }
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => clearSijisuPdtcRow(sourceRow, fieldId));
        }
        return next;
    }
    function applySijisuPdtcSelectionToRow(row, fieldId, code, name = "") {
        if (isEmpty(row) || fieldId === "") return row;
        const targetFieldId = normalizeColumnIdUpper(fieldId);
        const normalizedCode = normalizeDetailMasterCode(code);
        const resolvedName = resolveSijisuPdtcSelectionName(row, targetFieldId, normalizeKakousijiUiString(name) || normalizedCode);
        const next = {
            ...row,
            code: normalizedCode,
            name: resolvedName
        };
        if (targetFieldId === "SSDM_COLORCD") {
            next.SSDM_COLORCD = normalizedCode;
            next.SSDM_COLORCD_cd = normalizedCode;
            next.SSDM_COLORCD_nm = resolvedName;
            next.PDTC_COLORCD = normalizedCode;
            next.PDTC_COLORNM = resolvedName;
        }
        if (targetFieldId === "SSDM_SIZECD") {
            next.SSDM_SIZECD = normalizedCode;
            next.SSDM_SIZECD_cd = normalizedCode;
            next.SSDM_SIZECD_nm = resolvedName;
            next.PDTC_SIZECD = normalizedCode;
            next.PDTC_SIZENM = resolvedName;
        }
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => applySijisuPdtcSelectionToRow(sourceRow, fieldId, normalizedCode, resolvedName));
        }
        return next;
    }
    function clearDetailMasterSelectionCacheEntries(cacheRef, row, fieldId, readCode) {
        const cache = DicVal(cacheRef, "current", null);
        if (isEmpty(cache) || typeof cache !== "object") return;
        const rowIdKeys = [];
        const codeKeys = [];
        const addRowId = (value) => {
            const normalized = normalizeKakousijiUiString(value);
            if (normalized !== "" && rowIdKeys.indexOf(normalized) === -1) rowIdKeys.push(normalized);
        };
        const addCode = (value) => {
            const normalized = normalizeDetailMasterCode(value);
            if (normalized !== "" && codeKeys.indexOf(normalized) === -1) codeKeys.push(normalized);
        };
        const addFromRow = (targetRow) => {
            if (isEmpty(targetRow) || typeof targetRow !== "object") return;
            addRowId(DicVal(targetRow, "rowid", ""));
            addCode(typeof readCode === "function" ? readCode(targetRow) : "");
        };
        addFromRow(row);
        const sourceRows = Array.isArray(DicVal(row, "__sourceRows", null)) ? row.__sourceRows : [];
        sourceRows.forEach((sourceRow) => addFromRow(sourceRow));
        Object.keys(cache).forEach((key) => {
            const entry = cache[key];
            if (isEmpty(entry) || typeof entry !== "object") {
                const normalizedKey = normalizeKakousijiUiString(key);
                if (rowIdKeys.indexOf(normalizedKey) !== -1 || codeKeys.indexOf(normalizedKey) !== -1) delete cache[key];
                return;
            }
            const cachedFieldId = normalizeColumnIdUpper(DicVal(entry, "fieldId", ""));
            if (cachedFieldId !== "" && cachedFieldId !== normalizeColumnIdUpper(fieldId)) return;
            const normalizedKey = normalizeKakousijiUiString(key);
            const cachedCode = normalizeDetailMasterCode(DicVal(entry, "code", ""));
            if (rowIdKeys.indexOf(normalizedKey) !== -1 || codeKeys.indexOf(normalizedKey) !== -1 || (cachedCode !== "" && codeKeys.indexOf(cachedCode) !== -1)) {
                delete cache[key];
            }
        });
    }
    function clearMaterialZaiHinbanCache(row) {
        clearDetailMasterSelectionCacheEntries(materialZaiHinbanSelectionCacheRef, row, "SSDS_ZAIHINBAN", readMaterialZaiHinbanCode);
    }
    function clearAccessoryFuzokuHinbanCache(row) {
        clearDetailMasterSelectionCacheEntries(accessoryFuzokuHinbanSelectionCacheRef, row, "SSDF_FUZOKU_HINBAN", readAccessoryFuzokuHinbanCode);
    }
    function applyMaterialZaiHinbanSelectionToRow(row, code, name) {
        if (isEmpty(row)) return row;
        if (code === "") return clearMaterialZaiHinbanRow(row);
        const appliedName = resolveMaterialZaiHinbanAppliedName(row, code, name);
        const linkedFields = resolveMaterialZaiHinbanLinkedFields(row, code);
        const next = {
            ...row,
            SSDS_ZAIHINBAN: formatDetailMasterDisplayValue(code, appliedName),
            SSDS_ZAIHINBAN_cd: code,
            SSDS_ZAIHINBAN_nm: appliedName,
            ZAI_HINBAN: code,
            ZAI_NAME: appliedName,
            ...linkedFields
        };
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => applyMaterialZaiHinbanSelectionToRow(sourceRow, code, appliedName));
        }
        return next;
    }
    function applyAccessoryFuzokuHinbanSelectionToRow(row, code, name) {
        if (isEmpty(row)) return row;
        if (code === "") return clearAccessoryFuzokuHinbanRow(row);
        const appliedName = resolveAccessoryFuzokuHinbanAppliedName(row, code, name);
        const next = {
            ...row,
            SSDF_FUZOKU_HINBAN: formatDetailMasterDisplayValue(code, appliedName),
            SSDF_FUZOKU_HINBAN_cd: code,
            SSDF_FUZOKU_HINBAN_nm: appliedName,
            FZK_FUZOKU_HINBAN: code,
            FZK_FUZOKU_NM: appliedName
        };
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((sourceRow) => applyAccessoryFuzokuHinbanSelectionToRow(sourceRow, code, appliedName));
        }
        return next;
    }
    function resolveMaterialZaiHinbanName(source, code, rows = []) {
        const sourceName = readMaterialZaiHinbanName(source, code);
        if (sourceName !== "") return sourceName;
        const cachedName = resolveDetailMasterCacheName(materialZaiHinbanSelectionCacheRef, source, code, "SSDS_ZAIHINBAN");
        if (cachedName !== "") return cachedName;
        for (let i = 0; i < rows.length; i++) {
            if (readMaterialZaiHinbanCode(rows[i]) !== normalizeKakousijiUiString(code)) continue;
            const name = readMaterialZaiHinbanName(rows[i], code);
            if (name !== "") return name;
        }
        return "";
    }
    function resolveAccessoryFuzokuHinbanName(source, code, rows = []) {
        const sourceName = readAccessoryFuzokuHinbanName(source, code);
        if (sourceName !== "") return sourceName;
        const cachedName = resolveDetailMasterCacheName(accessoryFuzokuHinbanSelectionCacheRef, source, code, "SSDF_FUZOKU_HINBAN");
        if (cachedName !== "") return cachedName;
        for (let i = 0; i < rows.length; i++) {
            if (readAccessoryFuzokuHinbanCode(rows[i]) !== normalizeKakousijiUiString(code)) continue;
            const name = readAccessoryFuzokuHinbanName(rows[i], code);
            if (name !== "") return name;
        }
        return "";
    }
    function normalizeMaterialZaiHinbanSearchListResponseForStandardApply(response, dataInfo) {
        if (isEmpty(response) || !Array.isArray(DicVal(response, "rowdata", null))) return response;
        if (!isMaterialZaiHinbanMasterDataInfo(dataInfo)) return response;
        return {
            ...response,
            rowdata: response.rowdata.map((row) => {
                const code = readMaterialZaiHinbanCode(row);
                const name = resolveMaterialZaiHinbanName(row, code, response.rowdata);
                if (code === "") return row;
                const sourceRowId = normalizeKakousijiUiString(DicVal(row, "rowid", ""));
                const linkedFields = readMaterialZaiHinbanLinkedFields(row);
                if (sourceRowId !== "") upsertDetailMasterSelectionCacheEntry(materialZaiHinbanSelectionCacheRef, sourceRowId, code, name, "SSDS_ZAIHINBAN", { linkedFields });
                upsertDetailMasterSelectionCacheEntry(materialZaiHinbanSelectionCacheRef, code, code, name, "SSDS_ZAIHINBAN", { linkedFields });
                return {
                    ...row,
                    dataid: normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", ""))) || "FM_ZAI",
                    rowid: code,
                    code,
                    name,
                    ZAI_HINBAN: code,
                    ZAI_NAME: name,
                    SSDS_ZAIHINBAN: formatDetailMasterDisplayValue(code, name),
                    SSDS_ZAIHINBAN_cd: code,
                    SSDS_ZAIHINBAN_nm: name,
                    ...linkedFields
                };
            })
        };
    }
    function normalizeAccessoryFuzokuHinbanSearchListResponseForStandardApply(response, dataInfo) {
        if (isEmpty(response) || !Array.isArray(DicVal(response, "rowdata", null))) return response;
        if (!isAccessoryFuzokuHinbanMasterDataInfo(dataInfo)) return response;
        return {
            ...response,
            rowdata: response.rowdata.map((row) => {
                const code = readAccessoryFuzokuHinbanCode(row);
                const name = resolveAccessoryFuzokuHinbanName(row, code, response.rowdata);
                if (code === "") return row;
                const sourceRowId = normalizeKakousijiUiString(DicVal(row, "rowid", ""));
                if (sourceRowId !== "") upsertDetailMasterSelectionCacheEntry(accessoryFuzokuHinbanSelectionCacheRef, sourceRowId, code, name, "SSDF_FUZOKU_HINBAN");
                upsertDetailMasterSelectionCacheEntry(accessoryFuzokuHinbanSelectionCacheRef, code, code, name, "SSDF_FUZOKU_HINBAN");
                return {
                    ...row,
                    dataid: normalizeKakousijiUiString(DicVal(dataInfo, "dataid", DicVal(dataInfo, "mastertype", ""))) || "FM_FZK",
                    rowid: code,
                    code,
                    name,
                    FZK_FUZOKU_HINBAN: code,
                    FZK_FUZOKU_NM: name,
                    SSDF_FUZOKU_HINBAN: formatDetailMasterDisplayValue(code, name),
                    SSDF_FUZOKU_HINBAN_cd: code,
                    SSDF_FUZOKU_HINBAN_nm: name
                };
            })
        };
    }
    function wrapDetailMasterSearchListResponseCallback(url, param, callback) {
        const normalizedUrl = normalizeKakousijiUiString(url).toLowerCase();
        if (normalizedUrl !== "common/getsearchmasterlist"
            && normalizedUrl !== "kakousiji/getsearchmasterlist"
            && normalizedUrl !== "kakousiji/getmaterialaccessorymastersearchlist") return callback;
        if (isEmpty(callback) || typeof callback !== "object" || typeof callback.onSuccess !== "function") return callback;
        const materialInfo = resolveMaterialZaiHinbanDataInfo(param);
        const accessoryInfo = resolveAccessoryFuzokuHinbanDataInfo(param);
        if (!isMaterialZaiHinbanMasterDataInfo(materialInfo) && !isAccessoryFuzokuHinbanMasterDataInfo(accessoryInfo)) return callback;
        return {
            ...callback,
            onSuccess: function (data) {
                const withMaterial = normalizeMaterialZaiHinbanSearchListResponseForStandardApply(data, materialInfo);
                const withAccessory = normalizeAccessoryFuzokuHinbanSearchListResponseForStandardApply(withMaterial, accessoryInfo);
                return callback.onSuccess(withAccessory);
            }
        };
    }
    function normalizeDetailMasterGetMasterDataRequest(url, param) {
        if (normalizeKakousijiUiString(url).toLowerCase() !== "common/getmasterdata") return { url, param, skip: false };
        if (isEmpty(param) || typeof param !== "object") return { url, param, skip: false };
        const materialInfo = resolveMaterialZaiHinbanDataInfo(param);
        const accessoryInfo = resolveAccessoryFuzokuHinbanDataInfo(param);
        const normalizeRequest = (options) => {
            const rowdata = DicVal(param, "rowdata", {});
            const requestCode = normalizeDetailMasterCode(DicVal(param, "code", ""));
            const rowdataCode = options.readCode(rowdata);
            if (rowdataCode === "" && (options.hasOwnField(rowdata) || requestCode === "")) {
                return {
                    url,
                    param: {
                        ...param,
                        code: "",
                        rowdata: options.clearRow(isEmpty(rowdata) ? {} : { ...rowdata })
                    },
                    skip: true
                };
            }
            if (requestCode === "" || requestCode === rowdataCode) return { url, param, skip: false };
            const sourceRowId = normalizeKakousijiUiString(DicVal(rowdata, "rowid", ""));
            const cache = DicVal(options.cacheRef, "current", {});
            const cached = DicVal(cache, requestCode, DicVal(cache, sourceRowId, null));
            const code = rowdataCode || normalizeKakousijiUiString(DicVal(cached, "code", ""));
            const name = options.resolveName(rowdata, code, normalizeKakousijiUiString(DicVal(cached, "name", "")));
            if (code === "") {
                return { url, param: { ...param, code: "" }, skip: true };
            }
            return {
                url,
                param: {
                    ...param,
                    code,
                    rowdata: options.applyRow(isEmpty(rowdata) ? {} : { ...rowdata }, code, name)
                },
                skip: false
            };
        };
        if (isMaterialZaiHinbanMasterDataInfo(materialInfo)) {
            return normalizeRequest({
                cacheRef: materialZaiHinbanSelectionCacheRef,
                readCode: readMaterialZaiHinbanCode,
                readName: readMaterialZaiHinbanName,
                resolveName: (rowdata, code, cachedName) => resolveMaterialZaiHinbanAppliedName({ ...(rowdata || {}), name: cachedName }, code, cachedName),
                applyRow: applyMaterialZaiHinbanSelectionToRow,
                clearRow: clearMaterialZaiHinbanRow,
                hasOwnField: (row) =>
                    hasOwnGridValue(row, "SSDS_ZAIHINBAN")
                    || hasOwnGridValue(row, "SSDS_ZAIHINBAN_cd")
                    || hasOwnGridValue(row, "ZAI_HINBAN"),
                warnLabel: "[Kakousiji][ZaiHinban] GetMasterData blocked"
            });
        }
        if (isAccessoryFuzokuHinbanMasterDataInfo(accessoryInfo)) {
            return normalizeRequest({
                cacheRef: accessoryFuzokuHinbanSelectionCacheRef,
                readCode: readAccessoryFuzokuHinbanCode,
                readName: readAccessoryFuzokuHinbanName,
                resolveName: (rowdata, code, cachedName) => resolveAccessoryFuzokuHinbanAppliedName({ ...(rowdata || {}), name: cachedName }, code, cachedName),
                applyRow: applyAccessoryFuzokuHinbanSelectionToRow,
                clearRow: clearAccessoryFuzokuHinbanRow,
                hasOwnField: (row) =>
                    hasOwnGridValue(row, "SSDF_FUZOKU_HINBAN")
                    || hasOwnGridValue(row, "SSDF_FUZOKU_HINBAN_cd")
                    || hasOwnGridValue(row, "FZK_FUZOKU_HINBAN"),
                warnLabel: "[Kakousiji][FuzokuHinban] GetMasterData blocked"
            });
        }
        return { url, param, skip: false };
    }
    function materialZaiHinbanChangedFieldId(panelInfo, params) {
        if (canonicalPanelType(DicVal(panelInfo, "type", "")) !== PANEL_TYPE.MATERIAL_DETAIL) return "";
        const column = DicVal(params, "column", null);
        const candidates = [
            DicVal(DicVal(params, "colDef", {}), "field", ""),
            DicVal(DicVal(params, "colDef", {}), "colId", ""),
            DicVal(DicVal(column, "colDef", {}), "field", ""),
            DicVal(DicVal(column, "colDef", {}), "colId", ""),
            typeof column?.getColId === "function" ? column.getColId() : "",
            DicVal(params, "field", ""),
            DicVal(params, "columnid", "")
        ];
        for (let i = 0; i < candidates.length; i++) {
            if (normalizeColumnIdUpper(candidates[i]) === "SSDS_ZAIHINBAN") return "SSDS_ZAIHINBAN";
        }
        return "";
    }
    function accessoryFuzokuHinbanChangedFieldId(panelInfo, params) {
        if (canonicalPanelType(DicVal(panelInfo, "type", "")) !== PANEL_TYPE.ACCESSORY_DETAIL) return "";
        const column = DicVal(params, "column", null);
        const candidates = [
            DicVal(DicVal(params, "colDef", {}), "field", ""),
            DicVal(DicVal(params, "colDef", {}), "colId", ""),
            DicVal(DicVal(column, "colDef", {}), "field", ""),
            DicVal(DicVal(column, "colDef", {}), "colId", ""),
            typeof column?.getColId === "function" ? column.getColId() : "",
            DicVal(params, "field", ""),
            DicVal(params, "columnid", "")
        ];
        for (let i = 0; i < candidates.length; i++) {
            if (normalizeColumnIdUpper(candidates[i]) === "SSDF_FUZOKU_HINBAN") return "SSDF_FUZOKU_HINBAN";
        }
        return "";
    }
    function normalizeMaterialZaiHinbanAfterGridValueChanged(panelInfo, params) {
        const fieldId = materialZaiHinbanChangedFieldId(panelInfo, params);
        if (fieldId === "") return false;
        const row = DicVal(params, "data", DicVal(DicVal(params, "node", {}), "data", null));
        if (isEmpty(row)) return false;
        if (isExplicitEmptyGridValueChange(params)) {
            const rowBeforeClear = { ...row };
            const cleared = clearMaterialZaiHinbanRow(row);
            clearMaterialZaiHinbanCache(rowBeforeClear);
            Object.assign(row, cleared);
            const node = DicVal(params, "node", null);
            if (!isEmpty(node)) {
                if (typeof node.setData === "function") {
                    node.setData(row);
                } else if (!isEmpty(node.data)) {
                    Object.assign(node.data, row);
                }
            }
            const api = DicVal(params, "api", GridApi(panelInfo));
            if (!isEmpty(api) && typeof api.refreshCells === "function") {
                api.refreshCells({ rowNodes: isEmpty(node) ? undefined : [node], force: true });
            }
            return true;
        }
        const changedValue = DicVal(params, "newValue", DicVal(params, "value", readRowValueIgnoreCase(row, fieldId)));
        const code = readMaterialZaiHinbanCodeFromChange(panelInfo, params, row);
        if (code === "") return false;
        const rows = collectColorwayProductColorGridRows(panelInfo, params);
        const name = resolveMaterialZaiHinbanName({
            SSDS_ZAIHINBAN_nm: readRowValueIgnoreCase(row, "SSDS_ZAIHINBAN_nm"),
            ZAI_NAME: readRowValueIgnoreCase(row, "ZAI_NAME"),
            SSDS_ZAIHINBAN: changedValue,
            SSDS_ZAIHINBAN_cd: code,
            ZAI_HINBAN: code
        }, code, rows);
        const normalized = applyMaterialZaiHinbanSelectionToRow(row, code, name);
        Object.assign(row, normalized);
        const node = DicVal(params, "node", null);
        if (!isEmpty(node)) {
            if (typeof node.setData === "function") {
                node.setData(row);
            } else if (!isEmpty(node.data)) {
                Object.assign(node.data, row);
            }
        }
        const api = DicVal(params, "api", GridApi(panelInfo));
        if (!isEmpty(api) && typeof api.refreshCells === "function") {
            api.refreshCells({ rowNodes: isEmpty(node) ? undefined : [node], force: true });
        }
        return true;
    }
    function finalizeMaterialZaiHinbanSelection(panelInfo, params, options = {}) {
        const normalized = normalizeMaterialZaiHinbanAfterGridValueChanged(panelInfo, params);
        const row = DicVal(params, "data", DicVal(DicVal(params, "node", {}), "data", null));
        if (!normalized || isEmpty(row)) return false;
        const existingRow = resolveExistingDetailMasterRow(panelInfo, PANEL_TYPE.MATERIAL_DETAIL, params, row);
        const updatedRow = { ...(existingRow || {}), ...row };
        updatedRow.rowid = normalizeKakousijiUiString(DicVal(existingRow, "rowid", DicVal(row, "rowid", "")));
        Object.assign(updatedRow, recalcMaterialDetailCalcRow(updatedRow));
        const rowIndex = resolveDetailMasterRowIndex(params, GridData(panelInfo));
        const committedGridRows = commitGridRowToRefs(panelInfo, updatedRow, { rowIndex });
        const gridRows = Array.isArray(committedGridRows) ? committedGridRows : (Array.isArray(GridData(panelInfo)) ? GridData(panelInfo) : []);
        const committedDetailRows = commitDetailRowByType(PANEL_TYPE.MATERIAL_DETAIL, updatedRow, { rowIndex });
        const detailRows = Array.isArray(committedDetailRows) ? committedDetailRows : getDetailRowsByPanelType(entrydetailRef.current, PANEL_TYPE.MATERIAL_DETAIL);
        const sourceRows = Array.isArray(detailRows) && detailRows.length !== 0 ? detailRows : (Array.isArray(gridRows) ? gridRows : []);
        const rowIdentityKey = resolveRowIdentityKey(updatedRow);
        const selectedCode = normalizeDetailMasterCode(updatedRow.SSDS_ZAIHINBAN_cd || updatedRow.SSDS_ZAIHINBAN);
        if (selectedCode === "") {
            clearMaterialZaiHinbanCache(updatedRow);
        } else {
            const linkedFields = readMaterialZaiHinbanLinkedFields(updatedRow);
            if (rowIdentityKey !== "") upsertDetailMasterSelectionCacheEntry(materialZaiHinbanSelectionCacheRef, rowIdentityKey, selectedCode, updatedRow.SSDS_ZAIHINBAN_nm, "SSDS_ZAIHINBAN", { linkedFields });
            upsertDetailMasterSelectionCacheEntry(materialZaiHinbanSelectionCacheRef, selectedCode, selectedCode, updatedRow.SSDS_ZAIHINBAN_nm, "SSDS_ZAIHINBAN", { linkedFields });
        }
        syncLinkedDetailPanelsFromGrid(panelInfo, { materialSourceRowsOverride: sourceRows });
        if (!isEmpty(fnc.current) && typeof fnc.current.modify === "function") fnc.current.modify(true);
        if (!isEnabled(DicVal(options, "skipDeferred", false))) {
            const timerKey = `${canonicalPanelType(DicVal(panelInfo, "type", ""))}:${resolveRowIdentityKey(updatedRow)}:SSDS_ZAIHINBAN`;
            const currentTimers = isEmpty(linkedDetailSyncTimerRef.current) ? {} : linkedDetailSyncTimerRef.current;
            const prevTimer = DicVal(currentTimers, timerKey, null);
            if (prevTimer !== null && prevTimer !== undefined) clearTimeout(prevTimer);
            linkedDetailSyncTimerRef.current[timerKey] = setTimeout(() => {
                const latestApi = GridApi(panelInfo);
                let latestRow = updatedRow;
                const rowId = normalizeKakousijiUiString(DicVal(updatedRow, "rowid", ""));
                if (!isEmpty(latestApi) && typeof latestApi.getRowNode === "function" && rowId !== "") {
                    const latestNode = latestApi.getRowNode(rowId);
                    if (!isEmpty(latestNode) && !isEmpty(latestNode.data)) latestRow = latestNode.data;
                }
                const deferredParams = { ...params, data: latestRow, rowdata: latestRow };
                finalizeMaterialZaiHinbanSelection(panelInfo, deferredParams, { skipDeferred: true });
                delete linkedDetailSyncTimerRef.current[timerKey];
            }, 0);
        }
        return Array.isArray(gridRows) ? gridRows : GridData(panelInfo);
    }
    function normalizeAccessoryFuzokuHinbanAfterGridValueChanged(panelInfo, params) {
        const fieldId = accessoryFuzokuHinbanChangedFieldId(panelInfo, params);
        if (fieldId === "") return false;
        const row = DicVal(params, "data", DicVal(DicVal(params, "node", {}), "data", null));
        if (isEmpty(row)) return false;
        if (isExplicitEmptyGridValueChange(params)) {
            const rowBeforeClear = { ...row };
            const cleared = clearAccessoryFuzokuHinbanRow(row);
            clearAccessoryFuzokuHinbanCache(rowBeforeClear);
            Object.assign(row, cleared);
            const node = DicVal(params, "node", null);
            if (!isEmpty(node)) {
                if (typeof node.setData === "function") {
                    node.setData(row);
                } else if (!isEmpty(node.data)) {
                    Object.assign(node.data, row);
                }
            }
            const api = DicVal(params, "api", GridApi(panelInfo));
            if (!isEmpty(api) && typeof api.refreshCells === "function") {
                api.refreshCells({ rowNodes: isEmpty(node) ? undefined : [node], force: true });
            }
            return true;
        }
        const changedValue = DicVal(params, "newValue", DicVal(params, "value", readRowValueIgnoreCase(row, fieldId)));
        const code = readAccessoryFuzokuHinbanCodeFromChange(panelInfo, params, row);
        if (code === "") return false;
        const rows = collectColorwayProductColorGridRows(panelInfo, params);
        const name = resolveAccessoryFuzokuHinbanName({
            SSDF_FUZOKU_HINBAN_nm: readRowValueIgnoreCase(row, "SSDF_FUZOKU_HINBAN_nm"),
            FZK_FUZOKU_NM: readRowValueIgnoreCase(row, "FZK_FUZOKU_NM"),
            SSDF_FUZOKU_HINBAN: changedValue,
            SSDF_FUZOKU_HINBAN_cd: code,
            FZK_FUZOKU_HINBAN: code
        }, code, rows);
        const normalized = applyAccessoryFuzokuHinbanSelectionToRow(row, code, name);
        Object.assign(row, normalized);
        const node = DicVal(params, "node", null);
        if (!isEmpty(node)) {
            if (typeof node.setData === "function") {
                node.setData(row);
            } else if (!isEmpty(node.data)) {
                Object.assign(node.data, row);
            }
        }
        const api = DicVal(params, "api", GridApi(panelInfo));
        if (!isEmpty(api) && typeof api.refreshCells === "function") {
            api.refreshCells({ rowNodes: isEmpty(node) ? undefined : [node], force: true });
        }
        return true;
    }
    function finalizeAccessoryFuzokuHinbanSelection(panelInfo, params, options = {}) {
        const normalized = normalizeAccessoryFuzokuHinbanAfterGridValueChanged(panelInfo, params);
        const row = DicVal(params, "data", DicVal(DicVal(params, "node", {}), "data", null));
        if (!normalized || isEmpty(row)) return false;
        const existingRow = resolveExistingDetailMasterRow(panelInfo, PANEL_TYPE.ACCESSORY_DETAIL, params, row);
        const updatedRow = { ...(existingRow || {}), ...row };
        updatedRow.rowid = normalizeKakousijiUiString(DicVal(existingRow, "rowid", DicVal(row, "rowid", "")));
        Object.assign(updatedRow, recalcAccessoryDetailCalcRow(updatedRow));
        const rowIndex = resolveDetailMasterRowIndex(params, GridData(panelInfo));
        const committedGridRows = commitGridRowToRefs(panelInfo, updatedRow, { rowIndex });
        const gridRows = Array.isArray(committedGridRows) ? committedGridRows : (Array.isArray(GridData(panelInfo)) ? GridData(panelInfo) : []);
        const committedDetailRows = commitDetailRowByType(PANEL_TYPE.ACCESSORY_DETAIL, updatedRow, { rowIndex });
        const detailRows = Array.isArray(committedDetailRows) ? committedDetailRows : getDetailRowsByPanelType(entrydetailRef.current, PANEL_TYPE.ACCESSORY_DETAIL);
        const sourceRows = Array.isArray(detailRows) && detailRows.length !== 0 ? detailRows : (Array.isArray(gridRows) ? gridRows : []);
        const rowIdentityKey = resolveRowIdentityKey(updatedRow);
        const selectedCode = normalizeDetailMasterCode(updatedRow.SSDF_FUZOKU_HINBAN_cd || updatedRow.SSDF_FUZOKU_HINBAN);
        if (selectedCode === "") {
            clearAccessoryFuzokuHinbanCache(updatedRow);
        } else {
            if (rowIdentityKey !== "") upsertDetailMasterSelectionCacheEntry(accessoryFuzokuHinbanSelectionCacheRef, rowIdentityKey, selectedCode, updatedRow.SSDF_FUZOKU_HINBAN_nm, "SSDF_FUZOKU_HINBAN");
            upsertDetailMasterSelectionCacheEntry(accessoryFuzokuHinbanSelectionCacheRef, selectedCode, selectedCode, updatedRow.SSDF_FUZOKU_HINBAN_nm, "SSDF_FUZOKU_HINBAN");
        }
        syncLinkedDetailPanelsFromGrid(panelInfo, { accessorySourceRowsOverride: sourceRows });
        if (!isEmpty(fnc.current) && typeof fnc.current.modify === "function") fnc.current.modify(true);
        if (!isEnabled(DicVal(options, "skipDeferred", false))) {
            const timerKey = `${canonicalPanelType(DicVal(panelInfo, "type", ""))}:${resolveRowIdentityKey(updatedRow)}:SSDF_FUZOKU_HINBAN`;
            const currentTimers = isEmpty(linkedDetailSyncTimerRef.current) ? {} : linkedDetailSyncTimerRef.current;
            const prevTimer = DicVal(currentTimers, timerKey, null);
            if (prevTimer !== null && prevTimer !== undefined) clearTimeout(prevTimer);
            linkedDetailSyncTimerRef.current[timerKey] = setTimeout(() => {
                const latestApi = GridApi(panelInfo);
                let latestRow = updatedRow;
                const rowId = normalizeKakousijiUiString(DicVal(updatedRow, "rowid", ""));
                if (!isEmpty(latestApi) && typeof latestApi.getRowNode === "function" && rowId !== "") {
                    const latestNode = latestApi.getRowNode(rowId);
                    if (!isEmpty(latestNode) && !isEmpty(latestNode.data)) latestRow = latestNode.data;
                }
                const deferredParams = { ...params, data: latestRow, rowdata: latestRow };
                finalizeAccessoryFuzokuHinbanSelection(panelInfo, deferredParams, { skipDeferred: true });
                delete linkedDetailSyncTimerRef.current[timerKey];
            }, 0);
        }
        return Array.isArray(gridRows) ? gridRows : GridData(panelInfo);
    }
    useEffect(() => {
        const current = fnc.current;
        if (isEmpty(current)) return;
        const originalSearchListOpen = current.searchlistopen;
        const originalPostAxios = current.postaxios;
        const wrappedSearchListOpen = typeof originalSearchListOpen === "function"
            ? (payload) => originalSearchListOpen.call(current, wrapSijisuPdtcSearchApply(routeSubSoseiMasterSearchPayload(routeSijisuPdtcMasterSearchPayload(routeMaterialAccessoryMasterSearchPayload(payload)))))
            : null;
        const wrappedPostAxios = typeof originalPostAxios === "function"
            ? (url, param, ...rest) => {
                const normalizedProductColor = normalizeColorwayProductColorGetMasterDataRequest(url, param);
                if (normalizedProductColor.skip) return undefined;
                const normalized = normalizeSsdshColorNoGetMasterDataRequest(normalizedProductColor.url, normalizedProductColor.param);
                if (normalized.skip) return undefined;
                const normalizedSijisuPdtc = normalizeSijisuPdtcGetMasterDataRequest(normalized.url, normalized.param);
                if (normalizedSijisuPdtc.skip) return undefined;
                const normalizedDetailMaster = normalizeDetailMasterGetMasterDataRequest(normalizedSijisuPdtc.url, normalizedSijisuPdtc.param);
                if (normalizedDetailMaster.skip) return undefined;
                const responseWrapped = rest.length === 0
                    ? rest
                    : [wrapDetailMasterSearchListResponseCallback(
                        normalizedDetailMaster.url,
                        normalizedDetailMaster.param,
                        wrapSsdshColorNoSearchListResponseCallback(
                            normalizedDetailMaster.url,
                            normalizedDetailMaster.param,
                            wrapProductColorSearchListResponseCallback(normalizedDetailMaster.url, normalizedDetailMaster.param, rest[0])
                        )
                    ), ...rest.slice(1)];
                return originalPostAxios.call(current, normalizedDetailMaster.url, normalizedDetailMaster.param, ...responseWrapped);
            }
            : null;
        if (wrappedSearchListOpen === null && wrappedPostAxios === null) return;
        if (wrappedSearchListOpen !== null) current.searchlistopen = wrappedSearchListOpen;
        if (wrappedPostAxios !== null) current.postaxios = wrappedPostAxios;
        return () => {
            if (wrappedSearchListOpen !== null && !isEmpty(fnc.current) && fnc.current.searchlistopen === wrappedSearchListOpen) {
                fnc.current.searchlistopen = originalSearchListOpen;
            }
            if (wrappedPostAxios !== null && !isEmpty(fnc.current) && fnc.current.postaxios === wrappedPostAxios) {
                fnc.current.postaxios = originalPostAxios;
            }
        };
    }, [changeurl]);
    useEffect(() => {
        if (!tabsReady) return;
        ensureKakousijiSearchMasterChangeUrl();
    }, [tabsReady, changeurl]);
    useEffect(() => {
        searchlistOpenRef.current = searchlistOpen;
        if (!searchlistOpen) {
            restoreWashStpSearchChangeUrl();
        }
    }, [searchlistOpen]);
    useEffect(() => {
        return () => {
            restoreWashStpSearchChangeUrl();
            restoreKakousijiSearchMasterChangeUrl();
        };
    }, []);
    // =====================================================================
    // 品質表示 118〜125
    // ---------------------------------------------------------------------
    // 品質表示系の各セクションを扱い、保存時は118へ集約する。
    // =====================================================================

    function qualityPanelContentColumnIds(panelType) {
        const type = canonicalPanelType(panelType);
        const map = getQualityPanelFieldMap(type) || {};
        const saveableIds = getSaveableColumnIdSetByPanelType(type);
        const excluded = new Set([
            ROW_ID_FIELD,
            "INDEX",
            "GRIP",
            "EXPAND",
            "ROW_KIND",
            String(DicVal(map, "no", "") ?? ""),
            String(DicVal(map, "item", "") ?? ""),
            String(DicVal(map, "group", "") ?? ""),
            String(DicVal(map, "groupFallback", "") ?? ""),
            String(DicVal(map, "color", "") ?? ""),
            String(DicVal(map, "order", "") ?? ""),
            String(DicVal(map, "invalid", "") ?? "")
        ].map((fieldId) => normalizeColumnIdUpper(fieldId)).filter((fieldId) => fieldId !== ""));
        const fromSaveable = [...saveableIds]
            .map((fieldId) => String(fieldId ?? "").trim())
            .filter((fieldId) => {
                const cid = normalizeColumnIdUpper(fieldId);
                return cid !== "" && !excluded.has(cid) && !isKakousijiSavePayloadUiOnlyField(fieldId, type);
            });
        if (fromSaveable.length !== 0) return fromSaveable;
        return [];
    }
    function qualityRepresentativeContentKey(row, panelType) {
        const type = canonicalPanelType(panelType);
        const map = getQualityPanelFieldMap(type) || {};
        const orderValue = normalizeKakousijiUiString(readRowValueIgnoreCase(row, map.order));
        const contentColumnIds = qualityPanelContentColumnIds(type);
        const contentKeys = contentColumnIds.length !== 0
            ? contentColumnIds
            : Object.keys(row || {}).filter((key) => {
                const cid = normalizeColumnIdUpper(key);
                if (cid === "" || cid === "ROWID" || cid === "GRIP" || cid === "EXPAND" || cid === "ROW_KIND") return false;
                if (cid === normalizeColumnIdUpper(DicVal(map, "no", ""))) return false;
                if (cid === normalizeColumnIdUpper(DicVal(map, "item", ""))) return false;
                if (cid === normalizeColumnIdUpper(DicVal(map, "group", ""))) return false;
                if (cid === normalizeColumnIdUpper(DicVal(map, "groupFallback", ""))) return false;
                if (cid === normalizeColumnIdUpper(DicVal(map, "color", ""))) return false;
                if (cid === normalizeColumnIdUpper(DicVal(map, "order", ""))) return false;
                if (cid === normalizeColumnIdUpper(DicVal(map, "invalid", ""))) return false;
                return !isKakousijiSavePayloadUiOnlyField(key, type);
            });
        const contentPart = [...new Set(contentKeys.map((key) => String(key ?? "").trim()).filter((key) => key !== ""))]
            .sort((a, b) => a.localeCompare(b))
            .map((key) => `${normalizeColumnIdUpper(key)}=${normalizeKakousijiUiString(readRowValueIgnoreCase(row, key))}`)
            .join("\u001f");
        return `${type}\u001f${orderValue}\u001f${contentPart}`;
    }
    function qualityRowsForContext(rows, panelType, contextOverride) {
        const context = normalizeFukushizaiContext(contextOverride);
        if (context.itemCd === "" || context.groupNo === "") return [];
        return (Array.isArray(rows) ? rows : []).filter((row) => {
            if (isEmpty(row) || isInvalidDisplayRow(row, panelType)) return false;
            const rowContext = readFukushizaiItemGroupFromAnyRow(row);
            return rowContext.hasItemGroupKey === true
                && rowContext.itemCd === context.itemCd
                && rowContext.groupNo === context.groupNo
                && rowContext.colorCd !== "";
        });
    }
    function qualityRepresentativeColorForContext(contextOverride, rows = [], panelType = "") {
        const context = normalizeFukushizaiContext(contextOverride);
        if (context.itemCd === "" || context.groupNo === "") return "";
        const selectedColor = normalizeColorCd(context.colorCd);
        if (selectedColor !== "") return selectedColor;
        const colors = qualityTargetColorsForContext(context, rows, panelType);
        return colors.length === 0 ? "" : colors[0];
    }
    function qualityTargetColorsForContext(contextOverride, rows = [], panelType = "") {
        const context = normalizeFukushizaiContext(contextOverride);
        const seen = new Set();
        const add = (value) => {
            const color = normalizeColorCd(value);
            if (color === "" || seen.has(color)) return;
            seen.add(color);
        };
        // 品質表示のカラー集合は品質detail行(118-124)から導出する。
        // 副資材(113)の色構成を参照すると、品質側でのカラー削減が保存時の行展開で
        // 副資材の色構成へ引き戻される(分割管理が壊れる)ため、参照しない。
        getQualityDetailGroupContexts(context.itemCd)
            .filter((rowContext) => rowContext.groupNo === context.groupNo)
            .forEach((rowContext) => add(rowContext.colorCd));
        (Array.isArray(rows) ? rows : []).forEach((row) => {
            if (!rowMatchesFukushizaiItemGroup(row, context.itemCd, context.groupNo)) return;
            if (panelType !== "" && isInvalidDisplayRow(row, panelType)) return;
            add(readFukushizaiItemGroupFromAnyRow(row).colorCd);
        });
        add(context.colorCd);
        return [...seen];
    }
    function createQualityEmptyDisplayRow(panelType, contextOverride, representativeColor, targetColors = []) {
        const type = canonicalPanelType(panelType);
        const context = normalizeFukushizaiContext(contextOverride);
        const row = { [ROW_ID_FIELD]: "0" };
        setRowContextForPanel(row, type, context.itemCd, context.groupNo, representativeColor);
        const map = getQualityPanelFieldMap(type) || {};
        const orderField = String(DicVal(map, "order", "") ?? "").trim();
        if (orderField !== "") row[orderField] = "1";
        const displayRow = normalizeQualityDisplayRowForPanel(row, type);
        return {
            ...displayRow,
            __QUALITY_PANEL_TYPE: type,
            __QUALITY_EMPTY_INPUT_ROW: true,
            __QUALITY_TARGET_ITEM: context.itemCd,
            __QUALITY_TARGET_GROUP: context.groupNo,
            __QUALITY_TARGET_COLORS: targetColors,
            __QUALITY_SOURCE_COLOR: normalizeColorCd(representativeColor)
        };
    }
    // 品質表示の代表色行を画面表示用に組み立てる。
    function buildQualityRepresentativeDisplayRows(rows, panelType, contextOverride) {
        const type = canonicalPanelType(panelType);
        if (!isQualityPanelType(type)) return Array.isArray(rows) ? rows : [];
        const context = normalizeFukushizaiContext(contextOverride);
        if (context.itemCd === "" || context.groupNo === "") return [];
        const contextRows = qualityRowsForContext(rows, type, context);
        const targetColors = qualityTargetColorsForContext(context, contextRows, type);
        const representativeColor = qualityRepresentativeColorForContext(context, contextRows, type);
        const representativeRows = contextRows.filter((row) => readFukushizaiItemGroupFromAnyRow(row).colorCd === representativeColor);
        if (representativeRows.length === 0) {
            return [createQualityEmptyDisplayRow(type, context, representativeColor, targetColors)];
        }
        const colorOrder = new Map(targetColors.map((colorCd, index) => [colorCd, index]));
        const selectedColor = normalizeColorCd(context.colorCd);
        const sortedRows = [...representativeRows].sort((a, b) => {
            const ac = readFukushizaiItemGroupFromAnyRow(a).colorCd;
            const bc = readFukushizaiItemGroupFromAnyRow(b).colorCd;
            if (selectedColor !== "" && ac !== bc) {
                if (ac === selectedColor) return -1;
                if (bc === selectedColor) return 1;
            }
            const ai = colorOrder.has(ac) ? colorOrder.get(ac) : 9999;
            const bi = colorOrder.has(bc) ? colorOrder.get(bc) : 9999;
            if (ai !== bi) return ai - bi;
            const orderField = String(DicVal(getQualityPanelFieldMap(type), "order", "") ?? "").trim();
            const ao = Number(normalizeKakousijiUiString(readRowValueIgnoreCase(a, orderField)));
            const bo = Number(normalizeKakousijiUiString(readRowValueIgnoreCase(b, orderField)));
            if (Number.isFinite(ao) && Number.isFinite(bo) && ao !== bo) return ao - bo;
            return normalizeKakousijiUiString(DicVal(a, ROW_ID_FIELD, "")).localeCompare(normalizeKakousijiUiString(DicVal(b, ROW_ID_FIELD, "")), "ja", { numeric: true });
        });
        const seen = new Set();
        const out = [];
        sortedRows.forEach((row, index) => {
            const key = qualityRepresentativeContentKey(row, type);
            if (seen.has(key)) return;
            seen.add(key);
            const rowContext = readFukushizaiItemGroupFromAnyRow(row);
            const displayRow = normalizeQualityDisplayRowForPanel(row, type);
            const next = {
                ...displayRow,
                __QUALITY_PANEL_TYPE: type,
                __QUALITY_SOURCE_KEYS: key,
                __QUALITY_TARGET_ITEM: context.itemCd,
                __QUALITY_TARGET_GROUP: context.groupNo,
                __QUALITY_TARGET_COLORS: targetColors,
                __QUALITY_SOURCE_COLOR: rowContext.colorCd
            };
            if (normalizeKakousijiUiString(DicVal(next, ROW_ID_FIELD, "")) === "") next[ROW_ID_FIELD] = String(index);
            out.push(next);
        });
        return out;
    }
    function setRowContextForPanel(row, panelType, itemCd, groupNo, colorCd) {
        if (isEmpty(row) || typeof row !== "object") return row;
        const type = canonicalPanelType(panelType);
        const item = normalizeItemCd(itemCd);
        const group = normalizeGroupNo(groupNo);
        const color = normalizeColorCd(colorCd);
        if (type === FUKUSHIZAI_BASE_PANEL_TYPE) {
            row[FUKUSHIZAI_FIELD.NO] = readCurrentFukushizaiNo();
            row[FUKUSHIZAI_FIELD.ITEM_CD] = item;
            row[FUKUSHIZAI_FIELD.GROUP_NO] = group;
            row[FUKUSHIZAI_FIELD.COLOR_CD] = color;
            return row;
        }
        const map = getQualityPanelFieldMap(type);
        if (isEmpty(map)) return row;
        if (!isEmpty(DicVal(map, "no", ""))) row[map.no] = readCurrentFukushizaiNo();
        row[map.item] = item;
        row[map.group] = group;
        if (!isEmpty(DicVal(map, "groupFallback", ""))) delete row[map.groupFallback];
        row[map.color] = color;
        const orderField = String(DicVal(map, "order", "") ?? "").trim();
        if (orderField !== "" && normalizeKakousijiUiString(readRowValueIgnoreCase(row, orderField)) === "") {
            // 表示順はDBの数値列。Grid が採番する行ID（"GID17_123_1i40umu727o" 等）を入れると
            // 数値列に文字列が渡り、列名として解釈されて SQL エラーになる。
            const rowId = normalizeKakousijiUiString(DicVal(row, ROW_ID_FIELD, ""));
            row[orderField] = /^\d+$/.test(rowId) ? rowId : "1";
        }
        if (!isEmpty(DicVal(map, "invalid", ""))) row[map.invalid] = "0";
        return row;
    }
    function markQualityRowsInvalidByColor(itemCd, groupNo, colorCodes = null) {
        const item = normalizeItemCd(itemCd);
        const group = normalizeGroupNo(groupNo);
        const colorSet = Array.isArray(colorCodes)
            ? new Set(colorCodes.map((value) => normalizeColorCd(value)).filter((value) => value !== ""))
            : null;
        if (item === "" || group === "") return false;
        let changed = false;
        QUALITY_DISPLAY_PANEL_TYPES.forEach((panelType) => {
            const invalidField = getQualityInvalidField(panelType);
            if (invalidField === "") return;
            const detail = ensureDetailRowsByTypeForMutation(panelType);
            const rows = Array.isArray(detail.rows) ? detail.rows : [];
            let detailChanged = false;
            const nextRows = rows.map((row) => {
                if (!rowMatchesFukushizaiItemGroup(row, item, group)) return row;
                if (colorSet !== null && !colorSet.has(readFukushizaiItemGroupFromAnyRow(row).colorCd)) return row;
                if (String(readRowValueIgnoreCase(row, invalidField) ?? "").trim() === "1") return row;
                const next = { ...row, [invalidField]: "1" };
                detailChanged = true;
                return next;
            });
            if (detailChanged) {
                entrydetailRef.current[detail.key] = nextRows;
                changed = true;
            }
        });
        return changed;
    }
    function filterRowsBySelectedColors(rows, itemCd, groupNo, selectedColorCodes) {
        const colorSet = new Set((Array.isArray(selectedColorCodes) ? selectedColorCodes : []).map((value) => normalizeColorCd(value)).filter((value) => value !== ""));
        return (Array.isArray(rows) ? rows : []).filter((row) => {
            if (!rowMatchesFukushizaiItemGroup(row, itemCd, groupNo)) return true;
            return colorSet.has(readFukushizaiItemGroupFromAnyRow(row).colorCd);
        });
    }
    function nextDetailRowIdForRows(rows) {
        const nums = (Array.isArray(rows) ? rows : [])
            .map((row) => Number(String(DicVal(row, ROW_ID_FIELD, "") ?? "").trim()))
            .filter((value) => Number.isFinite(value) && value >= 0);
        return nums.length === 0 ? 0 : Math.max(...nums) + 1;
    }
    function expandRowsToAddedColors(rows, panelType, itemCd, groupNo, selectedColorCodes) {
        const source = Array.isArray(rows) ? rows : [];
        const selectedColors = [...new Set((Array.isArray(selectedColorCodes) ? selectedColorCodes : []).map((value) => normalizeColorCd(value)).filter((value) => value !== ""))];
        if (selectedColors.length === 0) return { rows: source, changed: false };
        const contextRows = source.filter((row) => rowMatchesFukushizaiItemGroup(row, itemCd, groupNo) && !isInvalidDisplayRow(row, panelType));
        if (contextRows.length === 0) return { rows: source, changed: false };
        const existingColors = new Set(contextRows.map((row) => readFukushizaiItemGroupFromAnyRow(row).colorCd).filter((value) => value !== ""));
        const addColors = selectedColors.filter((color) => !existingColors.has(color));
        if (addColors.length === 0) return { rows: source, changed: false };
        const templateColor = readFukushizaiItemGroupFromAnyRow(contextRows[0]).colorCd;
        const templateRows = contextRows.filter((row) => readFukushizaiItemGroupFromAnyRow(row).colorCd === templateColor);
        if (templateRows.length === 0) return { rows: source, changed: false };
        let nextRowId = nextDetailRowIdForRows(source);
        const additions = [];
        addColors.forEach((colorCd) => {
            templateRows.forEach((row) => {
                const next = DeepCopy(row);
                next[ROW_ID_FIELD] = String(nextRowId++);
                setRowContextForPanel(next, panelType, itemCd, groupNo, colorCd);
                additions.push(next);
            });
        });
        return { rows: [...source, ...additions], changed: additions.length !== 0 };
    }
    function clearQualityDisplayRowValues(row, panelType) {
        if (isEmpty(row) || typeof row !== "object") return { row, changed: false };
        const out = { ...row };
        const colIds = getVisibleOrKnownColumnIds(panelType);
        const preserve = new Set([
            "ROWID", "GRIP", "EXPAND", "ROW_KIND",
            "SSDZ_NO", "SSD_NO", "NO",
            "SSDZ_ITMCITEMCD", "SSDQ_ITMCITEMCD", "SSDH_ITMCITEMCD", "SSDY_ITMCITEMCD", "SSDB_ITMCITEMCD", "SSDD_ITMCITEMCD", "SSDE_ITMCITEMCD",
            "SSDQ_GROUPNO", "SSDH_GROUPNO", "SSDY_GROUPNO", "SSDB_GROUPNO", "SSDD_GROUPNO", "SSDE_GROUPNO",
            "SSDZ_FUKUSIZAICOLORGRP", "SSDQ_FUKUSIZAICOLORGRP", "SSDH_FUKUSIZAICOLORGRP", "SSDY_FUKUSIZAICOLORGRP", "SSDB_FUKUSIZAICOLORGRP", "SSDD_FUKUSIZAICOLORGRP", "SSDE_FUKUSIZAICOLORGRP",
            "SSDZ_COLORCD", "SSDQ_COLORCD", "SSDH_COLORCD", "SSDY_COLORCD", "SSDB_COLORCD", "SSDD_COLORCD", "SSDE_COLORCD",
            "ITEM", "ITEMCD", "GROUP", "GROUPNO", "COLOR", "COLORCD"
        ]);
        let changed = false;
        const targetKeys = colIds.length === 0 ? Object.keys(out) : colIds;
        targetKeys.forEach((key) => {
            const cid = normalizeColumnIdUpper(key);
            if (cid === "" || preserve.has(cid)) return;
            if (cid.endsWith("_NO") || cid.endsWith("_GYONO") || cid.endsWith("_ROWID")) return;
            if (!Object.prototype.hasOwnProperty.call(out, key)) return;
            if (String(out[key] ?? "").trim() === "") return;
            out[key] = "";
            changed = true;
        });
        return { row: out, changed };
    }
    function clearQualityDisplayRowsForContext(itemCd, groupNo) {
        return markQualityRowsInvalidByColor(itemCd, groupNo, null);
    }
    // ---------------------------------------------------------------------
    // 品質表示側のグループ追加/削除/編集(副資材とは独立)
    // ---------------------------------------------------------------------
    function refreshAfterQualityGroupMutation(itemCd, groupNo) {
        refreshQualityContextSelection({ itemCd, groupNo });
        scheduleFukushizaiSectionGridRepaint();
        if (!isEmpty(fnc.current) && typeof fnc.current.modify === "function") fnc.current.modify(true);
        rerender();
    }
    function applyQualityGroupAddFromDialog() {
        const dialog = groupDialogState;
        const itemCd = normalizeKakousijiUiString(dialog.itemCd || selectedQualityItem);
        const groupNo = normalizeEditableGroupNo(dialog.groupNo);
        const colorCodes = checkedGroupDialogColorCodes();
        if (itemCd === "" || groupNo === "") return false;
        if (getKnownQualityGroupNos(itemCd).indexOf(groupNo) !== -1) return false;

        setQualityGroupOptions((prev) => [...new Set([...(Array.isArray(prev) ? prev : []), `${itemCd}|${groupNo}`])]);
        if (colorCodes.length !== 0) {
            ensureQualityBaseKeyRowsForColors(itemCd, groupNo, colorCodes);
        }
        refreshAfterQualityGroupMutation(itemCd, groupNo);
        return true;
    }
    function applyQualityGroupDelete(itemCd, groupNo) {
        const item = normalizeItemCd(itemCd || selectedQualityItem);
        const group = normalizeGroupNo(groupNo || selectedQualityGroup);
        if (item === "" || group === "") return false;

        const changed = clearQualityDisplayRowsForContext(item, group);
        setQualityGroupOptions((prev) => (Array.isArray(prev) ? prev : []).filter((key) => key !== `${item}|${group}`));
        // 削除後は残っているグループのうち次候補へ移動する。
        const remaining = getKnownQualityGroupNos(item).filter((value) => value !== group);
        const nextGroup = remaining.find((value) => Number(value) > Number(group)) || remaining[remaining.length - 1] || "";
        refreshAfterQualityGroupMutation(item, nextGroup);
        return changed;
    }
    function applyQualityGroupEditFromDialog() {
        const dialog = groupDialogState;
        const itemCd = normalizeItemCd(dialog.itemCd || selectedQualityItem);
        const groupNo = normalizeGroupNo(dialog.groupNo || selectedQualityGroup);
        const checkedColorsList = checkedGroupDialogColorCodes();
        if (itemCd === "" || groupNo === "") return false;

        const snapshotRowsByPanel = QUALITY_DISPLAY_PANEL_TYPES.reduce((acc, panelType) => {
            acc[panelType] = DeepCopy(sourceRowsForCopy(panelType, itemCd, groupNo));
            return acc;
        }, {});
        let changed = false;
        QUALITY_DISPLAY_PANEL_TYPES.forEach((panelType) => {
            if (rebuildQualityRowsForEditedGroup(panelType, itemCd, groupNo, snapshotRowsByPanel[panelType], checkedColorsList)) {
                changed = true;
            }
        });
        // 行が無いグループ(追加直後)に色を付けた場合はBASEキー行を補完する。
        if (!changed && checkedColorsList.length !== 0) {
            changed = ensureQualityBaseKeyRowsForColors(itemCd, groupNo, checkedColorsList);
        }
        if (!changed) return false;
        refreshAfterQualityGroupMutation(itemCd, groupNo);
        return true;
    }
    // ---------------------------------------------------------------------
    // 品質表示側のアイテム追加/削除(タブ候補は品質detail行+追加/seedアイテムから導出)
    // ---------------------------------------------------------------------
    function getKnownQualityItemCds() {
        const seen = new Set();
        const out = [];
        getQualityDetailGroupContexts("").forEach((context) => {
            const itemCd = normalizeItemCd(context.itemCd);
            if (itemCd === "" || seen.has(itemCd)) return;
            seen.add(itemCd);
            out.push(itemCd);
        });
        return out;
    }
    function resolveItemMasterName(itemCd) {
        const code = normalizeItemCd(itemCd);
        if (code === "") return "";
        const masterHit = (Array.isArray(itemNameMasterListRef.current) ? itemNameMasterListRef.current : [])
            .find((option) => normalizeItemCd(DicVal(option, "code", "")) === code);
        if (!isEmpty(masterHit)) return String(DicVal(masterHit, "name", "") ?? "").trim();
        const layoutHit = (Array.isArray(fukushizaiItemMasterOptions) ? fukushizaiItemMasterOptions : [])
            .find((option) => getNamedOptionCode(option) === code);
        return isEmpty(layoutHit) ? "" : getNamedOptionName(layoutHit);
    }
    // 品質表示スコープのアイテムタブ候補。副資材(D_SSDZ)由来の候補とは独立して、
    // 品質detail行の使用アイテム+このセッションで追加/seedしたアイテムのみを返す。
    function getQualityItemTabOptions() {
        const seen = new Set();
        const out = [];
        const push = (code, name) => {
            const normalized = normalizeItemCd(code);
            if (normalized === "" || seen.has(normalized)) return;
            seen.add(normalized);
            out.push({ code: normalized, name: String(name ?? "").trim() || resolveItemMasterName(normalized) });
        };
        getKnownQualityItemCds().forEach((code) => push(code, ""));
        (Array.isArray(qualityItemOptions) ? qualityItemOptions : []).forEach((option) => push(DicVal(option, "code", ""), DicVal(option, "name", "")));
        return out.sort((a, b) => a.code.localeCompare(b.code, "ja", { numeric: true }));
    }
    function ensureItemNameMasterList(callback) {
        if (Array.isArray(itemNameMasterListRef.current)) {
            if (typeof callback === "function") callback(true, itemNameMasterListRef.current);
            return;
        }
        fnc.current.postaxios(ITEM_NAME_MASTER_LIST_URL, { controller }, {
            onSuccess: function (data) {
                try {
                    const items = extractQualityHsituhabaResolveItems(data)
                        .map((row) => ({
                            code: normalizeItemCd(DicVal(row, "code", "")),
                            name: String(DicVal(row, "name", "") ?? "").trim()
                        }))
                        .filter((row) => row.code !== "");
                    itemNameMasterListRef.current = items;
                    // seed/追加済みアイテム(両ドメイン)のうち名称未解決のものへ名称を補完する。
                    const hydrateNames = (list) => (Array.isArray(list) ? list : []).map((option) => {
                        if (String(DicVal(option, "name", "") ?? "").trim() !== "") return option;
                        const hit = items.find((item) => item.code === normalizeItemCd(DicVal(option, "code", "")));
                        return isEmpty(hit) ? option : { ...option, name: hit.name };
                    });
                    setQualityItemOptions((prev) => {
                        const next = hydrateNames(prev);
                        qualityItemOptionsRef.current = next;
                        return next;
                    });
                    setFukushizaiItemAddedOptions((prev) => {
                        const next = hydrateNames(prev);
                        fukushizaiItemAddedOptionsRef.current = next;
                        return next;
                    });
                    if (typeof callback === "function") callback(true, items);
                } finally {
                    if (!isEmpty(fnc.current)) fnc.current.wait(false);
                }
            },
            onError: function () {
                try {
                    if (typeof fnc.current?.warnmsg === "function") fnc.current.warnmsg("アイテム名称マスタの取得に失敗しました。");
                    if (typeof callback === "function") callback(false, []);
                } finally {
                    if (!isEmpty(fnc.current)) fnc.current.wait(false);
                }
            }
        });
    }
    // 品質detail(118-124)にアイテム/グループを持つ行が無い場合、既定アイテム00をseedして選択する。
    // seedはUI状態のみで、行(D_SSDQ等)はグループ追加や単票入力の確定時に作られる。
    function seedDefaultQualityItemIfNeeded() {
        if (getKnownQualityItemCds().length !== 0) return false;
        if ((Array.isArray(qualityItemOptionsRef.current) ? qualityItemOptionsRef.current : []).length !== 0) return false;
        // 名称マスタ未取得(新規作成等)なら取得してseedアイテムの名称を補完する。
        if (!Array.isArray(itemNameMasterListRef.current)) ensureItemNameMasterList();
        // __seeded=trueの行は自動seed由来の目印。ロード後にデータ側アイテムが見つかった場合だけ自動撤去する。
        const seeded = [{ code: DEFAULT_ITEM_TAB_CD, name: resolveItemMasterName(DEFAULT_ITEM_TAB_CD), __seeded: true }];
        qualityItemOptionsRef.current = seeded;
        setQualityItemOptions(seeded);
        setSelectedQualityItem(DEFAULT_ITEM_TAB_CD);
        setSelectedQualityGroup("");
        updateSelectedQualityContext({ itemCd: DEFAULT_ITEM_TAB_CD, groupNo: "", colorCd: "" });
        return true;
    }
    // ロード完了後のseed整合: データ側にアイテムがあればseed済み既定アイテムを撤去し、
    // 無ければ既定アイテム00をseedする。
    function syncDefaultQualityItemAfterLoad() {
        if (getKnownQualityItemCds().length === 0) {
            seedDefaultQualityItemIfNeeded();
            return;
        }
        const current = Array.isArray(qualityItemOptionsRef.current) ? qualityItemOptionsRef.current : [];
        // ユーザーが[+]で明示追加したアイテムは撤去しない(自動seed分のみ対象)。
        if (current.length === 1
            && normalizeItemCd(DicVal(current[0], "code", "")) === DEFAULT_ITEM_TAB_CD
            && !!DicVal(current[0], "__seeded", false)) {
            qualityItemOptionsRef.current = [];
            setQualityItemOptions([]);
        }
    }
    // 対象ドメインで既にタブ候補になっているアイテムコード集合(追加ダイアログの除外用)。
    function knownItemTabCdsByDomain(domain) {
        if (domain === "quality") {
            return new Set([
                ...getKnownQualityItemCds(),
                ...(Array.isArray(qualityItemOptionsRef.current) ? qualityItemOptionsRef.current : [])
                    .map((option) => normalizeItemCd(DicVal(option, "code", "")))
            ]);
        }
        return new Set([
            ...(Array.isArray(fukushizaiItemMasterOptions) ? fukushizaiItemMasterOptions : [])
                .map((option) => normalizeItemCd(getNamedOptionCode(option))),
            ...(Array.isArray(fukushizaiItemAddedOptionsRef.current) ? fukushizaiItemAddedOptionsRef.current : [])
                .map((option) => normalizeItemCd(DicVal(option, "code", "")))
        ]);
    }
    function emptySangenDialogState() {
        return { open: false, loading: false, header: {}, sizes: [], rows: [] };
    }
    function closeSangenDisplayDialog() {
        sangenDisplayRequestNoRef.current += 1;
        setSangenDialogState(emptySangenDialogState());
    }
    function openSangenDisplayDialog() {
        const oppiCd = normalizeKakousijiUiString(readRowValueIgnoreCase(entrydataRef.current, "SSD_OPPICD"));
        if (oppiCd === "") {
            fnc.current.warnmsg("PS品番を入力してください。");
            return;
        }
        if (sangenDialogState.loading) return;

        const requestNo = sangenDisplayRequestNoRef.current + 1;
        sangenDisplayRequestNoRef.current = requestNo;
        setSangenDialogState({ open: true, loading: true, header: {}, sizes: [], rows: [] });
        fnc.current.postaxios(sangenDisplayUrl, {
            corpkey,
            account,
            oppiCd
        }, {
            onSuccess: function (data) {
                try {
                    if (sangenDisplayRequestNoRef.current !== requestNo) return;
                    if (!DicVal(data, "productFound", false)) {
                        setSangenDialogState(emptySangenDialogState());
                        fnc.current.warnmsg("品番が存在しません。PS品番[" + oppiCd + "]");
                        return;
                    }
                    setSangenDialogState({
                        open: true,
                        loading: false,
                        header: DicVal(data, "header", {}) || {},
                        sizes: Array.isArray(DicVal(data, "sizes", [])) ? DicVal(data, "sizes", []) : [],
                        rows: Array.isArray(DicVal(data, "rows", [])) ? DicVal(data, "rows", []) : []
                    });
                } finally {
                    if (!isEmpty(fnc.current)) fnc.current.wait(false);
                }
            },
            onError: function (data) {
                try {
                    if (sangenDisplayRequestNoRef.current !== requestNo) return;
                    setSangenDialogState(emptySangenDialogState());
                    const message = normalizeKakousijiUiString(DicVal(data, "errDescription", "")) || "三元表記の取得に失敗しました。";
                    fnc.current.warnmsg(message);
                } finally {
                    if (!isEmpty(fnc.current)) fnc.current.wait(false);
                }
            }
        });
    }
    function openItemTabActionDialog(domain, mode, itemCd = "") {
        const normalizedDomain = domain === "quality" ? "quality" : "fukushizai";
        if (mode === "add") {
            setItemTabDialogState({ open: true, domain: normalizedDomain, mode: "add", itemCd: "", options: [], loading: true });
            ensureItemNameMasterList((ok, items) => {
                if (!ok) {
                    closeItemTabActionDialog();
                    return;
                }
                const knownCds = knownItemTabCdsByDomain(normalizedDomain);
                const options = items
                    .filter((item) => !knownCds.has(item.code))
                    .map((item) => ({ ...item, checked: false }));
                setItemTabDialogState({ open: true, domain: normalizedDomain, mode: "add", itemCd: "", options, loading: false });
            });
            return;
        }
        const target = normalizeItemCd(itemCd || (normalizedDomain === "quality" ? selectedQualityItem : selectedSetItem));
        if (target === "") return;
        setItemTabDialogState({ open: true, domain: normalizedDomain, mode: "delete", itemCd: target, options: [], loading: false });
    }
    function closeItemTabActionDialog() {
        setItemTabDialogState({ open: false, domain: "", mode: "", itemCd: "", options: [], loading: false });
    }
    function updateItemTabDialogChecked(code, checked) {
        const target = normalizeItemCd(code);
        setItemTabDialogState((prev) => ({
            ...prev,
            options: (Array.isArray(prev.options) ? prev.options : []).map((option) =>
                normalizeItemCd(DicVal(option, "code", "")) === target ? { ...option, checked: !!checked } : option)
        }));
    }
    function applyItemTabAddFromDialog() {
        const dialog = itemTabDialogState;
        const isQuality = dialog.domain === "quality";
        const selected = (Array.isArray(dialog.options) ? dialog.options : [])
            .filter((option) => !!DicVal(option, "checked", false))
            .map((option) => ({
                code: normalizeItemCd(DicVal(option, "code", "")),
                name: String(DicVal(option, "name", "") ?? "").trim()
            }))
            .filter((option) => option.code !== "");
        if (selected.length === 0) return false;
        const targetRef = isQuality ? qualityItemOptionsRef : fukushizaiItemAddedOptionsRef;
        const setTargetOptions = isQuality ? setQualityItemOptions : setFukushizaiItemAddedOptions;
        const next = [...(Array.isArray(targetRef.current) ? targetRef.current : [])];
        selected.forEach((option) => {
            if (next.some((item) => normalizeItemCd(DicVal(item, "code", "")) === option.code)) return;
            next.push(option);
        });
        targetRef.current = next;
        setTargetOptions(next);
        // 先頭の追加アイテムを選択状態にする(グループは未作成のため空のまま)。
        if (isQuality) {
            refreshQualityContextSelection({ itemCd: selected[0].code, groupNo: "" });
        } else {
            refreshFukushizaiContextSelection({ itemCd: selected[0].code, groupNo: "" });
        }
        rerender();
        return true;
    }
    function applyQualityItemDelete(itemCd) {
        const item = normalizeItemCd(itemCd || selectedQualityItem);
        if (item === "") return false;
        let changed = false;
        getKnownQualityGroupNos(item).forEach((groupNo) => {
            if (clearQualityDisplayRowsForContext(item, groupNo)) changed = true;
        });
        setQualityGroupOptions((prev) => (Array.isArray(prev) ? prev : []).filter((key) => !String(key ?? "").startsWith(`${item}|`)));
        const nextItems = (Array.isArray(qualityItemOptionsRef.current) ? qualityItemOptionsRef.current : [])
            .filter((option) => normalizeItemCd(DicVal(option, "code", "")) !== item);
        qualityItemOptionsRef.current = nextItems;
        setQualityItemOptions(nextItems);
        // 次のアイテムへ移動する。残りが無ければ既定アイテム00をseedし直す。
        const remaining = [...new Set([
            ...getKnownQualityItemCds(),
            ...nextItems.map((option) => normalizeItemCd(DicVal(option, "code", "")))
        ])].filter((code) => code !== "" && code !== item);
        if (remaining.length === 0) {
            const seeded = [{ code: DEFAULT_ITEM_TAB_CD, name: resolveItemMasterName(DEFAULT_ITEM_TAB_CD), __seeded: true }];
            qualityItemOptionsRef.current = seeded;
            setQualityItemOptions(seeded);
            refreshAfterQualityGroupMutation(DEFAULT_ITEM_TAB_CD, "");
        } else {
            const nextItem = remaining[0];
            refreshAfterQualityGroupMutation(nextItem, getKnownQualityGroupNos(nextItem)[0] || "");
        }
        return changed;
    }
    // 副資材スコープのアイテムタブ候補(D_SSDZ由来のロード候補+セッション追加/seedアイテム)。
    function getFukushizaiItemTabOptions() {
        const seen = new Set();
        const out = [];
        const push = (code, name) => {
            const normalized = normalizeItemCd(code);
            if (normalized === "" || seen.has(normalized)) return;
            seen.add(normalized);
            out.push({ code: normalized, name: String(name ?? "").trim() || resolveItemMasterName(normalized) });
        };
        (Array.isArray(fukushizaiItemMasterOptions) ? fukushizaiItemMasterOptions : []).forEach((option) => push(getNamedOptionCode(option), getNamedOptionName(option)));
        (Array.isArray(fukushizaiItemAddedOptions) ? fukushizaiItemAddedOptions : []).forEach((option) => push(DicVal(option, "code", ""), DicVal(option, "name", "")));
        return out.sort((a, b) => a.code.localeCompare(b.code, "ja", { numeric: true }));
    }
    // 副資材候補(D_SSDZ由来)が空の場合、既定アイテム00をseedして選択する(品質側と同じ方式)。
    function seedDefaultFukushizaiItemIfNeeded(masterOptions = null) {
        const master = Array.isArray(masterOptions) ? masterOptions : (Array.isArray(fukushizaiItemMasterOptions) ? fukushizaiItemMasterOptions : []);
        if (master.some((option) => normalizeItemCd(getNamedOptionCode(option)) !== "")) return false;
        if ((Array.isArray(fukushizaiItemAddedOptionsRef.current) ? fukushizaiItemAddedOptionsRef.current : []).length !== 0) return false;
        if (!Array.isArray(itemNameMasterListRef.current)) ensureItemNameMasterList();
        const seeded = [{ code: DEFAULT_ITEM_TAB_CD, name: resolveItemMasterName(DEFAULT_ITEM_TAB_CD), __seeded: true }];
        fukushizaiItemAddedOptionsRef.current = seeded;
        setFukushizaiItemAddedOptions(seeded);
        setSelectedSetItem(DEFAULT_ITEM_TAB_CD);
        setSelectedGroup("");
        updateSelectedFukushizaiContext({ itemCd: DEFAULT_ITEM_TAB_CD, groupNo: "", colorCd: "" });
        return true;
    }
    // ロード完了後のseed整合(副資材): ロード候補が空ならseed、あれば自動seed分を撤去する。
    function syncDefaultFukushizaiItemAfterLoad(masterOptions) {
        const master = Array.isArray(masterOptions) ? masterOptions : [];
        if (!master.some((option) => normalizeItemCd(getNamedOptionCode(option)) !== "")) {
            seedDefaultFukushizaiItemIfNeeded(master);
            return;
        }
        const current = Array.isArray(fukushizaiItemAddedOptionsRef.current) ? fukushizaiItemAddedOptionsRef.current : [];
        // ユーザーが[+]で明示追加したアイテムは撤去しない(自動seed分のみ対象)。
        if (current.length === 1
            && normalizeItemCd(DicVal(current[0], "code", "")) === DEFAULT_ITEM_TAB_CD
            && !!DicVal(current[0], "__seeded", false)) {
            fukushizaiItemAddedOptionsRef.current = [];
            setFukushizaiItemAddedOptions([]);
        }
    }
    // 副資材アイテムの削除: 対象アイテムの全グループの113行/登録グループ行を削除する。
    function applyFukushizaiItemDelete(itemCd) {
        const item = normalizeItemCd(itemCd || selectedSetItem);
        if (item === "") return false;
        let changed = false;
        getKnownFukushizaiGroupNos(item).forEach((groupNo) => {
            if (applyFukushizaiGroupDelete(item, groupNo)) changed = true;
        });
        // ロード時スナップショットのタブ候補からも明示的に落とす(再ロードまでタブが残るのを防ぐ)。
        setFukushizaiItemMasterOptions((prev) => (Array.isArray(prev) ? prev : [])
            .filter((option) => normalizeItemCd(getNamedOptionCode(option)) !== item));
        const nextAdded = (Array.isArray(fukushizaiItemAddedOptionsRef.current) ? fukushizaiItemAddedOptionsRef.current : [])
            .filter((option) => normalizeItemCd(DicVal(option, "code", "")) !== item);
        fukushizaiItemAddedOptionsRef.current = nextAdded;
        setFukushizaiItemAddedOptions(nextAdded);
        // 次のアイテムへ移動する。残りが無ければ既定アイテム00をseedし直す。
        const remaining = [...new Set([
            ...(Array.isArray(fukushizaiItemMasterOptions) ? fukushizaiItemMasterOptions : [])
                .map((option) => normalizeItemCd(getNamedOptionCode(option))),
            ...nextAdded.map((option) => normalizeItemCd(DicVal(option, "code", "")))
        ])].filter((code) => code !== "" && code !== item);
        if (remaining.length === 0) {
            const seeded = [{ code: DEFAULT_ITEM_TAB_CD, name: resolveItemMasterName(DEFAULT_ITEM_TAB_CD), __seeded: true }];
            fukushizaiItemAddedOptionsRef.current = seeded;
            setFukushizaiItemAddedOptions(seeded);
            refreshFukushizaiContextSelection({ itemCd: DEFAULT_ITEM_TAB_CD, groupNo: "" });
        } else {
            const nextItem = remaining[0];
            refreshFukushizaiContextSelection({ itemCd: nextItem, groupNo: getKnownFukushizaiGroupNos(nextItem)[0] || "" });
        }
        scheduleFukushizaiSectionGridRepaint();
        if (!isEmpty(fnc.current) && typeof fnc.current.modify === "function") fnc.current.modify(true);
        rerender();
        return changed;
    }
    function commitItemTabActionDialog() {
        const dialog = itemTabDialogState;
        if (dialog.mode === "add") {
            applyItemTabAddFromDialog();
        } else if (dialog.mode === "delete") {
            if (dialog.domain === "quality") {
                applyQualityItemDelete(dialog.itemCd);
            } else {
                applyFukushizaiItemDelete(dialog.itemCd);
            }
        }
        closeItemTabActionDialog();
    }
    // アイテム操作前に対象ドメインの未確定編集を確定してからダイアログを開く(グループ操作と同じ扱い)。
    async function runItemTabAction(domain, mode, itemCd = "") {
        if (isFukushizaiCopyPreviewing) return;
        const normalizedDomain = domain === "quality" ? "quality" : "fukushizai";
        const activeContext = normalizedDomain === "quality"
            ? selectedQualityContextRef.current
            : selectedFukushizaiContextRef.current;
        await commitFukushizaiActiveContextBeforeLeave(activeContext, { domain: normalizedDomain });
        openItemTabActionDialog(normalizedDomain, mode, itemCd);
    }
    // 品質表示のグループ複写(複写元アイテム/グループ → 選択中アイテム/グループ)。
    // 対象は QUALITY_GROUP_COPY_PANEL_TYPES(119-124)のみで、118(品質表示基本)は複写しない。
    // 副資材の複写(applyFukushizaiGroupCopyNow)は113のみ対象のため役割が重複しない。
    function applyQualityGroupCopyNow(targetItem, targetGroup, sourceItem, sourceGroup) {
        const resolvedTargetItem = normalizeItemCd(targetItem);
        const resolvedTargetGroup = normalizeGroupNo(targetGroup);
        const resolvedSourceItem = normalizeItemCd(sourceItem);
        const resolvedSourceGroup = normalizeGroupNo(sourceGroup);
        if (resolvedTargetItem === "" || resolvedTargetGroup === "") {
            fnc.current.warnmsg("複写先のアイテムとグループを選択してください。");
            return null;
        }
        if (resolvedSourceItem === "" || resolvedSourceGroup === "") {
            fnc.current.warnmsg("複写元アイテムと複写元グループを選択してください。");
            return null;
        }
        if (resolvedTargetItem === resolvedSourceItem && resolvedTargetGroup === resolvedSourceGroup) {
            fnc.current.warnmsg("複写元と複写先が同じグループです。");
            return null;
        }

        // 複写先の色構成は品質表示detail(118-124)から導出する(副資材113の色構成は参照しない)。
        const targetColors = qualityTargetColorsForContext({
            itemCd: resolvedTargetItem,
            groupNo: resolvedTargetGroup,
            colorCd: ""
        });
        if (targetColors.length === 0) {
            fnc.current.warnmsg("複写先グループにカラーが設定されていません。");
            return null;
        }

        let changed = false;
        QUALITY_GROUP_COPY_PANEL_TYPES.forEach((panelType) => {
            // 元rowsは置換処理と同一参照にならないよう複製してから渡す。
            const sourceRows = DeepCopy(sourceRowsForCopy(panelType, resolvedSourceItem, resolvedSourceGroup));
            if (replaceQualityRowsForContext(panelType, resolvedTargetItem, resolvedTargetGroup, sourceRows, targetColors)) {
                changed = true;
            }
        });
        if (!changed) return null;

        refreshAfterQualityGroupMutation(resolvedTargetItem, resolvedTargetGroup);
        debugFukushizaiSyncLog("[Kakousiji][quality group copy applied]", {
            sourceContext: { itemCd: resolvedSourceItem, groupNo: resolvedSourceGroup },
            targetContext: { itemCd: resolvedTargetItem, groupNo: resolvedTargetGroup },
            targetColors,
            panelTypes: QUALITY_GROUP_COPY_PANEL_TYPES
        });
        return {
            changed: true,
            sourceContext: { itemCd: resolvedSourceItem, groupNo: resolvedSourceGroup },
            targetContext: { itemCd: resolvedTargetItem, groupNo: resolvedTargetGroup }
        };
    }
    function getCurrentFukushizaiGroupRows() {
        const refRows = Array.isArray(fukushizaiGroupRowsRef.current) ? fukushizaiGroupRowsRef.current : [];
        return refRows.length !== 0 ? refRows : (Array.isArray(groupRows) ? groupRows : []);
    }
    function getNextUnusedFukushizaiGroupNo(itemCd, preferredGroupNo = "") {
        const item = normalizeItemCd(itemCd);
        const preferred = normalizeGroupNo(preferredGroupNo);
        const used = new Set(getKnownFukushizaiGroupNos(item).map((value) => normalizeGroupNo(value)).filter((value) => value !== ""));
        if (preferred !== "" && !used.has(preferred)) return preferred;
        for (let i = 1; i <= 99; i++) {
            const candidate = String(i).padStart(2, "0");
            if (!used.has(candidate)) return candidate;
        }
        return "";
    }
    function hasSagefudaItemFlagField(rows) {
        const fieldId = "SSDZ_SAGEFUDAITEMFLG";
        return getFukushizaiAllFieldIds().some((id) => normalizeColumnIdUpper(id) === fieldId)
            || (Array.isArray(rows) ? rows : []).some((row) => Object.keys(row || {}).some((key) => normalizeColumnIdUpper(key) === fieldId));
    }
    function updateSagefudaItemFlags(itemCds = null) {
        const rows = ensureFukushizaiDetailRowsForMutation();
        if (!hasSagefudaItemFlagField(rows)) return false;
        const targets = new Set((Array.isArray(itemCds) ? itemCds : distinctTextList(rows, FUKUSHIZAI_FIELD.ITEM_CD)).map((value) => normalizeItemCd(value)).filter((value) => value !== ""));
        if (targets.size === 0) return false;
        let changed = false;
        targets.forEach((itemCd) => {
            const itemRows = rows.filter((row) => getItemCdFromRow(row) === itemCd);
            const hasSagefuda = itemRows.some((row) => readFukushizaiRowField(row, "SSDZ_SAGEFUDASIZECD") !== "");
            const nextValue = hasSagefuda ? "1" : "0";
            itemRows.forEach((row) => {
                if (String(DicVal(row, "SSDZ_SAGEFUDAITEMFLG", "") ?? "").trim() === nextValue) return;
                row.SSDZ_SAGEFUDAITEMFLG = nextValue;
                changed = true;
            });
        });
        return changed;
    }
    // 表示グリッドのdataRefを構築したcontextを記録する(renderKeyによる再生成判定用)。
    // normalizeDetailRowsForPanel と同じ規則でcontextを解決すること。
    function recordFukushizaiGridRenderContext(panelInfo, contextOverride = null) {
        const type = canonicalPanelType(DicVal(panelInfo, "type", ""));
        // 118(単票)と124(WashGrid)はEntryGridArではないため対象外。
        const isQualityDisplay = isQualityPanelType(type) && type !== PANEL_TYPE.QUALITY_BASE && type !== PANEL_TYPE.WASH;
        const isFukushizaiDisplay = FUKUSHIZAI_CONTEXT_DISPLAY_PANEL_TYPES.includes(type);
        if (!isQualityDisplay && !isFukushizaiDisplay) return;
        const context = normalizeFukushizaiContext(
            isQualityDisplay
                ? selectedQualityContextRef.current
                : (contextOverride || selectedFukushizaiContextRef.current)
        );
        fukushizaiGridRenderContextKeyRef.current[type] = `${context.itemCd}|${context.groupNo}`;
    }
    function applyFukushizaiSectionPanelRows(panelInfo, detailData, previewOverride = undefined, contextOverride = null) {
        if (isEmpty(panelInfo)) return;
        const nextRows = normalizeDetailRowsForPanel(panelInfo, detailData, previewOverride, contextOverride);
        SetGridData(panelInfo, nextRows);
        recordFukushizaiGridRenderContext(panelInfo, contextOverride);
        const hasRows = Array.isArray(nextRows) && nextRows.length !== 0;
        const apiReady = !isEmpty(GridApi(panelInfo)) && isGridDomReady(panelInfo);
        if (!apiReady) {
            if (hasRows) {
                gridRefreshCoordinator.markPendingGridApply(panelInfo);
                gridRefreshCoordinator.scheduleGridDataRerender(panelInfo);
            } else {
                gridRefreshCoordinator.clearPendingGridApply(panelInfo);
            }
        } else {
            gridRefreshCoordinator.clearPendingGridApply(panelInfo);
            applyGridRowsNow(panelInfo, nextRows);
        }
    }
    function applyFukushizaiDisplayRowsNow(panelInfo, rows) {
        const previousSyncing = fukushizaiDetailSyncingRef.current;
        fukushizaiDetailSyncingRef.current = true;
        try {
            applyGridRowsNow(panelInfo, rows);
        } finally {
            fukushizaiDetailSyncingRef.current = previousSyncing;
        }
    }
    function logFukushizaiBaseSyncFlat(payload) {
        return;
    }
    function readGridRowsPreferApi(panelInfo, options = {}) {
        const api = GridApi(panelInfo);
        if (!isEmpty(api)) {
            try {
                if (DicVal(options, "stopEditing", true) !== false && typeof api.stopEditing === "function") api.stopEditing();
                if (!isEmpty(AGRef.current) && typeof AGRef.current.GetDatasource === "function") {
                    const rows = AGRef.current.GetDatasource(api);
                    if (Array.isArray(rows)) return rows;
                }
            } catch (error) {
                debugFukushizaiSyncLog("[Kakousiji][grid rows api read failed]", {
                    panelType: canonicalPanelType(DicVal(panelInfo, "type", "")),
                    error
                });
            }
        }
        return GridData(panelInfo);
    }
    function buildFukushizaiDebugRowSnapshot(row) {
        if (!DEBUG_FUKUSHIZAI_SYNC_VERBOSE || isEmpty(row)) return null;
        const fields = [
            "rowid",
            "SSDZ_ITMCITEMCD",
            "SSDZ_COLORCD",
            "SSDZ_FUKUSIZAICOLORGRP",
            "SSDZ_KOMONOFUDACD",
            "SSDZ_SAGEFUDASIZECD",
            "SSDZ_TORCODE",
            "SSDZ_BRANDNAMECD3",
            "SSDZ_SONOTANAMECD6",
            "SSDZ_SONOTAFUZOKUCD5",
            "SSDZ_SONOTAFUZOKUCD6"
        ];
        const snapshot = {};
        fields.forEach((fieldId) => {
            snapshot[fieldId] = readRowValueIgnoreCase(row, fieldId);
        });
        return snapshot;
    }
    function buildFukushizaiDebugGroupSnapshot(itemCd, groupNo) {
        if (!DEBUG_FUKUSHIZAI_SYNC_VERBOSE) return [];
        const targetItem = String(itemCd ?? "").trim();
        const targetGroup = normalizeGroupNo(groupNo);
        return getDetailRowsByPanelType(entrydetailRef.current, "113")
            .filter((row) => {
                if (isEmpty(row)) return false;
                const rowItem = String(readRowValueIgnoreCase(row, "SSDZ_ITMCITEMCD") ?? "").trim();
                const rowGroup = normalizeGroupNo(readRowValueIgnoreCase(row, "SSDZ_FUKUSIZAICOLORGRP"));
                if (targetItem !== "" && rowItem !== targetItem) return false;
                if (targetGroup !== "" && rowGroup !== targetGroup) return false;
                return true;
            })
            .map((row) => buildFukushizaiDebugRowSnapshot(row))
            .filter((row) => !isEmpty(row));
    }
    function buildFukushizaiGroupRowsForDebug(context) {
        const normalized = normalizeFukushizaiContext(context);
        return getDetailRowsByPanelType(entrydetailRef.current, "113")
            .filter((row) => {
                if (isEmpty(row)) return false;
                if (normalized.itemCd !== "" && getItemCdFromRow(row) !== normalized.itemCd) return false;
                if (normalized.groupNo !== "" && getGroupNoFromRow(row) !== normalized.groupNo) return false;
                return true;
            })
            .map((row) => ({
                item: getItemCdFromRow(row),
                group: getGroupNoFromRow(row),
                color: getColorCdFromRow(row),
                rowid: String(DicVal(row, "rowid", "") ?? ""),
                SSDZ_KOMONOFUDACD: DicVal(row, "SSDZ_KOMONOFUDACD", ""),
                SSDZ_SAGEFUDASIZECD: DicVal(row, "SSDZ_SAGEFUDASIZECD", ""),
                SSDZ_TORCODE: DicVal(row, "SSDZ_TORCODE", "")
            }));
    }
    function buildFukushizaiDetail113GroupCounts(rows) {
        const counts = {};
        (Array.isArray(rows) ? rows : []).forEach((row) => {
            if (isEmpty(row)) return;
            const item = getItemCdFromRow(row);
            const group = getGroupNoFromRow(row);
            if (item === "" || group === "") return;
            const key = `${item}/${group}`;
            counts[key] = (counts[key] || 0) + 1;
        });
        return counts;
    }
    function summarizeFukushizaiRepresentativePick(picked) {
        const row = DicVal(picked, "row", null);
        if (isEmpty(row)) return null;
        return {
            item: getItemCdFromRow(row),
            group: getGroupNoFromRow(row),
            color: getColorCdFromRow(row),
            rowid: String(DicVal(row, "rowid", "") ?? ""),
            SSDZ_KOMONOFUDACD: DicVal(row, "SSDZ_KOMONOFUDACD", ""),
            SSDZ_SAGEFUDASIZECD: DicVal(row, "SSDZ_SAGEFUDASIZECD", ""),
            SSDZ_TORCODE: DicVal(row, "SSDZ_TORCODE", "")
        };
    }
    function buildFukushizaiDebugRepresentativeSnapshot(context) {
        const rows = getDetailRowsByPanelType(entrydetailRef.current, "113");
        const picked = pickFukushizaiRepresentativeRow(rows, context, false);
        const summary = summarizeFukushizaiRepresentativePick(picked);
        if (!DEBUG_FUKUSHIZAI_SYNC_VERBOSE) return summary;
        return buildFukushizaiDebugRowSnapshot(DicVal(picked, "row", null)) || summary;
    }
    function buildFukushizaiDebugEntrySnapshot(entryObj) {
        if (!DEBUG_FUKUSHIZAI_SYNC_VERBOSE || isEmpty(entryObj)) return null;
        return buildFukushizaiDebugRowSnapshot(entryObj);
    }
    function refreshFukushizaiSectionViews(itemCd, groupNo, previewOverride = undefined, contextOverride = null) {
        const previousSyncing = fukushizaiDetailSyncingRef.current;
        fukushizaiDetailSyncingRef.current = true;
        try {
            const detailData = entrydetailRef.current;
            const displayBuildContext = normalizeFukushizaiContext(contextOverride || {
                itemCd,
                groupNo,
                colorCd: selectedFukushizaiContextRef.current?.colorCd
            });
            primeFukushizaiMasterStoreFromRow(entrydataRef.current);
            primeFukushizaiMasterStoreFromRows(getDetailRowsByPanelType(detailData, "113"));
            if (!Array.isArray(gridlist) || gridlist.length === 0) return;
            gridlist.forEach((panelInfo) => {
                if (!isFukushizaiSharedContextPanelInfo(panelInfo)) return;
                // 品質表示(118-124)は品質専用コンテキストで描画するため、ここでは副資材側だけを扱う。
                if (isQualityPanelType(getPanelType(panelInfo))) return;
                applyFukushizaiSectionPanelRows(panelInfo, detailData, previewOverride, displayBuildContext);
            });
            // 品質表示パネルは描画契機を共有しつつ、参照するコンテキストだけを品質専用に分ける。
            // (初期表示もこの経路のため、ここで呼ばないと品質パネルが空のままになる)
            refreshQualitySectionViews(previewOverride);
        } finally {
            fukushizaiDetailSyncingRef.current = previousSyncing;
        }
    }
    // 品質表示(118-124)パネルだけを品質専用コンテキストで再構築する。
    function refreshQualitySectionViews(previewOverride = undefined) {
        const previousSyncing = fukushizaiDetailSyncingRef.current;
        fukushizaiDetailSyncingRef.current = true;
        try {
            const detailData = entrydetailRef.current;
            if (!Array.isArray(gridlist) || gridlist.length === 0) return;
            gridlist.forEach((panelInfo) => {
                if (!isQualityPanelType(getPanelType(panelInfo))) return;
                applyFukushizaiSectionPanelRows(panelInfo, detailData, previewOverride, selectedQualityContextRef.current);
            });
        } finally {
            fukushizaiDetailSyncingRef.current = previousSyncing;
        }
    }
    // 品質表示のitem/group切替を副資材とは独立に反映する。
    function refreshQualityContextSelection(nextPartialContext) {
        const oldContext = normalizeFukushizaiContext(selectedQualityContextRef.current);
        const normalizedNextPartial = normalizeFukushizaiContext(nextPartialContext);
        const qualityBaseRows = getDetailRowsByPanelType(entrydetailRef.current, PANEL_TYPE.QUALITY_BASE);
        const nextContext = resolveFukushizaiContext(qualityBaseRows, {
            ...oldContext,
            ...normalizedNextPartial
        });
        if (selectedQualityItem !== nextContext.itemCd) setSelectedQualityItem(nextContext.itemCd);
        if (selectedQualityGroup !== nextContext.groupNo) setSelectedQualityGroup(nextContext.groupNo);
        updateSelectedQualityContext(nextContext);
        // 単票(118 BASE)も新contextの代表行で更新する。
        // ここを省くと表示グリッドだけが切り替わり、単票が旧グループのまま残る。
        mergeQualityRepresentativeRowToEntry(entrydataRef.current, entrydetailRef.current, nextContext);
        refreshQualitySectionViews();
        dispatchEntryRerenderWithTrace("qualityGroupSwitch");
        rerender();
        return nextContext;
    }
    function getFukushizaiDisplayRowsCountByPanel() {
        const counts = {};
        if (!Array.isArray(gridlist)) return counts;
        gridlist.forEach((panelInfo) => {
            const panelType = canonicalPanelType(DicVal(panelInfo, "type", ""));
            if (!FUKUSHIZAI_CONTEXT_DISPLAY_PANEL_TYPES.includes(panelType)) return;
            const rows = GridData(panelInfo);
            counts[panelType] = Array.isArray(rows) ? rows.length : 0;
        });
        return counts;
    }
    function refreshFukushizaiContextSelection(nextPartialContext) {
        const detailRows = getDetailRowsByPanelType(entrydetailRef.current, FUKUSHIZAI_BASE_PANEL_TYPE);
        const oldContext = normalizeFukushizaiContext(selectedFukushizaiContextRef.current);
        const normalizedNextPartial = normalizeFukushizaiContext(nextPartialContext);
        const entrydataBefore = buildFukushizaiDebugEntrySnapshot(entrydataRef.current);
        const representativeRowBefore = buildFukushizaiDebugRepresentativeSnapshot(oldContext);
        const selectedSetItemBefore = selectedSetItem;
        const selectedGroupBefore = selectedGroup;
        const detail113Count = detailRows.length;
        const detail113GroupCounts = buildFukushizaiDetail113GroupCounts(detailRows);
        const nextContext = resolveFukushizaiContext(detailRows, {
            ...oldContext,
            ...normalizedNextPartial
        });
        if (selectedSetItem !== nextContext.itemCd) setSelectedSetItem(nextContext.itemCd);
        if (selectedGroup !== nextContext.groupNo) setSelectedGroup(nextContext.groupNo);
        updateSelectedFukushizaiContext(nextContext);
        if (!hasCompleteFukushizaiContext(nextContext)) {
            clearFukushizaiMergedFields(entrydataRef.current);
            fukushizaiProjection.refreshSectionViews(nextContext.itemCd, nextContext.groupNo, pendingFukushizaiCopy, nextContext);
            resetFukushizaiContextDisplayGridRowState();
            const flatPayload = {
                oldContext,
                nextPartialContext,
                resolvedNextContext: nextContext,
                detail113Count,
                detail113GroupCounts,
                pickedRepresentative: null,
                pickedRepresentativeReason: "incomplete-context",
                selectedSetItemBefore,
                selectedSetItemAfter: nextContext.itemCd,
                selectedGroupBefore,
                selectedGroupAfter: nextContext.groupNo,
                itemOptionsCount: Array.isArray(fukushizaiItemMasterOptions) ? fukushizaiItemMasterOptions.length : 0,
                groupOptionsCount: Array.isArray(groupOptions) ? groupOptions.length : 0,
                baseDirtyBeforeLeave: hasFukushizaiBaseDirty(oldContext),
                displayDirtyBeforeLeave: Object.keys(fukushizaiDirtyPanelRef.current || {}).some((key) => key.startsWith(`${oldContext.itemCd}|${oldContext.groupNo}|`)),
                clearedProjection: true,
                entrydataBefore,
                entrydataAfter: buildFukushizaiDebugEntrySnapshot(entrydataRef.current),
                groupRowsForOldContext: buildFukushizaiGroupRowsForDebug(oldContext),
                groupRowsForNextContext: buildFukushizaiGroupRowsForDebug(nextContext),
                groupSnapshotBefore: buildFukushizaiDebugGroupSnapshot(oldContext.itemCd, oldContext.groupNo),
                groupSnapshotAfter: buildFukushizaiDebugGroupSnapshot(nextContext.itemCd, nextContext.groupNo),
                displayBuildContext: nextContext,
                displayBuildContextReason: "resolved-next-context",
                displayBuildPanelTypes: FUKUSHIZAI_CONTEXT_DISPLAY_PANEL_TYPES,
                displayRowsCountByPanel: getFukushizaiDisplayRowsCountByPanel()
            };
            debugFukushizaiSyncLog("[Kakousiji][fukushizai group switch]", flatPayload);
            // 単票(EntryInput)は entrydataRef を直接参照し、entryinputrender の変化でのみ再描画される。
            // グループ切替では値の入れ替えしか行っていないため、明示的に再描画を要求しないと旧グループの表示が残る。
            dispatchEntryRerenderWithTrace("fukushizaiGroupSwitch:incompleteContext");
            rerender();
            return nextContext;
        }
        const merged = mergeFukushizaiRepresentativeRowToEntry(entrydataRef.current, entrydetailRef.current, nextContext);
        const representativeRowAfter = buildFukushizaiDebugRepresentativeSnapshot(nextContext);
        fukushizaiProjection.refreshSectionViews(nextContext.itemCd, nextContext.groupNo, pendingFukushizaiCopy, nextContext);
        resetFukushizaiContextDisplayGridRowState();
        const flatPayload = {
            oldContext,
            nextPartialContext,
            resolvedNextContext: nextContext,
            detail113Count,
            detail113GroupCounts,
            pickedRepresentative: representativeRowAfter,
            pickedRepresentativeReason: merged ? "matched-context" : "no-matching-detail113-row",
            selectedSetItemBefore,
            selectedSetItemAfter: nextContext.itemCd,
            selectedGroupBefore,
            selectedGroupAfter: nextContext.groupNo,
            itemOptionsCount: Array.isArray(fukushizaiItemMasterOptions) ? fukushizaiItemMasterOptions.length : 0,
            groupOptionsCount: Array.isArray(groupOptions) ? groupOptions.length : 0,
            baseDirtyBeforeLeave: hasFukushizaiBaseDirty(oldContext),
            displayDirtyBeforeLeave: Object.keys(fukushizaiDirtyPanelRef.current || {}).some((key) => key.startsWith(`${oldContext.itemCd}|${oldContext.groupNo}|`)),
            clearedProjection: true,
            entrydataBefore,
            entrydataAfter: buildFukushizaiDebugEntrySnapshot(entrydataRef.current),
            groupRowsForOldContext: buildFukushizaiGroupRowsForDebug(oldContext),
            groupRowsForNextContext: buildFukushizaiGroupRowsForDebug(nextContext),
            groupSnapshotBefore: buildFukushizaiDebugGroupSnapshot(oldContext.itemCd, oldContext.groupNo),
            groupSnapshotAfter: buildFukushizaiDebugGroupSnapshot(nextContext.itemCd, nextContext.groupNo),
            displayBuildContext: nextContext,
            displayBuildContextReason: "resolved-next-context",
            displayBuildPanelTypes: FUKUSHIZAI_CONTEXT_DISPLAY_PANEL_TYPES,
            displayRowsCountByPanel: getFukushizaiDisplayRowsCountByPanel()
        };
        debugFukushizaiSyncLog("[Kakousiji][fukushizai group switch]", {
            ...flatPayload,
            representativeRowBefore,
            representativeRowAfter,
            group01Snapshot: buildFukushizaiDebugGroupSnapshot(nextContext.itemCd, "01"),
            group02Snapshot: buildFukushizaiDebugGroupSnapshot(nextContext.itemCd, "02")
        });
        // 単票(EntryInput)は entrydataRef を直接参照し、entryinputrender の変化でのみ再描画される。
        // 代表行の投影で entrydataRef の値は入れ替わっているため、ここで再描画を要求しないと
        // 表示グリッド(114〜117)だけが切り替わり、単票は旧グループのまま残る。
        dispatchEntryRerenderWithTrace("fukushizaiGroupSwitch");
        rerender();
        return nextContext;
    }
    function readFukushizaiBaseMasterName(row, fieldId) {
        if (isEmpty(row) || isEmpty(fieldId)) return "";
        const code = extractMasterCodeFromDisplayValue(DicVal(row, fieldId, ""));
        if (code === "") return "";
        return readFukushizaiMasterNameFromStore(fieldId, code);
    }
    function isBrandNamePanelInfo(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return canonicalPanelType(DicVal(panelInfo, "type", "")) === PANEL_TYPE.BRAND_NAME;
    }
    function isOtherNamePanelInfo(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return canonicalPanelType(DicVal(panelInfo, "type", "")) === PANEL_TYPE.OTHER_NAME;
    }
    function isOtherFukuzaiPanelInfo(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return canonicalPanelType(DicVal(panelInfo, "type", "")) === PANEL_TYPE.OTHER_FUKUZAI;
    }
    function debugFukushizaiSyncLog(message, payload) {
        return;
    }
    function isCurrentKomonoFudaDisplayRow(row) {
        if (isEmpty(row)) return false;
        const displayCode = String(DicVal(row, "__komonofudaCode", "") ?? "").trim();
        if (displayCode === "") return true;
        const detailRows = getDetailRowsByPanelType(entrydetailRef.current, "113");
        const index = findFukushizaiDetailExactRowIndexByMatchInfo(detailRows, normalizeFukushizaiDetailMatchInfo(row));
        if (index < 0 || isEmpty(detailRows[index])) return false;
        const currentCode = extractMasterCodeFromDisplayValue(DicVal(detailRows[index], "SSDZ_KOMONOFUDACD", ""));
        const matched = currentCode === displayCode;
        if (!matched) {
            debugFukushizaiSyncLog("[Kakousiji][komonofuda stale row sync skipped]", {
                displayCode,
                currentCode,
                rowid: String(DicVal(row, "rowid", "") ?? "")
            });
        }
        return matched;
    }
    function isFukushizaiBaseMasterField(columnId) {
        const target = String(columnId ?? "").trim().toUpperCase();
        return FUKUSHIZAI_BASE_MASTER_FIELD_IDS.some((fieldId) => fieldId.toUpperCase() === target);
    }
    // 品質表示BASEの dirty/detail 同期へ渡す依存関係をまとめます。
    function buildQualityBaseSyncServiceDeps() {
        return {
            fnc,
            entrydataRef,
            entrydetailRef,
            qualityBaseDirtyRef,
            PANEL_TYPE,
            QUALITY_LIST_HABACD_FIELD,
            isEmpty,
            isEnabled,
            DicVal,
            normalizeKakousijiUiString,
            normalizeFukushizaiContext,
            normalizeColorCd,
            isSameFukushizaiItemGroupContext,
            createEmptyFukushizaiContext,
            isQualityBaseField,
            resolveQualityBaseEditContext,
            resolveQualityHsituhabaCdFromLocalSelectionValue,
            qualityTargetColorsForContext,
            ensureDetailRowsByTypeForMutation,
            rowMatchesFukushizaiItemGroupColor,
            createQualityBaseRow,
            setRowContextForPanel,
            mergeQualityRepresentativeRowToEntry
        };
    }
    // 品質表示BASEの dirty/detail 同期は専用 service へ委譲します。
    const {
        readQualityBaseDirtyState,
        clearQualityBaseDirtyFields,
        applyQualityBaseUpdatesToCurrentContext,
        syncQualityBaseFieldValueToDetail
    } = createQualityBaseSyncService(buildQualityBaseSyncServiceDeps());
    // 副資材 context 切替前 commit/品質表示 flush へ渡す依存関係をまとめます。
    function buildFukushizaiContextCommitServiceDeps() {
        return {
            entrydetailRef,
            selectedFukushizaiContextRef,
            selectedQualityContextRef,
            fukushizaiDirtyPanelRef,
            gridlist,
            PANEL_TYPE,
            isEmpty,
            isEnabled,
            DicVal,
            normalizeFukushizaiContext,
            canonicalPanelType,
            isQualityPanelType,
            isFukushizaiContextDisplayPanelInfo,
            getPanelType,
            getDetailRowsByPanelType,
            resolveFukushizaiBaseEditContext,
            hasFukushizaiBaseDirty,
            syncFukushizaiBaseDirtyFieldsToDetail,
            readQualityBaseDirtyState,
            clearQualityBaseDirtyFields,
            applyQualityBaseUpdatesToCurrentContext,
            isFukushizaiDirtyPanel,
            clearFukushizaiDirtyPanel,
            GridApi,
            isGridDomReady,
            GridData,
            readGridRowsPreferApi,
            toQualitySaveRows,
            flushFukushizaiDisplayGridsToDetail,
            debugFukushizaiSyncLog
        };
    }
    // 副資材 context 切替前 commit と品質表示 flush は専用 service へ委譲します。
    const {
        syncFukushizaiRepresentativeRowFromEntry,
        syncQualityBaseDirtyFieldsToDetail,
        syncQualityDisplayGridToDetail,
        flushQualityDisplayGridsToDetail,
        commitFukushizaiActiveContextBeforeLeave
    } = createFukushizaiContextCommitService(buildFukushizaiContextCommitServiceDeps());
    // 副資材まわりの projection 呼び出し口です。
    // まずは呼び出し経路だけを分離し、実装本体は既存関数をそのまま使用します。
    const fukushizaiProjection = createFukushizaiProjection({
        syncFukushizaiBaseFieldValueToDetail,
        syncFukushizaiDisplayRowsToDetail,
        applyFukushizaiDisplayRowsNow,
        refreshFukushizaiSectionViews
    });
    // 品質表示まわりの projection 呼び出し口です。
    const qualityProjection = createQualityProjection({
        syncQualityBaseFieldValueToDetail,
        syncQualityDisplayGridToDetail
    });
    function syncFukushizaiKomonoDisplayRowToDetail(row, params = null) {
        const result = applyFukushizaiKomonoDisplayRowToDetail(row, params);
        return finishFukushizaiDetailSync(result, pendingFukushizaiCopy, {
            refresh: false,
            flushBeforeRefresh: false,
            rerender: false,
            updateSelection: false
        });
    }
    function applyFukushizaiKomonoDisplayRowToDetail(row, params = null) {
        if (isEmpty(row)) return { changed: false, index: -1, row: null, context: normalizeFukushizaiContext(row) };
        if (isEnabled(DicVal(row, "__fukushizaiCopyPreview", false))) return { changed: false, index: -1, row: null, context: normalizeFukushizaiContext(row) };
        const paramRowIndex = Number(DicVal(DicVal(params, "node", null), "rowIndex", -1));
        const colDef = DicVal(params, "colDef", {});
        const hasParams = !isEmpty(params);
        const colId = String(hasParams
            ? (DicVal(colDef, "colId", "") || DicVal(colDef, "field", "") || readFukushizaiDisplaySourceColumnId(row) || "")
            : "KOMONOFUDA_NAIYO_DMY").trim();
        const value = DicVal(params, "newValue", undefined) !== undefined
            ? DicVal(params, "newValue", "")
            : DicVal(row, "KOMONOFUDA_NAIYO_DMY", DicVal(row, colId || "KOMONOFUDA_NAIYO_DMY", ""));
        if (colId === "SSDZ_KOMONOFUDACD") {
            return { changed: false, index: -1, row: null, context: normalizeFukushizaiContext(row) };
        }
        return syncFukushizaiDisplayCellToDetail({
            panelType: "114",
            row,
            rowIndex: Number.isFinite(paramRowIndex) ? paramRowIndex : -1,
            changedField: colId,
            rawValue: value,
            timing: "immediate"
        });
    }
    function brandNameSourceColumnId(slot) {
        const value = Number(slot ?? 0);
        if (!Number.isFinite(value) || value < 1 || value > 3) return "";
        return `SSDZ_BRANDNAMECD${value}`;
    }
    function otherNameSourceColumnId(slot) {
        const value = Number(slot ?? 0);
        if (!Number.isFinite(value) || value < 1 || value > 6) return "";
        return `SSDZ_SONOTANAMECD${value}`;
    }
    function otherFukuzaiSourceColumnId(slot) {
        const value = Number(slot ?? 0);
        if (!Number.isFinite(value) || value < 1 || value > 5) return "";
        return `SSDZ_SONOTAFUZOKUCD${value}`;
    }
    function isOtherNameSourceColumnId(columnId) {
        const cid = String(columnId ?? "").trim().toUpperCase();
        return /^SSDZ_SONOTANAMECD[1-6]$/.test(cid);
    }
    function isOtherFukuzaiSourceColumnId(columnId) {
        const cid = String(columnId ?? "").trim().toUpperCase();
        return /^SSDZ_SONOTAFUZOKUCD[1-5]$/.test(cid);
    }
    function isBrandNameMasterPreloadItem(item) {
        if (isEmpty(item)) return false;
        const cid = String(DicVal(item, "columnid", "") ?? "").trim().toUpperCase();
        return cid === "SSDZ_BRANDNAMECD1" || cid === "SSDZ_BRANDNAMECD2" || cid === "SSDZ_BRANDNAMECD3";
    }
    function filterBrandNameMasterPreload(list) {
        if (!Array.isArray(list) || list.length === 0) return Array.isArray(list) ? list : [];
        return list.filter((item) => !isBrandNameMasterPreloadItem(item));
    }
    function stripKomonoFudaDisplayOnlyFields(row) {
        const out = {};
        Object.keys(row || {}).forEach((key) => {
            if (isKomonofudaUiOnlyField(key)) return;
            out[key] = row[key];
        });
        return out;
    }
    function emptyGenkaRow(rowKey, itemName, rowid) {
        return {
            rowid: String(rowid ?? "0"),
            row_key: String(rowKey ?? ""),
            item_name: itemName,
            muryo: "",
            muryo_f: "",
            yusho: "",
            yusho_f: "",
            kojo: "",
            kojo_f: "",
            syokei: "",
            syokei_f: "",
            kousei: ""
        };
    }
    function emptyGenkaSummaryRow(itemName, rowid) {
        const item = resolveGenkaSummaryItem(itemName);
        const itemId = item === "" ? normalizeColumnIdUpper(itemName) : item;
        const label = resolveGenkaSummaryLabel(itemId);
        return {
            rowid: String(rowid ?? "0"),
            total_item: itemId,
            total_key: itemId,
            total_label: label,
            total_value: "",
            total_value2: ""
        };
    }
    function normalizeGenkaItemLabel(label) {
        let s = String(label ?? "");
        s = s.replace(/[（(][^）)]*[）)]/g, "");
        s = s.replace(/\s+/g, "").replace(/[　]/g, "").trim();
        return s;
    }
    function toGenkaRowKey(rowLike) {
        if (isEmpty(rowLike)) return "";
        const key = normalizeGenkaItemLabel(rowLike);
        if (key in genkaRowLabelByKey) return key;
        return DicVal(genkaRowKeyByLabel, key, "");
    }
    function canonicalGenkaRowName(name) {
        return toGenkaRowKey(name);
    }
    // 原価右合計の行ラベルは、レイアウト情報（columninfo.columnnm）を最優先で使う。
    function resolveGenkaSummaryLabel(itemId) {
        const key = resolveGenkaSummaryItem(itemId);
        if (key === "") return "";
        const hit = findColumnInfoByCandidates([key], [PANEL_TYPE.GENKA_SUMMARY, "127", "t2"]);
        const fromLayout = String(DicVal(hit, "columnnm", "") ?? "").trim();
        if (fromLayout !== "") return fromLayout;
        return String(DicVal(genkaSummaryLabelById, key, "") ?? "");
    }
    function fallbackColInfo(datatype) {
        return {
            datatype: String(datatype ?? "0"),
            decimalplace: 0,
            options: [],
            primary: false,
            keyinfo: "",
            dataid: "",
            format: "",
            length: 0,
            multiple: false
        };
    }
    function findColumnInfoByCandidates(candidates, typeCandidates) {
        if (!Array.isArray(columninfo) || columninfo.length === 0) return null;
        const ids = (Array.isArray(candidates) ? candidates : [])
            .map(c => String(c ?? "").trim().toUpperCase())
            .filter(c => c !== "");
        if (ids.length === 0) return null;
        const tset = (Array.isArray(typeCandidates) ? typeCandidates : []).map(t => String(t ?? "").trim());
        const hit = columninfo.find((c) => {
            const cid = String(c.columnid ?? "").trim().toUpperCase();
            if (!ids.includes(cid)) return false;
            if (tset.length === 0) return true;
            return tset.includes(String(c.type ?? "").trim());
        });
        return isEmpty(hit) ? null : hit;
    }
    function findGenkaColInfoByCell(rowKey, slot) {
        const rkey = toGenkaRowKey(rowKey);
        const scol = String(slot ?? "");
        if (isEmpty(rkey) || isEmpty(scol) || !Array.isArray(columninfo) || columninfo.length === 0) return null;
        const list = columninfo.filter((c) => {
            if (String(c.type ?? "") !== PANEL_TYPE.GENKA) return false;
            const mapped = mapGenkaByColumnId(String(c.columnid ?? ""));
            if (isEmpty(mapped)) return false;
            if (toGenkaRowKey(mapped.row) !== rkey) return false;
            return Array.isArray(mapped.cols) && mapped.cols.includes(scol);
        });
        if (!Array.isArray(list) || list.length === 0) return null;
        const numeric = list.filter(c => String(c.datatype ?? "") === "1");
        if (numeric.length !== 0) {
            const base = { ...numeric[0] };
            const dps = numeric.map(c => Number(c.decimalplace ?? 0)).filter(n => !Number.isNaN(n));
            base.decimalplace = dps.length === 0 ? 0 : Math.max(...dps);
            return base;
        }
        return { ...list[0] };
    }
    function floorByDecimal(value, decimalplace) {
        const n = Number(value);
        if (!Number.isFinite(n)) return "";
        const dp = Number(decimalplace ?? 0);
        const digit = Number.isFinite(dp) ? Math.max(0, dp) : 0;
        const p = Math.pow(10, digit);
        const shifted = n * p;
        const floored = Math.floor(shifted + 1e-9) / p;
        if (digit === 0) return String(floored);
        return floored.toFixed(digit);
    }
    function roundByDecimal(value, decimalplace) {
        const n = Number(value);
        if (!Number.isFinite(n)) return "";
        const dp = Number(decimalplace ?? 0);
        const digit = Number.isFinite(dp) ? Math.max(0, dp) : 0;
        const p = Math.pow(10, digit);
        const rounded = Math.round((n + Number.EPSILON) * p) / p;
        if (digit === 0) return String(rounded);
        return rounded.toFixed(digit);
    }
    function isZeroLikeGenkaDisplayValue(value) {
        const raw = String(value ?? "").trim();
        if (raw === "") return false;
        const normalized = raw.replace(/[,\s　]/g, "").replace(/―/g, "-");
        if (normalized === "" || normalized === "-" || normalized === "―") return false;
        const n = Number(normalized);
        return Number.isFinite(n) && n === 0;
    }
    function isMeaningfulGenkaValue(value, keepZero) {
        const raw = String(value ?? "").trim();
        if (raw === "") return false;
        if (!isZeroLikeGenkaDisplayValue(raw)) return true;
        return keepZero === true;
    }
    function blankDefaultZeroGenkaRows(rows) {
        if (!Array.isArray(rows) || rows.length === 0) return [];
        return rows.map((row) => {
            const next = { ...row };
            const rowKey = toGenkaRowKey(DicVal(row, "row_key", "") || DicVal(row, "item_name", ""));
            genkaCalcSlots.forEach((slot) => {
                const raw = String(DicVal(next, slot, "") ?? "").trim();
                if (raw === "") return;
                if (!isZeroLikeGenkaDisplayValue(raw)) return;
                if (hasActualGenkaEntryValueForCell(rowKey, slot)) return;
                if (isGenkaTouchedCell(rowKey, slot)) return;
                next[slot] = "";
            });
            return next;
        });
    }
    function blankDefaultZeroGenkaSummaryRows(rows) {
        if (!Array.isArray(rows) || rows.length === 0) return [];
        return rows.map((row) => {
            const next = { ...row };
            const item = resolveGenkaSummaryItem(DicVal(row, "total_key", "") || DicVal(row, "total_item", ""));
            if (item === "") return next;
            ["total_value", "total_value2"].forEach((field) => {
                const raw = String(DicVal(next, field, "") ?? "").trim();
                if (raw === "") return;
                if (!isZeroLikeGenkaDisplayValue(raw)) return;
                const isValue2 = field === "total_value2";
                const keepZero = isGenkaKeepZeroSummaryField(item, isValue2)
                    || hasActualGenkaSummaryEntryValueForField(item, isValue2);
                if (keepZero) return;
                if (isGenkaTouchedSummary(item, field)) return;
                next[field] = "";
            });
            return next;
        });
    }
    function hasActualGenkaSummaryEntryValueForField(item, isValue2) {
        const conf = genkaSummaryColumnCandidates[item];
        if (isEmpty(conf)) return false;
        const ids = isValue2 ? (conf.value2 || []) : (conf.value || []);
        return ids.some((cid) => hasActualEntryValueByColumnId(entrydataRef.current, cid));
    }
    function isGenkaKeepZeroSummaryField(item, isValue2) {
        return resolveGenkaSummaryItem(item) === "SSDGM_BOUEKIJYOKEN" && !isValue2;
    }
    function formatGenkaDisplayValue(params) {
        const raw = String(DicVal(params, "value", "") ?? "").trim();
        if (raw === "") return "";
        const rowKey = toGenkaRowKey(DicVal(DicVal(params, "data", {}), "row_key", "") || DicVal(DicVal(params, "data", {}), "item_name", ""));
        const slot = String(DicVal(DicVal(params, "colDef", {}), "colId", "") || DicVal(DicVal(params, "colDef", {}), "field", ""));
        if (isZeroLikeGenkaDisplayValue(raw) && !hasActualGenkaEntryValueForCell(rowKey, slot)) return "";
        return raw;
    }
    function formatGenkaKouseiDisplayValue(params) {
        const raw = String(DicVal(params, "value", "") ?? "").trim();
        if (raw === "") return "";
        const n = Number(raw);
        if (!Number.isFinite(n)) return raw;
        if (n === 0) return "";
        return String(Math.round(n)) + "%";
    }
    function normalizeGenkaCellByLayout(params) {
        if (isEmpty(params) || isEmpty(params.colDef) || isEmpty(params.data)) return false;
        const slot = String(DicVal(params.colDef, "colId", "") || DicVal(params.colDef, "field", ""));
        if (!["muryo", "muryo_f", "yusho", "yusho_f", "kojo", "kojo_f", "syokei", "syokei_f", "kousei"].includes(slot)) return false;
        const rowKey = String(DicVal(params.data, "row_key", "") || DicVal(params.data, "item_name", ""));
        const cinfo = findGenkaColInfoByCell(rowKey, slot);
        if (isEmpty(cinfo)) return false;
        const datatype = String(cinfo.datatype ?? "");
        if (datatype !== "1") return false;
        const raw = String(DicVal(params, "newValue", "") ?? "").trim();
        const normalized = raw === "" ? "" : floorByDecimal(raw, DicVal(cinfo, "decimalplace", 0));
        if (String(normalized) === String(DicVal(params, "newValue", ""))) return false;
        const node = DicVal(params, "node", null);
        if (isEmpty(node) || typeof node.setDataValue !== "function") return false;
        node.setDataValue(slot, normalized);
        return true;
    }
    function normalizeGenkaRowsByLayoutPrecision(rows) {
        if (!Array.isArray(rows) || rows.length === 0) return rows;
        const slots = ["muryo", "muryo_f", "yusho", "yusho_f", "kojo", "kojo_f", "syokei", "syokei_f", "kousei"];
        return rows.map((row) => {
            const out = { ...row };
            const rowKey = String(DicVal(row, "row_key", "") || DicVal(row, "item_name", ""));
            slots.forEach((slot) => {
                const cinfo = findGenkaColInfoByCell(rowKey, slot);
                if (isEmpty(cinfo)) return;
                if (String(cinfo.datatype ?? "") !== "1") return;
                const raw = String(DicVal(row, slot, "") ?? "").trim();
                if (raw === "") return;
                out[slot] = floorByDecimal(raw, DicVal(cinfo, "decimalplace", 0));
            });
            return out;
        });
    }
    // 表示用丸め。
    // 現状は左Gridへ反映するrows自体を丸めており、右合計もこのrowsを元に計算する。
    // 内部小数を保持したまま右合計/保存へ使う必要が出た場合は、rawRows/displayRows の2系統へ分離する。
    // 金額計・小計・見積原価小計は表示を0桁へ寄せる。
    function applyGenkaCalcDisplayRounding(rows) {
        if (!Array.isArray(rows) || rows.length === 0) return rows;
        const zeroSlotsByRow = {
            MAT_TOTAL: ["muryo", "muryo_f", "yusho", "yusho_f", "kojo", "kojo_f", "syokei", "syokei_f"],
            SUB_TOTAL: ["muryo", "muryo_f", "yusho", "yusho_f", "kojo", "kojo_f", "syokei", "syokei_f"],
            EST_COST: ["syokei", "syokei_f"]
        };
        const subtotalSlots = ["syokei", "syokei_f"];
        const toZeroDecimal = (value) => {
            const raw = String(value ?? "").trim();
            if (raw === "") return "";
            const n = Number(raw.replace(/,/g, ""));
            if (!Number.isFinite(n)) return raw;
            return roundByDecimal(n, 0);
        };
        return rows.map((row) => {
            const next = { ...row };
            const rowKey = toGenkaRowKey(DicVal(row, "row_key", "") || DicVal(row, "item_name", ""));
            const rowSlots = DicVal(zeroSlotsByRow, rowKey, []);
            rowSlots.forEach((slot) => {
                next[slot] = toZeroDecimal(DicVal(next, slot, ""));
            });
            if (rowKey !== "MAT_TOTAL" && rowKey !== "SUB_TOTAL") {
                subtotalSlots.forEach((slot) => {
                    next[slot] = toZeroDecimal(DicVal(next, slot, ""));
                });
            }
            return next;
        });
    }
    function genkaSummaryColInfoByField(field) {
        if (field === "total_item") return fallbackColInfo("0");
        if (field === "total_value") {
            const c = findColumnInfoByCandidates(["SSDGM_BOUEKIJYOKEN"], [PANEL_TYPE.GENKA_SUMMARY]);
            return genkaTradeConditionColInfo(isEmpty(c) ? fallbackColInfo("0") : c);
        }
        if (field === "total_value2") {
            const c = findColumnInfoByCandidates(["SSDGM_FOBKINF"], [PANEL_TYPE.GENKA_SUMMARY]);
            return isEmpty(c) ? fallbackColInfo("1") : c;
        }
        return fallbackColInfo("0");
    }
    function genkaTradeConditionColInfo(base) {
        const source = isEmpty(base) ? fallbackColInfo("0") : base;
        return {
            ...source,
            columnid: "SSDGM_BOUEKIJYOKEN",
            columnnm: String(DicVal(source, "columnnm", "") ?? "") || "貿易条件区分",
            datatype: "6",
            dataid: GENKA_TRADE_CONDITION_DATAID,
            dataidctrl: "m_code",
            mastertype: GENKA_TRADE_CONDITION_DATAID,
            dbcolumn: "m_code_name",
            dbcolumnnm: "m_code_name",
            keyinfo: "",
            searchtype: String(DicVal(source, "searchtype", "") ?? "").trim(),
            searchparam: normalizeSearchParamObject(DicVal(source, "searchparam", null)),
            trigger: Array.isArray(DicVal(source, "trigger", null)) ? source.trigger : [],
            length: DicVal(source, "length", 0),
            format: String(DicVal(source, "format", "") ?? "")
        };
    }
    // 原価右合計: 行ごとの実Column IDから datatype/decimalplace を解決する。
    function genkaSummaryValueColumnInfoByRow(row, isValue2) {
        const item = resolveGenkaSummaryItem(
            DicVal(row, "total_key", "") || DicVal(row, "total_item", "")
        );
        if (isEmpty(item)) return fallbackColInfo(isValue2 ? "1" : "0");
        const conf = DicVal(genkaSummaryColumnCandidates, item, null);
        if (isEmpty(conf)) return fallbackColInfo(isValue2 ? "1" : "0");
        const candidates = isValue2 ? DicVal(conf, "value2", []) : DicVal(conf, "value", []);
        const cinfo = findColumnInfoByCandidates(candidates, [PANEL_TYPE.GENKA_SUMMARY, "127", "t2"]);
        if (!isValue2 && item === "SSDGM_BOUEKIJYOKEN") {
            return genkaTradeConditionColInfo(isEmpty(cinfo) ? fallbackColInfo("0") : cinfo);
        }
        return isEmpty(cinfo) ? fallbackColInfo(isValue2 ? "1" : "0") : cinfo;
    }
    function findGenkaSummaryCurrencyColInfo() {
        return findColumnInfoByCandidates(["SSDGM_TSUKATANI"], [PANEL_TYPE.GENKA_SUMMARY, "127", "t2"])
            || findColumnInfoByCandidates(["SSDGM_TSUKATANI"], []);
    }
    function normalizeGenkaSummaryCurrencyDataId(dataid) {
        const raw = String(dataid ?? "").trim();
        if (raw === "") return "m_code:3130";
        if (raw.toLowerCase().startsWith("m_code")) return "m_code:3130";
        return raw;
    }
    function getGenkaSummaryCurrencyMasterMeta(code = "") {
        const colInfo = findGenkaSummaryCurrencyColInfo();
        const dataid = normalizeGenkaSummaryCurrencyDataId(readColumnMasterDataId(colInfo));
        const dbcolumn = readColumnMasterDbColumn(colInfo) || "m_code_name";
        const keyinfo = String(DicVal(colInfo, "keyinfo", "") ?? "").trim();
        const targetCode = String(code ?? "").trim();
        if (dataid === "" || dbcolumn === "") return null;
        return {
            colInfo,
            dataid,
            dbcolumn,
            keyinfo,
            code: targetCode,
            loadingKey: [dataid, targetCode, keyinfo, dbcolumn].join("|")
        };
    }
    function refreshGenkaSummaryCurrencyDisplay() {
        rerender();
        Object.keys(totalgridapiRefs.current || {}).forEach((key) => {
            const refKey = String(key ?? "");
            if (!refKey.startsWith("19_") && !refKey.startsWith("genka_")) return;
            const api = DicVal(DicVal(totalgridapiRefs.current, refKey, null), "current", null);
            if (isEmpty(api)) return;
            if (typeof api.refreshCells === "function") api.refreshCells({ force: true });
            if (typeof api.redrawRows === "function") api.redrawRows();
        });
    }
    function requestGenkaSummaryCurrencyName(code) {
        const meta = getGenkaSummaryCurrencyMasterMeta(code);
        const targetCode = String(code ?? "").trim();
        if (isEmpty(meta) || targetCode === "") return false;
        if (isEnabled(DicVal(genkaSummaryCurrencyNameLoadingRef.current, meta.loadingKey, false))) return false;
        if (isEmpty(fnc.current) || typeof fnc.current.getMasterdata !== "function") return false;
        genkaSummaryCurrencyNameLoadingRef.current[meta.loadingKey] = true;
        const finish = function () {
            genkaSummaryCurrencyNameLoadingRef.current[meta.loadingKey] = false;
        };
        const others = [{ columnid: "SSDGM_TSUKATANI", dbcolumn: meta.dbcolumn }];
        try {
            fnc.current.getMasterdata(meta.dataid, targetCode, meta.keyinfo, others, entrydataRef.current, (data) => {
                try {
                    const name = pickFirstFukushizaiText(data, [meta.dbcolumn, "m_code_name", "M_CODE_NAME", "name", "label", "abbr"]);
                    if (name === "") return;
                    if (!isEmpty(fnc.current) && typeof fnc.current.setMaster === "function") {
                        const masterRow = { ...(isEmpty(data) ? {} : data), dataid: meta.dataid, code: targetCode };
                        if (meta.keyinfo !== "") masterRow.keyinfo = meta.keyinfo;
                        masterRow[meta.dbcolumn] = name;
                        fnc.current.setMaster(masterRow);
                    }
                    refreshGenkaSummaryCurrencyDisplay();
                } finally {
                    finish();
                }
            }, false);
            return true;
        } catch (e) {
            finish();
            return false;
        }
    }
    function readGenkaSummaryCurrencyName(code) {
        const targetCode = String(code ?? "").trim();
        if (targetCode === "") return "";
        const meta = getGenkaSummaryCurrencyMasterMeta(targetCode);
        if (isEmpty(meta)) return "";
        const name = readMasterStoreOptionName(meta.dataid, targetCode, [meta.dbcolumn, "m_code_name", "M_CODE_NAME", "name", "label", "abbr"]);
        if (name !== "") return name;
        requestGenkaSummaryCurrencyName(targetCode);
        return "";
    }
    function formatGenkaSummaryCurrencyDisplayValue(value) {
        const code = String(value ?? "").trim();
        if (code === "") return "";
        const name = String(readGenkaSummaryCurrencyName(code) ?? "").trim();
        return name === "" ? code : `${code}:${name}`;
    }
    function getGenkaSummaryTradeConditionMasterMeta(code = "") {
        const colInfo = genkaTradeConditionColInfo(findColumnInfoByCandidates(["SSDGM_BOUEKIJYOKEN"], [PANEL_TYPE.GENKA_SUMMARY, "127", "t2"]));
        const dataid = GENKA_TRADE_CONDITION_DATAID;
        const dbcolumn = readColumnMasterDbColumn(colInfo) || "m_code_name";
        const keyinfo = String(DicVal(colInfo, "keyinfo", "") ?? "").trim();
        const targetCode = String(code ?? "").trim();
        return {
            colInfo,
            dataid,
            dbcolumn,
            keyinfo,
            code: targetCode,
            loadingKey: [dataid, targetCode, keyinfo, dbcolumn].join("|")
        };
    }
    function requestGenkaSummaryTradeConditionName(code) {
        const meta = getGenkaSummaryTradeConditionMasterMeta(code);
        const targetCode = String(code ?? "").trim();
        if (targetCode === "") return false;
        if (isEnabled(DicVal(genkaSummaryCurrencyNameLoadingRef.current, meta.loadingKey, false))) return false;
        if (isEmpty(fnc.current) || typeof fnc.current.getMasterdata !== "function") return false;
        genkaSummaryCurrencyNameLoadingRef.current[meta.loadingKey] = true;
        const finish = function () {
            genkaSummaryCurrencyNameLoadingRef.current[meta.loadingKey] = false;
        };
        const others = [{ columnid: "SSDGM_BOUEKIJYOKEN", dbcolumn: meta.dbcolumn }];
        try {
            fnc.current.getMasterdata(meta.dataid, targetCode, meta.keyinfo, others, entrydataRef.current, (data) => {
                try {
                    const name = pickFirstFukushizaiText(data, [meta.dbcolumn, "m_code_name", "M_CODE_NAME", "name", "label", "abbr"]);
                    if (name === "") return;
                    if (!isEmpty(fnc.current) && typeof fnc.current.setMaster === "function") {
                        const masterRow = { ...(isEmpty(data) ? {} : data), dataid: meta.dataid, code: targetCode };
                        if (meta.keyinfo !== "") masterRow.keyinfo = meta.keyinfo;
                        masterRow[meta.dbcolumn] = name;
                        fnc.current.setMaster(masterRow);
                    }
                    refreshGenkaSummaryCurrencyDisplay();
                } finally {
                    finish();
                }
            }, false);
            return true;
        } catch (e) {
            finish();
            return false;
        }
    }
    function readGenkaSummaryTradeConditionName(code) {
        const targetCode = String(code ?? "").trim();
        if (targetCode === "") return "";
        const meta = getGenkaSummaryTradeConditionMasterMeta(targetCode);
        const name = readMasterStoreOptionName(meta.dataid, targetCode, [meta.dbcolumn, "m_code_name", "M_CODE_NAME", "name", "label", "abbr"]);
        if (name !== "") return name;
        requestGenkaSummaryTradeConditionName(targetCode);
        return "";
    }
    function formatGenkaSummaryTradeConditionDisplayValue(value) {
        const code = normalizeCodeValue(value);
        if (code === "") return "";
        const explicit = String(value ?? "").trim();
        if (explicit.indexOf(":") !== -1 || explicit.indexOf("：") !== -1) return explicit;
        const name = String(readGenkaSummaryTradeConditionName(code) ?? "").trim();
        return name === "" ? code : `${code}:${name}`;
    }
    function getGenkaSummaryGridDisplayValue(row, field) {
        const targetField = String(field ?? "").trim();
        if (targetField === "") return "";
        const raw = String(DicVal(row, targetField, "") ?? "").trim();
        if (raw === "") return "";
        const item = resolveGenkaSummaryItem(DicVal(row, "total_key", "") || DicVal(row, "total_item", ""));
        if (targetField === "total_value" && item === "SSDGM_BOUEKIJYOKEN") {
            return formatGenkaSummaryTradeConditionDisplayValue(raw);
        }
        if (targetField === "total_value" && item === "SSDGM_TSUKATANI") {
            return formatGenkaSummaryCurrencyDisplayValue(raw);
        }
        return raw;
    }
    function setGenkaSummaryGridValue(row, field, value) {
        if (isEmpty(row)) return false;
        const targetField = String(field ?? "").trim();
        if (targetField === "") return false;
        const item = resolveGenkaSummaryItem(DicVal(row, "total_key", "") || DicVal(row, "total_item", ""));
        row[targetField] = (targetField === "total_value" && item === "SSDGM_BOUEKIJYOKEN")
            ? normalizeCodeValue(value)
            : String(value ?? "");
        return true;
    }
    // 原価右合計: 行ごとのlayout設定に従って表示値を整形する。
    function formatGenkaSummaryDisplayValue(params, isValue2) {
        const raw = String(DicVal(params, "value", "") ?? "").trim();
        if (raw === "") return "";
        const item = resolveGenkaSummaryItem(DicVal(DicVal(params, "data", {}), "total_key", "") || DicVal(DicVal(params, "data", {}), "total_item", ""));
        const keepZero = isGenkaKeepZeroSummaryField(item, isValue2) || hasActualGenkaSummaryEntryValueForField(item, isValue2);
        if (isZeroLikeGenkaDisplayValue(raw) && !keepZero) return "";
        if (!isValue2 && item === "SSDGM_BOUEKIJYOKEN") return formatGenkaSummaryTradeConditionDisplayValue(raw);
        if (!isValue2 && item === "SSDGM_TSUKATANI") return formatGenkaSummaryCurrencyDisplayValue(raw);
        const cinfo = genkaSummaryValueColumnInfoByRow(DicVal(params, "data", {}), isValue2);
        if (String(cinfo.datatype ?? "") === "1") {
            const n = Number(raw.replace(/,/g, ""));
            if (Number.isFinite(n)) {
                const formatted = roundByDecimal(n, DicVal(cinfo, "decimalplace", 0));
                return isZeroLikeGenkaDisplayValue(formatted) && !keepZero ? "" : formatted;
            }
        }
        return isZeroLikeGenkaDisplayValue(raw) && !keepZero ? "" : raw;
    }
    function mapGenkaByColumnId(columnid) {
        const keyUpper = normalizeColumnIdUpper(columnid);
        if (keyUpper !== "" && (keyUpper in genkaColumnMapByColumnIdUpper)) return genkaColumnMapByColumnIdUpper[keyUpper];
        return null;
    }
    function genkaDisplaySlotsByColumnId(columnid, mapped = null) {
        const map = isEmpty(mapped) ? mapGenkaByColumnId(columnid) : mapped;
        if (isEmpty(map) || !Array.isArray(map.cols)) return [];
        const keyUpper = normalizeColumnIdUpper(columnid);
        if (keyUpper === "SSDGM_MARGINKIN_KTEHAI") return ["kojo"];
        return map.cols;
    }
    function applyExclusiveGenkaDisplaySlotPolicy(rowKey, row) {
        if (rowKey !== "MARGIN" || isEmpty(row)) return row;
        const next = { ...row };
        const kojo = String(DicVal(next, "kojo", "") ?? "").trim();
        const kojoF = String(DicVal(next, "kojo_f", "") ?? "").trim();
        if (kojo !== "" && kojoF !== "") {
            if (isGenkaTouchedCell("MARGIN", "kojo_f")) {
                next.kojo = "";
            } else if (isGenkaTouchedCell("MARGIN", "kojo")) {
                next.kojo_f = "";
            }
        }
        return next;
    }
    function toGenkaCellValueBySlots(row, slots) {
        if (isEmpty(row) || !Array.isArray(slots) || slots.length === 0) return "";
        for (let i = 0; i < slots.length; i++) {
            const key = String(slots[i] ?? "");
            if (key === "") continue;
            const v = String(DicVal(row, key, ""));
            if (v !== "") return v;
        }
        return "";
    }
    // 原価左の固定セル値を Column ID キーへ戻して保存用行を作る。
    function toGenkaSaveRows(rows, panelType) {
        if (!Array.isArray(rows)) return [];
        const pType = String(panelType ?? "");
        if (pType !== PANEL_TYPE.GENKA) return rows;
        if (isEmpty(columninfo)) return rows;
        const targetCols = columninfo.filter(c => String(c.type ?? "") === pType);
        if (targetCols.length === 0) return rows;

        const normalizedRows = normalizeGenkaRowsWithSkeleton(rows, entrydataRef.current);
        return normalizedRows.map((row, idx) => {
            const rowKey = toGenkaRowKey(DicVal(row, "row_key", "") || DicVal(row, "item_name", ""));
            const out = {
                rowid: String(DicVal(row, "rowid", idx)),
                row_key: rowKey,
                item_name: String(DicVal(row, "item_name", DicVal(genkaRowLabelByKey, rowKey, "")))
            };
            targetCols.forEach((c) => {
                const cid = String(c.columnid ?? "");
                if (cid === "" || cid === "rowid" || cid === "grip") return;
                const mapped = mapGenkaByColumnId(cid);
                if (isEmpty(mapped)) return;
                const mappedRow = toGenkaRowKey(mapped.row);
                if (mappedRow !== rowKey) return;
                const val = toGenkaCellValueBySlots(row, mapped.cols);
                const keepZero = Array.isArray(mapped.cols) && mapped.cols.some((slot) => hasActualGenkaEntryValueForCell(rowKey, slot));
                out[cid] = (String(val ?? "").trim() !== "" && !(isZeroLikeGenkaDisplayValue(val) && !keepZero))
                    ? val
                    : "";
            });
            ["SSDGM_HACHUKEITAI", "SSDGM_KAIGAIKBN", "SSDGM_ZANFLG"].forEach((fieldId) => {
                const value = readRowValueIgnoreCase(entrydataRef.current, fieldId);
                if (value !== undefined) out[fieldId] = value;
            });
            return out;
        }).filter(row => !isEmpty(row));
    }
    function toDemandSaveRows(rows, panelType) {
        if (!Array.isArray(rows)) return [];
        const type = canonicalPanelType(panelType);
        if (type !== "130" && type !== "131") return rows;
        const stripDemandUiOnlyFields = (row) => {
            const out = {};
            Object.keys(row || {}).forEach((key) => {
                const k = String(key ?? "");
                if (k === "row_kind" || k === "grip" || k === "expand") return;
                if (isDemandUiOnlyColumnId(k)) return;
                out[key] = row[key];
            });
            return out;
        };
        const saveCols = Array.isArray(columninfo)
            ? [...new Set(
                columninfo
                    .filter(c => canonicalPanelType(DicVal(c, "type", "")) === type)
                    .map(c => normalizeColumnIdUpper(DicVal(c, "columnid", "")))
                    .filter(cid => cid !== "" && cid !== "ROWID" && cid !== "GRIP" && !isDemandUiOnlyColumnId(cid))
            )]
            : [];
        const isSummaryRow = (row) => {
            const kind = String(DicVal(row, "row_kind", "")).trim();
            return kind === "subtotal" || kind === "total" || kind === "summary_label" || kind === "summary_total";
        };
        const detailRows = rows.filter(row => !isSummaryRow(row));
        if (saveCols.length === 0) {
            return detailRows.map(stripDemandUiOnlyFields);
        }
        const readValue = (row, cidUpper) => {
            if (isEmpty(row) || isEmpty(cidUpper)) return undefined;
            const keys = Object.keys(row);
            for (let i = 0; i < keys.length; i++) {
                const k = keys[i];
                if (normalizeColumnIdUpper(k) === cidUpper) return row[k];
            }
            return undefined;
        };
        return detailRows
            .map((row, idx) => {
                const out = { rowid: String(DicVal(row, "rowid", idx)) };
                saveCols.forEach((cidUpper) => {
                    const raw = readValue(row, cidUpper);
                    if (raw === undefined) return;
                    out[cidUpper] = raw;
                });
                return out;
            });
    }
    function isDemeritPanelInfo(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return canonicalPanelType(DicVal(panelInfo, "type", "")) === PANEL_TYPE.DEMERIT
            || String(DicVal(panelInfo, "id", "")).trim() === "17"
            || resolveSectionIdByGridPanel(panelInfo) === "demerit";
    }
    function toDemeritSaveRows(rows, contextOverride = null) {
        if (!Array.isArray(rows)) return [];
        const orderField = String(DicVal(getQualityPanelFieldMap(PANEL_TYPE.DEMERIT), "order", "") ?? "").trim();
        const context = normalizeFukushizaiContext(contextOverride || selectedQualityContextRef.current);
        // 論理削除済み(INVALID=1)の行は保存 payload へ載せない(送らない=物理削除)。
        // 送ると INVALID 列が保存可能列セットから strip され、サーバの既存行マージで
        // INVALID=0 に戻って削除したグループが復活する。早期 return の経路も含めて
        // 取得時点で除外しておく。
        const existingRows = getDetailRowsByPanelType(entrydetailRef.current, PANEL_TYPE.DEMERIT)
            .filter((row) => !isInvalidDisplayRow(row, PANEL_TYPE.DEMERIT));

        // context が未確定のときは現状の detail を維持する（全消しを防ぐ）。
        if (context.itemCd === "" || context.groupNo === "") return existingRows;

        // 表示中でないアイテム／グループの行を引き継ぐ。
        //
        // グリッドには選択中のグループしか出ないため、そのまま保存すると他グループの行が消える。
        // 他の品質表示系（toQualitySaveRows）は同じ引き継ぎを行っており、デメリットだけ抜けていた。
        // （例：グループ1を編集→グループ2へ切替→追加→登録 で、グループ1の内容が消える）
        const preservedRows = existingRows
            .filter((row) => {
                const rowContext = readFukushizaiItemGroupFromAnyRow(row);
                if (rowContext.itemCd === "" || rowContext.groupNo === "" || rowContext.colorCd === "") return false;
                return !rowMatchesFukushizaiItemGroup(row, context.itemCd, context.groupNo);
            })
            .map((row) => {
                const rowContext = readFukushizaiItemGroupFromAnyRow(row);
                const next = { ...row };
                setRowContextForPanel(next, PANEL_TYPE.DEMERIT, rowContext.itemCd, rowContext.groupNo, rowContext.colorCd);
                return next;
            });

        const fallbackColor = context.colorCd !== ""
            ? context.colorCd
            : qualityRepresentativeColorForContext(context, existingRows, PANEL_TYPE.DEMERIT);
        // 表示順は明細の統合キーの一部（加工指示番号＋アイテム＋表示順＋グループ＋カラー）。
        // 同一コンテキスト内で重複すると統合時に後勝ちでマージされ、行が消える。
        // 画面で追加した行は表示順を持たないため、表示順序でアイテム＋グループ＋カラーごとに振り直す。
        const orderCounters = {};
        const displaySaveRows = rows.map((row, idx) => {
            const out = { ...normalizeDemeritRowForSave(row), rowid: String(DicVal(row, "rowid", idx)) };
            // グリッド由来の行はアイテム／グループ／カラーを持たない。
            // 補完しないと保存自体は通るが、どのグループにも属さない行になり再表示されない。
            const rowContext = readFukushizaiItemGroupFromAnyRow(out);
            const itemCd = rowContext.itemCd !== "" ? rowContext.itemCd : context.itemCd;
            const groupNo = rowContext.groupNo !== "" ? rowContext.groupNo : context.groupNo;
            const colorCd = rowContext.colorCd !== "" ? rowContext.colorCd : fallbackColor;
            if (orderField !== "") {
                const contextKey = [itemCd, groupNo, colorCd].join("\u001f");
                const nextOrder = (Number(DicVal(orderCounters, contextKey, 0)) || 0) + 1;
                orderCounters[contextKey] = nextOrder;
                out[orderField] = String(nextOrder);
            }
            setRowContextForPanel(out, PANEL_TYPE.DEMERIT, itemCd, groupNo, colorCd);
            return out;
        });

        // 引き継ぎ行と混在するため rowid を振り直す。
        return [...preservedRows, ...displaySaveRows].map((row, index) => ({ ...row, rowid: String(index) }));
    }
    function isColorwaySaveType(type) {
        const t = canonicalPanelType(type);
        return t === PANEL_TYPE.MATERIAL_COLORWAY || t === PANEL_TYPE.ACCESSORY_COLORWAY;
    }
    function colorwayProductColorFieldId(type) {
        const t = canonicalPanelType(type);
        if (t === PANEL_TYPE.MATERIAL_COLORWAY) return "SSDSH_COLORCD";
        if (t === PANEL_TYPE.ACCESSORY_COLORWAY) return "SSDFH_COLORCD";
        return "";
    }
    function isColorwayProductColorField(type, columnId) {
        const fieldId = colorwayProductColorFieldId(type);
        return fieldId !== "" && normalizeColumnIdUpper(columnId) === normalizeColumnIdUpper(fieldId);
    }
    function isRowIdLikeColorwayCode(value, row = null) {
        const text = normalizeKakousijiUiString(value);
        if (text === "") return false;
        const rowid = normalizeKakousijiUiString(DicVal(row, "rowid", ""));
        if (rowid !== "" && text === rowid) return true;
        return /^rowid/i.test(text);
    }
    function normalizeColorwayMasterCode(value, row = null) {
        const text = normalizeKakousijiUiString(value).replace(/：/g, ":");
        if (text === "") return "";
        const code = extractMasterCodeFromDisplayValue(text);
        return isRowIdLikeColorwayCode(code, row) ? "" : code;
    }
    function normalizeColorwayMasterName(value) {
        const text = normalizeKakousijiUiString(value).replace(/：/g, ":");
        if (text === "" || text.indexOf(":") === -1) return text;
        return text.substring(text.indexOf(":") + 1).trim();
    }
    function firstColorwayProductColorCode(row, fieldId) {
        const keys = ["PDTC_COLORCD", "code", fieldId, `${fieldId}_cd`];
        for (let i = 0; i < keys.length; i++) {
            const code = normalizeColorwayMasterCode(readRowValueIgnoreCase(row, keys[i]), row);
            if (code !== "") return code;
        }
        return "";
    }
    function firstColorwayProductColorName(row, fieldId, code = "") {
        const keys = [`${fieldId}_nm`, "PDTC_COLORNM", "name", "label", fieldId];
        const targetCode = normalizeKakousijiUiString(code);
        for (let i = 0; i < keys.length; i++) {
            const source = readRowValueIgnoreCase(row, keys[i]);
            const sourceText = normalizeKakousijiUiString(source);
            if (targetCode !== "") {
                if (keys[i] === `${fieldId}_nm`) {
                    const relatedCode = normalizeColorwayMasterCode(readRowValueIgnoreCase(row, `${fieldId}_cd`), row);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
                if (keys[i] === "PDTC_COLORNM") {
                    const relatedCode = normalizeColorwayMasterCode(readRowValueIgnoreCase(row, "PDTC_COLORCD"), row);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                    const fieldCode = normalizeColorwayMasterCode(readRowValueIgnoreCase(row, `${fieldId}_cd`), row);
                    if (relatedCode === "" && fieldCode !== "" && fieldCode !== targetCode) continue;
                }
                if (keys[i] === "name" || keys[i] === "label") {
                    const fieldCode = normalizeColorwayMasterCode(readRowValueIgnoreCase(row, `${fieldId}_cd`), row);
                    if (fieldCode !== "" && fieldCode !== targetCode) continue;
                }
                if (keys[i] === fieldId) {
                    const relatedCode = normalizeColorwayMasterCode(source, row);
                    if (relatedCode !== "" && relatedCode !== targetCode) continue;
                }
            }
            if (keys[i] === fieldId && sourceText.indexOf(":") === -1 && sourceText.indexOf("：") === -1) continue;
            const name = normalizeColorwayMasterName(source);
            if (name !== "" && !isRowIdLikeColorwayCode(name, row)) return name;
        }
        return "";
    }
    function formatColorwayProductColorDisplay(code, name) {
        const colorCode = normalizeKakousijiUiString(code);
        const colorName = normalizeKakousijiUiString(name);
        if (colorCode === "") return "";
        return colorName === "" ? colorCode : `${colorCode}:${colorName}`;
    }
    function normalizeSsdshColorNoDisplayRow(row, rows = []) {
        if (isEmpty(row) || typeof row !== "object") return row;
        const fieldId = "SSDSH_COLORNO";
        const next = { ...row };
        const code = readSsdshColorNoCode(next, fieldId);
        const name = resolveSsdshColorNoName(next, fieldId, code, rows);
        if (code === "") {
            if (isRowIdLikeColorwayCode(readRowValueIgnoreCase(next, fieldId), next)) {
                next[fieldId] = "";
                next[`${fieldId}_cd`] = "";
            }
            return next;
        }
        next[fieldId] = formatColorwayProductColorDisplay(code, name);
        next[`${fieldId}_cd`] = code;
        next[`${fieldId}_nm`] = name;
        next.ZAIC_COLORCD = code;
        next.ZAIC_COLORNM = name;
        return next;
    }
    function normalizeSsdshColorNoDisplayRows(rows) {
        if (!Array.isArray(rows)) return [];
        return rows.map((row) => normalizeSsdshColorNoDisplayRow(row, rows));
    }
    function normalizeColorwayProductColorDisplayRow(row, panelType, rows = []) {
        if (isEmpty(row) || typeof row !== "object") return row;
        const fieldId = colorwayProductColorFieldId(panelType);
        if (fieldId === "") return row;
        const next = { ...row };
        const code = firstColorwayProductColorCode(next, fieldId);
        const name = resolveColorwayProductColorName(next, fieldId, code, rows);
        if (code === "") {
            if (isRowIdLikeColorwayCode(readRowValueIgnoreCase(next, fieldId), next)) {
                next[fieldId] = "";
                next[`${fieldId}_cd`] = "";
            }
            return next;
        }
        next[fieldId] = formatColorwayProductColorDisplay(code, name);
        next[`${fieldId}_cd`] = code;
        next[`${fieldId}_nm`] = name;
        return next;
    }
    function normalizeColorwayProductColorDisplayRows(rows, panelType) {
        if (!Array.isArray(rows) || !isColorwaySaveType(panelType)) return Array.isArray(rows) ? rows : [];
        return rows.map((row) => normalizeColorwayProductColorDisplayRow(row, panelType, rows));
    }
    function normalizeGridRowsForDisplay(panelInfo, rows) {
        const panelType = canonicalPanelType(DicVal(panelInfo, "type", ""));
        let nextRows = Array.isArray(rows) ? rows : [];
        if (panelType === PANEL_TYPE.JUTYUSU) nextRows = normalizeDemandJutyuDisplayRows(nextRows, panelType);
        if (isColorwaySaveType(panelType)) nextRows = normalizeColorwayProductColorDisplayRows(nextRows, panelType);
        if (panelType === PANEL_TYPE.MATERIAL_COLORWAY) nextRows = normalizeSsdshColorNoDisplayRows(nextRows);
        if (panelType === PANEL_TYPE.ACCESSORY_DETAIL) nextRows = recalcAccessoryDetailCalcRows(nextRows);
        if (panelType === PANEL_TYPE.MATERIAL_DETAIL) nextRows = recalcMaterialDetailCalcRows(nextRows);
        if (panelType === FUKUSHIZAI_LIST_PANEL_TYPE) nextRows = recalcFukushizaiListCalcRows(nextRows);
        nextRows = hydrateRowsForDisplay(panelInfo, nextRows);
        return nextRows;
    }
    function normalizeColorwayProductColorSaveValue(panelType, columnId, value, row = null) {
        if (!isColorwayProductColorField(panelType, columnId) && !isSsdshColorNoField(panelType, columnId)) return value;
        return normalizeColorwayMasterCode(value, row);
    }
    function isColorwayUiOnlyField(key) {
        const k = String(key ?? "");
        if (k === "rowKey" || k === "callRecords" || k === "__sourceRows") return true;
        if (k === "colno" || k === "colnm") return true;
        if (/^size_/.test(k)) return true;
        if (/^__col/.test(k) || /^__colnm/.test(k) || /^__size/.test(k)) return true;
        return false;
    }
    function colorwaySaveColumnIds(type) {
        if (!Array.isArray(columninfo)) return [];
        const t = canonicalPanelType(type);
        return [...new Set(
            columninfo
                .filter(c => canonicalPanelType(DicVal(c, "type", "")) === t)
                .filter(c => parseBoolLike(DicVal(c, "saveed", true), true))
                .map(c => String(DicVal(c, "columnid", "") ?? "").trim())
                .filter(cid => cid !== "" && cid.toUpperCase() !== "ROWID" && cid.toUpperCase() !== "GRIP" && !/^-+$/.test(cid))
        )];
    }
    function colorwayRequiredPhysicalKeyIds(type) {
        const t = canonicalPanelType(type);
        if (t === PANEL_TYPE.MATERIAL_COLORWAY) {
            return [
                "SSDSH_NO", "SSDSH_GYONO", "SSDSH_COLORCD", "SSDSH_COLORNO", "SSDSH_SIZECD",
                "SSDSH_COLORINDEX", "SSDSH_SIZEINDEX", "SSDSH_SIZAIKBN", "SSDSH_OPPICD",
                "SSDSH_SIIREKBN", "SSDSH_SIIRECD", "SSDSH_SIIRESUBCD", "SSDSH_ZAIHINBAN",
                "SSDSH_MAKERCOLORNO", "SSDSH_YOJAKUALL", "SSDSH_YOJAKU", "SSDSH_BUICD", "SSDSH_ZAISIZECD",
                "SSDSH_HACHUTAISYOFLG", "SSDSH_HACHUJYOKYOFLG", "SSDSH_FUKUSIZAIHACHUDENNO"
            ];
        }
        if (t === PANEL_TYPE.ACCESSORY_COLORWAY) {
            return [
                "SSDFH_NO", "SSDFH_GYONO", "SSDFH_COLORCD", "SSDFH_COLORNO", "SSDFH_SIZECD",
                "SSDFH_COLORINDEX", "SSDFH_SIZEINDEX", "SSDFH_OPPICD",
                "SSDFH_SIIREKBN", "SSDFH_SIIRECD", "SSDFH_SIIRESUBCD", "SSDFH_FUZOKU_HINBAN",
                "SSDFH_FUZOKU_SIZE", "SSDFH_YOJAKUALL", "SSDFH_YOJAKU",
                "SSDFH_HACHUTAISYOFLG", "SSDFH_HACHUJYOKYOFLG", "SSDFH_FUKUSIZAIHACHUDENNO"
            ];
        }
        return [];
    }
    function stripColorwayUiOnlyFields(row) {
        const out = {};
        Object.keys(row || {}).forEach((key) => {
            if (isColorwayUiOnlyField(key)) return;
            out[key] = row[key];
        });
        return out;
    }
    function buildColorwaySaveRow(panelType, row, sourceRow, rowIdx, sourceIdx) {
        const baseRow = stripColorwayUiOnlyFields(isEmpty(sourceRow) ? row : sourceRow);
        const out = { ...baseRow };
        const saveCols = colorwaySaveColumnIds(panelType);
        const keyCols = colorwayRequiredPhysicalKeyIds(panelType);
        const fallbackRowId = `${rowIdx}_${sourceIdx}`;
        const sourceRowId = isEmpty(sourceRow) ? undefined : readRowValueIgnoreCase(sourceRow, "rowid");
        const rowRowId = readRowValueIgnoreCase(row, "rowid");
        out.rowid = String(sourceRowId ?? rowRowId ?? fallbackRowId);

        keyCols.forEach((columnId) => {
            let value = undefined;
            if (!isEmpty(sourceRow)) value = readRowValueIgnoreCase(sourceRow, columnId);
            if (value === undefined) value = readRowValueIgnoreCase(row, columnId);
            if (value !== undefined) out[columnId] = normalizeColorwayProductColorSaveValue(panelType, columnId, value, sourceRow);
        });

        saveCols.forEach((columnId) => {
            if (isColorwayUiOnlyField(columnId)) return;
            let value = readRowValueIgnoreCase(row, columnId);
            if (value === undefined && !isEmpty(sourceRow)) value = readRowValueIgnoreCase(sourceRow, columnId);
            if (value !== undefined) out[columnId] = normalizeColorwayProductColorSaveValue(panelType, columnId, value, sourceRow);
        });

        return out;
    }
    function toColorwaySaveRows(rows, panelType) {
        if (!Array.isArray(rows)) return [];
        const saveCols = colorwaySaveColumnIds(panelType);
        if (saveCols.length === 0) return null;
        const outRows = [];
        rows.forEach((row, rowIdx) => {
            const sourceRows = Array.isArray(DicVal(row, "__sourceRows", null)) ? row.__sourceRows : [];
            if (sourceRows.length === 0) {
                outRows.push(buildColorwaySaveRow(panelType, row, null, rowIdx, 0));
                return;
            }
            sourceRows.forEach((sourceRow, sourceIdx) => {
                outRows.push(buildColorwaySaveRow(panelType, row, sourceRow, rowIdx, sourceIdx));
            });
        });
        return outRows;
    }
    function toDetailSaveRows(rows, panelType) {
        const type = canonicalPanelType(panelType);
        if (type === PANEL_TYPE.GENKA) return toGenkaSaveRows(rows, panelType);
        if (isColorwaySaveType(type)) return toColorwaySaveRows(rows, type);
        if (type === PANEL_TYPE.DEMERIT) return toDemeritSaveRows(rows, selectedQualityContextRef.current);
        if (type === PANEL_TYPE.WASH) return toWashSaveRows(rows, selectedQualityContextRef.current);
        if (isQualityPanelType(type) && type !== PANEL_TYPE.QUALITY_BASE) {
            // 119-122 は保存直前の flushQualityDisplayGridsToDetail が表示グリッドを
            // toQualitySaveRows で detail へ確定済み(セル編集・行増減時も都度同期済み)。
            // ここで再変換すると toQualitySaveRows が保存経路で二重実行されるため、
            // flush 済みの detail を正としてそのまま payload に載せる。
            // 論理削除済み行は「送らない=物理削除」の契約に従い除外する。
            return getDetailRowsByPanelType(entrydetailRef.current, type)
                .filter((row) => !isInvalidDisplayRow(row, type));
        }
        if (type === PANEL_TYPE.BRAND_NAME) return [];
        if (type === PANEL_TYPE.OTHER_NAME) return [];
        if (type === PANEL_TYPE.OTHER_FUKUZAI) return [];
        if (type === PANEL_TYPE.KOMONOFUDA) {
            return [];
        }
        if (type === PANEL_TYPE.JUTYUSU || type === PANEL_TYPE.NOUHIN_YOTEI) return toDemandSaveRows(rows, type);
        if (!isEmpty(DETAIL_CALC_CONFIG_BY_TYPE[type])) return toCurrencyPriceSaveRows(rows, type);
        return Array.isArray(rows) ? rows : [];
    }
    // 保存直前に通貨ルールを再適用する。
    // 新規登録は forms/InsertEntry を使いサーバ側の加工指示用正規化を通らないため、ここが最後の防波堤になる。
    function toCurrencyPriceSaveRows(rows, panelType) {
        const config = DETAIL_CALC_CONFIG_BY_TYPE[canonicalPanelType(panelType)];
        if (!Array.isArray(rows) || isEmpty(config)) return Array.isArray(rows) ? rows : [];
        return rows.map((row) => {
            if (isEmpty(row) || typeof row !== "object") return row;
            return applyCurrencyPriceRuleToRow({ ...row }, config);
        });
    }
    function shouldSaveDetailType(typeKey) {
        const key = canonicalPanelType(typeKey);
        if (key === "" || key === PANEL_TYPE.JUTYUSU) return false;
        // 登録グループ(125)は画面・処理を廃止済み。ロード時スナップショット経由でも保存へ送らない
        // (D_SSDQへは品質表示(118/119)側の保存経路だけを使う)。
        if (key === PANEL_TYPE.REGISTERED_GROUP) return false;
        const mode = String(kakouShijiKubun ?? "").trim().toLowerCase();
        if (mode === "sample") return SAMPLE_SAVE_DETAIL_TYPE_SET.has(key);
        return !SAMPLE_SAVE_DETAIL_TYPE_SET.has(key);
    }
    function buildGenkaRowsFromFlatData(entryObj) {
        if (isEmpty(columninfo) || isEmpty(entryObj)) return [];
        const rows = {};
        genkaRowDefs.forEach((d, idx) => { rows[d.key] = emptyGenkaRow(d.key, d.label, idx); });
        const genkaCols = columninfo.filter(c => String(c.type ?? "") === PANEL_TYPE.GENKA || String(c.type ?? "") === "genka");
        if (genkaCols.length === 0) return genkaRowKeyOrder.map((k) => rows[k]);

        genkaCols.forEach((c) => {
            const cid = String(c.columnid ?? "");
            if (cid === "" || !(cid in entryObj)) return;
            const v = entryObj[cid];
            const val = String(v ?? "");
            if (val === "") return;

            // Column IDのみで割当（表示名フォールバックなし）
            const fromId = mapGenkaByColumnId(cid);
            const fromIdRow = canonicalGenkaRowName(fromId?.row ?? "");
            if (!isEmpty(fromId) && !isEmpty(rows[fromIdRow])) {
                genkaDisplaySlotsByColumnId(cid, fromId).forEach((t) => { rows[fromIdRow][t] = val; });
            }
        });

        // 構成比率は対象行以外を空に固定
        Object.keys(rows).forEach((rk) => {
            if (!isEnabled(genkaKouseiEnabledRows[rk])) rows[rk].kousei = "";
        });
        return genkaRowKeyOrder.map((k) => applyExclusiveGenkaDisplaySlotPolicy(k, rows[k]));
    }
    function normalizeGenkaRowsWithSkeleton(rows, entryObj) {
        const skeleton = {};
        genkaRowDefs.forEach((d, idx) => { skeleton[d.key] = emptyGenkaRow(d.key, d.label, idx); });
        const copySlots = function (to, from) {
            ["muryo", "muryo_f", "yusho", "yusho_f", "kojo", "kojo_f", "syokei", "syokei_f", "kousei"].forEach((k) => {
                const v = String(from?.[k] ?? "");
                if (v !== "") to[k] = v;
            });
        };
        const mergeRow = function (src) {
            const rowKey = toGenkaRowKey(DicVal(src, "row_key", "") || DicVal(src, "item_name", ""));
            if (isEmpty(rowKey) || isEmpty(skeleton[rowKey])) return;
            const to = skeleton[rowKey];
            copySlots(to, src);
            // 返却行が columnid ベースの場合を救済
            const keys = Object.keys(src || {});
            keys.forEach((k) => {
                if (["rowid", "grip", "row_key", "item_name"].includes(k)) return;
                const map = mapGenkaByColumnId(k);
                if (isEmpty(map)) return;
                const mappedRow = toGenkaRowKey(map.row);
                if (mappedRow !== rowKey) return;
                const value = String(src[k] ?? "");
                if (value === "") return;
                genkaDisplaySlotsByColumnId(k, map).forEach((slot) => {
                    if (!isEmpty(slot)) to[slot] = value;
                });
            });
        };
        // flat側の値も最終補完としてマージ
        const rebuilt = buildGenkaRowsFromFlatData(entryObj);
        if (Array.isArray(rebuilt) && rebuilt.length !== 0) {
            rebuilt.forEach((r) => mergeRow(r));
        }
        if (Array.isArray(rows)) rows.forEach((r) => mergeRow(r));
        return genkaRowKeyOrder.map((k) => applyExclusiveGenkaDisplaySlotPolicy(k, skeleton[k]));
    }
    function buildGenkaSkeletonRows() {
        return genkaRowDefs.map((d, idx) => ({ ...emptyGenkaRow(d.key, d.label, idx), __displayOnly: true }));
    }
    function buildGenkaRowsForDisplay(entryObj) {
        let rows = buildGenkaRowsFromFlatData(entryObj);
        if (!Array.isArray(rows) || rows.length === 0) rows = buildGenkaSkeletonRows();
        rows = normalizeGenkaRowsWithSkeleton(rows, entryObj);
        rows = normalizeGenkaRowsByPattern(rows);
        rows = normalizeGenkaRowsByLayoutPrecision(rows);
        return blankDefaultZeroGenkaRows(rows);
    }
    function ensureGenkaDisplayRows(rows, entryObj) {
        const normalized = normalizeGenkaRowsWithSkeleton(rows, entryObj);
        const hasLabel = Array.isArray(normalized) && normalized.some((r) => String(r?.item_name ?? "").trim() !== "");
        if (!hasLabel) {
            return blankDefaultZeroGenkaRows(normalizeGenkaRowsByLayoutPrecision(normalizeGenkaRowsByPattern(buildGenkaSkeletonRows())));
        }
        return blankDefaultZeroGenkaRows(normalizeGenkaRowsByLayoutPrecision(normalizeGenkaRowsByPattern(normalized)));
    }
    function ensureGenkaRowsBound() {
        try {
            if (isEmpty(gridlist) || gridlist.length === 0) return;
            const genkaPanel = gridlist.find(g => isGenkaGridPanelInfo(g));
            if (isEmpty(genkaPanel)) return;
        } catch (e) { console.error(e); }
    }
    function ensureWashRowsBound() {
        try {
            if (isEmpty(gridlist) || gridlist.length === 0) return;
            const washPanel = gridlist.find(g => isWashPanelInfo(g));
            if (isEmpty(washPanel)) return;
        } catch (e) { console.error(e); }
    }
    function buildGenkaSummaryRowsFromFlatData(entryObj) {
        if (isEmpty(entryObj)) return [];
        const rows = {};
        genkaSummaryOrder.forEach((name, idx) => { rows[name] = emptyGenkaSummaryRow(name, idx); });
        // 項目ごとの正規Column ID候補を優先して反映する。
        genkaSummaryOrder.forEach((item) => {
            const conf = genkaSummaryColumnCandidates[item];
            if (isEmpty(conf)) return;
            const v1 = findEntryValue(entryObj, conf.value || []);
            const v2 = findEntryValue(entryObj, conf.value2 || []);
            if (String(v1 ?? "").trim() !== "") rows[item].total_value = String(v1);
            if (String(v2 ?? "").trim() !== "") rows[item].total_value2 = String(v2);
        });
        return blankDefaultZeroGenkaSummaryRows(applyForcedGenkaJpyToSummaryRows(genkaSummaryOrder.map((n) => rows[n])));
    }
    function isGenkaHorizontalDetailRow(row) {
        if (isEmpty(row) || typeof row !== "object") return false;
        return Object.keys(row).some((key) => String(key ?? "").startsWith("SSDGM_"));
    }
    function findGenkaHorizontalDetailRow(detailData) {
        if (isEmpty(detailData)) return null;
        const candidates = [PANEL_TYPE.GENKA, PANEL_TYPE.GENKA_SUMMARY, "genka"];
        for (let i = 0; i < candidates.length; i++) {
            const rows = DicVal(detailData, candidates[i], null);
            if (!Array.isArray(rows) || rows.length === 0) continue;
            const hit = rows.find((row) => isGenkaHorizontalDetailRow(row));
            if (!isEmpty(hit)) return hit;
        }
        return null;
    }
    function mergeGenkaHorizontalDetailRow(entryObj, detailData) {
        if (isEmpty(entryObj) || isEmpty(detailData)) return false;
        const row = findGenkaHorizontalDetailRow(detailData);
        if (isEmpty(row)) return false;
        Object.keys(row).forEach((key) => {
            if (String(key ?? "") === "") return;
            const value = row[key];
            if (value === null || value === undefined) return;
            if (String(value).trim() === "") return;
            entryObj[key] = value;
        });
        detailData[PANEL_TYPE.GENKA] = buildGenkaRowsForDisplay(entryObj);
        detailData[PANEL_TYPE.GENKA_SUMMARY] = buildGenkaSummaryRowsFromFlatData(entryObj);
        return true;
    }
    function currentGenkaPatternNo() {
        const forced = resolveTempGenkaPatternNo();
        if (forced !== 0) return forced;
        const stateNo = Number(genkaPatternNo);
        if (Number.isFinite(stateNo) && stateNo !== 0) return stateNo;
        const derived = Number(deriveGenkaPatternFromEntry(entrydataRef.current));
        if (Number.isFinite(derived)) return derived;
        const m = String(genkaPattern ?? "").match(/^\s*(\d+)/);
        if (isEmpty(m)) return 0;
        return Number(m[1]);
    }
    function genkaColSlot(colId) {
        const cid = String(colId ?? "").trim();
        if (["item_name", "muryo", "muryo_f", "yusho", "yusho_f", "kojo", "kojo_f", "syokei", "syokei_f", "kousei"].includes(cid)) return cid;
        const mapped = mapGenkaByColumnId(cid);
        if (!isEmpty(mapped) && Array.isArray(mapped.cols) && mapped.cols.length !== 0) return String(mapped.cols[0] ?? "");
        return cid;
    }
    function normalizeCodeValue(raw) {
        const s = String(raw ?? "").trim();
        if (s === "") return "";
        const m = s.match(/^(-?\d+)/);
        if (!isEmpty(m)) return m[1];
        return s;
    }
    // 指定typeの候補配列を返す。
    function resolveTypeCandidates(type) {
        return typeColumnResolver.resolveTypeCandidates(type);
    }
    // 指定typeのcolumnidを、suffix候補（正規化後）で解決する。
    function resolveTypeColumnIdBySuffix(type, suffixCandidates) {
        return typeColumnResolver.resolveTypeColumnIdBySuffix(type, suffixCandidates);
    }
    // 指定typeのcolumnnmを候補名で解決する（columnidが "-" などの場合の補助）。
    function resolveTypeColumnIdByName(type, nameCandidates) {
        return typeColumnResolver.resolveTypeColumnIdByName(type, nameCandidates);
    }
    // 指定type + columnid から columnnm を取得する。
    function resolveTypeColumnNameById(type, columnId) {
        return typeColumnResolver.resolveTypeColumnNameById(type, columnId);
    }
    function findEntryValue(entryObj, candidates) {
        if (isEmpty(entryObj) || isEmpty(candidates) || candidates.length === 0) return "";
        const keys = Object.keys(entryObj);
        for (let i = 0; i < candidates.length; i++) {
            const cand = String(candidates[i] ?? "");
            if (cand === "") continue;
            if (cand in entryObj && String(entryObj[cand] ?? "").trim() !== "") return entryObj[cand];
            const low = cand.toLowerCase();
            const byKey = keys.find(k => String(k).toLowerCase() === low);
            if (!isEmpty(byKey) && String(entryObj[byKey] ?? "").trim() !== "") return entryObj[byKey];
        }
        return "";
    }
    // =====================================================================
    // サステナブル 128/129
    // ---------------------------------------------------------------------
    // 画像ファイル名と予備項目を D_SSDSAS の保存行へまとめる。
    // NOTE: ファイル名は画面内inputで編集する。
    // =====================================================================

    function sustainableDisplayTextFields(source, panelType) {
        return createSustainableImageService(buildSustainableImageServiceDeps()).sustainableDisplayTextFields(source, panelType);
    }
    function readSustainableImageFileName(source) {
        return createSustainableImageService(buildSustainableImageServiceDeps()).readSustainableImageFileName(source);
    }
    function commitSustainableImageFileName() {
        return createSustainableImageService(buildSustainableImageServiceDeps()).commitSustainableImageFileName();
    }
    function handleSustainableImageFileNameKeyDown(event) {
        return createSustainableImageService(buildSustainableImageServiceDeps()).handleSustainableImageFileNameKeyDown(event);
    }
    function handleSustainableImagePanelClick(event) {
        return createSustainableImageService(buildSustainableImageServiceDeps()).handleSustainableImagePanelClick(event);
    }
    // サステナブル画像ファイル名の編集補助へ渡す依存関係をまとめます。
    function buildSustainableImageServiceDeps() {
        return {
            PANEL_TYPE,
            SUSTAINABLE_IMAGE_FILE_FIELD,
            normalizeKakousijiUiString,
            readRowValueIgnoreCase,
            isEmpty,
            fnc,
            getEntryLock: () => entrylock,
            getLayoutLock: () => layoutlock,
            entrydataRef,
            getSustainableImageFileInputValue: () => sustainableImageFileInputValue,
            sustainableImageFileCancelBlurRef,
            setSustainableImageFileInputValue,
            setSustainableImageFileEditing,
            loadSustainableImageFromServer,
            rerender
        };
    }
    function loadSustainableImageFromServer(source) {
        const seq = sustainableImageRequestSeqRef.current + 1;
        sustainableImageRequestSeqRef.current = seq;
        setSustainableServerImageUrl("");

        const fileName = readSustainableImageFileName(source || entrydataRef.current);
        if (fileName === "") return;
        if (isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") return;

        fnc.current.postaxios("kakousiji/GetSustainableImage", {
            corpkey,
            account,
            fileName
        }, {
            onSuccess: function (data) {
                if (sustainableImageRequestSeqRef.current !== seq) return;
                const imageUrl = normalizeKakousijiUiString(DicVal(DicVal(data, "data", {}), "imageUrl", ""));
                setSustainableServerImageUrl(imageUrl);
            },
            onError: function () {
                if (sustainableImageRequestSeqRef.current !== seq) return;
                setSustainableServerImageUrl("");
            }
        }, true);
    }
    function genkaPatternLabelByNo(no) {
        const labels = {
            1: "1:国内無償",
            2: "2:国内有償",
            3: "3:国内商品仕入",
            4: "4:海外無償（円貨）",
            5: "5:海外無償（外貨）",
            6: "6:海外有償（円貨）",
            7: "7:海外有償（外貨）",
            8: "8:海外商品仕入（円貨）",
            9: "9:海外商品仕入（外貨）"
        };
        return labels[Number(no)] || "";
    }
    function genkaCurrencyDisplayLabel(value) {
        const code = String(value ?? "").trim().toUpperCase();
        if (code === "") return "";
        return code === "JPY" ? "円貨" : "外貨";
    }
    const genkaSsdNoColumnIdCandidates = ["SSD_NO", "SSDM_NO", "SSDS_NO", "SSDSH_NO", "SSDF_NO", "SSDFH_NO", "SSDZM_NO"];
    const genkaKaigaiKbnColumnIdCandidates = ["SSD_KAIGAIKBN", "SSDS_KAIGAIKBN", "SSDF_KAIGAIKBN", "SSDZM_KAIGAIKBN"];
    const genkaBrandKbnColumnIdCandidates = ["BRD_BRANDKBN"];
    const genkaYushoMushoKbnColumnIdCandidates = ["TOR_YUSHOMUSHOKBN"];
    const genkaShohinKbnColumnIdCandidates = ["PDT_SHOHINKBN"];
    const genkaOppiCdColumnIdCandidates = ["SSD_OPPICD", "SSDS_OPPICD", "SSDSH_OPPICD", "SSDF_OPPICD", "SSDZM_OPPICD", "PDT_OPPICD", "SSDM_OPPICD"];
    const genkaKakouSakiKbnColumnIdCandidates = ["SSD_KAKOUSAKIKBN", "SSDS_KAKOUSAKIKBN", "SSDF_KAKOUSAKIKBN", "SSDZM_KAKOUSAKIKBN"];
    const genkaKakouSakiCdColumnIdCandidates = ["SSD_KAKOUSAKICD", "SSDS_KAKOUSAKICD", "SSDF_KAKOUSAKICD", "SSDZM_KAKOUSAKICD"];
    const genkaKakouSakiSubCdColumnIdCandidates = ["SSD_KAKOUSAKISUBCD", "SSDS_KAKOUSAKISUBCD", "SSDF_KAKOUSAKISUBCD", "SSDZM_KAKOUSAKISUBCD"];
    const genkaSupplierCurrencyColumnIdCandidates = ["SSD_TSUKATANI", "SSDS_TSUKATANI", "SSDF_TSUKATANI", "SSDZM_TSUKATANI", "SSDGM_TSUKATANI"];
    function isJpyCurrencyValue(value) {
        return String(value ?? "").trim().toUpperCase() === "JPY";
    }
    function shouldForceGenkaCurrencyJpy(entryObj) {
        if (isEmpty(entryObj)) return false;
        const supplierCurrency = findEntryValue(entryObj, genkaSupplierCurrencyColumnIdCandidates);
        return isJpyCurrencyValue(supplierCurrency);
    }
    function deriveGenkaPatternFromEntry(entryObj) {
        if (isEmpty(entryObj)) return;
        // Column ID（大文字）基準のみで判定する。
        const kaigaiRaw = findEntryValue(entryObj, genkaKaigaiKbnColumnIdCandidates);
        const brandRaw = findEntryValue(entryObj, genkaBrandKbnColumnIdCandidates);
        const yushoRaw = findEntryValue(entryObj, genkaYushoMushoKbnColumnIdCandidates);
        const shohinRaw = findEntryValue(entryObj, genkaShohinKbnColumnIdCandidates);
        const tsukaRaw = findEntryValue(entryObj, genkaSupplierCurrencyColumnIdCandidates);

        const kaigai = normalizeCodeValue(kaigaiRaw); // 1:国内 / 2:海外
        const brand = normalizeCodeValue(brandRaw);   // 0:製品 / 1:商品
        const yusho = normalizeCodeValue(yushoRaw);   // 2:無償 / 1:有償
        const shohin = normalizeCodeValue(shohinRaw); // 01:製商品 / 03:貸与品 / 04:販促品 等
        const isJPY = isJpyCurrencyValue(tsukaRaw);
        const isShohin01 = shohin === "01" || shohin === "1";
        const isShohin03 = shohin === "03" || shohin === "3";
        const isShohin04 = shohin === "04" || shohin === "4";
        const isShohin010304 = isShohin01 || isShohin03 || isShohin04;

        // 仕様書「3.原価計算パターン」の 9 パターンをそのまま判定する。
        if (kaigai === "1" && brand === "0" && yusho === "2" && isJPY && isShohin01) return 1;
        if (kaigai === "1" && brand === "0" && yusho === "1" && isJPY && isShohin03) return 2;
        if (kaigai === "1" && brand === "1" && yusho === "2" && isJPY && isShohin010304) return 3;
        if (kaigai === "2" && brand === "0" && yusho === "2" && isJPY) return 4;
        if (kaigai === "2" && brand === "0" && yusho === "2" && !isJPY) return 5;
        if (kaigai === "2" && brand === "0" && yusho === "1" && isJPY) return 6;
        if (kaigai === "2" && brand === "0" && yusho === "1" && !isJPY) return 7;
        if (kaigai === "2" && brand === "1" && yusho === "2" && isJPY) return 8;
        if (kaigai === "2" && brand === "1" && yusho === "2" && !isJPY) return 9;
    }
    function syncGenkaPatternByEntry(entryObj) {
        const patternNo = deriveGenkaPatternFromEntry(entryObj);
        setGenkaPattern(genkaPatternLabelByNo(patternNo));
    }
    function deriveGenkaPatternFromEntry(entryObj) {
        if (isEmpty(entryObj)) return;
        // Column ID（大文字）基準のみで判定する。
        const kaigaiRaw = findEntryValue(entryObj, genkaKaigaiKbnColumnIdCandidates);
        const brandRaw = findEntryValue(entryObj, genkaBrandKbnColumnIdCandidates);
        const yushoRaw = findEntryValue(entryObj, genkaYushoMushoKbnColumnIdCandidates);
        const shohinRaw = findEntryValue(entryObj, genkaShohinKbnColumnIdCandidates);
        const tsukaRaw = findEntryValue(entryObj, genkaSupplierCurrencyColumnIdCandidates);

        const kaigai = normalizeCodeValue(kaigaiRaw); // 1:国内 / 2:海外
        const brand = normalizeCodeValue(brandRaw);   // 0:製品 / 1:商品
        const yusho = normalizeCodeValue(yushoRaw);   // 2:無償 / 1:有償
        const shohin = normalizeCodeValue(shohinRaw); // 01:製商品 / 03:貸与品 / 04:販促品 等
        const isJPY = isJpyCurrencyValue(tsukaRaw);
        const isShohin01 = shohin === "01" || shohin === "1";
        const isShohin03 = shohin === "03" || shohin === "3";
        const isShohin04 = shohin === "04" || shohin === "4";
        const isShohin010304 = isShohin01 || isShohin03 || isShohin04;

        // 仕様書「3.原価計算パターン」の 9 パターンをそのまま判定する。
        if (kaigai === "1" && brand === "0" && yusho === "2" && isJPY && isShohin01) return 1;
        if (kaigai === "1" && brand === "0" && yusho === "1" && isJPY && isShohin03) return 2;
        if (kaigai === "1" && brand === "1" && yusho === "2" && isJPY && isShohin010304) return 3;
        if (kaigai === "2" && brand === "0" && yusho === "2" && isJPY) return 4;
        if (kaigai === "2" && brand === "0" && yusho === "2" && !isJPY) return 5;
        if (kaigai === "2" && brand === "0" && yusho === "1" && isJPY) return 6;
        if (kaigai === "2" && brand === "0" && yusho === "1" && !isJPY) return 7;
        if (kaigai === "2" && brand === "1" && yusho === "2" && isJPY) return 8;
        if (kaigai === "2" && brand === "1" && yusho === "2" && !isJPY) return 9;
    }
    function syncGenkaPatternByEntry(entryObj) {
        const patternNo = deriveGenkaPatternFromEntry(entryObj);
        setGenkaPattern(genkaPatternLabelByNo(patternNo));
    }
    function deriveGenkaPatternFromEntry(entryObj) {
        if (isEmpty(entryObj)) return;
        // Column ID（大文字）基準のみで判定する。
        const kaigaiRaw = findEntryValue(entryObj, genkaKaigaiKbnColumnIdCandidates);
        const brandRaw = findEntryValue(entryObj, genkaBrandKbnColumnIdCandidates);
        const yushoRaw = findEntryValue(entryObj, genkaYushoMushoKbnColumnIdCandidates);
        const shohinRaw = findEntryValue(entryObj, genkaShohinKbnColumnIdCandidates);
        const tsukaRaw = findEntryValue(entryObj, genkaSupplierCurrencyColumnIdCandidates);

        const kaigai = normalizeCodeValue(kaigaiRaw); // 1:国内 / 2:海外
        const brand = normalizeCodeValue(brandRaw);   // 0:製品 / 1:商品
        const yusho = normalizeCodeValue(yushoRaw);   // 2:無償 / 1:有償
        const shohin = normalizeCodeValue(shohinRaw); // 01:製商品 / 03:貸与品 / 04:販促品 等
        const isJPY = isJpyCurrencyValue(tsukaRaw);
        const isShohin01 = shohin === "01" || shohin === "1";
        const isShohin03 = shohin === "03" || shohin === "3";
        const isShohin04 = shohin === "04" || shohin === "4";
        const isShohin010304 = isShohin01 || isShohin03 || isShohin04;

        // 仕様書「3.原価計算パターン」の 9 パターンをそのまま判定する。
        if (kaigai === "1" && brand === "0" && yusho === "2" && isJPY && isShohin01) return 1;
        if (kaigai === "1" && brand === "0" && yusho === "1" && isJPY && isShohin03) return 2;
        if (kaigai === "1" && brand === "1" && yusho === "2" && isJPY && isShohin010304) return 3;
        if (kaigai === "2" && brand === "0" && yusho === "2" && isJPY) return 4;
        if (kaigai === "2" && brand === "0" && yusho === "2" && !isJPY) return 5;
        if (kaigai === "2" && brand === "0" && yusho === "1" && isJPY) return 6;
        if (kaigai === "2" && brand === "0" && yusho === "1" && !isJPY) return 7;
        if (kaigai === "2" && brand === "1" && yusho === "2" && isJPY) return 8;
        if (kaigai === "2" && brand === "1" && yusho === "2" && !isJPY) return 9;
    }
    function syncGenkaPatternByEntry(entryObj, code = edittingcode) {
        const requestCode = (typeof code === "string" || typeof code === "number") ? code : edittingcode;
        autoGenkaPatternWatchKeyRef.current = buildGenkaPatternWatchState(entryObj, requestCode).watchKey;
        loadGenkaPattern(requestCode, entryObj);
    }
    function normalizeGenkaPatternNo(value) {
        const num = Number(value);
        if (!Number.isFinite(num)) return 0;
        return num;
    }
    function applyGenkaPatternResult(source) {
        const patternNo = normalizeGenkaPatternNo(DicVal(source, "patternNo", DicVal(source, "PatternNo", 0)));
        const patternName = String(DicVal(source, "patternName", DicVal(source, "PatternName", "")) ?? "").trim();
        setGenkaPatternNo(patternNo);
        setGenkaPattern(patternName !== "" ? patternName : genkaPatternLabelByNo(patternNo));
        requestGenkaGridEditableRefresh();
    }
    function applyGenkaPatternFallback(entryObj) {
        const fallbackNo = deriveGenkaPatternFromEntry(entryObj);
        setGenkaPatternNo(0);
        setGenkaPattern(genkaPatternLabelByNo(fallbackNo));
        requestGenkaGridEditableRefresh();
    }
    function resolveGenkaPatternRequestCode(code, entryObj) {
        const direct = String(
            (typeof code === "string" || typeof code === "number")
                ? code
                : ""
        ).trim();
        if (direct !== "") return direct;

        const fromEntry = String(findEntryValue(entryObj, genkaSsdNoColumnIdCandidates) ?? "").trim();
        if (fromEntry !== "") return fromEntry;

        return String(resolveEntryCode(entryObj, "") ?? "").trim();
    }
    function buildGenkaPatternWatchState(entryObj, code = edittingcode) {
        const request = buildGenkaPatternRequest(code, entryObj);
        const watchValues = [
            String(request.code ?? "").trim(),
            String(request.oppiCd ?? "").trim(),
            String(request.kaigaiKbn ?? "").trim(),
            String(request.kakouSakiKbn ?? "").trim(),
            String(request.kakouSakiCd ?? "").trim(),
            String(request.kakouSakiSubCd ?? "").trim(),
            String(request.tsukaTani ?? "").trim()
        ];
        const ready = watchValues.slice(1).every((value) => value !== "");
        return {
            request,
            watchKey: watchValues.join("|"),
            ready
        };
    }
    function buildGenkaPatternRequest(code, entryObj) {
        const request = {
            controller: controller,
            code: resolveGenkaPatternRequestCode(code, entryObj)
        };
        const oppiCd = String(findEntryValue(entryObj, genkaOppiCdColumnIdCandidates) ?? "").trim();
        const kaigaiKbn = String(findEntryValue(entryObj, genkaKaigaiKbnColumnIdCandidates) ?? "").trim();
        const kakouSakiKbn = String(findEntryValue(entryObj, genkaKakouSakiKbnColumnIdCandidates) ?? "").trim();
        const kakouSakiCd = String(findEntryValue(entryObj, genkaKakouSakiCdColumnIdCandidates) ?? "").trim();
        const kakouSakiSubCd = String(findEntryValue(entryObj, genkaKakouSakiSubCdColumnIdCandidates) ?? "").trim();
        const tsukaTani = String(findEntryValue(entryObj, genkaSupplierCurrencyColumnIdCandidates) ?? "").trim();
        if (oppiCd !== "") request.oppiCd = oppiCd;
        if (kaigaiKbn !== "") request.kaigaiKbn = kaigaiKbn;
        if (kakouSakiKbn !== "") request.kakouSakiKbn = kakouSakiKbn;
        if (kakouSakiCd !== "") request.kakouSakiCd = kakouSakiCd;
        if (kakouSakiSubCd !== "") request.kakouSakiSubCd = kakouSakiSubCd;
        if (tsukaTani !== "") request.tsukaTani = tsukaTani;
        return request;
    }
    function loadGenkaPattern(code, entryObj = entrydataRef.current) {
        const request = buildGenkaPatternRequest(code, entryObj);
        const hasSourceValue = [
            request.code,
            request.oppiCd,
            request.kaigaiKbn,
            request.kakouSakiKbn,
            request.kakouSakiCd,
            request.kakouSakiSubCd,
            request.tsukaTani
        ].some((value) => String(value ?? "").trim() !== "");
        if (!hasSourceValue) {
            applyGenkaPatternFallback(entryObj);
            return;
        }

        if (isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") {
            applyGenkaPatternFallback(entryObj);
            return;
        }

        const requestSeq = genkaPatternRequestSeqRef.current + 1;
        genkaPatternRequestSeqRef.current = requestSeq;
        fnc.current.postaxios(genkaPatternUrl, request,
            {
                onSuccess: function (data) {
                    // 応答が古い場合でも解除されるよう、判定より前に閉じる。
                    if (!isEmpty(fnc.current)) fnc.current.wait(false);
                    if (genkaPatternRequestSeqRef.current !== requestSeq) return;
                    applyGenkaPatternResult(data);
                },
                onError: function (error) {
                    if (!isEmpty(fnc.current)) fnc.current.wait(false);
                    if (genkaPatternRequestSeqRef.current !== requestSeq) return;
                    applyGenkaPatternFallback(entryObj);
                }
            }
        );
    }
    function isGenkaCellEditableByLayout(rowName, colId) {
        const row = toGenkaRowKey(rowName);
        const slot = genkaColSlot(colId);
        if (row === "" || slot === "") return false;
        const cinfo = findGenkaColInfoByCell(row, slot);
        if (isEmpty(cinfo)) return false;
        const locked = parseBoolLike(DicVal(cinfo, "locked", false), false);
        const unchange = parseBoolLike(DicVal(cinfo, "unchange", false), false);
        if (locked || unchange) return false;
        const saveed = parseBoolLike(DicVal(cinfo, "saveed", true), true);
        if (!saveed) return false;
        return true;
    }
    function isGenkaPatternEditableCell(patternNo, rowName, colId) {
        const no = Number(patternNo);
        if (!Number.isFinite(no) || no < 1 || no > 9) return false;
        const set = GENKA_PATTERN_EDITABLE_CELLS[no];
        if (!(set instanceof Set) || set.size === 0) return false;
        const key = buildGenkaCellKey(rowName, colId);
        return key !== "" && set.has(key);
    }
    function isGenkaCellEditable(rowName, colId) {
        const row = toGenkaRowKey(rowName);
        const col = genkaColSlot(colId);
        if (col === "" || col === "item_name" || col === "syokei" || col === "syokei_f" || col === "kousei") return false;
        const layoutEditable = isGenkaCellEditableByLayout(row, col);
        const patternNo = currentGenkaPatternNo();
        const patternEditable = isGenkaPatternEditableCell(patternNo, row, col);
        return layoutEditable && patternEditable;
    }
    function genkaCellStyleByEditable(params, isLabel) {
        if (isLabel) return { backgroundColor: "#8fa4a3", color: "#fff", fontWeight: 600 };
        const rowName = String(DicVal(DicVal(params, "data", {}), "row_key", "") || DicVal(DicVal(params, "data", {}), "item_name", ""));
        const colDef = DicVal(params, "colDef", {});
        const colId = String(DicVal(colDef, "colId", "") || DicVal(colDef, "field", ""));
        const editable = isGenkaCellEditable(rowName, colId);
        if (editable) {
            return { backgroundColor: "#ffffff", color: "#2f3a4a" };
        }
        return { backgroundColor: "#eef1f1", color: "#2f3a4a" };
    }
    function hasGenkaValueRows(rows) {
        if (!Array.isArray(rows) || rows.length === 0) return false;
        return rows.some((r) => String(r?.item_name ?? "").trim() !== "");
    }
    // ファイルドラッグ開始時にDropZoneを開く。
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    // DropZoneを閉じる。
    function FileDropClose() {
        setIsDragActive(false);
    }

    // 主キー列IDを返す。
    function primarykey() {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.primarykey)) return "";
        return columninfo.find(e => e.primarykey).columnid;
    }
    // 名前の一部から列IDを探す。
    function nametocolumn(name) {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.columnid.indexOf(name) !== -1)) return "";
        return columninfo.find(e => e.columnid.indexOf(name) !== -1).columnid;
    }
    // 加工指示区分の列IDを特定する。
    function getKakouShijiKubunColumnId() {
        if (!isEmpty(kakouShijiKubunColumnRef.current)) return kakouShijiKubunColumnRef.current;
        if (isEmpty(columninfo)) return "";
        const targetId = "SSDX_KBN";
        const col = columninfo.find(e => String(e.columnid ?? "").trim().toUpperCase() === targetId);
        if (isEmpty(col)) return "";
        kakouShijiKubunColumnRef.current = col.columnid;
        return col.columnid;
    }
    // 加工指示区分の生値をサンプル判定用に正規化する。
    function normalizeKakouShijiKubunValue(raw) {
        const value = String(raw ?? "").trim();
        if (value === "") return "";
        const colon = value.indexOf(":");
        if (colon !== -1) return value.substring(0, colon).trim();
        return value;
    }
    // 加工指示区分の値がサンプルを示すか判定する。
    function isSampleKubunValue(raw) {
        const value = String(raw ?? "").trim();
        if (value === "") return false;
        const normalized = normalizeKakouShijiKubunValue(value);
        return normalized === "0";
    }
    // 加工指示区分から sample/normal を決める。
    function applyKakouShijiKubun(entrydata) {
        if (isEmpty(entrydata)) return;
        const colid = getKakouShijiKubunColumnId();
        if (isEmpty(colid)) return;
        const rawValue = findEntryValue(entrydata, [colid]);
        if (String(rawValue ?? "").trim() === "") return;
        setKakouShijiKubun(isSampleKubunValue(rawValue) ? "sample" : "normal");
    }
    // 配列を文字列配列として整形する。
    function toStringArray(value, fallback) {
        if (!Array.isArray(value)) return fallback;
        const result = value.map(v => String(v ?? "").trim()).filter(v => v !== "");
        return result.length === 0 ? fallback : result;
    }
    // colinfo.options を表示用文字列配列へ正規化する。
    function normalizeColOptionsToStrings(options) {
        const out = [];
        const pushVal = (v) => {
            const s = String(v ?? "").trim();
            if (s === "") return;
            if (out.indexOf(s) !== -1) return;
            out.push(s);
        };
        if (Array.isArray(options)) {
            options.forEach((o) => {
                if (o === null || o === undefined) return;
                if (typeof o === "string" || typeof o === "number") {
                    pushVal(o);
                    return;
                }
                pushVal(o.value ?? o.label ?? o.name ?? o.text ?? o.code ?? o.cd ?? "");
            });
            return out;
        }
        if (typeof options === "string") {
            const raw = options.trim();
            if (raw === "") return out;
            try {
                const parsed = JSON.parse(raw);
                return normalizeColOptionsToStrings(parsed);
            } catch (e) {
                raw.split(",").forEach(v => pushVal(v));
                return out;
            }
        }
        return out;
    }
    const genkaHeaderCurrencyColumnIdCandidates = ["SSD_TSUKATANI"];
    const genkaRateColumnIdCandidates = ["SSDGM_RATE"];
    const genkaHeaderCurrencyLayoutTypeCandidates = [PANEL_TYPE.GENKA, "126", "19", "genka"];
    function findGenkaCurrencyLayoutMeta() {
        return findLayoutMetaByCandidates(genkaHeaderCurrencyColumnIdCandidates, genkaHeaderCurrencyLayoutTypeCandidates)
            || findLayoutMetaByCandidates(genkaHeaderCurrencyColumnIdCandidates, []);
    }
    function findGenkaCurrencyColInfo() {
        return layoutColInfo(genkaHeaderCurrencyColumnIdCandidates, genkaHeaderCurrencyLayoutTypeCandidates)
            || layoutColInfo(genkaHeaderCurrencyColumnIdCandidates, []);
    }
    function findLayoutMetaByCandidates(candidates, typeCandidates = []) {
        if (isEmpty(candidates) || !Array.isArray(candidates)) return null;
        const ids = candidates.map(c => normalizeColumnIdUpper(c)).filter(c => c !== "");
        if (ids.length === 0) return null;
        const types = (Array.isArray(typeCandidates) ? typeCandidates : []).map(t => String(t ?? "").trim());
        const infoHit = findColumnInfoByCandidates(ids, types);
        if (!isEmpty(infoHit)) return infoHit;
        if (!Array.isArray(columns) || columns.length === 0) return null;
        const colHit = columns.find((c) => {
            const cid = normalizeColumnIdUpper(DicVal(c, "columnid", ""));
            if (!ids.includes(cid)) return false;
            if (types.length === 0) return true;
            return types.includes(String(DicVal(c, "type", "")).trim());
        });
        return isEmpty(colHit) ? null : colHit;
    }
    function layoutColInfo(candidates, typeCandidates = []) {
        if (isEmpty(candidates) || !Array.isArray(candidates)) return null;
        return findColumnInfoByCandidates(candidates, typeCandidates);
    }
    function layoutDisplayName(candidates, typeCandidates, fallbackLabel) {
        const hit = findLayoutMetaByCandidates(candidates, typeCandidates);
        const name = String(DicVal(hit, "columnnm", "") ?? "").trim();
        if (name !== "") return name;
        return String(fallbackLabel ?? "");
    }
    function isLayoutEditable(candidates, typeCandidates = []) {
        const cinfo = layoutColInfo(candidates, typeCandidates);
        if (isEmpty(cinfo)) return false;
        const locked = parseBoolLike(DicVal(cinfo, "locked", false), false);
        const unchange = parseBoolLike(DicVal(cinfo, "unchange", false), false);
        if (locked || unchange) return false;
        const saveed = parseBoolLike(DicVal(cinfo, "saveed", true), true);
        if (!saveed) return false;
        return true;
    }
    function isGenkaCurrencyEditableByLayout() {
        const cinfo = findGenkaCurrencyColInfo();
        if (isEmpty(cinfo)) return false;
        const locked = parseBoolLike(DicVal(cinfo, "locked", false), false);
        const unchange = parseBoolLike(DicVal(cinfo, "unchange", false), false);
        if (locked || unchange) return false;
        const saveed = parseBoolLike(DicVal(cinfo, "saveed", true), true);
        if (!saveed) return false;
        return true;
    }
    // 通貨単位（SSD_TSUKATANI）の選択肢をレイアウト定義（colinfo）から取得する。
    function genkaCurrencyOptionsFromLayout() {
        const cinfo = findGenkaCurrencyColInfo();
        if (isEmpty(cinfo)) return [];
        return normalizeColOptionsToStrings(DicVal(cinfo, "options", []));
    }
    function resolveGenkaCurrencyFromEntry(entryObj) {
        if (shouldForceGenkaCurrencyJpy(entryObj)) return "JPY";
        return String(findEntryValue(entryObj, genkaHeaderCurrencyColumnIdCandidates) ?? "").trim();
    }
    function resolveGenkaCurrencyColumnId() {
        const preferred = findColumnInfoByCandidates(
            genkaHeaderCurrencyColumnIdCandidates,
            genkaHeaderCurrencyLayoutTypeCandidates
        );
        if (!isEmpty(preferred) && !isEmpty(preferred.columnid)) return String(preferred.columnid ?? "").trim();
        const fallback = findColumnInfoByCandidates(
            genkaHeaderCurrencyColumnIdCandidates,
            []
        );
        if (!isEmpty(fallback) && !isEmpty(fallback.columnid)) return String(fallback.columnid ?? "").trim();
        return "";
    }
    function setGenkaCurrencyToEntry(entryObj, value) {
        if (isEmpty(entryObj)) return false;
        const nextValue = String(value ?? "");
        const colId = resolveGenkaCurrencyColumnId();
        if (!isEmpty(colId)) {
            entryObj[colId] = nextValue;
            return true;
        }
        const keys = Object.keys(entryObj);
        for (let i = 0; i < genkaHeaderCurrencyColumnIdCandidates.length; i++) {
            const cand = String(genkaHeaderCurrencyColumnIdCandidates[i] ?? "");
            if (cand === "") continue;
            if (cand in entryObj) {
                entryObj[cand] = nextValue;
                return true;
            }
            const hit = keys.find(k => String(k ?? "").toUpperCase() === cand);
            if (!isEmpty(hit)) {
                entryObj[hit] = nextValue;
                return true;
            }
        }
        return false;
    }
    function setGenkaRateToEntry(entryObj, value) {
        if (isEmpty(entryObj)) return false;
        const colId = resolveEntryColumnId(genkaRateColumnIdCandidates, entryObj);
        if (isEmpty(colId)) return false;
        entryObj[colId] = String(value ?? "");
        return true;
    }
    function applyForcedGenkaJpyIfNeeded(entryObj) {
        if (!shouldForceGenkaCurrencyJpy(entryObj)) return false;
        const currencyColId = resolveEntryColumnId(["SSDGM_TSUKATANI"], entryObj);
        if (!isEmpty(currencyColId)) entryObj[currencyColId] = "JPY";
        setGenkaRateToEntry(entryObj, "1");
        return true;
    }
    function applyForcedGenkaJpyToSummaryRows(rows) {
        const normalized = normalizeGenkaSummaryRows(rows);
        if (!shouldForceGenkaCurrencyJpy(entrydataRef.current)) return normalized;
        return normalized.map((r) => {
            const item = resolveGenkaSummaryItem(DicVal(r, "total_key", "") || DicVal(r, "total_item", ""));
            if (item === "SSDGM_TSUKATANI") return { ...r, total_value: "JPY" };
            if (item === "SSDGM_RATE") return { ...r, total_value: "1" };
            return r;
        });
    }
    function isGenkaOverseasEntry(entryObj = entrydataRef.current) {
        const kaigaiRaw = findEntryValue(entryObj, genkaKaigaiKbnColumnIdCandidates);
        return normalizeCodeValue(kaigaiRaw) === "2";
    }
    function resolveGenkaPanelFromGridList() {
        if (!Array.isArray(gridlist) || gridlist.length === 0) return null;
        return gridlist.find(g => isGenkaGridPanelInfo(g)) || null;
    }
    function handleGenkaCurrencyChanged(value) {
        if (!isGenkaCurrencyEditableByLayout()) return;
        const nextValue = shouldForceGenkaCurrencyJpy(entrydataRef.current) ? "JPY" : String(value ?? "");
        setGenkaCurrency(nextValue);
        setGenkaCurrencyToEntry(entrydataRef.current, nextValue);
        if (shouldForceGenkaCurrencyJpy(entrydataRef.current)) setGenkaRateToEntry(entrydataRef.current, "1");
        syncGenkaPatternByEntry(entrydataRef.current);
        const genkaPanel = resolveGenkaPanelFromGridList();
        if (!isEmpty(genkaPanel)) {
            recalcGenkaGridAndSummary(genkaPanel);
        }
        fnc.current.modify(true);
    }
    // 原価再計算 service へ渡す依存関係は、genka 定数・補助関数の初期化後に束ねます。
    function buildGenkaRecalcServiceDeps() {
        return {
            PANEL_TYPE,
            entrydataRef,
            totalgriddataRefs,
            entryLoadingRef,
            genkaPatternNo,
            genkaPattern,
            isEmpty,
            DicVal,
            DeepCopy,
            GridData,
            SetGridData,
            applyGridRowsNow,
            applyTotalRowsNow,
            ensureTotalDataRef,
            rerender,
            roundByDecimal,
            normalizeTotalTypeForColumns,
            normalizeGenkaSummaryRows,
            defaultGenkaSummaryRows,
            buildGenkaSummaryRowsFromFlatData,
            buildGenkaRowsForDisplay,
            normalizeGenkaRowsWithSkeleton,
            buildGenkaSkeletonRows,
            blankDefaultZeroGenkaRows,
            blankDefaultZeroGenkaSummaryRows,
            applyGenkaSummaryRowsToEntryData,
            deriveGenkaPatternFromEntry,
            toGenkaRowKey,
            resolveGenkaSummaryItem,
            resolveGenkaSummaryKeyId,
            emptyGenkaRow,
            emptyGenkaSummaryRow,
            genkaRowLabelByKey,
            genkaRowKeyOrder,
            genkaSummaryOrder,
            genkaSummaryColumnCandidates,
            genkaColumnMapByColumnIdUpper,
            shouldForceGenkaCurrencyJpy,
            applyForcedGenkaJpyToSummaryRows,
            hasActualGenkaSummaryEntryValueForField,
            isGenkaKeepZeroSummaryField,
            normalizeGenkaRowsByLayoutPrecision,
            applyGenkaCalcDisplayRounding,
            findColumnInfoByCandidates,
            isMeaningfulGenkaValue,
            isGenkaTouchedColumnId,
            isGenkaKouseiEnabledRow,
            isGenkaGridPanelInfo,
            resolveTempGenkaPatternNo
        };
    }

    // 原価明細の再計算とサマリ再反映は専用 service へ委譲します。
    const {
        recalcGenkaGridAndSummary
    } = createGenkaRecalcService(buildGenkaRecalcServiceDeps());

    // 発注履歴データを表示用に整える。
    function normalizeHistoryRows(value) {
        if (!Array.isArray(value)) return [];
        return value
            .map(row => ({
                date: String((row && row.date) ?? "").trim(),
                denpyoNo: String((row && (row.denpyoNo ?? row.denpyo_no)) ?? "").trim(),
                kind: String((row && row.kind) ?? "").trim(),
                controller: String((row && row.controller) ?? "").trim(),
                url: String((row && (row.url ?? row.link ?? row.href)) ?? "").trim(),
                target: String((row && (row.target ?? "")) ?? "").trim()
            }))
            .filter(row => row.date !== "" || row.denpyoNo !== "")
            .sort((a, b) => a.denpyoNo.localeCompare(b.denpyoNo, "ja", { numeric: true, sensitivity: "base" }));
    }
    // 登録グループ一覧を表示用に整える。
    function normalizeGroupRows(value) {
        if (!Array.isArray(value)) return [];
        return value
            .map(row => {
                const source = (isEmpty(row) || typeof row !== "object") ? {} : row;
                const groupNo = normalizeGroupNo(
                    DicVal(source, "groupNo", "")
                    || readRowValueIgnoreCase(source, "SSDZ_FUKUSIZAICOLORGRP")
                    || readRowValueIgnoreCase(source, "SSDQ_GROUPNO")
                    || DicVal(source, "group", "")
                );
                const groupLabel = groupNoToLabel(groupNo) || groupNo;
                return {
                    ...source,
                    item: String(DicVal(source, "item", "") || readRowValueIgnoreCase(source, "SSDQ_ITMCITEMCD") || readRowValueIgnoreCase(source, "SSDZ_ITMCITEMCD") || "").trim(),
                    color: String(DicVal(source, "color", "") || readRowValueIgnoreCase(source, "SSDQ_COLORCD") || readRowValueIgnoreCase(source, "SSDZ_COLORCD") || "").trim(),
                    group: groupLabel,
                    groupNo
                };
            })
            .filter(row => row.item !== "" || row.color !== "" || row.group !== "");
    }
    // UiAction系レスポンスの表示データだけを抽出する。
    function extractKakousijiUiActionSource(response) {
        if (isEmpty(response) || typeof response !== "object") return null;
        if (!isEmpty(response.kakousijiUi) && typeof response.kakousijiUi === "object") return response.kakousijiUi;
        const candidates = [response.data, response.returnData, response.result];
        for (let i = 0; i < candidates.length; i++) {
            const candidate = candidates[i];
            if (isEmpty(candidate) || typeof candidate !== "object") continue;
            if (Object.prototype.hasOwnProperty.call(candidate, "action")
                || Object.prototype.hasOwnProperty.call(candidate, "mode")
                || Object.prototype.hasOwnProperty.call(candidate, "sectionId")
                || Object.prototype.hasOwnProperty.call(candidate, "panelType")
                || Object.prototype.hasOwnProperty.call(candidate, "message")
                || Object.prototype.hasOwnProperty.call(candidate, "detail")
                || Object.prototype.hasOwnProperty.call(candidate, "entryData")) {
                return candidate;
            }
        }
        if (Object.prototype.hasOwnProperty.call(response, "action")
            || Object.prototype.hasOwnProperty.call(response, "mode")
            || Object.prototype.hasOwnProperty.call(response, "sectionId")
            || Object.prototype.hasOwnProperty.call(response, "panelType")
            || Object.prototype.hasOwnProperty.call(response, "message")
            || Object.prototype.hasOwnProperty.call(response, "detail")
            || Object.prototype.hasOwnProperty.call(response, "entryData")) {
            return response;
        }
        return null;
    }
    function normalizeUiActionDetailData(source) {
        if (isEmpty(source) || typeof source !== "object") return null;
        const detail = source.detail;
        if (Array.isArray(detail)) {
            const panelType = normalizeKakousijiUiString(DicVal(source, "panelType", ""));
            if (panelType !== "") return { [panelType]: detail };
            const sectionId = normalizeKakousijiUiString(DicVal(source, "sectionId", ""));
            if (/^\d+$/.test(sectionId)) return { [sectionId]: detail };
            return null;
        }
        if (!isEmpty(detail) && typeof detail === "object") return detail;
        return null;
    }
    // 補助UIデータ（履歴/グループ/原価）をstateへ反映する。
    function applyKakousijiUiData(response, options = {}) {
        const timing = createTimingCollector("applyKakousijiUiData");
        const source = timing.measure("extractSource", () => extractKakousijiUiActionSource(response) ?? (response && typeof response === "object" ? response : null));
        const nextFukushizaiGroupRows = timing.measure("normalizeInitialGroupRows", () => Array.isArray(source?.groupRows) ? normalizeGroupRows(source.groupRows) : []);
        fukushizaiGroupRowsRef.current = nextFukushizaiGroupRows;
        const skipUiActionRefresh = isEnabled(DicVal(options, "skipUiActionRefresh", false));
        const skipGenkaPatternSync = isEnabled(DicVal(options, "skipGenkaPatternSync", false));
        const isUiActionResult = !skipUiActionRefresh && !isEmpty(source) && (
            Object.prototype.hasOwnProperty.call(source, "action")
            || Object.prototype.hasOwnProperty.call(source, "mode")
            || Object.prototype.hasOwnProperty.call(source, "sectionId")
            || Object.prototype.hasOwnProperty.call(source, "message")
            || Object.prototype.hasOwnProperty.call(source, "entryData")
        );
        const forcedJpy = timing.measure("applyForcedGenkaJpyIfNeeded", () => applyForcedGenkaJpyIfNeeded(entrydataRef.current));
        const layoutGenkaCurrencies = timing.measure("genkaCurrencyOptionsFromLayout", () => genkaCurrencyOptionsFromLayout());
        const entryCurrency = timing.measure("resolveGenkaCurrencyFromEntry", () => resolveGenkaCurrencyFromEntry(entrydataRef.current));
        const effectiveGenkaCurrencies = layoutGenkaCurrencies.length !== 0
            ? layoutGenkaCurrencies
            : (isEmpty(entryCurrency) ? [] : [entryCurrency]);
        const nextGenkaCurrencyValue = forcedJpy
            ? "JPY"
            : effectiveGenkaCurrencies.length === 0
                ? entryCurrency
                : (!isEmpty(entryCurrency) && effectiveGenkaCurrencies.indexOf(entryCurrency) !== -1)
                    ? entryCurrency
                    : (isEmpty(entryCurrency) ? effectiveGenkaCurrencies[0] : "");

        // 通貨単位は SSD_TSUKATANI を表示元とし、候補はそのレイアウト情報を優先する。
        timing.measure("setGenkaCurrencyState", () => {});

        // 原価パターンは常に実データから判定（補助返却値は使わない）。
        if (!skipGenkaPatternSync) {
            timing.measure("syncGenkaPatternInitial", () => {
                syncGenkaPatternByEntry(entrydataRef.current, source);
            });
        }

        if (isUiActionResult) {
            const entryData = DicVal(source, "entryData", null);
            if (!isEmpty(entryData) && typeof entryData === "object") {
                timing.measure("mergeUiActionEntryData", () => {
                    entrydataRef.current = {
                        ...(isEmpty(entrydataRef.current) ? {} : DeepCopy(entrydataRef.current)),
                        ...DeepCopy(entryData)
                    };
                    clearFukushizaiMergedFields(entrydataRef.current);
                });
            }

            const detailData = timing.measure("normalizeUiActionDetailData", () => normalizeUiActionDetailData(source));
            if (!isEmpty(detailData)) {
                timing.measure("applyUiActionDetailData", () => {
                    entrydetailRef.current = detailData;
                    ensureFukushizaiDetailRowsFromEntryData(entrydataRef.current);
                    mergeFukushizaiRepresentativeRowToEntry(entrydataRef.current, entrydetailRef.current, selectedFukushizaiContextRef.current);
                    applyDetailRowsToGrids(entrydetailRef.current);
                    applyTotalRowsByPanelDefinition(entrydetailRef.current);
                    applyTotalRowsBySectionDefinition(entrydetailRef.current);
                });
            }

            if (!isEmpty(entryData) || !isEmpty(detailData)) {
                timing.measure("dispatchUiActionRerender", () => {
                    dispatchEntryDataWithTrace({ ...entrydataRef.current }, "applyKakousijiUiData:uiAction");
                    dispatchEntryRerenderWithTrace("applyKakousijiUiData:uiAction");
                    syncGenkaPatternByEntry(entrydataRef.current, source);
                    rerender();
                });
            }
        }

        // 返却がない場合は補助UI stateのみ既定維持（通貨単位/原価パターンは上で反映済み）
        if (isEmpty(source)) {
            runBatched(() => {
                setGenkaCurrencyOptions(effectiveGenkaCurrencies);
                setGenkaCurrency(nextGenkaCurrencyValue);
            });
            timing.flush({
                skipUiActionRefresh,
                skipGenkaPatternSync,
                isUiActionResult,
                hasSource: false
            });
            return;
        }

        const historySource = source.orderHistory;
        let nextHistory = null;
        if (!isEmpty(historySource) && typeof historySource === "object") {
            timing.measure("setOrderHistoryData", () => {
                nextHistory = {};
                orderHistoryDefs.forEach(def => {
                    nextHistory[def.id] = normalizeHistoryRows(historySource[def.id]);
                });
            });
        }
        const resolvedFukushizaiGroupRows = timing.measure("resolveGroupRows", () => nextFukushizaiGroupRows.length !== 0
            ? nextFukushizaiGroupRows
            : normalizeGroupRows(resolveRegisteredGroupRows()));
        fukushizaiGroupRowsRef.current = resolvedFukushizaiGroupRows;
        timing.measure("setGroupRows", () => {});
        const detail113RowsForOptions = timing.measure("getDetail113RowsForOptions", () => getDetailRowsByPanelType(entrydetailRef.current, FUKUSHIZAI_BASE_PANEL_TYPE));
        const detailItemOptions = timing.measure("buildDetailItemOptions", () => normalizeNamedOptions(
            (Array.isArray(detail113RowsForOptions) ? detail113RowsForOptions : []).map((row) => ({
                code: getItemCdFromRow(row),
                name: pickFirstFukushizaiText(row, ["itemName", "itemNm", "item_name", "SSDZ_ITMCITEMNM", "SSDZ_ITMCITEM_NM"])
            })),
            ["code"],
            ["name"]
        ));
        const nextFukushizaiItemOptions = timing.measure("buildItemOptionsFromSource", () => normalizeNamedOptions(
            readFukushizaiOptionsFromEntryDataSource(source, "fukushizaiItemOptions", "__fukushizaiItemOptions"),
            ["code", "itemCd", "item", "value", "PDT_ITMCITEMCD"],
            ["name", "itemName", "label", "abbr", "PDT_HINMEINM"]
        ));
        const nextFukushizaiColorOptions = timing.measure("buildColorOptionsFromSource", () => normalizeNamedOptions(
            readFukushizaiOptionsFromEntryDataSource(source, "fukushizaiColorOptions", "__fukushizaiColorOptions"),
            ["code", "colorCd", "color", "value", "PDTC_COLORCD"],
            ["name", "colorName", "label", "abbr", "PDTC_COLORNM"]
        ));
        const effectiveFukushizaiItemOptions = timing.measure("hydrateItemOptionsFromMasterStore", () => hydrateNamedOptionsFromMasterStore(
            nextFukushizaiItemOptions.length !== 0 ? nextFukushizaiItemOptions : detailItemOptions,
            resolveFukushizaiItemMasterDataId(),
            ["itemName", "itemNm", "item_name", "name", "label", "abbr", "PDT_ITMCITEMCD"]
        ));
        // アイテム名称マスタ(m_code:0138)一覧をキャッシュへ取り込む(seed/追加アイテムの初期表示名称用)。
        timing.measure("readItemNameMasterOptions", () => {
            const itemNameMasterRows = readFukushizaiOptionsFromEntryDataSource(source, "itemNameMasterOptions", ITEM_NAME_MASTER_OPTIONS_DATA_KEY);
            if (itemNameMasterRows.length !== 0) {
                itemNameMasterListRef.current = itemNameMasterRows
                    .map((row) => ({
                        code: normalizeItemCd(DicVal(row, "code", "")),
                        name: String(DicVal(row, "name", "") ?? "").trim()
                    }))
                    .filter((row) => row.code !== "");
            }
        });
        const effectiveFukushizaiColorOptions = timing.measure("hydrateColorOptionsFromMasterStore", () => hydrateNamedOptionsFromMasterStore(nextFukushizaiColorOptions, resolveFukushizaiColorMasterDataId(), ["colorName", "colorNm", "color_name", "name", "label", "abbr", "PDTC_COLORNM"]));
        timing.measure("setItemColorOptionStates", () => {});
        debugFukushizaiSyncLog("[Kakousiji][fukushizai item/color options]", {
            itemCount: effectiveFukushizaiItemOptions.length,
            colorCount: effectiveFukushizaiColorOptions.length,
            source: "GetEntryData"
        });
        const nextSetItems = toStringArray(source.setItemOptions, []);
        const nextGroups = toStringArray(source.groupOptions, []);
        const nextGenkaPatterns = toStringArray(source.genkaPatternOptions, []);
        const nextSetItemOptions = effectiveFukushizaiItemOptions.length !== 0 ? effectiveFukushizaiItemOptions : nextSetItems;
        timing.measure("setSetItemAndGenkaPatternOptions", () => {});

        const nextSelectedSetItems = timing.measure("buildNextSelectedSetItems", () => effectiveFukushizaiItemOptions.length !== 0
            ? effectiveFukushizaiItemOptions.map((item) => getNamedOptionCode(item)).filter((value) => value !== "")
            : nextSetItems);
        const nextSelectedItem = nextSelectedSetItems.length === 0
            ? ""
            : (nextSelectedSetItems.indexOf(selectedSetItem) === -1 ? nextSelectedSetItems[0] : selectedSetItem);
        const nextSelectedSetItemState = nextSelectedSetItems.length === 0
            ? ""
            : (nextSelectedSetItems.indexOf(selectedSetItem) === -1 ? nextSelectedItem : selectedSetItem);
        const nextCopyItemState = nextSelectedSetItems.length === 0
            ? ""
            : (nextSelectedSetItems.indexOf(copyItem) === -1 ? nextSelectedItem : copyItem);
        timing.measure("setSelectedItemState", () => {});
        const localGroupRows = timing.measure("buildLocalGroupRows", () => resolvedFukushizaiGroupRows
            .filter((row) => normalizeKakousijiUiString(DicVal(row, "item", DicVal(row, "SSDZ_ITMCITEMCD", ""))) === nextSelectedItem)
            .map((row) => DicVal(row, "group", DicVal(row, "SSDZ_FUKUSIZAICOLORGRP", ""))));
        const localGroups = timing.measure("buildLocalGroups", () => (localGroupRows.length !== 0 ? localGroupRows : nextGroups)
            .map((value) => normalizeGroupNo(value))
            .filter((value, index, list) => value !== "" && list.indexOf(value) === index)
            .sort((a, b) => Number(a) - Number(b) || a.localeCompare(b)));
        timing.measure("setGroupOptions", () => {});
        let projectedContext = createEmptyFukushizaiContext();
        let nextSelectedGroupState = "";
        let nextCopyGroupState = "";
        timing.measure("resolveProjectedContext", () => {
            if (localGroups.length === 0) {
                nextSelectedGroupState = "";
                nextCopyGroupState = "";
                projectedContext = normalizeFukushizaiContext({ itemCd: nextSelectedItem, groupNo: "" });
            } else {
                const currentGroup = normalizeGroupNo(selectedGroup);
                const nextGroup = localGroups.indexOf(currentGroup) === -1 ? localGroups[0] : currentGroup;
                nextSelectedGroupState = nextGroup;
                nextCopyGroupState = localGroups.indexOf(normalizeGroupNo(copyGroup)) === -1 ? nextGroup : copyGroup;
                projectedContext = normalizeFukushizaiContext(resolveFukushizaiContext(detail113RowsForOptions, { itemCd: nextSelectedItem, groupNo: nextGroup }));
            }
        });
        timing.measure("mergeRepresentativeRowFinal", () => {
            mergeFukushizaiRepresentativeRowToEntry(entrydataRef.current, entrydetailRef.current, projectedContext);
        });
        // 品質表示(118-124)スコープの選択も副資材と同じタイミングで確定する。
        // 直後の applyDetailRowsToGrids は selectedQualityContextRef を参照して品質グリッドを構築するため、
        // ここで確定しないと初期表示が「コンテキスト未確定=空行」のままになる
        // (後追いの seed 用 effect は state/ref 更新のみでグリッド再適用を行わない)。
        // 現在の品質選択が有効ならそのまま維持する(UIアクション後の再適用で選択を巻き戻さない)。
        const currentQualityItem = normalizeKakousijiUiString(selectedQualityItem);
        const nextQualityItemState = nextSelectedSetItems.length === 0
            ? ""
            : (nextSelectedSetItems.indexOf(currentQualityItem) === -1 ? nextSelectedItem : currentQualityItem);
        const knownQualityGroups = getKnownQualityGroupNos(nextQualityItemState)
            .map((value) => normalizeGroupNo(value))
            .filter((value) => value !== "");
        const currentQualityGroup = normalizeGroupNo(selectedQualityGroup);
        const nextQualityGroupState = knownQualityGroups.length === 0
            ? ""
            : (knownQualityGroups.indexOf(currentQualityGroup) === -1 ? knownQualityGroups[0] : currentQualityGroup);
        const qualityProjectedContext = normalizeFukushizaiContext(resolveFukushizaiContext(
            getDetailRowsByPanelType(entrydetailRef.current, PANEL_TYPE.QUALITY_BASE),
            { itemCd: nextQualityItemState, groupNo: nextQualityGroupState }
        ));
        timing.measure("mergeQualityRepresentativeRowFinal", () => {
            // 品質118単票は品質側コンテキストの代表行で投影し直す
            // (mergeFukushizaiRepresentativeRowToEntry 内の品質投影は副資材コンテキスト基準のため)。
            mergeQualityRepresentativeRowToEntry(entrydataRef.current, entrydetailRef.current, qualityProjectedContext);
        });
        logEntryVisualTrace("applyKakousijiUiData:afterMergeRepresentativeRowFinal", {
            projectedContext,
            localGroupsCount: localGroups.length,
            nextSelectedSetItemState,
            nextSelectedGroupState
        });
        const nextCurrencyNo = String(source.genkaCurrencyNo ?? "").trim();
        timing.measure("setGenkaCurrencyNo", () => {});
        timing.measure("commitUiStates", () => {
            runBatched(() => {
                setGenkaCurrencyOptions(effectiveGenkaCurrencies);
                setGenkaCurrency(nextGenkaCurrencyValue);
                if (nextHistory !== null) setOrderHistoryData(nextHistory);
                setGroupRows(resolvedFukushizaiGroupRows);
                setFukushizaiItemMasterOptions(effectiveFukushizaiItemOptions);
                setFukushizaiColorMasterOptions(effectiveFukushizaiColorOptions);
                setSetItemOptions(nextSetItemOptions);
                setGenkaPatternOptions(nextGenkaPatterns);
                setGroupOptions(localGroups);
                setSelectedSetItem(nextSelectedSetItemState);
                setCopyItem(nextCopyItemState);
                setSelectedGroup(nextSelectedGroupState);
                setCopyGroup(nextCopyGroupState);
                updateSelectedFukushizaiContext(projectedContext);
                // 品質表示スコープの選択とコンテキストも同時に確定する(refは同期更新される)。
                setSelectedQualityItem(nextQualityItemState);
                setSelectedQualityGroup(nextQualityGroupState);
                updateSelectedQualityContext(qualityProjectedContext);
                if (!isEmpty(nextCurrencyNo)) setGenkaCurrencyNo(nextCurrencyNo);
            });
            clearFukushizaiOptionPayloadFields(entrydataRef.current);
        });
        logEntryVisualTrace("applyKakousijiUiData:afterCommitUiStates", {
            projectedContext,
            localGroupsCount: localGroups.length,
            nextSelectedSetItemState,
            nextSelectedGroupState,
            nextCopyItemState,
            nextCopyGroupState
        });
        // 各ドメインのdetailにアイテム/グループを持つ行が無い場合は既定アイテム00をseedする。
        // 逆にデータ側にアイテムがある場合は自動seed分を撤去する(ユーザー追加分は残す)。
        timing.measure("syncDefaultQualityItem", () => syncDefaultQualityItemAfterLoad());
        timing.measure("syncDefaultFukushizaiItem", () => syncDefaultFukushizaiItemAfterLoad(effectiveFukushizaiItemOptions));
        timing.flush({
            skipUiActionRefresh,
            skipGenkaPatternSync,
            isUiActionResult,
            hasSource: !isEmpty(source),
            historyCount: Array.isArray(source?.orderHistory) ? source.orderHistory.length : 0,
            groupRowCount: resolvedFukushizaiGroupRows.length,
            itemOptionCount: effectiveFukushizaiItemOptions.length,
            colorOptionCount: effectiveFukushizaiColorOptions.length
        });
    }
    //発注画面呼び出し
    function openTemporaryOrderTab(action) {
        let code = [];
        let param = baseref.current?.GetSelectrowdata();
        if (param.length === 0) {
            fnc.current.warnmsg("対象データを選択してください");
            return;
        }
        for (let i = 0; i < primarykeys.length; i++) {
            if (primarykeys[i] in param[0]) {
                for (let j = 0; j < param.length; j++) {
                    code.push(param[j][primarykeys[i]]);
                }
                break;
            }
        }
        if (code.length === 0) return;
        // callforms(action, code, placeholderTabs);
        callforms(action, code);

    }
    function createPlaceholderTabs(count) {
        const tabs = [];
        if (count <= 0) return tabs;
        const firstTab = window.open("", "_blank");
        preparePlaceholderTab(firstTab);
        tabs.push(firstTab);
        for (let i = 1; i < count; i++) {
            let tab = null;
            try {
                // 環境によっては親タブから複数回 open するより、最初に開いたタブを起点にした方が
                // ユーザー操作由来として扱われやすい。
                tab = firstTab && !firstTab.closed ? firstTab.open("", "_blank") : window.open("", "_blank");
            } catch (error) {
                tab = null;
            }
            preparePlaceholderTab(tab);
            tabs.push(tab);
        }
        return tabs;
    }
    function preparePlaceholderTab(tab) {
        if (tab && !tab.closed) {
            try {
                tab.document.title = "起動中";
            } catch (error) {
            }
        }
    }
    function closePlaceholderTabs(tabs, startIndex = 0) {
        if (!Array.isArray(tabs)) return;
        for (let i = startIndex; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab && !tab.closed) {
                try {
                    tab.close();
                } catch (error) {
                }
            }
        }
    }
    function buildCallformRequests(action, code, rowdata) {
        const callid = action === "seihin_bulk_order" ? "ShnOrder" : "RawM?type=D_KHD";
        return (Array.isArray(rowdata) ? rowdata : []).map((detail, index) => ({
            index: index,
            callid: callid,
            state: { status: "ENTRY", code: "", accepttype: formid, acceptno: code, mode: action, detail: detail }
        }));
    }
    function pendingOrderLaunchLabel(item) {
        if (isEmpty(item)) return "";
        return "起動対象 " + (item.index + 1);
    }
    function openPendingOrderLaunch(item) {
        if (isEmpty(item)) return false;
        const openedTab = fnc.current.callform(item.state, item.callid);
        if (openedTab === null) {
            fnc.current.warnmsg("タブを開けませんでした。ブラウザのポップアップ設定を確認してください。");
            return false;
        }
        setPendingOrderLaunches((prev) => prev.filter((entry) => entry.index !== item.index));
        return true;
    }
    function callforms(action, code, placeholderTabs = []) {
        //発注情報の収集
        fnc.current.postaxios("kakousiji/GetCallFormStatus", { type: action, keys: code },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);
                    const placeholderTabs = createPlaceholderTabs(code.length);
                    const requests = buildCallformRequests(action, code, data.rowdata);
                    if (requests.length === 0) {
                        closePlaceholderTabs(placeholderTabs);
                        setPendingOrderLaunches([]);
                        return;
                    }
                    const targetTab = placeholderTabs.length !== 0 ? placeholderTabs[0] : null;
                    const firstOpenedTab = fnc.current.callform(requests[0].state, requests[0].callid, targetTab);
                    closePlaceholderTabs(placeholderTabs, 1);
                    if (firstOpenedTab === null) {
                        setPendingOrderLaunches(requests);
                        fnc.current.warnmsg("ブラウザ制限のため自動で複数タブを開けません。起動一覧から 1 件ずつ開いてください。");
                        return;
                    }
                    const remains = requests.slice(1);
                    setPendingOrderLaunches(remains);
                },
                onError: function (data) {
                    // setPendingOrderLaunches([]);
                    // closePlaceholderTabs(placeholderTabs);
                    if (!isEmpty(data.errDescription)) fnc.current.warnmsg(data.errDescription);
                    fnc.current.wait(false);
                }
            }
        );
    }

    function resolveOrderHistoryAction(historyId) {
        const normalizedHistoryId = normalizeKakousijiUiString(historyId);
        if (normalizedHistoryId === "") return "";
        const def = orderHistoryDefs.find((item) => normalizeKakousijiUiString(item.id) === normalizedHistoryId);
        return normalizeKakousijiUiString(DicVal(def, "action", ""));
    }
    function resolveOrderHistoryFormTarget(historyId) {
        const normalizedHistoryId = normalizeKakousijiUiString(historyId);
        if (normalizedHistoryId === "seihin") {
            return { callid: "ShnOrder", historyType: "" };
        }
        if (normalizedHistoryId === "sozai") {
            return { callid: "RawM?type=D_KHD", historyType: "0" };
        }
        if (normalizedHistoryId === "fuzoku") {
            return { callid: "RawM?type=D_KHD", historyType: "1" };
        }
        if (normalizedHistoryId === "fukushizai") {
            return { callid: "RawM?type=D_KHD", historyType: "2" };
        }
        return null;
    }
    function resolveOrderActionBySectionId(sectionId) {
        const normalizedSectionId = normalizeKakousijiUiString(sectionId);
        if (normalizedSectionId === "") return "";
        const historyId = normalizeKakousijiUiString(DicVal(SECTION_ORDER_ACTION_MAP, normalizedSectionId, ""));
        if (historyId === "") return "";
        return resolveOrderHistoryAction(historyId);
    }
    function openOrderHistoryButton(kind) {
        const action = resolveOrderHistoryAction(kind);
        if (action === "") {
            fnc.current.warnmsg("発注起動定義が見つかりません。");
            return;
        }
        openTemporaryOrderTab(action);
    }
    // 履歴の伝票番号クリックで発注入力画面を別タブ表示する。
    function openHistorySlip(historyId, row) {
        if (isEmpty(row)) return;
        const denpyoNo = normalizeKakousijiUiString(DicVal(row, "denpyoNo", ""));
        if (denpyoNo === "") return;
        const target = resolveOrderHistoryFormTarget(historyId);
        if (isEmpty(target) || isEmpty(target.callid)) {
            fnc.current.warnmsg("履歴表示起動定義が見つかりません。");
            return;
        }
        const state = {
            status: "ENTRY",
            code: denpyoNo,
            accepttype: formid
        };
        if (!isEmpty(target.historyType)) {
            state.historyType = target.historyType;
        }
        const openedTab = fnc.current.callform(state, target.callid);
        if (openedTab === null) {
            fnc.current.warnmsg("タブを開けませんでした。ブラウザのポップアップ設定を確認してください。");
        }
    }
    // 画面内操作APIを呼び出す。
    function callKakousijiUiAction(action, payload) {
        if (isEmpty(edittingcode)) {
            fnc.current.warnmsg("入力画面表示後に操作してください。");
            return;
        }
        if (uiActionBusy) return;
        const param = {
            controller: controller,
            code: edittingcode,
            action: action,
            payload: payload
        };
        setUiActionBusy(true);
        fnc.current.wait(true);
        fnc.current.postaxios(kakousijiUiActionUrl, param,
            {
                onSuccess: function (data) {
                    applyKakousijiUiData(data, { skipGenkaPatternSync: true });
                    fnc.current.success();
                    setUiActionBusy(false);
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    let msg = "操作に失敗しました。";
                    if (!isEmpty(data) && !isEmpty(data.errDescription)) msg = data.errDescription;
                    fnc.current.warnmsg(msg);
                    setUiActionBusy(false);
                    fnc.current.wait(false);
                }
            }
        );
    }
    // 確認ダイアログ経由で画面内操作APIを呼ぶ。
    function confirmKakousijiUiAction(message, section, action, extra = {}) {
        fnc.current.confmsg([message], () => runKakousijiUiAction(section, action, extra));
    }

    function toArray(value) {
        return Array.isArray(value) ? value : [];
    }

    useEffect(() => {
        // 入力初回遷移時に user 情報の反映より先に本effectが走るケースがある。
        // corpkey/account 未設定でもレイアウト取得は可能なため、ここでは止めない。
        setTabsReady(false);

        const param = { "panels": panelsdef, "controller": controller, "subkey": subkey };
        const applyTabsData = function (data) {
            const tabsData = data;
            const normalizedColInfo = buildOtherFukuzaiDisplayColInfo(buildOtherNameDisplayColInfo(buildBrandNameDisplayColInfo(normalizeLayoutMeta(tabsData.colinfo))));
            const normalizedColumns = buildOtherFukuzaiDisplayColInfo(buildOtherNameDisplayColInfo(buildBrandNameDisplayColInfo(normalizeLayoutMeta(tabsData.columns))))
                .filter((item) => {
                    const cid = String(DicVal(item, "columnid", "")).trim().toUpperCase();
                    return !isOtherNameSourceColumnId(cid) && !isOtherFukuzaiSourceColumnId(cid);
                });
            const normalizedPanels = normalizePanelMeta(tabsData.panels);
            const normalizedMasters = filterBrandNameMasterPreload(Array.isArray(tabsData.master) ? tabsData.master : []);
            setpanel(normalizedPanels);
            setResolvedSections(buildResolvedSections(kakouSectionDefs, normalizedPanels));
            setResolvedSampleSections(buildResolvedSections(kakouSampleSectionDefs, normalizedPanels));
            dispatch(setentrypanel({
                layouts: tabsData.layouts, prelayout: tabsData.prelayout,
                initlayout: tabsData.initlayout.length === 0 ? " " : tabsData.initlayout,
                fitColumn: tabsData.fitColumn
            }));
            setcolumninfo(normalizedColInfo);
            setcolumns(normalizedColumns);
            let fields = normalizedColInfo
                .filter(e => String(e.logpid ?? "") === G_id.BASE)
                .map(e => applyDesignReadonlyToField(e));
            settextfieldsall(fields);
            const baseFields = buildBaseTextFields(normalizedColumns, normalizedColInfo);
            settextfields(baseFields);
            fnc.current.initMaster(normalizedMasters);

            setprimarykeys(tabsData.primarykeys);

            let idx = 0;
            let glist = [];
            let gridmaxinit = {};
            normalizedPanels.filter(e => e.grid).forEach(function (panel) {
                gridapiRefs.current[idx] = createRef();
                gridcolapiRefs.current[idx] = createRef();
                const initRows = [];
                griddataRefs.current[idx] = { current: initRows };
                gridcolRefs.current[idx] = { current: [] };
                glist.push({ id: panel.id, type: panel.type, index: idx });
                gridmaxinit[fnc.current.GridID(panel)] = false;
                idx++;
            });

            dispatch(setgridlist(glist));
            // GridPanel最大化Flag（他画面の残値を引き継がない）
            var gridmax = Getstorage(corpkey, account, GridPanelStorageKey);
            if (isEmpty(gridmax)) {
                gridmax = gridmaxinit;
            } else {
                const normalized = {};
                Object.keys(gridmaxinit).forEach((k) => {
                    normalized[k] = isEnabled(gridmax[k]);
                });
                gridmax = normalized;
            }
            GridPanelRef.current = gridmax;
            dispatch(gridmaximize(gridmax));

            if (tabsData.prelayout) {
                RestoreLayout(normalizedPanels, fields);
            }

            let state = props.location.state;
            if (isEmpty(state) && !isEmpty(window.history.state)) {
                if ("status" in window.history.state) {
                    state = window.history.state;
                }
            }
            const stateCode = String(DicVal(state, "code", "") || DicVal(state, "request", "")).trim();
            const hasPendingShowRequest = !isEmpty(pendingShowRef.current);
            if (!isEmpty(stateCode) && !hasPendingShowRequest) {
                locationstate.current = state;
                clearform();
                dispatch(changestatus(stateCode === "" ? "NEW FORM" : "ENTRY FORM"));
            } else {
                locationstate.current = null;
            }
            setTabsReady(true);
        };
        const requestTabs = function (url) {
            fnc.current.postaxios(url, param, {
                onSuccess: function (data) {
                    applyTabsData(data);
                },
                onError: function () {
                    setTabsReady(false);
                    // レイアウト取得に失敗した時点で Entry 表示は続行できない。
                    // entryLoadingRef が true でも解除しないと、tabsReady=false のままとなり
                    // pendingShow の再実行条件も揃わず、ローディング表示のまま操作不能になる。
                    entryLoadingRef.current = false;
                    fnc.current.wait(false);
                }
            });
        };

        fnc.current.wait(true);
        requestTabs(listTabsUrl);
    }, [search]);


    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);
    // 本画面表示中のみ ResizeObserver の通知を rAF 経由にして
    // 拡大縮小時の通知連鎖（67%付近）を抑制する。
    useEffect(() => {
        if (typeof window === "undefined") return;
        const OriginalResizeObserver = window.ResizeObserver;
        if (isEmpty(OriginalResizeObserver)) return;
        const PatchedResizeObserver = class {
            constructor(callback) {
                this._raf = 0;
                this._observer = new OriginalResizeObserver((entries, observer) => {
                    if (this._raf) cancelAnimationFrame(this._raf);
                    this._raf = requestAnimationFrame(() => callback(entries, observer));
                });
            }
            observe(target, options) {
                this._observer.observe(target, options);
            }
            unobserve(target) {
                this._observer.unobserve(target);
            }
            disconnect() {
                if (this._raf) cancelAnimationFrame(this._raf);
                this._observer.disconnect();
            }
            takeRecords() {
                if (typeof this._observer.takeRecords === "function") return this._observer.takeRecords();
                return [];
            }
        };
        window.ResizeObserver = PatchedResizeObserver;
        return () => {
            window.ResizeObserver = OriginalResizeObserver;
        };
    }, []);
    useEffect(() => {
        resetColorwayMatrix();
    }, []);
    useEffect(() => {
        setSelectedOrderHistoryDenpyoMap((prev) => {
            const next = { ...prev };
            const ensureSelection = (sectionId, historyId) => {
                const history = Array.isArray(orderHistoryData[historyId]) ? orderHistoryData[historyId] : [];
                const optionRows = buildOrderHistoryOptionRows(history);
                const current = normalizeKakousijiUiString(next[sectionId]);
                if (current !== "" || optionRows.length === 0) return;
                next[sectionId] = optionRows[0].value;
            };
            ensureSelection("seihin", "seihin");
            ensureSelection("sozai_meisai", "sozai");
            ensureSelection("fuzoku_meisai", "fuzoku");
            ensureSelection("fukushizai", "fukushizai");
            return next;
        });
    }, [orderHistoryData]);

    useEffect(() => {
        if (formstatus === "COPY FORM") {
            columninfo.filter(e => e.copyclear).forEach(function (col) {
                entrydataRef.current[col.columnid] = "";
            });
            rerender();
        }
    }, [formstatus]);
    useEffect(() => {
        if (isEmpty(pendingShowRef.current)) return;
        if (!canExecuteShow()) return;
        const req = pendingShowRef.current;
        pendingShowRef.current = null;
        executeShowWithCode(req.code, req.data);
    }, [tabsReady, columninfo, gridlist, panel]);
    useEffect(() => {
        const contextItem = normalizeKakousijiUiString(selectedFukushizaiContextRef.current?.itemCd);
        const contextGroup = normalizeGroupNo(selectedFukushizaiContextRef.current?.groupNo);
        const itemCandidate = normalizeKakousijiUiString(
            selectedSetItem ||
            contextItem
        );
        const groupCandidate = normalizeGroupNo(
            selectedGroup ||
            contextGroup
        );
        // アイテム未選択状態は廃止。選択もcontextも空なら先頭アイテム+先頭グループを自動選択し、
        // グリッド再構築まで含めて反映する(setStateだけでは表示が切り替わらないため)。
        if (isEmpty(selectedSetItem) && itemCandidate === "") {
            const firstOptionItem = normalizeKakousijiUiString(
                getFukushizaiItemTabOptions()
                    .map((item) => getNamedOptionCode(item))
                    .find((code) => code !== "") || ""
            );
            if (firstOptionItem !== "") {
                const firstGroup = getFirstFukushizaiGroupNo(firstOptionItem);
                setSelectedSetItem(firstOptionItem);
                if (isEmpty(selectedGroup) && firstGroup !== "") setSelectedGroup(firstGroup);
                refreshFukushizaiContextSelection({ itemCd: firstOptionItem, groupNo: firstGroup });
            }
            return;
        }
        if (isEmpty(selectedSetItem) && itemCandidate !== "") setSelectedSetItem(itemCandidate);
        if (isEmpty(selectedGroup) && groupCandidate !== "") {
            setSelectedGroup(groupCandidate);
        } else if (!fukushizaiGroupClearedByUserRef.current && itemCandidate !== "" && isEmpty(selectedGroup) && isEmpty(contextGroup)) {
            const firstGroup = getFirstFukushizaiGroupNo(itemCandidate);
            if (firstGroup !== "") {
                setSelectedGroup(firstGroup);
                updateSelectedFukushizaiContext({ itemCd: itemCandidate, groupNo: firstGroup });
            }
        }
        if (!copyContextTouchedRef.current) {
            const nextCopyItem = normalizeKakousijiUiString(copyItem || itemCandidate);
            const nextCopyGroup = normalizeGroupNo(copyGroup || groupCandidate);
            if (isEmpty(copyItem) && nextCopyItem !== "") setCopyItem(nextCopyItem);
            if (isEmpty(copyGroup) && nextCopyGroup !== "") setCopyGroup(nextCopyGroup);
        }
    }, [setItemOptions, groupOptions, fukushizaiItemMasterOptions, fukushizaiItemAddedOptions, groupRows, selectedSetItem, selectedGroup, copyItem, copyGroup]);
    useEffect(() => {
        updateSelectedFukushizaiContext({
            itemCd: selectedSetItem,
            groupNo: selectedGroup,
            colorCd: selectedFukushizaiContextRef.current.colorCd
        });
    }, [selectedSetItem, selectedGroup]);
    // 品質表示コンテキストを selectedQualityItem/Group と同期する。
    // アイテム候補は品質detail行+追加/seedアイテムから導出するため(副資材とは独立)、
    // 未選択時は品質側候補の先頭でseedする。グループも品質側候補の先頭でseedする。
    useEffect(() => {
        let qItem = selectedQualityItem;
        let qGroup = selectedQualityGroup;
        if (isEmpty(qItem)) {
            const fallbackItem = normalizeKakousijiUiString(
                getQualityItemTabOptions().map((option) => DicVal(option, "code", "")).find((code) => code !== "") || ""
            );
            if (!isEmpty(fallbackItem)) { qItem = fallbackItem; setSelectedQualityItem(qItem); }
        }
        if (isEmpty(qGroup) && !isEmpty(qItem)) {
            const fallbackGroup = getKnownQualityGroupNos(qItem)[0] || "";
            if (!isEmpty(fallbackGroup)) { qGroup = fallbackGroup; setSelectedQualityGroup(qGroup); }
        }
        // 品質グリッド(118-124)は「コンテキスト未確定=空行」で構築されるため、
        // ここで未確定→確定へ変わる場合は state 更新だけでなくグリッド再適用まで行う。
        // (通常はロード時の applyKakousijiUiData で確定済みのため、この分岐は保険)
        const wasIncomplete = !hasCompleteFukushizaiContext(selectedQualityContextRef.current);
        if (wasIncomplete && !isEmpty(qItem) && !isEmpty(qGroup)) {
            refreshQualityContextSelection({ itemCd: qItem, groupNo: qGroup });
            return;
        }
        updateSelectedQualityContext({
            itemCd: qItem,
            groupNo: qGroup,
            colorCd: selectedQualityContextRef.current.colorCd
        });
    }, [selectedQualityItem, selectedQualityGroup, selectedSetItem, selectedGroup, qualityItemOptions]);
    // 新規作成(データ未ロード)時はdetailが空のため、両ドメインへ既定アイテム00をseedする。
    useEffect(() => {
        if (formstatus !== "NEW FORM") return;
        seedDefaultQualityItemIfNeeded();
        seedDefaultFukushizaiItemIfNeeded();
    }, [formstatus]);
    // ---------------------------------------------------------------------
    // 遷移コード解決・画面操作入口
    // ---------------------------------------------------------------------
    // 一覧、遷移state、URLから開く対象コードを解決する。
    function resolveCodeFromRowData(row) {
        if (isEmpty(row)) return "";
        const getByKey = function (obj, key) {
            if (isEmpty(obj) || isEmpty(key)) return "";
            if (key in obj) return DicVal(obj, key, "");
            const keys = Object.keys(obj);
            const hit = keys.find(k => String(k).toUpperCase() === String(key).toUpperCase());
            if (!isEmpty(hit)) return DicVal(obj, hit, "");
            return "";
        };
        for (let i = 0; i < primarykeys.length; i++) {
            const key = primarykeys[i];
            const val = getByKey(row, key);
            if (!isEmpty(val)) return val;
        }
        const directKeys = ["SSDNY_NO", "SSD_NO", "SSDX_NO", "SSDN_NO", "KAKOUSIJI_NO", "KAKOSHIJI_NO", "KKSJ_NO"];
        for (let i = 0; i < directKeys.length; i++) {
            const val = getByKey(row, directKeys[i]);
            if (!isEmpty(val)) return val;
        }
        return "";
    }

    // Show呼び出し時に使用する最終コードを決定する。
    function resolveEntryCode(data, pushcode) {
        if (data === undefined) {
            if (!isEmpty(pushcode)) return pushcode;
            return isEmpty(edittingcode) ? "" : edittingcode;
        }
        let code = "";
        if (data !== null) {
            for (let i = 0; i < primarykeys.length; i++) {
                const key = primarykeys[i];
                if (!isEmpty(DicVal(data, key, ""))) {
                    code = DicVal(data, key, "");
                    break;
                }
            }
        }
        if (isEmpty(code)) code = resolveCodeFromRowData(data);
        if (isEmpty(code) && !isEmpty(pushcode)) code = pushcode;
        return code;
    }

    // 遷移stateに保持されたコードでShowを1回だけ実行する。
    function callShowFromLocationState() {
        if (isEmpty(locationstate.current)) return;
        const stateCode = String(DicVal(locationstate.current, "code", "") || DicVal(locationstate.current, "request", ""));
        if (!isEmpty(stateCode)) {
            Show(undefined, stateCode);
        }
        locationstate.current = null;
    }
    // 現在列定義から実データ列（補助列除外）を抽出する。
    function dataColumnsFromDefs(defs) {
        if (!Array.isArray(defs)) return [];
        return defs.filter((d) => {
            const cid = String(DicVal(d, "colId", DicVal(d, "field", "")));
            return cid !== "" && !isGridAuxColId(cid);
        });
    }
    // 指定パネルのtype候補を、受注/納品は130/131優先で解決する。
    function resolveTypeCandidatesForPanel(panelInfo) {
        const ptype = String(DicVal(panelInfo, "type", ""));
        const pid = String(DicVal(panelInfo, "id", ""));
        const demandType = demandTypeKeyByPanel(panelInfo);
        if (!isEmpty(demandType)) return [demandType];
        let typeCandidates = resolveTypeCandidates(ptype);
        if (typeCandidates.length === 0) typeCandidates = resolveTypeCandidates(tabletype(pid));
        if (typeCandidates.length === 0) typeCandidates = resolveTypeCandidates(pid);
        return typeCandidates;
    }
    // type候補に応じて列定義を再構築する（原価/受注/納品の特殊表示を適用）。
    function createPanelColumnDefsByType(panelInfo, typeCandidates, fukushizaiPreviewLock = undefined) {
        if (!Array.isArray(typeCandidates) || typeCandidates.length === 0) return [];
        const typedColInfo = columninfo.filter(e => typeCandidates.includes(String(e.type ?? "").trim().toLowerCase()));
        const typedLayoutCols = Array.isArray(columns)
            ? columns.filter(e => typeCandidates.includes(String(e.type ?? "").trim().toLowerCase()))
            : [];
        let nextDefs = AGRef.current.createColDef(
            typedColInfo,
            typedLayoutCols,
            false
        );
        if (isGenkaGridPanelInfo(panelInfo)) {
            nextDefs = buildGenkaFixedColumns(nextDefs, "genka");
        }
        nextDefs = buildDemandColumns(nextDefs, panelInfo);
        // 納品予定ヘッダの2段化判定は builder 側へ閉じ込めます。
        nextDefs = buildNouhinHeaderColumns(nextDefs, panelInfo);
        if (isQualityPanelType(getPanelType(panelInfo))) {
            nextDefs = nextDefs.map((col) => applyQualityHsituhabaLocalSelectColDef(col));
        }
        if (isKomonofudaPanelInfo(panelInfo)) {
            nextDefs = nextDefs.map((col) => {
                if (isEmpty(col) || typeof col !== "object") return col;
                const colId = String(DicVal(col, "colId", DicVal(col, "field", "")) ?? "").trim().toUpperCase();
                if (colId === "KOMONOFUDA_NAIYO_DMY") {
                    const next = {
                        ...col,
                        editable: function () {
                            if (isFukushizaiCopyPreviewing) return false;
                            if (layoutlock || entrylock) return false;
                            return true;
                        },
                        suppressClickEdit: false,
                        cellEditor: "agTextCellEditor",
                        locked: false,
                        unchange: false,
                        saveed: false,
                        datatype: "0"
                    };
                    next.colinfo = {
                        ...(isEmpty(col.colinfo) ? {} : col.colinfo),
                        locked: false,
                        unchange: false,
                        saveed: false,
                        datatype: "0"
                    };
                    return next;
                }
                if (colId === "SSDZ_KOMONOFUDACD") {
                    return {
                        ...col,
                        editable: false,
                        suppressClickEdit: true,
                        datatype: CELLTYPE.MASTERREF,
                        dataid: "",
                        dbcolumn: "",
                        dbcolumnnm: "",
                        mastertype: "",
                        keyinfo: ""
                    };
                }
                return col;
            });
        }
        const shouldLockFukushizai = typeof fukushizaiPreviewLock === "boolean"
            ? fukushizaiPreviewLock
            : isFukushizaiCopyPreviewing;
        if (shouldLockFukushizai && isFukushizaiContextDisplayPanelInfo(panelInfo)) {
            nextDefs = nextDefs.map((col) => {
                if (isEmpty(col) || typeof col !== "object") return col;
                return {
                    ...col,
                    editable: false,
                    suppressClickEdit: true
                };
            });
        }
        nextDefs = applyDesignReadonlyToColDefs(nextDefs, typeCandidates);
        return Array.isArray(nextDefs) ? nextDefs : [];
    }
    // 名称補完用に、現在パネルで有効な master 列定義を取得する。
    function resolvePanelMasterColumnDefsForHydration(panelInfo) {
        const currentDefs = ensureGridColRef(panelInfo).current;
        if (Array.isArray(currentDefs) && currentDefs.length !== 0) return currentDefs;
        const typeCandidates = resolveTypeCandidatesForPanel(panelInfo);
        let nextDefs = createPanelColumnDefsByType(panelInfo, typeCandidates);
        if (isDemeritPanelInfo(panelInfo)) {
            nextDefs = buildDemeritGridColumns(nextDefs);
        }
        if (isBrandNamePanelInfo(panelInfo)) {
            nextDefs = buildBrandNameGridColumns(nextDefs);
        }
        return Array.isArray(nextDefs) ? nextDefs : [];
    }
    // 品質表示幅の候補は EntryData 受信後に確定するため、品質系 Grid の列定義だけ再適用する。
    function refreshQualityPanelColumnDefs() {
        if (!Array.isArray(gridlist) || gridlist.length === 0) return;
        gridlist.forEach((panelInfo) => {
            if (!isQualityPanelType(getPanelType(panelInfo))) return;
            const typeCandidates = resolveTypeCandidatesForPanel(panelInfo);
            if (!Array.isArray(typeCandidates) || typeCandidates.length === 0) return;
            const nextDefs = createPanelColumnDefsByType(panelInfo, typeCandidates);
            if (!Array.isArray(nextDefs) || nextDefs.length === 0) return;
            SetGridColDef(panelInfo, nextDefs);
            // AG Grid へ直接 columnDefs を流し込むと、EntryGridAr が React 側で付与している
            // valueFormatter / cellRenderer ごと差し替わってしまう。
            // createPanelColumnDefsByType が返す定義にはそれらが含まれないため、
            // MASTER 列が「コード:名称」に整形されなくなり、コードだけの表示になる。
            // （初回はこの時点で GridApi が未生成のため差し替えが起きず、2回目以降だけ発症していた）
            // ref を更新したうえで再描画を要求し、必ず EntryGridAr の列適用経路を通す。
            gridRefreshCoordinator.scheduleGridDataRerender(panelInfo);
        });
    }
    // 初回描画時に、保持済みrowDataをAPIへ反映する。
    function restoreRowsOnFirstRender(panelInfo, api) {
        const currentRows = GridData(panelInfo);
        if (!Array.isArray(currentRows) || currentRows.length === 0) return;
        setGridRowsByApi(api, currentRows);
    }
    // 初回描画時に、列不足時の列定義再構築を行う。
    function rebuildColumnDefsOnFirstRender(panelInfo, api) {
        if (isWashPanelInfo(panelInfo)) return;
        if (isEmpty(api) || typeof api.getColumnDefs !== "function") return;
        if (!Array.isArray(columninfo) || columninfo.length === 0) return;
        const defs = api.getColumnDefs();
        const hasDataCols = dataColumnsFromDefs(defs).length !== 0;
        const typeCandidates = resolveTypeCandidatesForPanel(panelInfo);
        // 既に実データ列が存在する場合は再適用しない。
        // setColumnDefs の連続実行で Header refresh が再入し、React の update depth 超過を招くため。
        if (hasDataCols) return;
        if (typeCandidates.length === 0) return;
        const nextDefs = createPanelColumnDefsByType(panelInfo, typeCandidates);
        if (!Array.isArray(nextDefs) || nextDefs.length === 0) return;
        SetGridColDef(panelInfo, nextDefs);
        setGridColumnDefsByApi(api, nextDefs);
        fitDemandColumns(panelInfo, api);
    }
    // 初回描画時のパネル種別ごとの表示補正（補助列・固定行など）を適用する。
    function applyPanelDisplayFixesOnFirstRender(panelInfo, api) {
        const isDemandPanel = isDemandPanelInfo(panelInfo);
        if (isDemandPanel || isGenkaGridPanelInfo(panelInfo) || isGenkaTotalPanelInfo(panelInfo)) {
            if (!isDemandPanel) {
                hideGridAuxColumns(api);
            }
            if (isDemandPanel) {
                enforceDemandLeftColumns(panelInfo, api);
                fitDemandColumns(panelInfo, api);
            }
        }
        if (isGenkaGridPanelInfo(panelInfo) || isGenkaTotalPanelInfo(panelInfo)) {
            if (!isEmpty(api) && typeof api.setGridOption === "function") {
                api.setGridOption("rowNumbers", false);
            }
        }
    }
    // 遷移state待ちの初回表示は、全グリッド初期化後にShowを1回だけ実行する。
    function callShowWhenAllVisibleGridReady() {
        if (isEmpty(locationstate.current) || !isEmpty(getglobaldata("entryrowdata"))) return;
        let call = true;
        for (let i = 0; i < gridlist.length; i++) {
            if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
            const gid = fnc.current.GridID(gridlist[i]);
            if (isEmpty(document.getElementById(gid))) continue;
            if (isEmpty(GridApi(gridlist[i]))) {
                call = false;
                break;
            }
        }
        if (call) callShowFromLocationState();
    }

    //遷移state状態表示
    // 遷移元の状態に応じて初期表示を分岐する。
    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.columnApi);
        try {
            rebuildColumnDefsOnFirstRender(panel, param.api);
        } catch (e) { console.error(e); }
        try {
            applyPanelDisplayFixesOnFirstRender(panel, param.api);
            if (!gridRefreshCoordinator.flushPendingGridApply(panel)) {
                restoreRowsOnFirstRender(panel, param.api);
            }
            if (isGenkaGridPanelInfo(panel)) {
                gridRefreshCoordinator.flushPendingGenkaEditableRefresh("onFirstDataRendered");
            }
            callShowWhenAllVisibleGridReady();
        } catch (e) { console.error(e); }
    }
    // 入力画面表示処理の入口。
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            code = resolveEntryCode(undefined, pushcode);
            if (!isEmpty(code)) setedittingcode(code);
        } else {
            // 一覧選択からの遷移時は locationstate 経由の二重Showを防ぐ。
            locationstate.current = null;
            setglobaldata("entryrowdata",data);
            applyKakouShijiKubun(data);
            code = resolveEntryCode(data, pushcode);
            if (!isEmpty(code)) setedittingcode(code);
        }
        if (isEmpty(code)) return false;
        // 遷移直後からローディングを表示し、初回描画中の操作を抑止する。
        entryLoadingRef.current = true;
        fnc.current.wait(true);
        // 既存Forms寄せ + 2回押し対策:
        // 準備前は1回だけ要求を保留し、準備完了後に自動でShowを再実行する。
        if (!canExecuteShow()) {
            pendingShowRef.current = { code: code, data: data };
            return true;
        }
        executeShowWithCode(code, data);
        return true;
    }
    function executeShowWithCode(code, data) {
        if (isEmpty(code)) return false;
        // VIEW→Entry遷移時は受注/納品データの有無に関わらず基本情報タブから表示する。
        entryShowKakouTypeResetRef.current = true;
        clearDeferredEntryVisualTraceTimers();
        activateEntryVisualTraceWindow(10000);
        entryLoadingRef.current = true;
        logEntryVisualTrace("executeShowWithCode:start", {
            code,
            hasRowData: !isEmpty(data),
            rowDataSample: buildEntryVisualFieldSamples(data)
        });
        dispatchEntryDataWithTrace({}, "executeShowWithCode:clearReduxEntrydata");
        logEntryVisualTrace("executeShowWithCode:dispatchedEmptyReduxEntrydata", { code });
        fnc.current.wait(true);
        if (code === "") clearform(true);
        if (!isEmpty(data)) {
            applyKakouShijiKubun(data);
        } else {
            applyKakouShijiKubun(getglobaldata("entryrowdata"));
        }
        //データ読み込み
        LoadData(code);
        return true;
    }

    // レイアウト設定の反映。
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    // パネルの表示/非表示を切り替える。

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    function replaceDetailRowsByType(panelType, rows) {
        const detail = ensureDetailRowsByTypeForMutation(panelType);
        const nextRows = DeepCopy(Array.isArray(rows) ? rows : []);
        entrydetailRef.current[detail.key] = nextRows;
        return nextRows;
    }
    function detailLinkKey(row, noField, gyonoField) {
        const no = normalizeKakousijiUiString(readRowValueIgnoreCase(row, noField));
        const gyono = normalizeKakousijiUiString(readRowValueIgnoreCase(row, gyonoField));
        if (no === "" && gyono === "") return "";
        return `${no}\u0001${gyono}`;
    }
    function strictDetailLinkKey(row, noField, gyonoField) {
        const no = normalizeKakousijiUiString(readRowValueIgnoreCase(row, noField));
        const gyono = normalizeKakousijiUiString(readRowValueIgnoreCase(row, gyonoField));
        if (no === "" || gyono === "") return "";
        return `${no}\u0001${gyono}`;
    }
    function resolveRowIdentityKey(row) {
        const rowid = normalizeKakousijiUiString(DicVal(row, "rowid", ""));
        if (rowid !== "") return `rowid:${rowid}`;
        const rowKey = normalizeKakousijiUiString(DicVal(row, "rowKey", ""));
        if (rowKey !== "") return `rowKey:${rowKey}`;
        return "";
    }
    function detailMasterBusinessKeys(panelType, row) {
        const type = canonicalPanelType(panelType);
        const keys = [];
        const add = (value) => {
            const key = normalizeKakousijiUiString(value);
            if (key !== "" && keys.indexOf(key) === -1) keys.push(key);
        };
        if (type === "107") {
            add(strictDetailLinkKey(row, "SSDS_NO", "SSDS_KIJIGYO"));
            add(strictDetailLinkKey(row, "SSDS_NO", "SSDS_GYONO"));
        }
        if (type === "110") {
            add(detailLinkKey(row, "SSDF_NO", "SSDF_GYONO"));
        }
        return keys;
    }
    function resolveDetailMasterRowIndex(params, rows) {
        const index = Number(DicVal(DicVal(params, "node", null), "rowIndex", -1));
        const list = Array.isArray(rows) ? rows : [];
        return Number.isFinite(index) && index >= 0 && index < list.length ? index : -1;
    }
    function replaceRowInListByIdentity(rows, updatedRow, options = {}) {
        const list = Array.isArray(rows) ? rows : [];
        const panelType = canonicalPanelType(DicVal(options, "panelType", ""));
        const businessKeys = detailMasterBusinessKeys(panelType, updatedRow);
        const targetKey = resolveRowIdentityKey(updatedRow);
        const targetIndex = Number(DicVal(options, "rowIndex", -1));
        let replaced = false;
        const nextRows = list.map((row, index) => {
            if (replaced) return row;
            const rowBusinessKeys = detailMasterBusinessKeys(panelType, row);
            const matchedByBusinessKey = businessKeys.length !== 0 && rowBusinessKeys.some((key) => businessKeys.indexOf(key) !== -1);
            const matchedByIndex = targetIndex >= 0 && index === targetIndex;
            const matchedByIdentity = targetKey !== "" && resolveRowIdentityKey(row) === targetKey;
            if (!matchedByBusinessKey && !matchedByIndex && !matchedByIdentity) return row;
            replaced = true;
            return updatedRow;
        });
        return { rows: replaced ? nextRows : list, changed: replaced, replaced };
    }
    function commitGridRowToRefs(panelInfo, updatedRow, options = {}) {
        if (isEmpty(panelInfo) || isEmpty(updatedRow)) return false;
        const currentRows = Array.isArray(GridData(panelInfo)) ? GridData(panelInfo) : [];
        const replaced = replaceRowInListByIdentity(currentRows, updatedRow, {
            ...options,
            panelType: canonicalPanelType(DicVal(panelInfo, "type", ""))
        });
        if (!replaced.replaced) return false;
        SetGridData(panelInfo, replaced.rows);
        return replaced.rows;
    }
    function commitDetailRowByType(panelType, updatedRow, options = {}) {
        const detail = ensureDetailRowsByTypeForMutation(panelType);
        const replaced = replaceRowInListByIdentity(detail.rows, updatedRow, {
            ...options,
            panelType
        });
        if (!replaced.replaced) return false;
        entrydetailRef.current[detail.key] = DeepCopy(replaced.rows);
        return replaced.rows;
    }
    function resolveExistingDetailMasterRow(panelInfo, panelType, params, currentRow) {
        const gridRows = Array.isArray(GridData(panelInfo)) ? GridData(panelInfo) : [];
        const detailRows = getDetailRowsByPanelType(entrydetailRef.current, panelType);
        const rowIndex = resolveDetailMasterRowIndex(params, gridRows);
        if (rowIndex >= 0 && rowIndex < gridRows.length) return gridRows[rowIndex];
        const nodeId = normalizeKakousijiUiString(DicVal(DicVal(params, "node", null), "id", ""));
        if (nodeId !== "") {
            const matchByNodeId = (rows) => (Array.isArray(rows) ? rows : []).find((row) =>
                normalizeKakousijiUiString(DicVal(row, "rowid", "")) === nodeId
            );
            const byNodeId = matchByNodeId(gridRows) || matchByNodeId(detailRows);
            if (!isEmpty(byNodeId)) return byNodeId;
        }
        const businessKeys = detailMasterBusinessKeys(panelType, currentRow);
        const findByBusinessKey = (rows) => (Array.isArray(rows) ? rows : []).find((row) =>
            detailMasterBusinessKeys(panelType, row).some((key) => businessKeys.indexOf(key) !== -1)
        );
        return findByBusinessKey(gridRows) || findByBusinessKey(detailRows) || null;
    }
    function readMaterialColorwayHinbanCode(row) {
        return normalizeDetailMasterCode(readRowValueIgnoreCase(row, "SSDSH_ZAIHINBAN_cd"))
            || normalizeDetailMasterCode(readRowValueIgnoreCase(row, "SSDSH_ZAIHINBAN"));
    }
    function readAccessoryColorwayHinbanCode(row) {
        return normalizeDetailMasterCode(readRowValueIgnoreCase(row, "SSDFH_FUZOKU_HINBAN_cd"))
            || normalizeDetailMasterCode(readRowValueIgnoreCase(row, "SSDFH_FUZOKU_HINBAN"));
    }
    function applyMaterialDetailFieldsToColorwayRow(row, sourceRow) {
        const next = { ...(row || {}) };
        const code = readMaterialZaiHinbanCode(sourceRow);
        const name = resolveMaterialZaiHinbanName(sourceRow, code, [sourceRow]);
        const kijigyo = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDS_KIJIGYO"));
        const ssdsGyono = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDS_GYONO"));
        next.SSDSH_NO = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDS_NO"));
        next.SSDSH_GYONO = kijigyo !== "" ? kijigyo : ssdsGyono;
        next.SSDSH_SIIREKBN = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDS_SIIREKBN"));
        next.SSDSH_SIIRECD = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDS_SIIRECD"));
        next.SSDSH_SIIRESUBCD = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDS_SIIRESUBCD"));
        next.SSDSH_ZAIHINBAN = code;
        next.SSDSH_ZAIHINBAN_cd = code;
        next.SSDSH_ZAIHINBAN_nm = name;
        next.ZAI_NAME = name;
        MATERIAL_ZAI_LINKED_FIELD_IDS.forEach((fieldId) => {
            if (hasOwnGridValue(sourceRow, fieldId)) {
                next[fieldId] = readRowValueIgnoreCase(sourceRow, fieldId);
            }
        });
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((source) => applyMaterialDetailFieldsToColorwayRow(source, sourceRow));
        }
        return next;
    }
    function applyAccessoryDetailFieldsToColorwayRow(row, sourceRow) {
        const next = { ...(row || {}) };
        const code = readAccessoryFuzokuHinbanCode(sourceRow);
        const name = resolveAccessoryFuzokuHinbanName(sourceRow, code, [sourceRow]);
        next.SSDFH_NO = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDF_NO"));
        next.SSDFH_GYONO = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDF_GYONO"));
        next.SSDFH_SIIREKBN = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDF_SIIREKBN"));
        next.SSDFH_SIIRECD = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDF_SIIRECD"));
        next.SSDFH_SIIRESUBCD = normalizeKakousijiUiString(readRowValueIgnoreCase(sourceRow, "SSDF_SIIRESUBCD"));
        next.SSDFH_FUZOKU_HINBAN = code;
        next.SSDFH_FUZOKU_HINBAN_cd = code;
        next.SSDFH_FUZOKU_HINBAN_nm = name;
        next.FZK_FUZOKU_NM = name;
        if (Array.isArray(DicVal(row, "__sourceRows", null))) {
            next.__sourceRows = row.__sourceRows.map((source) => applyAccessoryDetailFieldsToColorwayRow(source, sourceRow));
        }
        return next;
    }
    function syncMaterialDetailRowsToColorwayRows({ sourceRowsOverride } = {}) {
        const sourcePanel = resolveGridPanelByType("107");
        const targetPanel = resolveGridPanelByType("108");
        const sourceRows = Array.isArray(sourceRowsOverride)
            ? replaceDetailRowsByType("107", sourceRowsOverride)
            : replaceDetailRowsByType("107", !isEmpty(sourcePanel) ? GridData(sourcePanel) : getDetailRowsByPanelType(entrydetailRef.current, "107"));
        const currentTargetRows = Array.isArray(getDetailRowsByPanelType(entrydetailRef.current, "108")) ? DeepCopy(getDetailRowsByPanelType(entrydetailRef.current, "108")) : [];
        const sourceMap = new Map();
        sourceRows.forEach((row) => {
            const key = strictDetailLinkKey(row, "SSDS_NO", "SSDS_KIJIGYO") || strictDetailLinkKey(row, "SSDS_NO", "SSDS_GYONO");
            if (key !== "") sourceMap.set(key, row);
        });
        let changed = false;
        const nextTargetRows = [];
        currentTargetRows.forEach((row) => {
            const key = strictDetailLinkKey(row, "SSDSH_NO", "SSDSH_GYONO");
            if (key === "") {
                nextTargetRows.push(row);
                return;
            }
            const sourceRow = sourceMap.get(key);
            if (isEmpty(sourceRow)) {
                nextTargetRows.push(row);
                return;
            }
            const nextRow = applyMaterialDetailFieldsToColorwayRow(row, sourceRow);
            if (JSON.stringify(nextRow) !== JSON.stringify(row)) changed = true;
            nextTargetRows.push(nextRow);
        });
        replaceDetailRowsByType("108", nextTargetRows);
        if (changed && !isEmpty(targetPanel)) {
            const displayRows = normalizeDetailRowsForPanel(targetPanel, entrydetailRef.current);
            SetGridData(targetPanel, displayRows);
        }
        return changed;
    }
    function syncAccessoryDetailRowsToColorwayRows({ sourceRowsOverride } = {}) {
        const sourcePanel = resolveGridPanelByType("110");
        const targetPanel = resolveGridPanelByType("111");
        const sourceRows = Array.isArray(sourceRowsOverride)
            ? replaceDetailRowsByType("110", sourceRowsOverride)
            : replaceDetailRowsByType("110", !isEmpty(sourcePanel) ? GridData(sourcePanel) : getDetailRowsByPanelType(entrydetailRef.current, "110"));
        const currentTargetRows = Array.isArray(getDetailRowsByPanelType(entrydetailRef.current, "111")) ? DeepCopy(getDetailRowsByPanelType(entrydetailRef.current, "111")) : [];
        const sourceMap = new Map();
        sourceRows.forEach((row) => {
            const key = detailLinkKey(row, "SSDF_NO", "SSDF_GYONO");
            if (key !== "") sourceMap.set(key, row);
        });
        let changed = false;
        const nextTargetRows = [];
        currentTargetRows.forEach((row) => {
            const key = detailLinkKey(row, "SSDFH_NO", "SSDFH_GYONO");
            if (key === "") {
                nextTargetRows.push(row);
                return;
            }
            const sourceRow = sourceMap.get(key);
            if (isEmpty(sourceRow)) {
                nextTargetRows.push(row);
                return;
            }
            const nextRow = applyAccessoryDetailFieldsToColorwayRow(row, sourceRow);
            if (JSON.stringify(nextRow) !== JSON.stringify(row)) changed = true;
            nextTargetRows.push(nextRow);
        });
        replaceDetailRowsByType("111", nextTargetRows);
        if (changed && !isEmpty(targetPanel)) {
            const displayRows = normalizeDetailRowsForPanel(targetPanel, entrydetailRef.current);
            SetGridData(targetPanel, displayRows);
        }
        return changed;
    }
    function syncLinkedDetailPanelsFromGrid(panel = undefined, options = {}) {
        const panelType = canonicalPanelType(DicVal(panel, "type", ""));
        const syncMaterial = panel === undefined || panelType === "107";
        const syncAccessory = panel === undefined || panelType === "110";
        let changed = false;
        if (syncMaterial) changed = syncMaterialDetailRowsToColorwayRows({ sourceRowsOverride: DicVal(options, "materialSourceRowsOverride", null) }) || changed;
        if (syncAccessory) changed = syncAccessoryDetailRowsToColorwayRows({ sourceRowsOverride: DicVal(options, "accessorySourceRowsOverride", null) }) || changed;
        if (changed) applyDetailRowsToGrids(entrydetailRef.current);
        return changed;
    }
    // 編集中グリッドの行データを保存する。
    function storeRowData(panel) {
        const hydrateMasterNamesIfNeeded = (targetPanel) => {
            if (isEmpty(targetPanel) || isWashPanelInfo(targetPanel)) return;
            hydratePanelRowsAsync(targetPanel);
        };
        const syncLinkedPanelsIfNeeded = (targetPanel) => {
            const panelType = canonicalPanelType(DicVal(targetPanel, "type", ""));
            if (panelType === "107" || panelType === "110") {
                syncLinkedDetailPanelsFromGrid(targetPanel);
            }
        };
        const syncFixedVerticalRows = (targetPanel) => {
            const rows = normalizeFixedVerticalDisplayRows(targetPanel, AGRef.current.GetDatasource(GridApi(targetPanel)));
            if (isKomonofudaPanelInfo(targetPanel) || isBrandNamePanelInfo(targetPanel) || isOtherNamePanelInfo(targetPanel) || isOtherFukuzaiPanelInfo(targetPanel)) {
                fukushizaiProjection.syncDisplayRowsToDetail(targetPanel, rows, { timing: "store" });
            }
            SetGridData(targetPanel, rows);
            if (!entryLoadingRef.current && !isEmpty(GridApi(targetPanel)) && isGridDomReady(targetPanel)) {
                applyGridRowsNow(targetPanel, rows);
            }
        };
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                if (isFukushizaiDetailPanelInfo(gridlist[i]) && isFukushizaiBaseDisplaySection()) {
                    continue;
                }
                if (isFixedVerticalDisplayPanelInfo(gridlist[i])) {
                    syncFixedVerticalRows(gridlist[i]);
                    continue;
                }
                // 洗濯表示124はM_STP選択時に親側GridData/detailを同期済み。古いAG datasourceで戻さない。
                if (isWashPanelInfo(gridlist[i])) {
                    continue;
                }
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
                hydrateMasterNamesIfNeeded(gridlist[i]);
            }
            syncLinkedDetailPanelsFromGrid();
        } else {
            if (isFukushizaiDetailPanelInfo(panel) && isFukushizaiBaseDisplaySection()) {
                syncFukushizaiRepresentativeRowFromEntry(entrydataRef.current);
                return;
            }
            if (isFixedVerticalDisplayPanelInfo(panel)) {
                syncFixedVerticalRows(panel);
                return;
            }
            // 洗濯表示124はM_STP選択時に親側GridData/detailを同期済み。古いAG datasourceで戻さない。
            if (isWashPanelInfo(panel)) {
                return;
            }
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
            hydrateMasterNamesIfNeeded(panel);
            syncLinkedPanelsIfNeeded(panel);
        }
    }
    function buildBrandNameEntryDataForGrid() {
        const src = entrydataRef.current || {};
        const next = { ...src };
        delete next.rowid;
        delete next.BRANDNAME_CD_DMY;
        delete next.BRANDNAME_NM_DMY;
        delete next.__brandNameSourceColumnId;
        delete next.__brandNameBaseRowId;
        delete next.BRANDNAME_CD_DMY_cd;
        delete next.BRANDNAME_CD_DMY_nm;
        delete next.BRANDNAME_CD_DMY_CD;
        delete next.BRANDNAME_CD_DMY_NM;
        return next;
    }
    function resolveEntryDataRefForGrid(panelInfo) {
        if (isBrandNamePanelInfo(panelInfo)) {
            brandNameEntryDataRef.current = buildBrandNameEntryDataForGrid();
            return brandNameEntryDataRef;
        }
        return entrydataRef;
    }
    function handleBrandNameRowValueChanged(panelInfo, colid, rows) {
        if (fukushizaiDetailSyncingRef.current) return;
        if (isKomonofudaPanelInfo(panelInfo)) {
            if (isFukushizaiCopyPreviewing) {
                fukushizaiProjection.refreshSectionViews(selectedSetItem, selectedGroup, pendingFukushizaiCopy, selectedFukushizaiContextRef.current);
                return;
            }
            markFukushizaiDirtyPanel(panelInfo);
            const currentRows = GridData(panelInfo);
            const list = (Array.isArray(rows) ? rows : [])
                .map((row) => restoreFukushizaiDisplayMetaFromCurrentRows(panelInfo, row, currentRows));
            SetGridData(panelInfo, list);
            list.forEach((row) => syncFukushizaiKomonoDisplayRowToDetail(row));
            if (!entryLoadingRef.current && !isEmpty(GridApi(panelInfo)) && isGridDomReady(panelInfo)) {
                fukushizaiProjection.applyDisplayRowsNow(panelInfo, list);
            }
            fnc.current.modify(true);
            return;
        }
        // デメリットは検索リストから選択すると EntryGridAr の Suppress により ValueChanged が呼ばれず、
        // 種別/フラグ/コードの同期(handleGridValueChanged 側)が走らないため、ここで同じ同期を行う。
        // 同期しないと SSDD_DMTCD が空のまま保存され、NothingDataRow 判定で登録がスキップされる。
        if (isDemeritPanelInfo(panelInfo)) {
            markFukushizaiDirtyPanel(panelInfo);
            const normalizedColId = normalizeColumnIdUpper(colid);
            (Array.isArray(rows) ? rows : []).forEach((row) => {
                if (isEmpty(row)) return;
                if (normalizedColId === normalizeColumnIdUpper(DEMERIT_KIND_FIELD)) {
                    applyDemeritKindToRow(row, DicVal(row, DEMERIT_KIND_FIELD, ""));
                }
                if (normalizedColId === DEMERIT_NAME_DMY.toUpperCase() || normalizedColId === DEMERIT_HUDA_DMY.toUpperCase()) {
                    syncDemeritDmtCd(row, colid);
                }
            });
            storeRowData(panelInfo);
            const demeritRows = GridData(panelInfo);
            // 品質表示のグループは副資材と独立して選択されるため、品質側のcontextで同期する。
            if (qualityProjection.syncDisplayGridToDetail(panelInfo, demeritRows, selectedQualityContextRef.current)) {
                if (!isEmpty(fnc.current) && typeof fnc.current.modify === "function") fnc.current.modify(true);
            }
            // 同期で書き換えた種別列を表示へ反映する。
            if (!entryLoadingRef.current && !isEmpty(GridApi(panelInfo)) && isGridDomReady(panelInfo)) {
                applyGridRowsNow(panelInfo, demeritRows);
            }
            return;
        }
        // 品質表示系の表示グリッド（組成明細・付記用語・構成部品など）も detail へ伝える。
        //
        // storeRowData だけでは Grid 用の保持データしか更新されず、detail(entrydetailRef) は元のまま残る。
        // セル編集は handleGridValueChanged 側で detail へ同期されるが、行の削除・追加はこの経路しか通らないため、
        // 同期しないと削除した行が detail に残り続け、保存時にそのまま送信される。
        // さらに他グループ・他カラーの行は detail から引き継がれるため、削除が全体へ反映されない。
        if (isQualityPanelType(getPanelType(panelInfo)) && getPanelType(panelInfo) !== PANEL_TYPE.QUALITY_BASE) {
            markFukushizaiDirtyPanel(panelInfo);
            storeRowData(panelInfo);
            const qualityRows = GridData(panelInfo);
            const synced = qualityProjection.syncDisplayGridToDetail(panelInfo, qualityRows, selectedQualityContextRef.current);
            if (synced) {
                if (!isEmpty(fnc.current) && typeof fnc.current.modify === "function") fnc.current.modify(true);
            }
            return;
        }
        if (!(isBrandNamePanelInfo(panelInfo) || isOtherNamePanelInfo(panelInfo) || isOtherFukuzaiPanelInfo(panelInfo))) {
            if (isColorwaySaveType(getPanelType(panelInfo))) {
                storeRowData(panelInfo);
                const currentRows = GridData(panelInfo);
                if (!entryLoadingRef.current && !isEmpty(GridApi(panelInfo)) && isGridDomReady(panelInfo)) {
                    applyGridRowsNow(panelInfo, currentRows);
                }
                return;
            }
            storeRowData(panelInfo);
            return;
        }
        if (isFukushizaiCopyPreviewing) {
            fukushizaiProjection.refreshSectionViews(selectedSetItem, selectedGroup, pendingFukushizaiCopy, selectedFukushizaiContextRef.current);
            return;
        }
        markFukushizaiDirtyPanel(panelInfo);
        fukushizaiProjection.syncDisplayRowsToDetail(panelInfo, Array.isArray(rows) ? rows : [], { timing: "immediate" });
        if (!entryLoadingRef.current && !isEmpty(GridApi(panelInfo)) && isGridDomReady(panelInfo)) {
            fukushizaiProjection.applyDisplayRowsNow(panelInfo, GridData(panelInfo));
        }
        fnc.current.modify(true);
    }
    // グリッド編集時に、受注/納品の集計行を再計算して再描画する。
    function handleGridValueChanged(panel, params) {
        if (fukushizaiDetailSyncingRef.current) return;
        if (isFukushizaiPreviewLockedPanel(panel)) {
            fukushizaiProjection.refreshSectionViews(selectedSetItem, selectedGroup, pendingFukushizaiCopy, selectedFukushizaiContextRef.current);
            return;
        }
        if (isBrandNamePanelInfo(panel) || isOtherNamePanelInfo(panel) || isOtherFukuzaiPanelInfo(panel) || isKomonofudaPanelInfo(panel)) {
            if (isFukushizaiCopyPreviewing && isFukushizaiContextDisplayPanelInfo(panel)) {
                fukushizaiProjection.refreshSectionViews(selectedSetItem, selectedGroup, pendingFukushizaiCopy, selectedFukushizaiContextRef.current);
                return;
            }
            if (isKomonofudaPanelInfo(panel)) {
                markFukushizaiDirtyPanel(panel);
                const eventRow = readFukushizaiEventRow(params);
                const rows = mergeFukushizaiEventRowIntoRows(panel, GridData(panel), eventRow);
                const eventRowId = String(DicVal(eventRow, "rowid", "") ?? "").trim();
                const syncRow = rows.find((row) => String(DicVal(row, "rowid", "") ?? "").trim() === eventRowId) || eventRow;
                SetGridData(panel, rows);
                syncFukushizaiKomonoDisplayRowToDetail(syncRow, params);
                if (!entryLoadingRef.current && !isEmpty(GridApi(panel)) && isGridDomReady(panel)) {
                    fukushizaiProjection.applyDisplayRowsNow(panel, rows);
                }
            } else {
                markFukushizaiDirtyPanel(panel);
                const eventRow = readFukushizaiEventRow(params);
                const currentRows = GridData(panel);
                const rows = mergeFukushizaiEventRowIntoRows(panel, currentRows, eventRow);
                const eventRowIndex = Number(DicVal(DicVal(params, "node", null), "rowIndex", -1));
                const changedField = String(DicVal(DicVal(params, "colDef", {}), "colId", "") || DicVal(DicVal(params, "colDef", {}), "field", ""));
                syncFukushizaiDisplayCellToDetail({
                    panelInfo: panel,
                    row: eventRow,
                    rowIndex: Number.isFinite(eventRowIndex) ? eventRowIndex : -1,
                    changedField,
                    rawValue: DicVal(params, "newValue", undefined),
                    timing: "immediate"
                });
                fukushizaiProjection.syncDisplayRowsToDetail(panel, rows, { timing: "immediate" });
                if (!entryLoadingRef.current && !isEmpty(GridApi(panel)) && isGridDomReady(panel)) {
                    fukushizaiProjection.applyDisplayRowsNow(panel, rows);
                }
            }
            fnc.current.modify(true);
            return;
        }
        if (isQualityPanelType(getPanelType(panel)) && getPanelType(panel) !== PANEL_TYPE.QUALITY_BASE) {
            markFukushizaiDirtyPanel(panel);
            if (isDemeritPanelInfo(panel)) {
                const row = DicVal(params, "data", null);
                const colId = String(DicVal(DicVal(params, "colDef", {}), "colId", "") || DicVal(DicVal(params, "colDef", {}), "field", ""));
                if (!isEmpty(row)) {
                    const normalizedColId = normalizeColumnIdUpper(colId);
                    if (normalizedColId === normalizeColumnIdUpper(DEMERIT_KIND_FIELD)) {
                        applyDemeritKindToRow(row, DicVal(params, "newValue", DicVal(row, DEMERIT_KIND_FIELD, "")));
                    }
                    if (normalizedColId === DEMERIT_NAME_DMY.toUpperCase() || normalizedColId === DEMERIT_HUDA_DMY.toUpperCase()) {
                        syncDemeritDmtCd(row, colId);
                    }
                }
            }
            const currentRows = GridData(panel);
            if (qualityProjection.syncDisplayGridToDetail(panel, currentRows, selectedQualityContextRef.current)) {
                if (!isEmpty(fnc.current) && typeof fnc.current.modify === "function") fnc.current.modify(true);
            }
            return;
        }
        if (isGenkaGridPanelInfo(panel)) {
            // 固定列でも、行×列に対応する実columnidのdatatype/decimalplaceを適用する。
            normalizeGenkaCellByLayout(params);
            const rowKey = String(DicVal(DicVal(params, "data", {}), "row_key", "") || DicVal(DicVal(params, "data", {}), "item_name", ""));
            const slot = String(DicVal(DicVal(params, "colDef", {}), "colId", "") || DicVal(DicVal(params, "colDef", {}), "field", ""));
            markGenkaTouchedCell(rowKey, slot);
            Object.keys(genkaColumnMapByColumnIdUpper || {}).forEach((cid) => {
                const map = genkaColumnMapByColumnIdUpper[cid];
                if (toGenkaRowKey(DicVal(map, "row", "")) !== toGenkaRowKey(rowKey)) return;
                const slots = Array.isArray(DicVal(map, "cols", null)) ? map.cols : [];
                if (!slots.includes(slot)) return;
                markGenkaTouchedCellByColumnId(cid);
            });
            storeRowData(panel);
            recalcGenkaGridAndSummary(panel);
            return;
        }
        if (isDemeritPanelInfo(panel)) {
            const row = DicVal(params, "data", null);
            const colId = String(DicVal(DicVal(params, "colDef", {}), "colId", "") || DicVal(DicVal(params, "colDef", {}), "field", ""));
            if (!isEmpty(row)) {
                const normalizedColId = String(colId ?? "").trim().toUpperCase();
                if (normalizedColId === String(DEMERIT_KIND_FIELD ?? "").trim().toUpperCase()) {
                    applyDemeritKindToRow(row, DicVal(params, "newValue", DicVal(row, DEMERIT_KIND_FIELD, "")));
                }
                if (normalizedColId === DEMERIT_NAME_DMY.toUpperCase() || normalizedColId === DEMERIT_HUDA_DMY.toUpperCase()) {
                    syncDemeritDmtCd(row, colId);
                }
            }
            storeRowData(panel);
            return;
        }
        if (canonicalPanelType(DicVal(panel, "type", "")) === "107") {
            const nextRows = finalizeMaterialZaiHinbanSelection(panel, params);
            if (nextRows !== false) {
                if (Array.isArray(nextRows) && !entryLoadingRef.current && !isEmpty(GridApi(panel)) && isGridDomReady(panel)) {
                    applyGridRowsNow(panel, nextRows);
                }
                return;
            }
        }
        if (canonicalPanelType(DicVal(panel, "type", "")) === "110") {
            const nextRows = finalizeAccessoryFuzokuHinbanSelection(panel, params);
            if (nextRows !== false) {
                if (Array.isArray(nextRows) && !entryLoadingRef.current && !isEmpty(GridApi(panel)) && isGridDomReady(panel)) {
                    applyGridRowsNow(panel, nextRows);
                }
                return;
            }
        }
        if (isColorwaySaveType(getPanelType(panel))) {
            normalizeColorwayProductColorAfterGridValueChanged(panel, params);
            normalizeSsdshColorNoAfterGridValueChanged(panel, params);
            storeRowData(panel);
            const currentRows = GridData(panel);
            if (!entryLoadingRef.current && !isEmpty(GridApi(panel)) && isGridDomReady(panel)) {
                applyGridRowsNow(panel, currentRows);
            }
            return;
        }
        if (canonicalPanelType(DicVal(panel, "type", "")) === "104") {
            normalizeSijisuPdtcAfterGridValueChanged(panel, params);
        }
        storeRowData(panel);
        try {
            const panelType = canonicalPanelType(DicVal(panel, "type", ""));
            if (panelType === "107") {
                const currentRows = GridData(panel);
                const nextRows = recalcMaterialDetailCalcRows(currentRows);
                SetGridData(panel, nextRows);
                if (!entryLoadingRef.current && !isEmpty(GridApi(panel)) && isGridDomReady(panel)) {
                    applyGridRowsNow(panel, nextRows);
                }
                fnc.current.modify(true);
                return;
            }
            if (panelType === "110") {
                const currentRows = GridData(panel);
                const nextRows = recalcAccessoryDetailCalcRows(currentRows);
                SetGridData(panel, nextRows);
                if (!entryLoadingRef.current && !isEmpty(GridApi(panel)) && isGridDomReady(panel)) {
                    applyGridRowsNow(panel, nextRows);
                }
                fnc.current.modify(true);
                return;
            }
            if (panelType === FUKUSHIZAI_LIST_PANEL_TYPE) {
                const currentRows = GridData(panel);
                const nextRows = recalcFukushizaiListCalcRows(currentRows);
                SetGridData(panel, nextRows);
                if (!entryLoadingRef.current && !isEmpty(GridApi(panel)) && isGridDomReady(panel)) {
                    applyGridRowsNow(panel, nextRows);
                }
                fnc.current.modify(true);
                return;
            }
            if (panelType === PANEL_TYPE.SIJISU || panelType === "104") {
                recalcSijisuTotalRows(panel);
            } else if (panelType === PANEL_TYPE.SAMPLE_DETAIL || panelType === "135") {
                recalcSampleTotalRows(panel);
            }
            const demandType = demandTypeKeyByPanel(panel);
            if (demandType !== "130" && demandType !== "131") return;
            const currentRows = GridData(panel);
            if (!Array.isArray(currentRows)) return;
            const nextRows = demandType === "130" ? normalizeJutyuRows(currentRows) : normalizeNouhinYoteiRows(currentRows);
            SetGridData(panel, nextRows);
            applyGridRowsNow(panel, nextRows);
        } catch (e) { console.error(e); }
    }
    // 合計グリッド（gridlist外）の編集内容をdataRefへ同期する。
    function storeTotalRowData(totalPanel, api, params) {
        try {
            if (suppressTotalValueChangedRef.current) return;
            if (isEmpty(totalPanel)) return;
            if (!isEmpty(params)) {
                const item = resolveGenkaSummaryItem(DicVal(DicVal(params, "data", {}), "total_key", "") || DicVal(DicVal(params, "data", {}), "total_item", ""));
                const field = String(DicVal(DicVal(params, "colDef", {}), "colId", "") || DicVal(DicVal(params, "colDef", {}), "field", ""));
                if (item !== "" && field !== "") {
                    const isValue2 = field === "total_value2";
                    markGenkaTouchedSummary(item, isValue2 ? "total_value2" : "total_value");
                    const conf = genkaSummaryColumnCandidates[item];
                    const ids = isValue2 ? (DicVal(conf, "value2", []) || []) : (DicVal(conf, "value", []) || []);
                    ids.forEach((cid) => markGenkaTouchedCellByColumnId(cid));
                }
            }
            const targetApi = isEmpty(api) ? TotalGridApi(totalPanel) : api;
            if (isEmpty(targetApi) || isEmpty(AGRef.current) || typeof AGRef.current.GetDatasource !== "function") return;
            const rows = AGRef.current.GetDatasource(targetApi);
            ensureTotalDataRef(totalPanel).current = Array.isArray(rows) ? rows : [];

            const isGenkaTotal = String(resolveSectionIdByGridPanel(totalPanel) ?? "") === "genka"
                || normalizeTypeKey(DicVal(totalPanel, "totaltype", "")) === normalizeTypeKey(PANEL_TYPE.GENKA_SUMMARY);
            if (!isGenkaTotal) return;

            const genkaPanel = Array.isArray(gridlist) ? gridlist.find(g => isGenkaGridPanelInfo(g)) : null;
            if (isEmpty(genkaPanel)) return;
            recalcGenkaGridAndSummary(genkaPanel);
        } catch (e) {
            console.error(e);
        }
    }

    // 指定パネルへジャンプ表示する。

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }


    // =====================================================================
    // 登録・更新・削除・アップロード
    // ---------------------------------------------------------------------
    // 保存前の同期処理と既存API呼び出しをまとめる。
    // NOTE: 保存payloadのキー構造と集約先typeは変えない。
    // =====================================================================

    // ヘッダメニュー操作を振り分ける。
    function printurl(action, param, code) {
        switch (action) {
            case "sozai_tehai":         //素材手配書
                param['denNo'] = code.join(',');
                return 'SozaiTehaiShoReport/Generate';
            case "fuzoku_tehai":        //附属手配書
                param['denNo'] = code.join(',');
                return 'FuzokuTehaiShoReport/Generate';
            case "fukushizai_tehai":    //副資材手配書
                param['denNo'] = code.join(',');
                return 'FukushizaiTehaiShoReport/Generate';
            case "hinshitsu_tehai":     //品質表示手配書
                param['ssdNo'] = code.join(',');
                return 'HinshitsuHyojiTehaiShoReport/Generate';
            case "kakousiji_report":    //加工指示書
                param['ssdNo'] = code.join(',');
                return 'KakoShijishoReport/Generate';
        }
    }

    // ヘッダメニュー操作を処理別に振り分ける。
    function MenuAction(action, finallycallback) {
        if (action === "sozai_tehai" || action === "fuzoku_tehai" || action === "fukushizai_tehai" || action === "hinshitsu_tehai" || action === "kakousiji_report") {
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                let param = baseref.current?.GetSelectrowdata();
                if (param.length === 0) {
                    fnc.current.warnmsg("対象データを選択してください");
                    return;
                }
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            var param = { controller: controller, id: action };
            var url = printurl(action, param, code);
            fnc.current.postaxios(url, param,
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === "seihin_bulk_order") {
            openTemporaryOrderTab(action);
            return;
        }
        if (action === "sozai_bulk_order") {
            openTemporaryOrderTab(action);
            return;
        }
        if (action === "fuzoku_bulk_order") {
            openTemporaryOrderTab(action);
            return;
        }
        if (action === "fukushizai_bulk_order") {
            openTemporaryOrderTab(action);
            return;
        }
        LayoutSaveStorage();   //現在レイアウト保持
        // Entry Form を閉じる時点でグリッドは破棄されるため、紐づくrefも同時に破棄する。
        if (action === "close") resetGridRefsOnEntryClose();
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type)?true:e.type === finallycallback.type));
            if (col === undefined) {
                //明細グリッド項目は textfields に載らないため、レイアウト全体から解決する。
                col = (columninfo ?? []).find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type)?true:e.type === finallycallback.type));
            }
            if (col === undefined) return;
            if (col.logpid == "0") {    //基本情報
                let key = finallycallback.field + "_" + col.type;
                //セクション折り畳み中などで要素が無い場合があるため、存在チェックしてから操作する。
                let elem = document.getElementById(key);
                if (!isEmpty(elem)) {
                    elem.focus();
                    if (typeof elem.select === "function") elem.select();
                }
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
    }
    // 登録/更新を実行する。
    function Save(finallycallback, nocheck) {
        fnc.current.closewarnning();    //前回登録時の警告表示をクリアする。
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        // Redux側で読み取り専用化された参照を保存前補正で直接更新しないよう、保存用の可変コピーに差し替える。
        if (!isEmpty(entrydataRef.current) && typeof entrydataRef.current === "object") {
            entrydataRef.current = DeepCopy(entrydataRef.current);
        }
        // 原価右「合計」の編集値を保存用の単票データへ反映する。
        applyGenkaSummaryRowsToEntryData(entrydataRef.current);
        applyForcedGenkaJpyIfNeeded(entrydataRef.current);
        // 条件仕入チェックを物理列SSD_JYOKENSIIREFLGへ反映する(ヘッダ保存対象)。
        syncJokenSiireFlagFromCheckbox(entrydataRef.current);
        const fukushizaiRowsBeforeStore = DeepCopy(getDetailRowsByPanelType(entrydetailRef.current, FUKUSHIZAI_BASE_PANEL_TYPE));
        storeRowData();
        if (getDetailRowsByPanelType(entrydetailRef.current, FUKUSHIZAI_BASE_PANEL_TYPE).length === 0 && fukushizaiRowsBeforeStore.length !== 0) {
            const detail = ensureDetailRowsByTypeForMutation(FUKUSHIZAI_BASE_PANEL_TYPE);
            entrydetailRef.current[detail.key] = fukushizaiRowsBeforeStore;
        }
        SetPLData();    //PL行データをentrydataRefにセット
        syncFukushizaiBaseDirtyFieldsToDetail({
            context: selectedFukushizaiContextRef.current,
            timing: "save-before-payload",
            reason: "save"
        });
        // 品質表示のグループは副資材と独立して選択されるため、品質表示側の context を使う。
        syncQualityBaseDirtyFieldsToDetail({
            context: selectedQualityContextRef.current,
            timing: "save-before-payload",
            reason: "save"
        });
        // 保存直前は品質側と同様に dirty 判定へ依存せず全 flush する。
        // dirty キーは item|group が未確定の編集を記録できないため、dirtyOnly だと保存漏れが起きうる。
        flushFukushizaiDisplayGridsToDetail({ dirtyOnly: false, stopEditing: true, timing: "save-before-payload" });
        flushQualityDisplayGridsToDetail({ dirtyOnly: false, stopEditing: true });
        if (!validateKakousijiBeforeSave()) return;
        var detail = buildInitialDetailPayloadFromLoadedData();
        GROUPED_DETAIL_TARGET_TYPES.forEach((targetType) => {
            if (!shouldSaveDetailType(targetType)) return;
            if (targetType === FUKUSHIZAI_BASE_PANEL_TYPE || targetType === PANEL_TYPE.QUALITY_BASE) return;
            const saveRows = buildBaseDetailSaveRows(targetType);
            if (targetType === "102") {
                if (Array.isArray(saveRows) && saveRows.length !== 0) {
                    appendDetailRows(detail, targetType, saveRows);
                } else {
                    // 二次加工を空欄にした更新でも、D_SSDNの既存行を削除するため空行を送る。
                    detail[targetType] = [{ rowid: "0" }];
                }
                return;
            }
            appendDetailRows(detail, targetType, saveRows);
        });
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            const typeKey = canonicalPanelType(gridlist[i].type);

            if (!shouldSaveDetailType(typeKey)) continue;
            const rows = GridData(gridlist[i]);
            const saveRows = stripKakousijiDetailSaveRows(toDetailSaveRows(rows, typeKey), typeKey);
            const isEmptySaveRows = saveRows === null || (Array.isArray(saveRows) && saveRows.length === 0);
            const isExplicitEmptyDeleteType = typeKey === FUKUSHIZAI_LIST_PANEL_TYPE
                || (isQualityPanelType(typeKey) && typeKey !== PANEL_TYPE.QUALITY_BASE);
            if (isExplicitEmptyDeleteType && isEmptySaveRows) {
                // 空でも detail キーを送る。「キーあり+空配列=そのテーブルの全行削除」の契約で、
                // サーバ側 RemoveEmptyDetailRowsForUpdate の許可リストと対になる。
                // キーを送らないとサーバは該当テーブルへ触れず、全行削除がDBへ反映されない。
                if (!Array.isArray(detail[typeKey])) detail[typeKey] = [];
                continue;
            }
            if (isColorwaySaveType(typeKey) && isEmptySaveRows) continue;
            appendDetailRows(detail, typeKey, saveRows);
        }
        // 素材(106)/附属(109)の単票項目(注意フラグ/注意内容)を明細(107/110)行へ反映して保存する。
        // (106/109はs_tblに子定義が無くdetailキーとしてはサーバで破棄されるため)
        applyBaseSectionFieldsToDetailRows(detail, PANEL_TYPE.MATERIAL, PANEL_TYPE.MATERIAL_DETAIL, "D_SSDS");
        applyBaseSectionFieldsToDetailRows(detail, PANEL_TYPE.ACCESSORY, PANEL_TYPE.ACCESSORY_DETAIL, "D_SSDF");
        // 商品情報(101)のD_SSDX項目(仕入先公開/ささげ連携等)の編集値を後勝ちで追加する。
        // サーバのキー補完(NormalizeSsdxDetailRowsForUpdate)がある更新登録経路のみ対象。
        if (formstatus === "ENTRY FORM") {
            appendDetailRows(detail, PANEL_TYPE.PRODUCT_INFO, buildProductInfoSsdxSaveRows());
        }
        const dssdqSaveRows = stripKakousijiDetailSaveRows(buildQualityDssdqSaveRows(), PANEL_TYPE.QUALITY_BASE);
        if (Array.isArray(dssdqSaveRows) && dssdqSaveRows.length !== 0) {
            appendDetailRows(detail, PANEL_TYPE.QUALITY_BASE, dssdqSaveRows);
        } else if (shouldSaveDetailType(PANEL_TYPE.QUALITY_BASE)) {
            // 空でもキーを送る(品質表示の全行削除をサーバへ伝える。空配列=全行削除の契約)。
            detail[PANEL_TYPE.QUALITY_BASE] = [];
        } else {
            // sample モードでは 118 は保存対象外のため、従来どおりキーごと送らない。
            delete detail[PANEL_TYPE.QUALITY_BASE];
        }
        const fukushizaiSaveRows = buildFukushizaiDetail113SaveRows();
        detail[FUKUSHIZAI_BASE_PANEL_TYPE] = fukushizaiSaveRows;
        const saveData = stripBaseUiOnlyFields(entrydataRef.current);
        // screenData はサーバが明細→ヘッダ同名列コピー等で参照するため物理列は残し、
        // UI 専用マーカー("__" 始まり)だけを取り除いて送る。
        const screenData = DeepCopy(entrydataRef.current);
        Object.keys(screenData).forEach((key) => {
            if (String(key ?? "").startsWith("__")) delete screenData[key];
        });
        const saveUrl = formstatus === "ENTRY FORM" ? "kakousiji/UpdateKakousijiEntry" : "forms/InsertEntry";
        const paramdata = {
            "controller": formid,
            "data": saveData,
            "screenData": screenData,
            "detail": detail,
            "images": toArray(imageRef.current),
            "files": toArray(fileRef.current),
            // 条件仕入フラグ(SSD_JYOKENSIIREFLG)の保存用列定義を補って送る。
            "colinfo": buildSaveColinfoWithJokenSiireFlag(),
            "code": edittingcode,
            "noconfirm": nocheck
        }
        if (saveUrl === "kakousiji/UpdateKakousijiEntry") {
            const saveOppiCd = normalizeKakousijiUiString(
                readRowValueIgnoreCase(entrydataRef.current, "SSD_OPPICD")
                ?? readRowValueIgnoreCase(saveData, "SSD_OPPICD")
            );
            paramdata.data.SSD_OPPICD = saveOppiCd;
        }
        // 性能調査用: 保存リクエストの往復時間とリロード開始までの時間を計測する。
        const saveTimingStartedAt = loadTimingNow();
        try {
            console.info("[Kakousiji][saveTiming] request:start", { url: saveUrl, code: edittingcode });
        } catch { }
        fnc.current.postaxios(saveUrl, paramdata,
            {
                onSuccess: function (data) {
                    try {
                        console.info("[Kakousiji][saveTiming] response:received", {
                            url: saveUrl,
                            roundTripMs: Math.round(loadTimingNow() - saveTimingStartedAt),
                            warningCount: data.warning.length
                        });
                    } catch { }
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if(pkey !== "")  entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        const reloadAfterSave = (showMessage) => {
                            const saveNote = String(DicVal(data, "note", "") ?? "").trim();
                            if (saveNote !== "") {
                                fnc.current.warnmsg(saveNote);
                            } else if (showMessage) {
                                fnc.current.success();
                            }
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            try {
                                console.info("[Kakousiji][saveTiming] reload:start", {
                                    code,
                                    sinceSaveStartMs: Math.round(loadTimingNow() - saveTimingStartedAt)
                                });
                            } catch { }
                            LoadData(code);     //再表示
                        };
                        if (newfiles.length !== 0) {        //v1.4
                            reloadAfterSave(false);
                        } else {
                            reloadAfterSave(true);
                        }
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            //確認メッセージ
                            var msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください","　"];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    // 削除を実行する。
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("kakousiji/KakousijiDelete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg([data.warning[0].message]);
                    }
                    fnc.current.wait(false);
               },
                errmsg: "削除に失敗しました"
            }
        )
    }
    // 選択中rowidを取得する。
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    // 一覧行に保持している単票補助項目（メモ/付箋/タグ）をGetData結果へマージする。
    function mergeEntryRowTransientFields(entryData) {
        if (isEmpty(entryData)) return;
        const row = getglobaldata("entryrowdata");
        if (isEmpty(row)) return;
        ["_memo", "_sticky", "_mytags"].forEach((name) => {
            const col = nametocolumn(name);
            if (col === "") return;
            if (col in row) entryData[col] = row[col];
        });
    }
    // 指定パネルの明細行を表示用に正規化する（受注/納品集計、原価/Wash補完含む）。
    function normalizeDetailRowsForPanel(panelInfo, detailData, previewOverride = undefined, contextOverride = null) {
        // 品質表示パネル(118-124)は品質専用コンテキストで、副資材系はcontextOverride/副資材コンテキストで解決する。
        const domainContext = isQualityPanelType(getPanelType(panelInfo))
            ? selectedQualityContextRef.current
            : (contextOverride || selectedFukushizaiContextRef.current);
        const resolved = resolvePanelDetailSourceRows(panelInfo, detailData, {
            previewOverride,
            context: domainContext
        });
        if (resolved.handled) return resolved.rows;

        const buildContext = resolved.context;
        let nextRows = resolved.rows;
        nextRows = postProcessPanelDetailRows(panelInfo, nextRows, {
            context: buildContext,
            entryData: entrydataRef.current
        });
        if (isFukushizaiDetailPanelInfo(panelInfo)) return nextRows;
        return nextRows;
    }








    // PLグリッド行を再構築して反映する。
    function applyPlRows(entryData) {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            const plRows = fnc.current.PLRowData(entryData, l.type, columninfo);
            SetGridData(l, plRows);
            applyGridRowsNow(l, plRows);
        });
    }
    function loadTimingNow() {
        if (typeof performance !== "undefined" && typeof performance.now === "function") {
            return performance.now();
        }
        return Date.now();
    }
    function runBatched(action) {
        if (typeof unstable_batchedUpdates === "function") {
            unstable_batchedUpdates(action);
            return;
        }
        action();
    }
    function createTimingCollector(label) {
        return {
            label,
            startedAt: loadTimingNow(),
            steps: {},
            measure(name, action) {
                const stepStartedAt = loadTimingNow();
                const result = action();
                this.steps[name] = Math.round(loadTimingNow() - stepStartedAt);
                return result;
            },
            flush(extra = {}) {
                const summary = {
                    label: this.label,
                    totalMs: Math.round(loadTimingNow() - this.startedAt),
                    stepMs: this.steps,
                    ...extra
                };
                return summary;
            }
        };
    }
    function logEntryLoadTiming(summary) {
        // 性能調査用: LoadDataの取得/反映の内訳(requestMs/applyMs/stepMs)を出力する。
        try {
            console.info("[Kakousiji][loadTiming]", JSON.stringify(summary));
        } catch { /* トレース失敗で業務処理を止めない */ }
    }
    function measureTimedLoop(items, getName, callback, summaryName = "") {
        const source = Array.isArray(items) ? items : [];
        const detail = [];
        const startedAt = loadTimingNow();
        source.forEach((item, index) => {
            const name = typeof getName === "function" ? getName(item, index) : String(index);
            const itemStartedAt = loadTimingNow();
            callback(item, index);
            detail.push({
                name,
                elapsedMs: Math.round(loadTimingNow() - itemStartedAt)
            });
        });
        return detail;
    }
    function isLatestLoadRequestCode(code) {
        return String(currentLoadRequestCodeRef.current ?? "").trim() === String(code ?? "").trim();
    }
    function prepareLoadDataEntry(data) {
        mergeEntryRowTransientFields(data.data);
        fnc.current.margeMaster(filterBrandNameMasterPreload(Array.isArray(data.master) ? data.master : []));
        entrydataRef.current = data.data;
        // 金額の端数処理設定は明細をグリッドへ流し込む前に確定させる（初期表示の金額計算で参照する）。
        amountRoundingRef.current = DicVal(data, "amountrounding", null);
        qualityHsituhabaResolvedMapRef.current = {};
        qualityHsituhabaFallbackLoadedRef.current = false;
        qualityHsituhabaOptionsRef.current = normalizeQualityHsituhabaOptions(readQualityHsituhabaOptionsFromEntryDataSource(data));
        upsertQualityHsituhabaResolvedItems(qualityHsituhabaOptionsRef.current);
        refreshQualityPanelColumnDefs();
        clearFukushizaiMergedFields(entrydataRef.current);
        resetGenkaTouchedRef();
        applyKakouShijiKubun(entrydataRef.current);
    }
    function mergeLoadDataEntryProjection(detailData, initialFukushizaiContext) {
        mergeFukushizaiRepresentativeRowToEntry(entrydataRef.current, detailData, initialFukushizaiContext, {
            allowInitialFallback: true,
            updateSelection: false
        });
        mergeSampleDetailRowsToEntry(entrydataRef.current, detailData);
        // 素材/附属の単票項目(注意フラグ等)は明細(107/110)行に保存されるため、先頭行から単票へ投影する。
        mergeSozaiFuzokuBaseFieldsToEntry(entrydataRef.current, detailData);
        // 条件仕入チェックを物理列SSD_JYOKENSIIREFLGから復元する。
        syncJokenSiireCheckboxFromEntry(entrydataRef.current);
    }
    function dispatchLoadDataBaseEntryData(code) {
        dispatchBaseEntryDataTraceRef.current = {
            code,
            reason: "LoadData:dispatchBaseEntryData",
            startedAt: loadTimingNow(),
            layoutCount: 0,
            effectCount: 0
        };
        dispatchEntryDataWithTrace({ ...entrydataRef.current }, "LoadData:dispatchBaseEntryData");
        dispatchEntryRerenderWithTrace("LoadData:dispatchBaseEntryData");
    }
    // LoadData 後段の描画制御へ渡す依存関係をここで束ねます。
    function buildEntryVisualPostLoadDeps() {
        return {
            now: loadTimingNow,
            // ブラウザ組み込み関数は this 文脈を失わないよう、ラッパー経由で渡します。
            // また、coordinator配下の後段処理(グリッド再描画・finish処理等)のsetState/dispatchを
            // 1コミットへ集約するため、コールバックをrunBatchedで包みます。
            requestAnimationFrame: typeof requestAnimationFrame === "function"
                ? ((callback) => requestAnimationFrame(() => runBatched(callback)))
                : null,
            cancelAnimationFrame: typeof cancelAnimationFrame === "function"
                ? ((timerId) => cancelAnimationFrame(timerId))
                : null,
            setTimeout: (callback, delay = 0) => setTimeout(() => runBatched(callback), delay),
            clearTimeout: (timerId) => clearTimeout(timerId),
            isEmpty,
            DicVal,
            logEntryVisualTrace,
            logEntryLoadTiming,
            logInteractionDiagnostics,
            getGridList: () => gridlist,
            getKakouType: () => kakouType,
            getEntryLoadTiming: () => entryLoadTimingRef.current,
            clearEntryLoadTiming: () => { entryLoadTimingRef.current = null; },
            isEntryLoading: () => entryLoadingRef.current === true,
            setEntryLoading: (value) => { entryLoadingRef.current = value === true; },
            getFinishEntryLoadingTimer: () => finishEntryLoadingTimerRef.current,
            setFinishEntryLoadingTimer: (value) => { finishEntryLoadingTimerRef.current = value; },
            getPendingVisibleGridRefresh: () => pendingVisibleGridRefreshRef.current,
            setPendingVisibleGridRefresh: (value) => { pendingVisibleGridRefreshRef.current = value; },
            setLastEntryFinishLoadingAt: (value) => { lastEntryFinishLoadingAtRef.current = value; },
            getEntryVisualTraceCode,
            activateEntryVisualTraceWindow,
            setFinalizeEntryVisualTrace: (value) => { finalizeEntryVisualTraceRef.current = value; },
            // sample / normal の切り替え条件は coordinator 側から参照できるようにします。
            resolveVisibleSections: (targetType) => {
                if (targetType === "sample") return currentSampleSectionDefs();
                return currentNormalSectionDefs().filter((section) => section.view === targetType);
            },
            resolveGridSectionPanel,
            resolveTotalHostPanel,
            getGridId: (panelInfo) => {
                // GridID が引けない場面では空文字を返し、対象から除外します。
                if (isEmpty(fnc.current) || typeof fnc.current.GridID !== "function") return "";
                return fnc.current.GridID(panelInfo);
            },
            rerenderGridById: (gridId) => {
                // rerenderGrid が無い環境では coordinator 側に false を返します。
                if (isEmpty(fnc.current) || typeof fnc.current.rerenderGrid !== "function") return false;
                fnc.current.rerenderGrid(gridId);
                return true;
            },
            findGridPanelInfoByGridId,
            shouldKeepPostLoadVisibleGridRefresh: gridRefreshCoordinator.shouldKeepPostLoadVisibleGridRefresh,
            refreshGridPanelByApi,
            ensureGenkaRowsBound,
            recalcGenkaGridAndSummary,
            isGenkaGridPanelInfo,
            ensureWashRowsBound,
            setGenkaPostLoadRefreshSkip: (value) => { genkaPostLoadRefreshSkipRef.current = value === true; },
            waitOff: () => {
                if (fnc.current && typeof fnc.current.wait === "function") {
                    fnc.current.wait(false);
                }
            },
            scheduleDeferredColorwayMatricesLoad,
            schedulePostFinishEntryVisualTrace,
            schedulePostFinishInteractionDiagnostics
        };
    }
    // LoadData 後段の描画制御を coordinator へ委譲します。
    const entryVisualPostLoadCoordinator = createEntryVisualPostLoadCoordinator(buildEntryVisualPostLoadDeps());
    function buildLoadDataOrchestratorDeps() {
        return {
            now: loadTimingNow,
            isLatestRequest: isLatestLoadRequestCode,
            onSkippedStaleRequest: ({ code, phase }) => {
                logEntryVisualTrace("LoadData:skipStaleRequest", {
                    code,
                    phase,
                    currentCode: currentLoadRequestCodeRef.current
                }, { forceTrace: true });
            },
            prepareEntry: prepareLoadDataEntry,
            afterPrepareEntry: ({ code }) => {
                logEntryVisualTrace("LoadData:afterPrepareEntry", { code });
            },
            deferApply: (action) => {
                // 反映中の複数setState/dispatchを1コミットへ集約する(再レンダー1回0.6〜1.2秒対策)。
                const batchedAction = () => runBatched(action);
                if (typeof requestAnimationFrame === "function") {
                    requestAnimationFrame(batchedAction);
                } else {
                    setTimeout(batchedAction, 0);
                }
            },
            deepCopyDetail: (data) => DeepCopy(data.detail ?? {}),
            storeDetailCopy: (detailData) => {
                loadedEntryDetailRef.current = DeepCopy(detailData);
                entrydetailRef.current = detailData;
            },
            afterDetailReceived: ({ code, detailData }) => {
                debugFukushizaiSyncLog("[Kakousiji][LoadData detail received]", {
                    code,
                    detail112Count: countFukushizaiDebugRows(getDetailRowsByPanelType(detailData, FUKUSHIZAI_LIST_PANEL_TYPE)),
                    detail112KeyCount: fukushizaiListCompositionKeysFromRows(getDetailRowsByPanelType(detailData, FUKUSHIZAI_LIST_PANEL_TYPE)).length,
                    detail113Count: countFukushizaiDebugRows(getDetailRowsByPanelType(detailData, FUKUSHIZAI_BASE_PANEL_TYPE)),
                    detail118Count: countFukushizaiDebugRows(getDetailRowsByPanelType(detailData, PANEL_TYPE.QUALITY_BASE)),
                    detail119Count: countFukushizaiDebugRows(getDetailRowsByPanelType(detailData, "119"))
                });
            },
            ensureFukushizaiDetailRows: () => {
                ensureFukushizaiDetailRowsFromEntryData(entrydataRef.current);
            },
            getEffectiveDetailData: () => entrydetailRef.current,
            afterDetailPrepared: ({ code, detailData }) => {
                debugFukushizaiSyncLog("[Kakousiji][LoadData detail prepared]", {
                    code,
                    detail112Count: countFukushizaiDebugRows(getDetailRowsByPanelType(detailData, FUKUSHIZAI_LIST_PANEL_TYPE)),
                    detail112KeyCount: fukushizaiListCompositionKeysFromRows(getDetailRowsByPanelType(detailData, FUKUSHIZAI_LIST_PANEL_TYPE)).length,
                    detail113Count: countFukushizaiDebugRows(getDetailRowsByPanelType(detailData, FUKUSHIZAI_BASE_PANEL_TYPE)),
                    detail113SourceKeyCount: fukushizaiListCompositionKeysFromSourceItems(collectFukushizaiSourceItems()).length
                });
            },
            resolveInitialFukushizaiContext: (detailData) => resolveInitialFukushizaiContextFromDetailRows(getDetailRowsByPanelType(detailData, FUKUSHIZAI_BASE_PANEL_TYPE)),
            mergeEntryProjection: mergeLoadDataEntryProjection,
            afterMergeEntryProjection: ({ code, initialFukushizaiContext }) => {
                logEntryVisualTrace("LoadData:afterMergeEntryProjection", {
                    code,
                    initialFukushizaiContext
                });
            },
            applyEntryUiState: (data) => {
                applyKakousijiUiData(data, { skipUiActionRefresh: true, skipGenkaPatternSync: true });
                loadSustainableImageFromServer(entrydataRef.current);
            },
            afterApplyEntryUiState: ({ code }) => {
                logEntryVisualTrace("LoadData:afterApplyEntryUiState", { code });
            },
            syncGenka: (detailData, data) => {
                mergeGenkaHorizontalDetailRow(entrydataRef.current, detailData);
                syncGenkaPatternByEntry(entrydataRef.current, data);
            },
            afterSyncGenka: ({ code }) => {
                logEntryVisualTrace("LoadData:afterSyncGenka", { code });
            },
            dispatchBaseEntryData: dispatchLoadDataBaseEntryData,
            afterDispatchBaseEntryData: ({ code }) => {
                logEntryVisualTrace("LoadData:afterDispatchBaseEntryData", { code });
            },
            applyDetailRowsToGrids,
            afterApplyDetailRows: ({ code, detailData }) => {
                const fukushizaiListPanel = resolveGridPanelByType(FUKUSHIZAI_LIST_PANEL_TYPE);
                debugFukushizaiSyncLog("[Kakousiji][LoadData grid applied]", {
                    code,
                    detail112Count: countFukushizaiDebugRows(getDetailRowsByPanelType(detailData, FUKUSHIZAI_LIST_PANEL_TYPE)),
                    grid112Count: countFukushizaiDebugRows(isEmpty(fukushizaiListPanel) ? [] : GridData(fukushizaiListPanel)),
                    grid112KeyCount: fukushizaiListCompositionKeysFromRows(isEmpty(fukushizaiListPanel) ? [] : GridData(fukushizaiListPanel)).length
                });
            },
            hydrateMasterNamesKickoff: () => {
                hydrateAllGridRowsAsync();
            },
            applyTotalRowsByPanelDefinition,
            applyTotalRowsBySectionDefinition,
            applyPlRows,
            resolveInitialDemandKakouType,
            scheduleVisibleGridRefresh: (targetType, nextKakouType) => {
                // 初回 LoadData 中に表示先タブが変わる場合は、先に state を揃えてから再描画を予約します。
                if (!isEmpty(nextKakouType)) {
                    setKakouType(nextKakouType);
                }
                entryVisualPostLoadCoordinator.scheduleVisibleGridRefresh(targetType);
            },
            loadColorwayMatricesKickoff: (code) => {
                pendingColorwayLoadCodeRef.current = code;
            },
            finalizeEntryVisualDataKickoff: (code, detailData, data) => {
                entryVisualPostLoadCoordinator.finalizeEntryVisualData(code, detailData, data);
            },
            onApplyCompleted: ({ code, timing }) => {
                entryLoadTimingRef.current = timing;
                logEntryLoadTiming({
                    code,
                    stage: "applyData",
                    requestMs: Math.round(timing.responseAt - timing.requestStartAt),
                    applyMs: Math.round(timing.applyEndAt - timing.applyStartAt),
                    stepMs: timing.stepMs
                });
                entryVisualPostLoadCoordinator.scheduleFinishEntryLoading();
            },
            onApplyError: (error, { code, timing, phase } = {}) => {
                logEntryVisualTrace("LoadData:applyError", {
                    code,
                    phase,
                    errorMessage: String(DicVal(error, "message", error)),
                    stepMs: DicVal(timing, "stepMs", {})
                }, { forceTrace: true });
                entryVisualPostLoadCoordinator.finishEntryLoading();
            }
        };
    }
    // LoadData の適用順序をまとめた orchestrator です。
    // 画面固有の処理本体は helper へ切り出し、順序管理だけを外へ出します。
    const loadDataOrchestrator = createLoadDataOrchestrator(buildLoadDataOrchestratorDeps());

    useEffect(() => {
        if (entryLoadingRef.current) return;
        if (isEmpty(entrydataRef.current)) return;
        entryVisualPostLoadCoordinator.scheduleVisibleGridRefresh(kakouType);
    }, [kakouType]);
    useLayoutEffect(() => {
        const dispatchTrace = dispatchBaseEntryDataTraceRef.current;
        if (!isEmpty(dispatchTrace)) {
            const now = loadTimingNow();
            const elapsedMs = Math.round(now - Number(dispatchTrace.startedAt || now));
            if (elapsedMs <= 10000) {
                dispatchTrace.layoutCount = Number(dispatchTrace.layoutCount || 0) + 1;
                logEntryVisualTrace("dispatchBaseEntryDataCommit:layoutEffect", {
                    code: dispatchTrace.code,
                    reason: dispatchTrace.reason,
                    elapsedMs,
                    commitCount: dispatchTrace.layoutCount,
                    reduxEntrydataKeyCount: countTraceObjectKeys(reduxStore.getState().form.entrydata)
                }, { forceTrace: true });
            } else {
                dispatchBaseEntryDataTraceRef.current = null;
            }
        }
        const finalizeTrace = finalizeEntryVisualTraceRef.current;
        if (!isEmpty(finalizeTrace)) {
            const now = loadTimingNow();
            const elapsedMs = Math.round(now - Number(finalizeTrace.startedAt || now));
            if (elapsedMs <= 10000) {
                finalizeTrace.layoutCount = Number(finalizeTrace.layoutCount || 0) + 1;
                logEntryVisualTrace("finalizeEntryVisualDataCommit:layoutEffect", {
                    code: finalizeTrace.code,
                    elapsedMs,
                    commitCount: finalizeTrace.layoutCount,
                    update
                }, { forceTrace: true });
            } else {
                finalizeEntryVisualTraceRef.current = null;
            }
        }
    });
    useEffect(() => {
        const dispatchTrace = dispatchBaseEntryDataTraceRef.current;
        if (!isEmpty(dispatchTrace)) {
            const now = loadTimingNow();
            const elapsedMs = Math.round(now - Number(dispatchTrace.startedAt || now));
            if (elapsedMs <= 10000) {
                dispatchTrace.effectCount = Number(dispatchTrace.effectCount || 0) + 1;
                logEntryVisualTrace("dispatchBaseEntryDataCommit:effect", {
                    code: dispatchTrace.code,
                    reason: dispatchTrace.reason,
                    elapsedMs,
                    commitCount: dispatchTrace.effectCount,
                    reduxEntrydataWatchedFields: buildEntryVisualWatchSamples(reduxStore.getState().form.entrydata)
                }, { forceTrace: true });
            } else {
                dispatchBaseEntryDataTraceRef.current = null;
            }
        }
        const finalizeTrace = finalizeEntryVisualTraceRef.current;
        if (!isEmpty(finalizeTrace)) {
            const now = loadTimingNow();
            const elapsedMs = Math.round(now - Number(finalizeTrace.startedAt || now));
            if (elapsedMs <= 10000) {
                finalizeTrace.effectCount = Number(finalizeTrace.effectCount || 0) + 1;
                logEntryVisualTrace("finalizeEntryVisualDataCommit:effect", {
                    code: finalizeTrace.code,
                    elapsedMs,
                    commitCount: finalizeTrace.effectCount,
                    update
                }, { forceTrace: true });
            } else {
                finalizeEntryVisualTraceRef.current = null;
            }
        }
    });
    // 注: 旧「storeEntrydataChanged」トレース(entrydata購読のuseEffect)は性能対策で削除。
    // dispatch側のトレース(dispatchEntrydata:before)で代替する。
    useEffect(() => {
        logEntryVisualTrace("selectedSetItemOrGroupChanged");
    }, [selectedSetItem, selectedGroup]);
    useEffect(() => {
        const prevFormstatus = prevFormstatusRef.current;
        if (prevFormstatus !== formstatus) {
            logEntryVisualTrace("formstatusChanged", {
                prevFormstatus,
                nextFormstatus: formstatus
            });
            prevFormstatusRef.current = formstatus;
        }
    }, [formstatus]);
    useEffect(() => {
        const prevWaitOpen = prevWaitOpenRef.current;
        if (prevWaitOpen !== waitOpen) {
            logInteractionDiagnostics("waitChanged", {
                prevWaitOpen,
                nextWaitOpen: waitOpen
            });
            prevWaitOpenRef.current = waitOpen;
        }
    }, [waitOpen]);
    useEffect(() => {
        const prevEntryLock = prevEntryLockRef.current;
        if (prevEntryLock !== entrylock) {
            logInteractionDiagnostics("entrylockChanged", {
                prevEntryLock,
                nextEntryLock: entrylock
            });
            prevEntryLockRef.current = entrylock;
        }
    }, [entrylock]);
    // 登録時警告の対象行を強調するため、警告一覧の変化でグリッドを再描画します。
    useEffect(() => {
        if (!Array.isArray(gridlist) || gridlist.length === 0) return;
        gridlist.forEach((panelInfo) => {
            if (!isGridDomReady(panelInfo)) return;
            const api = GridApi(panelInfo);
            if (isEmpty(api) || typeof api.redrawRows !== "function") return;
            api.redrawRows();
        });
    }, [warndescription]);
    useEffect(() => {
        const prevUiActionBusy = prevUiActionBusyRef.current;
        if (prevUiActionBusy !== uiActionBusy) {
            logInteractionDiagnostics("uiActionBusyChanged", {
                prevUiActionBusy,
                nextUiActionBusy: uiActionBusy
            });
            prevUiActionBusyRef.current = uiActionBusy;
        }
    }, [uiActionBusy]);
    useEffect(() => {
        if (isEmpty(entrydataRef.current)) return;
    }, [formstatus, kakouShijiKubun, update]);
    // GetData結果を単票/明細/合計へ反映する。
    // =====================================================================
    // 初期表示・データ取得
    // ---------------------------------------------------------------------
    // レイアウト、Entryデータ、明細データの取得と反映を扱う。
    // =====================================================================

    // GetEntryData結果をentrydata、detail、Gridへ反映する。
    function LoadData(code) {
        if (code === "") return;
        currentLoadRequestCodeRef.current = String(code ?? "");
        entryLoadingRef.current = true;
        genkaPostLoadRefreshSkipRef.current = false;
        resetPendingGenkaEditableRefresh();
        clearDeferredColorwayLoadTimer();
        pendingColorwayLoadCodeRef.current = "";
        dispatchBaseEntryDataTraceRef.current = null;
        finalizeEntryVisualTraceRef.current = null;
        entryLoadTimingRef.current = {
            code,
            requestStartAt: loadTimingNow(),
            responseAt: 0,
            applyStartAt: 0,
            applyEndAt: 0,
            stepMs: {}
        };
        closeGroupActionDialog();
        fnc.current.wait(true);
        logEntryVisualTrace("LoadData:requestStart", { code }, { forceTrace: true });

        const param = { "code": code, "colinfo": columninfo, "controller": controller };
        const applyData = function (data) {
            try {
                if (code !== "") {
                    const timing = entryLoadTimingRef.current ?? {
                        code,
                        requestStartAt: loadTimingNow(),
                        stepMs: {}
                    };
                    // 反映中の複数setState/dispatchを1コミットへ集約する。
                    runBatched(() => loadDataOrchestrator.applyResponseData({
                        code,
                        data,
                        timing,
                        currentKakouType: kakouType
                    }));
                    return;
                }
            } catch (error) {
                entryVisualPostLoadCoordinator.finishEntryLoading();
            }
        };
        const requestData = function (url) {
            fnc.current.postaxios(url, param,
                {
                    onSuccess: function (data) {
                        applyData(data);
                    },
                    onError: function (data) {
                        let msg = "表示に失敗しました";
                        if (!isEmpty(data) && !isEmpty(data.errDescription)) {
                            msg = data.errDescription;
                        }
                        fnc.current.warnmsg(msg);
                        dispatch(changestatus("VIEW"));
                        entryVisualPostLoadCoordinator.finishEntryLoading();
                    }
                }
            );
        };

        requestData(entryDataUrl);
    }
    // PL用データを単票項目へ戻す。
    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }
    function validateColorwayBeforeSave() {
        return true;
    }
    function validateFukushizaiListReflectBeforeSave() {
        const section = getSectionDefById(FUKUSHIZAI_LIST_TARGET_SECTION_ID);
        const targetPanel = resolveUiActionGridPanel(section);
        if (isEmpty(targetPanel)) return true;
        // 品質表示幅区分(14)は一覧反映・反映チェックの対象外。
        // 既存データ(品番マスタ由来等)に14行が残っていてもチェックに引っ掛けない。
        const checkTargetRows = (Array.isArray(GridData(targetPanel)) ? GridData(targetPanel) : [])
            .filter((row) => readFukushizaiRowField(row, "SSDZM_FUSIZAIKBN") !== FUKUSHIZAI_LIST_QUALITY_KIND);
        const currentListKeys = fukushizaiListCompositionKeysFromRows(checkTargetRows);
        if (currentListKeys.length === 0) return true;
        const sourceKeys = fukushizaiListCompositionKeysFromSourceItems(collectFukushizaiSourceItems());
        if (fukushizaiListKeysEqual(currentListKeys, sourceKeys)) return true;
        fnc.current.warnmsg("反映ボタンを押して、入力した内容を使用副資材一覧に反映させてください。");
        return false;
    }
    function validateKakousijiBeforeSave() {
        if (!validateColorwayBeforeSave()) return false;
        if (!validateFukushizaiListReflectBeforeSave()) return false;
        applyForcedGenkaJpyIfNeeded(entrydataRef.current);
        return true;
    }
    // SQL初期値反映後に、加工指示固有state（区分/原価/通貨）を再同期する。
    function refreshKakousijiStateAfterEntryDefaults() {
        try {
            applyKakouShijiKubun(entrydataRef.current);
            applyKakousijiUiData(null);
            const genkaPanel = resolveGenkaPanelFromGridList();
            if (!isEmpty(genkaPanel)) {
                const rows = buildGenkaRowsForDisplay(entrydataRef.current);
                SetGridData(genkaPanel, rows);
                applyGridRowsNow(genkaPanel, rows);
                recalcGenkaGridAndSummary(genkaPanel);
            }
            rerender();
        } catch (e) {
            console.error(e);
            rerender();
        }
    }
    // 入力内容を初期状態に戻す。
    function clearform(newform) {
        clearDeferredEntryVisualTraceTimers();
        activateEntryVisualTraceWindow(3000);
        logEntryVisualTrace("clearform:start", { newform: isEnabled(newform) });
        entrydataRef.current = initializedata(textfieldsall, staff);
        entrydetailRef.current = null;
        loadedEntryDetailRef.current = null;
        fukushizaiRepresentativeRowRef.current = { rowid: "", index: -1 };
        updateSelectedFukushizaiContext({ itemCd: "", colorCd: "", groupNo: "" });
        setPendingFukushizaiCopy(null);
        refreshFukushizaiCopyPreviewGridEditLock(false);
        pendingGridApplyRef.current = {};
        pendingGridRerenderIdsRef.current = {};
        pendingVisibleGridRefreshRef.current = "";
        genkaPostLoadRefreshSkipRef.current = false;
        resetPendingGenkaEditableRefresh();
        // pending な Grid 再描画タイマーもここで確実に掃除します。
        gridRefreshCoordinator.clearAllPendingTimers();
        clearDeferredColorwayLoadTimer();
        pendingColorwayLoadCodeRef.current = "";
        if (!isEmpty(finishEntryLoadingTimerRef.current)) {
            if (typeof cancelAnimationFrame === "function") {
                cancelAnimationFrame(finishEntryLoadingTimerRef.current);
            } else {
                clearTimeout(finishEntryLoadingTimerRef.current);
            }
            finishEntryLoadingTimerRef.current = null;
        }
        resetColorwayMatrix();
        genkaPatternRequestSeqRef.current += 1;
        autoGenkaPatternWatchKeyRef.current = "";
        supplierCostAttributeWatchKeyRef.current = "";
        setKakouShijiKubun("normal");
        setSelectedOrderHistoryDenpyoMap({
            seihin: "",
            sozai_meisai: "",
            fuzoku_meisai: "",
            fukushizai: ""
        });
        setOrderHistoryData(emptyOrderHistoryData);
        setSetItemOptions([]);
        setGroupOptions([]);
        fukushizaiGroupRowsRef.current = [];
        setGroupRows([]);
        setFukushizaiItemMasterOptions([]);
        setFukushizaiColorMasterOptions([]);
        setSelectedSetItem("");
        setSelectedGroup("");
        setCopyItem("");
        setCopyGroup("");
        copyContextTouchedRef.current = false;
        setQualityCopyItem("");
        setQualityCopyGroup("");
        qualityCopyContextTouchedRef.current = false;
        closeGroupActionDialog();
        setQualityItemOptions([]);
        qualityItemOptionsRef.current = [];
        setFukushizaiItemAddedOptions([]);
        fukushizaiItemAddedOptionsRef.current = [];
        closeItemTabActionDialog();
        setGenkaPatternOptions([]);
        setGenkaCurrencyOptions([]);
        setGenkaPatternNo(0);
        setGenkaPattern("");
        setGenkaCurrency("");
        setGenkaCurrencyNo("0");
        sustainableImageRequestSeqRef.current += 1;
        setSustainableServerImageUrl("");
        imageRef.current = null;
        fileRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            if (newform) {
                if (isWashPanelInfo(gridlist[i])) {
                    SetGridData(gridlist[i], defaultWashRows());
                    continue;
                }
                if (isGenkaGridPanelInfo(gridlist[i])) {
                    SetGridData(gridlist[i], buildGenkaRowsForDisplay(entrydataRef.current));
                    continue;
                }
            }
            SetGridData(gridlist[i], []);
        }
        Object.keys(totalgriddataRefs.current).forEach((key) => {
            if (String(key).indexOf("_" + PANEL_TYPE.GENKA_SUMMARY) !== -1) {
                totalgriddataRefs.current[key].current = defaultGenkaSummaryRows();
            } else {
                totalgriddataRefs.current[key].current = [{ rowid: "TOTAL", grip: "計" }];
            }
        });

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
            {
                onSuccess: function (data) {
                    for (let key in data.returnData) {
                        var col = textfieldsall.find(e => e.columnid === key);
                        if (!isEmpty(col)) col.initvalue = data.returnData[key];
                    }
                    entrydataRef.current = initializedata(textfieldsall, staff);
                    refreshKakousijiStateAfterEntryDefaults();
                },
            }, true
            )
        }
    }
    // ---------------------------------------------------------------------
    // レイアウト保存・復元
    // ---------------------------------------------------------------------
    // 保存済みレイアウトを復元する。
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    // 保存済みパネル状態を復元する。
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => String(e.id ?? "") === String(paneldata[i].id ?? "") && String(e.type ?? "") === String(paneldata[i].type ?? ""));
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(normalizePanelMeta(paneldata));
    }
    // 保存済みBASE項目表示を復元する。
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    // Entry Form を閉じたときに、グリッドに紐づくrefを破棄する。
    //
    // Cancel/VIEW復帰では MasterLayout が Entry Form 配下を丸ごとアンマウントするが、
    // gridcolRefs / gridapiRefs は GetListTabs 成功時にしか初期化されないため前回の値が残る。
    // 残ったままだと EntryGridAr のマウント処理が
    //   if (isValidcolumndef(props.columnRef.current)) DidMountSetColumn(props.columnRef.current);
    // の分岐に入り、columninfo から列定義を作り直さない。
    // 品質表示系パネルは refreshQualityPanelColumnDefs が別ビルダーの定義でrefを上書きするため、
    // 2回目以降は colinfo が初回と一致せず、datatype=6(MASTER) と判定されなくなって
    // 付記用語・構成部品の名称が「コードのみ」になっていた。
    function resetGridRefsOnEntryClose() {
        const refLists = [gridapiRefs, gridcolapiRefs, gridcolRefs];
        refLists.forEach((refList) => {
            const list = DicVal(refList, "current", null);
            if (!Array.isArray(list)) return;
            list.forEach((item) => {
                if (isEmpty(item) || typeof item !== "object") return;
                item.current = refList === gridcolRefs ? [] : null;
            });
        });
        // 名称補完の重複要求ガードも破棄する。キーは伝票内で一意になるため、
        // 残っていると再表示時の補完要求がスキップされ名称を引き直せない。
        masterNameHydrationPendingRef.current = {};
        pendingGridApplyRef.current = {};
        pendingGridRerenderIdsRef.current = {};
    }
    // 現在レイアウトをstorageへ保存する。
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({id:gridlist[i].id, type:gridlist[i].type}));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    // レイアウトを名前付き保存する。
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id })); 
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
               },
            }
        )
    }
    // 保存レイアウトを削除する。
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    // 保存レイアウトを読み込む。
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    const layoutColumns = normalizeLayoutMeta(data.columns);
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = String(gridlist[i].type ?? "");
                        var coldef = AGRef.current.createColDef(
                            columninfo.filter(e => String(e.type ?? "") === type),
                            layoutColumns.filter(e => String(e.type ?? "") === type),
                            false
                        );
                        if (isQualityPanelType(type)) {
                            coldef = coldef.map((col) => applyQualityHsituhabaLocalSelectColDef(col));
                        }
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    const normalizedPanels = normalizePanelMeta(data.panels);
                    setpanel(normalizedPanels);
                    setResolvedSections(buildResolvedSections(kakouSectionDefs, normalizedPanels));
                    setResolvedSampleSections(buildResolvedSections(kakouSampleSectionDefs, normalizedPanels));
                    const baseFields = buildBaseTextFields(layoutColumns, columninfo);
                    settextfields(baseFields);
                    setcolumns(layoutColumns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    // セル編集可否を判定する。
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }

    //パネル別列情報取得
    // panel id から type を取得する。
    function tabletype(id) {
        let pnl = panel.find(e => String(e.id ?? "") === String(id ?? ""));
        if (isEmpty(pnl)) return '';
        return String(pnl.type ?? "");
    }

    //File Upload 再表示
    // アップロード後の画像/ファイルを反映する。
    function fileuploaded(data) {
        let duplicate = false;
        const nextImages = toArray(DicVal(data, "images", []));
        const nextFiles = toArray(DicVal(data, "files", []));
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, nextImages)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, nextFiles)) duplicate = true;
        } else {
            imageRef.current = nextImages;
            fileRef.current = nextFiles;
        }
        dispatch(setimagelist(Array.isArray(imageRef.current) ? imageRef.current : []));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }

    //Basic Data Change
    // 単票変更時のトリガー通知を行う。
    function ValueChanged(id, value, edit) {
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (String(id ?? "").trim().toUpperCase() === SUSTAINABLE_IMAGE_FILE_FIELD) {
                loadSustainableImageFromServer({ ...(entrydataRef.current || {}), [id]: value });
            }
            if (isFukushizaiCopyPreviewing && isFukushizaiBaseField(id)) {
                fukushizaiProjection.refreshSectionViews(selectedSetItem, selectedGroup, pendingFukushizaiCopy, selectedFukushizaiContextRef.current);
                return;
            }
            if (isFukushizaiBaseField(id)) {
                if (fukushizaiDetailSyncingRef.current || fukushizaiProjectionGuardRef.current || entryLoadingRef.current) {
                    logFukushizaiBaseSyncFlat({
                        timing: fukushizaiProjectionGuardRef.current || fukushizaiDetailSyncingRef.current ? "projection" : "refresh",
                        reason: id,
                        allowed: false,
                        context: normalizeFukushizaiContext(selectedFukushizaiContextRef.current),
                        dirtyFields: [],
                        updates: {},
                        targetColors: [],
                        updatedCount: 0,
                        skipReason: fukushizaiProjectionGuardRef.current || fukushizaiDetailSyncingRef.current ? "projection-syncing" : "refresh-syncing"
                    });
                    return;
                }
                fukushizaiProjection.syncBaseFieldValueToDetail(id, value);
            }
            if (isQualityBaseField(id)) {
                if (fukushizaiDetailSyncingRef.current || fukushizaiProjectionGuardRef.current || entryLoadingRef.current) {
                    return;
                }
                qualityProjection.syncBaseFieldValueToDetail(id, value);
            }
            // 摘要(SSDE_TEKIYO)はSSDQ_プレフィックスでないため品質base判定に乗らない。
            // 物理列は洗濯表示(D_SSDE)側のため、個別に洗濯明細へ同期する。
            if (normalizeColumnIdUpper(id) === "SSDE_TEKIYO") {
                if (!(fukushizaiDetailSyncingRef.current || fukushizaiProjectionGuardRef.current || entryLoadingRef.current)) {
                    syncQualityTekiyoToWashDetail(value);
                }
            }
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }

    // =====================================================================
    // パネル描画切り替え
    // =====================================================================

    // ---------------------------------------------------------------------
    // 表示判定と描画分岐
    // ---------------------------------------------------------------------
    // セクション定義に応じて BASE/Grid/WashGrid を切り替える。
    function buildEntryGridProps(contentProps, gridOptions = {}) {
        const panelInfo = contentProps.panel;
        const base = {
            key: gridOptions.renderKey,
            id: fnc.current.GridID(panelInfo),
            forceNormalLayout: gridOptions.forceNormalLayout,
            fixedNormalHeight: gridOptions.fixedNormalHeight,
            AutoAddRow: (isEnabled(gridOptions.isDemandPanel) || isFixedVerticalDisplayPanelInfo(panelInfo)) ? false : undefined,
            // 小物札(114)は副資材(113)の設定内容を表示・編集する投影パネルのため、
            // 手動での行追加/挿入/削除を禁止（コピーは可）にする。
            rowContext: isKomonofudaPanelInfo(panelInfo) ? 1 : undefined,
            hideRowNumbers: isEnabled(gridOptions.hideRowNumbers),
            masterDetail: isEnabled(gridOptions.masterDetail),
            detailCellRendererParams: gridOptions.detailCellRendererParams,
            rowDrag: gridOptions.rowDrag,
            CellClicked: gridOptions.onGridCellClicked,
            CellDoubleClicked: gridOptions.onGridCellDoubleClicked,
            getRowStyle: gridOptions.getRowStyle,
            entrydataRef: resolveEntryDataRefForGrid(panelInfo),
            dataRef: ensureGridDataRef(panelInfo),
            columnRef: ensureGridColRef(panelInfo),
            columninfo: columninfo,
            columns: columns,
            QuerySetColumn: gridOptions.QuerySetColumn,
            fnc: fnc,
            onFirstDataRendered: onFirstDataRendered,
            formid: formid,
            ValueChanged: (params) => handleGridValueChanged(panelInfo, params),
            RowValueChanged: (colid, rows) => handleBrandNameRowValueChanged(panelInfo, colid, rows),
            // 通貨単位による単価/金額の入力制御（可否＋背景色）
            lockcell: lockGridCellByCurrency,
            ColdefSpecial: applyCurrencyInputLockColDef,
            panel: panelInfo
        };
        if (isEnabled(gridOptions.withEntryBodyRef)) base.EntrybodyRef = EntrybodyRef;
        return base;
    }

    // 表示対象が空かどうか判定する。
    function EmptyPanel(id, type) {
        try {
            const sid = String(id ?? "");
            const stype = String(type ?? "");
            if (isEmpty(panel) || !Array.isArray(panel)) return true;
            const reqTypeCandidates = resolveTypeCandidates(stype);
            const hasPanelById = panel.some(e => String(e.id ?? "") === sid);
            const hasPanelByType = reqTypeCandidates.length !== 0
                ? panel.some(e => reqTypeCandidates.includes(String(e.type ?? "").trim().toLowerCase()))
                : false;
            if (!hasPanelById && !hasPanelByType) return true; // パネル定義なし
            if (sid === G_id.BASE) {
                if (isEmpty(textfields) || !Array.isArray(textfields)) return true;
                return isEmpty(textfields.find(e => String(e.type ?? "") === stype));
            }
            let tbltype = tabletype(sid);
            let typeCandidates = resolveTypeCandidates(tbltype);
            if (typeCandidates.length === 0 && reqTypeCandidates.length !== 0) typeCandidates = reqTypeCandidates;
            const reqTypeKey = normalizeTypeKey(stype);
            const panelTypeKey = normalizeTypeKey(tbltype);
            const isDemandPanel =
                sid === "20" || sid === "21" ||
                reqTypeKey === "130" || reqTypeKey === "131" ||
                panelTypeKey === "130" || panelTypeKey === "131";
            if (WASH_PANEL_IDS.includes(sid) || WASH_PANEL_IDS.includes(stype)) return false;
            // 受注納品は初期化順に依存させず常にマウントする。
            // 列メタ到着順による表示揺れを避けるため、常時マウントを維持する。
            if (isDemandPanel) return false;

            if (Array.isArray(columns) &&
                columns.some(e => typeCandidates.includes(String(e.type ?? "").trim().toLowerCase()))) {
                return false;
            }
            // それ以外のグリッドは従来どおり columns 準備待ち。
            if (isEmpty(columns) || !Array.isArray(columns)) return true;
            return true;
        } catch { }
        return true;
    }
    // パネルを非表示にするか判定する。
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    // 現在表示すべきセクション一覧を返す。
    function sectionPanelOrderIndex(section) {
        return sectionPanelResolver.sectionPanelOrderIndex(section);
    }
    function orderSectionsByPanel(defs) {
        return sectionPanelResolver.orderSectionsByPanel(defs);
    }
    function showSections() {
        return sectionPanelResolver.showSections();
    }
    // VIEW→Entry遷移直後のLoadDataでのみ、基本情報タブへ戻す。
    // 保存後の再表示など Show を経由しない LoadData では現在のタブを維持する。
    function resolveInitialDemandKakouType() {
        const shouldReset = entryShowKakouTypeResetRef.current === true;
        entryShowKakouTypeResetRef.current = false;
        if (!shouldReset) return "";
        return sectionPanelResolver.resolveInitialDemandKakouType();
    }
    // 商品情報で使うBASEパネルを決める。
    function getPrimaryBasePanel() {
        return sectionPanelResolver.getPrimaryBasePanel();
    }
    // BASEセクションの対応panelを決める。
    function resolveSectionPanel(section) {
        return sectionPanelResolver.resolveSectionPanel(section);
    }
    // コメントセクションの対応panelを決める。
    function resolveRemarksSectionPanel(section) {
        return sectionPanelResolver.resolveRemarksSectionPanel(section);
    }
    // GRIDセクションの対応panelを決める。
    function resolveGridSectionPanel(section) {
        return sectionPanelResolver.resolveGridSectionPanel(section);
    }
    // セクションの合計タイプを返す。
    function sectionTotalType(section, gridPanel) {
        return sectionPanelResolver.sectionTotalType(section, gridPanel);
    }
    // 合計typeを列定義がある正規typeへ正規化する。
    function normalizeTotalTypeForColumns(totaltype, sectionId) {
        return sectionPanelResolver.normalizeTotalTypeForColumns(totaltype, sectionId);
    }
    // detailから合計行を取得する。
    function pickTotalRows(detail, totaltype, sectionId) {
        return sectionPanelResolver.pickTotalRows(detail, totaltype, sectionId);
    }
    // 合計グリッドを載せるpanelを決める。
    function resolveTotalHostPanel(section, gridPanel) {
        return sectionPanelResolver.resolveTotalHostPanel(section, gridPanel);
    }
    // grid表示設定は panel 定義の値をそのまま使用する。
    function toStableAutoHeightPanel(panelInfo, sectionId) {
        return sectionRenderModelResolver.toStableAutoHeightPanel(panelInfo, sectionId);
    }
    // 受注納品グリッドは列メタ到着順の揺れを吸収するため、関連メタ件数をkeyへ反映して再マウント可能にする。
    function gridRenderKey(panelInfo) {
        return sectionRenderModelResolver.gridRenderKey(panelInfo);
    }

    // =====================================================================
    // 画面描画ヘルパー
    // ---------------------------------------------------------------------
    // JSX return から呼ばれる表示補助関数をまとめる。
    // =====================================================================

    // 受注数/納品予定の列構築は demandGridColumnBuilder へ移管済みです。
    // ---------------------------------------------------------------------
    // section本体描画と画面全体組み立て
    // ---------------------------------------------------------------------
    // サステナブル画像とファイル名入力欄を描画する。
    function renderSustainableImagePanel() {
        const fileName = readSustainableImageFileName(entrydataRef.current);
        const title = fileName === ""
            ? "クリックしてサステナブルマーク画像ファイル名を入力"
            : `クリックしてサステナブルマーク画像ファイル名を入力: ${fileName}`;
        const isReadonly = entrylock || layoutlock;
        const cellClassName = isReadonly
            ? "kakousiji-sustainable-panel__cell kakousiji-sustainable-panel__cell--readonly"
            : "kakousiji-sustainable-panel__cell";

        // 表示専用の JSX は専用 component へ委譲します。
        return (
            <SustainableImagePanel
                imageUrl={sustainableServerImageUrl}
                title={title}
                cellClassName={cellClassName}
                isEditing={sustainableImageFileEditing}
                inputValue={sustainableImageFileInputValue}
                onPanelClick={handleSustainableImagePanelClick}
                onInputChange={setSustainableImageFileInputValue}
                onInputBlur={commitSustainableImageFileName}
                onInputKeyDown={handleSustainableImageFileNameKeyDown}
            />
        );
    }
    // 品質表示スコープ先頭の品表注意パネル(139)を標準の単票描画(EntryBase)で表示する。
    // 編集可否・保存・変更追跡はすべて他の単票項目と同じ標準機構に乗る。
    // ヘッダ項目(D_SSD)のため、アイテムタブ・グループトグルの切替(品質投影はSSDQ_系のみ操作)では値が変わらない。
    function renderQualityWarningHeader(domain) {
        if (domain !== "quality") return null;
        const warningPanel = (Array.isArray(panel) ? panel : []).find((p) =>
            String(DicVal(p, "id", "")) === G_id.BASE &&
            canonicalPanelType(DicVal(p, "type", "")) === QUALITY_WARNING_PANEL_TYPE);
        if (isEmpty(warningPanel)) return null;
        return (
            <div className="kakousiji-quality-warning-header">
                {renderPanelContents({ panel: warningPanel })}
            </div>
        );
    }
    // セクション一覧表示とチップ遷移は専用 service へ委譲します。
    function buildSectionNavigationServiceDeps() {
        return {
            kakouShijiKubun,
            currentSampleSectionDefs,
            currentNormalSectionDefs,
            orderSectionsByPanel,
            showSections,
            sectionChipTargetIds,
            sectionChipLabelMap,
            renderSection,
            renderItemGroupTabBar,
            renderItemGroupScopeHeader: renderQualityWarningHeader,
            isEmpty,
            setCollapsedSections,
            sectionRefs,
            EntrybodyRef
        };
    }

    const {
        buildCurrentSectionListPresentation,
        scrollToSection
    } = createSectionNavigationService(buildSectionNavigationServiceDeps());

    // 画面上部のセクション一覧とチップ表示情報をまとめます。
    const sectionPresentation = buildCurrentSectionListPresentation();
    const showModeButtons = kakouShijiKubun !== "sample";
    // =====================================================================
    // JSX return
    // ---------------------------------------------------------------------
    // 画面構造のみを組み立てる。
    // =====================================================================

    return (
        <div>
            <ComFunc ref={fnc} />
            {/*primaryid削除　影響不明*/}
            <MasterBase
                ref={baseref}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primarykey={primarykeys}
                entrydataRef={entrydataRef}
                navmenu={entrylock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                lockcell={ListlockCell}
                usecondition={true}
           >
            <EntryFormLayout
                renderedSections={sectionPresentation.renderedSections}
                showModeButtons={showModeButtons}
                kakouTypeButtons={kakouTypeButtons}
                kakouType={kakouType}
                onChangeKakouType={setKakouType}
                entryBodyRef={EntrybodyRef}
                onDragEnter={onDragEnter}
                onInteractionCapture={handleEntryInteractionCapture}
            />
            </MasterBase>
            {renderGroupActionDialog()}
            {renderItemTabActionDialog()}
            {renderPendingOrderLaunchDialog()}
            <SangenDisplayDialog
                open={sangenDialogState.open}
                loading={sangenDialogState.loading}
                header={sangenDialogState.header}
                sizes={sangenDialogState.sizes}
                rows={sangenDialogState.rows}
                onClose={closeSangenDisplayDialog}
            />
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            <EntryHeaderOverlay
                visible={formstatus === "NEW FORM" || formstatus === "ENTRY FORM" || formstatus === "COPY FORM"}
                onOpenEntrySetting={() => fnc.current.entrysettingopen()}
                columninfo={columninfo}
                entrydata={entrydataRef.current}
                chips={sectionPresentation.topSectionChips}
                onChipClick={scrollToSection}
            />
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DropZone
                controller={controller}
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};
